var kr = Object.defineProperty;
var Ar = (t, r, n) => r in t ? kr(t, r, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[r] = n;
var Pr = (t, r, n) => Ar(t, typeof r != "symbol" ? r + "" : r, n);
import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import clsx from "clsx";
import * as React from "react";
import React__default, { forwardRef, version, isValidElement, useState as useState$1, useMemo as useMemo$1, useCallback, useRef, useLayoutEffect as useLayoutEffect$3, useEffect, cloneElement, createContext, useContext, useId as useId$3, useReducer, Children } from "react";
import * as ReactDOM from "react-dom";
import ReactDOM__default, { unstable_batchedUpdates, createPortal, flushSync } from "react-dom";
import { ru as ru$1, enUS } from "date-fns/locale";
import { CloseMiniLine, DoneRoundLight, SearchLight, ArrowDropDown, ArrowLeftLight, ArrowRightLight, ArrowDropUp, ExpandDown, CloseRoundLight, DoneLight, CalendarDuotoneLine, CloseRoundDuotone, InfoLight, InfoRoundFill, QuestionFill, CheckRoundFill, AttantionMiniCustom, CloseRingDuotoneLine, ExpandRightLight } from "@repo/go-icons";
import { getMonth, isSameDay, setHours, setMinutes, getMinutes, getHours, startOfMonth, startOfWeek, sub as sub$1, add as add$1, eachDayOfInterval, differenceInWeeks, format, isWeekend, toDate, endOfWeek, getYear, setMonth, isBefore, startOfMinute, isAfter, endOfMinute, startOfHour, endOfHour, startOfDay, endOfDay, parse, millisecondsToSeconds, secondsToMilliseconds, getUnixTime } from "date-fns";
function ActionsBar({ children: t, className: r, style: n }) {
  return /* @__PURE__ */ jsx("div", { className: clsx("go-actions-bar", r), style: n, children: t });
}
function TopBar({ children: t, className: r, style: n }) {
  return /* @__PURE__ */ jsx("div", { className: clsx("go-actions-bar__top", r), style: n, children: t });
}
function BottomBar({ children: t, className: r, style: n }) {
  return /* @__PURE__ */ jsx("div", { className: clsx("go-actions-bar__bottom", r), style: n, children: t });
}
const Item$3 = forwardRef(function({ children: r, className: n, style: a, active: s, disabled: o, onClick: l }, c) {
  return /* @__PURE__ */ jsx(
    "button",
    {
      ref: c,
      type: "button",
      disabled: o,
      className: clsx("go-actions-bar__item", s && "active", n),
      style: a,
      onClick: l,
      children: r
    }
  );
});
function Space({ children: t, className: r, style: n }) {
  return /* @__PURE__ */ jsx("div", { className: clsx("go-actions-bar__space", r), style: n, children: t });
}
function Divider({ children: t, className: r, style: n }) {
  return /* @__PURE__ */ jsx("div", { className: clsx("go-actions-bar__divider", r), style: n, children: t });
}
const actionsBar = Object.assign(ActionsBar, { TopBar, BottomBar, Item: Item$3, Space, Divider });
function getDefaultExportFromCjs(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var toArray$4 = {}, interopRequireDefault = { exports: {} }, hasRequiredInteropRequireDefault;
function requireInteropRequireDefault() {
  return hasRequiredInteropRequireDefault || (hasRequiredInteropRequireDefault = 1, (function(t) {
    function r(n) {
      return n && n.__esModule ? n : {
        default: n
      };
    }
    t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
  })(interopRequireDefault)), interopRequireDefault.exports;
}
var isFragment$1 = {}, _typeof$2 = { exports: {} }, hasRequired_typeof;
function require_typeof() {
  return hasRequired_typeof || (hasRequired_typeof = 1, (function(t) {
    function r(n) {
      "@babel/helpers - typeof";
      return t.exports = r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(a) {
        return typeof a;
      } : function(a) {
        return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
      }, t.exports.__esModule = !0, t.exports.default = t.exports, r(n);
    }
    t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
  })(_typeof$2)), _typeof$2.exports;
}
var hasRequiredIsFragment;
function requireIsFragment() {
  if (hasRequiredIsFragment) return isFragment$1;
  hasRequiredIsFragment = 1;
  var t = requireInteropRequireDefault().default;
  Object.defineProperty(isFragment$1, "__esModule", {
    value: !0
  }), isFragment$1.default = o;
  var r = t(require_typeof()), n = /* @__PURE__ */ Symbol.for("react.element"), a = /* @__PURE__ */ Symbol.for("react.transitional.element"), s = /* @__PURE__ */ Symbol.for("react.fragment");
  function o(l) {
    return (
      // Base object type
      l && (0, r.default)(l) === "object" && // React Element type
      (l.$$typeof === n || l.$$typeof === a) && // React Fragment type
      l.type === s
    );
  }
  return isFragment$1;
}
var hasRequiredToArray;
function requireToArray() {
  if (hasRequiredToArray) return toArray$4;
  hasRequiredToArray = 1;
  var t = requireInteropRequireDefault().default;
  Object.defineProperty(toArray$4, "__esModule", {
    value: !0
  }), toArray$4.default = a;
  var r = t(requireIsFragment()), n = t(React__default);
  function a(s) {
    var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, l = [];
    return n.default.Children.forEach(s, function(c) {
      c == null && !o.keepEmpty || (Array.isArray(c) ? l = l.concat(a(c)) : (0, r.default)(c) && c.props ? l = l.concat(a(c.props.children, o)) : l.push(c));
    }), l;
  }
  return toArray$4;
}
var toArrayExports = requireToArray();
const toArray$3 = /* @__PURE__ */ getDefaultExportFromCjs(toArrayExports);
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(t) {
    for (var r = 1; r < arguments.length; r++) {
      var n = arguments[r];
      for (var a in n) ({}).hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, _extends.apply(null, arguments);
}
function _arrayLikeToArray(t, r) {
  (r == null || r > t.length) && (r = t.length);
  for (var n = 0, a = Array(r); n < r; n++) a[n] = t[n];
  return a;
}
function _arrayWithoutHoles(t) {
  if (Array.isArray(t)) return _arrayLikeToArray(t);
}
function _iterableToArray(t) {
  if (typeof Symbol != "undefined" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function _unsupportedIterableToArray(t, r) {
  if (t) {
    if (typeof t == "string") return _arrayLikeToArray(t, r);
    var n = {}.toString.call(t).slice(8, -1);
    return n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set" ? Array.from(t) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? _arrayLikeToArray(t, r) : void 0;
  }
}
function _nonIterableSpread() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _toConsumableArray(t) {
  return _arrayWithoutHoles(t) || _iterableToArray(t) || _unsupportedIterableToArray(t) || _nonIterableSpread();
}
function _typeof$1(t) {
  "@babel/helpers - typeof";
  return _typeof$1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, _typeof$1(t);
}
function toPrimitive(t, r) {
  if (_typeof$1(t) != "object" || !t) return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var a = n.call(t, r);
    if (_typeof$1(a) != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(t);
}
function toPropertyKey(t) {
  var r = toPrimitive(t, "string");
  return _typeof$1(r) == "symbol" ? r : r + "";
}
function _defineProperty(t, r, n) {
  return (r = toPropertyKey(r)) in t ? Object.defineProperty(t, r, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[r] = n, t;
}
function ownKeys(t, r) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    r && (a = a.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function _objectSpread2(t) {
  for (var r = 1; r < arguments.length; r++) {
    var n = arguments[r] != null ? arguments[r] : {};
    r % 2 ? ownKeys(Object(n), !0).forEach(function(a) {
      _defineProperty(t, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ownKeys(Object(n)).forEach(function(a) {
      Object.defineProperty(t, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return t;
}
function _arrayWithHoles(t) {
  if (Array.isArray(t)) return t;
}
function _iterableToArrayLimit(t, r) {
  var n = t == null ? null : typeof Symbol != "undefined" && t[Symbol.iterator] || t["@@iterator"];
  if (n != null) {
    var a, s, o, l, c = [], x = !0, j = !1;
    try {
      if (o = (n = n.call(t)).next, r === 0) {
        if (Object(n) !== n) return;
        x = !1;
      } else for (; !(x = (a = o.call(n)).done) && (c.push(a.value), c.length !== r); x = !0) ;
    } catch (Z) {
      j = !0, s = Z;
    } finally {
      try {
        if (!x && n.return != null && (l = n.return(), Object(l) !== l)) return;
      } finally {
        if (j) throw s;
      }
    }
    return c;
  }
}
function _nonIterableRest() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _slicedToArray(t, r) {
  return _arrayWithHoles(t) || _iterableToArrayLimit(t, r) || _unsupportedIterableToArray(t, r) || _nonIterableRest();
}
function _objectWithoutPropertiesLoose(t, r) {
  if (t == null) return {};
  var n = {};
  for (var a in t) if ({}.hasOwnProperty.call(t, a)) {
    if (r.indexOf(a) !== -1) continue;
    n[a] = t[a];
  }
  return n;
}
function _objectWithoutProperties(t, r) {
  if (t == null) return {};
  var n, a, s = _objectWithoutPropertiesLoose(t, r);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (a = 0; a < o.length; a++) n = o[a], r.indexOf(n) === -1 && {}.propertyIsEnumerable.call(t, n) && (s[n] = t[n]);
  }
  return s;
}
function useEvent$1(t) {
  var r = React.useRef();
  r.current = t;
  var n = React.useCallback(function() {
    for (var a, s = arguments.length, o = new Array(s), l = 0; l < s; l++)
      o[l] = arguments[l];
    return (a = r.current) === null || a === void 0 ? void 0 : a.call.apply(a, [r].concat(o));
  }, []);
  return n;
}
function canUseDom$1() {
  return !!(typeof window != "undefined" && window.document && window.document.createElement);
}
var useInternalLayoutEffect = process.env.NODE_ENV !== "test" && canUseDom$1() ? React.useLayoutEffect : React.useEffect, useLayoutEffect$2 = function(r, n) {
  var a = React.useRef(!0);
  useInternalLayoutEffect(function() {
    return r(a.current);
  }, n), useInternalLayoutEffect(function() {
    return a.current = !1, function() {
      a.current = !0;
    };
  }, []);
}, useLayoutUpdateEffect = function(r, n) {
  useLayoutEffect$2(function(a) {
    if (!a)
      return r();
  }, n);
};
function useSafeState(t) {
  var r = React.useRef(!1), n = React.useState(t), a = _slicedToArray(n, 2), s = a[0], o = a[1];
  React.useEffect(function() {
    return r.current = !1, function() {
      r.current = !0;
    };
  }, []);
  function l(c, x) {
    x && r.current || o(c);
  }
  return [s, l];
}
function hasValue$2(t) {
  return t !== void 0;
}
function useMergedState$2(t, r) {
  var n = r || {}, a = n.defaultValue, s = n.value, o = n.onChange, l = n.postState, c = useSafeState(function() {
    return hasValue$2(s) ? s : hasValue$2(a) ? typeof a == "function" ? a() : a : typeof t == "function" ? t() : t;
  }), x = _slicedToArray(c, 2), j = x[0], Z = x[1], V = s !== void 0 ? s : j, U = l ? l(V) : V, $ = useEvent$1(o), Y = useSafeState([V]), G = _slicedToArray(Y, 2), W = G[0], X = G[1];
  useLayoutUpdateEffect(function() {
    var J = W[0];
    j !== J && $(j, J);
  }, [W]), useLayoutUpdateEffect(function() {
    hasValue$2(s) || Z(s);
  }, [s]);
  var K = useEvent$1(function(J, ee) {
    Z(J, ee), X([V], ee);
  });
  return [U, K];
}
var warned = {}, preWarningFns = [], preMessage = function(r) {
  preWarningFns.push(r);
};
function warning(t, r) {
  if (process.env.NODE_ENV !== "production" && !t && console !== void 0) {
    var n = preWarningFns.reduce(function(a, s) {
      return s(a != null ? a : "", "warning");
    }, r);
    n && console.error("Warning: ".concat(n));
  }
}
function note(t, r) {
  if (process.env.NODE_ENV !== "production" && !t && console !== void 0) {
    var n = preWarningFns.reduce(function(a, s) {
      return s(a != null ? a : "", "note");
    }, r);
    n && console.warn("Note: ".concat(n));
  }
}
function resetWarned() {
  warned = {};
}
function call(t, r, n) {
  !r && !warned[n] && (t(!1, n), warned[n] = !0);
}
function warningOnce(t, r) {
  call(warning, t, r);
}
function noteOnce(t, r) {
  call(note, t, r);
}
warningOnce.preMessage = preMessage;
warningOnce.resetWarned = resetWarned;
warningOnce.noteOnce = noteOnce;
var classnames = { exports: {} };
var hasRequiredClassnames;
function requireClassnames() {
  return hasRequiredClassnames || (hasRequiredClassnames = 1, (function(t) {
    (function() {
      var r = {}.hasOwnProperty;
      function n() {
        for (var o = "", l = 0; l < arguments.length; l++) {
          var c = arguments[l];
          c && (o = s(o, a(c)));
        }
        return o;
      }
      function a(o) {
        if (typeof o == "string" || typeof o == "number")
          return o;
        if (typeof o != "object")
          return "";
        if (Array.isArray(o))
          return n.apply(null, o);
        if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]"))
          return o.toString();
        var l = "";
        for (var c in o)
          r.call(o, c) && o[c] && (l = s(l, c));
        return l;
      }
      function s(o, l) {
        return l ? o ? o + " " + l : o + l : o;
      }
      t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
    })();
  })(classnames)), classnames.exports;
}
var classnamesExports = requireClassnames();
const cls = /* @__PURE__ */ getDefaultExportFromCjs(classnamesExports), isMobile = (function() {
  if (typeof navigator == "undefined" || typeof window == "undefined")
    return !1;
  var t = navigator.userAgent || navigator.vendor || window.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(t) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(t == null ? void 0 : t.substr(0, 4));
});
var KeyCode = {
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35,
  // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40,
  /**
   * N
   */
  N: 78,
  /**
   * P
   */
  P: 80,
  /**
   * META
   */
  META: 91,
  // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187,
  // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224
}, reactIs$1 = { exports: {} }, reactIs_production_min$1 = {};
var hasRequiredReactIs_production_min$1;
function requireReactIs_production_min$1() {
  if (hasRequiredReactIs_production_min$1) return reactIs_production_min$1;
  hasRequiredReactIs_production_min$1 = 1;
  var t = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), n = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), s = /* @__PURE__ */ Symbol.for("react.profiler"), o = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), c = /* @__PURE__ */ Symbol.for("react.server_context"), x = /* @__PURE__ */ Symbol.for("react.forward_ref"), j = /* @__PURE__ */ Symbol.for("react.suspense"), Z = /* @__PURE__ */ Symbol.for("react.suspense_list"), V = /* @__PURE__ */ Symbol.for("react.memo"), U = /* @__PURE__ */ Symbol.for("react.lazy"), $ = /* @__PURE__ */ Symbol.for("react.offscreen"), Y;
  Y = /* @__PURE__ */ Symbol.for("react.module.reference");
  function G(W) {
    if (typeof W == "object" && W !== null) {
      var X = W.$$typeof;
      switch (X) {
        case t:
          switch (W = W.type, W) {
            case n:
            case s:
            case a:
            case j:
            case Z:
              return W;
            default:
              switch (W = W && W.$$typeof, W) {
                case c:
                case l:
                case x:
                case U:
                case V:
                case o:
                  return W;
                default:
                  return X;
              }
          }
        case r:
          return X;
      }
    }
  }
  return reactIs_production_min$1.ContextConsumer = l, reactIs_production_min$1.ContextProvider = o, reactIs_production_min$1.Element = t, reactIs_production_min$1.ForwardRef = x, reactIs_production_min$1.Fragment = n, reactIs_production_min$1.Lazy = U, reactIs_production_min$1.Memo = V, reactIs_production_min$1.Portal = r, reactIs_production_min$1.Profiler = s, reactIs_production_min$1.StrictMode = a, reactIs_production_min$1.Suspense = j, reactIs_production_min$1.SuspenseList = Z, reactIs_production_min$1.isAsyncMode = function() {
    return !1;
  }, reactIs_production_min$1.isConcurrentMode = function() {
    return !1;
  }, reactIs_production_min$1.isContextConsumer = function(W) {
    return G(W) === l;
  }, reactIs_production_min$1.isContextProvider = function(W) {
    return G(W) === o;
  }, reactIs_production_min$1.isElement = function(W) {
    return typeof W == "object" && W !== null && W.$$typeof === t;
  }, reactIs_production_min$1.isForwardRef = function(W) {
    return G(W) === x;
  }, reactIs_production_min$1.isFragment = function(W) {
    return G(W) === n;
  }, reactIs_production_min$1.isLazy = function(W) {
    return G(W) === U;
  }, reactIs_production_min$1.isMemo = function(W) {
    return G(W) === V;
  }, reactIs_production_min$1.isPortal = function(W) {
    return G(W) === r;
  }, reactIs_production_min$1.isProfiler = function(W) {
    return G(W) === s;
  }, reactIs_production_min$1.isStrictMode = function(W) {
    return G(W) === a;
  }, reactIs_production_min$1.isSuspense = function(W) {
    return G(W) === j;
  }, reactIs_production_min$1.isSuspenseList = function(W) {
    return G(W) === Z;
  }, reactIs_production_min$1.isValidElementType = function(W) {
    return typeof W == "string" || typeof W == "function" || W === n || W === s || W === a || W === j || W === Z || W === $ || typeof W == "object" && W !== null && (W.$$typeof === U || W.$$typeof === V || W.$$typeof === o || W.$$typeof === l || W.$$typeof === x || W.$$typeof === Y || W.getModuleId !== void 0);
  }, reactIs_production_min$1.typeOf = G, reactIs_production_min$1;
}
var reactIs_development$1 = {};
var hasRequiredReactIs_development$1;
function requireReactIs_development$1() {
  return hasRequiredReactIs_development$1 || (hasRequiredReactIs_development$1 = 1, process.env.NODE_ENV !== "production" && (function() {
    var t = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), n = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), s = /* @__PURE__ */ Symbol.for("react.profiler"), o = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), c = /* @__PURE__ */ Symbol.for("react.server_context"), x = /* @__PURE__ */ Symbol.for("react.forward_ref"), j = /* @__PURE__ */ Symbol.for("react.suspense"), Z = /* @__PURE__ */ Symbol.for("react.suspense_list"), V = /* @__PURE__ */ Symbol.for("react.memo"), U = /* @__PURE__ */ Symbol.for("react.lazy"), $ = /* @__PURE__ */ Symbol.for("react.offscreen"), Y = !1, G = !1, W = !1, X = !1, K = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ee(ye) {
      return !!(typeof ye == "string" || typeof ye == "function" || ye === n || ye === s || K || ye === a || ye === j || ye === Z || X || ye === $ || Y || G || W || typeof ye == "object" && ye !== null && (ye.$$typeof === U || ye.$$typeof === V || ye.$$typeof === o || ye.$$typeof === l || ye.$$typeof === x || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      ye.$$typeof === J || ye.getModuleId !== void 0));
    }
    function te(ye) {
      if (typeof ye == "object" && ye !== null) {
        var Ae = ye.$$typeof;
        switch (Ae) {
          case t:
            var Fe = ye.type;
            switch (Fe) {
              case n:
              case s:
              case a:
              case j:
              case Z:
                return Fe;
              default:
                var Ie = Fe && Fe.$$typeof;
                switch (Ie) {
                  case c:
                  case l:
                  case x:
                  case U:
                  case V:
                  case o:
                    return Ie;
                  default:
                    return Ae;
                }
            }
          case r:
            return Ae;
        }
      }
    }
    var ne = l, re = o, ie = t, ue = x, le = n, oe = U, he = V, fe = r, ce = s, se = a, pe = j, ve = Z, ae = !1, me = !1;
    function de(ye) {
      return ae || (ae = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function ge(ye) {
      return me || (me = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function Se(ye) {
      return te(ye) === l;
    }
    function xe(ye) {
      return te(ye) === o;
    }
    function Ee(ye) {
      return typeof ye == "object" && ye !== null && ye.$$typeof === t;
    }
    function Ce(ye) {
      return te(ye) === x;
    }
    function ke(ye) {
      return te(ye) === n;
    }
    function Re(ye) {
      return te(ye) === U;
    }
    function _e(ye) {
      return te(ye) === V;
    }
    function Me(ye) {
      return te(ye) === r;
    }
    function we(ye) {
      return te(ye) === s;
    }
    function Te(ye) {
      return te(ye) === a;
    }
    function be(ye) {
      return te(ye) === j;
    }
    function Pe(ye) {
      return te(ye) === Z;
    }
    reactIs_development$1.ContextConsumer = ne, reactIs_development$1.ContextProvider = re, reactIs_development$1.Element = ie, reactIs_development$1.ForwardRef = ue, reactIs_development$1.Fragment = le, reactIs_development$1.Lazy = oe, reactIs_development$1.Memo = he, reactIs_development$1.Portal = fe, reactIs_development$1.Profiler = ce, reactIs_development$1.StrictMode = se, reactIs_development$1.Suspense = pe, reactIs_development$1.SuspenseList = ve, reactIs_development$1.isAsyncMode = de, reactIs_development$1.isConcurrentMode = ge, reactIs_development$1.isContextConsumer = Se, reactIs_development$1.isContextProvider = xe, reactIs_development$1.isElement = Ee, reactIs_development$1.isForwardRef = Ce, reactIs_development$1.isFragment = ke, reactIs_development$1.isLazy = Re, reactIs_development$1.isMemo = _e, reactIs_development$1.isPortal = Me, reactIs_development$1.isProfiler = we, reactIs_development$1.isStrictMode = Te, reactIs_development$1.isSuspense = be, reactIs_development$1.isSuspenseList = Pe, reactIs_development$1.isValidElementType = ee, reactIs_development$1.typeOf = te;
  })()), reactIs_development$1;
}
var hasRequiredReactIs$1;
function requireReactIs$1() {
  return hasRequiredReactIs$1 || (hasRequiredReactIs$1 = 1, process.env.NODE_ENV === "production" ? reactIs$1.exports = requireReactIs_production_min$1() : reactIs$1.exports = requireReactIs_development$1()), reactIs$1.exports;
}
var reactIsExports = requireReactIs$1();
function useMemo(t, r, n) {
  var a = React.useRef({});
  return (!("value" in a.current) || n(a.current.condition, r)) && (a.current.value = t(), a.current.condition = r), a.current.value;
}
var REACT_ELEMENT_TYPE_18 = /* @__PURE__ */ Symbol.for("react.element"), REACT_ELEMENT_TYPE_19 = /* @__PURE__ */ Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
function isFragment(t) {
  return (
    // Base object type
    t && _typeof$1(t) === "object" && // React Element type
    (t.$$typeof === REACT_ELEMENT_TYPE_18 || t.$$typeof === REACT_ELEMENT_TYPE_19) && // React Fragment type
    t.type === REACT_FRAGMENT_TYPE
  );
}
var ReactMajorVersion = Number(version.split(".")[0]), fillRef = function(r, n) {
  typeof r == "function" ? r(n) : _typeof$1(r) === "object" && r && "current" in r && (r.current = n);
}, composeRef = function() {
  for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
    n[a] = arguments[a];
  var s = n.filter(Boolean);
  return s.length <= 1 ? s[0] : function(o) {
    n.forEach(function(l) {
      fillRef(l, o);
    });
  };
}, useComposeRef = function() {
  for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
    n[a] = arguments[a];
  return useMemo(function() {
    return composeRef.apply(void 0, n);
  }, n, function(s, o) {
    return s.length !== o.length || s.every(function(l, c) {
      return l !== o[c];
    });
  });
}, supportRef = function(r) {
  var n, a;
  if (!r)
    return !1;
  if (isReactElement(r) && ReactMajorVersion >= 19)
    return !0;
  var s = reactIsExports.isMemo(r) ? r.type.type : r.type;
  return !(typeof s == "function" && !((n = s.prototype) !== null && n !== void 0 && n.render) && s.$$typeof !== reactIsExports.ForwardRef || typeof r == "function" && !((a = r.prototype) !== null && a !== void 0 && a.render) && r.$$typeof !== reactIsExports.ForwardRef);
};
function isReactElement(t) {
  return /* @__PURE__ */ isValidElement(t) && !isFragment(t);
}
var getNodeRef = function(r) {
  if (r && isReactElement(r)) {
    var n = r;
    return n.props.propertyIsEnumerable("ref") ? n.props.ref : n.ref;
  }
  return null;
}, TransBtn = function(r) {
  var n = r.className, a = r.customizeIcon, s = r.customizeIconProps, o = r.children, l = r.onMouseDown, c = r.onClick, x = typeof a == "function" ? a(s) : a;
  return /* @__PURE__ */ React.createElement("span", {
    className: n,
    onMouseDown: function(Z) {
      Z.preventDefault(), l == null || l(Z);
    },
    style: {
      userSelect: "none",
      WebkitUserSelect: "none"
    },
    unselectable: "on",
    onClick: c,
    "aria-hidden": !0
  }, x !== void 0 ? x : /* @__PURE__ */ React.createElement("span", {
    className: cls(n.split(/\s+/).map(function(j) {
      return "".concat(j, "-icon");
    }))
  }, o));
}, useAllowClear = function(r, n, a, s, o) {
  var l = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !1, c = arguments.length > 6 ? arguments[6] : void 0, x = arguments.length > 7 ? arguments[7] : void 0, j = React__default.useMemo(function() {
    if (_typeof$1(s) === "object")
      return s.clearIcon;
    if (o)
      return o;
  }, [s, o]), Z = React__default.useMemo(function() {
    return !!(!l && s && (a.length || c) && !(x === "combobox" && c === ""));
  }, [s, l, a.length, c, x]);
  return {
    allowClear: Z,
    clearIcon: /* @__PURE__ */ React__default.createElement(TransBtn, {
      className: "".concat(r, "-clear"),
      onMouseDown: n,
      customizeIcon: j
    }, "×")
  };
}, BaseSelectContext = /* @__PURE__ */ React.createContext(null);
function useBaseProps() {
  return React.useContext(BaseSelectContext);
}
function useDelayReset() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10, r = React.useState(!1), n = _slicedToArray(r, 2), a = n[0], s = n[1], o = React.useRef(null), l = function() {
    window.clearTimeout(o.current);
  };
  React.useEffect(function() {
    return l;
  }, []);
  var c = function(j, Z) {
    l(), o.current = window.setTimeout(function() {
      s(j), Z && Z();
    }, t);
  };
  return [a, c, l];
}
function useLock() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 250, r = React.useRef(null), n = React.useRef(null);
  React.useEffect(function() {
    return function() {
      window.clearTimeout(n.current);
    };
  }, []);
  function a(s) {
    (s || r.current === null) && (r.current = s), window.clearTimeout(n.current), n.current = window.setTimeout(function() {
      r.current = null;
    }, t);
  }
  return [function() {
    return r.current;
  }, a];
}
function useSelectTriggerControl(t, r, n, a) {
  var s = React.useRef(null);
  s.current = {
    open: r,
    triggerOpen: n,
    customizedTrigger: a
  }, React.useEffect(function() {
    function o(l) {
      var c;
      if (!((c = s.current) !== null && c !== void 0 && c.customizedTrigger)) {
        var x = l.target;
        x.shadowRoot && l.composed && (x = l.composedPath()[0] || x), s.current.open && t().filter(function(j) {
          return j;
        }).every(function(j) {
          return !j.contains(x) && j !== x;
        }) && s.current.triggerOpen(!1);
      }
    }
    return window.addEventListener("mousedown", o), function() {
      return window.removeEventListener("mousedown", o);
    };
  }, []);
}
function isValidateOpenKey(t) {
  return ![
    // System function button
    KeyCode.ESC,
    KeyCode.SHIFT,
    KeyCode.BACKSPACE,
    KeyCode.TAB,
    KeyCode.WIN_KEY,
    KeyCode.ALT,
    KeyCode.META,
    KeyCode.WIN_KEY_RIGHT,
    KeyCode.CTRL,
    KeyCode.SEMICOLON,
    KeyCode.EQUALS,
    KeyCode.CAPS_LOCK,
    KeyCode.CONTEXT_MENU,
    // F1-F12
    KeyCode.F1,
    KeyCode.F2,
    KeyCode.F3,
    KeyCode.F4,
    KeyCode.F5,
    KeyCode.F6,
    KeyCode.F7,
    KeyCode.F8,
    KeyCode.F9,
    KeyCode.F10,
    KeyCode.F11,
    KeyCode.F12
  ].includes(t);
}
var attributes = `accept acceptCharset accessKey action allowFullScreen allowTransparency
    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge
    charSet checked classID className colSpan cols content contentEditable contextMenu
    controls coords crossOrigin data dateTime default defer dir disabled download draggable
    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder
    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity
    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media
    mediaGroup method min minLength multiple muted name noValidate nonce open
    optimum pattern placeholder poster preload radioGroup readOnly rel required
    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected
    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style
    summary tabIndex target title type useMap value width wmode wrap`, eventsName = `onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown
    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick
    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown
    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel
    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough
    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata
    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError`, propList = "".concat(attributes, " ").concat(eventsName).split(/[\s\n]+/), ariaPrefix = "aria-", dataPrefix = "data-";
function match(t, r) {
  return t.indexOf(r) === 0;
}
function pickAttrs(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n;
  r === !1 ? n = {
    aria: !0,
    data: !0,
    attr: !0
  } : r === !0 ? n = {
    aria: !0
  } : n = _objectSpread2({}, r);
  var a = {};
  return Object.keys(t).forEach(function(s) {
    // Aria
    (n.aria && (s === "role" || match(s, ariaPrefix)) || // Data
    n.data && match(s, dataPrefix) || // Attr
    n.attr && propList.includes(s)) && (a[s] = t[s]);
  }), a;
}
function toArray$2(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = [];
  return React__default.Children.forEach(t, function(a) {
    a == null && !r.keepEmpty || (Array.isArray(a) ? n = n.concat(toArray$2(a)) : isFragment(a) && a.props ? n = n.concat(toArray$2(a.props.children, r)) : n.push(a));
  }), n;
}
function isDOM(t) {
  return t instanceof HTMLElement || t instanceof SVGElement;
}
function getDOM(t) {
  return t && _typeof$1(t) === "object" && isDOM(t.nativeElement) ? t.nativeElement : isDOM(t) ? t : null;
}
function findDOMNode(t) {
  var r = getDOM(t);
  if (r)
    return r;
  if (t instanceof React__default.Component) {
    var n;
    return (n = ReactDOM__default.findDOMNode) === null || n === void 0 ? void 0 : n.call(ReactDOM__default, t);
  }
  return null;
}
var CollectionContext = /* @__PURE__ */ React.createContext(null);
function Collection(t) {
  var r = t.children, n = t.onBatchResize, a = React.useRef(0), s = React.useRef([]), o = React.useContext(CollectionContext), l = React.useCallback(function(c, x, j) {
    a.current += 1;
    var Z = a.current;
    s.current.push({
      size: c,
      element: x,
      data: j
    }), Promise.resolve().then(function() {
      Z === a.current && (n == null || n(s.current), s.current = []);
    }), o == null || o(c, x, j);
  }, [n, o]);
  return /* @__PURE__ */ React.createElement(CollectionContext.Provider, {
    value: l
  }, r);
}
var MapShim = (function() {
  if (typeof Map != "undefined")
    return Map;
  function t(r, n) {
    var a = -1;
    return r.some(function(s, o) {
      return s[0] === n ? (a = o, !0) : !1;
    }), a;
  }
  return (
    /** @class */
    (function() {
      function r() {
        this.__entries__ = [];
      }
      return Object.defineProperty(r.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), r.prototype.get = function(n) {
        var a = t(this.__entries__, n), s = this.__entries__[a];
        return s && s[1];
      }, r.prototype.set = function(n, a) {
        var s = t(this.__entries__, n);
        ~s ? this.__entries__[s][1] = a : this.__entries__.push([n, a]);
      }, r.prototype.delete = function(n) {
        var a = this.__entries__, s = t(a, n);
        ~s && a.splice(s, 1);
      }, r.prototype.has = function(n) {
        return !!~t(this.__entries__, n);
      }, r.prototype.clear = function() {
        this.__entries__.splice(0);
      }, r.prototype.forEach = function(n, a) {
        a === void 0 && (a = null);
        for (var s = 0, o = this.__entries__; s < o.length; s++) {
          var l = o[s];
          n.call(a, l[1], l[0]);
        }
      }, r;
    })()
  );
})(), isBrowser$1 = typeof window != "undefined" && typeof document != "undefined" && window.document === document, global$1 = (function() {
  return typeof global != "undefined" && global.Math === Math ? global : typeof self != "undefined" && self.Math === Math ? self : typeof window != "undefined" && window.Math === Math ? window : Function("return this")();
})(), requestAnimationFrame$1 = (function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(global$1) : function(t) {
    return setTimeout(function() {
      return t(Date.now());
    }, 1e3 / 60);
  };
})(), trailingTimeout = 2;
function throttle(t, r) {
  var n = !1, a = !1, s = 0;
  function o() {
    n && (n = !1, t()), a && c();
  }
  function l() {
    requestAnimationFrame$1(o);
  }
  function c() {
    var x = Date.now();
    if (n) {
      if (x - s < trailingTimeout)
        return;
      a = !0;
    } else
      n = !0, a = !1, setTimeout(l, r);
    s = x;
  }
  return c;
}
var REFRESH_DELAY = 20, transitionKeys = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], mutationObserverSupported = typeof MutationObserver != "undefined", ResizeObserverController = (
  /** @class */
  (function() {
    function t() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    return t.prototype.addObserver = function(r) {
      ~this.observers_.indexOf(r) || this.observers_.push(r), this.connected_ || this.connect_();
    }, t.prototype.removeObserver = function(r) {
      var n = this.observers_, a = n.indexOf(r);
      ~a && n.splice(a, 1), !n.length && this.connected_ && this.disconnect_();
    }, t.prototype.refresh = function() {
      var r = this.updateObservers_();
      r && this.refresh();
    }, t.prototype.updateObservers_ = function() {
      var r = this.observers_.filter(function(n) {
        return n.gatherActive(), n.hasActive();
      });
      return r.forEach(function(n) {
        return n.broadcastActive();
      }), r.length > 0;
    }, t.prototype.connect_ = function() {
      !isBrowser$1 || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), mutationObserverSupported ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, t.prototype.disconnect_ = function() {
      !isBrowser$1 || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, t.prototype.onTransitionEnd_ = function(r) {
      var n = r.propertyName, a = n === void 0 ? "" : n, s = transitionKeys.some(function(o) {
        return !!~a.indexOf(o);
      });
      s && this.refresh();
    }, t.getInstance = function() {
      return this.instance_ || (this.instance_ = new t()), this.instance_;
    }, t.instance_ = null, t;
  })()
), defineConfigurable = (function(t, r) {
  for (var n = 0, a = Object.keys(r); n < a.length; n++) {
    var s = a[n];
    Object.defineProperty(t, s, {
      value: r[s],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return t;
}), getWindowOf = (function(t) {
  var r = t && t.ownerDocument && t.ownerDocument.defaultView;
  return r || global$1;
}), emptyRect = createRectInit(0, 0, 0, 0);
function toFloat(t) {
  return parseFloat(t) || 0;
}
function getBordersSize(t) {
  for (var r = [], n = 1; n < arguments.length; n++)
    r[n - 1] = arguments[n];
  return r.reduce(function(a, s) {
    var o = t["border-" + s + "-width"];
    return a + toFloat(o);
  }, 0);
}
function getPaddings(t) {
  for (var r = ["top", "right", "bottom", "left"], n = {}, a = 0, s = r; a < s.length; a++) {
    var o = s[a], l = t["padding-" + o];
    n[o] = toFloat(l);
  }
  return n;
}
function getSVGContentRect(t) {
  var r = t.getBBox();
  return createRectInit(0, 0, r.width, r.height);
}
function getHTMLElementContentRect(t) {
  var r = t.clientWidth, n = t.clientHeight;
  if (!r && !n)
    return emptyRect;
  var a = getWindowOf(t).getComputedStyle(t), s = getPaddings(a), o = s.left + s.right, l = s.top + s.bottom, c = toFloat(a.width), x = toFloat(a.height);
  if (a.boxSizing === "border-box" && (Math.round(c + o) !== r && (c -= getBordersSize(a, "left", "right") + o), Math.round(x + l) !== n && (x -= getBordersSize(a, "top", "bottom") + l)), !isDocumentElement(t)) {
    var j = Math.round(c + o) - r, Z = Math.round(x + l) - n;
    Math.abs(j) !== 1 && (c -= j), Math.abs(Z) !== 1 && (x -= Z);
  }
  return createRectInit(s.left, s.top, c, x);
}
var isSVGGraphicsElement = /* @__PURE__ */ (function() {
  return typeof SVGGraphicsElement != "undefined" ? function(t) {
    return t instanceof getWindowOf(t).SVGGraphicsElement;
  } : function(t) {
    return t instanceof getWindowOf(t).SVGElement && typeof t.getBBox == "function";
  };
})();
function isDocumentElement(t) {
  return t === getWindowOf(t).document.documentElement;
}
function getContentRect(t) {
  return isBrowser$1 ? isSVGGraphicsElement(t) ? getSVGContentRect(t) : getHTMLElementContentRect(t) : emptyRect;
}
function createReadOnlyRect(t) {
  var r = t.x, n = t.y, a = t.width, s = t.height, o = typeof DOMRectReadOnly != "undefined" ? DOMRectReadOnly : Object, l = Object.create(o.prototype);
  return defineConfigurable(l, {
    x: r,
    y: n,
    width: a,
    height: s,
    top: n,
    right: r + a,
    bottom: s + n,
    left: r
  }), l;
}
function createRectInit(t, r, n, a) {
  return { x: t, y: r, width: n, height: a };
}
var ResizeObservation = (
  /** @class */
  (function() {
    function t(r) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = createRectInit(0, 0, 0, 0), this.target = r;
    }
    return t.prototype.isActive = function() {
      var r = getContentRect(this.target);
      return this.contentRect_ = r, r.width !== this.broadcastWidth || r.height !== this.broadcastHeight;
    }, t.prototype.broadcastRect = function() {
      var r = this.contentRect_;
      return this.broadcastWidth = r.width, this.broadcastHeight = r.height, r;
    }, t;
  })()
), ResizeObserverEntry = (
  /** @class */
  /* @__PURE__ */ (function() {
    function t(r, n) {
      var a = createReadOnlyRect(n);
      defineConfigurable(this, { target: r, contentRect: a });
    }
    return t;
  })()
), ResizeObserverSPI = (
  /** @class */
  (function() {
    function t(r, n, a) {
      if (this.activeObservations_ = [], this.observations_ = new MapShim(), typeof r != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = r, this.controller_ = n, this.callbackCtx_ = a;
    }
    return t.prototype.observe = function(r) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element == "undefined" || !(Element instanceof Object))) {
        if (!(r instanceof getWindowOf(r).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(r) || (n.set(r, new ResizeObservation(r)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, t.prototype.unobserve = function(r) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element == "undefined" || !(Element instanceof Object))) {
        if (!(r instanceof getWindowOf(r).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(r) && (n.delete(r), n.size || this.controller_.removeObserver(this));
      }
    }, t.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, t.prototype.gatherActive = function() {
      var r = this;
      this.clearActive(), this.observations_.forEach(function(n) {
        n.isActive() && r.activeObservations_.push(n);
      });
    }, t.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var r = this.callbackCtx_, n = this.activeObservations_.map(function(a) {
          return new ResizeObserverEntry(a.target, a.broadcastRect());
        });
        this.callback_.call(r, n, r), this.clearActive();
      }
    }, t.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, t.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, t;
  })()
), observers = typeof WeakMap != "undefined" ? /* @__PURE__ */ new WeakMap() : new MapShim(), ResizeObserver$2 = (
  /** @class */
  /* @__PURE__ */ (function() {
    function t(r) {
      if (!(this instanceof t))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var n = ResizeObserverController.getInstance(), a = new ResizeObserverSPI(r, n, this);
      observers.set(this, a);
    }
    return t;
  })()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(t) {
  ResizeObserver$2.prototype[t] = function() {
    var r;
    return (r = observers.get(this))[t].apply(r, arguments);
  };
});
var index$2 = (function() {
  return typeof global$1.ResizeObserver != "undefined" ? global$1.ResizeObserver : ResizeObserver$2;
})(), elementListeners = /* @__PURE__ */ new Map();
function onResize(t) {
  t.forEach(function(r) {
    var n, a = r.target;
    (n = elementListeners.get(a)) === null || n === void 0 || n.forEach(function(s) {
      return s(a);
    });
  });
}
var resizeObserver = new index$2(onResize);
process.env.NODE_ENV;
process.env.NODE_ENV;
function observe(t, r) {
  elementListeners.has(t) || (elementListeners.set(t, /* @__PURE__ */ new Set()), resizeObserver.observe(t)), elementListeners.get(t).add(r);
}
function unobserve(t, r) {
  elementListeners.has(t) && (elementListeners.get(t).delete(r), elementListeners.get(t).size || (resizeObserver.unobserve(t), elementListeners.delete(t)));
}
function _classCallCheck(t, r) {
  if (!(t instanceof r)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(t, r) {
  for (var n = 0; n < r.length; n++) {
    var a = r[n];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, toPropertyKey(a.key), a);
  }
}
function _createClass(t, r, n) {
  return r && _defineProperties(t.prototype, r), n && _defineProperties(t, n), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
function _setPrototypeOf(t, r) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, _setPrototypeOf(t, r);
}
function _inherits(t, r) {
  if (typeof r != "function" && r !== null) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(r && r.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), r && _setPrototypeOf(t, r);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, _getPrototypeOf(t);
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct = function() {
    return !!t;
  })();
}
function _assertThisInitialized(t) {
  if (t === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function _possibleConstructorReturn(t, r) {
  if (r && (_typeof$1(r) == "object" || typeof r == "function")) return r;
  if (r !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _createSuper(t) {
  var r = _isNativeReflectConstruct();
  return function() {
    var n, a = _getPrototypeOf(t);
    if (r) {
      var s = _getPrototypeOf(this).constructor;
      n = Reflect.construct(a, arguments, s);
    } else n = a.apply(this, arguments);
    return _possibleConstructorReturn(this, n);
  };
}
var DomWrapper$1 = /* @__PURE__ */ (function(t) {
  _inherits(n, t);
  var r = _createSuper(n);
  function n() {
    return _classCallCheck(this, n), r.apply(this, arguments);
  }
  return _createClass(n, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), n;
})(React.Component);
function SingleObserver(t, r) {
  var n = t.children, a = t.disabled, s = React.useRef(null), o = React.useRef(null), l = React.useContext(CollectionContext), c = typeof n == "function", x = c ? n(s) : n, j = React.useRef({
    width: -1,
    height: -1,
    offsetWidth: -1,
    offsetHeight: -1
  }), Z = !c && /* @__PURE__ */ React.isValidElement(x) && supportRef(x), V = Z ? getNodeRef(x) : null, U = useComposeRef(V, s), $ = function() {
    var X;
    return findDOMNode(s.current) || // Support `nativeElement` format
    (s.current && _typeof$1(s.current) === "object" ? findDOMNode((X = s.current) === null || X === void 0 ? void 0 : X.nativeElement) : null) || findDOMNode(o.current);
  };
  React.useImperativeHandle(r, function() {
    return $();
  });
  var Y = React.useRef(t);
  Y.current = t;
  var G = React.useCallback(function(W) {
    var X = Y.current, K = X.onResize, J = X.data, ee = W.getBoundingClientRect(), te = ee.width, ne = ee.height, re = W.offsetWidth, ie = W.offsetHeight, ue = Math.floor(te), le = Math.floor(ne);
    if (j.current.width !== ue || j.current.height !== le || j.current.offsetWidth !== re || j.current.offsetHeight !== ie) {
      var oe = {
        width: ue,
        height: le,
        offsetWidth: re,
        offsetHeight: ie
      };
      j.current = oe;
      var he = re === Math.round(te) ? te : re, fe = ie === Math.round(ne) ? ne : ie, ce = _objectSpread2(_objectSpread2({}, oe), {}, {
        offsetWidth: he,
        offsetHeight: fe
      });
      l == null || l(ce, W, J), K && Promise.resolve().then(function() {
        K(ce, W);
      });
    }
  }, []);
  return React.useEffect(function() {
    var W = $();
    return W && !a && observe(W, G), function() {
      return unobserve(W, G);
    };
  }, [s.current, a]), /* @__PURE__ */ React.createElement(DomWrapper$1, {
    ref: o
  }, Z ? /* @__PURE__ */ React.cloneElement(x, {
    ref: U
  }) : x);
}
var RefSingleObserver = /* @__PURE__ */ React.forwardRef(SingleObserver);
process.env.NODE_ENV !== "production" && (RefSingleObserver.displayName = "SingleObserver");
var INTERNAL_PREFIX_KEY = "rc-observer-key";
function ResizeObserver$1(t, r) {
  var n = t.children, a = typeof n == "function" ? [n] : toArray$2(n);
  return process.env.NODE_ENV !== "production" && (a.length > 1 ? warning(!1, "Find more than one child node with `children` in ResizeObserver. Please use ResizeObserver.Collection instead.") : a.length === 0 && warning(!1, "`children` of ResizeObserver is empty. Nothing is in observe.")), a.map(function(s, o) {
    var l = (s == null ? void 0 : s.key) || "".concat(INTERNAL_PREFIX_KEY, "-").concat(o);
    return /* @__PURE__ */ React.createElement(RefSingleObserver, _extends({}, t, {
      key: l,
      ref: o === 0 ? r : void 0
    }), s);
  });
}
var RefResizeObserver = /* @__PURE__ */ React.forwardRef(ResizeObserver$1);
process.env.NODE_ENV !== "production" && (RefResizeObserver.displayName = "ResizeObserver");
RefResizeObserver.Collection = Collection;
var _excluded$c = ["prefixCls", "invalidate", "item", "renderItem", "responsive", "responsiveDisabled", "registerSize", "itemKey", "className", "style", "children", "display", "order", "component"], UNDEFINED = void 0;
function InternalItem(t, r) {
  var n = t.prefixCls, a = t.invalidate, s = t.item, o = t.renderItem, l = t.responsive, c = t.responsiveDisabled, x = t.registerSize, j = t.itemKey, Z = t.className, V = t.style, U = t.children, $ = t.display, Y = t.order, G = t.component, W = G === void 0 ? "div" : G, X = _objectWithoutProperties(t, _excluded$c), K = l && !$;
  function J(ie) {
    x(j, ie);
  }
  React.useEffect(function() {
    return function() {
      J(null);
    };
  }, []);
  var ee = o && s !== UNDEFINED ? o(s, {
    index: Y
  }) : U, te;
  a || (te = {
    opacity: K ? 0 : 1,
    height: K ? 0 : UNDEFINED,
    overflowY: K ? "hidden" : UNDEFINED,
    order: l ? Y : UNDEFINED,
    pointerEvents: K ? "none" : UNDEFINED,
    position: K ? "absolute" : UNDEFINED
  });
  var ne = {};
  K && (ne["aria-hidden"] = !0);
  var re = /* @__PURE__ */ React.createElement(W, _extends({
    className: cls(!a && n, Z),
    style: _objectSpread2(_objectSpread2({}, te), V)
  }, ne, X, {
    ref: r
  }), ee);
  return l && (re = /* @__PURE__ */ React.createElement(RefResizeObserver, {
    onResize: function(ue) {
      var le = ue.offsetWidth;
      J(le);
    },
    disabled: c
  }, re)), re;
}
var Item$2 = /* @__PURE__ */ React.forwardRef(InternalItem);
Item$2.displayName = "Item";
var raf = function(r) {
  return +setTimeout(r, 16);
}, caf = function(r) {
  return clearTimeout(r);
};
typeof window != "undefined" && "requestAnimationFrame" in window && (raf = function(r) {
  return window.requestAnimationFrame(r);
}, caf = function(r) {
  return window.cancelAnimationFrame(r);
});
var rafUUID = 0, rafIds = /* @__PURE__ */ new Map();
function cleanup(t) {
  rafIds.delete(t);
}
var wrapperRaf = function(r) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  rafUUID += 1;
  var a = rafUUID;
  function s(o) {
    if (o === 0)
      cleanup(a), r();
    else {
      var l = raf(function() {
        s(o - 1);
      });
      rafIds.set(a, l);
    }
  }
  return s(n), a;
};
wrapperRaf.cancel = function(t) {
  var r = rafIds.get(t);
  return cleanup(t), caf(r);
};
process.env.NODE_ENV !== "production" && (wrapperRaf.ids = function() {
  return rafIds;
});
function channelUpdate(t) {
  if (typeof MessageChannel == "undefined")
    wrapperRaf(t);
  else {
    var r = new MessageChannel();
    r.port1.onmessage = function() {
      return t();
    }, r.port2.postMessage(void 0);
  }
}
function useBatcher() {
  var t = React.useRef(null), r = function(a) {
    t.current || (t.current = [], channelUpdate(function() {
      unstable_batchedUpdates(function() {
        t.current.forEach(function(s) {
          s();
        }), t.current = null;
      });
    })), t.current.push(a);
  };
  return r;
}
function useEffectState(t, r) {
  var n = React.useState(r), a = _slicedToArray(n, 2), s = a[0], o = a[1], l = useEvent$1(function(c) {
    t(function() {
      o(c);
    });
  });
  return [s, l];
}
var OverflowContext = /* @__PURE__ */ React__default.createContext(null), _excluded$b = ["component"], _excluded2$2 = ["className"], _excluded3 = ["className"], InternalRawItem = function(r, n) {
  var a = React.useContext(OverflowContext);
  if (!a) {
    var s = r.component, o = s === void 0 ? "div" : s, l = _objectWithoutProperties(r, _excluded$b);
    return /* @__PURE__ */ React.createElement(o, _extends({}, l, {
      ref: n
    }));
  }
  var c = a.className, x = _objectWithoutProperties(a, _excluded2$2), j = r.className, Z = _objectWithoutProperties(r, _excluded3);
  return /* @__PURE__ */ React.createElement(OverflowContext.Provider, {
    value: null
  }, /* @__PURE__ */ React.createElement(Item$2, _extends({
    ref: n,
    className: cls(c, j)
  }, x, Z)));
}, RawItem = /* @__PURE__ */ React.forwardRef(InternalRawItem);
RawItem.displayName = "RawItem";
var _excluded$a = ["prefixCls", "data", "renderItem", "renderRawItem", "itemKey", "itemWidth", "ssr", "style", "className", "maxCount", "renderRest", "renderRawRest", "prefix", "suffix", "component", "itemComponent", "onVisibleChange"], RESPONSIVE = "responsive", INVALIDATE = "invalidate";
function defaultRenderRest(t) {
  return "+ ".concat(t.length, " ...");
}
function Overflow(t, r) {
  var n = t.prefixCls, a = n === void 0 ? "rc-overflow" : n, s = t.data, o = s === void 0 ? [] : s, l = t.renderItem, c = t.renderRawItem, x = t.itemKey, j = t.itemWidth, Z = j === void 0 ? 10 : j, V = t.ssr, U = t.style, $ = t.className, Y = t.maxCount, G = t.renderRest, W = t.renderRawRest, X = t.prefix, K = t.suffix, J = t.component, ee = J === void 0 ? "div" : J, te = t.itemComponent, ne = t.onVisibleChange, re = _objectWithoutProperties(t, _excluded$a), ie = V === "full", ue = useBatcher(), le = useEffectState(ue, null), oe = _slicedToArray(le, 2), he = oe[0], fe = oe[1], ce = he || 0, se = useEffectState(ue, /* @__PURE__ */ new Map()), pe = _slicedToArray(se, 2), ve = pe[0], ae = pe[1], me = useEffectState(ue, 0), de = _slicedToArray(me, 2), ge = de[0], Se = de[1], xe = useEffectState(ue, 0), Ee = _slicedToArray(xe, 2), Ce = Ee[0], ke = Ee[1], Re = useEffectState(ue, 0), _e = _slicedToArray(Re, 2), Me = _e[0], we = _e[1], Te = useEffectState(ue, 0), be = _slicedToArray(Te, 2), Pe = be[0], ye = be[1], Ae = useState$1(null), Fe = _slicedToArray(Ae, 2), Ie = Fe[0], Le = Fe[1], De = useState$1(null), je = _slicedToArray(De, 2), Ze = je[0], $e = je[1], Oe = React.useMemo(function() {
    return Ze === null && ie ? Number.MAX_SAFE_INTEGER : Ze || 0;
  }, [Ze, he]), Be = useState$1(!1), Qe = _slicedToArray(Be, 2), Xe = Qe[0], rt = Qe[1], lt = "".concat(a, "-item"), ct = Math.max(ge, Ce), Je = Y === RESPONSIVE, st = o.length && Je, At = Y === INVALIDATE, bt = st || typeof Y == "number" && o.length > Y, gt = useMemo$1(function() {
    var Ne = o;
    return st ? he === null && ie ? Ne = o : Ne = o.slice(0, Math.min(o.length, ce / Z)) : typeof Y == "number" && (Ne = o.slice(0, Y)), Ne;
  }, [o, Z, he, Y, st]), xt = useMemo$1(function() {
    return st ? o.slice(Oe + 1) : o.slice(gt.length);
  }, [o, gt, st, Oe]), ht = useCallback(function(Ne, Ve) {
    var qe;
    return typeof x == "function" ? x(Ne) : (qe = x && (Ne == null ? void 0 : Ne[x])) !== null && qe !== void 0 ? qe : Ve;
  }, [x]), jt = useCallback(l || function(Ne) {
    return Ne;
  }, [l]);
  function Rt(Ne, Ve, qe) {
    Ze === Ne && (Ve === void 0 || Ve === Ie) || ($e(Ne), qe || (rt(Ne < o.length - 1), ne == null || ne(Ne)), Ve !== void 0 && Le(Ve));
  }
  function Dt(Ne, Ve) {
    fe(Ve.clientWidth);
  }
  function wt(Ne, Ve) {
    ae(function(qe) {
      var nt = new Map(qe);
      return Ve === null ? nt.delete(Ne) : nt.set(Ne, Ve), nt;
    });
  }
  function Wt(Ne, Ve) {
    ke(Ve), Se(Ce);
  }
  function Bt(Ne, Ve) {
    we(Ve);
  }
  function It(Ne, Ve) {
    ye(Ve);
  }
  function pt(Ne) {
    return ve.get(ht(gt[Ne], Ne));
  }
  useLayoutEffect$2(function() {
    if (ce && typeof ct == "number" && gt) {
      var Ne = Me + Pe, Ve = gt.length, qe = Ve - 1;
      if (!Ve) {
        Rt(0, null);
        return;
      }
      for (var nt = 0; nt < Ve; nt += 1) {
        var Pt = pt(nt);
        if (ie && (Pt = Pt || 0), Pt === void 0) {
          Rt(nt - 1, void 0, !0);
          break;
        }
        if (Ne += Pt, // Only one means `totalWidth` is the final width
        qe === 0 && Ne <= ce || // Last two width will be the final width
        nt === qe - 1 && Ne + pt(qe) <= ce) {
          Rt(qe, null);
          break;
        } else if (Ne + ct > ce) {
          Rt(nt - 1, Ne - Pt - Pe + Ce);
          break;
        }
      }
      K && pt(0) + Pe > ce && Le(null);
    }
  }, [ce, ve, Ce, Me, Pe, ht, gt]);
  var et = Xe && !!xt.length, Tt = {};
  Ie !== null && st && (Tt = {
    position: "absolute",
    left: Ie,
    top: 0
  });
  var Et = {
    prefixCls: lt,
    responsive: st,
    component: te,
    invalidate: At
  }, dt = c ? function(Ne, Ve) {
    var qe = ht(Ne, Ve);
    return /* @__PURE__ */ React.createElement(OverflowContext.Provider, {
      key: qe,
      value: _objectSpread2(_objectSpread2({}, Et), {}, {
        order: Ve,
        item: Ne,
        itemKey: qe,
        registerSize: wt,
        display: Ve <= Oe
      })
    }, c(Ne, Ve));
  } : function(Ne, Ve) {
    var qe = ht(Ne, Ve);
    return /* @__PURE__ */ React.createElement(Item$2, _extends({}, Et, {
      order: Ve,
      key: qe,
      item: Ne,
      renderItem: jt,
      itemKey: qe,
      registerSize: wt,
      display: Ve <= Oe
    }));
  }, zt = {
    order: et ? Oe : Number.MAX_SAFE_INTEGER,
    className: "".concat(lt, "-rest"),
    registerSize: Wt,
    display: et
  }, Lt = G || defaultRenderRest, Ge = W ? /* @__PURE__ */ React.createElement(OverflowContext.Provider, {
    value: _objectSpread2(_objectSpread2({}, Et), zt)
  }, W(xt)) : /* @__PURE__ */ React.createElement(Item$2, _extends({}, Et, zt), typeof Lt == "function" ? Lt(xt) : Lt), ze = /* @__PURE__ */ React.createElement(ee, _extends({
    className: cls(!At && a, $),
    style: U,
    ref: r
  }, re), X && /* @__PURE__ */ React.createElement(Item$2, _extends({}, Et, {
    responsive: Je,
    responsiveDisabled: !st,
    order: -1,
    className: "".concat(lt, "-prefix"),
    registerSize: Bt,
    display: !0
  }), X), gt.map(dt), bt ? Ge : null, K && /* @__PURE__ */ React.createElement(Item$2, _extends({}, Et, {
    responsive: Je,
    responsiveDisabled: !st,
    order: Oe,
    className: "".concat(lt, "-suffix"),
    registerSize: It,
    display: !0,
    style: Tt
  }), K));
  return Je ? /* @__PURE__ */ React.createElement(RefResizeObserver, {
    onResize: Dt,
    disabled: !st
  }, ze) : ze;
}
var ForwardOverflow = /* @__PURE__ */ React.forwardRef(Overflow);
ForwardOverflow.displayName = "Overflow";
ForwardOverflow.Item = RawItem;
ForwardOverflow.RESPONSIVE = RESPONSIVE;
ForwardOverflow.INVALIDATE = INVALIDATE;
var Input$1 = function(r, n) {
  var a, s = r.prefixCls, o = r.id, l = r.inputElement, c = r.disabled, x = r.tabIndex, j = r.autoFocus, Z = r.autoComplete, V = r.editable, U = r.activeDescendantId, $ = r.value, Y = r.maxLength, G = r.onKeyDown, W = r.onMouseDown, X = r.onChange, K = r.onPaste, J = r.onCompositionStart, ee = r.onCompositionEnd, te = r.open, ne = r.attrs, re = l || /* @__PURE__ */ React.createElement("input", null), ie = re, ue = ie.ref, le = ie.props, oe = le.onKeyDown, he = le.onChange, fe = le.onMouseDown, ce = le.onCompositionStart, se = le.onCompositionEnd, pe = le.style;
  return warning(!("maxLength" in re.props), "Passing 'maxLength' to input element directly may not work because input in BaseSelect is controlled."), re = /* @__PURE__ */ React.cloneElement(re, _objectSpread2(_objectSpread2(_objectSpread2({
    type: "search"
  }, le), {}, {
    // Override over origin props
    id: o,
    ref: composeRef(n, ue),
    disabled: c,
    tabIndex: x,
    autoComplete: Z || "off",
    autoFocus: j,
    className: cls("".concat(s, "-selection-search-input"), (a = re) === null || a === void 0 || (a = a.props) === null || a === void 0 ? void 0 : a.className),
    role: "combobox",
    "aria-expanded": te || !1,
    "aria-haspopup": "listbox",
    "aria-owns": "".concat(o, "_list"),
    "aria-autocomplete": "list",
    "aria-controls": "".concat(o, "_list"),
    "aria-activedescendant": te ? U : void 0
  }, ne), {}, {
    value: V ? $ : "",
    maxLength: Y,
    readOnly: !V,
    unselectable: V ? null : "on",
    style: _objectSpread2(_objectSpread2({}, pe), {}, {
      opacity: V ? null : 0
    }),
    onKeyDown: function(ae) {
      G(ae), oe && oe(ae);
    },
    onMouseDown: function(ae) {
      W(ae), fe && fe(ae);
    },
    onChange: function(ae) {
      X(ae), he && he(ae);
    },
    onCompositionStart: function(ae) {
      J(ae), ce && ce(ae);
    },
    onCompositionEnd: function(ae) {
      ee(ae), se && se(ae);
    },
    onPaste: K
  })), re;
}, RefInput = /* @__PURE__ */ React.forwardRef(Input$1);
process.env.NODE_ENV !== "production" && (RefInput.displayName = "Input");
function toArray$1(t) {
  return Array.isArray(t) ? t : t !== void 0 ? [t] : [];
}
var isClient$2 = typeof window != "undefined" && window.document && window.document.documentElement, isBrowserClient$1 = process.env.NODE_ENV !== "test" && isClient$2;
function hasValue$1(t) {
  return t != null;
}
function isComboNoValue(t) {
  return !t && t !== 0;
}
function isTitleType$1(t) {
  return ["string", "number"].includes(_typeof$1(t));
}
function getTitle(t) {
  var r = void 0;
  return t && (isTitleType$1(t.title) ? r = t.title.toString() : isTitleType$1(t.label) && (r = t.label.toString())), r;
}
function useLayoutEffect$1(t, r) {
  isBrowserClient$1 ? React.useLayoutEffect(t, r) : React.useEffect(t, r);
}
function itemKey(t) {
  var r;
  return (r = t.key) !== null && r !== void 0 ? r : t.value;
}
var onPreventMouseDown = function(r) {
  r.preventDefault(), r.stopPropagation();
}, SelectSelector = function(r) {
  var n = r.id, a = r.prefixCls, s = r.values, o = r.open, l = r.searchValue, c = r.autoClearSearchValue, x = r.inputRef, j = r.placeholder, Z = r.disabled, V = r.mode, U = r.showSearch, $ = r.autoFocus, Y = r.autoComplete, G = r.activeDescendantId, W = r.tabIndex, X = r.removeIcon, K = r.maxTagCount, J = r.maxTagTextLength, ee = r.maxTagPlaceholder, te = ee === void 0 ? function(Pe) {
    return "+ ".concat(Pe.length, " ...");
  } : ee, ne = r.tagRender, re = r.onToggleOpen, ie = r.onRemove, ue = r.onInputChange, le = r.onInputPaste, oe = r.onInputKeyDown, he = r.onInputMouseDown, fe = r.onInputCompositionStart, ce = r.onInputCompositionEnd, se = React.useRef(null), pe = useState$1(0), ve = _slicedToArray(pe, 2), ae = ve[0], me = ve[1], de = useState$1(!1), ge = _slicedToArray(de, 2), Se = ge[0], xe = ge[1], Ee = "".concat(a, "-selection"), Ce = o || V === "multiple" && c === !1 || V === "tags" ? l : "", ke = V === "tags" || V === "multiple" && c === !1 || U && (o || Se);
  useLayoutEffect$1(function() {
    me(se.current.scrollWidth);
  }, [Ce]);
  var Re = function(ye, Ae, Fe, Ie, Le) {
    return /* @__PURE__ */ React.createElement("span", {
      title: getTitle(ye),
      className: cls("".concat(Ee, "-item"), _defineProperty({}, "".concat(Ee, "-item-disabled"), Fe))
    }, /* @__PURE__ */ React.createElement("span", {
      className: "".concat(Ee, "-item-content")
    }, Ae), Ie && /* @__PURE__ */ React.createElement(TransBtn, {
      className: "".concat(Ee, "-item-remove"),
      onMouseDown: onPreventMouseDown,
      onClick: Le,
      customizeIcon: X
    }, "×"));
  }, _e = function(ye, Ae, Fe, Ie, Le) {
    var De = function(Ze) {
      onPreventMouseDown(Ze), re(!o);
    };
    return /* @__PURE__ */ React.createElement("span", {
      onMouseDown: De
    }, ne({
      label: Ae,
      value: ye,
      disabled: Fe,
      closable: Ie,
      onClose: Le
    }));
  }, Me = function(ye) {
    var Ae = ye.disabled, Fe = ye.label, Ie = ye.value, Le = !Z && !Ae, De = Fe;
    if (typeof J == "number" && (typeof Fe == "string" || typeof Fe == "number")) {
      var je = String(De);
      je.length > J && (De = "".concat(je.slice(0, J), "..."));
    }
    var Ze = function(Oe) {
      Oe && Oe.stopPropagation(), ie(ye);
    };
    return typeof ne == "function" ? _e(Ie, De, Ae, Le, Ze) : Re(ye, De, Ae, Le, Ze);
  }, we = function(ye) {
    var Ae = typeof te == "function" ? te(ye) : te;
    return Re({
      title: Ae
    }, Ae, !1);
  }, Te = /* @__PURE__ */ React.createElement("div", {
    className: "".concat(Ee, "-search"),
    style: {
      width: ae
    },
    onFocus: function() {
      xe(!0);
    },
    onBlur: function() {
      xe(!1);
    }
  }, /* @__PURE__ */ React.createElement(RefInput, {
    ref: x,
    open: o,
    prefixCls: a,
    id: n,
    inputElement: null,
    disabled: Z,
    autoFocus: $,
    autoComplete: Y,
    editable: ke,
    activeDescendantId: G,
    value: Ce,
    onKeyDown: oe,
    onMouseDown: he,
    onChange: ue,
    onPaste: le,
    onCompositionStart: fe,
    onCompositionEnd: ce,
    tabIndex: W,
    attrs: pickAttrs(r, !0)
  }), /* @__PURE__ */ React.createElement("span", {
    ref: se,
    className: "".concat(Ee, "-search-mirror"),
    "aria-hidden": !0
  }, Ce, " ")), be = /* @__PURE__ */ React.createElement(ForwardOverflow, {
    prefixCls: "".concat(Ee, "-overflow"),
    data: s,
    renderItem: Me,
    renderRest: we,
    suffix: Te,
    itemKey,
    maxCount: K
  });
  return /* @__PURE__ */ React.createElement(React.Fragment, null, be, !s.length && !Ce && /* @__PURE__ */ React.createElement("span", {
    className: "".concat(Ee, "-placeholder")
  }, j));
}, SingleSelector = function(r) {
  var n = r.inputElement, a = r.prefixCls, s = r.id, o = r.inputRef, l = r.disabled, c = r.autoFocus, x = r.autoComplete, j = r.activeDescendantId, Z = r.mode, V = r.open, U = r.values, $ = r.placeholder, Y = r.tabIndex, G = r.showSearch, W = r.searchValue, X = r.activeValue, K = r.maxLength, J = r.onInputKeyDown, ee = r.onInputMouseDown, te = r.onInputChange, ne = r.onInputPaste, re = r.onInputCompositionStart, ie = r.onInputCompositionEnd, ue = r.title, le = React.useState(!1), oe = _slicedToArray(le, 2), he = oe[0], fe = oe[1], ce = Z === "combobox", se = ce || G, pe = U[0], ve = W || "";
  ce && X && !he && (ve = X), React.useEffect(function() {
    ce && fe(!1);
  }, [ce, X]);
  var ae = Z !== "combobox" && !V && !G ? !1 : !!ve, me = ue === void 0 ? getTitle(pe) : ue, de = React.useMemo(function() {
    return pe ? null : /* @__PURE__ */ React.createElement("span", {
      className: "".concat(a, "-selection-placeholder"),
      style: ae ? {
        visibility: "hidden"
      } : void 0
    }, $);
  }, [pe, ae, $, a]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", {
    className: "".concat(a, "-selection-search")
  }, /* @__PURE__ */ React.createElement(RefInput, {
    ref: o,
    prefixCls: a,
    id: s,
    open: V,
    inputElement: n,
    disabled: l,
    autoFocus: c,
    autoComplete: x,
    editable: se,
    activeDescendantId: j,
    value: ve,
    onKeyDown: J,
    onMouseDown: ee,
    onChange: function(Se) {
      fe(!0), te(Se);
    },
    onPaste: ne,
    onCompositionStart: re,
    onCompositionEnd: ie,
    tabIndex: Y,
    attrs: pickAttrs(r, !0),
    maxLength: ce ? K : void 0
  })), !ce && pe ? /* @__PURE__ */ React.createElement("span", {
    className: "".concat(a, "-selection-item"),
    title: me,
    style: ae ? {
      visibility: "hidden"
    } : void 0
  }, pe.label) : null, de);
}, Selector = function(r, n) {
  var a = useRef(null), s = useRef(!1), o = r.prefixCls, l = r.open, c = r.mode, x = r.showSearch, j = r.tokenWithEnter, Z = r.autoClearSearchValue, V = r.onSearch, U = r.onSearchSubmit, $ = r.onToggleOpen, Y = r.onInputKeyDown, G = r.domRef;
  React.useImperativeHandle(n, function() {
    return {
      focus: function(ve) {
        a.current.focus(ve);
      },
      blur: function() {
        a.current.blur();
      }
    };
  });
  var W = useLock(0), X = _slicedToArray(W, 2), K = X[0], J = X[1], ee = function(ve) {
    var ae = ve.which;
    (ae === KeyCode.UP || ae === KeyCode.DOWN) && ve.preventDefault(), Y && Y(ve), ae === KeyCode.ENTER && c === "tags" && !s.current && !l && (U == null || U(ve.target.value)), isValidateOpenKey(ae) && $(!0);
  }, te = function() {
    J(!0);
  }, ne = useRef(null), re = function(ve) {
    V(ve, !0, s.current) !== !1 && $(!0);
  }, ie = function() {
    s.current = !0;
  }, ue = function(ve) {
    s.current = !1, c !== "combobox" && re(ve.target.value);
  }, le = function(ve) {
    var ae = ve.target.value;
    if (j && ne.current && /[\r\n]/.test(ne.current)) {
      var me = ne.current.replace(/[\r\n]+$/, "").replace(/\r\n/g, " ").replace(/[\r\n]/g, " ");
      ae = ae.replace(me, ne.current);
    }
    ne.current = null, re(ae);
  }, oe = function(ve) {
    var ae = ve.clipboardData, me = ae == null ? void 0 : ae.getData("text");
    ne.current = me || "";
  }, he = function(ve) {
    var ae = ve.target;
    if (ae !== a.current) {
      var me = document.body.style.msTouchAction !== void 0;
      me ? setTimeout(function() {
        a.current.focus();
      }) : a.current.focus();
    }
  }, fe = function(ve) {
    var ae = K();
    ve.target !== a.current && !ae && c !== "combobox" && ve.preventDefault(), (c !== "combobox" && (!x || !ae) || !l) && (l && Z !== !1 && V("", !0, !1), $());
  }, ce = {
    inputRef: a,
    onInputKeyDown: ee,
    onInputMouseDown: te,
    onInputChange: le,
    onInputPaste: oe,
    onInputCompositionStart: ie,
    onInputCompositionEnd: ue
  }, se = c === "multiple" || c === "tags" ? /* @__PURE__ */ React.createElement(SelectSelector, _extends({}, r, ce)) : /* @__PURE__ */ React.createElement(SingleSelector, _extends({}, r, ce));
  return /* @__PURE__ */ React.createElement("div", {
    ref: G,
    className: "".concat(o, "-selector"),
    onClick: he,
    onMouseDown: fe
  }, se);
}, ForwardSelector = /* @__PURE__ */ React.forwardRef(Selector);
process.env.NODE_ENV !== "production" && (ForwardSelector.displayName = "Selector");
var OrderContext = /* @__PURE__ */ React.createContext(null), EMPTY_LIST = [];
function useDom(t, r) {
  var n = React.useState(function() {
    if (!canUseDom$1())
      return null;
    var Y = document.createElement("div");
    return process.env.NODE_ENV !== "production" && r && Y.setAttribute("data-debug", r), Y;
  }), a = _slicedToArray(n, 1), s = a[0], o = React.useRef(!1), l = React.useContext(OrderContext), c = React.useState(EMPTY_LIST), x = _slicedToArray(c, 2), j = x[0], Z = x[1], V = l || (o.current ? void 0 : function(Y) {
    Z(function(G) {
      var W = [Y].concat(_toConsumableArray(G));
      return W;
    });
  });
  function U() {
    s.parentElement || document.body.appendChild(s), o.current = !0;
  }
  function $() {
    var Y;
    (Y = s.parentElement) === null || Y === void 0 || Y.removeChild(s), o.current = !1;
  }
  return useLayoutEffect$2(function() {
    return t ? l ? l(U) : U() : $(), $;
  }, [t]), useLayoutEffect$2(function() {
    j.length && (j.forEach(function(Y) {
      return Y();
    }), Z(EMPTY_LIST));
  }, [j]), [s, V];
}
function contains$2(t, r) {
  if (!t)
    return !1;
  if (t.contains)
    return t.contains(r);
  for (var n = r; n; ) {
    if (n === t)
      return !0;
    n = n.parentNode;
  }
  return !1;
}
var APPEND_ORDER = "data-rc-order", APPEND_PRIORITY = "data-rc-priority", MARK_KEY = "rc-util-key", containerCache = /* @__PURE__ */ new Map();
function getMark() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = t.mark;
  return r ? r.startsWith("data-") ? r : "data-".concat(r) : MARK_KEY;
}
function getContainer(t) {
  if (t.attachTo)
    return t.attachTo;
  var r = document.querySelector("head");
  return r || document.body;
}
function getOrder(t) {
  return t === "queue" ? "prependQueue" : t ? "prepend" : "append";
}
function findStyles(t) {
  return Array.from((containerCache.get(t) || t).children).filter(function(r) {
    return r.tagName === "STYLE";
  });
}
function injectCSS(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!canUseDom$1())
    return null;
  var n = r.csp, a = r.prepend, s = r.priority, o = s === void 0 ? 0 : s, l = getOrder(a), c = l === "prependQueue", x = document.createElement("style");
  x.setAttribute(APPEND_ORDER, l), c && o && x.setAttribute(APPEND_PRIORITY, "".concat(o)), n != null && n.nonce && (x.nonce = n == null ? void 0 : n.nonce), x.innerHTML = t;
  var j = getContainer(r), Z = j.firstChild;
  if (a) {
    if (c) {
      var V = (r.styles || findStyles(j)).filter(function(U) {
        if (!["prepend", "prependQueue"].includes(U.getAttribute(APPEND_ORDER)))
          return !1;
        var $ = Number(U.getAttribute(APPEND_PRIORITY) || 0);
        return o >= $;
      });
      if (V.length)
        return j.insertBefore(x, V[V.length - 1].nextSibling), x;
    }
    j.insertBefore(x, Z);
  } else
    j.appendChild(x);
  return x;
}
function findExistNode(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = getContainer(r);
  return (r.styles || findStyles(n)).find(function(a) {
    return a.getAttribute(getMark(r)) === t;
  });
}
function removeCSS(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = findExistNode(t, r);
  if (n) {
    var a = getContainer(r);
    a.removeChild(n);
  }
}
function syncRealContainer(t, r) {
  var n = containerCache.get(t);
  if (!n || !contains$2(document, n)) {
    var a = injectCSS("", r), s = a.parentNode;
    containerCache.set(t, s), t.removeChild(a);
  }
}
function updateCSS(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = getContainer(n), s = findStyles(a), o = _objectSpread2(_objectSpread2({}, n), {}, {
    styles: s
  });
  syncRealContainer(a, o);
  var l = findExistNode(r, o);
  if (l) {
    var c, x;
    if ((c = o.csp) !== null && c !== void 0 && c.nonce && l.nonce !== ((x = o.csp) === null || x === void 0 ? void 0 : x.nonce)) {
      var j;
      l.nonce = (j = o.csp) === null || j === void 0 ? void 0 : j.nonce;
    }
    return l.innerHTML !== t && (l.innerHTML = t), l;
  }
  var Z = injectCSS(t, o);
  return Z.setAttribute(getMark(o), r), Z;
}
function measureScrollbarSize(t) {
  var r = "rc-scrollbar-measure-".concat(Math.random().toString(36).substring(7)), n = document.createElement("div");
  n.id = r;
  var a = n.style;
  a.position = "absolute", a.left = "0", a.top = "0", a.width = "100px", a.height = "100px", a.overflow = "scroll";
  var s, o;
  if (t) {
    var l = getComputedStyle(t);
    a.scrollbarColor = l.scrollbarColor, a.scrollbarWidth = l.scrollbarWidth;
    var c = getComputedStyle(t, "::-webkit-scrollbar"), x = parseInt(c.width, 10), j = parseInt(c.height, 10);
    try {
      var Z = x ? "width: ".concat(c.width, ";") : "", V = j ? "height: ".concat(c.height, ";") : "";
      updateCSS(`
#`.concat(r, `::-webkit-scrollbar {
`).concat(Z, `
`).concat(V, `
}`), r);
    } catch (Y) {
      console.error(Y), s = x, o = j;
    }
  }
  document.body.appendChild(n);
  var U = t && s && !isNaN(s) ? s : n.offsetWidth - n.clientWidth, $ = t && o && !isNaN(o) ? o : n.offsetHeight - n.clientHeight;
  return document.body.removeChild(n), removeCSS(r), {
    width: U,
    height: $
  };
}
function getTargetScrollBarSize(t) {
  return typeof document == "undefined" || !t || !(t instanceof Element) ? {
    width: 0,
    height: 0
  } : measureScrollbarSize(t);
}
function isBodyOverflowing() {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}
var UNIQUE_ID = "rc-util-locker-".concat(Date.now()), uuid$3 = 0;
function useScrollLocker(t) {
  var r = !!t, n = React.useState(function() {
    return uuid$3 += 1, "".concat(UNIQUE_ID, "_").concat(uuid$3);
  }), a = _slicedToArray(n, 1), s = a[0];
  useLayoutEffect$2(function() {
    if (r) {
      var o = getTargetScrollBarSize(document.body).width, l = isBodyOverflowing();
      updateCSS(`
html body {
  overflow-y: hidden;
  `.concat(l ? "width: calc(100% - ".concat(o, "px);") : "", `
}`), s);
    } else
      removeCSS(s);
    return function() {
      removeCSS(s);
    };
  }, [r, s]);
}
var inline = !1;
function inlineMock(t) {
  return inline;
}
var getPortalContainer = function(r) {
  return r === !1 ? !1 : !canUseDom$1() || !r ? null : typeof r == "string" ? document.querySelector(r) : typeof r == "function" ? r() : r;
}, Portal$1 = /* @__PURE__ */ React.forwardRef(function(t, r) {
  var n = t.open, a = t.autoLock, s = t.getContainer, o = t.debug, l = t.autoDestroy, c = l === void 0 ? !0 : l, x = t.children, j = React.useState(n), Z = _slicedToArray(j, 2), V = Z[0], U = Z[1], $ = V || n;
  process.env.NODE_ENV !== "production" && warningOnce(canUseDom$1() || !n, "Portal only work in client side. Please call 'useEffect' to show Portal instead default render in SSR."), React.useEffect(function() {
    (c || n) && U(n);
  }, [n, c]);
  var Y = React.useState(function() {
    return getPortalContainer(s);
  }), G = _slicedToArray(Y, 2), W = G[0], X = G[1];
  React.useEffect(function() {
    var he = getPortalContainer(s);
    X(he != null ? he : null);
  });
  var K = useDom($ && !W, o), J = _slicedToArray(K, 2), ee = J[0], te = J[1], ne = W != null ? W : ee;
  useScrollLocker(a && n && canUseDom$1() && (ne === ee || ne === document.body));
  var re = null;
  if (x && supportRef(x) && r) {
    var ie = x;
    re = ie.ref;
  }
  var ue = useComposeRef(re, r);
  if (!$ || !canUseDom$1() || W === void 0)
    return null;
  var le = ne === !1 || inlineMock(), oe = x;
  return r && (oe = /* @__PURE__ */ React.cloneElement(x, {
    ref: ue
  })), /* @__PURE__ */ React.createElement(OrderContext.Provider, {
    value: te
  }, le ? oe : /* @__PURE__ */ createPortal(oe, ne));
});
process.env.NODE_ENV !== "production" && (Portal$1.displayName = "Portal");
function getRoot(t) {
  var r;
  return t == null || (r = t.getRootNode) === null || r === void 0 ? void 0 : r.call(t);
}
function inShadow(t) {
  return getRoot(t) instanceof ShadowRoot;
}
function getShadowRoot(t) {
  return inShadow(t) ? getRoot(t) : null;
}
function getUseId() {
  var t = _objectSpread2({}, React);
  return t.useId;
}
var uuid$2 = 0, useOriginId = getUseId();
const useId$2 = useOriginId ? (
  // Use React `useId`
  function(r) {
    var n = useOriginId();
    return r || (process.env.NODE_ENV === "test" ? "test-id" : n);
  }
) : (
  // Use compatible of `useId`
  function(r) {
    var n = React.useState("ssr-id"), a = _slicedToArray(n, 2), s = a[0], o = a[1];
    return React.useEffect(function() {
      var l = uuid$2;
      uuid$2 += 1, o("rc_unique_".concat(l));
    }, []), r || (process.env.NODE_ENV === "test" ? "test-id" : s);
  }
);
var Context = /* @__PURE__ */ React.createContext({}), DomWrapper = /* @__PURE__ */ (function(t) {
  _inherits(n, t);
  var r = _createSuper(n);
  function n() {
    return _classCallCheck(this, n), r.apply(this, arguments);
  }
  return _createClass(n, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), n;
})(React.Component);
function _toArray(t) {
  return _arrayWithHoles(t) || _iterableToArray(t) || _unsupportedIterableToArray(t) || _nonIterableRest();
}
function useSyncState(t) {
  var r = React.useReducer(function(c) {
    return c + 1;
  }, 0), n = _slicedToArray(r, 2), a = n[1], s = React.useRef(t), o = useEvent$1(function() {
    return s.current;
  }), l = useEvent$1(function(c) {
    s.current = typeof c == "function" ? c(s.current) : c, a();
  });
  return [o, l];
}
var STATUS_NONE = "none", STATUS_APPEAR = "appear", STATUS_ENTER = "enter", STATUS_LEAVE = "leave", STEP_NONE = "none", STEP_PREPARE = "prepare", STEP_START = "start", STEP_ACTIVE = "active", STEP_ACTIVATED = "end", STEP_PREPARED = "prepared";
function makePrefixMap(t, r) {
  var n = {};
  return n[t.toLowerCase()] = r.toLowerCase(), n["Webkit".concat(t)] = "webkit".concat(r), n["Moz".concat(t)] = "moz".concat(r), n["ms".concat(t)] = "MS".concat(r), n["O".concat(t)] = "o".concat(r.toLowerCase()), n;
}
function getVendorPrefixes(t, r) {
  var n = {
    animationend: makePrefixMap("Animation", "AnimationEnd"),
    transitionend: makePrefixMap("Transition", "TransitionEnd")
  };
  return t && ("AnimationEvent" in r || delete n.animationend.animation, "TransitionEvent" in r || delete n.transitionend.transition), n;
}
var vendorPrefixes = getVendorPrefixes(canUseDom$1(), typeof window != "undefined" ? window : {}), style$1 = {};
if (canUseDom$1()) {
  var _document$createEleme = document.createElement("div");
  style$1 = _document$createEleme.style;
}
var prefixedEventNames = {};
function getVendorPrefixedEventName(t) {
  if (prefixedEventNames[t])
    return prefixedEventNames[t];
  var r = vendorPrefixes[t];
  if (r)
    for (var n = Object.keys(r), a = n.length, s = 0; s < a; s += 1) {
      var o = n[s];
      if (Object.prototype.hasOwnProperty.call(r, o) && o in style$1)
        return prefixedEventNames[t] = r[o], prefixedEventNames[t];
    }
  return "";
}
var internalAnimationEndName = getVendorPrefixedEventName("animationend"), internalTransitionEndName = getVendorPrefixedEventName("transitionend"), supportTransition = !!(internalAnimationEndName && internalTransitionEndName), animationEndName = internalAnimationEndName || "animationend", transitionEndName = internalTransitionEndName || "transitionend";
function getTransitionName(t, r) {
  if (!t) return null;
  if (_typeof$1(t) === "object") {
    var n = r.replace(/-\w/g, function(a) {
      return a[1].toUpperCase();
    });
    return t[n];
  }
  return "".concat(t, "-").concat(r);
}
const useDomMotionEvents = (function(t) {
  var r = useRef();
  function n(s) {
    s && (s.removeEventListener(transitionEndName, t), s.removeEventListener(animationEndName, t));
  }
  function a(s) {
    r.current && r.current !== s && n(r.current), s && s !== r.current && (s.addEventListener(transitionEndName, t), s.addEventListener(animationEndName, t), r.current = s);
  }
  return React.useEffect(function() {
    return function() {
      n(r.current);
    };
  }, []), [a, n];
});
var useIsomorphicLayoutEffect = canUseDom$1() ? useLayoutEffect$3 : useEffect;
const useNextFrame = (function() {
  var t = React.useRef(null);
  function r() {
    wrapperRaf.cancel(t.current);
  }
  function n(a) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    r();
    var o = wrapperRaf(function() {
      s <= 1 ? a({
        isCanceled: function() {
          return o !== t.current;
        }
      }) : n(a, s - 1);
    });
    t.current = o;
  }
  return React.useEffect(function() {
    return function() {
      r();
    };
  }, []), [n, r];
});
var FULL_STEP_QUEUE = [STEP_PREPARE, STEP_START, STEP_ACTIVE, STEP_ACTIVATED], SIMPLE_STEP_QUEUE = [STEP_PREPARE, STEP_PREPARED], SkipStep = !1, DoStep = !0;
function isActive(t) {
  return t === STEP_ACTIVE || t === STEP_ACTIVATED;
}
const useStepQueue = (function(t, r, n) {
  var a = useSafeState(STEP_NONE), s = _slicedToArray(a, 2), o = s[0], l = s[1], c = useNextFrame(), x = _slicedToArray(c, 2), j = x[0], Z = x[1];
  function V() {
    l(STEP_PREPARE, !0);
  }
  var U = r ? SIMPLE_STEP_QUEUE : FULL_STEP_QUEUE;
  return useIsomorphicLayoutEffect(function() {
    if (o !== STEP_NONE && o !== STEP_ACTIVATED) {
      var $ = U.indexOf(o), Y = U[$ + 1], G = n(o);
      G === SkipStep ? l(Y, !0) : Y && j(function(W) {
        function X() {
          W.isCanceled() || l(Y, !0);
        }
        G === !0 ? X() : Promise.resolve(G).then(X);
      });
    }
  }, [t, o]), React.useEffect(function() {
    return function() {
      Z();
    };
  }, []), [V, o];
});
function useStatus(t, r, n, a) {
  var s = a.motionEnter, o = s === void 0 ? !0 : s, l = a.motionAppear, c = l === void 0 ? !0 : l, x = a.motionLeave, j = x === void 0 ? !0 : x, Z = a.motionDeadline, V = a.motionLeaveImmediately, U = a.onAppearPrepare, $ = a.onEnterPrepare, Y = a.onLeavePrepare, G = a.onAppearStart, W = a.onEnterStart, X = a.onLeaveStart, K = a.onAppearActive, J = a.onEnterActive, ee = a.onLeaveActive, te = a.onAppearEnd, ne = a.onEnterEnd, re = a.onLeaveEnd, ie = a.onVisibleChanged, ue = useSafeState(), le = _slicedToArray(ue, 2), oe = le[0], he = le[1], fe = useSyncState(STATUS_NONE), ce = _slicedToArray(fe, 2), se = ce[0], pe = ce[1], ve = useSafeState(null), ae = _slicedToArray(ve, 2), me = ae[0], de = ae[1], ge = se(), Se = useRef(!1), xe = useRef(null);
  function Ee() {
    return n();
  }
  var Ce = useRef(!1);
  function ke() {
    pe(STATUS_NONE), de(null, !0);
  }
  var Re = useEvent$1(function(Ze) {
    var $e = se();
    if ($e !== STATUS_NONE) {
      var Oe = Ee();
      if (!(Ze && !Ze.deadline && Ze.target !== Oe)) {
        var Be = Ce.current, Qe;
        $e === STATUS_APPEAR && Be ? Qe = te == null ? void 0 : te(Oe, Ze) : $e === STATUS_ENTER && Be ? Qe = ne == null ? void 0 : ne(Oe, Ze) : $e === STATUS_LEAVE && Be && (Qe = re == null ? void 0 : re(Oe, Ze)), Be && Qe !== !1 && ke();
      }
    }
  }), _e = useDomMotionEvents(Re), Me = _slicedToArray(_e, 1), we = Me[0], Te = function($e) {
    switch ($e) {
      case STATUS_APPEAR:
        return _defineProperty(_defineProperty(_defineProperty({}, STEP_PREPARE, U), STEP_START, G), STEP_ACTIVE, K);
      case STATUS_ENTER:
        return _defineProperty(_defineProperty(_defineProperty({}, STEP_PREPARE, $), STEP_START, W), STEP_ACTIVE, J);
      case STATUS_LEAVE:
        return _defineProperty(_defineProperty(_defineProperty({}, STEP_PREPARE, Y), STEP_START, X), STEP_ACTIVE, ee);
      default:
        return {};
    }
  }, be = React.useMemo(function() {
    return Te(ge);
  }, [ge]), Pe = useStepQueue(ge, !t, function(Ze) {
    if (Ze === STEP_PREPARE) {
      var $e = be[STEP_PREPARE];
      return $e ? $e(Ee()) : SkipStep;
    }
    if (Fe in be) {
      var Oe;
      de(((Oe = be[Fe]) === null || Oe === void 0 ? void 0 : Oe.call(be, Ee(), null)) || null);
    }
    return Fe === STEP_ACTIVE && ge !== STATUS_NONE && (we(Ee()), Z > 0 && (clearTimeout(xe.current), xe.current = setTimeout(function() {
      Re({
        deadline: !0
      });
    }, Z))), Fe === STEP_PREPARED && ke(), DoStep;
  }), ye = _slicedToArray(Pe, 2), Ae = ye[0], Fe = ye[1], Ie = isActive(Fe);
  Ce.current = Ie;
  var Le = useRef(null);
  useIsomorphicLayoutEffect(function() {
    if (!(Se.current && Le.current === r)) {
      he(r);
      var Ze = Se.current;
      Se.current = !0;
      var $e;
      !Ze && r && c && ($e = STATUS_APPEAR), Ze && r && o && ($e = STATUS_ENTER), (Ze && !r && j || !Ze && V && !r && j) && ($e = STATUS_LEAVE);
      var Oe = Te($e);
      $e && (t || Oe[STEP_PREPARE]) ? (pe($e), Ae()) : pe(STATUS_NONE), Le.current = r;
    }
  }, [r]), useEffect(function() {
    // Cancel appear
    (ge === STATUS_APPEAR && !c || // Cancel enter
    ge === STATUS_ENTER && !o || // Cancel leave
    ge === STATUS_LEAVE && !j) && pe(STATUS_NONE);
  }, [c, o, j]), useEffect(function() {
    return function() {
      Se.current = !1, clearTimeout(xe.current);
    };
  }, []);
  var De = React.useRef(!1);
  useEffect(function() {
    oe && (De.current = !0), oe !== void 0 && ge === STATUS_NONE && ((De.current || oe) && (ie == null || ie(oe)), De.current = !0);
  }, [oe, ge]);
  var je = me;
  return be[STEP_PREPARE] && Fe === STEP_START && (je = _objectSpread2({
    transition: "none"
  }, je)), [ge, Fe, je, oe != null ? oe : r];
}
function genCSSMotion(t) {
  var r = t;
  _typeof$1(t) === "object" && (r = t.transitionSupport);
  function n(s, o) {
    return !!(s.motionName && r && o !== !1);
  }
  var a = /* @__PURE__ */ React.forwardRef(function(s, o) {
    var l = s.visible, c = l === void 0 ? !0 : l, x = s.removeOnLeave, j = x === void 0 ? !0 : x, Z = s.forceRender, V = s.children, U = s.motionName, $ = s.leavedClassName, Y = s.eventProps, G = React.useContext(Context), W = G.motion, X = n(s, W), K = useRef(), J = useRef();
    function ee() {
      try {
        return K.current instanceof HTMLElement ? K.current : findDOMNode(J.current);
      } catch {
        return null;
      }
    }
    var te = useStatus(X, c, ee, s), ne = _slicedToArray(te, 4), re = ne[0], ie = ne[1], ue = ne[2], le = ne[3], oe = React.useRef(le);
    le && (oe.current = !0);
    var he = React.useCallback(function(ae) {
      K.current = ae, fillRef(o, ae);
    }, [o]), fe, ce = _objectSpread2(_objectSpread2({}, Y), {}, {
      visible: c
    });
    if (!V)
      fe = null;
    else if (re === STATUS_NONE)
      le ? fe = V(_objectSpread2({}, ce), he) : !j && oe.current && $ ? fe = V(_objectSpread2(_objectSpread2({}, ce), {}, {
        className: $
      }), he) : Z || !j && !$ ? fe = V(_objectSpread2(_objectSpread2({}, ce), {}, {
        style: {
          display: "none"
        }
      }), he) : fe = null;
    else {
      var se;
      ie === STEP_PREPARE ? se = "prepare" : isActive(ie) ? se = "active" : ie === STEP_START && (se = "start");
      var pe = getTransitionName(U, "".concat(re, "-").concat(se));
      fe = V(_objectSpread2(_objectSpread2({}, ce), {}, {
        className: cls(getTransitionName(U, re), _defineProperty(_defineProperty({}, pe, pe && se), U, typeof U == "string")),
        style: ue
      }), he);
    }
    if (/* @__PURE__ */ React.isValidElement(fe) && supportRef(fe)) {
      var ve = getNodeRef(fe);
      ve || (fe = /* @__PURE__ */ React.cloneElement(fe, {
        ref: he
      }));
    }
    return /* @__PURE__ */ React.createElement(DomWrapper, {
      ref: J
    }, fe);
  });
  return a.displayName = "CSSMotion", a;
}
const CSSMotion = genCSSMotion(supportTransition);
var STATUS_ADD = "add", STATUS_KEEP = "keep", STATUS_REMOVE = "remove", STATUS_REMOVED = "removed";
function wrapKeyToObject(t) {
  var r;
  return t && _typeof$1(t) === "object" && "key" in t ? r = t : r = {
    key: t
  }, _objectSpread2(_objectSpread2({}, r), {}, {
    key: String(r.key)
  });
}
function parseKeys() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  return t.map(wrapKeyToObject);
}
function diffKeys() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], n = [], a = 0, s = r.length, o = parseKeys(t), l = parseKeys(r);
  o.forEach(function(j) {
    for (var Z = !1, V = a; V < s; V += 1) {
      var U = l[V];
      if (U.key === j.key) {
        a < V && (n = n.concat(l.slice(a, V).map(function($) {
          return _objectSpread2(_objectSpread2({}, $), {}, {
            status: STATUS_ADD
          });
        })), a = V), n.push(_objectSpread2(_objectSpread2({}, U), {}, {
          status: STATUS_KEEP
        })), a += 1, Z = !0;
        break;
      }
    }
    Z || n.push(_objectSpread2(_objectSpread2({}, j), {}, {
      status: STATUS_REMOVE
    }));
  }), a < s && (n = n.concat(l.slice(a).map(function(j) {
    return _objectSpread2(_objectSpread2({}, j), {}, {
      status: STATUS_ADD
    });
  })));
  var c = {};
  n.forEach(function(j) {
    var Z = j.key;
    c[Z] = (c[Z] || 0) + 1;
  });
  var x = Object.keys(c).filter(function(j) {
    return c[j] > 1;
  });
  return x.forEach(function(j) {
    n = n.filter(function(Z) {
      var V = Z.key, U = Z.status;
      return V !== j || U !== STATUS_REMOVE;
    }), n.forEach(function(Z) {
      Z.key === j && (Z.status = STATUS_KEEP);
    });
  }), n;
}
var _excluded$9 = ["component", "children", "onVisibleChanged", "onAllRemoved"], _excluded2$1 = ["status"], MOTION_PROP_NAMES = ["eventProps", "visible", "children", "motionName", "motionAppear", "motionEnter", "motionLeave", "motionLeaveImmediately", "motionDeadline", "removeOnLeave", "leavedClassName", "onAppearPrepare", "onAppearStart", "onAppearActive", "onAppearEnd", "onEnterStart", "onEnterActive", "onEnterEnd", "onLeaveStart", "onLeaveActive", "onLeaveEnd"];
function genCSSMotionList(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CSSMotion, n = /* @__PURE__ */ (function(a) {
    _inherits(o, a);
    var s = _createSuper(o);
    function o() {
      var l;
      _classCallCheck(this, o);
      for (var c = arguments.length, x = new Array(c), j = 0; j < c; j++)
        x[j] = arguments[j];
      return l = s.call.apply(s, [this].concat(x)), _defineProperty(_assertThisInitialized(l), "state", {
        keyEntities: []
      }), _defineProperty(_assertThisInitialized(l), "removeKey", function(Z) {
        l.setState(function(V) {
          var U = V.keyEntities.map(function($) {
            return $.key !== Z ? $ : _objectSpread2(_objectSpread2({}, $), {}, {
              status: STATUS_REMOVED
            });
          });
          return {
            keyEntities: U
          };
        }, function() {
          var V = l.state.keyEntities, U = V.filter(function($) {
            var Y = $.status;
            return Y !== STATUS_REMOVED;
          }).length;
          U === 0 && l.props.onAllRemoved && l.props.onAllRemoved();
        });
      }), l;
    }
    return _createClass(o, [{
      key: "render",
      value: function() {
        var c = this, x = this.state.keyEntities, j = this.props, Z = j.component, V = j.children, U = j.onVisibleChanged;
        j.onAllRemoved;
        var $ = _objectWithoutProperties(j, _excluded$9), Y = Z || React.Fragment, G = {};
        return MOTION_PROP_NAMES.forEach(function(W) {
          G[W] = $[W], delete $[W];
        }), delete $.keys, /* @__PURE__ */ React.createElement(Y, $, x.map(function(W, X) {
          var K = W.status, J = _objectWithoutProperties(W, _excluded2$1), ee = K === STATUS_ADD || K === STATUS_KEEP;
          return /* @__PURE__ */ React.createElement(r, _extends({}, G, {
            key: J.key,
            visible: ee,
            eventProps: J,
            onVisibleChanged: function(ne) {
              U == null || U(ne, {
                key: J.key
              }), ne || c.removeKey(J.key);
            }
          }), function(te, ne) {
            return V(_objectSpread2(_objectSpread2({}, te), {}, {
              index: X
            }), ne);
          });
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(c, x) {
        var j = c.keys, Z = x.keyEntities, V = parseKeys(j), U = diffKeys(Z, V);
        return {
          keyEntities: U.filter(function($) {
            var Y = Z.find(function(G) {
              var W = G.key;
              return $.key === W;
            });
            return !(Y && Y.status === STATUS_REMOVED && $.status === STATUS_REMOVE);
          })
        };
      }
    }]), o;
  })(React.Component);
  return _defineProperty(n, "defaultProps", {
    component: "div"
  }), n;
}
genCSSMotionList(supportTransition);
function Arrow(t) {
  var r = t.prefixCls, n = t.align, a = t.arrow, s = t.arrowPos, o = a || {}, l = o.className, c = o.content, x = s.x, j = x === void 0 ? 0 : x, Z = s.y, V = Z === void 0 ? 0 : Z, U = React.useRef();
  if (!n || !n.points)
    return null;
  var $ = {
    position: "absolute"
  };
  if (n.autoArrow !== !1) {
    var Y = n.points[0], G = n.points[1], W = Y[0], X = Y[1], K = G[0], J = G[1];
    W === K || !["t", "b"].includes(W) ? $.top = V : W === "t" ? $.top = 0 : $.bottom = 0, X === J || !["l", "r"].includes(X) ? $.left = j : X === "l" ? $.left = 0 : $.right = 0;
  }
  return /* @__PURE__ */ React.createElement("div", {
    ref: U,
    className: cls("".concat(r, "-arrow"), l),
    style: $
  }, c);
}
function Mask(t) {
  var r = t.prefixCls, n = t.open, a = t.zIndex, s = t.mask, o = t.motion;
  return s ? /* @__PURE__ */ React.createElement(CSSMotion, _extends({}, o, {
    motionAppear: !0,
    visible: n,
    removeOnLeave: !0
  }), function(l) {
    var c = l.className;
    return /* @__PURE__ */ React.createElement("div", {
      style: {
        zIndex: a
      },
      className: cls("".concat(r, "-mask"), c)
    });
  }) : null;
}
var PopupContent = /* @__PURE__ */ React.memo(function(t) {
  var r = t.children;
  return r;
}, function(t, r) {
  return r.cache;
});
process.env.NODE_ENV !== "production" && (PopupContent.displayName = "PopupContent");
var Popup = /* @__PURE__ */ React.forwardRef(function(t, r) {
  var n = t.popup, a = t.className, s = t.prefixCls, o = t.style, l = t.target, c = t.onVisibleChanged, x = t.open, j = t.keepDom, Z = t.fresh, V = t.onClick, U = t.mask, $ = t.arrow, Y = t.arrowPos, G = t.align, W = t.motion, X = t.maskMotion, K = t.forceRender, J = t.getPopupContainer, ee = t.autoDestroy, te = t.portal, ne = t.zIndex, re = t.onMouseEnter, ie = t.onMouseLeave, ue = t.onPointerEnter, le = t.ready, oe = t.offsetX, he = t.offsetY, fe = t.offsetR, ce = t.offsetB, se = t.onAlign, pe = t.onPrepare, ve = t.stretch, ae = t.targetWidth, me = t.targetHeight, de = typeof n == "function" ? n() : n, ge = x || j, Se = (J == null ? void 0 : J.length) > 0, xe = React.useState(!J || !Se), Ee = _slicedToArray(xe, 2), Ce = Ee[0], ke = Ee[1];
  if (useLayoutEffect$2(function() {
    !Ce && Se && l && ke(!0);
  }, [Ce, Se, l]), !Ce)
    return null;
  var Re = "auto", _e = {
    left: "-1000vw",
    top: "-1000vh",
    right: Re,
    bottom: Re
  };
  if (le || !x) {
    var Me, we = G.points, Te = G.dynamicInset || ((Me = G._experimental) === null || Me === void 0 ? void 0 : Me.dynamicInset), be = Te && we[0][1] === "r", Pe = Te && we[0][0] === "b";
    be ? (_e.right = fe, _e.left = Re) : (_e.left = oe, _e.right = Re), Pe ? (_e.bottom = ce, _e.top = Re) : (_e.top = he, _e.bottom = Re);
  }
  var ye = {};
  return ve && (ve.includes("height") && me ? ye.height = me : ve.includes("minHeight") && me && (ye.minHeight = me), ve.includes("width") && ae ? ye.width = ae : ve.includes("minWidth") && ae && (ye.minWidth = ae)), x || (ye.pointerEvents = "none"), /* @__PURE__ */ React.createElement(te, {
    open: K || ge,
    getContainer: J && function() {
      return J(l);
    },
    autoDestroy: ee
  }, /* @__PURE__ */ React.createElement(Mask, {
    prefixCls: s,
    open: x,
    zIndex: ne,
    mask: U,
    motion: X
  }), /* @__PURE__ */ React.createElement(RefResizeObserver, {
    onResize: se,
    disabled: !x
  }, function(Ae) {
    return /* @__PURE__ */ React.createElement(CSSMotion, _extends({
      motionAppear: !0,
      motionEnter: !0,
      motionLeave: !0,
      removeOnLeave: !1,
      forceRender: K,
      leavedClassName: "".concat(s, "-hidden")
    }, W, {
      onAppearPrepare: pe,
      onEnterPrepare: pe,
      visible: x,
      onVisibleChanged: function(Ie) {
        var Le;
        W == null || (Le = W.onVisibleChanged) === null || Le === void 0 || Le.call(W, Ie), c(Ie);
      }
    }), function(Fe, Ie) {
      var Le = Fe.className, De = Fe.style, je = cls(s, Le, a);
      return /* @__PURE__ */ React.createElement("div", {
        ref: composeRef(Ae, r, Ie),
        className: je,
        style: _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
          "--arrow-x": "".concat(Y.x || 0, "px"),
          "--arrow-y": "".concat(Y.y || 0, "px")
        }, _e), ye), De), {}, {
          boxSizing: "border-box",
          zIndex: ne
        }, o),
        onMouseEnter: re,
        onMouseLeave: ie,
        onPointerEnter: ue,
        onClick: V
      }, $ && /* @__PURE__ */ React.createElement(Arrow, {
        prefixCls: s,
        arrow: $,
        arrowPos: Y,
        align: G
      }), /* @__PURE__ */ React.createElement(PopupContent, {
        cache: !x && !Z
      }, de));
    });
  }));
});
process.env.NODE_ENV !== "production" && (Popup.displayName = "Popup");
var TriggerWrapper = /* @__PURE__ */ React.forwardRef(function(t, r) {
  var n = t.children, a = t.getTriggerDOMNode, s = supportRef(n), o = React.useCallback(function(c) {
    fillRef(r, a ? a(c) : c);
  }, [a]), l = useComposeRef(o, n.ref);
  return s ? /* @__PURE__ */ React.cloneElement(n, {
    ref: l
  }) : n;
});
process.env.NODE_ENV !== "production" && (TriggerWrapper.displayName = "TriggerWrapper");
var TriggerContext = /* @__PURE__ */ React.createContext(null);
function toArray(t) {
  return t ? Array.isArray(t) ? t : [t] : [];
}
function useAction(t, r, n, a) {
  return React.useMemo(function() {
    var s = toArray(n != null ? n : r), o = toArray(a != null ? a : r), l = new Set(s), c = new Set(o);
    return t && (l.has("hover") && (l.delete("hover"), l.add("click")), c.has("hover") && (c.delete("hover"), c.add("click"))), [l, c];
  }, [t, r, n, a]);
}
const isVisible = (function(t) {
  if (!t)
    return !1;
  if (t instanceof Element) {
    if (t.offsetParent)
      return !0;
    if (t.getBBox) {
      var r = t.getBBox(), n = r.width, a = r.height;
      if (n || a)
        return !0;
    }
    if (t.getBoundingClientRect) {
      var s = t.getBoundingClientRect(), o = s.width, l = s.height;
      if (o || l)
        return !0;
    }
  }
  return !1;
});
function isPointsEq() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], n = arguments.length > 2 ? arguments[2] : void 0;
  return n ? t[0] === r[0] : t[0] === r[0] && t[1] === r[1];
}
function getAlignPopupClassName(t, r, n, a) {
  for (var s = n.points, o = Object.keys(t), l = 0; l < o.length; l += 1) {
    var c, x = o[l];
    if (isPointsEq((c = t[x]) === null || c === void 0 ? void 0 : c.points, s, a))
      return "".concat(r, "-placement-").concat(x);
  }
  return "";
}
function getMotion(t, r, n, a) {
  return r || (n ? {
    motionName: "".concat(t, "-").concat(n)
  } : a ? {
    motionName: a
  } : null);
}
function getWin(t) {
  return t.ownerDocument.defaultView;
}
function collectScroller(t) {
  for (var r = [], n = t == null ? void 0 : t.parentElement, a = ["hidden", "scroll", "clip", "auto"]; n; ) {
    var s = getWin(n).getComputedStyle(n), o = s.overflowX, l = s.overflowY, c = s.overflow;
    [o, l, c].some(function(x) {
      return a.includes(x);
    }) && r.push(n), n = n.parentElement;
  }
  return r;
}
function toNum(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  return Number.isNaN(t) ? r : t;
}
function getPxValue(t) {
  return toNum(parseFloat(t), 0);
}
function getVisibleArea(t, r) {
  var n = _objectSpread2({}, t);
  return (r || []).forEach(function(a) {
    if (!(a instanceof HTMLBodyElement || a instanceof HTMLHtmlElement)) {
      var s = getWin(a).getComputedStyle(a), o = s.overflow, l = s.overflowClipMargin, c = s.borderTopWidth, x = s.borderBottomWidth, j = s.borderLeftWidth, Z = s.borderRightWidth, V = a.getBoundingClientRect(), U = a.offsetHeight, $ = a.clientHeight, Y = a.offsetWidth, G = a.clientWidth, W = getPxValue(c), X = getPxValue(x), K = getPxValue(j), J = getPxValue(Z), ee = toNum(Math.round(V.width / Y * 1e3) / 1e3), te = toNum(Math.round(V.height / U * 1e3) / 1e3), ne = (Y - G - K - J) * ee, re = (U - $ - W - X) * te, ie = W * te, ue = X * te, le = K * ee, oe = J * ee, he = 0, fe = 0;
      if (o === "clip") {
        var ce = getPxValue(l);
        he = ce * ee, fe = ce * te;
      }
      var se = V.x + le - he, pe = V.y + ie - fe, ve = se + V.width + 2 * he - le - oe - ne, ae = pe + V.height + 2 * fe - ie - ue - re;
      n.left = Math.max(n.left, se), n.top = Math.max(n.top, pe), n.right = Math.min(n.right, ve), n.bottom = Math.min(n.bottom, ae);
    }
  }), n;
}
function getUnitOffset(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = "".concat(r), a = n.match(/^(.*)\%$/);
  return a ? t * (parseFloat(a[1]) / 100) : parseFloat(n);
}
function getNumberOffset(t, r) {
  var n = r || [], a = _slicedToArray(n, 2), s = a[0], o = a[1];
  return [getUnitOffset(t.width, s), getUnitOffset(t.height, o)];
}
function splitPoints() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  return [t[0], t[1]];
}
function getAlignPoint(t, r) {
  var n = r[0], a = r[1], s, o;
  return n === "t" ? o = t.y : n === "b" ? o = t.y + t.height : o = t.y + t.height / 2, a === "l" ? s = t.x : a === "r" ? s = t.x + t.width : s = t.x + t.width / 2, {
    x: s,
    y: o
  };
}
function reversePoints(t, r) {
  var n = {
    t: "b",
    b: "t",
    l: "r",
    r: "l"
  };
  return t.map(function(a, s) {
    return s === r ? n[a] || "c" : a;
  }).join("");
}
function useAlign(t, r, n, a, s, o, l) {
  var c = React.useState({
    ready: !1,
    offsetX: 0,
    offsetY: 0,
    offsetR: 0,
    offsetB: 0,
    arrowX: 0,
    arrowY: 0,
    scaleX: 1,
    scaleY: 1,
    align: s[a] || {}
  }), x = _slicedToArray(c, 2), j = x[0], Z = x[1], V = React.useRef(0), U = React.useMemo(function() {
    return r ? collectScroller(r) : [];
  }, [r]), $ = React.useRef({}), Y = function() {
    $.current = {};
  };
  t || Y();
  var G = useEvent$1(function() {
    if (r && n && t) {
      let tr = function(lr, dr) {
        var mr = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : je, vr = de.x + lr, gr = de.y + dr, yr = vr + Me, xr = gr + _e, _r = Math.max(vr, mr.left), Cr = Math.max(gr, mr.top), Rr = Math.min(yr, mr.right), wr = Math.min(xr, mr.bottom);
        return Math.max(0, (Rr - _r) * (wr - Cr));
      }, br = function() {
        Mt = de.y + et, Ft = Mt + _e, Ke = de.x + pt, Ye = Ke + Me;
      };
      var K, J, ee = r, te = ee.ownerDocument, ne = getWin(ee), re = ne.getComputedStyle(ee), ie = re.width, ue = re.height, le = re.position, oe = ee.style.left, he = ee.style.top, fe = ee.style.right, ce = ee.style.bottom, se = ee.style.overflow, pe = _objectSpread2(_objectSpread2({}, s[a]), o), ve = te.createElement("div");
      (K = ee.parentElement) === null || K === void 0 || K.appendChild(ve), ve.style.left = "".concat(ee.offsetLeft, "px"), ve.style.top = "".concat(ee.offsetTop, "px"), ve.style.position = le, ve.style.height = "".concat(ee.offsetHeight, "px"), ve.style.width = "".concat(ee.offsetWidth, "px"), ee.style.left = "0", ee.style.top = "0", ee.style.right = "auto", ee.style.bottom = "auto", ee.style.overflow = "hidden";
      var ae;
      if (Array.isArray(n))
        ae = {
          x: n[0],
          y: n[1],
          width: 0,
          height: 0
        };
      else {
        var me = n.getBoundingClientRect();
        ae = {
          x: me.x,
          y: me.y,
          width: me.width,
          height: me.height
        };
      }
      var de = ee.getBoundingClientRect(), ge = te.documentElement, Se = ge.clientWidth, xe = ge.clientHeight, Ee = ge.scrollWidth, Ce = ge.scrollHeight, ke = ge.scrollTop, Re = ge.scrollLeft, _e = de.height, Me = de.width, we = ae.height, Te = ae.width, be = {
        left: 0,
        top: 0,
        right: Se,
        bottom: xe
      }, Pe = {
        left: -Re,
        top: -ke,
        right: Ee - Re,
        bottom: Ce - ke
      }, ye = pe.htmlRegion, Ae = "visible", Fe = "visibleFirst";
      ye !== "scroll" && ye !== Fe && (ye = Ae);
      var Ie = ye === Fe, Le = getVisibleArea(Pe, U), De = getVisibleArea(be, U), je = ye === Ae ? De : Le, Ze = Ie ? De : je;
      ee.style.left = "auto", ee.style.top = "auto", ee.style.right = "0", ee.style.bottom = "0";
      var $e = ee.getBoundingClientRect();
      ee.style.left = oe, ee.style.top = he, ee.style.right = fe, ee.style.bottom = ce, ee.style.overflow = se, (J = ee.parentElement) === null || J === void 0 || J.removeChild(ve);
      var Oe = toNum(Math.round(Me / parseFloat(ie) * 1e3) / 1e3), Be = toNum(Math.round(_e / parseFloat(ue) * 1e3) / 1e3);
      if (Oe === 0 || Be === 0 || isDOM(n) && !isVisible(n))
        return;
      var Qe = pe.offset, Xe = pe.targetOffset, rt = getNumberOffset(de, Qe), lt = _slicedToArray(rt, 2), ct = lt[0], Je = lt[1], st = getNumberOffset(ae, Xe), At = _slicedToArray(st, 2), bt = At[0], gt = At[1];
      ae.x -= bt, ae.y -= gt;
      var xt = pe.points || [], ht = _slicedToArray(xt, 2), jt = ht[0], Rt = ht[1], Dt = splitPoints(Rt), wt = splitPoints(jt), Wt = getAlignPoint(ae, Dt), Bt = getAlignPoint(de, wt), It = _objectSpread2({}, pe), pt = Wt.x - Bt.x + ct, et = Wt.y - Bt.y + Je, Tt = tr(pt, et), Et = tr(pt, et, De), dt = getAlignPoint(ae, ["t", "l"]), zt = getAlignPoint(de, ["t", "l"]), Lt = getAlignPoint(ae, ["b", "r"]), Ge = getAlignPoint(de, ["b", "r"]), ze = pe.overflow || {}, Ne = ze.adjustX, Ve = ze.adjustY, qe = ze.shiftX, nt = ze.shiftY, Pt = function(dr) {
        return typeof dr == "boolean" ? dr : dr >= 0;
      }, Mt, Ft, Ke, Ye;
      br();
      var ot = Pt(Ve), yt = wt[0] === Dt[0];
      if (ot && wt[0] === "t" && (Ft > Ze.bottom || $.current.bt)) {
        var mt = et;
        yt ? mt -= _e - we : mt = dt.y - Ge.y - Je;
        var Ct = tr(pt, mt), St = tr(pt, mt, De);
        // Of course use larger one
        Ct > Tt || Ct === Tt && (!Ie || // Choose recommend one
        St >= Et) ? ($.current.bt = !0, et = mt, Je = -Je, It.points = [reversePoints(wt, 0), reversePoints(Dt, 0)]) : $.current.bt = !1;
      }
      if (ot && wt[0] === "b" && (Mt < Ze.top || $.current.tb)) {
        var vt = et;
        yt ? vt += _e - we : vt = Lt.y - zt.y - Je;
        var He = tr(pt, vt), We = tr(pt, vt, De);
        // Of course use larger one
        He > Tt || He === Tt && (!Ie || // Choose recommend one
        We >= Et) ? ($.current.tb = !0, et = vt, Je = -Je, It.points = [reversePoints(wt, 0), reversePoints(Dt, 0)]) : $.current.tb = !1;
      }
      var tt = Pt(Ne), ft = wt[1] === Dt[1];
      if (tt && wt[1] === "l" && (Ye > Ze.right || $.current.rl)) {
        var _t = pt;
        ft ? _t -= Me - Te : _t = dt.x - Ge.x - ct;
        var rr = tr(_t, et), qt = tr(_t, et, De);
        // Of course use larger one
        rr > Tt || rr === Tt && (!Ie || // Choose recommend one
        qt >= Et) ? ($.current.rl = !0, pt = _t, ct = -ct, It.points = [reversePoints(wt, 1), reversePoints(Dt, 1)]) : $.current.rl = !1;
      }
      if (tt && wt[1] === "r" && (Ke < Ze.left || $.current.lr)) {
        var Ut = pt;
        ft ? Ut += Me - Te : Ut = Lt.x - zt.x - ct;
        var or = tr(Ut, et), Qt = tr(Ut, et, De);
        // Of course use larger one
        or > Tt || or === Tt && (!Ie || // Choose recommend one
        Qt >= Et) ? ($.current.lr = !0, pt = Ut, ct = -ct, It.points = [reversePoints(wt, 1), reversePoints(Dt, 1)]) : $.current.lr = !1;
      }
      br();
      var Gt = qe === !0 ? 0 : qe;
      typeof Gt == "number" && (Ke < De.left && (pt -= Ke - De.left - ct, ae.x + Te < De.left + Gt && (pt += ae.x - De.left + Te - Gt)), Ye > De.right && (pt -= Ye - De.right - ct, ae.x > De.right - Gt && (pt += ae.x - De.right + Gt)));
      var ar = nt === !0 ? 0 : nt;
      typeof ar == "number" && (Mt < De.top && (et -= Mt - De.top - Je, ae.y + we < De.top + ar && (et += ae.y - De.top + we - ar)), Ft > De.bottom && (et -= Ft - De.bottom - Je, ae.y > De.bottom - ar && (et += ae.y - De.bottom + ar)));
      var cr = de.x + pt, ur = cr + Me, nr = de.y + et, pr = nr + _e, ir = ae.x, Jt = ir + Te, ut = ae.y, it = ut + we, Zt = Math.max(cr, ir), Vt = Math.min(ur, Jt), kt = (Zt + Vt) / 2, $t = kt - cr, Yt = Math.max(nr, ut), Xt = Math.min(pr, it), er = (Yt + Xt) / 2, sr = er - nr;
      l == null || l(r, It);
      var Kt = $e.right - de.x - (pt + de.width), hr = $e.bottom - de.y - (et + de.height);
      Z({
        ready: !0,
        offsetX: pt / Oe,
        offsetY: et / Be,
        offsetR: Kt / Oe,
        offsetB: hr / Be,
        arrowX: $t / Oe,
        arrowY: sr / Be,
        scaleX: Oe,
        scaleY: Be,
        align: It
      });
    }
  }), W = function() {
    V.current += 1;
    var J = V.current;
    Promise.resolve().then(function() {
      V.current === J && G();
    });
  }, X = function() {
    Z(function(J) {
      return _objectSpread2(_objectSpread2({}, J), {}, {
        ready: !1
      });
    });
  };
  return useLayoutEffect$2(X, [a]), useLayoutEffect$2(function() {
    t || X();
  }, [t]), [j.ready, j.offsetX, j.offsetY, j.offsetR, j.offsetB, j.arrowX, j.arrowY, j.scaleX, j.scaleY, j.align, W];
}
function useWatch(t, r, n, a, s) {
  useLayoutEffect$2(function() {
    if (t && r && n) {
      let V = function() {
        a(), s();
      };
      var o = r, l = n, c = collectScroller(o), x = collectScroller(l), j = getWin(l), Z = new Set([j].concat(_toConsumableArray(c), _toConsumableArray(x)));
      return Z.forEach(function(U) {
        U.addEventListener("scroll", V, {
          passive: !0
        });
      }), j.addEventListener("resize", V, {
        passive: !0
      }), a(), function() {
        Z.forEach(function(U) {
          U.removeEventListener("scroll", V), j.removeEventListener("resize", V);
        });
      };
    }
  }, [t, r, n]);
}
function useWinClick(t, r, n, a, s, o, l, c) {
  var x = React.useRef(t), j = React.useRef(!1);
  x.current !== t && (j.current = !0, x.current = t), React.useEffect(function() {
    var Z = wrapperRaf(function() {
      j.current = !1;
    });
    return function() {
      wrapperRaf.cancel(Z);
    };
  }, [t]), React.useEffect(function() {
    if (r && a && (!s || o)) {
      var Z = function() {
        var le = !1, oe = function(ce) {
          var se = ce.target;
          le = l(se);
        }, he = function(ce) {
          var se = ce.target;
          !j.current && x.current && !le && !l(se) && c(!1);
        };
        return [oe, he];
      }, V = Z(), U = _slicedToArray(V, 2), $ = U[0], Y = U[1], G = Z(), W = _slicedToArray(G, 2), X = W[0], K = W[1], J = getWin(a);
      J.addEventListener("mousedown", $, !0), J.addEventListener("click", Y, !0), J.addEventListener("contextmenu", Y, !0);
      var ee = getShadowRoot(n);
      if (ee && (ee.addEventListener("mousedown", X, !0), ee.addEventListener("click", K, !0), ee.addEventListener("contextmenu", K, !0)), process.env.NODE_ENV !== "production") {
        var te, ne, re = n == null || (te = n.getRootNode) === null || te === void 0 ? void 0 : te.call(n), ie = (ne = a.getRootNode) === null || ne === void 0 ? void 0 : ne.call(a);
        warning(re === ie, "trigger element and popup element should in same shadow root.");
      }
      return function() {
        J.removeEventListener("mousedown", $, !0), J.removeEventListener("click", Y, !0), J.removeEventListener("contextmenu", Y, !0), ee && (ee.removeEventListener("mousedown", X, !0), ee.removeEventListener("click", K, !0), ee.removeEventListener("contextmenu", K, !0));
      };
    }
  }, [r, n, a, s, o]);
}
var _excluded$8 = ["prefixCls", "children", "action", "showAction", "hideAction", "popupVisible", "defaultPopupVisible", "onPopupVisibleChange", "afterPopupVisibleChange", "mouseEnterDelay", "mouseLeaveDelay", "focusDelay", "blurDelay", "mask", "maskClosable", "getPopupContainer", "forceRender", "autoDestroy", "destroyPopupOnHide", "popup", "popupClassName", "popupStyle", "popupPlacement", "builtinPlacements", "popupAlign", "zIndex", "stretch", "getPopupClassNameFromAlign", "fresh", "alignPoint", "onPopupClick", "onPopupAlign", "arrow", "popupMotion", "maskMotion", "popupTransitionName", "popupAnimation", "maskTransitionName", "maskAnimation", "className", "getTriggerDOMNode"];
function generateTrigger() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Portal$1, r = /* @__PURE__ */ React.forwardRef(function(n, a) {
    var s = n.prefixCls, o = s === void 0 ? "rc-trigger-popup" : s, l = n.children, c = n.action, x = c === void 0 ? "hover" : c, j = n.showAction, Z = n.hideAction, V = n.popupVisible, U = n.defaultPopupVisible, $ = n.onPopupVisibleChange, Y = n.afterPopupVisibleChange, G = n.mouseEnterDelay, W = n.mouseLeaveDelay, X = W === void 0 ? 0.1 : W, K = n.focusDelay, J = n.blurDelay, ee = n.mask, te = n.maskClosable, ne = te === void 0 ? !0 : te, re = n.getPopupContainer, ie = n.forceRender, ue = n.autoDestroy, le = n.destroyPopupOnHide, oe = n.popup, he = n.popupClassName, fe = n.popupStyle, ce = n.popupPlacement, se = n.builtinPlacements, pe = se === void 0 ? {} : se, ve = n.popupAlign, ae = n.zIndex, me = n.stretch, de = n.getPopupClassNameFromAlign, ge = n.fresh, Se = n.alignPoint, xe = n.onPopupClick, Ee = n.onPopupAlign, Ce = n.arrow, ke = n.popupMotion, Re = n.maskMotion, _e = n.popupTransitionName, Me = n.popupAnimation, we = n.maskTransitionName, Te = n.maskAnimation, be = n.className, Pe = n.getTriggerDOMNode, ye = _objectWithoutProperties(n, _excluded$8), Ae = ue || le || !1, Fe = React.useState(!1), Ie = _slicedToArray(Fe, 2), Le = Ie[0], De = Ie[1];
    useLayoutEffect$2(function() {
      De(isMobile());
    }, []);
    var je = React.useRef({}), Ze = React.useContext(TriggerContext), $e = React.useMemo(function() {
      return {
        registerSubPopup: function(at, Nt) {
          je.current[at] = Nt, Ze == null || Ze.registerSubPopup(at, Nt);
        }
      };
    }, [Ze]), Oe = useId$2(), Be = React.useState(null), Qe = _slicedToArray(Be, 2), Xe = Qe[0], rt = Qe[1], lt = useEvent$1(function(Ue) {
      isDOM(Ue) && Xe !== Ue && rt(Ue), Ze == null || Ze.registerSubPopup(Oe, Ue);
    }), ct = React.useState(null), Je = _slicedToArray(ct, 2), st = Je[0], At = Je[1], bt = React.useRef(null), gt = useEvent$1(function(Ue) {
      isDOM(Ue) && st !== Ue && (At(Ue), bt.current = Ue);
    }), xt = React.Children.only(l), ht = (xt == null ? void 0 : xt.props) || {}, jt = {}, Rt = useEvent$1(function(Ue) {
      var at, Nt, Ht = st;
      return (Ht == null ? void 0 : Ht.contains(Ue)) || ((at = getShadowRoot(Ht)) === null || at === void 0 ? void 0 : at.host) === Ue || Ue === Ht || (Xe == null ? void 0 : Xe.contains(Ue)) || ((Nt = getShadowRoot(Xe)) === null || Nt === void 0 ? void 0 : Nt.host) === Ue || Ue === Xe || Object.values(je.current).some(function(Ot) {
        return (Ot == null ? void 0 : Ot.contains(Ue)) || Ue === Ot;
      });
    }), Dt = getMotion(o, ke, Me, _e), wt = getMotion(o, Re, Te, we), Wt = React.useState(U || !1), Bt = _slicedToArray(Wt, 2), It = Bt[0], pt = Bt[1], et = V != null ? V : It, Tt = useEvent$1(function(Ue) {
      V === void 0 && pt(Ue);
    });
    useLayoutEffect$2(function() {
      pt(V || !1);
    }, [V]);
    var Et = React.useRef(et);
    Et.current = et;
    var dt = React.useRef([]);
    dt.current = [];
    var zt = useEvent$1(function(Ue) {
      var at;
      Tt(Ue), ((at = dt.current[dt.current.length - 1]) !== null && at !== void 0 ? at : et) !== Ue && (dt.current.push(Ue), $ == null || $(Ue));
    }), Lt = React.useRef(), Ge = function() {
      clearTimeout(Lt.current);
    }, ze = function(at) {
      var Nt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      Ge(), Nt === 0 ? zt(at) : Lt.current = setTimeout(function() {
        zt(at);
      }, Nt * 1e3);
    };
    React.useEffect(function() {
      return Ge;
    }, []);
    var Ne = React.useState(!1), Ve = _slicedToArray(Ne, 2), qe = Ve[0], nt = Ve[1];
    useLayoutEffect$2(function(Ue) {
      (!Ue || et) && nt(!0);
    }, [et]);
    var Pt = React.useState(null), Mt = _slicedToArray(Pt, 2), Ft = Mt[0], Ke = Mt[1], Ye = React.useState([0, 0]), ot = _slicedToArray(Ye, 2), yt = ot[0], mt = ot[1], Ct = function(at) {
      mt([at.clientX, at.clientY]);
    }, St = useAlign(et, Xe, Se ? yt : st, ce, pe, ve, Ee), vt = _slicedToArray(St, 11), He = vt[0], We = vt[1], tt = vt[2], ft = vt[3], _t = vt[4], rr = vt[5], qt = vt[6], Ut = vt[7], or = vt[8], Qt = vt[9], Gt = vt[10], ar = useAction(Le, x, j, Z), cr = _slicedToArray(ar, 2), ur = cr[0], nr = cr[1], pr = ur.has("click"), ir = nr.has("click") || nr.has("contextMenu"), Jt = useEvent$1(function() {
      qe || Gt();
    }), ut = function() {
      Et.current && Se && ir && ze(!1);
    };
    useWatch(et, st, Xe, Jt, ut), useLayoutEffect$2(function() {
      Jt();
    }, [yt, ce]), useLayoutEffect$2(function() {
      et && !(pe != null && pe[ce]) && Jt();
    }, [JSON.stringify(ve)]);
    var it = React.useMemo(function() {
      var Ue = getAlignPopupClassName(pe, o, Qt, Se);
      return cls(Ue, de == null ? void 0 : de(Qt));
    }, [Qt, de, pe, o, Se]);
    React.useImperativeHandle(a, function() {
      return {
        nativeElement: bt.current,
        forceAlign: Jt
      };
    });
    var Zt = React.useState(0), Vt = _slicedToArray(Zt, 2), kt = Vt[0], $t = Vt[1], Yt = React.useState(0), Xt = _slicedToArray(Yt, 2), er = Xt[0], sr = Xt[1], Kt = function() {
      if (me && st) {
        var at = st.getBoundingClientRect();
        $t(at.width), sr(at.height);
      }
    }, hr = function() {
      Kt(), Jt();
    }, tr = function(at) {
      nt(!1), Gt(), Y == null || Y(at);
    }, br = function() {
      return new Promise(function(at) {
        Kt(), Ke(function() {
          return at;
        });
      });
    };
    useLayoutEffect$2(function() {
      Ft && (Gt(), Ft(), Ke(null));
    }, [Ft]);
    function lr(Ue, at, Nt, Ht) {
      jt[Ue] = function(Ot) {
        var Sr;
        Ht == null || Ht(Ot), ze(at, Nt);
        for (var Tr = arguments.length, Mr = new Array(Tr > 1 ? Tr - 1 : 0), Er = 1; Er < Tr; Er++)
          Mr[Er - 1] = arguments[Er];
        (Sr = ht[Ue]) === null || Sr === void 0 || Sr.call.apply(Sr, [ht, Ot].concat(Mr));
      };
    }
    (pr || ir) && (jt.onClick = function(Ue) {
      var at;
      Et.current && ir ? ze(!1) : !Et.current && pr && (Ct(Ue), ze(!0));
      for (var Nt = arguments.length, Ht = new Array(Nt > 1 ? Nt - 1 : 0), Ot = 1; Ot < Nt; Ot++)
        Ht[Ot - 1] = arguments[Ot];
      (at = ht.onClick) === null || at === void 0 || at.call.apply(at, [ht, Ue].concat(Ht));
    }), useWinClick(et, ir, st, Xe, ee, ne, Rt, ze);
    var dr = ur.has("hover"), mr = nr.has("hover"), vr, gr;
    dr && (lr("onMouseEnter", !0, G, function(Ue) {
      Ct(Ue);
    }), lr("onPointerEnter", !0, G, function(Ue) {
      Ct(Ue);
    }), vr = function(at) {
      (et || qe) && Xe !== null && Xe !== void 0 && Xe.contains(at.target) && ze(!0, G);
    }, Se && (jt.onMouseMove = function(Ue) {
      var at;
      (at = ht.onMouseMove) === null || at === void 0 || at.call(ht, Ue);
    })), mr && (lr("onMouseLeave", !1, X), lr("onPointerLeave", !1, X), gr = function() {
      ze(!1, X);
    }), ur.has("focus") && lr("onFocus", !0, K), nr.has("focus") && lr("onBlur", !1, J), ur.has("contextMenu") && (jt.onContextMenu = function(Ue) {
      var at;
      Et.current && nr.has("contextMenu") ? ze(!1) : (Ct(Ue), ze(!0)), Ue.preventDefault();
      for (var Nt = arguments.length, Ht = new Array(Nt > 1 ? Nt - 1 : 0), Ot = 1; Ot < Nt; Ot++)
        Ht[Ot - 1] = arguments[Ot];
      (at = ht.onContextMenu) === null || at === void 0 || at.call.apply(at, [ht, Ue].concat(Ht));
    }), be && (jt.className = cls(ht.className, be));
    var yr = _objectSpread2(_objectSpread2({}, ht), jt), xr = {}, _r = ["onContextMenu", "onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur"];
    _r.forEach(function(Ue) {
      ye[Ue] && (xr[Ue] = function() {
        for (var at, Nt = arguments.length, Ht = new Array(Nt), Ot = 0; Ot < Nt; Ot++)
          Ht[Ot] = arguments[Ot];
        (at = yr[Ue]) === null || at === void 0 || at.call.apply(at, [yr].concat(Ht)), ye[Ue].apply(ye, Ht);
      });
    });
    var Cr = /* @__PURE__ */ React.cloneElement(xt, _objectSpread2(_objectSpread2({}, yr), xr)), Rr = {
      x: rr,
      y: qt
    }, wr = Ce ? _objectSpread2({}, Ce !== !0 ? Ce : {}) : null;
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(RefResizeObserver, {
      disabled: !et,
      ref: gt,
      onResize: hr
    }, /* @__PURE__ */ React.createElement(TriggerWrapper, {
      getTriggerDOMNode: Pe
    }, Cr)), /* @__PURE__ */ React.createElement(TriggerContext.Provider, {
      value: $e
    }, /* @__PURE__ */ React.createElement(Popup, {
      portal: t,
      ref: lt,
      prefixCls: o,
      popup: oe,
      className: cls(he, it),
      style: fe,
      target: st,
      onMouseEnter: vr,
      onMouseLeave: gr,
      onPointerEnter: vr,
      zIndex: ae,
      open: et,
      keepDom: qe,
      fresh: ge,
      onClick: xe,
      mask: ee,
      motion: Dt,
      maskMotion: wt,
      onVisibleChanged: tr,
      onPrepare: br,
      forceRender: ie,
      autoDestroy: Ae,
      getPopupContainer: re,
      align: Qt,
      arrow: wr,
      arrowPos: Rr,
      ready: He,
      offsetX: We,
      offsetY: tt,
      offsetR: ft,
      offsetB: _t,
      onAlign: Jt,
      stretch: me,
      targetWidth: kt / Ut,
      targetHeight: er / or
    })));
  });
  return process.env.NODE_ENV !== "production" && (r.displayName = "Trigger"), r;
}
const Trigger = generateTrigger(Portal$1);
var _excluded$7 = ["prefixCls", "disabled", "visible", "children", "popupElement", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "direction", "placement", "builtinPlacements", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "getPopupContainer", "empty", "getTriggerDOMNode", "onPopupVisibleChange", "onPopupMouseEnter"], getBuiltInPlacements = function(r) {
  var n = r === !0 ? 0 : 1;
  return {
    bottomLeft: {
      points: ["tl", "bl"],
      offset: [0, 4],
      overflow: {
        adjustX: n,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    bottomRight: {
      points: ["tr", "br"],
      offset: [0, 4],
      overflow: {
        adjustX: n,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    topLeft: {
      points: ["bl", "tl"],
      offset: [0, -4],
      overflow: {
        adjustX: n,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    topRight: {
      points: ["br", "tr"],
      offset: [0, -4],
      overflow: {
        adjustX: n,
        adjustY: 1
      },
      htmlRegion: "scroll"
    }
  };
}, SelectTrigger = function(r, n) {
  var a = r.prefixCls;
  r.disabled;
  var s = r.visible, o = r.children, l = r.popupElement, c = r.animation, x = r.transitionName, j = r.dropdownStyle, Z = r.dropdownClassName, V = r.direction, U = V === void 0 ? "ltr" : V, $ = r.placement, Y = r.builtinPlacements, G = r.dropdownMatchSelectWidth, W = r.dropdownRender, X = r.dropdownAlign, K = r.getPopupContainer, J = r.empty, ee = r.getTriggerDOMNode, te = r.onPopupVisibleChange, ne = r.onPopupMouseEnter, re = _objectWithoutProperties(r, _excluded$7), ie = "".concat(a, "-dropdown"), ue = l;
  W && (ue = W(l));
  var le = React.useMemo(function() {
    return Y || getBuiltInPlacements(G);
  }, [Y, G]), oe = c ? "".concat(ie, "-").concat(c) : x, he = typeof G == "number", fe = React.useMemo(function() {
    return he ? null : G === !1 ? "minWidth" : "width";
  }, [G, he]), ce = j;
  he && (ce = _objectSpread2(_objectSpread2({}, ce), {}, {
    width: G
  }));
  var se = React.useRef(null);
  return React.useImperativeHandle(n, function() {
    return {
      getPopupElement: function() {
        return se.current;
      }
    };
  }), /* @__PURE__ */ React.createElement(Trigger, _extends({}, re, {
    showAction: te ? ["click"] : [],
    hideAction: te ? ["click"] : [],
    popupPlacement: $ || (U === "rtl" ? "bottomRight" : "bottomLeft"),
    builtinPlacements: le,
    prefixCls: ie,
    popupTransitionName: oe,
    popup: /* @__PURE__ */ React.createElement("div", {
      ref: se,
      onMouseEnter: ne
    }, ue),
    stretch: fe,
    popupAlign: X,
    popupVisible: s,
    getPopupContainer: K,
    popupClassName: cls(Z, _defineProperty({}, "".concat(ie, "-empty"), J)),
    popupStyle: ce,
    getTriggerDOMNode: ee,
    onPopupVisibleChange: te
  }), o);
}, RefSelectTrigger = /* @__PURE__ */ React.forwardRef(SelectTrigger);
process.env.NODE_ENV !== "production" && (RefSelectTrigger.displayName = "SelectTrigger");
function getKey(t, r) {
  var n = t.key, a;
  return "value" in t && (a = t.value), n != null ? n : a !== void 0 ? a : "rc-index-key-".concat(r);
}
function isValidCount(t) {
  return typeof t != "undefined" && !Number.isNaN(t);
}
function fillFieldNames(t, r) {
  var n = t || {}, a = n.label, s = n.value, o = n.options, l = n.groupLabel, c = a || (r ? "children" : "label");
  return {
    label: c,
    value: s || "value",
    options: o || "options",
    groupLabel: l || c
  };
}
function flattenOptions(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.fieldNames, a = r.childrenAsData, s = [], o = fillFieldNames(n, !1), l = o.label, c = o.value, x = o.options, j = o.groupLabel;
  function Z(V, U) {
    Array.isArray(V) && V.forEach(function($) {
      if (U || !(x in $)) {
        var Y = $[c];
        s.push({
          key: getKey($, s.length),
          groupOption: U,
          data: $,
          label: $[l],
          value: Y
        });
      } else {
        var G = $[j];
        G === void 0 && a && (G = $.label), s.push({
          key: getKey($, s.length),
          group: !0,
          data: $,
          label: G
        }), Z($[x], !0);
      }
    });
  }
  return Z(t, !1), s;
}
function injectPropsWithOption(t) {
  var r = _objectSpread2({}, t);
  return "props" in r || Object.defineProperty(r, "props", {
    get: function() {
      return warningOnce(!1, "Return type is option instead of Option instance. Please read value directly instead of reading from `props`."), r;
    }
  }), r;
}
var getSeparatedContent = function(r, n, a) {
  if (!n || !n.length)
    return null;
  var s = !1, o = function c(x, j) {
    var Z = _toArray(j), V = Z[0], U = Z.slice(1);
    if (!V)
      return [x];
    var $ = x.split(V);
    return s = s || $.length > 1, $.reduce(function(Y, G) {
      return [].concat(_toConsumableArray(Y), _toConsumableArray(c(G, U)));
    }, []).filter(Boolean);
  }, l = o(r, n);
  return s ? typeof a != "undefined" ? l.slice(0, a) : l : null;
}, SelectContext = /* @__PURE__ */ React.createContext(null), _excluded$6 = ["id", "prefixCls", "className", "showSearch", "tagRender", "direction", "omitDomProps", "displayValues", "onDisplayValuesChange", "emptyOptions", "notFoundContent", "onClear", "mode", "disabled", "loading", "getInputElement", "getRawInputElement", "open", "defaultOpen", "onDropdownVisibleChange", "activeValue", "onActiveValueChange", "activeDescendantId", "searchValue", "autoClearSearchValue", "onSearch", "onSearchSplit", "tokenSeparators", "allowClear", "suffixIcon", "clearIcon", "OptionList", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "placement", "builtinPlacements", "getPopupContainer", "showAction", "onFocus", "onBlur", "onKeyUp", "onKeyDown", "onMouseDown"], DEFAULT_OMIT_PROPS = ["value", "onChange", "removeIcon", "placeholder", "autoFocus", "maxTagCount", "maxTagTextLength", "maxTagPlaceholder", "choiceTransitionName", "onInputKeyDown", "onPopupScroll", "tabIndex"], isMultiple = function(r) {
  return r === "tags" || r === "multiple";
}, BaseSelect = /* @__PURE__ */ React.forwardRef(function(t, r) {
  var n, a = t.id, s = t.prefixCls, o = t.className, l = t.showSearch, c = t.tagRender, x = t.direction, j = t.omitDomProps, Z = t.displayValues, V = t.onDisplayValuesChange, U = t.emptyOptions, $ = t.notFoundContent, Y = $ === void 0 ? "Not Found" : $, G = t.onClear, W = t.mode, X = t.disabled, K = t.loading, J = t.getInputElement, ee = t.getRawInputElement, te = t.open, ne = t.defaultOpen, re = t.onDropdownVisibleChange, ie = t.activeValue, ue = t.onActiveValueChange, le = t.activeDescendantId, oe = t.searchValue, he = t.autoClearSearchValue, fe = t.onSearch, ce = t.onSearchSplit, se = t.tokenSeparators, pe = t.allowClear, ve = t.suffixIcon, ae = t.clearIcon, me = t.OptionList, de = t.animation, ge = t.transitionName, Se = t.dropdownStyle, xe = t.dropdownClassName, Ee = t.dropdownMatchSelectWidth, Ce = t.dropdownRender, ke = t.dropdownAlign, Re = t.placement, _e = t.builtinPlacements, Me = t.getPopupContainer, we = t.showAction, Te = we === void 0 ? [] : we, be = t.onFocus, Pe = t.onBlur, ye = t.onKeyUp, Ae = t.onKeyDown, Fe = t.onMouseDown, Ie = _objectWithoutProperties(t, _excluded$6), Le = isMultiple(W), De = (l !== void 0 ? l : Le) || W === "combobox", je = _objectSpread2({}, Ie);
  DEFAULT_OMIT_PROPS.forEach(function(ut) {
    delete je[ut];
  }), j == null || j.forEach(function(ut) {
    delete je[ut];
  });
  var Ze = React.useState(!1), $e = _slicedToArray(Ze, 2), Oe = $e[0], Be = $e[1];
  React.useEffect(function() {
    Be(isMobile());
  }, []);
  var Qe = React.useRef(null), Xe = React.useRef(null), rt = React.useRef(null), lt = React.useRef(null), ct = React.useRef(null), Je = React.useRef(!1), st = useDelayReset(), At = _slicedToArray(st, 3), bt = At[0], gt = At[1], xt = At[2];
  React.useImperativeHandle(r, function() {
    var ut, it;
    return {
      focus: (ut = lt.current) === null || ut === void 0 ? void 0 : ut.focus,
      blur: (it = lt.current) === null || it === void 0 ? void 0 : it.blur,
      scrollTo: function(Vt) {
        var kt;
        return (kt = ct.current) === null || kt === void 0 ? void 0 : kt.scrollTo(Vt);
      }
    };
  });
  var ht = React.useMemo(function() {
    var ut;
    if (W !== "combobox")
      return oe;
    var it = (ut = Z[0]) === null || ut === void 0 ? void 0 : ut.value;
    return typeof it == "string" || typeof it == "number" ? String(it) : "";
  }, [oe, W, Z]), jt = W === "combobox" && typeof J == "function" && J() || null, Rt = typeof ee == "function" && ee(), Dt = useComposeRef(Xe, Rt == null || (n = Rt.props) === null || n === void 0 ? void 0 : n.ref), wt = React.useState(!1), Wt = _slicedToArray(wt, 2), Bt = Wt[0], It = Wt[1];
  useLayoutEffect$2(function() {
    It(!0);
  }, []);
  var pt = useMergedState$2(!1, {
    defaultValue: ne,
    value: te
  }), et = _slicedToArray(pt, 2), Tt = et[0], Et = et[1], dt = Bt ? Tt : !1, zt = !Y && U;
  (X || zt && dt && W === "combobox") && (dt = !1);
  var Lt = zt ? !1 : dt, Ge = React.useCallback(function(ut) {
    var it = ut !== void 0 ? ut : !dt;
    X || (Et(it), dt !== it && (re == null || re(it)));
  }, [X, dt, Et, re]), ze = React.useMemo(function() {
    return (se || []).some(function(ut) {
      return [`
`, `\r
`].includes(ut);
    });
  }, [se]), Ne = React.useContext(SelectContext) || {}, Ve = Ne.maxCount, qe = Ne.rawValues, nt = function(it, Zt, Vt) {
    if (!(isValidCount(Ve) && (qe == null ? void 0 : qe.size) >= Ve)) {
      var kt = !0, $t = it;
      ue == null || ue(null);
      var Yt = getSeparatedContent(it, se, isValidCount(Ve) ? Ve - qe.size : void 0), Xt = Vt ? null : Yt;
      return W !== "combobox" && Xt && ($t = "", ce == null || ce(Xt), Ge(!1), kt = !1), fe && ht !== $t && fe($t, {
        source: Zt ? "typing" : "effect"
      }), kt;
    }
  }, Pt = function(it) {
    !it || !it.trim() || fe(it, {
      source: "submit"
    });
  };
  React.useEffect(function() {
    !dt && !Le && W !== "combobox" && nt("", !1, !1);
  }, [dt]), React.useEffect(function() {
    Tt && X && Et(!1), X && !Je.current && gt(!1);
  }, [X]);
  var Mt = useLock(), Ft = _slicedToArray(Mt, 2), Ke = Ft[0], Ye = Ft[1], ot = function(it) {
    var Zt = Ke(), Vt = it.which;
    if (Vt === KeyCode.ENTER && (W !== "combobox" && it.preventDefault(), dt || Ge(!0)), Ye(!!ht), Vt === KeyCode.BACKSPACE && !Zt && Le && !ht && Z.length) {
      for (var kt = _toConsumableArray(Z), $t = null, Yt = kt.length - 1; Yt >= 0; Yt -= 1) {
        var Xt = kt[Yt];
        if (!Xt.disabled) {
          kt.splice(Yt, 1), $t = Xt;
          break;
        }
      }
      $t && V(kt, {
        type: "remove",
        values: [$t]
      });
    }
    for (var er = arguments.length, sr = new Array(er > 1 ? er - 1 : 0), Kt = 1; Kt < er; Kt++)
      sr[Kt - 1] = arguments[Kt];
    if (dt) {
      var hr;
      (hr = ct.current) === null || hr === void 0 || hr.onKeyDown.apply(hr, [it].concat(sr));
    }
    Ae == null || Ae.apply(void 0, [it].concat(sr));
  }, yt = function(it) {
    for (var Zt = arguments.length, Vt = new Array(Zt > 1 ? Zt - 1 : 0), kt = 1; kt < Zt; kt++)
      Vt[kt - 1] = arguments[kt];
    if (dt) {
      var $t;
      ($t = ct.current) === null || $t === void 0 || $t.onKeyUp.apply($t, [it].concat(Vt));
    }
    ye == null || ye.apply(void 0, [it].concat(Vt));
  }, mt = function(it) {
    var Zt = Z.filter(function(Vt) {
      return Vt !== it;
    });
    V(Zt, {
      type: "remove",
      values: [it]
    });
  }, Ct = React.useRef(!1), St = function() {
    gt(!0), X || (be && !Ct.current && be.apply(void 0, arguments), Te.includes("focus") && Ge(!0)), Ct.current = !0;
  }, vt = function() {
    Je.current = !0, gt(!1, function() {
      Ct.current = !1, Je.current = !1, Ge(!1);
    }), !X && (ht && (W === "tags" ? fe(ht, {
      source: "submit"
    }) : W === "multiple" && fe("", {
      source: "blur"
    })), Pe && Pe.apply(void 0, arguments));
  }, He = [];
  React.useEffect(function() {
    return function() {
      He.forEach(function(ut) {
        return clearTimeout(ut);
      }), He.splice(0, He.length);
    };
  }, []);
  var We = function(it) {
    var Zt, Vt = it.target, kt = (Zt = rt.current) === null || Zt === void 0 ? void 0 : Zt.getPopupElement();
    if (kt && kt.contains(Vt)) {
      var $t = setTimeout(function() {
        var sr = He.indexOf($t);
        if (sr !== -1 && He.splice(sr, 1), xt(), !Oe && !kt.contains(document.activeElement)) {
          var Kt;
          (Kt = lt.current) === null || Kt === void 0 || Kt.focus();
        }
      });
      He.push($t);
    }
    for (var Yt = arguments.length, Xt = new Array(Yt > 1 ? Yt - 1 : 0), er = 1; er < Yt; er++)
      Xt[er - 1] = arguments[er];
    Fe == null || Fe.apply(void 0, [it].concat(Xt));
  }, tt = React.useState({}), ft = _slicedToArray(tt, 2), _t = ft[1];
  function rr() {
    _t({});
  }
  var qt;
  Rt && (qt = function(it) {
    Ge(it);
  }), useSelectTriggerControl(function() {
    var ut;
    return [Qe.current, (ut = rt.current) === null || ut === void 0 ? void 0 : ut.getPopupElement()];
  }, Lt, Ge, !!Rt);
  var Ut = React.useMemo(function() {
    return _objectSpread2(_objectSpread2({}, t), {}, {
      notFoundContent: Y,
      open: dt,
      triggerOpen: Lt,
      id: a,
      showSearch: De,
      multiple: Le,
      toggleOpen: Ge
    });
  }, [t, Y, Lt, dt, a, De, Le, Ge]), or = !!ve || K, Qt;
  or && (Qt = /* @__PURE__ */ React.createElement(TransBtn, {
    className: cls("".concat(s, "-arrow"), _defineProperty({}, "".concat(s, "-arrow-loading"), K)),
    customizeIcon: ve,
    customizeIconProps: {
      loading: K,
      searchValue: ht,
      open: dt,
      focused: bt,
      showSearch: De
    }
  }));
  var Gt = function() {
    var it;
    G == null || G(), (it = lt.current) === null || it === void 0 || it.focus(), V([], {
      type: "clear",
      values: Z
    }), nt("", !1, !1);
  }, ar = useAllowClear(s, Gt, Z, pe, ae, X, ht, W), cr = ar.allowClear, ur = ar.clearIcon, nr = /* @__PURE__ */ React.createElement(me, {
    ref: ct
  }), pr = cls(s, o, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(s, "-focused"), bt), "".concat(s, "-multiple"), Le), "".concat(s, "-single"), !Le), "".concat(s, "-allow-clear"), pe), "".concat(s, "-show-arrow"), or), "".concat(s, "-disabled"), X), "".concat(s, "-loading"), K), "".concat(s, "-open"), dt), "".concat(s, "-customize-input"), jt), "".concat(s, "-show-search"), De)), ir = /* @__PURE__ */ React.createElement(RefSelectTrigger, {
    ref: rt,
    disabled: X,
    prefixCls: s,
    visible: Lt,
    popupElement: nr,
    animation: de,
    transitionName: ge,
    dropdownStyle: Se,
    dropdownClassName: xe,
    direction: x,
    dropdownMatchSelectWidth: Ee,
    dropdownRender: Ce,
    dropdownAlign: ke,
    placement: Re,
    builtinPlacements: _e,
    getPopupContainer: Me,
    empty: U,
    getTriggerDOMNode: function() {
      return Xe.current;
    },
    onPopupVisibleChange: qt,
    onPopupMouseEnter: rr
  }, Rt ? /* @__PURE__ */ React.cloneElement(Rt, {
    ref: Dt
  }) : /* @__PURE__ */ React.createElement(ForwardSelector, _extends({}, t, {
    domRef: Xe,
    prefixCls: s,
    inputElement: jt,
    ref: lt,
    id: a,
    showSearch: De,
    autoClearSearchValue: he,
    mode: W,
    activeDescendantId: le,
    tagRender: c,
    values: Z,
    open: dt,
    onToggleOpen: Ge,
    activeValue: ie,
    searchValue: ht,
    onSearch: nt,
    onSearchSubmit: Pt,
    onRemove: mt,
    tokenWithEnter: ze
  }))), Jt;
  return Rt ? Jt = ir : Jt = /* @__PURE__ */ React.createElement("div", _extends({
    className: pr
  }, je, {
    ref: Qe,
    onMouseDown: We,
    onKeyDown: ot,
    onKeyUp: yt,
    onFocus: St,
    onBlur: vt
  }), bt && !dt && /* @__PURE__ */ React.createElement("span", {
    "aria-live": "polite",
    style: {
      width: 0,
      height: 0,
      position: "absolute",
      overflow: "hidden",
      opacity: 0
    }
  }, "".concat(Z.map(function(ut) {
    var it = ut.label, Zt = ut.value;
    return ["number", "string"].includes(_typeof$1(it)) ? it : Zt;
  }).join(", "))), ir, Qt, cr && ur), /* @__PURE__ */ React.createElement(BaseSelectContext.Provider, {
    value: Ut
  }, Jt);
});
process.env.NODE_ENV !== "production" && (BaseSelect.displayName = "BaseSelect");
var OptGroup = function() {
  return null;
};
OptGroup.isSelectOptGroup = !0;
var Option = function() {
  return null;
};
Option.isSelectOption = !0;
function omit$2(t, r) {
  var n = Object.assign({}, t);
  return Array.isArray(r) && r.forEach(function(a) {
    delete n[a];
  }), n;
}
var Filler = /* @__PURE__ */ React.forwardRef(function(t, r) {
  var n = t.height, a = t.offsetY, s = t.offsetX, o = t.children, l = t.prefixCls, c = t.onInnerResize, x = t.innerProps, j = t.rtl, Z = t.extra, V = {}, U = {
    display: "flex",
    flexDirection: "column"
  };
  return a !== void 0 && (V = {
    height: n,
    position: "relative",
    overflow: "hidden"
  }, U = _objectSpread2(_objectSpread2({}, U), {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    transform: "translateY(".concat(a, "px)")
  }, j ? "marginRight" : "marginLeft", -s), "position", "absolute"), "left", 0), "right", 0), "top", 0))), /* @__PURE__ */ React.createElement("div", {
    style: V
  }, /* @__PURE__ */ React.createElement(RefResizeObserver, {
    onResize: function(Y) {
      var G = Y.offsetHeight;
      G && c && c();
    }
  }, /* @__PURE__ */ React.createElement("div", _extends({
    style: U,
    className: cls(_defineProperty({}, "".concat(l, "-holder-inner"), l)),
    ref: r
  }, x), o, Z)));
});
Filler.displayName = "Filler";
function Item$1(t) {
  var r = t.children, n = t.setRef, a = React.useCallback(function(s) {
    n(s);
  }, []);
  return /* @__PURE__ */ React.cloneElement(r, {
    ref: a
  });
}
function useChildren(t, r, n, a, s, o, l, c) {
  var x = c.getKey;
  return t.slice(r, n + 1).map(function(j, Z) {
    var V = r + Z, U = l(j, V, {
      style: {
        width: a
      },
      offsetX: s
    }), $ = x(j);
    return /* @__PURE__ */ React.createElement(Item$1, {
      key: $,
      setRef: function(G) {
        return o(j, G);
      }
    }, U);
  });
}
function findListDiffIndex(t, r, n) {
  var a = t.length, s = r.length, o, l;
  if (a === 0 && s === 0)
    return null;
  a < s ? (o = t, l = r) : (o = r, l = t);
  var c = {
    __EMPTY_ITEM__: !0
  };
  function x(Y) {
    return Y !== void 0 ? n(Y) : c;
  }
  for (var j = null, Z = Math.abs(a - s) !== 1, V = 0; V < l.length; V += 1) {
    var U = x(o[V]), $ = x(l[V]);
    if (U !== $) {
      j = V, Z = Z || U !== x(l[V + 1]);
      break;
    }
  }
  return j === null ? null : {
    index: j,
    multiple: Z
  };
}
function useDiffItem(t, r, n) {
  var a = React.useState(t), s = _slicedToArray(a, 2), o = s[0], l = s[1], c = React.useState(null), x = _slicedToArray(c, 2), j = x[0], Z = x[1];
  return React.useEffect(function() {
    var V = findListDiffIndex(o || [], t || [], r);
    (V == null ? void 0 : V.index) !== void 0 && Z(t[V.index]), l(t);
  }, [t]), [j];
}
var isFF = (typeof navigator == "undefined" ? "undefined" : _typeof$1(navigator)) === "object" && /Firefox/i.test(navigator.userAgent);
const useOriginScroll = (function(t, r, n, a) {
  var s = useRef(!1), o = useRef(null);
  function l() {
    clearTimeout(o.current), s.current = !0, o.current = setTimeout(function() {
      s.current = !1;
    }, 50);
  }
  var c = useRef({
    top: t,
    bottom: r,
    left: n,
    right: a
  });
  return c.current.top = t, c.current.bottom = r, c.current.left = n, c.current.right = a, function(x, j) {
    var Z = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, V = x ? (
      // Pass origin wheel when on the left
      j < 0 && c.current.left || // Pass origin wheel when on the right
      j > 0 && c.current.right
    ) : j < 0 && c.current.top || // Pass origin wheel when on the bottom
    j > 0 && c.current.bottom;
    return Z && V ? (clearTimeout(o.current), s.current = !1) : (!V || s.current) && l(), !s.current && V;
  };
});
function useFrameWheel(t, r, n, a, s, o, l) {
  var c = useRef(0), x = useRef(null), j = useRef(null), Z = useRef(!1), V = useOriginScroll(r, n, a, s);
  function U(K, J) {
    if (wrapperRaf.cancel(x.current), !V(!1, J)) {
      var ee = K;
      if (!ee._virtualHandled)
        ee._virtualHandled = !0;
      else
        return;
      c.current += J, j.current = J, isFF || ee.preventDefault(), x.current = wrapperRaf(function() {
        var te = Z.current ? 10 : 1;
        l(c.current * te, !1), c.current = 0;
      });
    }
  }
  function $(K, J) {
    l(J, !0), isFF || K.preventDefault();
  }
  var Y = useRef(null), G = useRef(null);
  function W(K) {
    if (t) {
      wrapperRaf.cancel(G.current), G.current = wrapperRaf(function() {
        Y.current = null;
      }, 2);
      var J = K.deltaX, ee = K.deltaY, te = K.shiftKey, ne = J, re = ee;
      (Y.current === "sx" || !Y.current && te && ee && !J) && (ne = ee, re = 0, Y.current = "sx");
      var ie = Math.abs(ne), ue = Math.abs(re);
      Y.current === null && (Y.current = o && ie > ue ? "x" : "y"), Y.current === "y" ? U(K, re) : $(K, ne);
    }
  }
  function X(K) {
    t && (Z.current = K.detail === j.current);
  }
  return [W, X];
}
function useGetSize(t, r, n, a) {
  var s = React.useMemo(function() {
    return [/* @__PURE__ */ new Map(), []];
  }, [t, n.id, a]), o = _slicedToArray(s, 2), l = o[0], c = o[1], x = function(Z) {
    var V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Z, U = l.get(Z), $ = l.get(V);
    if (U === void 0 || $ === void 0)
      for (var Y = t.length, G = c.length; G < Y; G += 1) {
        var W, X = t[G], K = r(X);
        l.set(K, G);
        var J = (W = n.get(K)) !== null && W !== void 0 ? W : a;
        if (c[G] = (c[G - 1] || 0) + J, K === Z && (U = G), K === V && ($ = G), U !== void 0 && $ !== void 0)
          break;
      }
    return {
      top: c[U - 1] || 0,
      bottom: c[$]
    };
  };
  return x;
}
var CacheMap = /* @__PURE__ */ (function() {
  function t() {
    _classCallCheck(this, t), _defineProperty(this, "maps", void 0), _defineProperty(this, "id", 0), _defineProperty(this, "diffRecords", /* @__PURE__ */ new Map()), this.maps = /* @__PURE__ */ Object.create(null);
  }
  return _createClass(t, [{
    key: "set",
    value: function(n, a) {
      this.diffRecords.set(n, this.maps[n]), this.maps[n] = a, this.id += 1;
    }
  }, {
    key: "get",
    value: function(n) {
      return this.maps[n];
    }
    /**
     * CacheMap will record the key changed.
     * To help to know what's update in the next render.
     */
  }, {
    key: "resetRecord",
    value: function() {
      this.diffRecords.clear();
    }
  }, {
    key: "getRecord",
    value: function() {
      return this.diffRecords;
    }
  }]), t;
})();
function parseNumber(t) {
  var r = parseFloat(t);
  return isNaN(r) ? 0 : r;
}
function useHeights(t, r, n) {
  var a = React.useState(0), s = _slicedToArray(a, 2), o = s[0], l = s[1], c = useRef(/* @__PURE__ */ new Map()), x = useRef(new CacheMap()), j = useRef(0);
  function Z() {
    j.current += 1;
  }
  function V() {
    var $ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    Z();
    var Y = function() {
      var X = !1;
      c.current.forEach(function(K, J) {
        if (K && K.offsetParent) {
          var ee = K.offsetHeight, te = getComputedStyle(K), ne = te.marginTop, re = te.marginBottom, ie = parseNumber(ne), ue = parseNumber(re), le = ee + ie + ue;
          x.current.get(J) !== le && (x.current.set(J, le), X = !0);
        }
      }), X && l(function(K) {
        return K + 1;
      });
    };
    if ($)
      Y();
    else {
      j.current += 1;
      var G = j.current;
      Promise.resolve().then(function() {
        G === j.current && Y();
      });
    }
  }
  function U($, Y) {
    var G = t($);
    c.current.get(G), Y ? (c.current.set(G, Y), V()) : c.current.delete(G);
  }
  return useEffect(function() {
    return Z;
  }, []), [U, V, x.current, o];
}
var SMOOTH_PTG = 14 / 15;
function useMobileTouchMove(t, r, n) {
  var a = useRef(!1), s = useRef(0), o = useRef(0), l = useRef(null), c = useRef(null), x, j = function($) {
    if (a.current) {
      var Y = Math.ceil($.touches[0].pageX), G = Math.ceil($.touches[0].pageY), W = s.current - Y, X = o.current - G, K = Math.abs(W) > Math.abs(X);
      K ? s.current = Y : o.current = G;
      var J = n(K, K ? W : X, !1, $);
      J && $.preventDefault(), clearInterval(c.current), J && (c.current = setInterval(function() {
        K ? W *= SMOOTH_PTG : X *= SMOOTH_PTG;
        var ee = Math.floor(K ? W : X);
        (!n(K, ee, !0) || Math.abs(ee) <= 0.1) && clearInterval(c.current);
      }, 16));
    }
  }, Z = function() {
    a.current = !1, x();
  }, V = function($) {
    x(), $.touches.length === 1 && !a.current && (a.current = !0, s.current = Math.ceil($.touches[0].pageX), o.current = Math.ceil($.touches[0].pageY), l.current = $.target, l.current.addEventListener("touchmove", j, {
      passive: !1
    }), l.current.addEventListener("touchend", Z, {
      passive: !0
    }));
  };
  x = function() {
    l.current && (l.current.removeEventListener("touchmove", j), l.current.removeEventListener("touchend", Z));
  }, useLayoutEffect$2(function() {
    return t && r.current.addEventListener("touchstart", V, {
      passive: !0
    }), function() {
      var U;
      (U = r.current) === null || U === void 0 || U.removeEventListener("touchstart", V), x(), clearInterval(c.current);
    };
  }, [t]);
}
function smoothScrollOffset(t) {
  return Math.floor(Math.pow(t, 0.5));
}
function getPageXY(t, r) {
  var n = "touches" in t ? t.touches[0] : t;
  return n[r ? "pageX" : "pageY"] - window[r ? "scrollX" : "scrollY"];
}
function useScrollDrag(t, r, n) {
  React.useEffect(function() {
    var a = r.current;
    if (t && a) {
      var s = !1, o, l, c = function() {
        wrapperRaf.cancel(o);
      }, x = function U() {
        c(), o = wrapperRaf(function() {
          n(l), U();
        });
      }, j = function() {
        s = !1, c();
      }, Z = function($) {
        if (!($.target.draggable || $.button !== 0)) {
          var Y = $;
          Y._virtualHandled || (Y._virtualHandled = !0, s = !0);
        }
      }, V = function($) {
        if (s) {
          var Y = getPageXY($, !1), G = a.getBoundingClientRect(), W = G.top, X = G.bottom;
          if (Y <= W) {
            var K = W - Y;
            l = -smoothScrollOffset(K), x();
          } else if (Y >= X) {
            var J = Y - X;
            l = smoothScrollOffset(J), x();
          } else
            c();
        }
      };
      return a.addEventListener("mousedown", Z), a.ownerDocument.addEventListener("mouseup", j), a.ownerDocument.addEventListener("mousemove", V), a.ownerDocument.addEventListener("dragend", j), function() {
        a.removeEventListener("mousedown", Z), a.ownerDocument.removeEventListener("mouseup", j), a.ownerDocument.removeEventListener("mousemove", V), a.ownerDocument.removeEventListener("dragend", j), c();
      };
    }
  }, [t]);
}
var MAX_TIMES = 10;
function useScrollTo(t, r, n, a, s, o, l, c) {
  var x = React.useRef(), j = React.useState(null), Z = _slicedToArray(j, 2), V = Z[0], U = Z[1];
  return useLayoutEffect$2(function() {
    if (V && V.times < MAX_TIMES) {
      if (!t.current) {
        U(function(me) {
          return _objectSpread2({}, me);
        });
        return;
      }
      o();
      var $ = V.targetAlign, Y = V.originAlign, G = V.index, W = V.offset, X = t.current.clientHeight, K = !1, J = $, ee = null;
      if (X) {
        for (var te = $ || Y, ne = 0, re = 0, ie = 0, ue = Math.min(r.length - 1, G), le = 0; le <= ue; le += 1) {
          var oe = s(r[le]);
          re = ne;
          var he = n.get(oe);
          ie = re + (he === void 0 ? a : he), ne = ie;
        }
        for (var fe = te === "top" ? W : X - W, ce = ue; ce >= 0; ce -= 1) {
          var se = s(r[ce]), pe = n.get(se);
          if (pe === void 0) {
            K = !0;
            break;
          }
          if (fe -= pe, fe <= 0)
            break;
        }
        switch (te) {
          case "top":
            ee = re - W;
            break;
          case "bottom":
            ee = ie - X + W;
            break;
          default: {
            var ve = t.current.scrollTop, ae = ve + X;
            re < ve ? J = "top" : ie > ae && (J = "bottom");
          }
        }
        ee !== null && l(ee), ee !== V.lastTop && (K = !0);
      }
      K && U(_objectSpread2(_objectSpread2({}, V), {}, {
        times: V.times + 1,
        targetAlign: J,
        lastTop: ee
      }));
    } else process.env.NODE_ENV !== "production" && (V == null ? void 0 : V.times) === MAX_TIMES && warningOnce(!1, "Seems `scrollTo` with `rc-virtual-list` reach the max limitation. Please fire issue for us. Thanks.");
  }, [V, t.current]), function($) {
    if ($ == null) {
      c();
      return;
    }
    if (wrapperRaf.cancel(x.current), typeof $ == "number")
      l($);
    else if ($ && _typeof$1($) === "object") {
      var Y, G = $.align;
      "index" in $ ? Y = $.index : Y = r.findIndex(function(K) {
        return s(K) === $.key;
      });
      var W = $.offset, X = W === void 0 ? 0 : W;
      U({
        times: 0,
        index: Y,
        offset: X,
        originAlign: G
      });
    }
  };
}
var ScrollBar = /* @__PURE__ */ React.forwardRef(function(t, r) {
  var n = t.prefixCls, a = t.rtl, s = t.scrollOffset, o = t.scrollRange, l = t.onStartMove, c = t.onStopMove, x = t.onScroll, j = t.horizontal, Z = t.spinSize, V = t.containerSize, U = t.style, $ = t.thumbStyle, Y = t.showScrollBar, G = React.useState(!1), W = _slicedToArray(G, 2), X = W[0], K = W[1], J = React.useState(null), ee = _slicedToArray(J, 2), te = ee[0], ne = ee[1], re = React.useState(null), ie = _slicedToArray(re, 2), ue = ie[0], le = ie[1], oe = !a, he = React.useRef(), fe = React.useRef(), ce = React.useState(Y), se = _slicedToArray(ce, 2), pe = se[0], ve = se[1], ae = React.useRef(), me = function() {
    Y === !0 || Y === !1 || (clearTimeout(ae.current), ve(!0), ae.current = setTimeout(function() {
      ve(!1);
    }, 3e3));
  }, de = o - V || 0, ge = V - Z || 0, Se = React.useMemo(function() {
    if (s === 0 || de === 0)
      return 0;
    var Te = s / de;
    return Te * ge;
  }, [s, de, ge]), xe = function(be) {
    be.stopPropagation(), be.preventDefault();
  }, Ee = React.useRef({
    top: Se,
    dragging: X,
    pageY: te,
    startTop: ue
  });
  Ee.current = {
    top: Se,
    dragging: X,
    pageY: te,
    startTop: ue
  };
  var Ce = function(be) {
    K(!0), ne(getPageXY(be, j)), le(Ee.current.top), l(), be.stopPropagation(), be.preventDefault();
  };
  React.useEffect(function() {
    var Te = function(Ae) {
      Ae.preventDefault();
    }, be = he.current, Pe = fe.current;
    return be.addEventListener("touchstart", Te, {
      passive: !1
    }), Pe.addEventListener("touchstart", Ce, {
      passive: !1
    }), function() {
      be.removeEventListener("touchstart", Te), Pe.removeEventListener("touchstart", Ce);
    };
  }, []);
  var ke = React.useRef();
  ke.current = de;
  var Re = React.useRef();
  Re.current = ge, React.useEffect(function() {
    if (X) {
      var Te, be = function(Ae) {
        var Fe = Ee.current, Ie = Fe.dragging, Le = Fe.pageY, De = Fe.startTop;
        wrapperRaf.cancel(Te);
        var je = he.current.getBoundingClientRect(), Ze = V / (j ? je.width : je.height);
        if (Ie) {
          var $e = (getPageXY(Ae, j) - Le) * Ze, Oe = De;
          !oe && j ? Oe -= $e : Oe += $e;
          var Be = ke.current, Qe = Re.current, Xe = Qe ? Oe / Qe : 0, rt = Math.ceil(Xe * Be);
          rt = Math.max(rt, 0), rt = Math.min(rt, Be), Te = wrapperRaf(function() {
            x(rt, j);
          });
        }
      }, Pe = function() {
        K(!1), c();
      };
      return window.addEventListener("mousemove", be, {
        passive: !0
      }), window.addEventListener("touchmove", be, {
        passive: !0
      }), window.addEventListener("mouseup", Pe, {
        passive: !0
      }), window.addEventListener("touchend", Pe, {
        passive: !0
      }), function() {
        window.removeEventListener("mousemove", be), window.removeEventListener("touchmove", be), window.removeEventListener("mouseup", Pe), window.removeEventListener("touchend", Pe), wrapperRaf.cancel(Te);
      };
    }
  }, [X]), React.useEffect(function() {
    return me(), function() {
      clearTimeout(ae.current);
    };
  }, [s]), React.useImperativeHandle(r, function() {
    return {
      delayHidden: me
    };
  });
  var _e = "".concat(n, "-scrollbar"), Me = {
    position: "absolute",
    visibility: pe ? null : "hidden"
  }, we = {
    position: "absolute",
    borderRadius: 99,
    background: "var(--rc-virtual-list-scrollbar-bg, rgba(0, 0, 0, 0.5))",
    cursor: "pointer",
    userSelect: "none"
  };
  return j ? (Object.assign(Me, {
    height: 8,
    left: 0,
    right: 0,
    bottom: 0
  }), Object.assign(we, _defineProperty({
    height: "100%",
    width: Z
  }, oe ? "left" : "right", Se))) : (Object.assign(Me, _defineProperty({
    width: 8,
    top: 0,
    bottom: 0
  }, oe ? "right" : "left", 0)), Object.assign(we, {
    width: "100%",
    height: Z,
    top: Se
  })), /* @__PURE__ */ React.createElement("div", {
    ref: he,
    className: cls(_e, _defineProperty(_defineProperty(_defineProperty({}, "".concat(_e, "-horizontal"), j), "".concat(_e, "-vertical"), !j), "".concat(_e, "-visible"), pe)),
    style: _objectSpread2(_objectSpread2({}, Me), U),
    onMouseDown: xe,
    onMouseMove: me
  }, /* @__PURE__ */ React.createElement("div", {
    ref: fe,
    className: cls("".concat(_e, "-thumb"), _defineProperty({}, "".concat(_e, "-thumb-moving"), X)),
    style: _objectSpread2(_objectSpread2({}, we), $),
    onMouseDown: Ce
  }));
});
process.env.NODE_ENV !== "production" && (ScrollBar.displayName = "ScrollBar");
var MIN_SIZE = 20;
function getSpinSize() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = t / r * t;
  return isNaN(n) && (n = 0), n = Math.max(n, MIN_SIZE), Math.floor(n);
}
var _excluded$5 = ["prefixCls", "className", "height", "itemHeight", "fullHeight", "style", "data", "children", "itemKey", "virtual", "direction", "scrollWidth", "component", "onScroll", "onVirtualScroll", "onVisibleChange", "innerProps", "extraRender", "styles", "showScrollBar"], EMPTY_DATA = [], ScrollStyle = {
  overflowY: "auto",
  overflowAnchor: "none"
};
function RawList(t, r) {
  var n = t.prefixCls, a = n === void 0 ? "rc-virtual-list" : n, s = t.className, o = t.height, l = t.itemHeight, c = t.fullHeight, x = c === void 0 ? !0 : c, j = t.style, Z = t.data, V = t.children, U = t.itemKey, $ = t.virtual, Y = t.direction, G = t.scrollWidth, W = t.component, X = W === void 0 ? "div" : W, K = t.onScroll, J = t.onVirtualScroll, ee = t.onVisibleChange, te = t.innerProps, ne = t.extraRender, re = t.styles, ie = t.showScrollBar, ue = ie === void 0 ? "optional" : ie, le = _objectWithoutProperties(t, _excluded$5), oe = React.useCallback(function(He) {
    return typeof U == "function" ? U(He) : He == null ? void 0 : He[U];
  }, [U]), he = useHeights(oe), fe = _slicedToArray(he, 4), ce = fe[0], se = fe[1], pe = fe[2], ve = fe[3], ae = !!($ !== !1 && o && l), me = React.useMemo(function() {
    return Object.values(pe.maps).reduce(function(He, We) {
      return He + We;
    }, 0);
  }, [pe.id, pe.maps]), de = ae && Z && (Math.max(l * Z.length, me) > o || !!G), ge = Y === "rtl", Se = cls(a, _defineProperty({}, "".concat(a, "-rtl"), ge), s), xe = Z || EMPTY_DATA, Ee = useRef(), Ce = useRef(), ke = useRef(), Re = useState$1(0), _e = _slicedToArray(Re, 2), Me = _e[0], we = _e[1], Te = useState$1(0), be = _slicedToArray(Te, 2), Pe = be[0], ye = be[1], Ae = useState$1(!1), Fe = _slicedToArray(Ae, 2), Ie = Fe[0], Le = Fe[1], De = function() {
    Le(!0);
  }, je = function() {
    Le(!1);
  }, Ze = {
    getKey: oe
  };
  function $e(He) {
    we(function(We) {
      var tt;
      typeof He == "function" ? tt = He(We) : tt = He;
      var ft = pt(tt);
      return Ee.current.scrollTop = ft, ft;
    });
  }
  var Oe = useRef({
    start: 0,
    end: xe.length
  }), Be = useRef(), Qe = useDiffItem(xe, oe), Xe = _slicedToArray(Qe, 1), rt = Xe[0];
  Be.current = rt;
  var lt = React.useMemo(function() {
    if (!ae)
      return {
        scrollHeight: void 0,
        start: 0,
        end: xe.length - 1,
        offset: void 0
      };
    if (!de) {
      var He;
      return {
        scrollHeight: ((He = Ce.current) === null || He === void 0 ? void 0 : He.offsetHeight) || 0,
        start: 0,
        end: xe.length - 1,
        offset: void 0
      };
    }
    for (var We = 0, tt, ft, _t, rr = xe.length, qt = 0; qt < rr; qt += 1) {
      var Ut = xe[qt], or = oe(Ut), Qt = pe.get(or), Gt = We + (Qt === void 0 ? l : Qt);
      Gt >= Me && tt === void 0 && (tt = qt, ft = We), Gt > Me + o && _t === void 0 && (_t = qt), We = Gt;
    }
    return tt === void 0 && (tt = 0, ft = 0, _t = Math.ceil(o / l)), _t === void 0 && (_t = xe.length - 1), _t = Math.min(_t + 1, xe.length - 1), {
      scrollHeight: We,
      start: tt,
      end: _t,
      offset: ft
    };
  }, [de, ae, Me, xe, ve, o]), ct = lt.scrollHeight, Je = lt.start, st = lt.end, At = lt.offset;
  Oe.current.start = Je, Oe.current.end = st, React.useLayoutEffect(function() {
    var He = pe.getRecord();
    if (He.size === 1) {
      var We = Array.from(He.keys())[0], tt = He.get(We), ft = xe[Je];
      if (ft && tt === void 0) {
        var _t = oe(ft);
        if (_t === We) {
          var rr = pe.get(We), qt = rr - l;
          $e(function(Ut) {
            return Ut + qt;
          });
        }
      }
    }
    pe.resetRecord();
  }, [ct]);
  var bt = React.useState({
    width: 0,
    height: o
  }), gt = _slicedToArray(bt, 2), xt = gt[0], ht = gt[1], jt = function(We) {
    ht({
      width: We.offsetWidth,
      height: We.offsetHeight
    });
  }, Rt = useRef(), Dt = useRef(), wt = React.useMemo(function() {
    return getSpinSize(xt.width, G);
  }, [xt.width, G]), Wt = React.useMemo(function() {
    return getSpinSize(xt.height, ct);
  }, [xt.height, ct]), Bt = ct - o, It = useRef(Bt);
  It.current = Bt;
  function pt(He) {
    var We = He;
    return Number.isNaN(It.current) || (We = Math.min(We, It.current)), We = Math.max(We, 0), We;
  }
  var et = Me <= 0, Tt = Me >= Bt, Et = Pe <= 0, dt = Pe >= G, zt = useOriginScroll(et, Tt, Et, dt), Lt = function() {
    return {
      x: ge ? -Pe : Pe,
      y: Me
    };
  }, Ge = useRef(Lt()), ze = useEvent$1(function(He) {
    if (J) {
      var We = _objectSpread2(_objectSpread2({}, Lt()), He);
      (Ge.current.x !== We.x || Ge.current.y !== We.y) && (J(We), Ge.current = We);
    }
  });
  function Ne(He, We) {
    var tt = He;
    We ? (flushSync(function() {
      ye(tt);
    }), ze()) : $e(tt);
  }
  function Ve(He) {
    var We = He.currentTarget.scrollTop;
    We !== Me && $e(We), K == null || K(He), ze();
  }
  var qe = function(We) {
    var tt = We, ft = G ? G - xt.width : 0;
    return tt = Math.max(tt, 0), tt = Math.min(tt, ft), tt;
  }, nt = useEvent$1(function(He, We) {
    We ? (flushSync(function() {
      ye(function(tt) {
        var ft = tt + (ge ? -He : He);
        return qe(ft);
      });
    }), ze()) : $e(function(tt) {
      var ft = tt + He;
      return ft;
    });
  }), Pt = useFrameWheel(ae, et, Tt, Et, dt, !!G, nt), Mt = _slicedToArray(Pt, 2), Ft = Mt[0], Ke = Mt[1];
  useMobileTouchMove(ae, Ee, function(He, We, tt, ft) {
    var _t = ft;
    return zt(He, We, tt) ? !1 : !_t || !_t._virtualHandled ? (_t && (_t._virtualHandled = !0), Ft({
      preventDefault: function() {
      },
      deltaX: He ? We : 0,
      deltaY: He ? 0 : We
    }), !0) : !1;
  }), useScrollDrag(de, Ee, function(He) {
    $e(function(We) {
      return We + He;
    });
  }), useLayoutEffect$2(function() {
    function He(tt) {
      var ft = et && tt.detail < 0, _t = Tt && tt.detail > 0;
      ae && !ft && !_t && tt.preventDefault();
    }
    var We = Ee.current;
    return We.addEventListener("wheel", Ft, {
      passive: !1
    }), We.addEventListener("DOMMouseScroll", Ke, {
      passive: !0
    }), We.addEventListener("MozMousePixelScroll", He, {
      passive: !1
    }), function() {
      We.removeEventListener("wheel", Ft), We.removeEventListener("DOMMouseScroll", Ke), We.removeEventListener("MozMousePixelScroll", He);
    };
  }, [ae, et, Tt]), useLayoutEffect$2(function() {
    if (G) {
      var He = qe(Pe);
      ye(He), ze({
        x: He
      });
    }
  }, [xt.width, G]);
  var Ye = function() {
    var We, tt;
    (We = Rt.current) === null || We === void 0 || We.delayHidden(), (tt = Dt.current) === null || tt === void 0 || tt.delayHidden();
  }, ot = useScrollTo(Ee, xe, pe, l, oe, function() {
    return se(!0);
  }, $e, Ye);
  React.useImperativeHandle(r, function() {
    return {
      nativeElement: ke.current,
      getScrollInfo: Lt,
      scrollTo: function(We) {
        function tt(ft) {
          return ft && _typeof$1(ft) === "object" && ("left" in ft || "top" in ft);
        }
        tt(We) ? (We.left !== void 0 && ye(qe(We.left)), ot(We.top)) : ot(We);
      }
    };
  }), useLayoutEffect$2(function() {
    if (ee) {
      var He = xe.slice(Je, st + 1);
      ee(He, xe);
    }
  }, [Je, st, xe]);
  var yt = useGetSize(xe, oe, pe, l), mt = ne == null ? void 0 : ne({
    start: Je,
    end: st,
    virtual: de,
    offsetX: Pe,
    offsetY: At,
    rtl: ge,
    getSize: yt
  }), Ct = useChildren(xe, Je, st, G, Pe, ce, V, Ze), St = null;
  o && (St = _objectSpread2(_defineProperty({}, x ? "height" : "maxHeight", o), ScrollStyle), ae && (St.overflowY = "hidden", G && (St.overflowX = "hidden"), Ie && (St.pointerEvents = "none")));
  var vt = {};
  return ge && (vt.dir = "rtl"), /* @__PURE__ */ React.createElement("div", _extends({
    ref: ke,
    style: _objectSpread2(_objectSpread2({}, j), {}, {
      position: "relative"
    }),
    className: Se
  }, vt, le), /* @__PURE__ */ React.createElement(RefResizeObserver, {
    onResize: jt
  }, /* @__PURE__ */ React.createElement(X, {
    className: "".concat(a, "-holder"),
    style: St,
    ref: Ee,
    onScroll: Ve,
    onMouseEnter: Ye
  }, /* @__PURE__ */ React.createElement(Filler, {
    prefixCls: a,
    height: ct,
    offsetX: Pe,
    offsetY: At,
    scrollWidth: G,
    onInnerResize: se,
    ref: Ce,
    innerProps: te,
    rtl: ge,
    extra: mt
  }, Ct))), de && ct > o && /* @__PURE__ */ React.createElement(ScrollBar, {
    ref: Rt,
    prefixCls: a,
    scrollOffset: Me,
    scrollRange: ct,
    rtl: ge,
    onScroll: Ne,
    onStartMove: De,
    onStopMove: je,
    spinSize: Wt,
    containerSize: xt.height,
    style: re == null ? void 0 : re.verticalScrollBar,
    thumbStyle: re == null ? void 0 : re.verticalScrollBarThumb,
    showScrollBar: ue
  }), de && G > xt.width && /* @__PURE__ */ React.createElement(ScrollBar, {
    ref: Dt,
    prefixCls: a,
    scrollOffset: Pe,
    scrollRange: G,
    rtl: ge,
    onScroll: Ne,
    onStartMove: De,
    onStopMove: je,
    spinSize: wt,
    containerSize: xt.width,
    horizontal: !0,
    style: re == null ? void 0 : re.horizontalScrollBar,
    thumbStyle: re == null ? void 0 : re.horizontalScrollBarThumb,
    showScrollBar: ue
  }));
}
var List = /* @__PURE__ */ React.forwardRef(RawList);
List.displayName = "List";
function isPlatformMac() {
  return /(mac\sos|macintosh)/i.test(navigator.appVersion);
}
var _excluded$4 = ["disabled", "title", "children", "style", "className"];
function isTitleType(t) {
  return typeof t == "string" || typeof t == "number";
}
var OptionList = function(r, n) {
  var a = useBaseProps(), s = a.prefixCls, o = a.id, l = a.open, c = a.multiple, x = a.mode, j = a.searchValue, Z = a.toggleOpen, V = a.notFoundContent, U = a.onPopupScroll, $ = React.useContext(SelectContext), Y = $.maxCount, G = $.flattenOptions, W = $.onActiveValue, X = $.defaultActiveFirstOption, K = $.onSelect, J = $.menuItemSelectedIcon, ee = $.rawValues, te = $.fieldNames, ne = $.virtual, re = $.direction, ie = $.listHeight, ue = $.listItemHeight, le = $.optionRender, oe = "".concat(s, "-item"), he = useMemo(function() {
    return G;
  }, [l, G], function(we, Te) {
    return Te[0] && we[1] !== Te[1];
  }), fe = React.useRef(null), ce = React.useMemo(function() {
    return c && isValidCount(Y) && (ee == null ? void 0 : ee.size) >= Y;
  }, [c, Y, ee == null ? void 0 : ee.size]), se = function(Te) {
    Te.preventDefault();
  }, pe = function(Te) {
    var be;
    (be = fe.current) === null || be === void 0 || be.scrollTo(typeof Te == "number" ? {
      index: Te
    } : Te);
  }, ve = function(Te) {
    for (var be = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, Pe = he.length, ye = 0; ye < Pe; ye += 1) {
      var Ae = (Te + ye * be + Pe) % Pe, Fe = he[Ae] || {}, Ie = Fe.group, Le = Fe.data;
      if (!Ie && !(Le != null && Le.disabled) && !ce)
        return Ae;
    }
    return -1;
  }, ae = React.useState(function() {
    return ve(0);
  }), me = _slicedToArray(ae, 2), de = me[0], ge = me[1], Se = function(Te) {
    var be = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    ge(Te);
    var Pe = {
      source: be ? "keyboard" : "mouse"
    }, ye = he[Te];
    if (!ye) {
      W(null, -1, Pe);
      return;
    }
    W(ye.value, Te, Pe);
  };
  useEffect(function() {
    Se(X !== !1 ? ve(0) : -1);
  }, [he.length, j]);
  var xe = React.useCallback(function(we) {
    return ee.has(we) && x !== "combobox";
  }, [x, _toConsumableArray(ee).toString(), ee.size]);
  useEffect(function() {
    var we = setTimeout(function() {
      if (!c && l && ee.size === 1) {
        var be = Array.from(ee)[0], Pe = he.findIndex(function(ye) {
          var Ae = ye.data;
          return Ae.value === be;
        });
        Pe !== -1 && (Se(Pe), pe(Pe));
      }
    });
    if (l) {
      var Te;
      (Te = fe.current) === null || Te === void 0 || Te.scrollTo(void 0);
    }
    return function() {
      return clearTimeout(we);
    };
  }, [l, j]);
  var Ee = function(Te) {
    Te !== void 0 && K(Te, {
      selected: !ee.has(Te)
    }), c || Z(!1);
  };
  if (React.useImperativeHandle(n, function() {
    return {
      onKeyDown: function(Te) {
        var be = Te.which, Pe = Te.ctrlKey;
        switch (be) {
          // >>> Arrow keys & ctrl + n/p on Mac
          case KeyCode.N:
          case KeyCode.P:
          case KeyCode.UP:
          case KeyCode.DOWN: {
            var ye = 0;
            if (be === KeyCode.UP ? ye = -1 : be === KeyCode.DOWN ? ye = 1 : isPlatformMac() && Pe && (be === KeyCode.N ? ye = 1 : be === KeyCode.P && (ye = -1)), ye !== 0) {
              var Ae = ve(de + ye, ye);
              pe(Ae), Se(Ae, !0);
            }
            break;
          }
          // >>> Select
          case KeyCode.ENTER: {
            var Fe, Ie = he[de];
            Ie && !(Ie != null && (Fe = Ie.data) !== null && Fe !== void 0 && Fe.disabled) && !ce ? Ee(Ie.value) : Ee(void 0), l && Te.preventDefault();
            break;
          }
          // >>> Close
          case KeyCode.ESC:
            Z(!1), l && Te.stopPropagation();
        }
      },
      onKeyUp: function() {
      },
      scrollTo: function(Te) {
        pe(Te);
      }
    };
  }), he.length === 0)
    return /* @__PURE__ */ React.createElement("div", {
      role: "listbox",
      id: "".concat(o, "_list"),
      className: "".concat(oe, "-empty"),
      onMouseDown: se
    }, V);
  var Ce = Object.keys(te).map(function(we) {
    return te[we];
  }), ke = function(Te) {
    return Te.label;
  };
  function Re(we, Te) {
    var be = we.group;
    return {
      role: be ? "presentation" : "option",
      id: "".concat(o, "_list_").concat(Te)
    };
  }
  var _e = function(Te) {
    var be = he[Te];
    if (!be)
      return null;
    var Pe = be.data || {}, ye = Pe.value, Ae = be.group, Fe = pickAttrs(Pe, !0), Ie = ke(be);
    return be ? /* @__PURE__ */ React.createElement("div", _extends({
      "aria-label": typeof Ie == "string" && !Ae ? Ie : null
    }, Fe, {
      key: Te
    }, Re(be, Te), {
      "aria-selected": xe(ye)
    }), ye) : null;
  }, Me = {
    role: "listbox",
    id: "".concat(o, "_list")
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, ne && /* @__PURE__ */ React.createElement("div", _extends({}, Me, {
    style: {
      height: 0,
      width: 0,
      overflow: "hidden"
    }
  }), _e(de - 1), _e(de), _e(de + 1)), /* @__PURE__ */ React.createElement(List, {
    itemKey: "key",
    ref: fe,
    data: he,
    height: ie,
    itemHeight: ue,
    fullHeight: !1,
    onMouseDown: se,
    onScroll: U,
    virtual: ne,
    direction: re,
    innerProps: ne ? null : Me
  }, function(we, Te) {
    var be = we.group, Pe = we.groupOption, ye = we.data, Ae = we.label, Fe = we.value, Ie = ye.key;
    if (be) {
      var Le, De = (Le = ye.title) !== null && Le !== void 0 ? Le : isTitleType(Ae) ? Ae.toString() : void 0;
      return /* @__PURE__ */ React.createElement("div", {
        className: cls(oe, "".concat(oe, "-group"), ye.className),
        title: De
      }, Ae !== void 0 ? Ae : Ie);
    }
    var je = ye.disabled, Ze = ye.title;
    ye.children;
    var $e = ye.style, Oe = ye.className, Be = _objectWithoutProperties(ye, _excluded$4), Qe = omit$2(Be, Ce), Xe = xe(Fe), rt = je || !Xe && ce, lt = "".concat(oe, "-option"), ct = cls(oe, lt, Oe, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(lt, "-grouped"), Pe), "".concat(lt, "-active"), de === Te && !rt), "".concat(lt, "-disabled"), rt), "".concat(lt, "-selected"), Xe)), Je = ke(we), st = !J || typeof J == "function" || Xe, At = typeof Je == "number" ? Je : Je || Fe, bt = isTitleType(At) ? At.toString() : void 0;
    return Ze !== void 0 && (bt = Ze), /* @__PURE__ */ React.createElement("div", _extends({}, pickAttrs(Qe), ne ? {} : Re(we, Te), {
      "aria-selected": Xe,
      className: ct,
      title: bt,
      onMouseMove: function() {
        de === Te || rt || Se(Te);
      },
      onClick: function() {
        rt || Ee(Fe);
      },
      style: $e
    }), /* @__PURE__ */ React.createElement("div", {
      className: "".concat(lt, "-content")
    }, typeof le == "function" ? le(we, {
      index: Te
    }) : At), /* @__PURE__ */ React.isValidElement(J) || Xe, st && /* @__PURE__ */ React.createElement(TransBtn, {
      className: "".concat(oe, "-option-state"),
      customizeIcon: J,
      customizeIconProps: {
        value: Fe,
        disabled: rt,
        isSelected: Xe
      }
    }, Xe ? "✓" : null));
  }));
}, RefOptionList = /* @__PURE__ */ React.forwardRef(OptionList);
process.env.NODE_ENV !== "production" && (RefOptionList.displayName = "OptionList");
const useCache = (function(t, r) {
  var n = React.useRef({
    values: /* @__PURE__ */ new Map(),
    options: /* @__PURE__ */ new Map()
  }), a = React.useMemo(function() {
    var o = n.current, l = o.values, c = o.options, x = t.map(function(V) {
      if (V.label === void 0) {
        var U;
        return _objectSpread2(_objectSpread2({}, V), {}, {
          label: (U = l.get(V.value)) === null || U === void 0 ? void 0 : U.label
        });
      }
      return V;
    }), j = /* @__PURE__ */ new Map(), Z = /* @__PURE__ */ new Map();
    return x.forEach(function(V) {
      j.set(V.value, V), Z.set(V.value, r.get(V.value) || c.get(V.value));
    }), n.current.values = j, n.current.options = Z, x;
  }, [t, r]), s = React.useCallback(function(o) {
    return r.get(o) || n.current.options.get(o);
  }, [r]);
  return [a, s];
});
function includes(t, r) {
  return toArray$1(t).join("").toUpperCase().includes(r);
}
const useFilterOptions = (function(t, r, n, a, s) {
  return React.useMemo(function() {
    if (!n || a === !1)
      return t;
    var o = r.options, l = r.label, c = r.value, x = [], j = typeof a == "function", Z = n.toUpperCase(), V = j ? a : function($, Y) {
      return s ? includes(Y[s], Z) : Y[o] ? includes(Y[l !== "children" ? l : "label"], Z) : includes(Y[c], Z);
    }, U = j ? function($) {
      return injectPropsWithOption($);
    } : function($) {
      return $;
    };
    return t.forEach(function($) {
      if ($[o]) {
        var Y = V(n, U($));
        if (Y)
          x.push($);
        else {
          var G = $[o].filter(function(W) {
            return V(n, U(W));
          });
          G.length && x.push(_objectSpread2(_objectSpread2({}, $), {}, _defineProperty({}, o, G)));
        }
        return;
      }
      V(n, U($)) && x.push($);
    }), x;
  }, [t, a, s, n, r]);
});
var uuid$1 = 0, isBrowserClient = process.env.NODE_ENV !== "test" && canUseDom$1();
function getUUID() {
  var t;
  return isBrowserClient ? (t = uuid$1, uuid$1 += 1) : t = "TEST_OR_SSR", t;
}
function useId$1(t) {
  var r = React.useState(), n = _slicedToArray(r, 2), a = n[0], s = n[1];
  return React.useEffect(function() {
    s("rc_select_".concat(getUUID()));
  }, []), t || a;
}
var _excluded$3 = ["children", "value"], _excluded2 = ["children"];
function convertNodeToOption(t) {
  var r = t, n = r.key, a = r.props, s = a.children, o = a.value, l = _objectWithoutProperties(a, _excluded$3);
  return _objectSpread2({
    key: n,
    value: o !== void 0 ? o : n,
    children: s
  }, l);
}
function convertChildrenToData(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  return toArray$2(t).map(function(n, a) {
    if (!/* @__PURE__ */ React.isValidElement(n) || !n.type)
      return null;
    var s = n, o = s.type.isSelectOptGroup, l = s.key, c = s.props, x = c.children, j = _objectWithoutProperties(c, _excluded2);
    return r || !o ? convertNodeToOption(n) : _objectSpread2(_objectSpread2({
      key: "__RC_SELECT_GRP__".concat(l === null ? a : l, "__"),
      label: l
    }, j), {}, {
      options: convertChildrenToData(x)
    });
  }).filter(function(n) {
    return n;
  });
}
var useOptions = function(r, n, a, s, o) {
  return React.useMemo(function() {
    var l = r, c = !r;
    c && (l = convertChildrenToData(n));
    var x = /* @__PURE__ */ new Map(), j = /* @__PURE__ */ new Map(), Z = function($, Y, G) {
      G && typeof G == "string" && $.set(Y[G], Y);
    }, V = function U($) {
      for (var Y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, G = 0; G < $.length; G += 1) {
        var W = $[G];
        !W[a.options] || Y ? (x.set(W[a.value], W), Z(j, W, a.label), Z(j, W, s), Z(j, W, o)) : U(W[a.options], !0);
      }
    };
    return V(l), {
      options: l,
      valueOptions: x,
      labelOptions: j
    };
  }, [r, n, a, s, o]);
};
function useRefFunc(t) {
  var r = React.useRef();
  r.current = t;
  var n = React.useCallback(function() {
    return r.current.apply(r, arguments);
  }, []);
  return n;
}
function warningProps(t) {
  var r = t.mode, n = t.options, a = t.children, s = t.backfill, o = t.allowClear, l = t.placeholder, c = t.getInputElement, x = t.showSearch, j = t.onSearch, Z = t.defaultOpen, V = t.autoFocus, U = t.labelInValue, $ = t.value, Y = t.inputValue, G = t.optionLabelProp, W = isMultiple(r), X = x !== void 0 ? x : W || r === "combobox", K = n || convertChildrenToData(a);
  if (warningOnce(r !== "tags" || K.every(function(ne) {
    return !ne.disabled;
  }), "Please avoid setting option to disabled in tags mode since user can always type text as tag."), r === "tags" || r === "combobox") {
    var J = K.some(function(ne) {
      return ne.options ? ne.options.some(function(re) {
        return typeof ("value" in re ? re.value : re.key) == "number";
      }) : typeof ("value" in ne ? ne.value : ne.key) == "number";
    });
    warningOnce(!J, "`value` of Option should not use number type when `mode` is `tags` or `combobox`.");
  }
  if (warningOnce(r !== "combobox" || !G, "`combobox` mode not support `optionLabelProp`. Please set `value` on Option directly."), warningOnce(r === "combobox" || !s, "`backfill` only works with `combobox` mode."), warningOnce(r === "combobox" || !c, "`getInputElement` only work with `combobox` mode."), noteOnce(r !== "combobox" || !c || !o || !l, "Customize `getInputElement` should customize clear and placeholder logic instead of configuring `allowClear` and `placeholder`."), j && !X && r !== "combobox" && r !== "tags" && warningOnce(!1, "`onSearch` should work with `showSearch` instead of use alone."), noteOnce(!Z || V, "`defaultOpen` makes Select open without focus which means it will not close by click outside. You can set `autoFocus` if needed."), $ != null) {
    var ee = toArray$1($);
    warningOnce(!U || ee.every(function(ne) {
      return _typeof$1(ne) === "object" && ("key" in ne || "value" in ne);
    }), "`value` should in shape of `{ value: string | number, label?: ReactNode }` when you set `labelInValue` to `true`"), warningOnce(!W || Array.isArray($), "`value` should be array when `mode` is `multiple` or `tags`");
  }
  if (a) {
    var te = null;
    toArray$2(a).some(function(ne) {
      if (!/* @__PURE__ */ React.isValidElement(ne) || !ne.type)
        return !1;
      var re = ne, ie = re.type;
      if (ie.isSelectOption)
        return !1;
      if (ie.isSelectOptGroup) {
        var ue = toArray$2(ne.props.children).every(function(le) {
          return !/* @__PURE__ */ React.isValidElement(le) || !ne.type || le.type.isSelectOption ? !0 : (te = le.type, !1);
        });
        return !ue;
      }
      return te = ie, !0;
    }), te && warningOnce(!1, "`children` should be `Select.Option` or `Select.OptGroup` instead of `".concat(te.displayName || te.name || te, "`.")), warningOnce(Y === void 0, "`inputValue` is deprecated, please use `searchValue` instead.");
  }
}
function warningNullOptions(t, r) {
  if (t) {
    var n = function a(s) {
      for (var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, l = 0; l < s.length; l++) {
        var c = s[l];
        if (c[r == null ? void 0 : r.value] === null)
          return warningOnce(!1, "`value` in Select options should not be `null`."), !0;
        if (!o && Array.isArray(c[r == null ? void 0 : r.options]) && a(c[r == null ? void 0 : r.options], !0))
          break;
      }
    };
    n(t);
  }
}
var _excluded$2 = ["id", "mode", "prefixCls", "backfill", "fieldNames", "inputValue", "searchValue", "onSearch", "autoClearSearchValue", "onSelect", "onDeselect", "dropdownMatchSelectWidth", "filterOption", "filterSort", "optionFilterProp", "optionLabelProp", "options", "optionRender", "children", "defaultActiveFirstOption", "menuItemSelectedIcon", "virtual", "direction", "listHeight", "listItemHeight", "labelRender", "value", "defaultValue", "labelInValue", "onChange", "maxCount"], OMIT_DOM_PROPS = ["inputValue"];
function isRawValue(t) {
  return !t || _typeof$1(t) !== "object";
}
var Select$1 = /* @__PURE__ */ React.forwardRef(function(t, r) {
  var n = t.id, a = t.mode, s = t.prefixCls, o = s === void 0 ? "rc-select" : s, l = t.backfill, c = t.fieldNames, x = t.inputValue, j = t.searchValue, Z = t.onSearch, V = t.autoClearSearchValue, U = V === void 0 ? !0 : V, $ = t.onSelect, Y = t.onDeselect, G = t.dropdownMatchSelectWidth, W = G === void 0 ? !0 : G, X = t.filterOption, K = t.filterSort, J = t.optionFilterProp, ee = t.optionLabelProp, te = t.options, ne = t.optionRender, re = t.children, ie = t.defaultActiveFirstOption, ue = t.menuItemSelectedIcon, le = t.virtual, oe = t.direction, he = t.listHeight, fe = he === void 0 ? 200 : he, ce = t.listItemHeight, se = ce === void 0 ? 20 : ce, pe = t.labelRender, ve = t.value, ae = t.defaultValue, me = t.labelInValue, de = t.onChange, ge = t.maxCount, Se = _objectWithoutProperties(t, _excluded$2), xe = useId$1(n), Ee = isMultiple(a), Ce = !!(!te && re), ke = React.useMemo(function() {
    return X === void 0 && a === "combobox" ? !1 : X;
  }, [X, a]), Re = React.useMemo(
    function() {
      return fillFieldNames(c, Ce);
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [
      // We stringify fieldNames to avoid unnecessary re-renders.
      JSON.stringify(c),
      Ce
    ]
    /* eslint-enable react-hooks/exhaustive-deps */
  ), _e = useMergedState$2("", {
    value: j !== void 0 ? j : x,
    postState: function(ze) {
      return ze || "";
    }
  }), Me = _slicedToArray(_e, 2), we = Me[0], Te = Me[1], be = useOptions(te, re, Re, J, ee), Pe = be.valueOptions, ye = be.labelOptions, Ae = be.options, Fe = React.useCallback(function(Ge) {
    var ze = toArray$1(Ge);
    return ze.map(function(Ne) {
      var Ve, qe, nt, Pt, Mt;
      if (isRawValue(Ne))
        Ve = Ne;
      else {
        var Ft;
        nt = Ne.key, qe = Ne.label, Ve = (Ft = Ne.value) !== null && Ft !== void 0 ? Ft : nt;
      }
      var Ke = Pe.get(Ve);
      if (Ke) {
        var Ye;
        if (qe === void 0 && (qe = Ke == null ? void 0 : Ke[ee || Re.label]), nt === void 0 && (nt = (Ye = Ke == null ? void 0 : Ke.key) !== null && Ye !== void 0 ? Ye : Ve), Pt = Ke == null ? void 0 : Ke.disabled, Mt = Ke == null ? void 0 : Ke.title, process.env.NODE_ENV !== "production" && !ee) {
          var ot = Ke == null ? void 0 : Ke[Re.label];
          ot !== void 0 && !/* @__PURE__ */ React.isValidElement(ot) && !/* @__PURE__ */ React.isValidElement(qe) && ot !== qe && warningOnce(!1, "`label` of `value` is not same as `label` in Select options.");
        }
      }
      return {
        label: qe,
        value: Ve,
        key: nt,
        disabled: Pt,
        title: Mt
      };
    });
  }, [Re, ee, Pe]), Ie = useMergedState$2(ae, {
    value: ve
  }), Le = _slicedToArray(Ie, 2), De = Le[0], je = Le[1], Ze = React.useMemo(function() {
    var Ge, ze = Ee && De === null ? [] : De, Ne = Fe(ze);
    return a === "combobox" && isComboNoValue((Ge = Ne[0]) === null || Ge === void 0 ? void 0 : Ge.value) ? [] : Ne;
  }, [De, Fe, a, Ee]), $e = useCache(Ze, Pe), Oe = _slicedToArray($e, 2), Be = Oe[0], Qe = Oe[1], Xe = React.useMemo(function() {
    if (!a && Be.length === 1) {
      var Ge = Be[0];
      if (Ge.value === null && (Ge.label === null || Ge.label === void 0))
        return [];
    }
    return Be.map(function(ze) {
      var Ne;
      return _objectSpread2(_objectSpread2({}, ze), {}, {
        label: (Ne = typeof pe == "function" ? pe(ze) : ze.label) !== null && Ne !== void 0 ? Ne : ze.value
      });
    });
  }, [a, Be, pe]), rt = React.useMemo(function() {
    return new Set(Be.map(function(Ge) {
      return Ge.value;
    }));
  }, [Be]);
  React.useEffect(function() {
    if (a === "combobox") {
      var Ge, ze = (Ge = Be[0]) === null || Ge === void 0 ? void 0 : Ge.value;
      Te(hasValue$1(ze) ? String(ze) : "");
    }
  }, [Be]);
  var lt = useRefFunc(function(Ge, ze) {
    var Ne = ze != null ? ze : Ge;
    return _defineProperty(_defineProperty({}, Re.value, Ge), Re.label, Ne);
  }), ct = React.useMemo(function() {
    if (a !== "tags")
      return Ae;
    var Ge = _toConsumableArray(Ae), ze = function(Ve) {
      return Pe.has(Ve);
    };
    return _toConsumableArray(Be).sort(function(Ne, Ve) {
      return Ne.value < Ve.value ? -1 : 1;
    }).forEach(function(Ne) {
      var Ve = Ne.value;
      ze(Ve) || Ge.push(lt(Ve, Ne.label));
    }), Ge;
  }, [lt, Ae, Pe, Be, a]), Je = useFilterOptions(ct, Re, we, ke, J), st = React.useMemo(function() {
    return a !== "tags" || !we || Je.some(function(Ge) {
      return Ge[J || "value"] === we;
    }) || Je.some(function(Ge) {
      return Ge[Re.value] === we;
    }) ? Je : [lt(we)].concat(_toConsumableArray(Je));
  }, [lt, J, a, Je, we, Re]), At = React.useMemo(function() {
    return K ? _toConsumableArray(st).sort(function(Ge, ze) {
      return K(Ge, ze);
    }) : st;
  }, [st, K]), bt = React.useMemo(function() {
    return flattenOptions(At, {
      fieldNames: Re,
      childrenAsData: Ce
    });
  }, [At, Re, Ce]), gt = function(ze) {
    var Ne = Fe(ze);
    if (je(Ne), de && // Trigger event only when value changed
    (Ne.length !== Be.length || Ne.some(function(nt, Pt) {
      var Mt;
      return ((Mt = Be[Pt]) === null || Mt === void 0 ? void 0 : Mt.value) !== (nt == null ? void 0 : nt.value);
    }))) {
      var Ve = me ? Ne : Ne.map(function(nt) {
        return nt.value;
      }), qe = Ne.map(function(nt) {
        return injectPropsWithOption(Qe(nt.value));
      });
      de(
        // Value
        Ee ? Ve : Ve[0],
        // Option
        Ee ? qe : qe[0]
      );
    }
  }, xt = React.useState(null), ht = _slicedToArray(xt, 2), jt = ht[0], Rt = ht[1], Dt = React.useState(0), wt = _slicedToArray(Dt, 2), Wt = wt[0], Bt = wt[1], It = ie !== void 0 ? ie : a !== "combobox", pt = React.useCallback(function(Ge, ze) {
    var Ne = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, Ve = Ne.source, qe = Ve === void 0 ? "keyboard" : Ve;
    Bt(ze), l && a === "combobox" && Ge !== null && qe === "keyboard" && Rt(String(Ge));
  }, [l, a]), et = function(ze, Ne, Ve) {
    var qe = function() {
      var Ct, St = Qe(ze);
      return [me ? {
        label: St == null ? void 0 : St[Re.label],
        value: ze,
        key: (Ct = St == null ? void 0 : St.key) !== null && Ct !== void 0 ? Ct : ze
      } : ze, injectPropsWithOption(St)];
    };
    if (Ne && $) {
      var nt = qe(), Pt = _slicedToArray(nt, 2), Mt = Pt[0], Ft = Pt[1];
      $(Mt, Ft);
    } else if (!Ne && Y && Ve !== "clear") {
      var Ke = qe(), Ye = _slicedToArray(Ke, 2), ot = Ye[0], yt = Ye[1];
      Y(ot, yt);
    }
  }, Tt = useRefFunc(function(Ge, ze) {
    var Ne, Ve = Ee ? ze.selected : !0;
    Ve ? Ne = Ee ? [].concat(_toConsumableArray(Be), [Ge]) : [Ge] : Ne = Be.filter(function(qe) {
      return qe.value !== Ge;
    }), gt(Ne), et(Ge, Ve), a === "combobox" ? Rt("") : (!isMultiple || U) && (Te(""), Rt(""));
  }), Et = function(ze, Ne) {
    gt(ze);
    var Ve = Ne.type, qe = Ne.values;
    (Ve === "remove" || Ve === "clear") && qe.forEach(function(nt) {
      et(nt.value, !1, Ve);
    });
  }, dt = function(ze, Ne) {
    if (Te(ze), Rt(null), Ne.source === "submit") {
      var Ve = (ze || "").trim();
      if (Ve) {
        var qe = Array.from(new Set([].concat(_toConsumableArray(rt), [Ve])));
        gt(qe), et(Ve, !0), Te("");
      }
      return;
    }
    Ne.source !== "blur" && (a === "combobox" && gt(ze), Z == null || Z(ze));
  }, zt = function(ze) {
    var Ne = ze;
    a !== "tags" && (Ne = ze.map(function(qe) {
      var nt = ye.get(qe);
      return nt == null ? void 0 : nt.value;
    }).filter(function(qe) {
      return qe !== void 0;
    }));
    var Ve = Array.from(new Set([].concat(_toConsumableArray(rt), _toConsumableArray(Ne))));
    gt(Ve), Ve.forEach(function(qe) {
      et(qe, !0);
    });
  }, Lt = React.useMemo(function() {
    var Ge = le !== !1 && W !== !1;
    return _objectSpread2(_objectSpread2({}, be), {}, {
      flattenOptions: bt,
      onActiveValue: pt,
      defaultActiveFirstOption: It,
      onSelect: Tt,
      menuItemSelectedIcon: ue,
      rawValues: rt,
      fieldNames: Re,
      virtual: Ge,
      direction: oe,
      listHeight: fe,
      listItemHeight: se,
      childrenAsData: Ce,
      maxCount: ge,
      optionRender: ne
    });
  }, [ge, be, bt, pt, It, Tt, ue, rt, Re, le, W, oe, fe, se, Ce, ne]);
  return process.env.NODE_ENV !== "production" && (warningProps(t), warningNullOptions(Ae, Re)), /* @__PURE__ */ React.createElement(SelectContext.Provider, {
    value: Lt
  }, /* @__PURE__ */ React.createElement(BaseSelect, _extends({}, Se, {
    // >>> MISC
    id: xe,
    prefixCls: o,
    ref: r,
    omitDomProps: OMIT_DOM_PROPS,
    mode: a,
    displayValues: Xe,
    onDisplayValuesChange: Et,
    direction: oe,
    searchValue: we,
    onSearch: dt,
    autoClearSearchValue: U,
    onSearchSplit: zt,
    dropdownMatchSelectWidth: W,
    OptionList: RefOptionList,
    emptyOptions: !bt.length,
    activeValue: jt,
    activeDescendantId: "".concat(xe, "_list_").concat(Wt)
  })));
});
process.env.NODE_ENV !== "production" && (Select$1.displayName = "Select");
var TypedSelect = Select$1;
TypedSelect.Option = Option;
TypedSelect.OptGroup = OptGroup;
var omit$1 = {}, hasRequiredOmit;
function requireOmit() {
  if (hasRequiredOmit) return omit$1;
  hasRequiredOmit = 1, Object.defineProperty(omit$1, "__esModule", {
    value: !0
  }), omit$1.default = t;
  function t(r, n) {
    var a = Object.assign({}, r);
    return Array.isArray(n) && n.forEach(function(s) {
      delete a[s];
    }), a;
  }
  return omit$1;
}
var omitExports = requireOmit();
const omit = /* @__PURE__ */ getDefaultExportFromCjs(omitExports);
function easeInOutQuad(t, r, n, a) {
  return (t /= a / 2) < 1 ? n / 2 * t * t * t * t + r : -n / 2 * ((t -= 2) * t * t * t - 2) + r;
}
function animate(t, r, n, a, s, o = {}) {
  const { duration: l = 300 } = o;
  let c, x;
  const j = (Z) => {
    if (c === void 0 && (c = Z), Z - c < l) {
      x = requestAnimationFrame(j);
      const V = easeInOutQuad(Z - c, t, r - t, l);
      n(V);
    } else
      n(r), a == null || a(r);
  };
  return x = requestAnimationFrame(j), () => {
    cancelAnimationFrame(x);
  };
}
function autoHeight(t) {
  t.style.height = "auto", t.style.height = `${t.scrollHeight}px`;
}
function hasValue(t) {
  return Array.isArray(t) ? t.length !== 0 : t != null && t !== "null";
}
function mergeRefs(...t) {
  return (r) => {
    for (const n of t)
      n && setRefValue(n, r);
  };
}
function setRefValue(t, r) {
  t && (typeof t == "function" ? t(r) : t.current = r);
}
function renderNode(t, r = "p", n) {
  const a = r;
  return ["string", "number", "boolean"].includes(typeof t) ? /* @__PURE__ */ jsx(a, { className: n, title: t == null ? void 0 : t.toString(), children: t }) : isValidElement(t) ? cloneElement(t, {
    className: clsx(t.props.className, n)
  }) : null;
}
const ru = {
  common: {
    yes: "Да",
    no: "Нет"
  },
  calendar: {
    locale: ru$1,
    values: {
      hour: "час",
      minuteShort: "мин."
    }
  },
  input: {
    values: {
      clear: "Очистить"
    }
  },
  datePicker: {
    values: {
      apply: "Применить",
      cancel: "Сбросить"
    }
  },
  tableMenu: {
    values: {
      sortAsc: "Сортировать по возрастанию",
      sortDesc: "Сортировать по убыванию",
      clearSorting: "Сбросить сортировку",
      hideColumn: "Скрыть столбец",
      tableSettings: "Настройка таблицы",
      pinLeft: "Закрепить слева",
      pinRight: "Закрепить справа",
      unpin: "Открепить",
      filter: "Добавить фильтр",
      inputPlaceholder: "Текст"
    },
    filter: {
      operators: {
        isAnyOf: "любой",
        isNotEmpty: "задано",
        isEmpty: "не задано",
        endsWith: "заканчивается на",
        startsWith: "начинается с",
        equals: "равно",
        contains: "содержит",
        is: "равно",
        not: "не",
        after: "после",
        onOrAfter: "с выбранной и позже",
        before: "до",
        onOrBefore: "до выбранной включительно"
      },
      clearAll: "Удалить все фильтры",
      clearAllForColumn: "Удалить фильтры для колонки"
    }
  },
  stringList: {
    values: {
      add: "Добавить",
      addAll: "Добавить все",
      addSomething: "Введите значение"
    }
  },
  noResultOverlay: {
    values: {
      overlayText: "Данные для выбранных фильтров отсутствуют. Попробуйте установить другие фильтры"
    }
  },
  noRowsOverlay: {
    values: {
      overlayText: "Данные отсутствуют"
    }
  }
}, en = {
  common: {
    yes: "Yes",
    no: "No"
  },
  calendar: {
    locale: enUS,
    values: {
      hour: "hour",
      minuteShort: "min."
    }
  },
  input: {
    values: {
      clear: "Clear"
    }
  },
  datePicker: {
    values: {
      apply: "Apply",
      cancel: "Cancel"
    }
  },
  tableMenu: {
    values: {
      sortAsc: "Sort ascending",
      sortDesc: "Sort descending",
      clearSorting: "Clear sorting",
      hideColumn: "Hide column",
      tableSettings: "Manage table",
      pinLeft: "Pin to the left",
      pinRight: "Pin to the right",
      unpin: "Unpin",
      filter: " Add Filter",
      inputPlaceholder: "Text"
    },
    filter: {
      operators: {
        isAnyOf: "is any of",
        isNotEmpty: "is not empty",
        isEmpty: "is empty",
        endsWith: "ends with",
        startsWith: "starts with",
        equals: "equals",
        contains: "contains",
        is: "is",
        not: "not",
        after: "after",
        onOrAfter: "on or after",
        before: "before",
        onOrBefore: "on or before"
      },
      clearAll: "Clear all filters",
      clearAllForColumn: "Clear all filters for current column"
    }
  },
  stringList: {
    values: {
      add: "Add",
      addAll: "Add all",
      addSomething: "Enter value"
    }
  },
  noResultOverlay: {
    values: {
      overlayText: "There is no data available for the selected filters. Try setting other filters."
    }
  },
  noRowsOverlay: {
    values: {
      overlayText: "No data"
    }
  }
}, DEFAULT_GLOBAL_CONFIG = {
  theme: "dark",
  style: void 0,
  size: "m",
  localization: ru
}, ConfigContext = createContext(DEFAULT_GLOBAL_CONFIG), ConfigProvider = ({ children: t, config: r, externalElement: n }) => {
  const a = { ...DEFAULT_GLOBAL_CONFIG, ...r, rootElement: n };
  return useLayoutEffect$3(() => (n && (a.theme === "dark" && n.classList.add("go-theme_dark"), a.theme === "light" && n.classList.add("go-theme_light"), a.style === "bordered" && n.classList.add("go-style_bordered")), () => {
    n && (n.classList.remove("go-theme_dark"), n.classList.remove("go-theme_light"), n.classList.remove("go-style_bordered"));
  }), [a.theme, a.style, n]), n ? /* @__PURE__ */ jsx(ConfigContext.Consumer, { children: (s) => /* @__PURE__ */ jsx(ConfigContext.Provider, { value: { ...s, ...a }, children: t }) }) : /* @__PURE__ */ jsx(ConfigContext.Consumer, { children: (s) => /* @__PURE__ */ jsx(ConfigContext.Provider, { value: { ...s, ...a }, children: /* @__PURE__ */ jsx(
    "div",
    {
      className: clsx(
        a.theme === "dark" && "go-theme_dark",
        a.theme === "light" && "go-theme_light",
        a.style === "bordered" && "go-style_bordered"
      ),
      children: t
    }
  ) }) });
};
function isValidSize(t) {
  return typeof t == "string" && ["s", "m"].includes(t);
}
function useGlobalComponentConfig(t) {
  const r = useContext(ConfigContext), n = t && isValidSize(t.size) ? t.size : null;
  return {
    ...r,
    size: n || r.size || DEFAULT_GLOBAL_CONFIG.size || "m"
  };
}
var extendStatics$1 = function(t, r) {
  return (extendStatics$1 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, a) {
    n.__proto__ = a;
  } || function(n, a) {
    for (var s in a) Object.prototype.hasOwnProperty.call(a, s) && (n[s] = a[s]);
  })(t, r);
};
function __extends$1(t, r) {
  if (typeof r != "function" && r !== null) throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
  function n() {
    this.constructor = t;
  }
  extendStatics$1(t, r), t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
}
var __assign$1 = function() {
  return (__assign$1 = Object.assign || function(t) {
    for (var r, n = 1, a = arguments.length; n < a; n++) for (var s in r = arguments[n]) Object.prototype.hasOwnProperty.call(r, s) && (t[s] = r[s]);
    return t;
  }).apply(this, arguments);
};
function __awaiter(t, r, n, a) {
  return new (n || (n = Promise))((function(s, o) {
    function l(j) {
      try {
        x(a.next(j));
      } catch (Z) {
        o(Z);
      }
    }
    function c(j) {
      try {
        x(a.throw(j));
      } catch (Z) {
        o(Z);
      }
    }
    function x(j) {
      var Z;
      j.done ? s(j.value) : (Z = j.value, Z instanceof n ? Z : new n((function(V) {
        V(Z);
      }))).then(l, c);
    }
    x((a = a.apply(t, [])).next());
  }));
}
function __generator(t, r) {
  var n, a, s, o, l = { label: 0, sent: function() {
    if (1 & s[0]) throw s[1];
    return s[1];
  }, trys: [], ops: [] };
  return o = { next: c(0), throw: c(1), return: c(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function c(x) {
    return function(j) {
      return (function(Z) {
        if (n) throw new TypeError("Generator is already executing.");
        for (; l; ) try {
          if (n = 1, a && (s = 2 & Z[0] ? a.return : Z[0] ? a.throw || ((s = a.return) && s.call(a), 0) : a.next) && !(s = s.call(a, Z[1])).done) return s;
          switch (a = 0, s && (Z = [2 & Z[0], s.value]), Z[0]) {
            case 0:
            case 1:
              s = Z;
              break;
            case 4:
              return l.label++, { value: Z[1], done: !1 };
            case 5:
              l.label++, a = Z[1], Z = [0];
              continue;
            case 7:
              Z = l.ops.pop(), l.trys.pop();
              continue;
            default:
              if (s = l.trys, !((s = s.length > 0 && s[s.length - 1]) || Z[0] !== 6 && Z[0] !== 2)) {
                l = 0;
                continue;
              }
              if (Z[0] === 3 && (!s || Z[1] > s[0] && Z[1] < s[3])) {
                l.label = Z[1];
                break;
              }
              if (Z[0] === 6 && l.label < s[1]) {
                l.label = s[1], s = Z;
                break;
              }
              if (s && l.label < s[2]) {
                l.label = s[2], l.ops.push(Z);
                break;
              }
              s[2] && l.ops.pop(), l.trys.pop();
              continue;
          }
          Z = r.call(t, l);
        } catch (V) {
          Z = [6, V], a = 0;
        } finally {
          n = s = 0;
        }
        if (5 & Z[0]) throw Z[1];
        return { value: Z[0] ? Z[1] : void 0, done: !0 };
      })([x, j]);
    };
  }
}
function createCommonjsModule(t, r) {
  return t(r = { exports: {} }, r.exports), r.exports;
}
var lottie = createCommonjsModule((function(module, exports$1) {
  typeof navigator != "undefined" && (function(t, r) {
    module.exports = r();
  })(0, (function() {
    var svgNS = "http://www.w3.org/2000/svg", locationHref = "", _useWebWorker = !1, initialDefaultFrame = -999999, setWebWorker = function(t) {
      _useWebWorker = !!t;
    }, getWebWorker = function() {
      return _useWebWorker;
    }, setLocationHref = function(t) {
      locationHref = t;
    }, getLocationHref = function() {
      return locationHref;
    };
    function createTag(t) {
      return document.createElement(t);
    }
    function extendPrototype(t, r) {
      var n, a, s = t.length;
      for (n = 0; n < s; n += 1) for (var o in a = t[n].prototype) Object.prototype.hasOwnProperty.call(a, o) && (r.prototype[o] = a[o]);
    }
    function getDescriptor(t, r) {
      return Object.getOwnPropertyDescriptor(t, r);
    }
    function createProxyFunction(t) {
      function r() {
      }
      return r.prototype = t, r;
    }
    var audioControllerFactory = (function() {
      function t(r) {
        this.audios = [], this.audioFactory = r, this._volume = 1, this._isMuted = !1;
      }
      return t.prototype = { addAudio: function(r) {
        this.audios.push(r);
      }, pause: function() {
        var r, n = this.audios.length;
        for (r = 0; r < n; r += 1) this.audios[r].pause();
      }, resume: function() {
        var r, n = this.audios.length;
        for (r = 0; r < n; r += 1) this.audios[r].resume();
      }, setRate: function(r) {
        var n, a = this.audios.length;
        for (n = 0; n < a; n += 1) this.audios[n].setRate(r);
      }, createAudio: function(r) {
        return this.audioFactory ? this.audioFactory(r) : window.Howl ? new window.Howl({ src: [r] }) : { isPlaying: !1, play: function() {
          this.isPlaying = !0;
        }, seek: function() {
          this.isPlaying = !1;
        }, playing: function() {
        }, rate: function() {
        }, setVolume: function() {
        } };
      }, setAudioFactory: function(r) {
        this.audioFactory = r;
      }, setVolume: function(r) {
        this._volume = r, this._updateVolume();
      }, mute: function() {
        this._isMuted = !0, this._updateVolume();
      }, unmute: function() {
        this._isMuted = !1, this._updateVolume();
      }, getVolume: function() {
        return this._volume;
      }, _updateVolume: function() {
        var r, n = this.audios.length;
        for (r = 0; r < n; r += 1) this.audios[r].volume(this._volume * (this._isMuted ? 0 : 1));
      } }, function() {
        return new t();
      };
    })(), createTypedArray = /* @__PURE__ */ (function() {
      function t(r, n) {
        var a, s = 0, o = [];
        switch (r) {
          case "int16":
          case "uint8c":
            a = 1;
            break;
          default:
            a = 1.1;
        }
        for (s = 0; s < n; s += 1) o.push(a);
        return o;
      }
      return typeof Uint8ClampedArray == "function" && typeof Float32Array == "function" ? function(r, n) {
        return r === "float32" ? new Float32Array(n) : r === "int16" ? new Int16Array(n) : r === "uint8c" ? new Uint8ClampedArray(n) : t(r, n);
      } : t;
    })();
    function createSizedArray(t) {
      return Array.apply(null, { length: t });
    }
    function _typeof$6(t) {
      return (_typeof$6 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
        return typeof r;
      } : function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      })(t);
    }
    var subframeEnabled = !0, expressionsPlugin = null, expressionsInterfaces = null, idPrefix$1 = "", isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent), bmPow = Math.pow, bmSqrt = Math.sqrt, bmFloor = Math.floor, bmMax = Math.max, bmMin = Math.min, BMMath = {};
    (function() {
      var t, r = ["abs", "acos", "acosh", "asin", "asinh", "atan", "atanh", "atan2", "ceil", "cbrt", "expm1", "clz32", "cos", "cosh", "exp", "floor", "fround", "hypot", "imul", "log", "log1p", "log2", "log10", "max", "min", "pow", "random", "round", "sign", "sin", "sinh", "sqrt", "tan", "tanh", "trunc", "E", "LN10", "LN2", "LOG10E", "LOG2E", "PI", "SQRT1_2", "SQRT2"], n = r.length;
      for (t = 0; t < n; t += 1) BMMath[r[t]] = Math[r[t]];
    })(), BMMath.random = Math.random, BMMath.abs = function(t) {
      if (_typeof$6(t) === "object" && t.length) {
        var r, n = createSizedArray(t.length), a = t.length;
        for (r = 0; r < a; r += 1) n[r] = Math.abs(t[r]);
        return n;
      }
      return Math.abs(t);
    };
    var defaultCurveSegments = 150, degToRads = Math.PI / 180, roundCorner = 0.5519;
    function styleDiv(t) {
      t.style.position = "absolute", t.style.top = 0, t.style.left = 0, t.style.display = "block", t.style.transformOrigin = "0 0", t.style.webkitTransformOrigin = "0 0", t.style.backfaceVisibility = "visible", t.style.webkitBackfaceVisibility = "visible", t.style.transformStyle = "preserve-3d", t.style.webkitTransformStyle = "preserve-3d", t.style.mozTransformStyle = "preserve-3d";
    }
    function BMEnterFrameEvent(t, r, n, a) {
      this.type = t, this.currentTime = r, this.totalTime = n, this.direction = a < 0 ? -1 : 1;
    }
    function BMCompleteEvent(t, r) {
      this.type = t, this.direction = r < 0 ? -1 : 1;
    }
    function BMCompleteLoopEvent(t, r, n, a) {
      this.type = t, this.currentLoop = n, this.totalLoops = r, this.direction = a < 0 ? -1 : 1;
    }
    function BMSegmentStartEvent(t, r, n) {
      this.type = t, this.firstFrame = r, this.totalFrames = n;
    }
    function BMDestroyEvent(t, r) {
      this.type = t, this.target = r;
    }
    function BMRenderFrameErrorEvent(t, r) {
      this.type = "renderFrameError", this.nativeError = t, this.currentTime = r;
    }
    function BMConfigErrorEvent(t) {
      this.type = "configError", this.nativeError = t;
    }
    var createElementID = (_count = 0, function() {
      return idPrefix$1 + "__lottie_element_" + (_count += 1);
    }), _count;
    function HSVtoRGB(t, r, n) {
      var a, s, o, l, c, x, j, Z;
      switch (x = n * (1 - r), j = n * (1 - (c = 6 * t - (l = Math.floor(6 * t))) * r), Z = n * (1 - (1 - c) * r), l % 6) {
        case 0:
          a = n, s = Z, o = x;
          break;
        case 1:
          a = j, s = n, o = x;
          break;
        case 2:
          a = x, s = n, o = Z;
          break;
        case 3:
          a = x, s = j, o = n;
          break;
        case 4:
          a = Z, s = x, o = n;
          break;
        case 5:
          a = n, s = x, o = j;
      }
      return [a, s, o];
    }
    function RGBtoHSV(t, r, n) {
      var a, s = Math.max(t, r, n), o = Math.min(t, r, n), l = s - o, c = s === 0 ? 0 : l / s, x = s / 255;
      switch (s) {
        case o:
          a = 0;
          break;
        case t:
          a = r - n + l * (r < n ? 6 : 0), a /= 6 * l;
          break;
        case r:
          a = n - t + 2 * l, a /= 6 * l;
          break;
        case n:
          a = t - r + 4 * l, a /= 6 * l;
      }
      return [a, c, x];
    }
    function addSaturationToRGB(t, r) {
      var n = RGBtoHSV(255 * t[0], 255 * t[1], 255 * t[2]);
      return n[1] += r, n[1] > 1 ? n[1] = 1 : n[1] <= 0 && (n[1] = 0), HSVtoRGB(n[0], n[1], n[2]);
    }
    function addBrightnessToRGB(t, r) {
      var n = RGBtoHSV(255 * t[0], 255 * t[1], 255 * t[2]);
      return n[2] += r, n[2] > 1 ? n[2] = 1 : n[2] < 0 && (n[2] = 0), HSVtoRGB(n[0], n[1], n[2]);
    }
    function addHueToRGB(t, r) {
      var n = RGBtoHSV(255 * t[0], 255 * t[1], 255 * t[2]);
      return n[0] += r / 360, n[0] > 1 ? n[0] -= 1 : n[0] < 0 && (n[0] += 1), HSVtoRGB(n[0], n[1], n[2]);
    }
    var rgbToHex = (function() {
      var t, r, n = [];
      for (t = 0; t < 256; t += 1) r = t.toString(16), n[t] = r.length === 1 ? "0" + r : r;
      return function(a, s, o) {
        return a < 0 && (a = 0), s < 0 && (s = 0), o < 0 && (o = 0), "#" + n[a] + n[s] + n[o];
      };
    })(), setSubframeEnabled = function(t) {
      subframeEnabled = !!t;
    }, getSubframeEnabled = function() {
      return subframeEnabled;
    }, setExpressionsPlugin = function(t) {
      expressionsPlugin = t;
    }, getExpressionsPlugin = function() {
      return expressionsPlugin;
    }, setExpressionInterfaces = function(t) {
      expressionsInterfaces = t;
    }, getExpressionInterfaces = function() {
      return expressionsInterfaces;
    }, setDefaultCurveSegments = function(t) {
      defaultCurveSegments = t;
    }, getDefaultCurveSegments = function() {
      return defaultCurveSegments;
    }, setIdPrefix = function(t) {
      idPrefix$1 = t;
    };
    function createNS(t) {
      return document.createElementNS(svgNS, t);
    }
    function _typeof$5(t) {
      return (_typeof$5 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
        return typeof r;
      } : function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      })(t);
    }
    var dataManager = /* @__PURE__ */ (function() {
      var t, r, n = 1, a = [], s = { onmessage: function() {
      }, postMessage: function(x) {
        t({ data: x });
      } }, o = { postMessage: function(x) {
        s.onmessage({ data: x });
      } };
      function l() {
        r || ((r = (function(x) {
          if (window.Worker && window.Blob && getWebWorker()) {
            var j = new Blob(["var _workerSelf = self; self.onmessage = ", x.toString()], { type: "text/javascript" }), Z = URL.createObjectURL(j);
            return new Worker(Z);
          }
          return t = x, s;
        })((function(x) {
          if (o.dataManager || (o.dataManager = (function() {
            function Z(re, ie) {
              var ue, le, oe, he, fe, ce, se = re.length;
              for (le = 0; le < se; le += 1) if ("ks" in (ue = re[le]) && !ue.completed) {
                if (ue.completed = !0, ue.hasMask) {
                  var pe = ue.masksProperties;
                  for (he = pe.length, oe = 0; oe < he; oe += 1) if (pe[oe].pt.k.i) $(pe[oe].pt.k);
                  else for (ce = pe[oe].pt.k.length, fe = 0; fe < ce; fe += 1) pe[oe].pt.k[fe].s && $(pe[oe].pt.k[fe].s[0]), pe[oe].pt.k[fe].e && $(pe[oe].pt.k[fe].e[0]);
                }
                ue.ty === 0 ? (ue.layers = V(ue.refId, ie), Z(ue.layers, ie)) : ue.ty === 4 ? U(ue.shapes) : ue.ty === 5 && te(ue);
              }
            }
            function V(re, ie) {
              var ue = (function(le, oe) {
                for (var he = 0, fe = oe.length; he < fe; ) {
                  if (oe[he].id === le) return oe[he];
                  he += 1;
                }
                return null;
              })(re, ie);
              return ue ? ue.layers.__used ? JSON.parse(JSON.stringify(ue.layers)) : (ue.layers.__used = !0, ue.layers) : null;
            }
            function U(re) {
              var ie, ue, le;
              for (ie = re.length - 1; ie >= 0; ie -= 1) if (re[ie].ty === "sh") if (re[ie].ks.k.i) $(re[ie].ks.k);
              else for (le = re[ie].ks.k.length, ue = 0; ue < le; ue += 1) re[ie].ks.k[ue].s && $(re[ie].ks.k[ue].s[0]), re[ie].ks.k[ue].e && $(re[ie].ks.k[ue].e[0]);
              else re[ie].ty === "gr" && U(re[ie].it);
            }
            function $(re) {
              var ie, ue = re.i.length;
              for (ie = 0; ie < ue; ie += 1) re.i[ie][0] += re.v[ie][0], re.i[ie][1] += re.v[ie][1], re.o[ie][0] += re.v[ie][0], re.o[ie][1] += re.v[ie][1];
            }
            function Y(re, ie) {
              var ue = ie ? ie.split(".") : [100, 100, 100];
              return re[0] > ue[0] || !(ue[0] > re[0]) && (re[1] > ue[1] || !(ue[1] > re[1]) && (re[2] > ue[2] || !(ue[2] > re[2]) && null));
            }
            var G, W = /* @__PURE__ */ (function() {
              var re = [4, 4, 14];
              function ie(ue) {
                var le, oe, he, fe = ue.length;
                for (le = 0; le < fe; le += 1) ue[le].ty === 5 && (oe = ue[le], he = void 0, he = oe.t.d, oe.t.d = { k: [{ s: he, t: 0 }] });
              }
              return function(ue) {
                if (Y(re, ue.v) && (ie(ue.layers), ue.assets)) {
                  var le, oe = ue.assets.length;
                  for (le = 0; le < oe; le += 1) ue.assets[le].layers && ie(ue.assets[le].layers);
                }
              };
            })(), X = (G = [4, 7, 99], function(re) {
              if (re.chars && !Y(G, re.v)) {
                var ie, ue = re.chars.length;
                for (ie = 0; ie < ue; ie += 1) {
                  var le = re.chars[ie];
                  le.data && le.data.shapes && (U(le.data.shapes), le.data.ip = 0, le.data.op = 99999, le.data.st = 0, le.data.sr = 1, le.data.ks = { p: { k: [0, 0], a: 0 }, s: { k: [100, 100], a: 0 }, a: { k: [0, 0], a: 0 }, r: { k: 0, a: 0 }, o: { k: 100, a: 0 } }, re.chars[ie].t || (le.data.shapes.push({ ty: "no" }), le.data.shapes[0].it.push({ p: { k: [0, 0], a: 0 }, s: { k: [100, 100], a: 0 }, a: { k: [0, 0], a: 0 }, r: { k: 0, a: 0 }, o: { k: 100, a: 0 }, sk: { k: 0, a: 0 }, sa: { k: 0, a: 0 }, ty: "tr" })));
                }
              }
            }), K = /* @__PURE__ */ (function() {
              var re = [5, 7, 15];
              function ie(ue) {
                var le, oe, he, fe = ue.length;
                for (le = 0; le < fe; le += 1) ue[le].ty === 5 && (oe = ue[le], he = void 0, typeof (he = oe.t.p).a == "number" && (he.a = { a: 0, k: he.a }), typeof he.p == "number" && (he.p = { a: 0, k: he.p }), typeof he.r == "number" && (he.r = { a: 0, k: he.r }));
              }
              return function(ue) {
                if (Y(re, ue.v) && (ie(ue.layers), ue.assets)) {
                  var le, oe = ue.assets.length;
                  for (le = 0; le < oe; le += 1) ue.assets[le].layers && ie(ue.assets[le].layers);
                }
              };
            })(), J = /* @__PURE__ */ (function() {
              var re = [4, 1, 9];
              function ie(le) {
                var oe, he, fe, ce = le.length;
                for (oe = 0; oe < ce; oe += 1) if (le[oe].ty === "gr") ie(le[oe].it);
                else if (le[oe].ty === "fl" || le[oe].ty === "st") if (le[oe].c.k && le[oe].c.k[0].i) for (fe = le[oe].c.k.length, he = 0; he < fe; he += 1) le[oe].c.k[he].s && (le[oe].c.k[he].s[0] /= 255, le[oe].c.k[he].s[1] /= 255, le[oe].c.k[he].s[2] /= 255, le[oe].c.k[he].s[3] /= 255), le[oe].c.k[he].e && (le[oe].c.k[he].e[0] /= 255, le[oe].c.k[he].e[1] /= 255, le[oe].c.k[he].e[2] /= 255, le[oe].c.k[he].e[3] /= 255);
                else le[oe].c.k[0] /= 255, le[oe].c.k[1] /= 255, le[oe].c.k[2] /= 255, le[oe].c.k[3] /= 255;
              }
              function ue(le) {
                var oe, he = le.length;
                for (oe = 0; oe < he; oe += 1) le[oe].ty === 4 && ie(le[oe].shapes);
              }
              return function(le) {
                if (Y(re, le.v) && (ue(le.layers), le.assets)) {
                  var oe, he = le.assets.length;
                  for (oe = 0; oe < he; oe += 1) le.assets[oe].layers && ue(le.assets[oe].layers);
                }
              };
            })(), ee = /* @__PURE__ */ (function() {
              var re = [4, 4, 18];
              function ie(le) {
                var oe, he, fe;
                for (oe = le.length - 1; oe >= 0; oe -= 1) if (le[oe].ty === "sh") if (le[oe].ks.k.i) le[oe].ks.k.c = le[oe].closed;
                else for (fe = le[oe].ks.k.length, he = 0; he < fe; he += 1) le[oe].ks.k[he].s && (le[oe].ks.k[he].s[0].c = le[oe].closed), le[oe].ks.k[he].e && (le[oe].ks.k[he].e[0].c = le[oe].closed);
                else le[oe].ty === "gr" && ie(le[oe].it);
              }
              function ue(le) {
                var oe, he, fe, ce, se, pe, ve = le.length;
                for (he = 0; he < ve; he += 1) {
                  if ((oe = le[he]).hasMask) {
                    var ae = oe.masksProperties;
                    for (ce = ae.length, fe = 0; fe < ce; fe += 1) if (ae[fe].pt.k.i) ae[fe].pt.k.c = ae[fe].cl;
                    else for (pe = ae[fe].pt.k.length, se = 0; se < pe; se += 1) ae[fe].pt.k[se].s && (ae[fe].pt.k[se].s[0].c = ae[fe].cl), ae[fe].pt.k[se].e && (ae[fe].pt.k[se].e[0].c = ae[fe].cl);
                  }
                  oe.ty === 4 && ie(oe.shapes);
                }
              }
              return function(le) {
                if (Y(re, le.v) && (ue(le.layers), le.assets)) {
                  var oe, he = le.assets.length;
                  for (oe = 0; oe < he; oe += 1) le.assets[oe].layers && ue(le.assets[oe].layers);
                }
              };
            })();
            function te(re) {
              re.t.a.length === 0 && re.t.p;
            }
            var ne = { completeData: function(re) {
              re.__complete || (J(re), W(re), X(re), K(re), ee(re), Z(re.layers, re.assets), (function(ie, ue) {
                if (ie) {
                  var le = 0, oe = ie.length;
                  for (le = 0; le < oe; le += 1) ie[le].t === 1 && (ie[le].data.layers = V(ie[le].data.refId, ue), Z(ie[le].data.layers, ue));
                }
              })(re.chars, re.assets), re.__complete = !0);
            } };
            return ne.checkColors = J, ne.checkChars = X, ne.checkPathProperties = K, ne.checkShapes = ee, ne.completeLayers = Z, ne;
          })()), o.assetLoader || (o.assetLoader = /* @__PURE__ */ (function() {
            function Z(V) {
              var U = V.getResponseHeader("content-type");
              return U && V.responseType === "json" && U.indexOf("json") !== -1 || V.response && _typeof$5(V.response) === "object" ? V.response : V.response && typeof V.response == "string" ? JSON.parse(V.response) : V.responseText ? JSON.parse(V.responseText) : null;
            }
            return { load: function(V, U, $, Y) {
              var G, W = new XMLHttpRequest();
              try {
                W.responseType = "json";
              } catch {
              }
              W.onreadystatechange = function() {
                if (W.readyState === 4) if (W.status === 200) G = Z(W), $(G);
                else try {
                  G = Z(W), $(G);
                } catch (X) {
                  Y && Y(X);
                }
              };
              try {
                W.open(["G", "E", "T"].join(""), V, !0);
              } catch {
                W.open(["G", "E", "T"].join(""), U + "/" + V, !0);
              }
              W.send();
            } };
          })()), x.data.type === "loadAnimation") o.assetLoader.load(x.data.path, x.data.fullPath, (function(Z) {
            o.dataManager.completeData(Z), o.postMessage({ id: x.data.id, payload: Z, status: "success" });
          }), (function() {
            o.postMessage({ id: x.data.id, status: "error" });
          }));
          else if (x.data.type === "complete") {
            var j = x.data.animation;
            o.dataManager.completeData(j), o.postMessage({ id: x.data.id, payload: j, status: "success" });
          } else x.data.type === "loadData" && o.assetLoader.load(x.data.path, x.data.fullPath, (function(Z) {
            o.postMessage({ id: x.data.id, payload: Z, status: "success" });
          }), (function() {
            o.postMessage({ id: x.data.id, status: "error" });
          }));
        }))).onmessage = function(x) {
          var j = x.data, Z = j.id, V = a[Z];
          a[Z] = null, j.status === "success" ? V.onComplete(j.payload) : V.onError && V.onError();
        });
      }
      function c(x, j) {
        var Z = "processId_" + (n += 1);
        return a[Z] = { onComplete: x, onError: j }, Z;
      }
      return { loadAnimation: function(x, j, Z) {
        l();
        var V = c(j, Z);
        r.postMessage({ type: "loadAnimation", path: x, fullPath: window.location.origin + window.location.pathname, id: V });
      }, loadData: function(x, j, Z) {
        l();
        var V = c(j, Z);
        r.postMessage({ type: "loadData", path: x, fullPath: window.location.origin + window.location.pathname, id: V });
      }, completeAnimation: function(x, j, Z) {
        l();
        var V = c(j, Z);
        r.postMessage({ type: "complete", animation: x, id: V });
      } };
    })(), ImagePreloader = (function() {
      var t = (function() {
        var c = createTag("canvas");
        c.width = 1, c.height = 1;
        var x = c.getContext("2d");
        return x.fillStyle = "rgba(0,0,0,0)", x.fillRect(0, 0, 1, 1), c;
      })();
      function r() {
        this.loadedAssets += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
      }
      function n() {
        this.loadedFootagesCount += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
      }
      function a(c, x, j) {
        var Z = "";
        if (c.e) Z = c.p;
        else if (x) {
          var V = c.p;
          V.indexOf("images/") !== -1 && (V = V.split("/")[1]), Z = x + V;
        } else Z = j, Z += c.u ? c.u : "", Z += c.p;
        return Z;
      }
      function s(c) {
        var x = 0, j = setInterval(function() {
          (c.getBBox().width || x > 500) && (this._imageLoaded(), clearInterval(j)), x += 1;
        }.bind(this), 50);
      }
      function o(c) {
        var x = { assetData: c }, j = a(c, this.assetsPath, this.path);
        return dataManager.loadData(j, function(Z) {
          x.img = Z, this._footageLoaded();
        }.bind(this), function() {
          x.img = {}, this._footageLoaded();
        }.bind(this)), x;
      }
      function l() {
        this._imageLoaded = r.bind(this), this._footageLoaded = n.bind(this), this.testImageLoaded = s.bind(this), this.createFootageData = o.bind(this), this.assetsPath = "", this.path = "", this.totalImages = 0, this.totalFootages = 0, this.loadedAssets = 0, this.loadedFootagesCount = 0, this.imagesLoadedCb = null, this.images = [];
      }
      return l.prototype = { loadAssets: function(c, x) {
        var j;
        this.imagesLoadedCb = x;
        var Z = c.length;
        for (j = 0; j < Z; j += 1) c[j].layers || (c[j].t && c[j].t !== "seq" ? c[j].t === 3 && (this.totalFootages += 1, this.images.push(this.createFootageData(c[j]))) : (this.totalImages += 1, this.images.push(this._createImageData(c[j]))));
      }, setAssetsPath: function(c) {
        this.assetsPath = c || "";
      }, setPath: function(c) {
        this.path = c || "";
      }, loadedImages: function() {
        return this.totalImages === this.loadedAssets;
      }, loadedFootages: function() {
        return this.totalFootages === this.loadedFootagesCount;
      }, destroy: function() {
        this.imagesLoadedCb = null, this.images.length = 0;
      }, getAsset: function(c) {
        for (var x = 0, j = this.images.length; x < j; ) {
          if (this.images[x].assetData === c) return this.images[x].img;
          x += 1;
        }
        return null;
      }, createImgData: function(c) {
        var x = a(c, this.assetsPath, this.path), j = createTag("img");
        j.crossOrigin = "anonymous", j.addEventListener("load", this._imageLoaded, !1), j.addEventListener("error", function() {
          Z.img = t, this._imageLoaded();
        }.bind(this), !1), j.src = x;
        var Z = { img: j, assetData: c };
        return Z;
      }, createImageData: function(c) {
        var x = a(c, this.assetsPath, this.path), j = createNS("image");
        isSafari ? this.testImageLoaded(j) : j.addEventListener("load", this._imageLoaded, !1), j.addEventListener("error", function() {
          Z.img = t, this._imageLoaded();
        }.bind(this), !1), j.setAttributeNS("http://www.w3.org/1999/xlink", "href", x), this._elementHelper.append ? this._elementHelper.append(j) : this._elementHelper.appendChild(j);
        var Z = { img: j, assetData: c };
        return Z;
      }, imageLoaded: r, footageLoaded: n, setCacheType: function(c, x) {
        c === "svg" ? (this._elementHelper = x, this._createImageData = this.createImageData.bind(this)) : this._createImageData = this.createImgData.bind(this);
      } }, l;
    })();
    function BaseEvent() {
    }
    BaseEvent.prototype = { triggerEvent: function(t, r) {
      if (this._cbs[t]) for (var n = this._cbs[t], a = 0; a < n.length; a += 1) n[a](r);
    }, addEventListener: function(t, r) {
      return this._cbs[t] || (this._cbs[t] = []), this._cbs[t].push(r), function() {
        this.removeEventListener(t, r);
      }.bind(this);
    }, removeEventListener: function(t, r) {
      if (r) {
        if (this._cbs[t]) {
          for (var n = 0, a = this._cbs[t].length; n < a; ) this._cbs[t][n] === r && (this._cbs[t].splice(n, 1), n -= 1, a -= 1), n += 1;
          this._cbs[t].length || (this._cbs[t] = null);
        }
      } else this._cbs[t] = null;
    } };
    var markerParser = /* @__PURE__ */ (function() {
      function t(r) {
        for (var n, a = r.split(`\r
`), s = {}, o = 0, l = 0; l < a.length; l += 1) (n = a[l].split(":")).length === 2 && (s[n[0]] = n[1].trim(), o += 1);
        if (o === 0) throw new Error();
        return s;
      }
      return function(r) {
        for (var n = [], a = 0; a < r.length; a += 1) {
          var s = r[a], o = { time: s.tm, duration: s.dr };
          try {
            o.payload = JSON.parse(r[a].cm);
          } catch {
            try {
              o.payload = t(r[a].cm);
            } catch {
              o.payload = { name: r[a].cm };
            }
          }
          n.push(o);
        }
        return n;
      };
    })(), ProjectInterface = /* @__PURE__ */ (function() {
      function t(r) {
        this.compositions.push(r);
      }
      return function() {
        function r(n) {
          for (var a = 0, s = this.compositions.length; a < s; ) {
            if (this.compositions[a].data && this.compositions[a].data.nm === n) return this.compositions[a].prepareFrame && this.compositions[a].data.xt && this.compositions[a].prepareFrame(this.currentFrame), this.compositions[a].compInterface;
            a += 1;
          }
          return null;
        }
        return r.compositions = [], r.currentFrame = 0, r.registerComposition = t, r;
      };
    })(), renderers = {}, registerRenderer = function(t, r) {
      renderers[t] = r;
    };
    function getRenderer(t) {
      return renderers[t];
    }
    function getRegisteredRenderer() {
      if (renderers.canvas) return "canvas";
      for (var t in renderers) if (renderers[t]) return t;
      return "";
    }
    function _typeof$4(t) {
      return (_typeof$4 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
        return typeof r;
      } : function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      })(t);
    }
    var AnimationItem = function() {
      this._cbs = [], this.name = "", this.path = "", this.isLoaded = !1, this.currentFrame = 0, this.currentRawFrame = 0, this.firstFrame = 0, this.totalFrames = 0, this.frameRate = 0, this.frameMult = 0, this.playSpeed = 1, this.playDirection = 1, this.playCount = 0, this.animationData = {}, this.assets = [], this.isPaused = !0, this.autoplay = !1, this.loop = !0, this.renderer = null, this.animationID = createElementID(), this.assetsPath = "", this.timeCompleted = 0, this.segmentPos = 0, this.isSubframeEnabled = getSubframeEnabled(), this.segments = [], this._idle = !0, this._completedLoop = !1, this.projectInterface = ProjectInterface(), this.imagePreloader = new ImagePreloader(), this.audioController = audioControllerFactory(), this.markers = [], this.configAnimation = this.configAnimation.bind(this), this.onSetupError = this.onSetupError.bind(this), this.onSegmentComplete = this.onSegmentComplete.bind(this), this.drawnFrameEvent = new BMEnterFrameEvent("drawnFrame", 0, 0, 0), this.expressionsPlugin = getExpressionsPlugin();
    };
    extendPrototype([BaseEvent], AnimationItem), AnimationItem.prototype.setParams = function(t) {
      (t.wrapper || t.container) && (this.wrapper = t.wrapper || t.container);
      var r = "svg";
      t.animType ? r = t.animType : t.renderer && (r = t.renderer);
      var n = getRenderer(r);
      this.renderer = new n(this, t.rendererSettings), this.imagePreloader.setCacheType(r, this.renderer.globalData.defs), this.renderer.setProjectInterface(this.projectInterface), this.animType = r, t.loop === "" || t.loop === null || t.loop === void 0 || t.loop === !0 ? this.loop = !0 : t.loop === !1 ? this.loop = !1 : this.loop = parseInt(t.loop, 10), this.autoplay = !("autoplay" in t) || t.autoplay, this.name = t.name ? t.name : "", this.autoloadSegments = !Object.prototype.hasOwnProperty.call(t, "autoloadSegments") || t.autoloadSegments, this.assetsPath = t.assetsPath, this.initialSegment = t.initialSegment, t.audioFactory && this.audioController.setAudioFactory(t.audioFactory), t.animationData ? this.setupAnimation(t.animationData) : t.path && (t.path.lastIndexOf("\\") !== -1 ? this.path = t.path.substr(0, t.path.lastIndexOf("\\") + 1) : this.path = t.path.substr(0, t.path.lastIndexOf("/") + 1), this.fileName = t.path.substr(t.path.lastIndexOf("/") + 1), this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf(".json")), dataManager.loadAnimation(t.path, this.configAnimation, this.onSetupError));
    }, AnimationItem.prototype.onSetupError = function() {
      this.trigger("data_failed");
    }, AnimationItem.prototype.setupAnimation = function(t) {
      dataManager.completeAnimation(t, this.configAnimation);
    }, AnimationItem.prototype.setData = function(t, r) {
      r && _typeof$4(r) !== "object" && (r = JSON.parse(r));
      var n = { wrapper: t, animationData: r }, a = t.attributes;
      n.path = a.getNamedItem("data-animation-path") ? a.getNamedItem("data-animation-path").value : a.getNamedItem("data-bm-path") ? a.getNamedItem("data-bm-path").value : a.getNamedItem("bm-path") ? a.getNamedItem("bm-path").value : "", n.animType = a.getNamedItem("data-anim-type") ? a.getNamedItem("data-anim-type").value : a.getNamedItem("data-bm-type") ? a.getNamedItem("data-bm-type").value : a.getNamedItem("bm-type") ? a.getNamedItem("bm-type").value : a.getNamedItem("data-bm-renderer") ? a.getNamedItem("data-bm-renderer").value : a.getNamedItem("bm-renderer") ? a.getNamedItem("bm-renderer").value : getRegisteredRenderer() || "canvas";
      var s = a.getNamedItem("data-anim-loop") ? a.getNamedItem("data-anim-loop").value : a.getNamedItem("data-bm-loop") ? a.getNamedItem("data-bm-loop").value : a.getNamedItem("bm-loop") ? a.getNamedItem("bm-loop").value : "";
      s === "false" ? n.loop = !1 : s === "true" ? n.loop = !0 : s !== "" && (n.loop = parseInt(s, 10));
      var o = a.getNamedItem("data-anim-autoplay") ? a.getNamedItem("data-anim-autoplay").value : a.getNamedItem("data-bm-autoplay") ? a.getNamedItem("data-bm-autoplay").value : !a.getNamedItem("bm-autoplay") || a.getNamedItem("bm-autoplay").value;
      n.autoplay = o !== "false", n.name = a.getNamedItem("data-name") ? a.getNamedItem("data-name").value : a.getNamedItem("data-bm-name") ? a.getNamedItem("data-bm-name").value : a.getNamedItem("bm-name") ? a.getNamedItem("bm-name").value : "", (a.getNamedItem("data-anim-prerender") ? a.getNamedItem("data-anim-prerender").value : a.getNamedItem("data-bm-prerender") ? a.getNamedItem("data-bm-prerender").value : a.getNamedItem("bm-prerender") ? a.getNamedItem("bm-prerender").value : "") === "false" && (n.prerender = !1), n.path ? this.setParams(n) : this.trigger("destroy");
    }, AnimationItem.prototype.includeLayers = function(t) {
      t.op > this.animationData.op && (this.animationData.op = t.op, this.totalFrames = Math.floor(t.op - this.animationData.ip));
      var r, n, a = this.animationData.layers, s = a.length, o = t.layers, l = o.length;
      for (n = 0; n < l; n += 1) for (r = 0; r < s; ) {
        if (a[r].id === o[n].id) {
          a[r] = o[n];
          break;
        }
        r += 1;
      }
      if ((t.chars || t.fonts) && (this.renderer.globalData.fontManager.addChars(t.chars), this.renderer.globalData.fontManager.addFonts(t.fonts, this.renderer.globalData.defs)), t.assets) for (s = t.assets.length, r = 0; r < s; r += 1) this.animationData.assets.push(t.assets[r]);
      this.animationData.__complete = !1, dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
    }, AnimationItem.prototype.onSegmentComplete = function(t) {
      this.animationData = t;
      var r = getExpressionsPlugin();
      r && r.initExpressions(this), this.loadNextSegment();
    }, AnimationItem.prototype.loadNextSegment = function() {
      var t = this.animationData.segments;
      if (!t || t.length === 0 || !this.autoloadSegments) return this.trigger("data_ready"), void (this.timeCompleted = this.totalFrames);
      var r = t.shift();
      this.timeCompleted = r.time * this.frameRate;
      var n = this.path + this.fileName + "_" + this.segmentPos + ".json";
      this.segmentPos += 1, dataManager.loadData(n, this.includeLayers.bind(this), function() {
        this.trigger("data_failed");
      }.bind(this));
    }, AnimationItem.prototype.loadSegments = function() {
      this.animationData.segments || (this.timeCompleted = this.totalFrames), this.loadNextSegment();
    }, AnimationItem.prototype.imagesLoaded = function() {
      this.trigger("loaded_images"), this.checkLoaded();
    }, AnimationItem.prototype.preloadImages = function() {
      this.imagePreloader.setAssetsPath(this.assetsPath), this.imagePreloader.setPath(this.path), this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
    }, AnimationItem.prototype.configAnimation = function(t) {
      if (this.renderer) try {
        this.animationData = t, this.initialSegment ? (this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]), this.firstFrame = Math.round(this.initialSegment[0])) : (this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip), this.firstFrame = Math.round(this.animationData.ip)), this.renderer.configAnimation(t), t.assets || (t.assets = []), this.assets = this.animationData.assets, this.frameRate = this.animationData.fr, this.frameMult = this.animationData.fr / 1e3, this.renderer.searchExtraCompositions(t.assets), this.markers = markerParser(t.markers || []), this.trigger("config_ready"), this.preloadImages(), this.loadSegments(), this.updaFrameModifier(), this.waitForFontsLoaded(), this.isPaused && this.audioController.pause();
      } catch (r) {
        this.triggerConfigError(r);
      }
    }, AnimationItem.prototype.waitForFontsLoaded = function() {
      this.renderer && (this.renderer.globalData.fontManager.isLoaded ? this.checkLoaded() : setTimeout(this.waitForFontsLoaded.bind(this), 20));
    }, AnimationItem.prototype.checkLoaded = function() {
      if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== "canvas") && this.imagePreloader.loadedFootages()) {
        this.isLoaded = !0;
        var t = getExpressionsPlugin();
        t && t.initExpressions(this), this.renderer.initItems(), setTimeout(function() {
          this.trigger("DOMLoaded");
        }.bind(this), 0), this.gotoFrame(), this.autoplay && this.play();
      }
    }, AnimationItem.prototype.resize = function(t, r) {
      var n = typeof t == "number" ? t : void 0, a = typeof r == "number" ? r : void 0;
      this.renderer.updateContainerSize(n, a);
    }, AnimationItem.prototype.setSubframe = function(t) {
      this.isSubframeEnabled = !!t;
    }, AnimationItem.prototype.gotoFrame = function() {
      this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame, this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted && (this.currentFrame = this.timeCompleted), this.trigger("enterFrame"), this.renderFrame(), this.trigger("drawnFrame");
    }, AnimationItem.prototype.renderFrame = function() {
      if (this.isLoaded !== !1 && this.renderer) try {
        this.expressionsPlugin && this.expressionsPlugin.resetFrame(), this.renderer.renderFrame(this.currentFrame + this.firstFrame);
      } catch (t) {
        this.triggerRenderFrameError(t);
      }
    }, AnimationItem.prototype.play = function(t) {
      t && this.name !== t || this.isPaused === !0 && (this.isPaused = !1, this.trigger("_play"), this.audioController.resume(), this._idle && (this._idle = !1, this.trigger("_active")));
    }, AnimationItem.prototype.pause = function(t) {
      t && this.name !== t || this.isPaused === !1 && (this.isPaused = !0, this.trigger("_pause"), this._idle = !0, this.trigger("_idle"), this.audioController.pause());
    }, AnimationItem.prototype.togglePause = function(t) {
      t && this.name !== t || (this.isPaused === !0 ? this.play() : this.pause());
    }, AnimationItem.prototype.stop = function(t) {
      t && this.name !== t || (this.pause(), this.playCount = 0, this._completedLoop = !1, this.setCurrentRawFrameValue(0));
    }, AnimationItem.prototype.getMarkerData = function(t) {
      for (var r, n = 0; n < this.markers.length; n += 1) if ((r = this.markers[n]).payload && r.payload.name === t) return r;
      return null;
    }, AnimationItem.prototype.goToAndStop = function(t, r, n) {
      if (!n || this.name === n) {
        var a = Number(t);
        if (isNaN(a)) {
          var s = this.getMarkerData(t);
          s && this.goToAndStop(s.time, !0);
        } else r ? this.setCurrentRawFrameValue(t) : this.setCurrentRawFrameValue(t * this.frameModifier);
        this.pause();
      }
    }, AnimationItem.prototype.goToAndPlay = function(t, r, n) {
      if (!n || this.name === n) {
        var a = Number(t);
        if (isNaN(a)) {
          var s = this.getMarkerData(t);
          s && (s.duration ? this.playSegments([s.time, s.time + s.duration], !0) : this.goToAndStop(s.time, !0));
        } else this.goToAndStop(a, r, n);
        this.play();
      }
    }, AnimationItem.prototype.advanceTime = function(t) {
      if (this.isPaused !== !0 && this.isLoaded !== !1) {
        var r = this.currentRawFrame + t * this.frameModifier, n = !1;
        r >= this.totalFrames - 1 && this.frameModifier > 0 ? this.loop && this.playCount !== this.loop ? r >= this.totalFrames ? (this.playCount += 1, this.checkSegments(r % this.totalFrames) || (this.setCurrentRawFrameValue(r % this.totalFrames), this._completedLoop = !0, this.trigger("loopComplete"))) : this.setCurrentRawFrameValue(r) : this.checkSegments(r > this.totalFrames ? r % this.totalFrames : 0) || (n = !0, r = this.totalFrames - 1) : r < 0 ? this.checkSegments(r % this.totalFrames) || (!this.loop || this.playCount-- <= 0 && this.loop !== !0 ? (n = !0, r = 0) : (this.setCurrentRawFrameValue(this.totalFrames + r % this.totalFrames), this._completedLoop ? this.trigger("loopComplete") : this._completedLoop = !0)) : this.setCurrentRawFrameValue(r), n && (this.setCurrentRawFrameValue(r), this.pause(), this.trigger("complete"));
      }
    }, AnimationItem.prototype.adjustSegment = function(t, r) {
      this.playCount = 0, t[1] < t[0] ? (this.frameModifier > 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(-1)), this.totalFrames = t[0] - t[1], this.timeCompleted = this.totalFrames, this.firstFrame = t[1], this.setCurrentRawFrameValue(this.totalFrames - 1e-3 - r)) : t[1] > t[0] && (this.frameModifier < 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(1)), this.totalFrames = t[1] - t[0], this.timeCompleted = this.totalFrames, this.firstFrame = t[0], this.setCurrentRawFrameValue(1e-3 + r)), this.trigger("segmentStart");
    }, AnimationItem.prototype.setSegment = function(t, r) {
      var n = -1;
      this.isPaused && (this.currentRawFrame + this.firstFrame < t ? n = t : this.currentRawFrame + this.firstFrame > r && (n = r - t)), this.firstFrame = t, this.totalFrames = r - t, this.timeCompleted = this.totalFrames, n !== -1 && this.goToAndStop(n, !0);
    }, AnimationItem.prototype.playSegments = function(t, r) {
      if (r && (this.segments.length = 0), _typeof$4(t[0]) === "object") {
        var n, a = t.length;
        for (n = 0; n < a; n += 1) this.segments.push(t[n]);
      } else this.segments.push(t);
      this.segments.length && r && this.adjustSegment(this.segments.shift(), 0), this.isPaused && this.play();
    }, AnimationItem.prototype.resetSegments = function(t) {
      this.segments.length = 0, this.segments.push([this.animationData.ip, this.animationData.op]), t && this.checkSegments(0);
    }, AnimationItem.prototype.checkSegments = function(t) {
      return !!this.segments.length && (this.adjustSegment(this.segments.shift(), t), !0);
    }, AnimationItem.prototype.destroy = function(t) {
      t && this.name !== t || !this.renderer || (this.renderer.destroy(), this.imagePreloader.destroy(), this.trigger("destroy"), this._cbs = null, this.onEnterFrame = null, this.onLoopComplete = null, this.onComplete = null, this.onSegmentStart = null, this.onDestroy = null, this.renderer = null, this.expressionsPlugin = null, this.imagePreloader = null, this.projectInterface = null);
    }, AnimationItem.prototype.setCurrentRawFrameValue = function(t) {
      this.currentRawFrame = t, this.gotoFrame();
    }, AnimationItem.prototype.setSpeed = function(t) {
      this.playSpeed = t, this.updaFrameModifier();
    }, AnimationItem.prototype.setDirection = function(t) {
      this.playDirection = t < 0 ? -1 : 1, this.updaFrameModifier();
    }, AnimationItem.prototype.setLoop = function(t) {
      this.loop = t;
    }, AnimationItem.prototype.setVolume = function(t, r) {
      r && this.name !== r || this.audioController.setVolume(t);
    }, AnimationItem.prototype.getVolume = function() {
      return this.audioController.getVolume();
    }, AnimationItem.prototype.mute = function(t) {
      t && this.name !== t || this.audioController.mute();
    }, AnimationItem.prototype.unmute = function(t) {
      t && this.name !== t || this.audioController.unmute();
    }, AnimationItem.prototype.updaFrameModifier = function() {
      this.frameModifier = this.frameMult * this.playSpeed * this.playDirection, this.audioController.setRate(this.playSpeed * this.playDirection);
    }, AnimationItem.prototype.getPath = function() {
      return this.path;
    }, AnimationItem.prototype.getAssetsPath = function(t) {
      var r = "";
      if (t.e) r = t.p;
      else if (this.assetsPath) {
        var n = t.p;
        n.indexOf("images/") !== -1 && (n = n.split("/")[1]), r = this.assetsPath + n;
      } else r = this.path, r += t.u ? t.u : "", r += t.p;
      return r;
    }, AnimationItem.prototype.getAssetData = function(t) {
      for (var r = 0, n = this.assets.length; r < n; ) {
        if (t === this.assets[r].id) return this.assets[r];
        r += 1;
      }
      return null;
    }, AnimationItem.prototype.hide = function() {
      this.renderer.hide();
    }, AnimationItem.prototype.show = function() {
      this.renderer.show();
    }, AnimationItem.prototype.getDuration = function(t) {
      return t ? this.totalFrames : this.totalFrames / this.frameRate;
    }, AnimationItem.prototype.updateDocumentData = function(t, r, n) {
      try {
        this.renderer.getElementByPath(t).updateDocumentData(r, n);
      } catch {
      }
    }, AnimationItem.prototype.trigger = function(t) {
      if (this._cbs && this._cbs[t]) switch (t) {
        case "enterFrame":
          this.triggerEvent(t, new BMEnterFrameEvent(t, this.currentFrame, this.totalFrames, this.frameModifier));
          break;
        case "drawnFrame":
          this.drawnFrameEvent.currentTime = this.currentFrame, this.drawnFrameEvent.totalTime = this.totalFrames, this.drawnFrameEvent.direction = this.frameModifier, this.triggerEvent(t, this.drawnFrameEvent);
          break;
        case "loopComplete":
          this.triggerEvent(t, new BMCompleteLoopEvent(t, this.loop, this.playCount, this.frameMult));
          break;
        case "complete":
          this.triggerEvent(t, new BMCompleteEvent(t, this.frameMult));
          break;
        case "segmentStart":
          this.triggerEvent(t, new BMSegmentStartEvent(t, this.firstFrame, this.totalFrames));
          break;
        case "destroy":
          this.triggerEvent(t, new BMDestroyEvent(t, this));
          break;
        default:
          this.triggerEvent(t);
      }
      t === "enterFrame" && this.onEnterFrame && this.onEnterFrame.call(this, new BMEnterFrameEvent(t, this.currentFrame, this.totalFrames, this.frameMult)), t === "loopComplete" && this.onLoopComplete && this.onLoopComplete.call(this, new BMCompleteLoopEvent(t, this.loop, this.playCount, this.frameMult)), t === "complete" && this.onComplete && this.onComplete.call(this, new BMCompleteEvent(t, this.frameMult)), t === "segmentStart" && this.onSegmentStart && this.onSegmentStart.call(this, new BMSegmentStartEvent(t, this.firstFrame, this.totalFrames)), t === "destroy" && this.onDestroy && this.onDestroy.call(this, new BMDestroyEvent(t, this));
    }, AnimationItem.prototype.triggerRenderFrameError = function(t) {
      var r = new BMRenderFrameErrorEvent(t, this.currentFrame);
      this.triggerEvent("error", r), this.onError && this.onError.call(this, r);
    }, AnimationItem.prototype.triggerConfigError = function(t) {
      var r = new BMConfigErrorEvent(t, this.currentFrame);
      this.triggerEvent("error", r), this.onError && this.onError.call(this, r);
    };
    var animationManager = (function() {
      var t = {}, r = [], n = 0, a = 0, s = 0, o = !0, l = !1;
      function c(G) {
        for (var W = 0, X = G.target; W < a; ) r[W].animation === X && (r.splice(W, 1), W -= 1, a -= 1, X.isPaused || Z()), W += 1;
      }
      function x(G, W) {
        if (!G) return null;
        for (var X = 0; X < a; ) {
          if (r[X].elem === G && r[X].elem !== null) return r[X].animation;
          X += 1;
        }
        var K = new AnimationItem();
        return V(K, G), K.setData(G, W), K;
      }
      function j() {
        s += 1, Y();
      }
      function Z() {
        s -= 1;
      }
      function V(G, W) {
        G.addEventListener("destroy", c), G.addEventListener("_active", j), G.addEventListener("_idle", Z), r.push({ elem: W, animation: G }), a += 1;
      }
      function U(G) {
        var W, X = G - n;
        for (W = 0; W < a; W += 1) r[W].animation.advanceTime(X);
        n = G, s && !l ? window.requestAnimationFrame(U) : o = !0;
      }
      function $(G) {
        n = G, window.requestAnimationFrame(U);
      }
      function Y() {
        !l && s && o && (window.requestAnimationFrame($), o = !1);
      }
      return t.registerAnimation = x, t.loadAnimation = function(G) {
        var W = new AnimationItem();
        return V(W, null), W.setParams(G), W;
      }, t.setSpeed = function(G, W) {
        var X;
        for (X = 0; X < a; X += 1) r[X].animation.setSpeed(G, W);
      }, t.setDirection = function(G, W) {
        var X;
        for (X = 0; X < a; X += 1) r[X].animation.setDirection(G, W);
      }, t.play = function(G) {
        var W;
        for (W = 0; W < a; W += 1) r[W].animation.play(G);
      }, t.pause = function(G) {
        var W;
        for (W = 0; W < a; W += 1) r[W].animation.pause(G);
      }, t.stop = function(G) {
        var W;
        for (W = 0; W < a; W += 1) r[W].animation.stop(G);
      }, t.togglePause = function(G) {
        var W;
        for (W = 0; W < a; W += 1) r[W].animation.togglePause(G);
      }, t.searchAnimations = function(G, W, X) {
        var K, J = [].concat([].slice.call(document.getElementsByClassName("lottie")), [].slice.call(document.getElementsByClassName("bodymovin"))), ee = J.length;
        for (K = 0; K < ee; K += 1) X && J[K].setAttribute("data-bm-type", X), x(J[K], G);
        if (W && ee === 0) {
          X || (X = "svg");
          var te = document.getElementsByTagName("body")[0];
          te.innerText = "";
          var ne = createTag("div");
          ne.style.width = "100%", ne.style.height = "100%", ne.setAttribute("data-bm-type", X), te.appendChild(ne), x(ne, G);
        }
      }, t.resize = function() {
        var G;
        for (G = 0; G < a; G += 1) r[G].animation.resize();
      }, t.goToAndStop = function(G, W, X) {
        var K;
        for (K = 0; K < a; K += 1) r[K].animation.goToAndStop(G, W, X);
      }, t.destroy = function(G) {
        var W;
        for (W = a - 1; W >= 0; W -= 1) r[W].animation.destroy(G);
      }, t.freeze = function() {
        l = !0;
      }, t.unfreeze = function() {
        l = !1, Y();
      }, t.setVolume = function(G, W) {
        var X;
        for (X = 0; X < a; X += 1) r[X].animation.setVolume(G, W);
      }, t.mute = function(G) {
        var W;
        for (W = 0; W < a; W += 1) r[W].animation.mute(G);
      }, t.unmute = function(G) {
        var W;
        for (W = 0; W < a; W += 1) r[W].animation.unmute(G);
      }, t.getRegisteredAnimations = function() {
        var G, W = r.length, X = [];
        for (G = 0; G < W; G += 1) X.push(r[G].animation);
        return X;
      }, t;
    })(), BezierFactory = (function() {
      var t = { getBezierEasing: function(j, Z, V, U, $) {
        var Y = $ || ("bez_" + j + "_" + Z + "_" + V + "_" + U).replace(/\./g, "p");
        if (r[Y]) return r[Y];
        var G = new x([j, Z, V, U]);
        return r[Y] = G, G;
      } }, r = {}, n = typeof Float32Array == "function";
      function a(j, Z) {
        return 1 - 3 * Z + 3 * j;
      }
      function s(j, Z) {
        return 3 * Z - 6 * j;
      }
      function o(j) {
        return 3 * j;
      }
      function l(j, Z, V) {
        return ((a(Z, V) * j + s(Z, V)) * j + o(Z)) * j;
      }
      function c(j, Z, V) {
        return 3 * a(Z, V) * j * j + 2 * s(Z, V) * j + o(Z);
      }
      function x(j) {
        this._p = j, this._mSampleValues = n ? new Float32Array(11) : new Array(11), this._precomputed = !1, this.get = this.get.bind(this);
      }
      return x.prototype = { get: function(j) {
        var Z = this._p[0], V = this._p[1], U = this._p[2], $ = this._p[3];
        return this._precomputed || this._precompute(), Z === V && U === $ ? j : j === 0 ? 0 : j === 1 ? 1 : l(this._getTForX(j), V, $);
      }, _precompute: function() {
        var j = this._p[0], Z = this._p[1], V = this._p[2], U = this._p[3];
        this._precomputed = !0, j === Z && V === U || this._calcSampleValues();
      }, _calcSampleValues: function() {
        for (var j = this._p[0], Z = this._p[2], V = 0; V < 11; ++V) this._mSampleValues[V] = l(0.1 * V, j, Z);
      }, _getTForX: function(j) {
        for (var Z = this._p[0], V = this._p[2], U = this._mSampleValues, $ = 0, Y = 1; Y !== 10 && U[Y] <= j; ++Y) $ += 0.1;
        var G = $ + 0.1 * ((j - U[--Y]) / (U[Y + 1] - U[Y])), W = c(G, Z, V);
        return W >= 1e-3 ? (function(X, K, J, ee) {
          for (var te = 0; te < 4; ++te) {
            var ne = c(K, J, ee);
            if (ne === 0) return K;
            K -= (l(K, J, ee) - X) / ne;
          }
          return K;
        })(j, G, Z, V) : W === 0 ? G : (function(X, K, J, ee, te) {
          var ne, re, ie = 0;
          do
            (ne = l(re = K + (J - K) / 2, ee, te) - X) > 0 ? J = re : K = re;
          while (Math.abs(ne) > 1e-7 && ++ie < 10);
          return re;
        })(j, $, $ + 0.1, Z, V);
      } }, t;
    })(), pooling = { double: function(t) {
      return t.concat(createSizedArray(t.length));
    } }, poolFactory = function(t, r, n) {
      var a = 0, s = t, o = createSizedArray(s);
      return { newElement: function() {
        return a ? o[a -= 1] : r();
      }, release: function(l) {
        a === s && (o = pooling.double(o), s *= 2), n && n(l), o[a] = l, a += 1;
      } };
    }, bezierLengthPool = poolFactory(8, (function() {
      return { addedLength: 0, percents: createTypedArray("float32", getDefaultCurveSegments()), lengths: createTypedArray("float32", getDefaultCurveSegments()) };
    })), segmentsLengthPool = poolFactory(8, (function() {
      return { lengths: [], totalLength: 0 };
    }), (function(t) {
      var r, n = t.lengths.length;
      for (r = 0; r < n; r += 1) bezierLengthPool.release(t.lengths[r]);
      t.lengths.length = 0;
    }));
    function bezFunction() {
      var t = Math;
      function r(j, Z, V, U, $, Y) {
        var G = j * U + Z * $ + V * Y - $ * U - Y * j - V * Z;
        return G > -1e-3 && G < 1e-3;
      }
      var n = function(j, Z, V, U) {
        var $, Y, G, W, X, K, J = getDefaultCurveSegments(), ee = 0, te = [], ne = [], re = bezierLengthPool.newElement();
        for (G = V.length, $ = 0; $ < J; $ += 1) {
          for (X = $ / (J - 1), K = 0, Y = 0; Y < G; Y += 1) W = bmPow(1 - X, 3) * j[Y] + 3 * bmPow(1 - X, 2) * X * V[Y] + 3 * (1 - X) * bmPow(X, 2) * U[Y] + bmPow(X, 3) * Z[Y], te[Y] = W, ne[Y] !== null && (K += bmPow(te[Y] - ne[Y], 2)), ne[Y] = te[Y];
          K && (ee += K = bmSqrt(K)), re.percents[$] = X, re.lengths[$] = ee;
        }
        return re.addedLength = ee, re;
      };
      function a(j) {
        this.segmentLength = 0, this.points = new Array(j);
      }
      function s(j, Z) {
        this.partialLength = j, this.point = Z;
      }
      var o, l = (o = {}, function(j, Z, V, U) {
        var $ = (j[0] + "_" + j[1] + "_" + Z[0] + "_" + Z[1] + "_" + V[0] + "_" + V[1] + "_" + U[0] + "_" + U[1]).replace(/\./g, "p");
        if (!o[$]) {
          var Y, G, W, X, K, J, ee, te = getDefaultCurveSegments(), ne = 0, re = null;
          j.length === 2 && (j[0] !== Z[0] || j[1] !== Z[1]) && r(j[0], j[1], Z[0], Z[1], j[0] + V[0], j[1] + V[1]) && r(j[0], j[1], Z[0], Z[1], Z[0] + U[0], Z[1] + U[1]) && (te = 2);
          var ie = new a(te);
          for (W = V.length, Y = 0; Y < te; Y += 1) {
            for (ee = createSizedArray(W), K = Y / (te - 1), J = 0, G = 0; G < W; G += 1) X = bmPow(1 - K, 3) * j[G] + 3 * bmPow(1 - K, 2) * K * (j[G] + V[G]) + 3 * (1 - K) * bmPow(K, 2) * (Z[G] + U[G]) + bmPow(K, 3) * Z[G], ee[G] = X, re !== null && (J += bmPow(ee[G] - re[G], 2));
            ne += J = bmSqrt(J), ie.points[Y] = new s(J, ee), re = ee;
          }
          ie.segmentLength = ne, o[$] = ie;
        }
        return o[$];
      });
      function c(j, Z) {
        var V = Z.percents, U = Z.lengths, $ = V.length, Y = bmFloor(($ - 1) * j), G = j * Z.addedLength, W = 0;
        if (Y === $ - 1 || Y === 0 || G === U[Y]) return V[Y];
        for (var X = U[Y] > G ? -1 : 1, K = !0; K; ) if (U[Y] <= G && U[Y + 1] > G ? (W = (G - U[Y]) / (U[Y + 1] - U[Y]), K = !1) : Y += X, Y < 0 || Y >= $ - 1) {
          if (Y === $ - 1) return V[Y];
          K = !1;
        }
        return V[Y] + (V[Y + 1] - V[Y]) * W;
      }
      var x = createTypedArray("float32", 8);
      return { getSegmentsLength: function(j) {
        var Z, V = segmentsLengthPool.newElement(), U = j.c, $ = j.v, Y = j.o, G = j.i, W = j._length, X = V.lengths, K = 0;
        for (Z = 0; Z < W - 1; Z += 1) X[Z] = n($[Z], $[Z + 1], Y[Z], G[Z + 1]), K += X[Z].addedLength;
        return U && W && (X[Z] = n($[Z], $[0], Y[Z], G[0]), K += X[Z].addedLength), V.totalLength = K, V;
      }, getNewSegment: function(j, Z, V, U, $, Y, G) {
        $ < 0 ? $ = 0 : $ > 1 && ($ = 1);
        var W, X = c($, G), K = c(Y = Y > 1 ? 1 : Y, G), J = j.length, ee = 1 - X, te = 1 - K, ne = ee * ee * ee, re = X * ee * ee * 3, ie = X * X * ee * 3, ue = X * X * X, le = ee * ee * te, oe = X * ee * te + ee * X * te + ee * ee * K, he = X * X * te + ee * X * K + X * ee * K, fe = X * X * K, ce = ee * te * te, se = X * te * te + ee * K * te + ee * te * K, pe = X * K * te + ee * K * K + X * te * K, ve = X * K * K, ae = te * te * te, me = K * te * te + te * K * te + te * te * K, de = K * K * te + te * K * K + K * te * K, ge = K * K * K;
        for (W = 0; W < J; W += 1) x[4 * W] = t.round(1e3 * (ne * j[W] + re * V[W] + ie * U[W] + ue * Z[W])) / 1e3, x[4 * W + 1] = t.round(1e3 * (le * j[W] + oe * V[W] + he * U[W] + fe * Z[W])) / 1e3, x[4 * W + 2] = t.round(1e3 * (ce * j[W] + se * V[W] + pe * U[W] + ve * Z[W])) / 1e3, x[4 * W + 3] = t.round(1e3 * (ae * j[W] + me * V[W] + de * U[W] + ge * Z[W])) / 1e3;
        return x;
      }, getPointInSegment: function(j, Z, V, U, $, Y) {
        var G = c($, Y), W = 1 - G;
        return [t.round(1e3 * (W * W * W * j[0] + (G * W * W + W * G * W + W * W * G) * V[0] + (G * G * W + W * G * G + G * W * G) * U[0] + G * G * G * Z[0])) / 1e3, t.round(1e3 * (W * W * W * j[1] + (G * W * W + W * G * W + W * W * G) * V[1] + (G * G * W + W * G * G + G * W * G) * U[1] + G * G * G * Z[1])) / 1e3];
      }, buildBezierData: l, pointOnLine2D: r, pointOnLine3D: function(j, Z, V, U, $, Y, G, W, X) {
        if (V === 0 && Y === 0 && X === 0) return r(j, Z, U, $, G, W);
        var K, J = t.sqrt(t.pow(U - j, 2) + t.pow($ - Z, 2) + t.pow(Y - V, 2)), ee = t.sqrt(t.pow(G - j, 2) + t.pow(W - Z, 2) + t.pow(X - V, 2)), te = t.sqrt(t.pow(G - U, 2) + t.pow(W - $, 2) + t.pow(X - Y, 2));
        return (K = J > ee ? J > te ? J - ee - te : te - ee - J : te > ee ? te - ee - J : ee - J - te) > -1e-4 && K < 1e-4;
      } };
    }
    var bez = bezFunction(), initFrame = initialDefaultFrame, mathAbs = Math.abs;
    function interpolateValue(t, r) {
      var n, a = this.offsetTime;
      this.propType === "multidimensional" && (n = createTypedArray("float32", this.pv.length));
      for (var s, o, l, c, x, j, Z, V, U, $ = r.lastIndex, Y = $, G = this.keyframes.length - 1, W = !0; W; ) {
        if (s = this.keyframes[Y], o = this.keyframes[Y + 1], Y === G - 1 && t >= o.t - a) {
          s.h && (s = o), $ = 0;
          break;
        }
        if (o.t - a > t) {
          $ = Y;
          break;
        }
        Y < G - 1 ? Y += 1 : ($ = 0, W = !1);
      }
      l = this.keyframesMetadata[Y] || {};
      var X, K = o.t - a, J = s.t - a;
      if (s.to) {
        l.bezierData || (l.bezierData = bez.buildBezierData(s.s, o.s || s.e, s.to, s.ti));
        var ee = l.bezierData;
        if (t >= K || t < J) {
          var te = t >= K ? ee.points.length - 1 : 0;
          for (x = ee.points[te].point.length, c = 0; c < x; c += 1) n[c] = ee.points[te].point[c];
        } else {
          l.__fnct ? U = l.__fnct : (U = BezierFactory.getBezierEasing(s.o.x, s.o.y, s.i.x, s.i.y, s.n).get, l.__fnct = U), j = U((t - J) / (K - J));
          var ne, re = ee.segmentLength * j, ie = r.lastFrame < t && r._lastKeyframeIndex === Y ? r._lastAddedLength : 0;
          for (V = r.lastFrame < t && r._lastKeyframeIndex === Y ? r._lastPoint : 0, W = !0, Z = ee.points.length; W; ) {
            if (ie += ee.points[V].partialLength, re === 0 || j === 0 || V === ee.points.length - 1) {
              for (x = ee.points[V].point.length, c = 0; c < x; c += 1) n[c] = ee.points[V].point[c];
              break;
            }
            if (re >= ie && re < ie + ee.points[V + 1].partialLength) {
              for (ne = (re - ie) / ee.points[V + 1].partialLength, x = ee.points[V].point.length, c = 0; c < x; c += 1) n[c] = ee.points[V].point[c] + (ee.points[V + 1].point[c] - ee.points[V].point[c]) * ne;
              break;
            }
            V < Z - 1 ? V += 1 : W = !1;
          }
          r._lastPoint = V, r._lastAddedLength = ie - ee.points[V].partialLength, r._lastKeyframeIndex = Y;
        }
      } else {
        var ue, le, oe, he, fe;
        if (G = s.s.length, X = o.s || s.e, this.sh && s.h !== 1) t >= K ? (n[0] = X[0], n[1] = X[1], n[2] = X[2]) : t <= J ? (n[0] = s.s[0], n[1] = s.s[1], n[2] = s.s[2]) : quaternionToEuler(n, slerp(createQuaternion(s.s), createQuaternion(X), (t - J) / (K - J)));
        else for (Y = 0; Y < G; Y += 1) s.h !== 1 && (t >= K ? j = 1 : t < J ? j = 0 : (s.o.x.constructor === Array ? (l.__fnct || (l.__fnct = []), l.__fnct[Y] ? U = l.__fnct[Y] : (ue = s.o.x[Y] === void 0 ? s.o.x[0] : s.o.x[Y], le = s.o.y[Y] === void 0 ? s.o.y[0] : s.o.y[Y], oe = s.i.x[Y] === void 0 ? s.i.x[0] : s.i.x[Y], he = s.i.y[Y] === void 0 ? s.i.y[0] : s.i.y[Y], U = BezierFactory.getBezierEasing(ue, le, oe, he).get, l.__fnct[Y] = U)) : l.__fnct ? U = l.__fnct : (ue = s.o.x, le = s.o.y, oe = s.i.x, he = s.i.y, U = BezierFactory.getBezierEasing(ue, le, oe, he).get, s.keyframeMetadata = U), j = U((t - J) / (K - J)))), X = o.s || s.e, fe = s.h === 1 ? s.s[Y] : s.s[Y] + (X[Y] - s.s[Y]) * j, this.propType === "multidimensional" ? n[Y] = fe : n = fe;
      }
      return r.lastIndex = $, n;
    }
    function slerp(t, r, n) {
      var a, s, o, l, c, x = [], j = t[0], Z = t[1], V = t[2], U = t[3], $ = r[0], Y = r[1], G = r[2], W = r[3];
      return (s = j * $ + Z * Y + V * G + U * W) < 0 && (s = -s, $ = -$, Y = -Y, G = -G, W = -W), 1 - s > 1e-6 ? (a = Math.acos(s), o = Math.sin(a), l = Math.sin((1 - n) * a) / o, c = Math.sin(n * a) / o) : (l = 1 - n, c = n), x[0] = l * j + c * $, x[1] = l * Z + c * Y, x[2] = l * V + c * G, x[3] = l * U + c * W, x;
    }
    function quaternionToEuler(t, r) {
      var n = r[0], a = r[1], s = r[2], o = r[3], l = Math.atan2(2 * a * o - 2 * n * s, 1 - 2 * a * a - 2 * s * s), c = Math.asin(2 * n * a + 2 * s * o), x = Math.atan2(2 * n * o - 2 * a * s, 1 - 2 * n * n - 2 * s * s);
      t[0] = l / degToRads, t[1] = c / degToRads, t[2] = x / degToRads;
    }
    function createQuaternion(t) {
      var r = t[0] * degToRads, n = t[1] * degToRads, a = t[2] * degToRads, s = Math.cos(r / 2), o = Math.cos(n / 2), l = Math.cos(a / 2), c = Math.sin(r / 2), x = Math.sin(n / 2), j = Math.sin(a / 2);
      return [c * x * l + s * o * j, c * o * l + s * x * j, s * x * l - c * o * j, s * o * l - c * x * j];
    }
    function getValueAtCurrentTime() {
      var t = this.comp.renderedFrame - this.offsetTime, r = this.keyframes[0].t - this.offsetTime, n = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
      if (!(t === this._caching.lastFrame || this._caching.lastFrame !== initFrame && (this._caching.lastFrame >= n && t >= n || this._caching.lastFrame < r && t < r))) {
        this._caching.lastFrame >= t && (this._caching._lastKeyframeIndex = -1, this._caching.lastIndex = 0);
        var a = this.interpolateValue(t, this._caching);
        this.pv = a;
      }
      return this._caching.lastFrame = t, this.pv;
    }
    function setVValue(t) {
      var r;
      if (this.propType === "unidimensional") r = t * this.mult, mathAbs(this.v - r) > 1e-5 && (this.v = r, this._mdf = !0);
      else for (var n = 0, a = this.v.length; n < a; ) r = t[n] * this.mult, mathAbs(this.v[n] - r) > 1e-5 && (this.v[n] = r, this._mdf = !0), n += 1;
    }
    function processEffectsSequence() {
      if (this.elem.globalData.frameId !== this.frameId && this.effectsSequence.length) if (this.lock) this.setVValue(this.pv);
      else {
        var t;
        this.lock = !0, this._mdf = this._isFirstFrame;
        var r = this.effectsSequence.length, n = this.kf ? this.pv : this.data.k;
        for (t = 0; t < r; t += 1) n = this.effectsSequence[t](n);
        this.setVValue(n), this._isFirstFrame = !1, this.lock = !1, this.frameId = this.elem.globalData.frameId;
      }
    }
    function addEffect(t) {
      this.effectsSequence.push(t), this.container.addDynamicProperty(this);
    }
    function ValueProperty(t, r, n, a) {
      this.propType = "unidimensional", this.mult = n || 1, this.data = r, this.v = n ? r.k * n : r.k, this.pv = r.k, this._mdf = !1, this.elem = t, this.container = a, this.comp = t.comp, this.k = !1, this.kf = !1, this.vel = 0, this.effectsSequence = [], this._isFirstFrame = !0, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.addEffect = addEffect;
    }
    function MultiDimensionalProperty(t, r, n, a) {
      var s;
      this.propType = "multidimensional", this.mult = n || 1, this.data = r, this._mdf = !1, this.elem = t, this.container = a, this.comp = t.comp, this.k = !1, this.kf = !1, this.frameId = -1;
      var o = r.k.length;
      for (this.v = createTypedArray("float32", o), this.pv = createTypedArray("float32", o), this.vel = createTypedArray("float32", o), s = 0; s < o; s += 1) this.v[s] = r.k[s] * this.mult, this.pv[s] = r.k[s];
      this._isFirstFrame = !0, this.effectsSequence = [], this.getValue = processEffectsSequence, this.setVValue = setVValue, this.addEffect = addEffect;
    }
    function KeyframedValueProperty(t, r, n, a) {
      this.propType = "unidimensional", this.keyframes = r.k, this.keyframesMetadata = [], this.offsetTime = t.data.st, this.frameId = -1, this._caching = { lastFrame: initFrame, lastIndex: 0, value: 0, _lastKeyframeIndex: -1 }, this.k = !0, this.kf = !0, this.data = r, this.mult = n || 1, this.elem = t, this.container = a, this.comp = t.comp, this.v = initFrame, this.pv = initFrame, this._isFirstFrame = !0, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.interpolateValue = interpolateValue, this.effectsSequence = [getValueAtCurrentTime.bind(this)], this.addEffect = addEffect;
    }
    function KeyframedMultidimensionalProperty(t, r, n, a) {
      var s;
      this.propType = "multidimensional";
      var o, l, c, x, j = r.k.length;
      for (s = 0; s < j - 1; s += 1) r.k[s].to && r.k[s].s && r.k[s + 1] && r.k[s + 1].s && (o = r.k[s].s, l = r.k[s + 1].s, c = r.k[s].to, x = r.k[s].ti, (o.length === 2 && (o[0] !== l[0] || o[1] !== l[1]) && bez.pointOnLine2D(o[0], o[1], l[0], l[1], o[0] + c[0], o[1] + c[1]) && bez.pointOnLine2D(o[0], o[1], l[0], l[1], l[0] + x[0], l[1] + x[1]) || o.length === 3 && (o[0] !== l[0] || o[1] !== l[1] || o[2] !== l[2]) && bez.pointOnLine3D(o[0], o[1], o[2], l[0], l[1], l[2], o[0] + c[0], o[1] + c[1], o[2] + c[2]) && bez.pointOnLine3D(o[0], o[1], o[2], l[0], l[1], l[2], l[0] + x[0], l[1] + x[1], l[2] + x[2])) && (r.k[s].to = null, r.k[s].ti = null), o[0] === l[0] && o[1] === l[1] && c[0] === 0 && c[1] === 0 && x[0] === 0 && x[1] === 0 && (o.length === 2 || o[2] === l[2] && c[2] === 0 && x[2] === 0) && (r.k[s].to = null, r.k[s].ti = null));
      this.effectsSequence = [getValueAtCurrentTime.bind(this)], this.data = r, this.keyframes = r.k, this.keyframesMetadata = [], this.offsetTime = t.data.st, this.k = !0, this.kf = !0, this._isFirstFrame = !0, this.mult = n || 1, this.elem = t, this.container = a, this.comp = t.comp, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.interpolateValue = interpolateValue, this.frameId = -1;
      var Z = r.k[0].s.length;
      for (this.v = createTypedArray("float32", Z), this.pv = createTypedArray("float32", Z), s = 0; s < Z; s += 1) this.v[s] = initFrame, this.pv[s] = initFrame;
      this._caching = { lastFrame: initFrame, lastIndex: 0, value: createTypedArray("float32", Z) }, this.addEffect = addEffect;
    }
    var PropertyFactory = { getProp: function(t, r, n, a, s) {
      var o;
      if (r.sid && (r = t.globalData.slotManager.getProp(r)), r.k.length) if (typeof r.k[0] == "number") o = new MultiDimensionalProperty(t, r, a, s);
      else switch (n) {
        case 0:
          o = new KeyframedValueProperty(t, r, a, s);
          break;
        case 1:
          o = new KeyframedMultidimensionalProperty(t, r, a, s);
      }
      else o = new ValueProperty(t, r, a, s);
      return o.effectsSequence.length && s.addDynamicProperty(o), o;
    } };
    function DynamicPropertyContainer() {
    }
    DynamicPropertyContainer.prototype = { addDynamicProperty: function(t) {
      this.dynamicProperties.indexOf(t) === -1 && (this.dynamicProperties.push(t), this.container.addDynamicProperty(this), this._isAnimated = !0);
    }, iterateDynamicProperties: function() {
      var t;
      this._mdf = !1;
      var r = this.dynamicProperties.length;
      for (t = 0; t < r; t += 1) this.dynamicProperties[t].getValue(), this.dynamicProperties[t]._mdf && (this._mdf = !0);
    }, initDynamicPropertyContainer: function(t) {
      this.container = t, this.dynamicProperties = [], this._mdf = !1, this._isAnimated = !1;
    } };
    var pointPool = poolFactory(8, (function() {
      return createTypedArray("float32", 2);
    }));
    function ShapePath() {
      this.c = !1, this._length = 0, this._maxLength = 8, this.v = createSizedArray(this._maxLength), this.o = createSizedArray(this._maxLength), this.i = createSizedArray(this._maxLength);
    }
    ShapePath.prototype.setPathData = function(t, r) {
      this.c = t, this.setLength(r);
      for (var n = 0; n < r; ) this.v[n] = pointPool.newElement(), this.o[n] = pointPool.newElement(), this.i[n] = pointPool.newElement(), n += 1;
    }, ShapePath.prototype.setLength = function(t) {
      for (; this._maxLength < t; ) this.doubleArrayLength();
      this._length = t;
    }, ShapePath.prototype.doubleArrayLength = function() {
      this.v = this.v.concat(createSizedArray(this._maxLength)), this.i = this.i.concat(createSizedArray(this._maxLength)), this.o = this.o.concat(createSizedArray(this._maxLength)), this._maxLength *= 2;
    }, ShapePath.prototype.setXYAt = function(t, r, n, a, s) {
      var o;
      switch (this._length = Math.max(this._length, a + 1), this._length >= this._maxLength && this.doubleArrayLength(), n) {
        case "v":
          o = this.v;
          break;
        case "i":
          o = this.i;
          break;
        case "o":
          o = this.o;
          break;
        default:
          o = [];
      }
      (!o[a] || o[a] && !s) && (o[a] = pointPool.newElement()), o[a][0] = t, o[a][1] = r;
    }, ShapePath.prototype.setTripleAt = function(t, r, n, a, s, o, l, c) {
      this.setXYAt(t, r, "v", l, c), this.setXYAt(n, a, "o", l, c), this.setXYAt(s, o, "i", l, c);
    }, ShapePath.prototype.reverse = function() {
      var t = new ShapePath();
      t.setPathData(this.c, this._length);
      var r = this.v, n = this.o, a = this.i, s = 0;
      this.c && (t.setTripleAt(r[0][0], r[0][1], a[0][0], a[0][1], n[0][0], n[0][1], 0, !1), s = 1);
      var o, l = this._length - 1, c = this._length;
      for (o = s; o < c; o += 1) t.setTripleAt(r[l][0], r[l][1], a[l][0], a[l][1], n[l][0], n[l][1], o, !1), l -= 1;
      return t;
    }, ShapePath.prototype.length = function() {
      return this._length;
    };
    var shapePool = (factory = poolFactory(4, (function() {
      return new ShapePath();
    }), (function(t) {
      var r, n = t._length;
      for (r = 0; r < n; r += 1) pointPool.release(t.v[r]), pointPool.release(t.i[r]), pointPool.release(t.o[r]), t.v[r] = null, t.i[r] = null, t.o[r] = null;
      t._length = 0, t.c = !1;
    })), factory.clone = function(t) {
      var r, n = factory.newElement(), a = t._length === void 0 ? t.v.length : t._length;
      for (n.setLength(a), n.c = t.c, r = 0; r < a; r += 1) n.setTripleAt(t.v[r][0], t.v[r][1], t.o[r][0], t.o[r][1], t.i[r][0], t.i[r][1], r);
      return n;
    }, factory), factory;
    function ShapeCollection() {
      this._length = 0, this._maxLength = 4, this.shapes = createSizedArray(this._maxLength);
    }
    ShapeCollection.prototype.addShape = function(t) {
      this._length === this._maxLength && (this.shapes = this.shapes.concat(createSizedArray(this._maxLength)), this._maxLength *= 2), this.shapes[this._length] = t, this._length += 1;
    }, ShapeCollection.prototype.releaseShapes = function() {
      var t;
      for (t = 0; t < this._length; t += 1) shapePool.release(this.shapes[t]);
      this._length = 0;
    };
    var shapeCollectionPool = (ob = { newShapeCollection: function() {
      return _length ? pool[_length -= 1] : new ShapeCollection();
    }, release: function(t) {
      var r, n = t._length;
      for (r = 0; r < n; r += 1) shapePool.release(t.shapes[r]);
      t._length = 0, _length === _maxLength && (pool = pooling.double(pool), _maxLength *= 2), pool[_length] = t, _length += 1;
    } }, _length = 0, _maxLength = 4, pool = createSizedArray(_maxLength), ob), ob, _length, _maxLength, pool, ShapePropertyFactory = (function() {
      function t(U, $, Y) {
        var G, W, X, K, J, ee, te, ne, re, ie = Y.lastIndex, ue = this.keyframes;
        if (U < ue[0].t - this.offsetTime) G = ue[0].s[0], X = !0, ie = 0;
        else if (U >= ue[ue.length - 1].t - this.offsetTime) G = ue[ue.length - 1].s ? ue[ue.length - 1].s[0] : ue[ue.length - 2].e[0], X = !0;
        else {
          for (var le, oe, he, fe = ie, ce = ue.length - 1, se = !0; se && (le = ue[fe], !((oe = ue[fe + 1]).t - this.offsetTime > U)); ) fe < ce - 1 ? fe += 1 : se = !1;
          if (he = this.keyframesMetadata[fe] || {}, ie = fe, !(X = le.h === 1)) {
            if (U >= oe.t - this.offsetTime) ne = 1;
            else if (U < le.t - this.offsetTime) ne = 0;
            else {
              var pe;
              he.__fnct ? pe = he.__fnct : (pe = BezierFactory.getBezierEasing(le.o.x, le.o.y, le.i.x, le.i.y).get, he.__fnct = pe), ne = pe((U - (le.t - this.offsetTime)) / (oe.t - this.offsetTime - (le.t - this.offsetTime)));
            }
            W = oe.s ? oe.s[0] : le.e[0];
          }
          G = le.s[0];
        }
        for (ee = $._length, te = G.i[0].length, Y.lastIndex = ie, K = 0; K < ee; K += 1) for (J = 0; J < te; J += 1) re = X ? G.i[K][J] : G.i[K][J] + (W.i[K][J] - G.i[K][J]) * ne, $.i[K][J] = re, re = X ? G.o[K][J] : G.o[K][J] + (W.o[K][J] - G.o[K][J]) * ne, $.o[K][J] = re, re = X ? G.v[K][J] : G.v[K][J] + (W.v[K][J] - G.v[K][J]) * ne, $.v[K][J] = re;
      }
      function r() {
        var U = this.comp.renderedFrame - this.offsetTime, $ = this.keyframes[0].t - this.offsetTime, Y = this.keyframes[this.keyframes.length - 1].t - this.offsetTime, G = this._caching.lastFrame;
        return G !== -999999 && (G < $ && U < $ || G > Y && U > Y) || (this._caching.lastIndex = G < U ? this._caching.lastIndex : 0, this.interpolateShape(U, this.pv, this._caching)), this._caching.lastFrame = U, this.pv;
      }
      function n() {
        this.paths = this.localShapeCollection;
      }
      function a(U) {
        (function($, Y) {
          if ($._length !== Y._length || $.c !== Y.c) return !1;
          var G, W = $._length;
          for (G = 0; G < W; G += 1) if ($.v[G][0] !== Y.v[G][0] || $.v[G][1] !== Y.v[G][1] || $.o[G][0] !== Y.o[G][0] || $.o[G][1] !== Y.o[G][1] || $.i[G][0] !== Y.i[G][0] || $.i[G][1] !== Y.i[G][1]) return !1;
          return !0;
        })(this.v, U) || (this.v = shapePool.clone(U), this.localShapeCollection.releaseShapes(), this.localShapeCollection.addShape(this.v), this._mdf = !0, this.paths = this.localShapeCollection);
      }
      function s() {
        if (this.elem.globalData.frameId !== this.frameId) if (this.effectsSequence.length) if (this.lock) this.setVValue(this.pv);
        else {
          var U, $;
          this.lock = !0, this._mdf = !1, U = this.kf ? this.pv : this.data.ks ? this.data.ks.k : this.data.pt.k;
          var Y = this.effectsSequence.length;
          for ($ = 0; $ < Y; $ += 1) U = this.effectsSequence[$](U);
          this.setVValue(U), this.lock = !1, this.frameId = this.elem.globalData.frameId;
        }
        else this._mdf = !1;
      }
      function o(U, $, Y) {
        this.propType = "shape", this.comp = U.comp, this.container = U, this.elem = U, this.data = $, this.k = !1, this.kf = !1, this._mdf = !1;
        var G = Y === 3 ? $.pt.k : $.ks.k;
        this.v = shapePool.clone(G), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.reset = n, this.effectsSequence = [];
      }
      function l(U) {
        this.effectsSequence.push(U), this.container.addDynamicProperty(this);
      }
      function c(U, $, Y) {
        this.propType = "shape", this.comp = U.comp, this.elem = U, this.container = U, this.offsetTime = U.data.st, this.keyframes = Y === 3 ? $.pt.k : $.ks.k, this.keyframesMetadata = [], this.k = !0, this.kf = !0;
        var G = this.keyframes[0].s[0].i.length;
        this.v = shapePool.newElement(), this.v.setPathData(this.keyframes[0].s[0].c, G), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.lastFrame = -999999, this.reset = n, this._caching = { lastFrame: -999999, lastIndex: 0 }, this.effectsSequence = [r.bind(this)];
      }
      o.prototype.interpolateShape = t, o.prototype.getValue = s, o.prototype.setVValue = a, o.prototype.addEffect = l, c.prototype.getValue = s, c.prototype.interpolateShape = t, c.prototype.setVValue = a, c.prototype.addEffect = l;
      var x = (function() {
        var U = roundCorner;
        function $(Y, G) {
          this.v = shapePool.newElement(), this.v.setPathData(!0, 4), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.localShapeCollection.addShape(this.v), this.d = G.d, this.elem = Y, this.comp = Y.comp, this.frameId = -1, this.initDynamicPropertyContainer(Y), this.p = PropertyFactory.getProp(Y, G.p, 1, 0, this), this.s = PropertyFactory.getProp(Y, G.s, 1, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertEllToPath());
        }
        return $.prototype = { reset: n, getValue: function() {
          this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertEllToPath());
        }, convertEllToPath: function() {
          var Y = this.p.v[0], G = this.p.v[1], W = this.s.v[0] / 2, X = this.s.v[1] / 2, K = this.d !== 3, J = this.v;
          J.v[0][0] = Y, J.v[0][1] = G - X, J.v[1][0] = K ? Y + W : Y - W, J.v[1][1] = G, J.v[2][0] = Y, J.v[2][1] = G + X, J.v[3][0] = K ? Y - W : Y + W, J.v[3][1] = G, J.i[0][0] = K ? Y - W * U : Y + W * U, J.i[0][1] = G - X, J.i[1][0] = K ? Y + W : Y - W, J.i[1][1] = G - X * U, J.i[2][0] = K ? Y + W * U : Y - W * U, J.i[2][1] = G + X, J.i[3][0] = K ? Y - W : Y + W, J.i[3][1] = G + X * U, J.o[0][0] = K ? Y + W * U : Y - W * U, J.o[0][1] = G - X, J.o[1][0] = K ? Y + W : Y - W, J.o[1][1] = G + X * U, J.o[2][0] = K ? Y - W * U : Y + W * U, J.o[2][1] = G + X, J.o[3][0] = K ? Y - W : Y + W, J.o[3][1] = G - X * U;
        } }, extendPrototype([DynamicPropertyContainer], $), $;
      })(), j = (function() {
        function U($, Y) {
          this.v = shapePool.newElement(), this.v.setPathData(!0, 0), this.elem = $, this.comp = $.comp, this.data = Y, this.frameId = -1, this.d = Y.d, this.initDynamicPropertyContainer($), Y.sy === 1 ? (this.ir = PropertyFactory.getProp($, Y.ir, 0, 0, this), this.is = PropertyFactory.getProp($, Y.is, 0, 0.01, this), this.convertToPath = this.convertStarToPath) : this.convertToPath = this.convertPolygonToPath, this.pt = PropertyFactory.getProp($, Y.pt, 0, 0, this), this.p = PropertyFactory.getProp($, Y.p, 1, 0, this), this.r = PropertyFactory.getProp($, Y.r, 0, degToRads, this), this.or = PropertyFactory.getProp($, Y.or, 0, 0, this), this.os = PropertyFactory.getProp($, Y.os, 0, 0.01, this), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertToPath());
        }
        return U.prototype = { reset: n, getValue: function() {
          this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertToPath());
        }, convertStarToPath: function() {
          var $, Y, G, W, X = 2 * Math.floor(this.pt.v), K = 2 * Math.PI / X, J = !0, ee = this.or.v, te = this.ir.v, ne = this.os.v, re = this.is.v, ie = 2 * Math.PI * ee / (2 * X), ue = 2 * Math.PI * te / (2 * X), le = -Math.PI / 2;
          le += this.r.v;
          var oe = this.data.d === 3 ? -1 : 1;
          for (this.v._length = 0, $ = 0; $ < X; $ += 1) {
            G = J ? ne : re, W = J ? ie : ue;
            var he = (Y = J ? ee : te) * Math.cos(le), fe = Y * Math.sin(le), ce = he === 0 && fe === 0 ? 0 : fe / Math.sqrt(he * he + fe * fe), se = he === 0 && fe === 0 ? 0 : -he / Math.sqrt(he * he + fe * fe);
            he += +this.p.v[0], fe += +this.p.v[1], this.v.setTripleAt(he, fe, he - ce * W * G * oe, fe - se * W * G * oe, he + ce * W * G * oe, fe + se * W * G * oe, $, !0), J = !J, le += K * oe;
          }
        }, convertPolygonToPath: function() {
          var $, Y = Math.floor(this.pt.v), G = 2 * Math.PI / Y, W = this.or.v, X = this.os.v, K = 2 * Math.PI * W / (4 * Y), J = 0.5 * -Math.PI, ee = this.data.d === 3 ? -1 : 1;
          for (J += this.r.v, this.v._length = 0, $ = 0; $ < Y; $ += 1) {
            var te = W * Math.cos(J), ne = W * Math.sin(J), re = te === 0 && ne === 0 ? 0 : ne / Math.sqrt(te * te + ne * ne), ie = te === 0 && ne === 0 ? 0 : -te / Math.sqrt(te * te + ne * ne);
            te += +this.p.v[0], ne += +this.p.v[1], this.v.setTripleAt(te, ne, te - re * K * X * ee, ne - ie * K * X * ee, te + re * K * X * ee, ne + ie * K * X * ee, $, !0), J += G * ee;
          }
          this.paths.length = 0, this.paths[0] = this.v;
        } }, extendPrototype([DynamicPropertyContainer], U), U;
      })(), Z = (function() {
        function U($, Y) {
          this.v = shapePool.newElement(), this.v.c = !0, this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.elem = $, this.comp = $.comp, this.frameId = -1, this.d = Y.d, this.initDynamicPropertyContainer($), this.p = PropertyFactory.getProp($, Y.p, 1, 0, this), this.s = PropertyFactory.getProp($, Y.s, 1, 0, this), this.r = PropertyFactory.getProp($, Y.r, 0, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertRectToPath());
        }
        return U.prototype = { convertRectToPath: function() {
          var $ = this.p.v[0], Y = this.p.v[1], G = this.s.v[0] / 2, W = this.s.v[1] / 2, X = bmMin(G, W, this.r.v), K = X * (1 - roundCorner);
          this.v._length = 0, this.d === 2 || this.d === 1 ? (this.v.setTripleAt($ + G, Y - W + X, $ + G, Y - W + X, $ + G, Y - W + K, 0, !0), this.v.setTripleAt($ + G, Y + W - X, $ + G, Y + W - K, $ + G, Y + W - X, 1, !0), X !== 0 ? (this.v.setTripleAt($ + G - X, Y + W, $ + G - X, Y + W, $ + G - K, Y + W, 2, !0), this.v.setTripleAt($ - G + X, Y + W, $ - G + K, Y + W, $ - G + X, Y + W, 3, !0), this.v.setTripleAt($ - G, Y + W - X, $ - G, Y + W - X, $ - G, Y + W - K, 4, !0), this.v.setTripleAt($ - G, Y - W + X, $ - G, Y - W + K, $ - G, Y - W + X, 5, !0), this.v.setTripleAt($ - G + X, Y - W, $ - G + X, Y - W, $ - G + K, Y - W, 6, !0), this.v.setTripleAt($ + G - X, Y - W, $ + G - K, Y - W, $ + G - X, Y - W, 7, !0)) : (this.v.setTripleAt($ - G, Y + W, $ - G + K, Y + W, $ - G, Y + W, 2), this.v.setTripleAt($ - G, Y - W, $ - G, Y - W + K, $ - G, Y - W, 3))) : (this.v.setTripleAt($ + G, Y - W + X, $ + G, Y - W + K, $ + G, Y - W + X, 0, !0), X !== 0 ? (this.v.setTripleAt($ + G - X, Y - W, $ + G - X, Y - W, $ + G - K, Y - W, 1, !0), this.v.setTripleAt($ - G + X, Y - W, $ - G + K, Y - W, $ - G + X, Y - W, 2, !0), this.v.setTripleAt($ - G, Y - W + X, $ - G, Y - W + X, $ - G, Y - W + K, 3, !0), this.v.setTripleAt($ - G, Y + W - X, $ - G, Y + W - K, $ - G, Y + W - X, 4, !0), this.v.setTripleAt($ - G + X, Y + W, $ - G + X, Y + W, $ - G + K, Y + W, 5, !0), this.v.setTripleAt($ + G - X, Y + W, $ + G - K, Y + W, $ + G - X, Y + W, 6, !0), this.v.setTripleAt($ + G, Y + W - X, $ + G, Y + W - X, $ + G, Y + W - K, 7, !0)) : (this.v.setTripleAt($ - G, Y - W, $ - G + K, Y - W, $ - G, Y - W, 1, !0), this.v.setTripleAt($ - G, Y + W, $ - G, Y + W - K, $ - G, Y + W, 2, !0), this.v.setTripleAt($ + G, Y + W, $ + G - K, Y + W, $ + G, Y + W, 3, !0)));
        }, getValue: function() {
          this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertRectToPath());
        }, reset: n }, extendPrototype([DynamicPropertyContainer], U), U;
      })(), V = { getShapeProp: function(U, $, Y) {
        var G;
        return Y === 3 || Y === 4 ? G = (Y === 3 ? $.pt : $.ks).k.length ? new c(U, $, Y) : new o(U, $, Y) : Y === 5 ? G = new Z(U, $) : Y === 6 ? G = new x(U, $) : Y === 7 && (G = new j(U, $)), G.k && U.addDynamicProperty(G), G;
      }, getConstructorFunction: function() {
        return o;
      }, getKeyframedConstructorFunction: function() {
        return c;
      } };
      return V;
    })(), Matrix = /* @__PURE__ */ (function() {
      var t = Math.cos, r = Math.sin, n = Math.tan, a = Math.round;
      function s() {
        return this.props[0] = 1, this.props[1] = 0, this.props[2] = 0, this.props[3] = 0, this.props[4] = 0, this.props[5] = 1, this.props[6] = 0, this.props[7] = 0, this.props[8] = 0, this.props[9] = 0, this.props[10] = 1, this.props[11] = 0, this.props[12] = 0, this.props[13] = 0, this.props[14] = 0, this.props[15] = 1, this;
      }
      function o(ae) {
        if (ae === 0) return this;
        var me = t(ae), de = r(ae);
        return this._t(me, -de, 0, 0, de, me, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function l(ae) {
        if (ae === 0) return this;
        var me = t(ae), de = r(ae);
        return this._t(1, 0, 0, 0, 0, me, -de, 0, 0, de, me, 0, 0, 0, 0, 1);
      }
      function c(ae) {
        if (ae === 0) return this;
        var me = t(ae), de = r(ae);
        return this._t(me, 0, de, 0, 0, 1, 0, 0, -de, 0, me, 0, 0, 0, 0, 1);
      }
      function x(ae) {
        if (ae === 0) return this;
        var me = t(ae), de = r(ae);
        return this._t(me, -de, 0, 0, de, me, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function j(ae, me) {
        return this._t(1, me, ae, 1, 0, 0);
      }
      function Z(ae, me) {
        return this.shear(n(ae), n(me));
      }
      function V(ae, me) {
        var de = t(me), ge = r(me);
        return this._t(de, ge, 0, 0, -ge, de, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, n(ae), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(de, -ge, 0, 0, ge, de, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function U(ae, me, de) {
        return de || de === 0 || (de = 1), ae === 1 && me === 1 && de === 1 ? this : this._t(ae, 0, 0, 0, 0, me, 0, 0, 0, 0, de, 0, 0, 0, 0, 1);
      }
      function $(ae, me, de, ge, Se, xe, Ee, Ce, ke, Re, _e, Me, we, Te, be, Pe) {
        return this.props[0] = ae, this.props[1] = me, this.props[2] = de, this.props[3] = ge, this.props[4] = Se, this.props[5] = xe, this.props[6] = Ee, this.props[7] = Ce, this.props[8] = ke, this.props[9] = Re, this.props[10] = _e, this.props[11] = Me, this.props[12] = we, this.props[13] = Te, this.props[14] = be, this.props[15] = Pe, this;
      }
      function Y(ae, me, de) {
        return de = de || 0, ae !== 0 || me !== 0 || de !== 0 ? this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, ae, me, de, 1) : this;
      }
      function G(ae, me, de, ge, Se, xe, Ee, Ce, ke, Re, _e, Me, we, Te, be, Pe) {
        var ye = this.props;
        if (ae === 1 && me === 0 && de === 0 && ge === 0 && Se === 0 && xe === 1 && Ee === 0 && Ce === 0 && ke === 0 && Re === 0 && _e === 1 && Me === 0) return ye[12] = ye[12] * ae + ye[15] * we, ye[13] = ye[13] * xe + ye[15] * Te, ye[14] = ye[14] * _e + ye[15] * be, ye[15] *= Pe, this._identityCalculated = !1, this;
        var Ae = ye[0], Fe = ye[1], Ie = ye[2], Le = ye[3], De = ye[4], je = ye[5], Ze = ye[6], $e = ye[7], Oe = ye[8], Be = ye[9], Qe = ye[10], Xe = ye[11], rt = ye[12], lt = ye[13], ct = ye[14], Je = ye[15];
        return ye[0] = Ae * ae + Fe * Se + Ie * ke + Le * we, ye[1] = Ae * me + Fe * xe + Ie * Re + Le * Te, ye[2] = Ae * de + Fe * Ee + Ie * _e + Le * be, ye[3] = Ae * ge + Fe * Ce + Ie * Me + Le * Pe, ye[4] = De * ae + je * Se + Ze * ke + $e * we, ye[5] = De * me + je * xe + Ze * Re + $e * Te, ye[6] = De * de + je * Ee + Ze * _e + $e * be, ye[7] = De * ge + je * Ce + Ze * Me + $e * Pe, ye[8] = Oe * ae + Be * Se + Qe * ke + Xe * we, ye[9] = Oe * me + Be * xe + Qe * Re + Xe * Te, ye[10] = Oe * de + Be * Ee + Qe * _e + Xe * be, ye[11] = Oe * ge + Be * Ce + Qe * Me + Xe * Pe, ye[12] = rt * ae + lt * Se + ct * ke + Je * we, ye[13] = rt * me + lt * xe + ct * Re + Je * Te, ye[14] = rt * de + lt * Ee + ct * _e + Je * be, ye[15] = rt * ge + lt * Ce + ct * Me + Je * Pe, this._identityCalculated = !1, this;
      }
      function W(ae) {
        var me = ae.props;
        return this.transform(me[0], me[1], me[2], me[3], me[4], me[5], me[6], me[7], me[8], me[9], me[10], me[11], me[12], me[13], me[14], me[15]);
      }
      function X() {
        return this._identityCalculated || (this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1), this._identityCalculated = !0), this._identity;
      }
      function K(ae) {
        for (var me = 0; me < 16; ) {
          if (ae.props[me] !== this.props[me]) return !1;
          me += 1;
        }
        return !0;
      }
      function J(ae) {
        var me;
        for (me = 0; me < 16; me += 1) ae.props[me] = this.props[me];
        return ae;
      }
      function ee(ae) {
        var me;
        for (me = 0; me < 16; me += 1) this.props[me] = ae[me];
      }
      function te(ae, me, de) {
        return { x: ae * this.props[0] + me * this.props[4] + de * this.props[8] + this.props[12], y: ae * this.props[1] + me * this.props[5] + de * this.props[9] + this.props[13], z: ae * this.props[2] + me * this.props[6] + de * this.props[10] + this.props[14] };
      }
      function ne(ae, me, de) {
        return ae * this.props[0] + me * this.props[4] + de * this.props[8] + this.props[12];
      }
      function re(ae, me, de) {
        return ae * this.props[1] + me * this.props[5] + de * this.props[9] + this.props[13];
      }
      function ie(ae, me, de) {
        return ae * this.props[2] + me * this.props[6] + de * this.props[10] + this.props[14];
      }
      function ue() {
        var ae = this.props[0] * this.props[5] - this.props[1] * this.props[4], me = this.props[5] / ae, de = -this.props[1] / ae, ge = -this.props[4] / ae, Se = this.props[0] / ae, xe = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / ae, Ee = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / ae, Ce = new Matrix();
        return Ce.props[0] = me, Ce.props[1] = de, Ce.props[4] = ge, Ce.props[5] = Se, Ce.props[12] = xe, Ce.props[13] = Ee, Ce;
      }
      function le(ae) {
        return this.getInverseMatrix().applyToPointArray(ae[0], ae[1], ae[2] || 0);
      }
      function oe(ae) {
        var me, de = ae.length, ge = [];
        for (me = 0; me < de; me += 1) ge[me] = le(ae[me]);
        return ge;
      }
      function he(ae, me, de) {
        var ge = createTypedArray("float32", 6);
        if (this.isIdentity()) ge[0] = ae[0], ge[1] = ae[1], ge[2] = me[0], ge[3] = me[1], ge[4] = de[0], ge[5] = de[1];
        else {
          var Se = this.props[0], xe = this.props[1], Ee = this.props[4], Ce = this.props[5], ke = this.props[12], Re = this.props[13];
          ge[0] = ae[0] * Se + ae[1] * Ee + ke, ge[1] = ae[0] * xe + ae[1] * Ce + Re, ge[2] = me[0] * Se + me[1] * Ee + ke, ge[3] = me[0] * xe + me[1] * Ce + Re, ge[4] = de[0] * Se + de[1] * Ee + ke, ge[5] = de[0] * xe + de[1] * Ce + Re;
        }
        return ge;
      }
      function fe(ae, me, de) {
        return this.isIdentity() ? [ae, me, de] : [ae * this.props[0] + me * this.props[4] + de * this.props[8] + this.props[12], ae * this.props[1] + me * this.props[5] + de * this.props[9] + this.props[13], ae * this.props[2] + me * this.props[6] + de * this.props[10] + this.props[14]];
      }
      function ce(ae, me) {
        if (this.isIdentity()) return ae + "," + me;
        var de = this.props;
        return Math.round(100 * (ae * de[0] + me * de[4] + de[12])) / 100 + "," + Math.round(100 * (ae * de[1] + me * de[5] + de[13])) / 100;
      }
      function se() {
        for (var ae = 0, me = this.props, de = "matrix3d("; ae < 16; ) de += a(1e4 * me[ae]) / 1e4, de += ae === 15 ? ")" : ",", ae += 1;
        return de;
      }
      function pe(ae) {
        return ae < 1e-6 && ae > 0 || ae > -1e-6 && ae < 0 ? a(1e4 * ae) / 1e4 : ae;
      }
      function ve() {
        var ae = this.props;
        return "matrix(" + pe(ae[0]) + "," + pe(ae[1]) + "," + pe(ae[4]) + "," + pe(ae[5]) + "," + pe(ae[12]) + "," + pe(ae[13]) + ")";
      }
      return function() {
        this.reset = s, this.rotate = o, this.rotateX = l, this.rotateY = c, this.rotateZ = x, this.skew = Z, this.skewFromAxis = V, this.shear = j, this.scale = U, this.setTransform = $, this.translate = Y, this.transform = G, this.multiply = W, this.applyToPoint = te, this.applyToX = ne, this.applyToY = re, this.applyToZ = ie, this.applyToPointArray = fe, this.applyToTriplePoints = he, this.applyToPointStringified = ce, this.toCSS = se, this.to2dCSS = ve, this.clone = J, this.cloneFromProps = ee, this.equals = K, this.inversePoints = oe, this.inversePoint = le, this.getInverseMatrix = ue, this._t = this.transform, this.isIdentity = X, this._identity = !0, this._identityCalculated = !1, this.props = createTypedArray("float32", 16), this.reset();
      };
    })();
    function _typeof$3(t) {
      return (_typeof$3 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
        return typeof r;
      } : function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      })(t);
    }
    var lottie = {};
    function setLocation(t) {
      setLocationHref(t);
    }
    function searchAnimations() {
      animationManager.searchAnimations();
    }
    function setSubframeRendering(t) {
      setSubframeEnabled(t);
    }
    function setPrefix(t) {
      setIdPrefix(t);
    }
    function loadAnimation(t) {
      return animationManager.loadAnimation(t);
    }
    function setQuality(t) {
      if (typeof t == "string") switch (t) {
        case "high":
          setDefaultCurveSegments(200);
          break;
        default:
        case "medium":
          setDefaultCurveSegments(50);
          break;
        case "low":
          setDefaultCurveSegments(10);
      }
      else !isNaN(t) && t > 1 && setDefaultCurveSegments(t);
    }
    function inBrowser() {
      return typeof navigator != "undefined";
    }
    function installPlugin(t, r) {
      t === "expressions" && setExpressionsPlugin(r);
    }
    function getFactory(t) {
      switch (t) {
        case "propertyFactory":
          return PropertyFactory;
        case "shapePropertyFactory":
          return ShapePropertyFactory;
        case "matrix":
          return Matrix;
        default:
          return null;
      }
    }
    function checkReady() {
      document.readyState === "complete" && (clearInterval(readyStateCheckInterval), searchAnimations());
    }
    function getQueryVariable(t) {
      for (var r = queryString.split("&"), n = 0; n < r.length; n += 1) {
        var a = r[n].split("=");
        if (decodeURIComponent(a[0]) == t) return decodeURIComponent(a[1]);
      }
      return null;
    }
    lottie.play = animationManager.play, lottie.pause = animationManager.pause, lottie.setLocationHref = setLocation, lottie.togglePause = animationManager.togglePause, lottie.setSpeed = animationManager.setSpeed, lottie.setDirection = animationManager.setDirection, lottie.stop = animationManager.stop, lottie.searchAnimations = searchAnimations, lottie.registerAnimation = animationManager.registerAnimation, lottie.loadAnimation = loadAnimation, lottie.setSubframeRendering = setSubframeRendering, lottie.resize = animationManager.resize, lottie.goToAndStop = animationManager.goToAndStop, lottie.destroy = animationManager.destroy, lottie.setQuality = setQuality, lottie.inBrowser = inBrowser, lottie.installPlugin = installPlugin, lottie.freeze = animationManager.freeze, lottie.unfreeze = animationManager.unfreeze, lottie.setVolume = animationManager.setVolume, lottie.mute = animationManager.mute, lottie.unmute = animationManager.unmute, lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations, lottie.useWebWorker = setWebWorker, lottie.setIDPrefix = setPrefix, lottie.__getFactory = getFactory, lottie.version = "5.12.2";
    var queryString = "";
    {
      var scripts = document.getElementsByTagName("script"), index = scripts.length - 1, myScript = scripts[index] || { src: "" };
      queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, "") : "", getQueryVariable("renderer");
    }
    var readyStateCheckInterval = setInterval(checkReady, 100);
    try {
      _typeof$3(exports$1) !== "object" && (window.bodymovin = lottie);
    } catch (t) {
    }
    var ShapeModifiers = (function() {
      var t = {}, r = {};
      return t.registerModifier = function(n, a) {
        r[n] || (r[n] = a);
      }, t.getModifier = function(n, a, s) {
        return new r[n](a, s);
      }, t;
    })();
    function ShapeModifier() {
    }
    function TrimModifier() {
    }
    function PuckerAndBloatModifier() {
    }
    ShapeModifier.prototype.initModifierProperties = function() {
    }, ShapeModifier.prototype.addShapeToModifier = function() {
    }, ShapeModifier.prototype.addShape = function(t) {
      if (!this.closed) {
        t.sh.container.addDynamicProperty(t.sh);
        var r = { shape: t.sh, data: t, localShapeCollection: shapeCollectionPool.newShapeCollection() };
        this.shapes.push(r), this.addShapeToModifier(r), this._isAnimated && t.setAsAnimated();
      }
    }, ShapeModifier.prototype.init = function(t, r) {
      this.shapes = [], this.elem = t, this.initDynamicPropertyContainer(t), this.initModifierProperties(t, r), this.frameId = initialDefaultFrame, this.closed = !1, this.k = !1, this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
    }, ShapeModifier.prototype.processKeys = function() {
      this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties());
    }, extendPrototype([DynamicPropertyContainer], ShapeModifier), extendPrototype([ShapeModifier], TrimModifier), TrimModifier.prototype.initModifierProperties = function(t, r) {
      this.s = PropertyFactory.getProp(t, r.s, 0, 0.01, this), this.e = PropertyFactory.getProp(t, r.e, 0, 0.01, this), this.o = PropertyFactory.getProp(t, r.o, 0, 0, this), this.sValue = 0, this.eValue = 0, this.getValue = this.processKeys, this.m = r.m, this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
    }, TrimModifier.prototype.addShapeToModifier = function(t) {
      t.pathsData = [];
    }, TrimModifier.prototype.calculateShapeEdges = function(t, r, n, a, s) {
      var o = [];
      r <= 1 ? o.push({ s: t, e: r }) : t >= 1 ? o.push({ s: t - 1, e: r - 1 }) : (o.push({ s: t, e: 1 }), o.push({ s: 0, e: r - 1 }));
      var l, c, x = [], j = o.length;
      for (l = 0; l < j; l += 1) {
        var Z, V;
        (c = o[l]).e * s < a || c.s * s > a + n || (Z = c.s * s <= a ? 0 : (c.s * s - a) / n, V = c.e * s >= a + n ? 1 : (c.e * s - a) / n, x.push([Z, V]));
      }
      return x.length || x.push([0, 0]), x;
    }, TrimModifier.prototype.releasePathsData = function(t) {
      var r, n = t.length;
      for (r = 0; r < n; r += 1) segmentsLengthPool.release(t[r]);
      return t.length = 0, t;
    }, TrimModifier.prototype.processShapes = function(t) {
      var r, n, a, s;
      if (this._mdf || t) {
        var o = this.o.v % 360 / 360;
        if (o < 0 && (o += 1), (r = this.s.v > 1 ? 1 + o : this.s.v < 0 ? 0 + o : this.s.v + o) > (n = this.e.v > 1 ? 1 + o : this.e.v < 0 ? 0 + o : this.e.v + o)) {
          var l = r;
          r = n, n = l;
        }
        r = 1e-4 * Math.round(1e4 * r), n = 1e-4 * Math.round(1e4 * n), this.sValue = r, this.eValue = n;
      } else r = this.sValue, n = this.eValue;
      var c, x, j, Z, V, U = this.shapes.length, $ = 0;
      if (n === r) for (s = 0; s < U; s += 1) this.shapes[s].localShapeCollection.releaseShapes(), this.shapes[s].shape._mdf = !0, this.shapes[s].shape.paths = this.shapes[s].localShapeCollection, this._mdf && (this.shapes[s].pathsData.length = 0);
      else if (n === 1 && r === 0 || n === 0 && r === 1) {
        if (this._mdf) for (s = 0; s < U; s += 1) this.shapes[s].pathsData.length = 0, this.shapes[s].shape._mdf = !0;
      } else {
        var Y, G, W = [];
        for (s = 0; s < U; s += 1) if ((Y = this.shapes[s]).shape._mdf || this._mdf || t || this.m === 2) {
          if (x = (a = Y.shape.paths)._length, V = 0, !Y.shape._mdf && Y.pathsData.length) V = Y.totalShapeLength;
          else {
            for (j = this.releasePathsData(Y.pathsData), c = 0; c < x; c += 1) Z = bez.getSegmentsLength(a.shapes[c]), j.push(Z), V += Z.totalLength;
            Y.totalShapeLength = V, Y.pathsData = j;
          }
          $ += V, Y.shape._mdf = !0;
        } else Y.shape.paths = Y.localShapeCollection;
        var X, K = r, J = n, ee = 0;
        for (s = U - 1; s >= 0; s -= 1) if ((Y = this.shapes[s]).shape._mdf) {
          for ((G = Y.localShapeCollection).releaseShapes(), this.m === 2 && U > 1 ? (X = this.calculateShapeEdges(r, n, Y.totalShapeLength, ee, $), ee += Y.totalShapeLength) : X = [[K, J]], x = X.length, c = 0; c < x; c += 1) {
            K = X[c][0], J = X[c][1], W.length = 0, J <= 1 ? W.push({ s: Y.totalShapeLength * K, e: Y.totalShapeLength * J }) : K >= 1 ? W.push({ s: Y.totalShapeLength * (K - 1), e: Y.totalShapeLength * (J - 1) }) : (W.push({ s: Y.totalShapeLength * K, e: Y.totalShapeLength }), W.push({ s: 0, e: Y.totalShapeLength * (J - 1) }));
            var te = this.addShapes(Y, W[0]);
            if (W[0].s !== W[0].e) {
              if (W.length > 1) if (Y.shape.paths.shapes[Y.shape.paths._length - 1].c) {
                var ne = te.pop();
                this.addPaths(te, G), te = this.addShapes(Y, W[1], ne);
              } else this.addPaths(te, G), te = this.addShapes(Y, W[1]);
              this.addPaths(te, G);
            }
          }
          Y.shape.paths = G;
        }
      }
    }, TrimModifier.prototype.addPaths = function(t, r) {
      var n, a = t.length;
      for (n = 0; n < a; n += 1) r.addShape(t[n]);
    }, TrimModifier.prototype.addSegment = function(t, r, n, a, s, o, l) {
      s.setXYAt(r[0], r[1], "o", o), s.setXYAt(n[0], n[1], "i", o + 1), l && s.setXYAt(t[0], t[1], "v", o), s.setXYAt(a[0], a[1], "v", o + 1);
    }, TrimModifier.prototype.addSegmentFromArray = function(t, r, n, a) {
      r.setXYAt(t[1], t[5], "o", n), r.setXYAt(t[2], t[6], "i", n + 1), a && r.setXYAt(t[0], t[4], "v", n), r.setXYAt(t[3], t[7], "v", n + 1);
    }, TrimModifier.prototype.addShapes = function(t, r, n) {
      var a, s, o, l, c, x, j, Z, V = t.pathsData, U = t.shape.paths.shapes, $ = t.shape.paths._length, Y = 0, G = [], W = !0;
      for (n ? (c = n._length, Z = n._length) : (n = shapePool.newElement(), c = 0, Z = 0), G.push(n), a = 0; a < $; a += 1) {
        for (x = V[a].lengths, n.c = U[a].c, o = U[a].c ? x.length : x.length + 1, s = 1; s < o; s += 1) if (Y + (l = x[s - 1]).addedLength < r.s) Y += l.addedLength, n.c = !1;
        else {
          if (Y > r.e) {
            n.c = !1;
            break;
          }
          r.s <= Y && r.e >= Y + l.addedLength ? (this.addSegment(U[a].v[s - 1], U[a].o[s - 1], U[a].i[s], U[a].v[s], n, c, W), W = !1) : (j = bez.getNewSegment(U[a].v[s - 1], U[a].v[s], U[a].o[s - 1], U[a].i[s], (r.s - Y) / l.addedLength, (r.e - Y) / l.addedLength, x[s - 1]), this.addSegmentFromArray(j, n, c, W), W = !1, n.c = !1), Y += l.addedLength, c += 1;
        }
        if (U[a].c && x.length) {
          if (l = x[s - 1], Y <= r.e) {
            var X = x[s - 1].addedLength;
            r.s <= Y && r.e >= Y + X ? (this.addSegment(U[a].v[s - 1], U[a].o[s - 1], U[a].i[0], U[a].v[0], n, c, W), W = !1) : (j = bez.getNewSegment(U[a].v[s - 1], U[a].v[0], U[a].o[s - 1], U[a].i[0], (r.s - Y) / X, (r.e - Y) / X, x[s - 1]), this.addSegmentFromArray(j, n, c, W), W = !1, n.c = !1);
          } else n.c = !1;
          Y += l.addedLength, c += 1;
        }
        if (n._length && (n.setXYAt(n.v[Z][0], n.v[Z][1], "i", Z), n.setXYAt(n.v[n._length - 1][0], n.v[n._length - 1][1], "o", n._length - 1)), Y > r.e) break;
        a < $ - 1 && (n = shapePool.newElement(), W = !0, G.push(n), c = 0);
      }
      return G;
    }, extendPrototype([ShapeModifier], PuckerAndBloatModifier), PuckerAndBloatModifier.prototype.initModifierProperties = function(t, r) {
      this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(t, r.a, 0, null, this), this._isAnimated = !!this.amount.effectsSequence.length;
    }, PuckerAndBloatModifier.prototype.processPath = function(t, r) {
      var n = r / 100, a = [0, 0], s = t._length, o = 0;
      for (o = 0; o < s; o += 1) a[0] += t.v[o][0], a[1] += t.v[o][1];
      a[0] /= s, a[1] /= s;
      var l, c, x, j, Z, V, U = shapePool.newElement();
      for (U.c = t.c, o = 0; o < s; o += 1) l = t.v[o][0] + (a[0] - t.v[o][0]) * n, c = t.v[o][1] + (a[1] - t.v[o][1]) * n, x = t.o[o][0] + (a[0] - t.o[o][0]) * -n, j = t.o[o][1] + (a[1] - t.o[o][1]) * -n, Z = t.i[o][0] + (a[0] - t.i[o][0]) * -n, V = t.i[o][1] + (a[1] - t.i[o][1]) * -n, U.setTripleAt(l, c, x, j, Z, V, o);
      return U;
    }, PuckerAndBloatModifier.prototype.processShapes = function(t) {
      var r, n, a, s, o, l, c = this.shapes.length, x = this.amount.v;
      if (x !== 0) for (n = 0; n < c; n += 1) {
        if (l = (o = this.shapes[n]).localShapeCollection, o.shape._mdf || this._mdf || t) for (l.releaseShapes(), o.shape._mdf = !0, r = o.shape.paths.shapes, s = o.shape.paths._length, a = 0; a < s; a += 1) l.addShape(this.processPath(r[a], x));
        o.shape.paths = o.localShapeCollection;
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    var TransformPropertyFactory = (function() {
      var t = [0, 0];
      function r(n, a, s) {
        if (this.elem = n, this.frameId = -1, this.propType = "transform", this.data = a, this.v = new Matrix(), this.pre = new Matrix(), this.appliedTransformations = 0, this.initDynamicPropertyContainer(s || n), a.p && a.p.s ? (this.px = PropertyFactory.getProp(n, a.p.x, 0, 0, this), this.py = PropertyFactory.getProp(n, a.p.y, 0, 0, this), a.p.z && (this.pz = PropertyFactory.getProp(n, a.p.z, 0, 0, this))) : this.p = PropertyFactory.getProp(n, a.p || { k: [0, 0, 0] }, 1, 0, this), a.rx) {
          if (this.rx = PropertyFactory.getProp(n, a.rx, 0, degToRads, this), this.ry = PropertyFactory.getProp(n, a.ry, 0, degToRads, this), this.rz = PropertyFactory.getProp(n, a.rz, 0, degToRads, this), a.or.k[0].ti) {
            var o, l = a.or.k.length;
            for (o = 0; o < l; o += 1) a.or.k[o].to = null, a.or.k[o].ti = null;
          }
          this.or = PropertyFactory.getProp(n, a.or, 1, degToRads, this), this.or.sh = !0;
        } else this.r = PropertyFactory.getProp(n, a.r || { k: 0 }, 0, degToRads, this);
        a.sk && (this.sk = PropertyFactory.getProp(n, a.sk, 0, degToRads, this), this.sa = PropertyFactory.getProp(n, a.sa, 0, degToRads, this)), this.a = PropertyFactory.getProp(n, a.a || { k: [0, 0, 0] }, 1, 0, this), this.s = PropertyFactory.getProp(n, a.s || { k: [100, 100, 100] }, 1, 0.01, this), a.o ? this.o = PropertyFactory.getProp(n, a.o, 0, 0.01, n) : this.o = { _mdf: !1, v: 1 }, this._isDirty = !0, this.dynamicProperties.length || this.getValue(!0);
      }
      return r.prototype = { applyToMatrix: function(n) {
        var a = this._mdf;
        this.iterateDynamicProperties(), this._mdf = this._mdf || a, this.a && n.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.s && n.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && n.skewFromAxis(-this.sk.v, this.sa.v), this.r ? n.rotate(-this.r.v) : n.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.data.p.s ? this.data.p.z ? n.translate(this.px.v, this.py.v, -this.pz.v) : n.translate(this.px.v, this.py.v, 0) : n.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
      }, getValue: function(n) {
        if (this.elem.globalData.frameId !== this.frameId) {
          if (this._isDirty && (this.precalculateMatrix(), this._isDirty = !1), this.iterateDynamicProperties(), this._mdf || n) {
            var a;
            if (this.v.cloneFromProps(this.pre.props), this.appliedTransformations < 1 && this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations < 2 && this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && this.appliedTransformations < 3 && this.v.skewFromAxis(-this.sk.v, this.sa.v), this.r && this.appliedTransformations < 4 ? this.v.rotate(-this.r.v) : !this.r && this.appliedTransformations < 4 && this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.autoOriented) {
              var s, o;
              if (a = this.elem.globalData.frameRate, this.p && this.p.keyframes && this.p.getValueAtTime) this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t ? (s = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / a, 0), o = this.p.getValueAtTime(this.p.keyframes[0].t / a, 0)) : this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t ? (s = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / a, 0), o = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / a, 0)) : (s = this.p.pv, o = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / a, this.p.offsetTime));
              else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                s = [], o = [];
                var l = this.px, c = this.py;
                l._caching.lastFrame + l.offsetTime <= l.keyframes[0].t ? (s[0] = l.getValueAtTime((l.keyframes[0].t + 0.01) / a, 0), s[1] = c.getValueAtTime((c.keyframes[0].t + 0.01) / a, 0), o[0] = l.getValueAtTime(l.keyframes[0].t / a, 0), o[1] = c.getValueAtTime(c.keyframes[0].t / a, 0)) : l._caching.lastFrame + l.offsetTime >= l.keyframes[l.keyframes.length - 1].t ? (s[0] = l.getValueAtTime(l.keyframes[l.keyframes.length - 1].t / a, 0), s[1] = c.getValueAtTime(c.keyframes[c.keyframes.length - 1].t / a, 0), o[0] = l.getValueAtTime((l.keyframes[l.keyframes.length - 1].t - 0.01) / a, 0), o[1] = c.getValueAtTime((c.keyframes[c.keyframes.length - 1].t - 0.01) / a, 0)) : (s = [l.pv, c.pv], o[0] = l.getValueAtTime((l._caching.lastFrame + l.offsetTime - 0.01) / a, l.offsetTime), o[1] = c.getValueAtTime((c._caching.lastFrame + c.offsetTime - 0.01) / a, c.offsetTime));
              } else s = o = t;
              this.v.rotate(-Math.atan2(s[1] - o[1], s[0] - o[0]));
            }
            this.data.p && this.data.p.s ? this.data.p.z ? this.v.translate(this.px.v, this.py.v, -this.pz.v) : this.v.translate(this.px.v, this.py.v, 0) : this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
          }
          this.frameId = this.elem.globalData.frameId;
        }
      }, precalculateMatrix: function() {
        if (this.appliedTransformations = 0, this.pre.reset(), !this.a.effectsSequence.length && (this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations = 1, !this.s.effectsSequence.length)) {
          if (this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.appliedTransformations = 2, this.sk) {
            if (this.sk.effectsSequence.length || this.sa.effectsSequence.length) return;
            this.pre.skewFromAxis(-this.sk.v, this.sa.v), this.appliedTransformations = 3;
          }
          this.r ? this.r.effectsSequence.length || (this.pre.rotate(-this.r.v), this.appliedTransformations = 4) : this.rz.effectsSequence.length || this.ry.effectsSequence.length || this.rx.effectsSequence.length || this.or.effectsSequence.length || (this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.appliedTransformations = 4);
        }
      }, autoOrient: function() {
      } }, extendPrototype([DynamicPropertyContainer], r), r.prototype.addDynamicProperty = function(n) {
        this._addDynamicProperty(n), this.elem.addDynamicProperty(n), this._isDirty = !0;
      }, r.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty, { getTransformProperty: function(n, a, s) {
        return new r(n, a, s);
      } };
    })();
    function RepeaterModifier() {
    }
    function RoundCornersModifier() {
    }
    function floatEqual(t, r) {
      return 1e5 * Math.abs(t - r) <= Math.min(Math.abs(t), Math.abs(r));
    }
    function floatZero(t) {
      return Math.abs(t) <= 1e-5;
    }
    function lerp(t, r, n) {
      return t * (1 - n) + r * n;
    }
    function lerpPoint(t, r, n) {
      return [lerp(t[0], r[0], n), lerp(t[1], r[1], n)];
    }
    function quadRoots(t, r, n) {
      if (t === 0) return [];
      var a = r * r - 4 * t * n;
      if (a < 0) return [];
      var s = -r / (2 * t);
      if (a === 0) return [s];
      var o = Math.sqrt(a) / (2 * t);
      return [s - o, s + o];
    }
    function polynomialCoefficients(t, r, n, a) {
      return [3 * r - t - 3 * n + a, 3 * t - 6 * r + 3 * n, -3 * t + 3 * r, t];
    }
    function singlePoint(t) {
      return new PolynomialBezier(t, t, t, t, !1);
    }
    function PolynomialBezier(t, r, n, a, s) {
      s && pointEqual(t, r) && (r = lerpPoint(t, a, 1 / 3)), s && pointEqual(n, a) && (n = lerpPoint(t, a, 2 / 3));
      var o = polynomialCoefficients(t[0], r[0], n[0], a[0]), l = polynomialCoefficients(t[1], r[1], n[1], a[1]);
      this.a = [o[0], l[0]], this.b = [o[1], l[1]], this.c = [o[2], l[2]], this.d = [o[3], l[3]], this.points = [t, r, n, a];
    }
    function extrema(t, r) {
      var n = t.points[0][r], a = t.points[t.points.length - 1][r];
      if (n > a) {
        var s = a;
        a = n, n = s;
      }
      for (var o = quadRoots(3 * t.a[r], 2 * t.b[r], t.c[r]), l = 0; l < o.length; l += 1) if (o[l] > 0 && o[l] < 1) {
        var c = t.point(o[l])[r];
        c < n ? n = c : c > a && (a = c);
      }
      return { min: n, max: a };
    }
    function intersectData(t, r, n) {
      var a = t.boundingBox();
      return { cx: a.cx, cy: a.cy, width: a.width, height: a.height, bez: t, t: (r + n) / 2, t1: r, t2: n };
    }
    function splitData(t) {
      var r = t.bez.split(0.5);
      return [intersectData(r[0], t.t1, t.t), intersectData(r[1], t.t, t.t2)];
    }
    function boxIntersect(t, r) {
      return 2 * Math.abs(t.cx - r.cx) < t.width + r.width && 2 * Math.abs(t.cy - r.cy) < t.height + r.height;
    }
    function intersectsImpl(t, r, n, a, s, o) {
      if (boxIntersect(t, r)) if (n >= o || t.width <= a && t.height <= a && r.width <= a && r.height <= a) s.push([t.t, r.t]);
      else {
        var l = splitData(t), c = splitData(r);
        intersectsImpl(l[0], c[0], n + 1, a, s, o), intersectsImpl(l[0], c[1], n + 1, a, s, o), intersectsImpl(l[1], c[0], n + 1, a, s, o), intersectsImpl(l[1], c[1], n + 1, a, s, o);
      }
    }
    function crossProduct(t, r) {
      return [t[1] * r[2] - t[2] * r[1], t[2] * r[0] - t[0] * r[2], t[0] * r[1] - t[1] * r[0]];
    }
    function lineIntersection(t, r, n, a) {
      var s = [t[0], t[1], 1], o = [r[0], r[1], 1], l = [n[0], n[1], 1], c = [a[0], a[1], 1], x = crossProduct(crossProduct(s, o), crossProduct(l, c));
      return floatZero(x[2]) ? null : [x[0] / x[2], x[1] / x[2]];
    }
    function polarOffset(t, r, n) {
      return [t[0] + Math.cos(r) * n, t[1] - Math.sin(r) * n];
    }
    function pointDistance(t, r) {
      return Math.hypot(t[0] - r[0], t[1] - r[1]);
    }
    function pointEqual(t, r) {
      return floatEqual(t[0], r[0]) && floatEqual(t[1], r[1]);
    }
    function ZigZagModifier() {
    }
    function setPoint(t, r, n, a, s, o, l) {
      var c = n - Math.PI / 2, x = n + Math.PI / 2, j = r[0] + Math.cos(n) * a * s, Z = r[1] - Math.sin(n) * a * s;
      t.setTripleAt(j, Z, j + Math.cos(c) * o, Z - Math.sin(c) * o, j + Math.cos(x) * l, Z - Math.sin(x) * l, t.length());
    }
    function getPerpendicularVector(t, r) {
      var n = [r[0] - t[0], r[1] - t[1]], a = 0.5 * -Math.PI;
      return [Math.cos(a) * n[0] - Math.sin(a) * n[1], Math.sin(a) * n[0] + Math.cos(a) * n[1]];
    }
    function getProjectingAngle(t, r) {
      var n = r === 0 ? t.length() - 1 : r - 1, a = (r + 1) % t.length(), s = getPerpendicularVector(t.v[n], t.v[a]);
      return Math.atan2(0, 1) - Math.atan2(s[1], s[0]);
    }
    function zigZagCorner(t, r, n, a, s, o, l) {
      var c = getProjectingAngle(r, n), x = r.v[n % r._length], j = r.v[n === 0 ? r._length - 1 : n - 1], Z = r.v[(n + 1) % r._length], V = o === 2 ? Math.sqrt(Math.pow(x[0] - j[0], 2) + Math.pow(x[1] - j[1], 2)) : 0, U = o === 2 ? Math.sqrt(Math.pow(x[0] - Z[0], 2) + Math.pow(x[1] - Z[1], 2)) : 0;
      setPoint(t, r.v[n % r._length], c, l, a, U / (2 * (s + 1)), V / (2 * (s + 1)));
    }
    function zigZagSegment(t, r, n, a, s, o) {
      for (var l = 0; l < a; l += 1) {
        var c = (l + 1) / (a + 1), x = s === 2 ? Math.sqrt(Math.pow(r.points[3][0] - r.points[0][0], 2) + Math.pow(r.points[3][1] - r.points[0][1], 2)) : 0, j = r.normalAngle(c);
        setPoint(t, r.point(c), j, o, n, x / (2 * (a + 1)), x / (2 * (a + 1))), o = -o;
      }
      return o;
    }
    function linearOffset(t, r, n) {
      var a = Math.atan2(r[0] - t[0], r[1] - t[1]);
      return [polarOffset(t, a, n), polarOffset(r, a, n)];
    }
    function offsetSegment(t, r) {
      var n, a, s, o, l, c, x;
      n = (x = linearOffset(t.points[0], t.points[1], r))[0], a = x[1], s = (x = linearOffset(t.points[1], t.points[2], r))[0], o = x[1], l = (x = linearOffset(t.points[2], t.points[3], r))[0], c = x[1];
      var j = lineIntersection(n, a, s, o);
      j === null && (j = a);
      var Z = lineIntersection(l, c, s, o);
      return Z === null && (Z = l), new PolynomialBezier(n, j, Z, c);
    }
    function joinLines(t, r, n, a, s) {
      var o = r.points[3], l = n.points[0];
      if (a === 3 || pointEqual(o, l)) return o;
      if (a === 2) {
        var c = -r.tangentAngle(1), x = -n.tangentAngle(0) + Math.PI, j = lineIntersection(o, polarOffset(o, c + Math.PI / 2, 100), l, polarOffset(l, c + Math.PI / 2, 100)), Z = j ? pointDistance(j, o) : pointDistance(o, l) / 2, V = polarOffset(o, c, 2 * Z * roundCorner);
        return t.setXYAt(V[0], V[1], "o", t.length() - 1), V = polarOffset(l, x, 2 * Z * roundCorner), t.setTripleAt(l[0], l[1], l[0], l[1], V[0], V[1], t.length()), l;
      }
      var U = lineIntersection(pointEqual(o, r.points[2]) ? r.points[0] : r.points[2], o, l, pointEqual(l, n.points[1]) ? n.points[3] : n.points[1]);
      return U && pointDistance(U, o) < s ? (t.setTripleAt(U[0], U[1], U[0], U[1], U[0], U[1], t.length()), U) : o;
    }
    function getIntersection(t, r) {
      var n = t.intersections(r);
      return n.length && floatEqual(n[0][0], 1) && n.shift(), n.length ? n[0] : null;
    }
    function pruneSegmentIntersection(t, r) {
      var n = t.slice(), a = r.slice(), s = getIntersection(t[t.length - 1], r[0]);
      return s && (n[t.length - 1] = t[t.length - 1].split(s[0])[0], a[0] = r[0].split(s[1])[1]), t.length > 1 && r.length > 1 && (s = getIntersection(t[0], r[r.length - 1])) ? [[t[0].split(s[0])[0]], [r[r.length - 1].split(s[1])[1]]] : [n, a];
    }
    function pruneIntersections(t) {
      for (var r, n = 1; n < t.length; n += 1) r = pruneSegmentIntersection(t[n - 1], t[n]), t[n - 1] = r[0], t[n] = r[1];
      return t.length > 1 && (r = pruneSegmentIntersection(t[t.length - 1], t[0]), t[t.length - 1] = r[0], t[0] = r[1]), t;
    }
    function offsetSegmentSplit(t, r) {
      var n, a, s, o, l = t.inflectionPoints();
      if (l.length === 0) return [offsetSegment(t, r)];
      if (l.length === 1 || floatEqual(l[1], 1)) return n = (s = t.split(l[0]))[0], a = s[1], [offsetSegment(n, r), offsetSegment(a, r)];
      n = (s = t.split(l[0]))[0];
      var c = (l[1] - l[0]) / (1 - l[0]);
      return o = (s = s[1].split(c))[0], a = s[1], [offsetSegment(n, r), offsetSegment(o, r), offsetSegment(a, r)];
    }
    function OffsetPathModifier() {
    }
    function getFontProperties(t) {
      for (var r = t.fStyle ? t.fStyle.split(" ") : [], n = "normal", a = "normal", s = r.length, o = 0; o < s; o += 1) switch (r[o].toLowerCase()) {
        case "italic":
          a = "italic";
          break;
        case "bold":
          n = "700";
          break;
        case "black":
          n = "900";
          break;
        case "medium":
          n = "500";
          break;
        case "regular":
        case "normal":
          n = "400";
          break;
        case "light":
        case "thin":
          n = "200";
      }
      return { style: a, weight: t.fWeight || n };
    }
    extendPrototype([ShapeModifier], RepeaterModifier), RepeaterModifier.prototype.initModifierProperties = function(t, r) {
      this.getValue = this.processKeys, this.c = PropertyFactory.getProp(t, r.c, 0, null, this), this.o = PropertyFactory.getProp(t, r.o, 0, null, this), this.tr = TransformPropertyFactory.getTransformProperty(t, r.tr, this), this.so = PropertyFactory.getProp(t, r.tr.so, 0, 0.01, this), this.eo = PropertyFactory.getProp(t, r.tr.eo, 0, 0.01, this), this.data = r, this.dynamicProperties.length || this.getValue(!0), this._isAnimated = !!this.dynamicProperties.length, this.pMatrix = new Matrix(), this.rMatrix = new Matrix(), this.sMatrix = new Matrix(), this.tMatrix = new Matrix(), this.matrix = new Matrix();
    }, RepeaterModifier.prototype.applyTransforms = function(t, r, n, a, s, o) {
      var l = o ? -1 : 1, c = a.s.v[0] + (1 - a.s.v[0]) * (1 - s), x = a.s.v[1] + (1 - a.s.v[1]) * (1 - s);
      t.translate(a.p.v[0] * l * s, a.p.v[1] * l * s, a.p.v[2]), r.translate(-a.a.v[0], -a.a.v[1], a.a.v[2]), r.rotate(-a.r.v * l * s), r.translate(a.a.v[0], a.a.v[1], a.a.v[2]), n.translate(-a.a.v[0], -a.a.v[1], a.a.v[2]), n.scale(o ? 1 / c : c, o ? 1 / x : x), n.translate(a.a.v[0], a.a.v[1], a.a.v[2]);
    }, RepeaterModifier.prototype.init = function(t, r, n, a) {
      for (this.elem = t, this.arr = r, this.pos = n, this.elemsData = a, this._currentCopies = 0, this._elements = [], this._groups = [], this.frameId = -1, this.initDynamicPropertyContainer(t), this.initModifierProperties(t, r[n]); n > 0; ) n -= 1, this._elements.unshift(r[n]);
      this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
    }, RepeaterModifier.prototype.resetElements = function(t) {
      var r, n = t.length;
      for (r = 0; r < n; r += 1) t[r]._processed = !1, t[r].ty === "gr" && this.resetElements(t[r].it);
    }, RepeaterModifier.prototype.cloneElements = function(t) {
      var r = JSON.parse(JSON.stringify(t));
      return this.resetElements(r), r;
    }, RepeaterModifier.prototype.changeGroupRender = function(t, r) {
      var n, a = t.length;
      for (n = 0; n < a; n += 1) t[n]._render = r, t[n].ty === "gr" && this.changeGroupRender(t[n].it, r);
    }, RepeaterModifier.prototype.processShapes = function(t) {
      var r, n, a, s, o, l = !1;
      if (this._mdf || t) {
        var c, x = Math.ceil(this.c.v);
        if (this._groups.length < x) {
          for (; this._groups.length < x; ) {
            var j = { it: this.cloneElements(this._elements), ty: "gr" };
            j.it.push({ a: { a: 0, ix: 1, k: [0, 0] }, nm: "Transform", o: { a: 0, ix: 7, k: 100 }, p: { a: 0, ix: 2, k: [0, 0] }, r: { a: 1, ix: 6, k: [{ s: 0, e: 0, t: 0 }, { s: 0, e: 0, t: 1 }] }, s: { a: 0, ix: 3, k: [100, 100] }, sa: { a: 0, ix: 5, k: 0 }, sk: { a: 0, ix: 4, k: 0 }, ty: "tr" }), this.arr.splice(0, 0, j), this._groups.splice(0, 0, j), this._currentCopies += 1;
          }
          this.elem.reloadShapes(), l = !0;
        }
        for (o = 0, a = 0; a <= this._groups.length - 1; a += 1) {
          if (c = o < x, this._groups[a]._render = c, this.changeGroupRender(this._groups[a].it, c), !c) {
            var Z = this.elemsData[a].it, V = Z[Z.length - 1];
            V.transform.op.v !== 0 ? (V.transform.op._mdf = !0, V.transform.op.v = 0) : V.transform.op._mdf = !1;
          }
          o += 1;
        }
        this._currentCopies = x;
        var U = this.o.v, $ = U % 1, Y = U > 0 ? Math.floor(U) : Math.ceil(U), G = this.pMatrix.props, W = this.rMatrix.props, X = this.sMatrix.props;
        this.pMatrix.reset(), this.rMatrix.reset(), this.sMatrix.reset(), this.tMatrix.reset(), this.matrix.reset();
        var K, J, ee = 0;
        if (U > 0) {
          for (; ee < Y; ) this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), ee += 1;
          $ && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, $, !1), ee += $);
        } else if (U < 0) {
          for (; ee > Y; ) this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !0), ee -= 1;
          $ && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -$, !0), ee -= $);
        }
        for (a = this.data.m === 1 ? 0 : this._currentCopies - 1, s = this.data.m === 1 ? 1 : -1, o = this._currentCopies; o; ) {
          if (J = (n = (r = this.elemsData[a].it)[r.length - 1].transform.mProps.v.props).length, r[r.length - 1].transform.mProps._mdf = !0, r[r.length - 1].transform.op._mdf = !0, r[r.length - 1].transform.op.v = this._currentCopies === 1 ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (a / (this._currentCopies - 1)), ee !== 0) {
            for ((a !== 0 && s === 1 || a !== this._currentCopies - 1 && s === -1) && this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), this.matrix.transform(W[0], W[1], W[2], W[3], W[4], W[5], W[6], W[7], W[8], W[9], W[10], W[11], W[12], W[13], W[14], W[15]), this.matrix.transform(X[0], X[1], X[2], X[3], X[4], X[5], X[6], X[7], X[8], X[9], X[10], X[11], X[12], X[13], X[14], X[15]), this.matrix.transform(G[0], G[1], G[2], G[3], G[4], G[5], G[6], G[7], G[8], G[9], G[10], G[11], G[12], G[13], G[14], G[15]), K = 0; K < J; K += 1) n[K] = this.matrix.props[K];
            this.matrix.reset();
          } else for (this.matrix.reset(), K = 0; K < J; K += 1) n[K] = this.matrix.props[K];
          ee += 1, o -= 1, a += s;
        }
      } else for (o = this._currentCopies, a = 0, s = 1; o; ) n = (r = this.elemsData[a].it)[r.length - 1].transform.mProps.v.props, r[r.length - 1].transform.mProps._mdf = !1, r[r.length - 1].transform.op._mdf = !1, o -= 1, a += s;
      return l;
    }, RepeaterModifier.prototype.addShape = function() {
    }, extendPrototype([ShapeModifier], RoundCornersModifier), RoundCornersModifier.prototype.initModifierProperties = function(t, r) {
      this.getValue = this.processKeys, this.rd = PropertyFactory.getProp(t, r.r, 0, null, this), this._isAnimated = !!this.rd.effectsSequence.length;
    }, RoundCornersModifier.prototype.processPath = function(t, r) {
      var n, a = shapePool.newElement();
      a.c = t.c;
      var s, o, l, c, x, j, Z, V, U, $, Y, G, W = t._length, X = 0;
      for (n = 0; n < W; n += 1) s = t.v[n], l = t.o[n], o = t.i[n], s[0] === l[0] && s[1] === l[1] && s[0] === o[0] && s[1] === o[1] ? n !== 0 && n !== W - 1 || t.c ? (c = n === 0 ? t.v[W - 1] : t.v[n - 1], j = (x = Math.sqrt(Math.pow(s[0] - c[0], 2) + Math.pow(s[1] - c[1], 2))) ? Math.min(x / 2, r) / x : 0, Z = Y = s[0] + (c[0] - s[0]) * j, V = G = s[1] - (s[1] - c[1]) * j, U = Z - (Z - s[0]) * roundCorner, $ = V - (V - s[1]) * roundCorner, a.setTripleAt(Z, V, U, $, Y, G, X), X += 1, c = n === W - 1 ? t.v[0] : t.v[n + 1], j = (x = Math.sqrt(Math.pow(s[0] - c[0], 2) + Math.pow(s[1] - c[1], 2))) ? Math.min(x / 2, r) / x : 0, Z = U = s[0] + (c[0] - s[0]) * j, V = $ = s[1] + (c[1] - s[1]) * j, Y = Z - (Z - s[0]) * roundCorner, G = V - (V - s[1]) * roundCorner, a.setTripleAt(Z, V, U, $, Y, G, X), X += 1) : (a.setTripleAt(s[0], s[1], l[0], l[1], o[0], o[1], X), X += 1) : (a.setTripleAt(t.v[n][0], t.v[n][1], t.o[n][0], t.o[n][1], t.i[n][0], t.i[n][1], X), X += 1);
      return a;
    }, RoundCornersModifier.prototype.processShapes = function(t) {
      var r, n, a, s, o, l, c = this.shapes.length, x = this.rd.v;
      if (x !== 0) for (n = 0; n < c; n += 1) {
        if (l = (o = this.shapes[n]).localShapeCollection, o.shape._mdf || this._mdf || t) for (l.releaseShapes(), o.shape._mdf = !0, r = o.shape.paths.shapes, s = o.shape.paths._length, a = 0; a < s; a += 1) l.addShape(this.processPath(r[a], x));
        o.shape.paths = o.localShapeCollection;
      }
      this.dynamicProperties.length || (this._mdf = !1);
    }, PolynomialBezier.prototype.point = function(t) {
      return [((this.a[0] * t + this.b[0]) * t + this.c[0]) * t + this.d[0], ((this.a[1] * t + this.b[1]) * t + this.c[1]) * t + this.d[1]];
    }, PolynomialBezier.prototype.derivative = function(t) {
      return [(3 * t * this.a[0] + 2 * this.b[0]) * t + this.c[0], (3 * t * this.a[1] + 2 * this.b[1]) * t + this.c[1]];
    }, PolynomialBezier.prototype.tangentAngle = function(t) {
      var r = this.derivative(t);
      return Math.atan2(r[1], r[0]);
    }, PolynomialBezier.prototype.normalAngle = function(t) {
      var r = this.derivative(t);
      return Math.atan2(r[0], r[1]);
    }, PolynomialBezier.prototype.inflectionPoints = function() {
      var t = this.a[1] * this.b[0] - this.a[0] * this.b[1];
      if (floatZero(t)) return [];
      var r = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / t, n = r * r - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / t;
      if (n < 0) return [];
      var a = Math.sqrt(n);
      return floatZero(a) ? a > 0 && a < 1 ? [r] : [] : [r - a, r + a].filter((function(s) {
        return s > 0 && s < 1;
      }));
    }, PolynomialBezier.prototype.split = function(t) {
      if (t <= 0) return [singlePoint(this.points[0]), this];
      if (t >= 1) return [this, singlePoint(this.points[this.points.length - 1])];
      var r = lerpPoint(this.points[0], this.points[1], t), n = lerpPoint(this.points[1], this.points[2], t), a = lerpPoint(this.points[2], this.points[3], t), s = lerpPoint(r, n, t), o = lerpPoint(n, a, t), l = lerpPoint(s, o, t);
      return [new PolynomialBezier(this.points[0], r, s, l, !0), new PolynomialBezier(l, o, a, this.points[3], !0)];
    }, PolynomialBezier.prototype.bounds = function() {
      return { x: extrema(this, 0), y: extrema(this, 1) };
    }, PolynomialBezier.prototype.boundingBox = function() {
      var t = this.bounds();
      return { left: t.x.min, right: t.x.max, top: t.y.min, bottom: t.y.max, width: t.x.max - t.x.min, height: t.y.max - t.y.min, cx: (t.x.max + t.x.min) / 2, cy: (t.y.max + t.y.min) / 2 };
    }, PolynomialBezier.prototype.intersections = function(t, r, n) {
      r === void 0 && (r = 2), n === void 0 && (n = 7);
      var a = [];
      return intersectsImpl(intersectData(this, 0, 1), intersectData(t, 0, 1), 0, r, a, n), a;
    }, PolynomialBezier.shapeSegment = function(t, r) {
      var n = (r + 1) % t.length();
      return new PolynomialBezier(t.v[r], t.o[r], t.i[n], t.v[n], !0);
    }, PolynomialBezier.shapeSegmentInverted = function(t, r) {
      var n = (r + 1) % t.length();
      return new PolynomialBezier(t.v[n], t.i[n], t.o[r], t.v[r], !0);
    }, extendPrototype([ShapeModifier], ZigZagModifier), ZigZagModifier.prototype.initModifierProperties = function(t, r) {
      this.getValue = this.processKeys, this.amplitude = PropertyFactory.getProp(t, r.s, 0, null, this), this.frequency = PropertyFactory.getProp(t, r.r, 0, null, this), this.pointsType = PropertyFactory.getProp(t, r.pt, 0, null, this), this._isAnimated = this.amplitude.effectsSequence.length !== 0 || this.frequency.effectsSequence.length !== 0 || this.pointsType.effectsSequence.length !== 0;
    }, ZigZagModifier.prototype.processPath = function(t, r, n, a) {
      var s = t._length, o = shapePool.newElement();
      if (o.c = t.c, t.c || (s -= 1), s === 0) return o;
      var l = -1, c = PolynomialBezier.shapeSegment(t, 0);
      zigZagCorner(o, t, 0, r, n, a, l);
      for (var x = 0; x < s; x += 1) l = zigZagSegment(o, c, r, n, a, -l), c = x !== s - 1 || t.c ? PolynomialBezier.shapeSegment(t, (x + 1) % s) : null, zigZagCorner(o, t, x + 1, r, n, a, l);
      return o;
    }, ZigZagModifier.prototype.processShapes = function(t) {
      var r, n, a, s, o, l, c = this.shapes.length, x = this.amplitude.v, j = Math.max(0, Math.round(this.frequency.v)), Z = this.pointsType.v;
      if (x !== 0) for (n = 0; n < c; n += 1) {
        if (l = (o = this.shapes[n]).localShapeCollection, o.shape._mdf || this._mdf || t) for (l.releaseShapes(), o.shape._mdf = !0, r = o.shape.paths.shapes, s = o.shape.paths._length, a = 0; a < s; a += 1) l.addShape(this.processPath(r[a], x, j, Z));
        o.shape.paths = o.localShapeCollection;
      }
      this.dynamicProperties.length || (this._mdf = !1);
    }, extendPrototype([ShapeModifier], OffsetPathModifier), OffsetPathModifier.prototype.initModifierProperties = function(t, r) {
      this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(t, r.a, 0, null, this), this.miterLimit = PropertyFactory.getProp(t, r.ml, 0, null, this), this.lineJoin = r.lj, this._isAnimated = this.amount.effectsSequence.length !== 0;
    }, OffsetPathModifier.prototype.processPath = function(t, r, n, a) {
      var s = shapePool.newElement();
      s.c = t.c;
      var o, l, c, x = t.length();
      t.c || (x -= 1);
      var j = [];
      for (o = 0; o < x; o += 1) c = PolynomialBezier.shapeSegment(t, o), j.push(offsetSegmentSplit(c, r));
      if (!t.c) for (o = x - 1; o >= 0; o -= 1) c = PolynomialBezier.shapeSegmentInverted(t, o), j.push(offsetSegmentSplit(c, r));
      j = pruneIntersections(j);
      var Z = null, V = null;
      for (o = 0; o < j.length; o += 1) {
        var U = j[o];
        for (V && (Z = joinLines(s, V, U[0], n, a)), V = U[U.length - 1], l = 0; l < U.length; l += 1) c = U[l], Z && pointEqual(c.points[0], Z) ? s.setXYAt(c.points[1][0], c.points[1][1], "o", s.length() - 1) : s.setTripleAt(c.points[0][0], c.points[0][1], c.points[1][0], c.points[1][1], c.points[0][0], c.points[0][1], s.length()), s.setTripleAt(c.points[3][0], c.points[3][1], c.points[3][0], c.points[3][1], c.points[2][0], c.points[2][1], s.length()), Z = c.points[3];
      }
      return j.length && joinLines(s, V, j[0][0], n, a), s;
    }, OffsetPathModifier.prototype.processShapes = function(t) {
      var r, n, a, s, o, l, c = this.shapes.length, x = this.amount.v, j = this.miterLimit.v, Z = this.lineJoin;
      if (x !== 0) for (n = 0; n < c; n += 1) {
        if (l = (o = this.shapes[n]).localShapeCollection, o.shape._mdf || this._mdf || t) for (l.releaseShapes(), o.shape._mdf = !0, r = o.shape.paths.shapes, s = o.shape.paths._length, a = 0; a < s; a += 1) l.addShape(this.processPath(r[a], x, Z, j));
        o.shape.paths = o.localShapeCollection;
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    var FontManager = (function() {
      var t = { w: 0, size: 0, shapes: [], data: { shapes: [] } }, r = [];
      r = r.concat([2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366, 2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379, 2380, 2381, 2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403]);
      var n = ["d83cdffb", "d83cdffc", "d83cdffd", "d83cdffe", "d83cdfff"];
      function a(x, j) {
        var Z = createTag("span");
        Z.setAttribute("aria-hidden", !0), Z.style.fontFamily = j;
        var V = createTag("span");
        V.innerText = "giItT1WQy@!-/#", Z.style.position = "absolute", Z.style.left = "-10000px", Z.style.top = "-10000px", Z.style.fontSize = "300px", Z.style.fontVariant = "normal", Z.style.fontStyle = "normal", Z.style.fontWeight = "normal", Z.style.letterSpacing = "0", Z.appendChild(V), document.body.appendChild(Z);
        var U = V.offsetWidth;
        return V.style.fontFamily = (function($) {
          var Y, G = $.split(","), W = G.length, X = [];
          for (Y = 0; Y < W; Y += 1) G[Y] !== "sans-serif" && G[Y] !== "monospace" && X.push(G[Y]);
          return X.join(",");
        })(x) + ", " + j, { node: V, w: U, parent: Z };
      }
      function s(x, j) {
        var Z, V = document.body && j ? "svg" : "canvas", U = getFontProperties(x);
        if (V === "svg") {
          var $ = createNS("text");
          $.style.fontSize = "100px", $.setAttribute("font-family", x.fFamily), $.setAttribute("font-style", U.style), $.setAttribute("font-weight", U.weight), $.textContent = "1", x.fClass ? ($.style.fontFamily = "inherit", $.setAttribute("class", x.fClass)) : $.style.fontFamily = x.fFamily, j.appendChild($), Z = $;
        } else {
          var Y = new OffscreenCanvas(500, 500).getContext("2d");
          Y.font = U.style + " " + U.weight + " 100px " + x.fFamily, Z = Y;
        }
        return { measureText: function(G) {
          return V === "svg" ? (Z.textContent = G, Z.getComputedTextLength()) : Z.measureText(G).width;
        } };
      }
      function o(x) {
        var j = 0, Z = x.charCodeAt(0);
        if (Z >= 55296 && Z <= 56319) {
          var V = x.charCodeAt(1);
          V >= 56320 && V <= 57343 && (j = 1024 * (Z - 55296) + V - 56320 + 65536);
        }
        return j;
      }
      function l(x) {
        var j = o(x);
        return j >= 127462 && j <= 127487;
      }
      var c = function() {
        this.fonts = [], this.chars = null, this.typekitLoaded = 0, this.isLoaded = !1, this._warned = !1, this.initTime = Date.now(), this.setIsLoadedBinded = this.setIsLoaded.bind(this), this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
      };
      return c.isModifier = function(x, j) {
        var Z = x.toString(16) + j.toString(16);
        return n.indexOf(Z) !== -1;
      }, c.isZeroWidthJoiner = function(x) {
        return x === 8205;
      }, c.isFlagEmoji = function(x) {
        return l(x.substr(0, 2)) && l(x.substr(2, 2));
      }, c.isRegionalCode = l, c.isCombinedCharacter = function(x) {
        return r.indexOf(x) !== -1;
      }, c.isRegionalFlag = function(x, j) {
        var Z = o(x.substr(j, 2));
        if (Z !== 127988) return !1;
        var V = 0;
        for (j += 2; V < 5; ) {
          if ((Z = o(x.substr(j, 2))) < 917601 || Z > 917626) return !1;
          V += 1, j += 2;
        }
        return o(x.substr(j, 2)) === 917631;
      }, c.isVariationSelector = function(x) {
        return x === 65039;
      }, c.BLACK_FLAG_CODE_POINT = 127988, c.prototype = { addChars: function(x) {
        if (x) {
          var j;
          this.chars || (this.chars = []);
          var Z, V, U = x.length, $ = this.chars.length;
          for (j = 0; j < U; j += 1) {
            for (Z = 0, V = !1; Z < $; ) this.chars[Z].style === x[j].style && this.chars[Z].fFamily === x[j].fFamily && this.chars[Z].ch === x[j].ch && (V = !0), Z += 1;
            V || (this.chars.push(x[j]), $ += 1);
          }
        }
      }, addFonts: function(x, j) {
        if (x) {
          if (this.chars) return this.isLoaded = !0, void (this.fonts = x.list);
          if (!document.body) return this.isLoaded = !0, x.list.forEach((function(ee) {
            ee.helper = s(ee), ee.cache = {};
          })), void (this.fonts = x.list);
          var Z, V = x.list, U = V.length, $ = U;
          for (Z = 0; Z < U; Z += 1) {
            var Y, G, W = !0;
            if (V[Z].loaded = !1, V[Z].monoCase = a(V[Z].fFamily, "monospace"), V[Z].sansCase = a(V[Z].fFamily, "sans-serif"), V[Z].fPath) {
              if (V[Z].fOrigin === "p" || V[Z].origin === 3) {
                if ((Y = document.querySelectorAll('style[f-forigin="p"][f-family="' + V[Z].fFamily + '"], style[f-origin="3"][f-family="' + V[Z].fFamily + '"]')).length > 0 && (W = !1), W) {
                  var X = createTag("style");
                  X.setAttribute("f-forigin", V[Z].fOrigin), X.setAttribute("f-origin", V[Z].origin), X.setAttribute("f-family", V[Z].fFamily), X.type = "text/css", X.innerText = "@font-face {font-family: " + V[Z].fFamily + "; font-style: normal; src: url('" + V[Z].fPath + "');}", j.appendChild(X);
                }
              } else if (V[Z].fOrigin === "g" || V[Z].origin === 1) {
                for (Y = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]'), G = 0; G < Y.length; G += 1) Y[G].href.indexOf(V[Z].fPath) !== -1 && (W = !1);
                if (W) {
                  var K = createTag("link");
                  K.setAttribute("f-forigin", V[Z].fOrigin), K.setAttribute("f-origin", V[Z].origin), K.type = "text/css", K.rel = "stylesheet", K.href = V[Z].fPath, document.body.appendChild(K);
                }
              } else if (V[Z].fOrigin === "t" || V[Z].origin === 2) {
                for (Y = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]'), G = 0; G < Y.length; G += 1) V[Z].fPath === Y[G].src && (W = !1);
                if (W) {
                  var J = createTag("link");
                  J.setAttribute("f-forigin", V[Z].fOrigin), J.setAttribute("f-origin", V[Z].origin), J.setAttribute("rel", "stylesheet"), J.setAttribute("href", V[Z].fPath), j.appendChild(J);
                }
              }
            } else V[Z].loaded = !0, $ -= 1;
            V[Z].helper = s(V[Z], j), V[Z].cache = {}, this.fonts.push(V[Z]);
          }
          $ === 0 ? this.isLoaded = !0 : setTimeout(this.checkLoadedFonts.bind(this), 100);
        } else this.isLoaded = !0;
      }, getCharData: function(x, j, Z) {
        for (var V = 0, U = this.chars.length; V < U; ) {
          if (this.chars[V].ch === x && this.chars[V].style === j && this.chars[V].fFamily === Z) return this.chars[V];
          V += 1;
        }
        return (typeof x == "string" && x.charCodeAt(0) !== 13 || !x) && console && console.warn && !this._warned && (this._warned = !0), t;
      }, getFontByName: function(x) {
        for (var j = 0, Z = this.fonts.length; j < Z; ) {
          if (this.fonts[j].fName === x) return this.fonts[j];
          j += 1;
        }
        return this.fonts[0];
      }, measureText: function(x, j, Z) {
        var V = this.getFontByName(j), U = x;
        if (!V.cache[U]) {
          var $ = V.helper;
          if (x === " ") {
            var Y = $.measureText("|" + x + "|"), G = $.measureText("||");
            V.cache[U] = (Y - G) / 100;
          } else V.cache[U] = $.measureText(x) / 100;
        }
        return V.cache[U] * Z;
      }, checkLoadedFonts: function() {
        var x, j, Z, V = this.fonts.length, U = V;
        for (x = 0; x < V; x += 1) this.fonts[x].loaded ? U -= 1 : this.fonts[x].fOrigin === "n" || this.fonts[x].origin === 0 ? this.fonts[x].loaded = !0 : (j = this.fonts[x].monoCase.node, Z = this.fonts[x].monoCase.w, j.offsetWidth !== Z ? (U -= 1, this.fonts[x].loaded = !0) : (j = this.fonts[x].sansCase.node, Z = this.fonts[x].sansCase.w, j.offsetWidth !== Z && (U -= 1, this.fonts[x].loaded = !0)), this.fonts[x].loaded && (this.fonts[x].sansCase.parent.parentNode.removeChild(this.fonts[x].sansCase.parent), this.fonts[x].monoCase.parent.parentNode.removeChild(this.fonts[x].monoCase.parent)));
        U !== 0 && Date.now() - this.initTime < 5e3 ? setTimeout(this.checkLoadedFontsBinded, 20) : setTimeout(this.setIsLoadedBinded, 10);
      }, setIsLoaded: function() {
        this.isLoaded = !0;
      } }, c;
    })();
    function SlotManager(t) {
      this.animationData = t;
    }
    function slotFactory(t) {
      return new SlotManager(t);
    }
    function RenderableElement() {
    }
    SlotManager.prototype.getProp = function(t) {
      return this.animationData.slots && this.animationData.slots[t.sid] ? Object.assign(t, this.animationData.slots[t.sid].p) : t;
    }, RenderableElement.prototype = { initRenderable: function() {
      this.isInRange = !1, this.hidden = !1, this.isTransparent = !1, this.renderableComponents = [];
    }, addRenderableComponent: function(t) {
      this.renderableComponents.indexOf(t) === -1 && this.renderableComponents.push(t);
    }, removeRenderableComponent: function(t) {
      this.renderableComponents.indexOf(t) !== -1 && this.renderableComponents.splice(this.renderableComponents.indexOf(t), 1);
    }, prepareRenderableFrame: function(t) {
      this.checkLayerLimits(t);
    }, checkTransparency: function() {
      this.finalTransform.mProp.o.v <= 0 ? !this.isTransparent && this.globalData.renderConfig.hideOnTransparent && (this.isTransparent = !0, this.hide()) : this.isTransparent && (this.isTransparent = !1, this.show());
    }, checkLayerLimits: function(t) {
      this.data.ip - this.data.st <= t && this.data.op - this.data.st > t ? this.isInRange !== !0 && (this.globalData._mdf = !0, this._mdf = !0, this.isInRange = !0, this.show()) : this.isInRange !== !1 && (this.globalData._mdf = !0, this.isInRange = !1, this.hide());
    }, renderRenderable: function() {
      var t, r = this.renderableComponents.length;
      for (t = 0; t < r; t += 1) this.renderableComponents[t].renderFrame(this._isFirstFrame);
    }, sourceRectAtTime: function() {
      return { top: 0, left: 0, width: 100, height: 100 };
    }, getLayerSize: function() {
      return this.data.ty === 5 ? { w: this.data.textData.width, h: this.data.textData.height } : { w: this.data.width, h: this.data.height };
    } };
    var getBlendMode = (blendModeEnums = { 0: "source-over", 1: "multiply", 2: "screen", 3: "overlay", 4: "darken", 5: "lighten", 6: "color-dodge", 7: "color-burn", 8: "hard-light", 9: "soft-light", 10: "difference", 11: "exclusion", 12: "hue", 13: "saturation", 14: "color", 15: "luminosity" }, function(t) {
      return blendModeEnums[t] || "";
    }), blendModeEnums;
    function SliderEffect(t, r, n) {
      this.p = PropertyFactory.getProp(r, t.v, 0, 0, n);
    }
    function AngleEffect(t, r, n) {
      this.p = PropertyFactory.getProp(r, t.v, 0, 0, n);
    }
    function ColorEffect(t, r, n) {
      this.p = PropertyFactory.getProp(r, t.v, 1, 0, n);
    }
    function PointEffect(t, r, n) {
      this.p = PropertyFactory.getProp(r, t.v, 1, 0, n);
    }
    function LayerIndexEffect(t, r, n) {
      this.p = PropertyFactory.getProp(r, t.v, 0, 0, n);
    }
    function MaskIndexEffect(t, r, n) {
      this.p = PropertyFactory.getProp(r, t.v, 0, 0, n);
    }
    function CheckboxEffect(t, r, n) {
      this.p = PropertyFactory.getProp(r, t.v, 0, 0, n);
    }
    function NoValueEffect() {
      this.p = {};
    }
    function EffectsManager(t, r) {
      var n, a = t.ef || [];
      this.effectElements = [];
      var s, o = a.length;
      for (n = 0; n < o; n += 1) s = new GroupEffect(a[n], r), this.effectElements.push(s);
    }
    function GroupEffect(t, r) {
      this.init(t, r);
    }
    function BaseElement() {
    }
    function FrameElement() {
    }
    function FootageElement(t, r, n) {
      this.initFrame(), this.initRenderable(), this.assetData = r.getAssetData(t.refId), this.footageData = r.imageLoader.getAsset(this.assetData), this.initBaseData(t, r, n);
    }
    function AudioElement(t, r, n) {
      this.initFrame(), this.initRenderable(), this.assetData = r.getAssetData(t.refId), this.initBaseData(t, r, n), this._isPlaying = !1, this._canPlay = !1;
      var a = this.globalData.getAssetsPath(this.assetData);
      this.audio = this.globalData.audioController.createAudio(a), this._currentTime = 0, this.globalData.audioController.addAudio(this), this._volumeMultiplier = 1, this._volume = 1, this._previousVolume = null, this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, r.frameRate, this) : { _placeholder: !0 }, this.lv = PropertyFactory.getProp(this, t.au && t.au.lv ? t.au.lv : { k: [100] }, 1, 0.01, this);
    }
    function BaseRenderer() {
    }
    extendPrototype([DynamicPropertyContainer], GroupEffect), GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties, GroupEffect.prototype.init = function(t, r) {
      var n;
      this.data = t, this.effectElements = [], this.initDynamicPropertyContainer(r);
      var a, s = this.data.ef.length, o = this.data.ef;
      for (n = 0; n < s; n += 1) {
        switch (a = null, o[n].ty) {
          case 0:
            a = new SliderEffect(o[n], r, this);
            break;
          case 1:
            a = new AngleEffect(o[n], r, this);
            break;
          case 2:
            a = new ColorEffect(o[n], r, this);
            break;
          case 3:
            a = new PointEffect(o[n], r, this);
            break;
          case 4:
          case 7:
            a = new CheckboxEffect(o[n], r, this);
            break;
          case 10:
            a = new LayerIndexEffect(o[n], r, this);
            break;
          case 11:
            a = new MaskIndexEffect(o[n], r, this);
            break;
          case 5:
            a = new EffectsManager(o[n], r);
            break;
          default:
            a = new NoValueEffect(o[n]);
        }
        a && this.effectElements.push(a);
      }
    }, BaseElement.prototype = { checkMasks: function() {
      if (!this.data.hasMask) return !1;
      for (var t = 0, r = this.data.masksProperties.length; t < r; ) {
        if (this.data.masksProperties[t].mode !== "n" && this.data.masksProperties[t].cl !== !1) return !0;
        t += 1;
      }
      return !1;
    }, initExpressions: function() {
      var t = getExpressionInterfaces();
      if (t) {
        var r = t("layer"), n = t("effects"), a = t("shape"), s = t("text"), o = t("comp");
        this.layerInterface = r(this), this.data.hasMask && this.maskManager && this.layerInterface.registerMaskInterface(this.maskManager);
        var l = n.createEffectsInterface(this, this.layerInterface);
        this.layerInterface.registerEffectsInterface(l), this.data.ty === 0 || this.data.xt ? this.compInterface = o(this) : this.data.ty === 4 ? (this.layerInterface.shapeInterface = a(this.shapesData, this.itemsData, this.layerInterface), this.layerInterface.content = this.layerInterface.shapeInterface) : this.data.ty === 5 && (this.layerInterface.textInterface = s(this), this.layerInterface.text = this.layerInterface.textInterface);
      }
    }, setBlendMode: function() {
      var t = getBlendMode(this.data.bm);
      (this.baseElement || this.layerElement).style["mix-blend-mode"] = t;
    }, initBaseData: function(t, r, n) {
      this.globalData = r, this.comp = n, this.data = t, this.layerId = createElementID(), this.data.sr || (this.data.sr = 1), this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
    }, getType: function() {
      return this.type;
    }, sourceRectAtTime: function() {
    } }, FrameElement.prototype = { initFrame: function() {
      this._isFirstFrame = !1, this.dynamicProperties = [], this._mdf = !1;
    }, prepareProperties: function(t, r) {
      var n, a = this.dynamicProperties.length;
      for (n = 0; n < a; n += 1) (r || this._isParent && this.dynamicProperties[n].propType === "transform") && (this.dynamicProperties[n].getValue(), this.dynamicProperties[n]._mdf && (this.globalData._mdf = !0, this._mdf = !0));
    }, addDynamicProperty: function(t) {
      this.dynamicProperties.indexOf(t) === -1 && this.dynamicProperties.push(t);
    } }, FootageElement.prototype.prepareFrame = function() {
    }, extendPrototype([RenderableElement, BaseElement, FrameElement], FootageElement), FootageElement.prototype.getBaseElement = function() {
      return null;
    }, FootageElement.prototype.renderFrame = function() {
    }, FootageElement.prototype.destroy = function() {
    }, FootageElement.prototype.initExpressions = function() {
      var t = getExpressionInterfaces();
      if (t) {
        var r = t("footage");
        this.layerInterface = r(this);
      }
    }, FootageElement.prototype.getFootageData = function() {
      return this.footageData;
    }, AudioElement.prototype.prepareFrame = function(t) {
      if (this.prepareRenderableFrame(t, !0), this.prepareProperties(t, !0), this.tm._placeholder) this._currentTime = t / this.data.sr;
      else {
        var r = this.tm.v;
        this._currentTime = r;
      }
      this._volume = this.lv.v[0];
      var n = this._volume * this._volumeMultiplier;
      this._previousVolume !== n && (this._previousVolume = n, this.audio.volume(n));
    }, extendPrototype([RenderableElement, BaseElement, FrameElement], AudioElement), AudioElement.prototype.renderFrame = function() {
      this.isInRange && this._canPlay && (this._isPlaying ? (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) && this.audio.seek(this._currentTime / this.globalData.frameRate) : (this.audio.play(), this.audio.seek(this._currentTime / this.globalData.frameRate), this._isPlaying = !0));
    }, AudioElement.prototype.show = function() {
    }, AudioElement.prototype.hide = function() {
      this.audio.pause(), this._isPlaying = !1;
    }, AudioElement.prototype.pause = function() {
      this.audio.pause(), this._isPlaying = !1, this._canPlay = !1;
    }, AudioElement.prototype.resume = function() {
      this._canPlay = !0;
    }, AudioElement.prototype.setRate = function(t) {
      this.audio.rate(t);
    }, AudioElement.prototype.volume = function(t) {
      this._volumeMultiplier = t, this._previousVolume = t * this._volume, this.audio.volume(this._previousVolume);
    }, AudioElement.prototype.getBaseElement = function() {
      return null;
    }, AudioElement.prototype.destroy = function() {
    }, AudioElement.prototype.sourceRectAtTime = function() {
    }, AudioElement.prototype.initExpressions = function() {
    }, BaseRenderer.prototype.checkLayers = function(t) {
      var r, n, a = this.layers.length;
      for (this.completeLayers = !0, r = a - 1; r >= 0; r -= 1) this.elements[r] || (n = this.layers[r]).ip - n.st <= t - this.layers[r].st && n.op - n.st > t - this.layers[r].st && this.buildItem(r), this.completeLayers = !!this.elements[r] && this.completeLayers;
      this.checkPendingElements();
    }, BaseRenderer.prototype.createItem = function(t) {
      switch (t.ty) {
        case 2:
          return this.createImage(t);
        case 0:
          return this.createComp(t);
        case 1:
          return this.createSolid(t);
        case 3:
          return this.createNull(t);
        case 4:
          return this.createShape(t);
        case 5:
          return this.createText(t);
        case 6:
          return this.createAudio(t);
        case 13:
          return this.createCamera(t);
        case 15:
          return this.createFootage(t);
        default:
          return this.createNull(t);
      }
    }, BaseRenderer.prototype.createCamera = function() {
      throw new Error("You're using a 3d camera. Try the html renderer.");
    }, BaseRenderer.prototype.createAudio = function(t) {
      return new AudioElement(t, this.globalData, this);
    }, BaseRenderer.prototype.createFootage = function(t) {
      return new FootageElement(t, this.globalData, this);
    }, BaseRenderer.prototype.buildAllItems = function() {
      var t, r = this.layers.length;
      for (t = 0; t < r; t += 1) this.buildItem(t);
      this.checkPendingElements();
    }, BaseRenderer.prototype.includeLayers = function(t) {
      var r;
      this.completeLayers = !1;
      var n, a = t.length, s = this.layers.length;
      for (r = 0; r < a; r += 1) for (n = 0; n < s; ) {
        if (this.layers[n].id === t[r].id) {
          this.layers[n] = t[r];
          break;
        }
        n += 1;
      }
    }, BaseRenderer.prototype.setProjectInterface = function(t) {
      this.globalData.projectInterface = t;
    }, BaseRenderer.prototype.initItems = function() {
      this.globalData.progressiveLoad || this.buildAllItems();
    }, BaseRenderer.prototype.buildElementParenting = function(t, r, n) {
      for (var a = this.elements, s = this.layers, o = 0, l = s.length; o < l; ) s[o].ind == r && (a[o] && a[o] !== !0 ? (n.push(a[o]), a[o].setAsParent(), s[o].parent !== void 0 ? this.buildElementParenting(t, s[o].parent, n) : t.setHierarchy(n)) : (this.buildItem(o), this.addPendingElement(t))), o += 1;
    }, BaseRenderer.prototype.addPendingElement = function(t) {
      this.pendingElements.push(t);
    }, BaseRenderer.prototype.searchExtraCompositions = function(t) {
      var r, n = t.length;
      for (r = 0; r < n; r += 1) if (t[r].xt) {
        var a = this.createComp(t[r]);
        a.initExpressions(), this.globalData.projectInterface.registerComposition(a);
      }
    }, BaseRenderer.prototype.getElementById = function(t) {
      var r, n = this.elements.length;
      for (r = 0; r < n; r += 1) if (this.elements[r].data.ind === t) return this.elements[r];
      return null;
    }, BaseRenderer.prototype.getElementByPath = function(t) {
      var r, n = t.shift();
      if (typeof n == "number") r = this.elements[n];
      else {
        var a, s = this.elements.length;
        for (a = 0; a < s; a += 1) if (this.elements[a].data.nm === n) {
          r = this.elements[a];
          break;
        }
      }
      return t.length === 0 ? r : r.getElementByPath(t);
    }, BaseRenderer.prototype.setupGlobalData = function(t, r) {
      this.globalData.fontManager = new FontManager(), this.globalData.slotManager = slotFactory(t), this.globalData.fontManager.addChars(t.chars), this.globalData.fontManager.addFonts(t.fonts, r), this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem), this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem), this.globalData.imageLoader = this.animationItem.imagePreloader, this.globalData.audioController = this.animationItem.audioController, this.globalData.frameId = 0, this.globalData.frameRate = t.fr, this.globalData.nm = t.nm, this.globalData.compSize = { w: t.w, h: t.h };
    };
    var effectTypes = { TRANSFORM_EFFECT: "transformEFfect" };
    function TransformElement() {
    }
    function MaskElement(t, r, n) {
      this.data = t, this.element = r, this.globalData = n, this.storedData = [], this.masksProperties = this.data.masksProperties || [], this.maskElement = null;
      var a, s, o = this.globalData.defs, l = this.masksProperties ? this.masksProperties.length : 0;
      this.viewData = createSizedArray(l), this.solidPath = "";
      var c, x, j, Z, V, U, $ = this.masksProperties, Y = 0, G = [], W = createElementID(), X = "clipPath", K = "clip-path";
      for (a = 0; a < l; a += 1) if (($[a].mode !== "a" && $[a].mode !== "n" || $[a].inv || $[a].o.k !== 100 || $[a].o.x) && (X = "mask", K = "mask"), $[a].mode !== "s" && $[a].mode !== "i" || Y !== 0 ? j = null : ((j = createNS("rect")).setAttribute("fill", "#ffffff"), j.setAttribute("width", this.element.comp.data.w || 0), j.setAttribute("height", this.element.comp.data.h || 0), G.push(j)), s = createNS("path"), $[a].mode === "n") this.viewData[a] = { op: PropertyFactory.getProp(this.element, $[a].o, 0, 0.01, this.element), prop: ShapePropertyFactory.getShapeProp(this.element, $[a], 3), elem: s, lastPath: "" }, o.appendChild(s);
      else {
        var J;
        if (Y += 1, s.setAttribute("fill", $[a].mode === "s" ? "#000000" : "#ffffff"), s.setAttribute("clip-rule", "nonzero"), $[a].x.k !== 0 ? (X = "mask", K = "mask", U = PropertyFactory.getProp(this.element, $[a].x, 0, null, this.element), J = createElementID(), (Z = createNS("filter")).setAttribute("id", J), (V = createNS("feMorphology")).setAttribute("operator", "erode"), V.setAttribute("in", "SourceGraphic"), V.setAttribute("radius", "0"), Z.appendChild(V), o.appendChild(Z), s.setAttribute("stroke", $[a].mode === "s" ? "#000000" : "#ffffff")) : (V = null, U = null), this.storedData[a] = { elem: s, x: U, expan: V, lastPath: "", lastOperator: "", filterId: J, lastRadius: 0 }, $[a].mode === "i") {
          x = G.length;
          var ee = createNS("g");
          for (c = 0; c < x; c += 1) ee.appendChild(G[c]);
          var te = createNS("mask");
          te.setAttribute("mask-type", "alpha"), te.setAttribute("id", W + "_" + Y), te.appendChild(s), o.appendChild(te), ee.setAttribute("mask", "url(" + getLocationHref() + "#" + W + "_" + Y + ")"), G.length = 0, G.push(ee);
        } else G.push(s);
        $[a].inv && !this.solidPath && (this.solidPath = this.createLayerSolidPath()), this.viewData[a] = { elem: s, lastPath: "", op: PropertyFactory.getProp(this.element, $[a].o, 0, 0.01, this.element), prop: ShapePropertyFactory.getShapeProp(this.element, $[a], 3), invRect: j }, this.viewData[a].prop.k || this.drawPath($[a], this.viewData[a].prop.v, this.viewData[a]);
      }
      for (this.maskElement = createNS(X), l = G.length, a = 0; a < l; a += 1) this.maskElement.appendChild(G[a]);
      Y > 0 && (this.maskElement.setAttribute("id", W), this.element.maskedElement.setAttribute(K, "url(" + getLocationHref() + "#" + W + ")"), o.appendChild(this.maskElement)), this.viewData.length && this.element.addRenderableComponent(this);
    }
    TransformElement.prototype = { initTransform: function() {
      var t = new Matrix();
      this.finalTransform = { mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : { o: 0 }, _matMdf: !1, _localMatMdf: !1, _opMdf: !1, mat: t, localMat: t, localOpacity: 1 }, this.data.ao && (this.finalTransform.mProp.autoOriented = !0), this.data.ty;
    }, renderTransform: function() {
      if (this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame, this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame, this.hierarchy) {
        var t, r = this.finalTransform.mat, n = 0, a = this.hierarchy.length;
        if (!this.finalTransform._matMdf) for (; n < a; ) {
          if (this.hierarchy[n].finalTransform.mProp._mdf) {
            this.finalTransform._matMdf = !0;
            break;
          }
          n += 1;
        }
        if (this.finalTransform._matMdf) for (t = this.finalTransform.mProp.v.props, r.cloneFromProps(t), n = 0; n < a; n += 1) r.multiply(this.hierarchy[n].finalTransform.mProp.v);
      }
      this.finalTransform._matMdf && (this.finalTransform._localMatMdf = this.finalTransform._matMdf), this.finalTransform._opMdf && (this.finalTransform.localOpacity = this.finalTransform.mProp.o.v);
    }, renderLocalTransform: function() {
      if (this.localTransforms) {
        var t = 0, r = this.localTransforms.length;
        if (this.finalTransform._localMatMdf = this.finalTransform._matMdf, !this.finalTransform._localMatMdf || !this.finalTransform._opMdf) for (; t < r; ) this.localTransforms[t]._mdf && (this.finalTransform._localMatMdf = !0), this.localTransforms[t]._opMdf && !this.finalTransform._opMdf && (this.finalTransform.localOpacity = this.finalTransform.mProp.o.v, this.finalTransform._opMdf = !0), t += 1;
        if (this.finalTransform._localMatMdf) {
          var n = this.finalTransform.localMat;
          for (this.localTransforms[0].matrix.clone(n), t = 1; t < r; t += 1) {
            var a = this.localTransforms[t].matrix;
            n.multiply(a);
          }
          n.multiply(this.finalTransform.mat);
        }
        if (this.finalTransform._opMdf) {
          var s = this.finalTransform.localOpacity;
          for (t = 0; t < r; t += 1) s *= 0.01 * this.localTransforms[t].opacity;
          this.finalTransform.localOpacity = s;
        }
      }
    }, searchEffectTransforms: function() {
      if (this.renderableEffectsManager) {
        var t = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
        if (t.length) {
          this.localTransforms = [], this.finalTransform.localMat = new Matrix();
          var r = 0, n = t.length;
          for (r = 0; r < n; r += 1) this.localTransforms.push(t[r]);
        }
      }
    }, globalToLocal: function(t) {
      var r = [];
      r.push(this.finalTransform);
      for (var n, a = !0, s = this.comp; a; ) s.finalTransform ? (s.data.hasMask && r.splice(0, 0, s.finalTransform), s = s.comp) : a = !1;
      var o, l = r.length;
      for (n = 0; n < l; n += 1) o = r[n].mat.applyToPointArray(0, 0, 0), t = [t[0] - o[0], t[1] - o[1], 0];
      return t;
    }, mHelper: new Matrix() }, MaskElement.prototype.getMaskProperty = function(t) {
      return this.viewData[t].prop;
    }, MaskElement.prototype.renderFrame = function(t) {
      var r, n = this.element.finalTransform.mat, a = this.masksProperties.length;
      for (r = 0; r < a; r += 1) if ((this.viewData[r].prop._mdf || t) && this.drawPath(this.masksProperties[r], this.viewData[r].prop.v, this.viewData[r]), (this.viewData[r].op._mdf || t) && this.viewData[r].elem.setAttribute("fill-opacity", this.viewData[r].op.v), this.masksProperties[r].mode !== "n" && (this.viewData[r].invRect && (this.element.finalTransform.mProp._mdf || t) && this.viewData[r].invRect.setAttribute("transform", n.getInverseMatrix().to2dCSS()), this.storedData[r].x && (this.storedData[r].x._mdf || t))) {
        var s = this.storedData[r].expan;
        this.storedData[r].x.v < 0 ? (this.storedData[r].lastOperator !== "erode" && (this.storedData[r].lastOperator = "erode", this.storedData[r].elem.setAttribute("filter", "url(" + getLocationHref() + "#" + this.storedData[r].filterId + ")")), s.setAttribute("radius", -this.storedData[r].x.v)) : (this.storedData[r].lastOperator !== "dilate" && (this.storedData[r].lastOperator = "dilate", this.storedData[r].elem.setAttribute("filter", null)), this.storedData[r].elem.setAttribute("stroke-width", 2 * this.storedData[r].x.v));
      }
    }, MaskElement.prototype.getMaskelement = function() {
      return this.maskElement;
    }, MaskElement.prototype.createLayerSolidPath = function() {
      var t = "M0,0 ";
      return t += " h" + this.globalData.compSize.w, t += " v" + this.globalData.compSize.h, t += " h-" + this.globalData.compSize.w, t += " v-" + this.globalData.compSize.h + " ";
    }, MaskElement.prototype.drawPath = function(t, r, n) {
      var a, s, o = " M" + r.v[0][0] + "," + r.v[0][1];
      for (s = r._length, a = 1; a < s; a += 1) o += " C" + r.o[a - 1][0] + "," + r.o[a - 1][1] + " " + r.i[a][0] + "," + r.i[a][1] + " " + r.v[a][0] + "," + r.v[a][1];
      if (r.c && s > 1 && (o += " C" + r.o[a - 1][0] + "," + r.o[a - 1][1] + " " + r.i[0][0] + "," + r.i[0][1] + " " + r.v[0][0] + "," + r.v[0][1]), n.lastPath !== o) {
        var l = "";
        n.elem && (r.c && (l = t.inv ? this.solidPath + o : o), n.elem.setAttribute("d", l)), n.lastPath = o;
      }
    }, MaskElement.prototype.destroy = function() {
      this.element = null, this.globalData = null, this.maskElement = null, this.data = null, this.masksProperties = null;
    };
    var filtersFactory = (function() {
      var t = {};
      return t.createFilter = function(r, n) {
        var a = createNS("filter");
        return a.setAttribute("id", r), n !== !0 && (a.setAttribute("filterUnits", "objectBoundingBox"), a.setAttribute("x", "0%"), a.setAttribute("y", "0%"), a.setAttribute("width", "100%"), a.setAttribute("height", "100%")), a;
      }, t.createAlphaToLuminanceFilter = function() {
        var r = createNS("feColorMatrix");
        return r.setAttribute("type", "matrix"), r.setAttribute("color-interpolation-filters", "sRGB"), r.setAttribute("values", "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1"), r;
      }, t;
    })(), featureSupport = (function() {
      var t = { maskType: !0, svgLumaHidden: !0, offscreenCanvas: typeof OffscreenCanvas != "undefined" };
      return (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) && (t.maskType = !1), /firefox/i.test(navigator.userAgent) && (t.svgLumaHidden = !1), t;
    })(), registeredEffects$1 = {}, idPrefix = "filter_result_";
    function SVGEffects(t) {
      var r, n, a = "SourceGraphic", s = t.data.ef ? t.data.ef.length : 0, o = createElementID(), l = filtersFactory.createFilter(o, !0), c = 0;
      for (this.filters = [], r = 0; r < s; r += 1) {
        n = null;
        var x = t.data.ef[r].ty;
        registeredEffects$1[x] && (n = new registeredEffects$1[x].effect(l, t.effectsManager.effectElements[r], t, idPrefix + c, a), a = idPrefix + c, registeredEffects$1[x].countsAsEffect && (c += 1)), n && this.filters.push(n);
      }
      c && (t.globalData.defs.appendChild(l), t.layerElement.setAttribute("filter", "url(" + getLocationHref() + "#" + o + ")")), this.filters.length && t.addRenderableComponent(this);
    }
    function registerEffect$1(t, r, n) {
      registeredEffects$1[t] = { effect: r, countsAsEffect: n };
    }
    function SVGBaseElement() {
    }
    function HierarchyElement() {
    }
    function RenderableDOMElement() {
    }
    function IImageElement(t, r, n) {
      this.assetData = r.getAssetData(t.refId), this.assetData && this.assetData.sid && (this.assetData = r.slotManager.getProp(this.assetData)), this.initElement(t, r, n), this.sourceRect = { top: 0, left: 0, width: this.assetData.w, height: this.assetData.h };
    }
    function ProcessedElement(t, r) {
      this.elem = t, this.pos = r;
    }
    function IShapeElement() {
    }
    SVGEffects.prototype.renderFrame = function(t) {
      var r, n = this.filters.length;
      for (r = 0; r < n; r += 1) this.filters[r].renderFrame(t);
    }, SVGEffects.prototype.getEffects = function(t) {
      var r, n = this.filters.length, a = [];
      for (r = 0; r < n; r += 1) this.filters[r].type === t && a.push(this.filters[r]);
      return a;
    }, SVGBaseElement.prototype = { initRendererElement: function() {
      this.layerElement = createNS("g");
    }, createContainerElements: function() {
      this.matteElement = createNS("g"), this.transformedElement = this.layerElement, this.maskedElement = this.layerElement, this._sizeChanged = !1;
      var t = null;
      if (this.data.td) {
        this.matteMasks = {};
        var r = createNS("g");
        r.setAttribute("id", this.layerId), r.appendChild(this.layerElement), t = r, this.globalData.defs.appendChild(r);
      } else this.data.tt ? (this.matteElement.appendChild(this.layerElement), t = this.matteElement, this.baseElement = this.matteElement) : this.baseElement = this.layerElement;
      if (this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), this.data.ty === 0 && !this.data.hd) {
        var n = createNS("clipPath"), a = createNS("path");
        a.setAttribute("d", "M0,0 L" + this.data.w + ",0 L" + this.data.w + "," + this.data.h + " L0," + this.data.h + "z");
        var s = createElementID();
        if (n.setAttribute("id", s), n.appendChild(a), this.globalData.defs.appendChild(n), this.checkMasks()) {
          var o = createNS("g");
          o.setAttribute("clip-path", "url(" + getLocationHref() + "#" + s + ")"), o.appendChild(this.layerElement), this.transformedElement = o, t ? t.appendChild(this.transformedElement) : this.baseElement = this.transformedElement;
        } else this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + s + ")");
      }
      this.data.bm !== 0 && this.setBlendMode();
    }, renderElement: function() {
      this.finalTransform._localMatMdf && this.transformedElement.setAttribute("transform", this.finalTransform.localMat.to2dCSS()), this.finalTransform._opMdf && this.transformedElement.setAttribute("opacity", this.finalTransform.localOpacity);
    }, destroyBaseElement: function() {
      this.layerElement = null, this.matteElement = null, this.maskManager.destroy();
    }, getBaseElement: function() {
      return this.data.hd ? null : this.baseElement;
    }, createRenderableComponents: function() {
      this.maskManager = new MaskElement(this.data, this, this.globalData), this.renderableEffectsManager = new SVGEffects(this), this.searchEffectTransforms();
    }, getMatte: function(t) {
      if (this.matteMasks || (this.matteMasks = {}), !this.matteMasks[t]) {
        var r, n, a, s, o = this.layerId + "_" + t;
        if (t === 1 || t === 3) {
          var l = createNS("mask");
          l.setAttribute("id", o), l.setAttribute("mask-type", t === 3 ? "luminance" : "alpha"), (a = createNS("use")).setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), l.appendChild(a), this.globalData.defs.appendChild(l), featureSupport.maskType || t !== 1 || (l.setAttribute("mask-type", "luminance"), r = createElementID(), n = filtersFactory.createFilter(r), this.globalData.defs.appendChild(n), n.appendChild(filtersFactory.createAlphaToLuminanceFilter()), (s = createNS("g")).appendChild(a), l.appendChild(s), s.setAttribute("filter", "url(" + getLocationHref() + "#" + r + ")"));
        } else if (t === 2) {
          var c = createNS("mask");
          c.setAttribute("id", o), c.setAttribute("mask-type", "alpha");
          var x = createNS("g");
          c.appendChild(x), r = createElementID(), n = filtersFactory.createFilter(r);
          var j = createNS("feComponentTransfer");
          j.setAttribute("in", "SourceGraphic"), n.appendChild(j);
          var Z = createNS("feFuncA");
          Z.setAttribute("type", "table"), Z.setAttribute("tableValues", "1.0 0.0"), j.appendChild(Z), this.globalData.defs.appendChild(n);
          var V = createNS("rect");
          V.setAttribute("width", this.comp.data.w), V.setAttribute("height", this.comp.data.h), V.setAttribute("x", "0"), V.setAttribute("y", "0"), V.setAttribute("fill", "#ffffff"), V.setAttribute("opacity", "0"), x.setAttribute("filter", "url(" + getLocationHref() + "#" + r + ")"), x.appendChild(V), (a = createNS("use")).setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), x.appendChild(a), featureSupport.maskType || (c.setAttribute("mask-type", "luminance"), n.appendChild(filtersFactory.createAlphaToLuminanceFilter()), s = createNS("g"), x.appendChild(V), s.appendChild(this.layerElement), x.appendChild(s)), this.globalData.defs.appendChild(c);
        }
        this.matteMasks[t] = o;
      }
      return this.matteMasks[t];
    }, setMatte: function(t) {
      this.matteElement && this.matteElement.setAttribute("mask", "url(" + getLocationHref() + "#" + t + ")");
    } }, HierarchyElement.prototype = { initHierarchy: function() {
      this.hierarchy = [], this._isParent = !1, this.checkParenting();
    }, setHierarchy: function(t) {
      this.hierarchy = t;
    }, setAsParent: function() {
      this._isParent = !0;
    }, checkParenting: function() {
      this.data.parent !== void 0 && this.comp.buildElementParenting(this, this.data.parent, []);
    } }, extendPrototype([RenderableElement, createProxyFunction({ initElement: function(t, r, n) {
      this.initFrame(), this.initBaseData(t, r, n), this.initTransform(t, r, n), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide();
    }, hide: function() {
      this.hidden || this.isInRange && !this.isTransparent || ((this.baseElement || this.layerElement).style.display = "none", this.hidden = !0);
    }, show: function() {
      this.isInRange && !this.isTransparent && (this.data.hd || ((this.baseElement || this.layerElement).style.display = "block"), this.hidden = !1, this._isFirstFrame = !0);
    }, renderFrame: function() {
      this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderLocalTransform(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
    }, renderInnerContent: function() {
    }, prepareFrame: function(t) {
      this._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange), this.checkTransparency();
    }, destroy: function() {
      this.innerElem = null, this.destroyBaseElement();
    } })], RenderableDOMElement), extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], IImageElement), IImageElement.prototype.createContent = function() {
      var t = this.globalData.getAssetsPath(this.assetData);
      this.innerElem = createNS("image"), this.innerElem.setAttribute("width", this.assetData.w + "px"), this.innerElem.setAttribute("height", this.assetData.h + "px"), this.innerElem.setAttribute("preserveAspectRatio", this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio), this.innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", t), this.layerElement.appendChild(this.innerElem);
    }, IImageElement.prototype.sourceRectAtTime = function() {
      return this.sourceRect;
    }, IShapeElement.prototype = { addShapeToModifiers: function(t) {
      var r, n = this.shapeModifiers.length;
      for (r = 0; r < n; r += 1) this.shapeModifiers[r].addShape(t);
    }, isShapeInAnimatedModifiers: function(t) {
      for (var r = this.shapeModifiers.length; 0 < r; ) if (this.shapeModifiers[0].isAnimatedWithShape(t)) return !0;
      return !1;
    }, renderModifiers: function() {
      if (this.shapeModifiers.length) {
        var t, r = this.shapes.length;
        for (t = 0; t < r; t += 1) this.shapes[t].sh.reset();
        for (t = (r = this.shapeModifiers.length) - 1; t >= 0 && !this.shapeModifiers[t].processShapes(this._isFirstFrame); t -= 1) ;
      }
    }, searchProcessedElement: function(t) {
      for (var r = this.processedElements, n = 0, a = r.length; n < a; ) {
        if (r[n].elem === t) return r[n].pos;
        n += 1;
      }
      return 0;
    }, addProcessedElement: function(t, r) {
      for (var n = this.processedElements, a = n.length; a; ) if (n[a -= 1].elem === t) return void (n[a].pos = r);
      n.push(new ProcessedElement(t, r));
    }, prepareFrame: function(t) {
      this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange);
    } };
    var lineCapEnum = { 1: "butt", 2: "round", 3: "square" }, lineJoinEnum = { 1: "miter", 2: "round", 3: "bevel" };
    function SVGShapeData(t, r, n) {
      this.caches = [], this.styles = [], this.transformers = t, this.lStr = "", this.sh = n, this.lvl = r, this._isAnimated = !!n.k;
      for (var a = 0, s = t.length; a < s; ) {
        if (t[a].mProps.dynamicProperties.length) {
          this._isAnimated = !0;
          break;
        }
        a += 1;
      }
    }
    function SVGStyleData(t, r) {
      this.data = t, this.type = t.ty, this.d = "", this.lvl = r, this._mdf = !1, this.closed = t.hd === !0, this.pElem = createNS("path"), this.msElem = null;
    }
    function DashProperty(t, r, n, a) {
      var s;
      this.elem = t, this.frameId = -1, this.dataProps = createSizedArray(r.length), this.renderer = n, this.k = !1, this.dashStr = "", this.dashArray = createTypedArray("float32", r.length ? r.length - 1 : 0), this.dashoffset = createTypedArray("float32", 1), this.initDynamicPropertyContainer(a);
      var o, l = r.length || 0;
      for (s = 0; s < l; s += 1) o = PropertyFactory.getProp(t, r[s].v, 0, 0, this), this.k = o.k || this.k, this.dataProps[s] = { n: r[s].n, p: o };
      this.k || this.getValue(!0), this._isAnimated = this.k;
    }
    function SVGStrokeStyleData(t, r, n) {
      this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(t, r.o, 0, 0.01, this), this.w = PropertyFactory.getProp(t, r.w, 0, null, this), this.d = new DashProperty(t, r.d || {}, "svg", this), this.c = PropertyFactory.getProp(t, r.c, 1, 255, this), this.style = n, this._isAnimated = !!this._isAnimated;
    }
    function SVGFillStyleData(t, r, n) {
      this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(t, r.o, 0, 0.01, this), this.c = PropertyFactory.getProp(t, r.c, 1, 255, this), this.style = n;
    }
    function SVGNoStyleData(t, r, n) {
      this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.style = n;
    }
    function GradientProperty(t, r, n) {
      this.data = r, this.c = createTypedArray("uint8c", 4 * r.p);
      var a = r.k.k[0].s ? r.k.k[0].s.length - 4 * r.p : r.k.k.length - 4 * r.p;
      this.o = createTypedArray("float32", a), this._cmdf = !1, this._omdf = !1, this._collapsable = this.checkCollapsable(), this._hasOpacity = a, this.initDynamicPropertyContainer(n), this.prop = PropertyFactory.getProp(t, r.k, 1, null, this), this.k = this.prop.k, this.getValue(!0);
    }
    function SVGGradientFillStyleData(t, r, n) {
      this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.initGradientData(t, r, n);
    }
    function SVGGradientStrokeStyleData(t, r, n) {
      this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.w = PropertyFactory.getProp(t, r.w, 0, null, this), this.d = new DashProperty(t, r.d || {}, "svg", this), this.initGradientData(t, r, n), this._isAnimated = !!this._isAnimated;
    }
    function ShapeGroupData() {
      this.it = [], this.prevViewData = [], this.gr = createNS("g");
    }
    function SVGTransformData(t, r, n) {
      this.transform = { mProps: t, op: r, container: n }, this.elements = [], this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
    }
    SVGShapeData.prototype.setAsAnimated = function() {
      this._isAnimated = !0;
    }, SVGStyleData.prototype.reset = function() {
      this.d = "", this._mdf = !1;
    }, DashProperty.prototype.getValue = function(t) {
      if ((this.elem.globalData.frameId !== this.frameId || t) && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf = this._mdf || t, this._mdf)) {
        var r = 0, n = this.dataProps.length;
        for (this.renderer === "svg" && (this.dashStr = ""), r = 0; r < n; r += 1) this.dataProps[r].n !== "o" ? this.renderer === "svg" ? this.dashStr += " " + this.dataProps[r].p.v : this.dashArray[r] = this.dataProps[r].p.v : this.dashoffset[0] = this.dataProps[r].p.v;
      }
    }, extendPrototype([DynamicPropertyContainer], DashProperty), extendPrototype([DynamicPropertyContainer], SVGStrokeStyleData), extendPrototype([DynamicPropertyContainer], SVGFillStyleData), extendPrototype([DynamicPropertyContainer], SVGNoStyleData), GradientProperty.prototype.comparePoints = function(t, r) {
      for (var n = 0, a = this.o.length / 2; n < a; ) {
        if (Math.abs(t[4 * n] - t[4 * r + 2 * n]) > 0.01) return !1;
        n += 1;
      }
      return !0;
    }, GradientProperty.prototype.checkCollapsable = function() {
      if (this.o.length / 2 != this.c.length / 4) return !1;
      if (this.data.k.k[0].s) for (var t = 0, r = this.data.k.k.length; t < r; ) {
        if (!this.comparePoints(this.data.k.k[t].s, this.data.p)) return !1;
        t += 1;
      }
      else if (!this.comparePoints(this.data.k.k, this.data.p)) return !1;
      return !0;
    }, GradientProperty.prototype.getValue = function(t) {
      if (this.prop.getValue(), this._mdf = !1, this._cmdf = !1, this._omdf = !1, this.prop._mdf || t) {
        var r, n, a, s = 4 * this.data.p;
        for (r = 0; r < s; r += 1) n = r % 4 == 0 ? 100 : 255, a = Math.round(this.prop.v[r] * n), this.c[r] !== a && (this.c[r] = a, this._cmdf = !t);
        if (this.o.length) for (s = this.prop.v.length, r = 4 * this.data.p; r < s; r += 1) n = r % 2 == 0 ? 100 : 1, a = r % 2 == 0 ? Math.round(100 * this.prop.v[r]) : this.prop.v[r], this.o[r - 4 * this.data.p] !== a && (this.o[r - 4 * this.data.p] = a, this._omdf = !t);
        this._mdf = !t;
      }
    }, extendPrototype([DynamicPropertyContainer], GradientProperty), SVGGradientFillStyleData.prototype.initGradientData = function(t, r, n) {
      this.o = PropertyFactory.getProp(t, r.o, 0, 0.01, this), this.s = PropertyFactory.getProp(t, r.s, 1, null, this), this.e = PropertyFactory.getProp(t, r.e, 1, null, this), this.h = PropertyFactory.getProp(t, r.h || { k: 0 }, 0, 0.01, this), this.a = PropertyFactory.getProp(t, r.a || { k: 0 }, 0, degToRads, this), this.g = new GradientProperty(t, r.g, this), this.style = n, this.stops = [], this.setGradientData(n.pElem, r), this.setGradientOpacity(r, n), this._isAnimated = !!this._isAnimated;
    }, SVGGradientFillStyleData.prototype.setGradientData = function(t, r) {
      var n = createElementID(), a = createNS(r.t === 1 ? "linearGradient" : "radialGradient");
      a.setAttribute("id", n), a.setAttribute("spreadMethod", "pad"), a.setAttribute("gradientUnits", "userSpaceOnUse");
      var s, o, l, c = [];
      for (l = 4 * r.g.p, o = 0; o < l; o += 4) s = createNS("stop"), a.appendChild(s), c.push(s);
      t.setAttribute(r.ty === "gf" ? "fill" : "stroke", "url(" + getLocationHref() + "#" + n + ")"), this.gf = a, this.cst = c;
    }, SVGGradientFillStyleData.prototype.setGradientOpacity = function(t, r) {
      if (this.g._hasOpacity && !this.g._collapsable) {
        var n, a, s, o = createNS("mask"), l = createNS("path");
        o.appendChild(l);
        var c = createElementID(), x = createElementID();
        o.setAttribute("id", x);
        var j = createNS(t.t === 1 ? "linearGradient" : "radialGradient");
        j.setAttribute("id", c), j.setAttribute("spreadMethod", "pad"), j.setAttribute("gradientUnits", "userSpaceOnUse"), s = t.g.k.k[0].s ? t.g.k.k[0].s.length : t.g.k.k.length;
        var Z = this.stops;
        for (a = 4 * t.g.p; a < s; a += 2) (n = createNS("stop")).setAttribute("stop-color", "rgb(255,255,255)"), j.appendChild(n), Z.push(n);
        l.setAttribute(t.ty === "gf" ? "fill" : "stroke", "url(" + getLocationHref() + "#" + c + ")"), t.ty === "gs" && (l.setAttribute("stroke-linecap", lineCapEnum[t.lc || 2]), l.setAttribute("stroke-linejoin", lineJoinEnum[t.lj || 2]), t.lj === 1 && l.setAttribute("stroke-miterlimit", t.ml)), this.of = j, this.ms = o, this.ost = Z, this.maskId = x, r.msElem = l;
      }
    }, extendPrototype([DynamicPropertyContainer], SVGGradientFillStyleData), extendPrototype([SVGGradientFillStyleData, DynamicPropertyContainer], SVGGradientStrokeStyleData);
    var buildShapeString = function(t, r, n, a) {
      if (r === 0) return "";
      var s, o = t.o, l = t.i, c = t.v, x = " M" + a.applyToPointStringified(c[0][0], c[0][1]);
      for (s = 1; s < r; s += 1) x += " C" + a.applyToPointStringified(o[s - 1][0], o[s - 1][1]) + " " + a.applyToPointStringified(l[s][0], l[s][1]) + " " + a.applyToPointStringified(c[s][0], c[s][1]);
      return n && r && (x += " C" + a.applyToPointStringified(o[s - 1][0], o[s - 1][1]) + " " + a.applyToPointStringified(l[0][0], l[0][1]) + " " + a.applyToPointStringified(c[0][0], c[0][1]), x += "z"), x;
    }, SVGElementsRenderer = (function() {
      var t = new Matrix(), r = new Matrix();
      function n(j, Z, V) {
        (V || Z.transform.op._mdf) && Z.transform.container.setAttribute("opacity", Z.transform.op.v), (V || Z.transform.mProps._mdf) && Z.transform.container.setAttribute("transform", Z.transform.mProps.v.to2dCSS());
      }
      function a() {
      }
      function s(j, Z, V) {
        var U, $, Y, G, W, X, K, J, ee, te, ne = Z.styles.length, re = Z.lvl;
        for (X = 0; X < ne; X += 1) {
          if (G = Z.sh._mdf || V, Z.styles[X].lvl < re) {
            for (J = r.reset(), ee = re - Z.styles[X].lvl, te = Z.transformers.length - 1; !G && ee > 0; ) G = Z.transformers[te].mProps._mdf || G, ee -= 1, te -= 1;
            if (G) for (ee = re - Z.styles[X].lvl, te = Z.transformers.length - 1; ee > 0; ) J.multiply(Z.transformers[te].mProps.v), ee -= 1, te -= 1;
          } else J = t;
          if ($ = (K = Z.sh.paths)._length, G) {
            for (Y = "", U = 0; U < $; U += 1) (W = K.shapes[U]) && W._length && (Y += buildShapeString(W, W._length, W.c, J));
            Z.caches[X] = Y;
          } else Y = Z.caches[X];
          Z.styles[X].d += j.hd === !0 ? "" : Y, Z.styles[X]._mdf = G || Z.styles[X]._mdf;
        }
      }
      function o(j, Z, V) {
        var U = Z.style;
        (Z.c._mdf || V) && U.pElem.setAttribute("fill", "rgb(" + bmFloor(Z.c.v[0]) + "," + bmFloor(Z.c.v[1]) + "," + bmFloor(Z.c.v[2]) + ")"), (Z.o._mdf || V) && U.pElem.setAttribute("fill-opacity", Z.o.v);
      }
      function l(j, Z, V) {
        c(j, Z, V), x(j, Z, V);
      }
      function c(j, Z, V) {
        var U, $, Y, G, W, X = Z.gf, K = Z.g._hasOpacity, J = Z.s.v, ee = Z.e.v;
        if (Z.o._mdf || V) {
          var te = j.ty === "gf" ? "fill-opacity" : "stroke-opacity";
          Z.style.pElem.setAttribute(te, Z.o.v);
        }
        if (Z.s._mdf || V) {
          var ne = j.t === 1 ? "x1" : "cx", re = ne === "x1" ? "y1" : "cy";
          X.setAttribute(ne, J[0]), X.setAttribute(re, J[1]), K && !Z.g._collapsable && (Z.of.setAttribute(ne, J[0]), Z.of.setAttribute(re, J[1]));
        }
        if (Z.g._cmdf || V) {
          U = Z.cst;
          var ie = Z.g.c;
          for (Y = U.length, $ = 0; $ < Y; $ += 1) (G = U[$]).setAttribute("offset", ie[4 * $] + "%"), G.setAttribute("stop-color", "rgb(" + ie[4 * $ + 1] + "," + ie[4 * $ + 2] + "," + ie[4 * $ + 3] + ")");
        }
        if (K && (Z.g._omdf || V)) {
          var ue = Z.g.o;
          for (Y = (U = Z.g._collapsable ? Z.cst : Z.ost).length, $ = 0; $ < Y; $ += 1) G = U[$], Z.g._collapsable || G.setAttribute("offset", ue[2 * $] + "%"), G.setAttribute("stop-opacity", ue[2 * $ + 1]);
        }
        if (j.t === 1) (Z.e._mdf || V) && (X.setAttribute("x2", ee[0]), X.setAttribute("y2", ee[1]), K && !Z.g._collapsable && (Z.of.setAttribute("x2", ee[0]), Z.of.setAttribute("y2", ee[1])));
        else if ((Z.s._mdf || Z.e._mdf || V) && (W = Math.sqrt(Math.pow(J[0] - ee[0], 2) + Math.pow(J[1] - ee[1], 2)), X.setAttribute("r", W), K && !Z.g._collapsable && Z.of.setAttribute("r", W)), Z.e._mdf || Z.h._mdf || Z.a._mdf || V) {
          W || (W = Math.sqrt(Math.pow(J[0] - ee[0], 2) + Math.pow(J[1] - ee[1], 2)));
          var le = Math.atan2(ee[1] - J[1], ee[0] - J[0]), oe = Z.h.v;
          oe >= 1 ? oe = 0.99 : oe <= -1 && (oe = -0.99);
          var he = W * oe, fe = Math.cos(le + Z.a.v) * he + J[0], ce = Math.sin(le + Z.a.v) * he + J[1];
          X.setAttribute("fx", fe), X.setAttribute("fy", ce), K && !Z.g._collapsable && (Z.of.setAttribute("fx", fe), Z.of.setAttribute("fy", ce));
        }
      }
      function x(j, Z, V) {
        var U = Z.style, $ = Z.d;
        $ && ($._mdf || V) && $.dashStr && (U.pElem.setAttribute("stroke-dasharray", $.dashStr), U.pElem.setAttribute("stroke-dashoffset", $.dashoffset[0])), Z.c && (Z.c._mdf || V) && U.pElem.setAttribute("stroke", "rgb(" + bmFloor(Z.c.v[0]) + "," + bmFloor(Z.c.v[1]) + "," + bmFloor(Z.c.v[2]) + ")"), (Z.o._mdf || V) && U.pElem.setAttribute("stroke-opacity", Z.o.v), (Z.w._mdf || V) && (U.pElem.setAttribute("stroke-width", Z.w.v), U.msElem && U.msElem.setAttribute("stroke-width", Z.w.v));
      }
      return { createRenderFunction: function(j) {
        switch (j.ty) {
          case "fl":
            return o;
          case "gf":
            return c;
          case "gs":
            return l;
          case "st":
            return x;
          case "sh":
          case "el":
          case "rc":
          case "sr":
            return s;
          case "tr":
            return n;
          case "no":
            return a;
          default:
            return null;
        }
      } };
    })();
    function SVGShapeElement(t, r, n) {
      this.shapes = [], this.shapesData = t.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.initElement(t, r, n), this.prevViewData = [];
    }
    function LetterProps(t, r, n, a, s, o) {
      this.o = t, this.sw = r, this.sc = n, this.fc = a, this.m = s, this.p = o, this._mdf = { o: !0, sw: !!r, sc: !!n, fc: !!a, m: !0, p: !0 };
    }
    function TextProperty(t, r) {
      this._frameId = initialDefaultFrame, this.pv = "", this.v = "", this.kf = !1, this._isFirstFrame = !0, this._mdf = !1, r.d && r.d.sid && (r.d = t.globalData.slotManager.getProp(r.d)), this.data = r, this.elem = t, this.comp = this.elem.comp, this.keysIndex = 0, this.canResize = !1, this.minimumFontSize = 1, this.effectsSequence = [], this.currentData = { ascent: 0, boxWidth: this.defaultBoxWidth, f: "", fStyle: "", fWeight: "", fc: "", j: "", justifyOffset: "", l: [], lh: 0, lineWidths: [], ls: "", of: "", s: "", sc: "", sw: 0, t: 0, tr: 0, sz: 0, ps: null, fillColorAnim: !1, strokeColorAnim: !1, strokeWidthAnim: !1, yOffset: 0, finalSize: 0, finalText: [], finalLineHeight: 0, __complete: !1 }, this.copyData(this.currentData, this.data.d.k[0].s), this.searchProperty() || this.completeTextData(this.currentData);
    }
    extendPrototype([BaseElement, TransformElement, SVGBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableDOMElement], SVGShapeElement), SVGShapeElement.prototype.initSecondaryElement = function() {
    }, SVGShapeElement.prototype.identityMatrix = new Matrix(), SVGShapeElement.prototype.buildExpressionInterface = function() {
    }, SVGShapeElement.prototype.createContent = function() {
      this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes();
    }, SVGShapeElement.prototype.filterUniqueShapes = function() {
      var t, r, n, a, s = this.shapes.length, o = this.stylesList.length, l = [], c = !1;
      for (n = 0; n < o; n += 1) {
        for (a = this.stylesList[n], c = !1, l.length = 0, t = 0; t < s; t += 1) (r = this.shapes[t]).styles.indexOf(a) !== -1 && (l.push(r), c = r._isAnimated || c);
        l.length > 1 && c && this.setShapesAsAnimated(l);
      }
    }, SVGShapeElement.prototype.setShapesAsAnimated = function(t) {
      var r, n = t.length;
      for (r = 0; r < n; r += 1) t[r].setAsAnimated();
    }, SVGShapeElement.prototype.createStyleElement = function(t, r) {
      var n, a = new SVGStyleData(t, r), s = a.pElem;
      return t.ty === "st" ? n = new SVGStrokeStyleData(this, t, a) : t.ty === "fl" ? n = new SVGFillStyleData(this, t, a) : t.ty === "gf" || t.ty === "gs" ? (n = new (t.ty === "gf" ? SVGGradientFillStyleData : SVGGradientStrokeStyleData)(this, t, a), this.globalData.defs.appendChild(n.gf), n.maskId && (this.globalData.defs.appendChild(n.ms), this.globalData.defs.appendChild(n.of), s.setAttribute("mask", "url(" + getLocationHref() + "#" + n.maskId + ")"))) : t.ty === "no" && (n = new SVGNoStyleData(this, t, a)), t.ty !== "st" && t.ty !== "gs" || (s.setAttribute("stroke-linecap", lineCapEnum[t.lc || 2]), s.setAttribute("stroke-linejoin", lineJoinEnum[t.lj || 2]), s.setAttribute("fill-opacity", "0"), t.lj === 1 && s.setAttribute("stroke-miterlimit", t.ml)), t.r === 2 && s.setAttribute("fill-rule", "evenodd"), t.ln && s.setAttribute("id", t.ln), t.cl && s.setAttribute("class", t.cl), t.bm && (s.style["mix-blend-mode"] = getBlendMode(t.bm)), this.stylesList.push(a), this.addToAnimatedContents(t, n), n;
    }, SVGShapeElement.prototype.createGroupElement = function(t) {
      var r = new ShapeGroupData();
      return t.ln && r.gr.setAttribute("id", t.ln), t.cl && r.gr.setAttribute("class", t.cl), t.bm && (r.gr.style["mix-blend-mode"] = getBlendMode(t.bm)), r;
    }, SVGShapeElement.prototype.createTransformElement = function(t, r) {
      var n = TransformPropertyFactory.getTransformProperty(this, t, this), a = new SVGTransformData(n, n.o, r);
      return this.addToAnimatedContents(t, a), a;
    }, SVGShapeElement.prototype.createShapeElement = function(t, r, n) {
      var a = 4;
      t.ty === "rc" ? a = 5 : t.ty === "el" ? a = 6 : t.ty === "sr" && (a = 7);
      var s = new SVGShapeData(r, n, ShapePropertyFactory.getShapeProp(this, t, a, this));
      return this.shapes.push(s), this.addShapeToModifiers(s), this.addToAnimatedContents(t, s), s;
    }, SVGShapeElement.prototype.addToAnimatedContents = function(t, r) {
      for (var n = 0, a = this.animatedContents.length; n < a; ) {
        if (this.animatedContents[n].element === r) return;
        n += 1;
      }
      this.animatedContents.push({ fn: SVGElementsRenderer.createRenderFunction(t), element: r, data: t });
    }, SVGShapeElement.prototype.setElementStyles = function(t) {
      var r, n = t.styles, a = this.stylesList.length;
      for (r = 0; r < a; r += 1) this.stylesList[r].closed || n.push(this.stylesList[r]);
    }, SVGShapeElement.prototype.reloadShapes = function() {
      var t;
      this._isFirstFrame = !0;
      var r = this.itemsData.length;
      for (t = 0; t < r; t += 1) this.prevViewData[t] = this.itemsData[t];
      for (this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes(), r = this.dynamicProperties.length, t = 0; t < r; t += 1) this.dynamicProperties[t].getValue();
      this.renderModifiers();
    }, SVGShapeElement.prototype.searchShapes = function(t, r, n, a, s, o, l) {
      var c, x, j, Z, V, U, $ = [].concat(o), Y = t.length - 1, G = [], W = [];
      for (c = Y; c >= 0; c -= 1) {
        if ((U = this.searchProcessedElement(t[c])) ? r[c] = n[U - 1] : t[c]._render = l, t[c].ty === "fl" || t[c].ty === "st" || t[c].ty === "gf" || t[c].ty === "gs" || t[c].ty === "no") U ? r[c].style.closed = !1 : r[c] = this.createStyleElement(t[c], s), t[c]._render && r[c].style.pElem.parentNode !== a && a.appendChild(r[c].style.pElem), G.push(r[c].style);
        else if (t[c].ty === "gr") {
          if (U) for (j = r[c].it.length, x = 0; x < j; x += 1) r[c].prevViewData[x] = r[c].it[x];
          else r[c] = this.createGroupElement(t[c]);
          this.searchShapes(t[c].it, r[c].it, r[c].prevViewData, r[c].gr, s + 1, $, l), t[c]._render && r[c].gr.parentNode !== a && a.appendChild(r[c].gr);
        } else t[c].ty === "tr" ? (U || (r[c] = this.createTransformElement(t[c], a)), Z = r[c].transform, $.push(Z)) : t[c].ty === "sh" || t[c].ty === "rc" || t[c].ty === "el" || t[c].ty === "sr" ? (U || (r[c] = this.createShapeElement(t[c], $, s)), this.setElementStyles(r[c])) : t[c].ty === "tm" || t[c].ty === "rd" || t[c].ty === "ms" || t[c].ty === "pb" || t[c].ty === "zz" || t[c].ty === "op" ? (U ? (V = r[c]).closed = !1 : ((V = ShapeModifiers.getModifier(t[c].ty)).init(this, t[c]), r[c] = V, this.shapeModifiers.push(V)), W.push(V)) : t[c].ty === "rp" && (U ? (V = r[c]).closed = !0 : (V = ShapeModifiers.getModifier(t[c].ty), r[c] = V, V.init(this, t, c, r), this.shapeModifiers.push(V), l = !1), W.push(V));
        this.addProcessedElement(t[c], c + 1);
      }
      for (Y = G.length, c = 0; c < Y; c += 1) G[c].closed = !0;
      for (Y = W.length, c = 0; c < Y; c += 1) W[c].closed = !0;
    }, SVGShapeElement.prototype.renderInnerContent = function() {
      var t;
      this.renderModifiers();
      var r = this.stylesList.length;
      for (t = 0; t < r; t += 1) this.stylesList[t].reset();
      for (this.renderShape(), t = 0; t < r; t += 1) (this.stylesList[t]._mdf || this._isFirstFrame) && (this.stylesList[t].msElem && (this.stylesList[t].msElem.setAttribute("d", this.stylesList[t].d), this.stylesList[t].d = "M0 0" + this.stylesList[t].d), this.stylesList[t].pElem.setAttribute("d", this.stylesList[t].d || "M0 0"));
    }, SVGShapeElement.prototype.renderShape = function() {
      var t, r, n = this.animatedContents.length;
      for (t = 0; t < n; t += 1) r = this.animatedContents[t], (this._isFirstFrame || r.element._isAnimated) && r.data !== !0 && r.fn(r.data, r.element, this._isFirstFrame);
    }, SVGShapeElement.prototype.destroy = function() {
      this.destroyBaseElement(), this.shapesData = null, this.itemsData = null;
    }, LetterProps.prototype.update = function(t, r, n, a, s, o) {
      this._mdf.o = !1, this._mdf.sw = !1, this._mdf.sc = !1, this._mdf.fc = !1, this._mdf.m = !1, this._mdf.p = !1;
      var l = !1;
      return this.o !== t && (this.o = t, this._mdf.o = !0, l = !0), this.sw !== r && (this.sw = r, this._mdf.sw = !0, l = !0), this.sc !== n && (this.sc = n, this._mdf.sc = !0, l = !0), this.fc !== a && (this.fc = a, this._mdf.fc = !0, l = !0), this.m !== s && (this.m = s, this._mdf.m = !0, l = !0), !o.length || this.p[0] === o[0] && this.p[1] === o[1] && this.p[4] === o[4] && this.p[5] === o[5] && this.p[12] === o[12] && this.p[13] === o[13] || (this.p = o, this._mdf.p = !0, l = !0), l;
    }, TextProperty.prototype.defaultBoxWidth = [0, 0], TextProperty.prototype.copyData = function(t, r) {
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
      return t;
    }, TextProperty.prototype.setCurrentData = function(t) {
      t.__complete || this.completeTextData(t), this.currentData = t, this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth, this._mdf = !0;
    }, TextProperty.prototype.searchProperty = function() {
      return this.searchKeyframes();
    }, TextProperty.prototype.searchKeyframes = function() {
      return this.kf = this.data.d.k.length > 1, this.kf && this.addEffect(this.getKeyframeValue.bind(this)), this.kf;
    }, TextProperty.prototype.addEffect = function(t) {
      this.effectsSequence.push(t), this.elem.addDynamicProperty(this);
    }, TextProperty.prototype.getValue = function(t) {
      if (this.elem.globalData.frameId !== this.frameId && this.effectsSequence.length || t) {
        this.currentData.t = this.data.d.k[this.keysIndex].s.t;
        var r = this.currentData, n = this.keysIndex;
        if (this.lock) this.setCurrentData(this.currentData);
        else {
          var a;
          this.lock = !0, this._mdf = !1;
          var s = this.effectsSequence.length, o = t || this.data.d.k[this.keysIndex].s;
          for (a = 0; a < s; a += 1) o = n !== this.keysIndex ? this.effectsSequence[a](o, o.t) : this.effectsSequence[a](this.currentData, o.t);
          r !== o && this.setCurrentData(o), this.v = this.currentData, this.pv = this.v, this.lock = !1, this.frameId = this.elem.globalData.frameId;
        }
      }
    }, TextProperty.prototype.getKeyframeValue = function() {
      for (var t = this.data.d.k, r = this.elem.comp.renderedFrame, n = 0, a = t.length; n <= a - 1 && !(n === a - 1 || t[n + 1].t > r); ) n += 1;
      return this.keysIndex !== n && (this.keysIndex = n), this.data.d.k[this.keysIndex].s;
    }, TextProperty.prototype.buildFinalText = function(t) {
      for (var r, n, a = [], s = 0, o = t.length, l = !1, c = !1, x = ""; s < o; ) l = c, c = !1, r = t.charCodeAt(s), x = t.charAt(s), FontManager.isCombinedCharacter(r) ? l = !0 : r >= 55296 && r <= 56319 ? FontManager.isRegionalFlag(t, s) ? x = t.substr(s, 14) : (n = t.charCodeAt(s + 1)) >= 56320 && n <= 57343 && (FontManager.isModifier(r, n) ? (x = t.substr(s, 2), l = !0) : x = FontManager.isFlagEmoji(t.substr(s, 4)) ? t.substr(s, 4) : t.substr(s, 2)) : r > 56319 ? (n = t.charCodeAt(s + 1), FontManager.isVariationSelector(r) && (l = !0)) : FontManager.isZeroWidthJoiner(r) && (l = !0, c = !0), l ? (a[a.length - 1] += x, l = !1) : a.push(x), s += x.length;
      return a;
    }, TextProperty.prototype.completeTextData = function(t) {
      t.__complete = !0;
      var r, n, a, s, o, l, c, x = this.elem.globalData.fontManager, j = this.data, Z = [], V = 0, U = j.m.g, $ = 0, Y = 0, G = 0, W = [], X = 0, K = 0, J = x.getFontByName(t.f), ee = 0, te = getFontProperties(J);
      t.fWeight = te.weight, t.fStyle = te.style, t.finalSize = t.s, t.finalText = this.buildFinalText(t.t), n = t.finalText.length, t.finalLineHeight = t.lh;
      var ne, re = t.tr / 1e3 * t.finalSize;
      if (t.sz) for (var ie, ue, le = !0, oe = t.sz[0], he = t.sz[1]; le; ) {
        ie = 0, X = 0, n = (ue = this.buildFinalText(t.t)).length, re = t.tr / 1e3 * t.finalSize;
        var fe = -1;
        for (r = 0; r < n; r += 1) ne = ue[r].charCodeAt(0), a = !1, ue[r] === " " ? fe = r : ne !== 13 && ne !== 3 || (X = 0, a = !0, ie += t.finalLineHeight || 1.2 * t.finalSize), x.chars ? (c = x.getCharData(ue[r], J.fStyle, J.fFamily), ee = a ? 0 : c.w * t.finalSize / 100) : ee = x.measureText(ue[r], t.f, t.finalSize), X + ee > oe && ue[r] !== " " ? (fe === -1 ? n += 1 : r = fe, ie += t.finalLineHeight || 1.2 * t.finalSize, ue.splice(r, fe === r ? 1 : 0, "\r"), fe = -1, X = 0) : (X += ee, X += re);
        ie += J.ascent * t.finalSize / 100, this.canResize && t.finalSize > this.minimumFontSize && he < ie ? (t.finalSize -= 1, t.finalLineHeight = t.finalSize * t.lh / t.s) : (t.finalText = ue, n = t.finalText.length, le = !1);
      }
      X = -re, ee = 0;
      var ce, se = 0;
      for (r = 0; r < n; r += 1) if (a = !1, (ne = (ce = t.finalText[r]).charCodeAt(0)) === 13 || ne === 3 ? (se = 0, W.push(X), K = X > K ? X : K, X = -2 * re, s = "", a = !0, G += 1) : s = ce, x.chars ? (c = x.getCharData(ce, J.fStyle, x.getFontByName(t.f).fFamily), ee = a ? 0 : c.w * t.finalSize / 100) : ee = x.measureText(s, t.f, t.finalSize), ce === " " ? se += ee + re : (X += ee + re + se, se = 0), Z.push({ l: ee, an: ee, add: $, n: a, anIndexes: [], val: s, line: G, animatorJustifyOffset: 0 }), U == 2) {
        if ($ += ee, s === "" || s === " " || r === n - 1) {
          for (s !== "" && s !== " " || ($ -= ee); Y <= r; ) Z[Y].an = $, Z[Y].ind = V, Z[Y].extra = ee, Y += 1;
          V += 1, $ = 0;
        }
      } else if (U == 3) {
        if ($ += ee, s === "" || r === n - 1) {
          for (s === "" && ($ -= ee); Y <= r; ) Z[Y].an = $, Z[Y].ind = V, Z[Y].extra = ee, Y += 1;
          $ = 0, V += 1;
        }
      } else Z[V].ind = V, Z[V].extra = 0, V += 1;
      if (t.l = Z, K = X > K ? X : K, W.push(X), t.sz) t.boxWidth = t.sz[0], t.justifyOffset = 0;
      else switch (t.boxWidth = K, t.j) {
        case 1:
          t.justifyOffset = -t.boxWidth;
          break;
        case 2:
          t.justifyOffset = -t.boxWidth / 2;
          break;
        default:
          t.justifyOffset = 0;
      }
      t.lineWidths = W;
      var pe, ve, ae, me, de = j.a;
      l = de.length;
      var ge = [];
      for (o = 0; o < l; o += 1) {
        for ((pe = de[o]).a.sc && (t.strokeColorAnim = !0), pe.a.sw && (t.strokeWidthAnim = !0), (pe.a.fc || pe.a.fh || pe.a.fs || pe.a.fb) && (t.fillColorAnim = !0), me = 0, ae = pe.s.b, r = 0; r < n; r += 1) (ve = Z[r]).anIndexes[o] = me, (ae == 1 && ve.val !== "" || ae == 2 && ve.val !== "" && ve.val !== " " || ae == 3 && (ve.n || ve.val == " " || r == n - 1) || ae == 4 && (ve.n || r == n - 1)) && (pe.s.rn === 1 && ge.push(me), me += 1);
        j.a[o].s.totalChars = me;
        var Se, xe = -1;
        if (pe.s.rn === 1) for (r = 0; r < n; r += 1) xe != (ve = Z[r]).anIndexes[o] && (xe = ve.anIndexes[o], Se = ge.splice(Math.floor(Math.random() * ge.length), 1)[0]), ve.anIndexes[o] = Se;
      }
      t.yOffset = t.finalLineHeight || 1.2 * t.finalSize, t.ls = t.ls || 0, t.ascent = J.ascent * t.finalSize / 100;
    }, TextProperty.prototype.updateDocumentData = function(t, r) {
      r = r === void 0 ? this.keysIndex : r;
      var n = this.copyData({}, this.data.d.k[r].s);
      n = this.copyData(n, t), this.data.d.k[r].s = n, this.recalculate(r), this.setCurrentData(n), this.elem.addDynamicProperty(this);
    }, TextProperty.prototype.recalculate = function(t) {
      var r = this.data.d.k[t].s;
      r.__complete = !1, this.keysIndex = 0, this._isFirstFrame = !0, this.getValue(r);
    }, TextProperty.prototype.canResizeFont = function(t) {
      this.canResize = t, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
    }, TextProperty.prototype.setMinimumFontSize = function(t) {
      this.minimumFontSize = Math.floor(t) || 1, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
    };
    var TextSelectorProp = (function() {
      var t = Math.max, r = Math.min, n = Math.floor;
      function a(s, o) {
        this._currentTextLength = -1, this.k = !1, this.data = o, this.elem = s, this.comp = s.comp, this.finalS = 0, this.finalE = 0, this.initDynamicPropertyContainer(s), this.s = PropertyFactory.getProp(s, o.s || { k: 0 }, 0, 0, this), this.e = "e" in o ? PropertyFactory.getProp(s, o.e, 0, 0, this) : { v: 100 }, this.o = PropertyFactory.getProp(s, o.o || { k: 0 }, 0, 0, this), this.xe = PropertyFactory.getProp(s, o.xe || { k: 0 }, 0, 0, this), this.ne = PropertyFactory.getProp(s, o.ne || { k: 0 }, 0, 0, this), this.sm = PropertyFactory.getProp(s, o.sm || { k: 100 }, 0, 0, this), this.a = PropertyFactory.getProp(s, o.a, 0, 0.01, this), this.dynamicProperties.length || this.getValue();
      }
      return a.prototype = { getMult: function(s) {
        this._currentTextLength !== this.elem.textProperty.currentData.l.length && this.getValue();
        var o = 0, l = 0, c = 1, x = 1;
        this.ne.v > 0 ? o = this.ne.v / 100 : l = -this.ne.v / 100, this.xe.v > 0 ? c = 1 - this.xe.v / 100 : x = 1 + this.xe.v / 100;
        var j = BezierFactory.getBezierEasing(o, l, c, x).get, Z = 0, V = this.finalS, U = this.finalE, $ = this.data.sh;
        if ($ === 2) Z = j(Z = U === V ? s >= U ? 1 : 0 : t(0, r(0.5 / (U - V) + (s - V) / (U - V), 1)));
        else if ($ === 3) Z = j(Z = U === V ? s >= U ? 0 : 1 : 1 - t(0, r(0.5 / (U - V) + (s - V) / (U - V), 1)));
        else if ($ === 4) U === V ? Z = 0 : (Z = t(0, r(0.5 / (U - V) + (s - V) / (U - V), 1))) < 0.5 ? Z *= 2 : Z = 1 - 2 * (Z - 0.5), Z = j(Z);
        else if ($ === 5) {
          if (U === V) Z = 0;
          else {
            var Y = U - V, G = -Y / 2 + (s = r(t(0, s + 0.5 - V), U - V)), W = Y / 2;
            Z = Math.sqrt(1 - G * G / (W * W));
          }
          Z = j(Z);
        } else $ === 6 ? (U === V ? Z = 0 : (s = r(t(0, s + 0.5 - V), U - V), Z = (1 + Math.cos(Math.PI + 2 * Math.PI * s / (U - V))) / 2), Z = j(Z)) : (s >= n(V) && (Z = t(0, r(s - V < 0 ? r(U, 1) - (V - s) : U - s, 1))), Z = j(Z));
        if (this.sm.v !== 100) {
          var X = 0.01 * this.sm.v;
          X === 0 && (X = 1e-8);
          var K = 0.5 - 0.5 * X;
          Z < K ? Z = 0 : (Z = (Z - K) / X) > 1 && (Z = 1);
        }
        return Z * this.a.v;
      }, getValue: function(s) {
        this.iterateDynamicProperties(), this._mdf = s || this._mdf, this._currentTextLength = this.elem.textProperty.currentData.l.length || 0, s && this.data.r === 2 && (this.e.v = this._currentTextLength);
        var o = this.data.r === 2 ? 1 : 100 / this.data.totalChars, l = this.o.v / o, c = this.s.v / o + l, x = this.e.v / o + l;
        if (c > x) {
          var j = c;
          c = x, x = j;
        }
        this.finalS = c, this.finalE = x;
      } }, extendPrototype([DynamicPropertyContainer], a), { getTextSelectorProp: function(s, o, l) {
        return new a(s, o);
      } };
    })();
    function TextAnimatorDataProperty(t, r, n) {
      var a = { propType: !1 }, s = PropertyFactory.getProp, o = r.a;
      this.a = { r: o.r ? s(t, o.r, 0, degToRads, n) : a, rx: o.rx ? s(t, o.rx, 0, degToRads, n) : a, ry: o.ry ? s(t, o.ry, 0, degToRads, n) : a, sk: o.sk ? s(t, o.sk, 0, degToRads, n) : a, sa: o.sa ? s(t, o.sa, 0, degToRads, n) : a, s: o.s ? s(t, o.s, 1, 0.01, n) : a, a: o.a ? s(t, o.a, 1, 0, n) : a, o: o.o ? s(t, o.o, 0, 0.01, n) : a, p: o.p ? s(t, o.p, 1, 0, n) : a, sw: o.sw ? s(t, o.sw, 0, 0, n) : a, sc: o.sc ? s(t, o.sc, 1, 0, n) : a, fc: o.fc ? s(t, o.fc, 1, 0, n) : a, fh: o.fh ? s(t, o.fh, 0, 0, n) : a, fs: o.fs ? s(t, o.fs, 0, 0.01, n) : a, fb: o.fb ? s(t, o.fb, 0, 0.01, n) : a, t: o.t ? s(t, o.t, 0, 0, n) : a }, this.s = TextSelectorProp.getTextSelectorProp(t, r.s, n), this.s.t = r.s.t;
    }
    function TextAnimatorProperty(t, r, n) {
      this._isFirstFrame = !0, this._hasMaskedPath = !1, this._frameId = -1, this._textData = t, this._renderType = r, this._elem = n, this._animatorsData = createSizedArray(this._textData.a.length), this._pathData = {}, this._moreOptions = { alignment: {} }, this.renderedLetters = [], this.lettersChangedFlag = !1, this.initDynamicPropertyContainer(n);
    }
    function ITextElement() {
    }
    TextAnimatorProperty.prototype.searchProperties = function() {
      var t, r, n = this._textData.a.length, a = PropertyFactory.getProp;
      for (t = 0; t < n; t += 1) r = this._textData.a[t], this._animatorsData[t] = new TextAnimatorDataProperty(this._elem, r, this);
      this._textData.p && "m" in this._textData.p ? (this._pathData = { a: a(this._elem, this._textData.p.a, 0, 0, this), f: a(this._elem, this._textData.p.f, 0, 0, this), l: a(this._elem, this._textData.p.l, 0, 0, this), r: a(this._elem, this._textData.p.r, 0, 0, this), p: a(this._elem, this._textData.p.p, 0, 0, this), m: this._elem.maskManager.getMaskProperty(this._textData.p.m) }, this._hasMaskedPath = !0) : this._hasMaskedPath = !1, this._moreOptions.alignment = a(this._elem, this._textData.m.a, 1, 0, this);
    }, TextAnimatorProperty.prototype.getMeasures = function(t, r) {
      if (this.lettersChangedFlag = r, this._mdf || this._isFirstFrame || r || this._hasMaskedPath && this._pathData.m._mdf) {
        this._isFirstFrame = !1;
        var n, a, s, o, l, c, x, j, Z, V, U, $, Y, G, W, X, K, J, ee, te = this._moreOptions.alignment.v, ne = this._animatorsData, re = this._textData, ie = this.mHelper, ue = this._renderType, le = this.renderedLetters.length, oe = t.l;
        if (this._hasMaskedPath) {
          if (ee = this._pathData.m, !this._pathData.n || this._pathData._mdf) {
            var he, fe = ee.v;
            for (this._pathData.r.v && (fe = fe.reverse()), l = { tLength: 0, segments: [] }, o = fe._length - 1, X = 0, s = 0; s < o; s += 1) he = bez.buildBezierData(fe.v[s], fe.v[s + 1], [fe.o[s][0] - fe.v[s][0], fe.o[s][1] - fe.v[s][1]], [fe.i[s + 1][0] - fe.v[s + 1][0], fe.i[s + 1][1] - fe.v[s + 1][1]]), l.tLength += he.segmentLength, l.segments.push(he), X += he.segmentLength;
            s = o, ee.v.c && (he = bez.buildBezierData(fe.v[s], fe.v[0], [fe.o[s][0] - fe.v[s][0], fe.o[s][1] - fe.v[s][1]], [fe.i[0][0] - fe.v[0][0], fe.i[0][1] - fe.v[0][1]]), l.tLength += he.segmentLength, l.segments.push(he), X += he.segmentLength), this._pathData.pi = l;
          }
          if (l = this._pathData.pi, c = this._pathData.f.v, U = 0, V = 1, j = 0, Z = !0, G = l.segments, c < 0 && ee.v.c) for (l.tLength < Math.abs(c) && (c = -Math.abs(c) % l.tLength), V = (Y = G[U = G.length - 1].points).length - 1; c < 0; ) c += Y[V].partialLength, (V -= 1) < 0 && (V = (Y = G[U -= 1].points).length - 1);
          $ = (Y = G[U].points)[V - 1], W = (x = Y[V]).partialLength;
        }
        o = oe.length, n = 0, a = 0;
        var ce, se, pe, ve, ae, me = 1.2 * t.finalSize * 0.714, de = !0;
        pe = ne.length;
        var ge, Se, xe, Ee, Ce, ke, Re, _e, Me, we, Te, be, Pe = -1, ye = c, Ae = U, Fe = V, Ie = -1, Le = "", De = this.defaultPropsArray;
        if (t.j === 2 || t.j === 1) {
          var je = 0, Ze = 0, $e = t.j === 2 ? -0.5 : -1, Oe = 0, Be = !0;
          for (s = 0; s < o; s += 1) if (oe[s].n) {
            for (je && (je += Ze); Oe < s; ) oe[Oe].animatorJustifyOffset = je, Oe += 1;
            je = 0, Be = !0;
          } else {
            for (se = 0; se < pe; se += 1) (ce = ne[se].a).t.propType && (Be && t.j === 2 && (Ze += ce.t.v * $e), (ae = ne[se].s.getMult(oe[s].anIndexes[se], re.a[se].s.totalChars)).length ? je += ce.t.v * ae[0] * $e : je += ce.t.v * ae * $e);
            Be = !1;
          }
          for (je && (je += Ze); Oe < s; ) oe[Oe].animatorJustifyOffset = je, Oe += 1;
        }
        for (s = 0; s < o; s += 1) {
          if (ie.reset(), Ee = 1, oe[s].n) n = 0, a += t.yOffset, a += de ? 1 : 0, c = ye, de = !1, this._hasMaskedPath && (V = Fe, $ = (Y = G[U = Ae].points)[V - 1], W = (x = Y[V]).partialLength, j = 0), Le = "", Te = "", Me = "", be = "", De = this.defaultPropsArray;
          else {
            if (this._hasMaskedPath) {
              if (Ie !== oe[s].line) {
                switch (t.j) {
                  case 1:
                    c += X - t.lineWidths[oe[s].line];
                    break;
                  case 2:
                    c += (X - t.lineWidths[oe[s].line]) / 2;
                }
                Ie = oe[s].line;
              }
              Pe !== oe[s].ind && (oe[Pe] && (c += oe[Pe].extra), c += oe[s].an / 2, Pe = oe[s].ind), c += te[0] * oe[s].an * 5e-3;
              var Qe = 0;
              for (se = 0; se < pe; se += 1) (ce = ne[se].a).p.propType && ((ae = ne[se].s.getMult(oe[s].anIndexes[se], re.a[se].s.totalChars)).length ? Qe += ce.p.v[0] * ae[0] : Qe += ce.p.v[0] * ae), ce.a.propType && ((ae = ne[se].s.getMult(oe[s].anIndexes[se], re.a[se].s.totalChars)).length ? Qe += ce.a.v[0] * ae[0] : Qe += ce.a.v[0] * ae);
              for (Z = !0, this._pathData.a.v && (c = 0.5 * oe[0].an + (X - this._pathData.f.v - 0.5 * oe[0].an - 0.5 * oe[oe.length - 1].an) * Pe / (o - 1), c += this._pathData.f.v); Z; ) j + W >= c + Qe || !Y ? (K = (c + Qe - j) / x.partialLength, Se = $.point[0] + (x.point[0] - $.point[0]) * K, xe = $.point[1] + (x.point[1] - $.point[1]) * K, ie.translate(-te[0] * oe[s].an * 5e-3, -te[1] * me * 0.01), Z = !1) : Y && (j += x.partialLength, (V += 1) >= Y.length && (V = 0, G[U += 1] ? Y = G[U].points : ee.v.c ? (V = 0, Y = G[U = 0].points) : (j -= x.partialLength, Y = null)), Y && ($ = x, W = (x = Y[V]).partialLength));
              ge = oe[s].an / 2 - oe[s].add, ie.translate(-ge, 0, 0);
            } else ge = oe[s].an / 2 - oe[s].add, ie.translate(-ge, 0, 0), ie.translate(-te[0] * oe[s].an * 5e-3, -te[1] * me * 0.01, 0);
            for (se = 0; se < pe; se += 1) (ce = ne[se].a).t.propType && (ae = ne[se].s.getMult(oe[s].anIndexes[se], re.a[se].s.totalChars), n === 0 && t.j === 0 || (this._hasMaskedPath ? ae.length ? c += ce.t.v * ae[0] : c += ce.t.v * ae : ae.length ? n += ce.t.v * ae[0] : n += ce.t.v * ae));
            for (t.strokeWidthAnim && (ke = t.sw || 0), t.strokeColorAnim && (Ce = t.sc ? [t.sc[0], t.sc[1], t.sc[2]] : [0, 0, 0]), t.fillColorAnim && t.fc && (Re = [t.fc[0], t.fc[1], t.fc[2]]), se = 0; se < pe; se += 1) (ce = ne[se].a).a.propType && ((ae = ne[se].s.getMult(oe[s].anIndexes[se], re.a[se].s.totalChars)).length ? ie.translate(-ce.a.v[0] * ae[0], -ce.a.v[1] * ae[1], ce.a.v[2] * ae[2]) : ie.translate(-ce.a.v[0] * ae, -ce.a.v[1] * ae, ce.a.v[2] * ae));
            for (se = 0; se < pe; se += 1) (ce = ne[se].a).s.propType && ((ae = ne[se].s.getMult(oe[s].anIndexes[se], re.a[se].s.totalChars)).length ? ie.scale(1 + (ce.s.v[0] - 1) * ae[0], 1 + (ce.s.v[1] - 1) * ae[1], 1) : ie.scale(1 + (ce.s.v[0] - 1) * ae, 1 + (ce.s.v[1] - 1) * ae, 1));
            for (se = 0; se < pe; se += 1) {
              if (ce = ne[se].a, ae = ne[se].s.getMult(oe[s].anIndexes[se], re.a[se].s.totalChars), ce.sk.propType && (ae.length ? ie.skewFromAxis(-ce.sk.v * ae[0], ce.sa.v * ae[1]) : ie.skewFromAxis(-ce.sk.v * ae, ce.sa.v * ae)), ce.r.propType && (ae.length ? ie.rotateZ(-ce.r.v * ae[2]) : ie.rotateZ(-ce.r.v * ae)), ce.ry.propType && (ae.length ? ie.rotateY(ce.ry.v * ae[1]) : ie.rotateY(ce.ry.v * ae)), ce.rx.propType && (ae.length ? ie.rotateX(ce.rx.v * ae[0]) : ie.rotateX(ce.rx.v * ae)), ce.o.propType && (ae.length ? Ee += (ce.o.v * ae[0] - Ee) * ae[0] : Ee += (ce.o.v * ae - Ee) * ae), t.strokeWidthAnim && ce.sw.propType && (ae.length ? ke += ce.sw.v * ae[0] : ke += ce.sw.v * ae), t.strokeColorAnim && ce.sc.propType) for (_e = 0; _e < 3; _e += 1) ae.length ? Ce[_e] += (ce.sc.v[_e] - Ce[_e]) * ae[0] : Ce[_e] += (ce.sc.v[_e] - Ce[_e]) * ae;
              if (t.fillColorAnim && t.fc) {
                if (ce.fc.propType) for (_e = 0; _e < 3; _e += 1) ae.length ? Re[_e] += (ce.fc.v[_e] - Re[_e]) * ae[0] : Re[_e] += (ce.fc.v[_e] - Re[_e]) * ae;
                ce.fh.propType && (Re = ae.length ? addHueToRGB(Re, ce.fh.v * ae[0]) : addHueToRGB(Re, ce.fh.v * ae)), ce.fs.propType && (Re = ae.length ? addSaturationToRGB(Re, ce.fs.v * ae[0]) : addSaturationToRGB(Re, ce.fs.v * ae)), ce.fb.propType && (Re = ae.length ? addBrightnessToRGB(Re, ce.fb.v * ae[0]) : addBrightnessToRGB(Re, ce.fb.v * ae));
              }
            }
            for (se = 0; se < pe; se += 1) (ce = ne[se].a).p.propType && (ae = ne[se].s.getMult(oe[s].anIndexes[se], re.a[se].s.totalChars), this._hasMaskedPath ? ae.length ? ie.translate(0, ce.p.v[1] * ae[0], -ce.p.v[2] * ae[1]) : ie.translate(0, ce.p.v[1] * ae, -ce.p.v[2] * ae) : ae.length ? ie.translate(ce.p.v[0] * ae[0], ce.p.v[1] * ae[1], -ce.p.v[2] * ae[2]) : ie.translate(ce.p.v[0] * ae, ce.p.v[1] * ae, -ce.p.v[2] * ae));
            if (t.strokeWidthAnim && (Me = ke < 0 ? 0 : ke), t.strokeColorAnim && (we = "rgb(" + Math.round(255 * Ce[0]) + "," + Math.round(255 * Ce[1]) + "," + Math.round(255 * Ce[2]) + ")"), t.fillColorAnim && t.fc && (Te = "rgb(" + Math.round(255 * Re[0]) + "," + Math.round(255 * Re[1]) + "," + Math.round(255 * Re[2]) + ")"), this._hasMaskedPath) {
              if (ie.translate(0, -t.ls), ie.translate(0, te[1] * me * 0.01 + a, 0), this._pathData.p.v) {
                J = (x.point[1] - $.point[1]) / (x.point[0] - $.point[0]);
                var Xe = 180 * Math.atan(J) / Math.PI;
                x.point[0] < $.point[0] && (Xe += 180), ie.rotate(-Xe * Math.PI / 180);
              }
              ie.translate(Se, xe, 0), c -= te[0] * oe[s].an * 5e-3, oe[s + 1] && Pe !== oe[s + 1].ind && (c += oe[s].an / 2, c += 1e-3 * t.tr * t.finalSize);
            } else {
              switch (ie.translate(n, a, 0), t.ps && ie.translate(t.ps[0], t.ps[1] + t.ascent, 0), t.j) {
                case 1:
                  ie.translate(oe[s].animatorJustifyOffset + t.justifyOffset + (t.boxWidth - t.lineWidths[oe[s].line]), 0, 0);
                  break;
                case 2:
                  ie.translate(oe[s].animatorJustifyOffset + t.justifyOffset + (t.boxWidth - t.lineWidths[oe[s].line]) / 2, 0, 0);
              }
              ie.translate(0, -t.ls), ie.translate(ge, 0, 0), ie.translate(te[0] * oe[s].an * 5e-3, te[1] * me * 0.01, 0), n += oe[s].l + 1e-3 * t.tr * t.finalSize;
            }
            ue === "html" ? Le = ie.toCSS() : ue === "svg" ? Le = ie.to2dCSS() : De = [ie.props[0], ie.props[1], ie.props[2], ie.props[3], ie.props[4], ie.props[5], ie.props[6], ie.props[7], ie.props[8], ie.props[9], ie.props[10], ie.props[11], ie.props[12], ie.props[13], ie.props[14], ie.props[15]], be = Ee;
          }
          le <= s ? (ve = new LetterProps(be, Me, we, Te, Le, De), this.renderedLetters.push(ve), le += 1, this.lettersChangedFlag = !0) : (ve = this.renderedLetters[s], this.lettersChangedFlag = ve.update(be, Me, we, Te, Le, De) || this.lettersChangedFlag);
        }
      }
    }, TextAnimatorProperty.prototype.getValue = function() {
      this._elem.globalData.frameId !== this._frameId && (this._frameId = this._elem.globalData.frameId, this.iterateDynamicProperties());
    }, TextAnimatorProperty.prototype.mHelper = new Matrix(), TextAnimatorProperty.prototype.defaultPropsArray = [], extendPrototype([DynamicPropertyContainer], TextAnimatorProperty), ITextElement.prototype.initElement = function(t, r, n) {
      this.lettersChangedFlag = !0, this.initFrame(), this.initBaseData(t, r, n), this.textProperty = new TextProperty(this, t.t, this.dynamicProperties), this.textAnimator = new TextAnimatorProperty(t.t, this.renderType, this), this.initTransform(t, r, n), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide(), this.textAnimator.searchProperties(this.dynamicProperties);
    }, ITextElement.prototype.prepareFrame = function(t) {
      this._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange);
    }, ITextElement.prototype.createPathShape = function(t, r) {
      var n, a, s = r.length, o = "";
      for (n = 0; n < s; n += 1) r[n].ty === "sh" && (a = r[n].ks.k, o += buildShapeString(a, a.i.length, !0, t));
      return o;
    }, ITextElement.prototype.updateDocumentData = function(t, r) {
      this.textProperty.updateDocumentData(t, r);
    }, ITextElement.prototype.canResizeFont = function(t) {
      this.textProperty.canResizeFont(t);
    }, ITextElement.prototype.setMinimumFontSize = function(t) {
      this.textProperty.setMinimumFontSize(t);
    }, ITextElement.prototype.applyTextPropertiesToMatrix = function(t, r, n, a, s) {
      switch (t.ps && r.translate(t.ps[0], t.ps[1] + t.ascent, 0), r.translate(0, -t.ls, 0), t.j) {
        case 1:
          r.translate(t.justifyOffset + (t.boxWidth - t.lineWidths[n]), 0, 0);
          break;
        case 2:
          r.translate(t.justifyOffset + (t.boxWidth - t.lineWidths[n]) / 2, 0, 0);
      }
      r.translate(a, s, 0);
    }, ITextElement.prototype.buildColor = function(t) {
      return "rgb(" + Math.round(255 * t[0]) + "," + Math.round(255 * t[1]) + "," + Math.round(255 * t[2]) + ")";
    }, ITextElement.prototype.emptyProp = new LetterProps(), ITextElement.prototype.destroy = function() {
    }, ITextElement.prototype.validateText = function() {
      (this.textProperty._mdf || this.textProperty._isFirstFrame) && (this.buildNewText(), this.textProperty._isFirstFrame = !1, this.textProperty._mdf = !1);
    };
    var emptyShapeData = { shapes: [] };
    function SVGTextLottieElement(t, r, n) {
      this.textSpans = [], this.renderType = "svg", this.initElement(t, r, n);
    }
    function ISolidElement(t, r, n) {
      this.initElement(t, r, n);
    }
    function NullElement(t, r, n) {
      this.initFrame(), this.initBaseData(t, r, n), this.initFrame(), this.initTransform(t, r, n), this.initHierarchy();
    }
    function SVGRendererBase() {
    }
    function ICompElement() {
    }
    function SVGCompElement(t, r, n) {
      this.layers = t.layers, this.supports3d = !0, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(t, r, n), this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, r.frameRate, this) : { _placeholder: !0 };
    }
    function SVGRenderer(t, r) {
      this.animationItem = t, this.layers = null, this.renderedFrame = -1, this.svgElement = createNS("svg");
      var n = "";
      if (r && r.title) {
        var a = createNS("title"), s = createElementID();
        a.setAttribute("id", s), a.textContent = r.title, this.svgElement.appendChild(a), n += s;
      }
      if (r && r.description) {
        var o = createNS("desc"), l = createElementID();
        o.setAttribute("id", l), o.textContent = r.description, this.svgElement.appendChild(o), n += " " + l;
      }
      n && this.svgElement.setAttribute("aria-labelledby", n);
      var c = createNS("defs");
      this.svgElement.appendChild(c);
      var x = createNS("g");
      this.svgElement.appendChild(x), this.layerElement = x, this.renderConfig = { preserveAspectRatio: r && r.preserveAspectRatio || "xMidYMid meet", imagePreserveAspectRatio: r && r.imagePreserveAspectRatio || "xMidYMid slice", contentVisibility: r && r.contentVisibility || "visible", progressiveLoad: r && r.progressiveLoad || !1, hideOnTransparent: !(r && r.hideOnTransparent === !1), viewBoxOnly: r && r.viewBoxOnly || !1, viewBoxSize: r && r.viewBoxSize || !1, className: r && r.className || "", id: r && r.id || "", focusable: r && r.focusable, filterSize: { width: r && r.filterSize && r.filterSize.width || "100%", height: r && r.filterSize && r.filterSize.height || "100%", x: r && r.filterSize && r.filterSize.x || "0%", y: r && r.filterSize && r.filterSize.y || "0%" }, width: r && r.width, height: r && r.height, runExpressions: !r || r.runExpressions === void 0 || r.runExpressions }, this.globalData = { _mdf: !1, frameNum: -1, defs: c, renderConfig: this.renderConfig }, this.elements = [], this.pendingElements = [], this.destroyed = !1, this.rendererType = "svg";
    }
    function ShapeTransformManager() {
      this.sequences = {}, this.sequenceList = [], this.transform_key_count = 0;
    }
    extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], SVGTextLottieElement), SVGTextLottieElement.prototype.createContent = function() {
      this.data.singleShape && !this.globalData.fontManager.chars && (this.textContainer = createNS("text"));
    }, SVGTextLottieElement.prototype.buildTextContents = function(t) {
      for (var r = 0, n = t.length, a = [], s = ""; r < n; ) t[r] === "\r" || t[r] === "" ? (a.push(s), s = "") : s += t[r], r += 1;
      return a.push(s), a;
    }, SVGTextLottieElement.prototype.buildShapeData = function(t, r) {
      if (t.shapes && t.shapes.length) {
        var n = t.shapes[0];
        if (n.it) {
          var a = n.it[n.it.length - 1];
          a.s && (a.s.k[0] = r, a.s.k[1] = r);
        }
      }
      return t;
    }, SVGTextLottieElement.prototype.buildNewText = function() {
      var t, r;
      this.addDynamicProperty(this);
      var n = this.textProperty.currentData;
      this.renderedLetters = createSizedArray(n ? n.l.length : 0), n.fc ? this.layerElement.setAttribute("fill", this.buildColor(n.fc)) : this.layerElement.setAttribute("fill", "rgba(0,0,0,0)"), n.sc && (this.layerElement.setAttribute("stroke", this.buildColor(n.sc)), this.layerElement.setAttribute("stroke-width", n.sw)), this.layerElement.setAttribute("font-size", n.finalSize);
      var a = this.globalData.fontManager.getFontByName(n.f);
      if (a.fClass) this.layerElement.setAttribute("class", a.fClass);
      else {
        this.layerElement.setAttribute("font-family", a.fFamily);
        var s = n.fWeight, o = n.fStyle;
        this.layerElement.setAttribute("font-style", o), this.layerElement.setAttribute("font-weight", s);
      }
      this.layerElement.setAttribute("aria-label", n.t);
      var l, c = n.l || [], x = !!this.globalData.fontManager.chars;
      r = c.length;
      var j = this.mHelper, Z = this.data.singleShape, V = 0, U = 0, $ = !0, Y = 1e-3 * n.tr * n.finalSize;
      if (!Z || x || n.sz) {
        var G, W = this.textSpans.length;
        for (t = 0; t < r; t += 1) {
          if (this.textSpans[t] || (this.textSpans[t] = { span: null, childSpan: null, glyph: null }), !x || !Z || t === 0) {
            if (l = W > t ? this.textSpans[t].span : createNS(x ? "g" : "text"), W <= t) {
              if (l.setAttribute("stroke-linecap", "butt"), l.setAttribute("stroke-linejoin", "round"), l.setAttribute("stroke-miterlimit", "4"), this.textSpans[t].span = l, x) {
                var X = createNS("g");
                l.appendChild(X), this.textSpans[t].childSpan = X;
              }
              this.textSpans[t].span = l, this.layerElement.appendChild(l);
            }
            l.style.display = "inherit";
          }
          if (j.reset(), Z && (c[t].n && (V = -Y, U += n.yOffset, U += $ ? 1 : 0, $ = !1), this.applyTextPropertiesToMatrix(n, j, c[t].line, V, U), V += c[t].l || 0, V += Y), x) {
            var K;
            if ((G = this.globalData.fontManager.getCharData(n.finalText[t], a.fStyle, this.globalData.fontManager.getFontByName(n.f).fFamily)).t === 1) K = new SVGCompElement(G.data, this.globalData, this);
            else {
              var J = emptyShapeData;
              G.data && G.data.shapes && (J = this.buildShapeData(G.data, n.finalSize)), K = new SVGShapeElement(J, this.globalData, this);
            }
            if (this.textSpans[t].glyph) {
              var ee = this.textSpans[t].glyph;
              this.textSpans[t].childSpan.removeChild(ee.layerElement), ee.destroy();
            }
            this.textSpans[t].glyph = K, K._debug = !0, K.prepareFrame(0), K.renderFrame(), this.textSpans[t].childSpan.appendChild(K.layerElement), G.t === 1 && this.textSpans[t].childSpan.setAttribute("transform", "scale(" + n.finalSize / 100 + "," + n.finalSize / 100 + ")");
          } else Z && l.setAttribute("transform", "translate(" + j.props[12] + "," + j.props[13] + ")"), l.textContent = c[t].val, l.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve");
        }
        Z && l && l.setAttribute("d", "");
      } else {
        var te = this.textContainer, ne = "start";
        switch (n.j) {
          case 1:
            ne = "end";
            break;
          case 2:
            ne = "middle";
            break;
          default:
            ne = "start";
        }
        te.setAttribute("text-anchor", ne), te.setAttribute("letter-spacing", Y);
        var re = this.buildTextContents(n.finalText);
        for (r = re.length, U = n.ps ? n.ps[1] + n.ascent : 0, t = 0; t < r; t += 1) (l = this.textSpans[t].span || createNS("tspan")).textContent = re[t], l.setAttribute("x", 0), l.setAttribute("y", U), l.style.display = "inherit", te.appendChild(l), this.textSpans[t] || (this.textSpans[t] = { span: null, glyph: null }), this.textSpans[t].span = l, U += n.finalLineHeight;
        this.layerElement.appendChild(te);
      }
      for (; t < this.textSpans.length; ) this.textSpans[t].span.style.display = "none", t += 1;
      this._sizeChanged = !0;
    }, SVGTextLottieElement.prototype.sourceRectAtTime = function() {
      if (this.prepareFrame(this.comp.renderedFrame - this.data.st), this.renderInnerContent(), this._sizeChanged) {
        this._sizeChanged = !1;
        var t = this.layerElement.getBBox();
        this.bbox = { top: t.y, left: t.x, width: t.width, height: t.height };
      }
      return this.bbox;
    }, SVGTextLottieElement.prototype.getValue = function() {
      var t, r, n = this.textSpans.length;
      for (this.renderedFrame = this.comp.renderedFrame, t = 0; t < n; t += 1) (r = this.textSpans[t].glyph) && (r.prepareFrame(this.comp.renderedFrame - this.data.st), r._mdf && (this._mdf = !0));
    }, SVGTextLottieElement.prototype.renderInnerContent = function() {
      if (this.validateText(), (!this.data.singleShape || this._mdf) && (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)) {
        var t, r;
        this._sizeChanged = !0;
        var n, a, s, o = this.textAnimator.renderedLetters, l = this.textProperty.currentData.l;
        for (r = l.length, t = 0; t < r; t += 1) l[t].n || (n = o[t], a = this.textSpans[t].span, (s = this.textSpans[t].glyph) && s.renderFrame(), n._mdf.m && a.setAttribute("transform", n.m), n._mdf.o && a.setAttribute("opacity", n.o), n._mdf.sw && a.setAttribute("stroke-width", n.sw), n._mdf.sc && a.setAttribute("stroke", n.sc), n._mdf.fc && a.setAttribute("fill", n.fc));
      }
    }, extendPrototype([IImageElement], ISolidElement), ISolidElement.prototype.createContent = function() {
      var t = createNS("rect");
      t.setAttribute("width", this.data.sw), t.setAttribute("height", this.data.sh), t.setAttribute("fill", this.data.sc), this.layerElement.appendChild(t);
    }, NullElement.prototype.prepareFrame = function(t) {
      this.prepareProperties(t, !0);
    }, NullElement.prototype.renderFrame = function() {
    }, NullElement.prototype.getBaseElement = function() {
      return null;
    }, NullElement.prototype.destroy = function() {
    }, NullElement.prototype.sourceRectAtTime = function() {
    }, NullElement.prototype.hide = function() {
    }, extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement], NullElement), extendPrototype([BaseRenderer], SVGRendererBase), SVGRendererBase.prototype.createNull = function(t) {
      return new NullElement(t, this.globalData, this);
    }, SVGRendererBase.prototype.createShape = function(t) {
      return new SVGShapeElement(t, this.globalData, this);
    }, SVGRendererBase.prototype.createText = function(t) {
      return new SVGTextLottieElement(t, this.globalData, this);
    }, SVGRendererBase.prototype.createImage = function(t) {
      return new IImageElement(t, this.globalData, this);
    }, SVGRendererBase.prototype.createSolid = function(t) {
      return new ISolidElement(t, this.globalData, this);
    }, SVGRendererBase.prototype.configAnimation = function(t) {
      this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg"), this.svgElement.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink"), this.renderConfig.viewBoxSize ? this.svgElement.setAttribute("viewBox", this.renderConfig.viewBoxSize) : this.svgElement.setAttribute("viewBox", "0 0 " + t.w + " " + t.h), this.renderConfig.viewBoxOnly || (this.svgElement.setAttribute("width", t.w), this.svgElement.setAttribute("height", t.h), this.svgElement.style.width = "100%", this.svgElement.style.height = "100%", this.svgElement.style.transform = "translate3d(0,0,0)", this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility), this.renderConfig.width && this.svgElement.setAttribute("width", this.renderConfig.width), this.renderConfig.height && this.svgElement.setAttribute("height", this.renderConfig.height), this.renderConfig.className && this.svgElement.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.svgElement.setAttribute("id", this.renderConfig.id), this.renderConfig.focusable !== void 0 && this.svgElement.setAttribute("focusable", this.renderConfig.focusable), this.svgElement.setAttribute("preserveAspectRatio", this.renderConfig.preserveAspectRatio), this.animationItem.wrapper.appendChild(this.svgElement);
      var r = this.globalData.defs;
      this.setupGlobalData(t, r), this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.data = t;
      var n = createNS("clipPath"), a = createNS("rect");
      a.setAttribute("width", t.w), a.setAttribute("height", t.h), a.setAttribute("x", 0), a.setAttribute("y", 0);
      var s = createElementID();
      n.setAttribute("id", s), n.appendChild(a), this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + s + ")"), r.appendChild(n), this.layers = t.layers, this.elements = createSizedArray(t.layers.length);
    }, SVGRendererBase.prototype.destroy = function() {
      var t;
      this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.layerElement = null, this.globalData.defs = null;
      var r = this.layers ? this.layers.length : 0;
      for (t = 0; t < r; t += 1) this.elements[t] && this.elements[t].destroy && this.elements[t].destroy();
      this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
    }, SVGRendererBase.prototype.updateContainerSize = function() {
    }, SVGRendererBase.prototype.findIndexByInd = function(t) {
      var r = 0, n = this.layers.length;
      for (r = 0; r < n; r += 1) if (this.layers[r].ind === t) return r;
      return -1;
    }, SVGRendererBase.prototype.buildItem = function(t) {
      var r = this.elements;
      if (!r[t] && this.layers[t].ty !== 99) {
        r[t] = !0;
        var n = this.createItem(this.layers[t]);
        if (r[t] = n, getExpressionsPlugin() && (this.layers[t].ty === 0 && this.globalData.projectInterface.registerComposition(n), n.initExpressions()), this.appendElementInPos(n, t), this.layers[t].tt) {
          var a = "tp" in this.layers[t] ? this.findIndexByInd(this.layers[t].tp) : t - 1;
          if (a === -1) return;
          if (this.elements[a] && this.elements[a] !== !0) {
            var s = r[a].getMatte(this.layers[t].tt);
            n.setMatte(s);
          } else this.buildItem(a), this.addPendingElement(n);
        }
      }
    }, SVGRendererBase.prototype.checkPendingElements = function() {
      for (; this.pendingElements.length; ) {
        var t = this.pendingElements.pop();
        if (t.checkParenting(), t.data.tt) for (var r = 0, n = this.elements.length; r < n; ) {
          if (this.elements[r] === t) {
            var a = "tp" in t.data ? this.findIndexByInd(t.data.tp) : r - 1, s = this.elements[a].getMatte(this.layers[r].tt);
            t.setMatte(s);
            break;
          }
          r += 1;
        }
      }
    }, SVGRendererBase.prototype.renderFrame = function(t) {
      if (this.renderedFrame !== t && !this.destroyed) {
        var r;
        t === null ? t = this.renderedFrame : this.renderedFrame = t, this.globalData.frameNum = t, this.globalData.frameId += 1, this.globalData.projectInterface.currentFrame = t, this.globalData._mdf = !1;
        var n = this.layers.length;
        for (this.completeLayers || this.checkLayers(t), r = n - 1; r >= 0; r -= 1) (this.completeLayers || this.elements[r]) && this.elements[r].prepareFrame(t - this.layers[r].st);
        if (this.globalData._mdf) for (r = 0; r < n; r += 1) (this.completeLayers || this.elements[r]) && this.elements[r].renderFrame();
      }
    }, SVGRendererBase.prototype.appendElementInPos = function(t, r) {
      var n = t.getBaseElement();
      if (n) {
        for (var a, s = 0; s < r; ) this.elements[s] && this.elements[s] !== !0 && this.elements[s].getBaseElement() && (a = this.elements[s].getBaseElement()), s += 1;
        a ? this.layerElement.insertBefore(n, a) : this.layerElement.appendChild(n);
      }
    }, SVGRendererBase.prototype.hide = function() {
      this.layerElement.style.display = "none";
    }, SVGRendererBase.prototype.show = function() {
      this.layerElement.style.display = "block";
    }, extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement, RenderableDOMElement], ICompElement), ICompElement.prototype.initElement = function(t, r, n) {
      this.initFrame(), this.initBaseData(t, r, n), this.initTransform(t, r, n), this.initRenderable(), this.initHierarchy(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), !this.data.xt && r.progressiveLoad || this.buildAllItems(), this.hide();
    }, ICompElement.prototype.prepareFrame = function(t) {
      if (this._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange), this.isInRange || this.data.xt) {
        if (this.tm._placeholder) this.renderedFrame = t / this.data.sr;
        else {
          var r = this.tm.v;
          r === this.data.op && (r = this.data.op - 1), this.renderedFrame = r;
        }
        var n, a = this.elements.length;
        for (this.completeLayers || this.checkLayers(this.renderedFrame), n = a - 1; n >= 0; n -= 1) (this.completeLayers || this.elements[n]) && (this.elements[n].prepareFrame(this.renderedFrame - this.layers[n].st), this.elements[n]._mdf && (this._mdf = !0));
      }
    }, ICompElement.prototype.renderInnerContent = function() {
      var t, r = this.layers.length;
      for (t = 0; t < r; t += 1) (this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
    }, ICompElement.prototype.setElements = function(t) {
      this.elements = t;
    }, ICompElement.prototype.getElements = function() {
      return this.elements;
    }, ICompElement.prototype.destroyElements = function() {
      var t, r = this.layers.length;
      for (t = 0; t < r; t += 1) this.elements[t] && this.elements[t].destroy();
    }, ICompElement.prototype.destroy = function() {
      this.destroyElements(), this.destroyBaseElement();
    }, extendPrototype([SVGRendererBase, ICompElement, SVGBaseElement], SVGCompElement), SVGCompElement.prototype.createComp = function(t) {
      return new SVGCompElement(t, this.globalData, this);
    }, extendPrototype([SVGRendererBase], SVGRenderer), SVGRenderer.prototype.createComp = function(t) {
      return new SVGCompElement(t, this.globalData, this);
    }, ShapeTransformManager.prototype = { addTransformSequence: function(t) {
      var r, n = t.length, a = "_";
      for (r = 0; r < n; r += 1) a += t[r].transform.key + "_";
      var s = this.sequences[a];
      return s || (s = { transforms: [].concat(t), finalTransform: new Matrix(), _mdf: !1 }, this.sequences[a] = s, this.sequenceList.push(s)), s;
    }, processSequence: function(t, r) {
      for (var n = 0, a = t.transforms.length, s = r; n < a && !r; ) {
        if (t.transforms[n].transform.mProps._mdf) {
          s = !0;
          break;
        }
        n += 1;
      }
      if (s) for (t.finalTransform.reset(), n = a - 1; n >= 0; n -= 1) t.finalTransform.multiply(t.transforms[n].transform.mProps.v);
      t._mdf = s;
    }, processSequences: function(t) {
      var r, n = this.sequenceList.length;
      for (r = 0; r < n; r += 1) this.processSequence(this.sequenceList[r], t);
    }, getNewKey: function() {
      return this.transform_key_count += 1, "_" + this.transform_key_count;
    } };
    var lumaLoader = function() {
      var t = "__lottie_element_luma_buffer", r = null, n = null, a = null;
      function s() {
        var o, l, c;
        r || (o = createNS("svg"), l = createNS("filter"), c = createNS("feColorMatrix"), l.setAttribute("id", t), c.setAttribute("type", "matrix"), c.setAttribute("color-interpolation-filters", "sRGB"), c.setAttribute("values", "0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0"), l.appendChild(c), o.appendChild(l), o.setAttribute("id", t + "_svg"), featureSupport.svgLumaHidden && (o.style.display = "none"), a = o, document.body.appendChild(a), r = createTag("canvas"), (n = r.getContext("2d")).filter = "url(#" + t + ")", n.fillStyle = "rgba(0,0,0,0)", n.fillRect(0, 0, 1, 1));
      }
      return { load: s, get: function(o) {
        return r || s(), r.width = o.width, r.height = o.height, n.filter = "url(#" + t + ")", r;
      } };
    };
    function createCanvas(t, r) {
      if (featureSupport.offscreenCanvas) return new OffscreenCanvas(t, r);
      var n = createTag("canvas");
      return n.width = t, n.height = r, n;
    }
    var assetLoader = { loadLumaCanvas: lumaLoader.load, getLumaCanvas: lumaLoader.get, createCanvas }, registeredEffects = {};
    function CVEffects(t) {
      var r, n, a = t.data.ef ? t.data.ef.length : 0;
      for (this.filters = [], r = 0; r < a; r += 1) {
        n = null;
        var s = t.data.ef[r].ty;
        registeredEffects[s] && (n = new registeredEffects[s].effect(t.effectsManager.effectElements[r], t)), n && this.filters.push(n);
      }
      this.filters.length && t.addRenderableComponent(this);
    }
    function registerEffect(t, r) {
      registeredEffects[t] = { effect: r };
    }
    function CVMaskElement(t, r) {
      var n;
      this.data = t, this.element = r, this.masksProperties = this.data.masksProperties || [], this.viewData = createSizedArray(this.masksProperties.length);
      var a = this.masksProperties.length, s = !1;
      for (n = 0; n < a; n += 1) this.masksProperties[n].mode !== "n" && (s = !0), this.viewData[n] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[n], 3);
      this.hasMasks = s, s && this.element.addRenderableComponent(this);
    }
    function CVBaseElement() {
    }
    CVEffects.prototype.renderFrame = function(t) {
      var r, n = this.filters.length;
      for (r = 0; r < n; r += 1) this.filters[r].renderFrame(t);
    }, CVEffects.prototype.getEffects = function(t) {
      var r, n = this.filters.length, a = [];
      for (r = 0; r < n; r += 1) this.filters[r].type === t && a.push(this.filters[r]);
      return a;
    }, CVMaskElement.prototype.renderFrame = function() {
      if (this.hasMasks) {
        var t, r, n, a, s = this.element.finalTransform.mat, o = this.element.canvasContext, l = this.masksProperties.length;
        for (o.beginPath(), t = 0; t < l; t += 1) if (this.masksProperties[t].mode !== "n") {
          var c;
          this.masksProperties[t].inv && (o.moveTo(0, 0), o.lineTo(this.element.globalData.compSize.w, 0), o.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h), o.lineTo(0, this.element.globalData.compSize.h), o.lineTo(0, 0)), a = this.viewData[t].v, r = s.applyToPointArray(a.v[0][0], a.v[0][1], 0), o.moveTo(r[0], r[1]);
          var x = a._length;
          for (c = 1; c < x; c += 1) n = s.applyToTriplePoints(a.o[c - 1], a.i[c], a.v[c]), o.bezierCurveTo(n[0], n[1], n[2], n[3], n[4], n[5]);
          n = s.applyToTriplePoints(a.o[c - 1], a.i[0], a.v[0]), o.bezierCurveTo(n[0], n[1], n[2], n[3], n[4], n[5]);
        }
        this.element.globalData.renderer.save(!0), o.clip();
      }
    }, CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty, CVMaskElement.prototype.destroy = function() {
      this.element = null;
    };
    var operationsMap = { 1: "source-in", 2: "source-out", 3: "source-in", 4: "source-out" };
    function CVShapeData(t, r, n, a) {
      this.styledShapes = [], this.tr = [0, 0, 0, 0, 0, 0];
      var s, o = 4;
      r.ty === "rc" ? o = 5 : r.ty === "el" ? o = 6 : r.ty === "sr" && (o = 7), this.sh = ShapePropertyFactory.getShapeProp(t, r, o, t);
      var l, c = n.length;
      for (s = 0; s < c; s += 1) n[s].closed || (l = { transforms: a.addTransformSequence(n[s].transforms), trNodes: [] }, this.styledShapes.push(l), n[s].elements.push(l));
    }
    function CVShapeElement(t, r, n) {
      this.shapes = [], this.shapesData = t.shapes, this.stylesList = [], this.itemsData = [], this.prevViewData = [], this.shapeModifiers = [], this.processedElements = [], this.transformsManager = new ShapeTransformManager(), this.initElement(t, r, n);
    }
    function CVTextElement(t, r, n) {
      this.textSpans = [], this.yOffset = 0, this.fillColorAnim = !1, this.strokeColorAnim = !1, this.strokeWidthAnim = !1, this.stroke = !1, this.fill = !1, this.justifyOffset = 0, this.currentRender = null, this.renderType = "canvas", this.values = { fill: "rgba(0,0,0,0)", stroke: "rgba(0,0,0,0)", sWidth: 0, fValue: "" }, this.initElement(t, r, n);
    }
    function CVImageElement(t, r, n) {
      this.assetData = r.getAssetData(t.refId), this.img = r.imageLoader.getAsset(this.assetData), this.initElement(t, r, n);
    }
    function CVSolidElement(t, r, n) {
      this.initElement(t, r, n);
    }
    function CanvasRendererBase() {
    }
    function CanvasContext() {
      this.opacity = -1, this.transform = createTypedArray("float32", 16), this.fillStyle = "", this.strokeStyle = "", this.lineWidth = "", this.lineCap = "", this.lineJoin = "", this.miterLimit = "", this.id = Math.random();
    }
    function CVContextData() {
      var t;
      for (this.stack = [], this.cArrPos = 0, this.cTr = new Matrix(), t = 0; t < 15; t += 1) {
        var r = new CanvasContext();
        this.stack[t] = r;
      }
      this._length = 15, this.nativeContext = null, this.transformMat = new Matrix(), this.currentOpacity = 1, this.currentFillStyle = "", this.appliedFillStyle = "", this.currentStrokeStyle = "", this.appliedStrokeStyle = "", this.currentLineWidth = "", this.appliedLineWidth = "", this.currentLineCap = "", this.appliedLineCap = "", this.currentLineJoin = "", this.appliedLineJoin = "", this.appliedMiterLimit = "", this.currentMiterLimit = "";
    }
    function CVCompElement(t, r, n) {
      this.completeLayers = !1, this.layers = t.layers, this.pendingElements = [], this.elements = createSizedArray(this.layers.length), this.initElement(t, r, n), this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, r.frameRate, this) : { _placeholder: !0 };
    }
    function CanvasRenderer(t, r) {
      this.animationItem = t, this.renderConfig = { clearCanvas: !r || r.clearCanvas === void 0 || r.clearCanvas, context: r && r.context || null, progressiveLoad: r && r.progressiveLoad || !1, preserveAspectRatio: r && r.preserveAspectRatio || "xMidYMid meet", imagePreserveAspectRatio: r && r.imagePreserveAspectRatio || "xMidYMid slice", contentVisibility: r && r.contentVisibility || "visible", className: r && r.className || "", id: r && r.id || "", runExpressions: !r || r.runExpressions === void 0 || r.runExpressions }, this.renderConfig.dpr = r && r.dpr || 1, this.animationItem.wrapper && (this.renderConfig.dpr = r && r.dpr || window.devicePixelRatio || 1), this.renderedFrame = -1, this.globalData = { frameNum: -1, _mdf: !1, renderConfig: this.renderConfig, currentGlobalAlpha: -1 }, this.contextData = new CVContextData(), this.elements = [], this.pendingElements = [], this.transformMat = new Matrix(), this.completeLayers = !1, this.rendererType = "canvas", this.renderConfig.clearCanvas && (this.ctxTransform = this.contextData.transform.bind(this.contextData), this.ctxOpacity = this.contextData.opacity.bind(this.contextData), this.ctxFillStyle = this.contextData.fillStyle.bind(this.contextData), this.ctxStrokeStyle = this.contextData.strokeStyle.bind(this.contextData), this.ctxLineWidth = this.contextData.lineWidth.bind(this.contextData), this.ctxLineCap = this.contextData.lineCap.bind(this.contextData), this.ctxLineJoin = this.contextData.lineJoin.bind(this.contextData), this.ctxMiterLimit = this.contextData.miterLimit.bind(this.contextData), this.ctxFill = this.contextData.fill.bind(this.contextData), this.ctxFillRect = this.contextData.fillRect.bind(this.contextData), this.ctxStroke = this.contextData.stroke.bind(this.contextData), this.save = this.contextData.save.bind(this.contextData));
    }
    function HBaseElement() {
    }
    function HSolidElement(t, r, n) {
      this.initElement(t, r, n);
    }
    function HShapeElement(t, r, n) {
      this.shapes = [], this.shapesData = t.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.shapesContainer = createNS("g"), this.initElement(t, r, n), this.prevViewData = [], this.currentBBox = { x: 999999, y: -999999, h: 0, w: 0 };
    }
    function HTextElement(t, r, n) {
      this.textSpans = [], this.textPaths = [], this.currentBBox = { x: 999999, y: -999999, h: 0, w: 0 }, this.renderType = "svg", this.isMasked = !1, this.initElement(t, r, n);
    }
    function HCameraElement(t, r, n) {
      this.initFrame(), this.initBaseData(t, r, n), this.initHierarchy();
      var a = PropertyFactory.getProp;
      if (this.pe = a(this, t.pe, 0, 0, this), t.ks.p.s ? (this.px = a(this, t.ks.p.x, 1, 0, this), this.py = a(this, t.ks.p.y, 1, 0, this), this.pz = a(this, t.ks.p.z, 1, 0, this)) : this.p = a(this, t.ks.p, 1, 0, this), t.ks.a && (this.a = a(this, t.ks.a, 1, 0, this)), t.ks.or.k.length && t.ks.or.k[0].to) {
        var s, o = t.ks.or.k.length;
        for (s = 0; s < o; s += 1) t.ks.or.k[s].to = null, t.ks.or.k[s].ti = null;
      }
      this.or = a(this, t.ks.or, 1, degToRads, this), this.or.sh = !0, this.rx = a(this, t.ks.rx, 0, degToRads, this), this.ry = a(this, t.ks.ry, 0, degToRads, this), this.rz = a(this, t.ks.rz, 0, degToRads, this), this.mat = new Matrix(), this._prevMat = new Matrix(), this._isFirstFrame = !0, this.finalTransform = { mProp: this };
    }
    function HImageElement(t, r, n) {
      this.assetData = r.getAssetData(t.refId), this.initElement(t, r, n);
    }
    function HybridRendererBase(t, r) {
      this.animationItem = t, this.layers = null, this.renderedFrame = -1, this.renderConfig = { className: r && r.className || "", imagePreserveAspectRatio: r && r.imagePreserveAspectRatio || "xMidYMid slice", hideOnTransparent: !(r && r.hideOnTransparent === !1), filterSize: { width: r && r.filterSize && r.filterSize.width || "400%", height: r && r.filterSize && r.filterSize.height || "400%", x: r && r.filterSize && r.filterSize.x || "-100%", y: r && r.filterSize && r.filterSize.y || "-100%" } }, this.globalData = { _mdf: !1, frameNum: -1, renderConfig: this.renderConfig }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
    }
    function HCompElement(t, r, n) {
      this.layers = t.layers, this.supports3d = !t.hasMask, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(t, r, n), this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, r.frameRate, this) : { _placeholder: !0 };
    }
    function HybridRenderer(t, r) {
      this.animationItem = t, this.layers = null, this.renderedFrame = -1, this.renderConfig = { className: r && r.className || "", imagePreserveAspectRatio: r && r.imagePreserveAspectRatio || "xMidYMid slice", hideOnTransparent: !(r && r.hideOnTransparent === !1), filterSize: { width: r && r.filterSize && r.filterSize.width || "400%", height: r && r.filterSize && r.filterSize.height || "400%", x: r && r.filterSize && r.filterSize.x || "-100%", y: r && r.filterSize && r.filterSize.y || "-100%" }, runExpressions: !r || r.runExpressions === void 0 || r.runExpressions }, this.globalData = { _mdf: !1, frameNum: -1, renderConfig: this.renderConfig }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
    }
    CVBaseElement.prototype = { createElements: function() {
    }, initRendererElement: function() {
    }, createContainerElements: function() {
      if (this.data.tt >= 1) {
        this.buffers = [];
        var t = this.globalData.canvasContext, r = assetLoader.createCanvas(t.canvas.width, t.canvas.height);
        this.buffers.push(r);
        var n = assetLoader.createCanvas(t.canvas.width, t.canvas.height);
        this.buffers.push(n), this.data.tt >= 3 && !document._isProxy && assetLoader.loadLumaCanvas();
      }
      this.canvasContext = this.globalData.canvasContext, this.transformCanvas = this.globalData.transformCanvas, this.renderableEffectsManager = new CVEffects(this), this.searchEffectTransforms();
    }, createContent: function() {
    }, setBlendMode: function() {
      var t = this.globalData;
      if (t.blendMode !== this.data.bm) {
        t.blendMode = this.data.bm;
        var r = getBlendMode(this.data.bm);
        t.canvasContext.globalCompositeOperation = r;
      }
    }, createRenderableComponents: function() {
      this.maskManager = new CVMaskElement(this.data, this), this.transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
    }, hideElement: function() {
      this.hidden || this.isInRange && !this.isTransparent || (this.hidden = !0);
    }, showElement: function() {
      this.isInRange && !this.isTransparent && (this.hidden = !1, this._isFirstFrame = !0, this.maskManager._isFirstFrame = !0);
    }, clearCanvas: function(t) {
      t.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w * this.transformCanvas.sx, this.transformCanvas.h * this.transformCanvas.sy);
    }, prepareLayer: function() {
      if (this.data.tt >= 1) {
        var t = this.buffers[0].getContext("2d");
        this.clearCanvas(t), t.drawImage(this.canvasContext.canvas, 0, 0), this.currentTransform = this.canvasContext.getTransform(), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.setTransform(this.currentTransform);
      }
    }, exitLayer: function() {
      if (this.data.tt >= 1) {
        var t = this.buffers[1], r = t.getContext("2d");
        if (this.clearCanvas(r), r.drawImage(this.canvasContext.canvas, 0, 0), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.setTransform(this.currentTransform), this.comp.getElementById("tp" in this.data ? this.data.tp : this.data.ind - 1).renderFrame(!0), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.data.tt >= 3 && !document._isProxy) {
          var n = assetLoader.getLumaCanvas(this.canvasContext.canvas);
          n.getContext("2d").drawImage(this.canvasContext.canvas, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.drawImage(n, 0, 0);
        }
        this.canvasContext.globalCompositeOperation = operationsMap[this.data.tt], this.canvasContext.drawImage(t, 0, 0), this.canvasContext.globalCompositeOperation = "destination-over", this.canvasContext.drawImage(this.buffers[0], 0, 0), this.canvasContext.setTransform(this.currentTransform), this.canvasContext.globalCompositeOperation = "source-over";
      }
    }, renderFrame: function(t) {
      if (!this.hidden && !this.data.hd && (this.data.td !== 1 || t)) {
        this.renderTransform(), this.renderRenderable(), this.renderLocalTransform(), this.setBlendMode();
        var r = this.data.ty === 0;
        this.prepareLayer(), this.globalData.renderer.save(r), this.globalData.renderer.ctxTransform(this.finalTransform.localMat.props), this.globalData.renderer.ctxOpacity(this.finalTransform.localOpacity), this.renderInnerContent(), this.globalData.renderer.restore(r), this.exitLayer(), this.maskManager.hasMasks && this.globalData.renderer.restore(!0), this._isFirstFrame && (this._isFirstFrame = !1);
      }
    }, destroy: function() {
      this.canvasContext = null, this.data = null, this.globalData = null, this.maskManager.destroy();
    }, mHelper: new Matrix() }, CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement, CVBaseElement.prototype.show = CVBaseElement.prototype.showElement, CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated, extendPrototype([BaseElement, TransformElement, CVBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableElement], CVShapeElement), CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement, CVShapeElement.prototype.transformHelper = { opacity: 1, _opMdf: !1 }, CVShapeElement.prototype.dashResetter = [], CVShapeElement.prototype.createContent = function() {
      this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []);
    }, CVShapeElement.prototype.createStyleElement = function(t, r) {
      var n = { data: t, type: t.ty, preTransforms: this.transformsManager.addTransformSequence(r), transforms: [], elements: [], closed: t.hd === !0 }, a = {};
      if (t.ty === "fl" || t.ty === "st" ? (a.c = PropertyFactory.getProp(this, t.c, 1, 255, this), a.c.k || (n.co = "rgb(" + bmFloor(a.c.v[0]) + "," + bmFloor(a.c.v[1]) + "," + bmFloor(a.c.v[2]) + ")")) : t.ty !== "gf" && t.ty !== "gs" || (a.s = PropertyFactory.getProp(this, t.s, 1, null, this), a.e = PropertyFactory.getProp(this, t.e, 1, null, this), a.h = PropertyFactory.getProp(this, t.h || { k: 0 }, 0, 0.01, this), a.a = PropertyFactory.getProp(this, t.a || { k: 0 }, 0, degToRads, this), a.g = new GradientProperty(this, t.g, this)), a.o = PropertyFactory.getProp(this, t.o, 0, 0.01, this), t.ty === "st" || t.ty === "gs") {
        if (n.lc = lineCapEnum[t.lc || 2], n.lj = lineJoinEnum[t.lj || 2], t.lj == 1 && (n.ml = t.ml), a.w = PropertyFactory.getProp(this, t.w, 0, null, this), a.w.k || (n.wi = a.w.v), t.d) {
          var s = new DashProperty(this, t.d, "canvas", this);
          a.d = s, a.d.k || (n.da = a.d.dashArray, n.do = a.d.dashoffset[0]);
        }
      } else n.r = t.r === 2 ? "evenodd" : "nonzero";
      return this.stylesList.push(n), a.style = n, a;
    }, CVShapeElement.prototype.createGroupElement = function() {
      return { it: [], prevViewData: [] };
    }, CVShapeElement.prototype.createTransformElement = function(t) {
      return { transform: { opacity: 1, _opMdf: !1, key: this.transformsManager.getNewKey(), op: PropertyFactory.getProp(this, t.o, 0, 0.01, this), mProps: TransformPropertyFactory.getTransformProperty(this, t, this) } };
    }, CVShapeElement.prototype.createShapeElement = function(t) {
      var r = new CVShapeData(this, t, this.stylesList, this.transformsManager);
      return this.shapes.push(r), this.addShapeToModifiers(r), r;
    }, CVShapeElement.prototype.reloadShapes = function() {
      var t;
      this._isFirstFrame = !0;
      var r = this.itemsData.length;
      for (t = 0; t < r; t += 1) this.prevViewData[t] = this.itemsData[t];
      for (this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []), r = this.dynamicProperties.length, t = 0; t < r; t += 1) this.dynamicProperties[t].getValue();
      this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame);
    }, CVShapeElement.prototype.addTransformToStyleList = function(t) {
      var r, n = this.stylesList.length;
      for (r = 0; r < n; r += 1) this.stylesList[r].closed || this.stylesList[r].transforms.push(t);
    }, CVShapeElement.prototype.removeTransformFromStyleList = function() {
      var t, r = this.stylesList.length;
      for (t = 0; t < r; t += 1) this.stylesList[t].closed || this.stylesList[t].transforms.pop();
    }, CVShapeElement.prototype.closeStyles = function(t) {
      var r, n = t.length;
      for (r = 0; r < n; r += 1) t[r].closed = !0;
    }, CVShapeElement.prototype.searchShapes = function(t, r, n, a, s) {
      var o, l, c, x, j, Z, V = t.length - 1, U = [], $ = [], Y = [].concat(s);
      for (o = V; o >= 0; o -= 1) {
        if ((x = this.searchProcessedElement(t[o])) ? r[o] = n[x - 1] : t[o]._shouldRender = a, t[o].ty === "fl" || t[o].ty === "st" || t[o].ty === "gf" || t[o].ty === "gs") x ? r[o].style.closed = !1 : r[o] = this.createStyleElement(t[o], Y), U.push(r[o].style);
        else if (t[o].ty === "gr") {
          if (x) for (c = r[o].it.length, l = 0; l < c; l += 1) r[o].prevViewData[l] = r[o].it[l];
          else r[o] = this.createGroupElement(t[o]);
          this.searchShapes(t[o].it, r[o].it, r[o].prevViewData, a, Y);
        } else t[o].ty === "tr" ? (x || (Z = this.createTransformElement(t[o]), r[o] = Z), Y.push(r[o]), this.addTransformToStyleList(r[o])) : t[o].ty === "sh" || t[o].ty === "rc" || t[o].ty === "el" || t[o].ty === "sr" ? x || (r[o] = this.createShapeElement(t[o])) : t[o].ty === "tm" || t[o].ty === "rd" || t[o].ty === "pb" || t[o].ty === "zz" || t[o].ty === "op" ? (x ? (j = r[o]).closed = !1 : ((j = ShapeModifiers.getModifier(t[o].ty)).init(this, t[o]), r[o] = j, this.shapeModifiers.push(j)), $.push(j)) : t[o].ty === "rp" && (x ? (j = r[o]).closed = !0 : (j = ShapeModifiers.getModifier(t[o].ty), r[o] = j, j.init(this, t, o, r), this.shapeModifiers.push(j), a = !1), $.push(j));
        this.addProcessedElement(t[o], o + 1);
      }
      for (this.removeTransformFromStyleList(), this.closeStyles(U), V = $.length, o = 0; o < V; o += 1) $[o].closed = !0;
    }, CVShapeElement.prototype.renderInnerContent = function() {
      this.transformHelper.opacity = 1, this.transformHelper._opMdf = !1, this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame), this.renderShape(this.transformHelper, this.shapesData, this.itemsData, !0);
    }, CVShapeElement.prototype.renderShapeTransform = function(t, r) {
      (t._opMdf || r.op._mdf || this._isFirstFrame) && (r.opacity = t.opacity, r.opacity *= r.op.v, r._opMdf = !0);
    }, CVShapeElement.prototype.drawLayer = function() {
      var t, r, n, a, s, o, l, c, x, j = this.stylesList.length, Z = this.globalData.renderer, V = this.globalData.canvasContext;
      for (t = 0; t < j; t += 1) if (((c = (x = this.stylesList[t]).type) !== "st" && c !== "gs" || x.wi !== 0) && x.data._shouldRender && x.coOp !== 0 && this.globalData.currentGlobalAlpha !== 0) {
        for (Z.save(), o = x.elements, c === "st" || c === "gs" ? (Z.ctxStrokeStyle(c === "st" ? x.co : x.grd), Z.ctxLineWidth(x.wi), Z.ctxLineCap(x.lc), Z.ctxLineJoin(x.lj), Z.ctxMiterLimit(x.ml || 0)) : Z.ctxFillStyle(c === "fl" ? x.co : x.grd), Z.ctxOpacity(x.coOp), c !== "st" && c !== "gs" && V.beginPath(), Z.ctxTransform(x.preTransforms.finalTransform.props), n = o.length, r = 0; r < n; r += 1) {
          for (c !== "st" && c !== "gs" || (V.beginPath(), x.da && (V.setLineDash(x.da), V.lineDashOffset = x.do)), s = (l = o[r].trNodes).length, a = 0; a < s; a += 1) l[a].t === "m" ? V.moveTo(l[a].p[0], l[a].p[1]) : l[a].t === "c" ? V.bezierCurveTo(l[a].pts[0], l[a].pts[1], l[a].pts[2], l[a].pts[3], l[a].pts[4], l[a].pts[5]) : V.closePath();
          c !== "st" && c !== "gs" || (Z.ctxStroke(), x.da && V.setLineDash(this.dashResetter));
        }
        c !== "st" && c !== "gs" && this.globalData.renderer.ctxFill(x.r), Z.restore();
      }
    }, CVShapeElement.prototype.renderShape = function(t, r, n, a) {
      var s, o;
      for (o = t, s = r.length - 1; s >= 0; s -= 1) r[s].ty === "tr" ? (o = n[s].transform, this.renderShapeTransform(t, o)) : r[s].ty === "sh" || r[s].ty === "el" || r[s].ty === "rc" || r[s].ty === "sr" ? this.renderPath(r[s], n[s]) : r[s].ty === "fl" ? this.renderFill(r[s], n[s], o) : r[s].ty === "st" ? this.renderStroke(r[s], n[s], o) : r[s].ty === "gf" || r[s].ty === "gs" ? this.renderGradientFill(r[s], n[s], o) : r[s].ty === "gr" ? this.renderShape(o, r[s].it, n[s].it) : r[s].ty;
      a && this.drawLayer();
    }, CVShapeElement.prototype.renderStyledShape = function(t, r) {
      if (this._isFirstFrame || r._mdf || t.transforms._mdf) {
        var n, a, s, o = t.trNodes, l = r.paths, c = l._length;
        o.length = 0;
        var x = t.transforms.finalTransform;
        for (s = 0; s < c; s += 1) {
          var j = l.shapes[s];
          if (j && j.v) {
            for (a = j._length, n = 1; n < a; n += 1) n === 1 && o.push({ t: "m", p: x.applyToPointArray(j.v[0][0], j.v[0][1], 0) }), o.push({ t: "c", pts: x.applyToTriplePoints(j.o[n - 1], j.i[n], j.v[n]) });
            a === 1 && o.push({ t: "m", p: x.applyToPointArray(j.v[0][0], j.v[0][1], 0) }), j.c && a && (o.push({ t: "c", pts: x.applyToTriplePoints(j.o[n - 1], j.i[0], j.v[0]) }), o.push({ t: "z" }));
          }
        }
        t.trNodes = o;
      }
    }, CVShapeElement.prototype.renderPath = function(t, r) {
      if (t.hd !== !0 && t._shouldRender) {
        var n, a = r.styledShapes.length;
        for (n = 0; n < a; n += 1) this.renderStyledShape(r.styledShapes[n], r.sh);
      }
    }, CVShapeElement.prototype.renderFill = function(t, r, n) {
      var a = r.style;
      (r.c._mdf || this._isFirstFrame) && (a.co = "rgb(" + bmFloor(r.c.v[0]) + "," + bmFloor(r.c.v[1]) + "," + bmFloor(r.c.v[2]) + ")"), (r.o._mdf || n._opMdf || this._isFirstFrame) && (a.coOp = r.o.v * n.opacity);
    }, CVShapeElement.prototype.renderGradientFill = function(t, r, n) {
      var a, s = r.style;
      if (!s.grd || r.g._mdf || r.s._mdf || r.e._mdf || t.t !== 1 && (r.h._mdf || r.a._mdf)) {
        var o, l = this.globalData.canvasContext, c = r.s.v, x = r.e.v;
        if (t.t === 1) a = l.createLinearGradient(c[0], c[1], x[0], x[1]);
        else {
          var j = Math.sqrt(Math.pow(c[0] - x[0], 2) + Math.pow(c[1] - x[1], 2)), Z = Math.atan2(x[1] - c[1], x[0] - c[0]), V = r.h.v;
          V >= 1 ? V = 0.99 : V <= -1 && (V = -0.99);
          var U = j * V, $ = Math.cos(Z + r.a.v) * U + c[0], Y = Math.sin(Z + r.a.v) * U + c[1];
          a = l.createRadialGradient($, Y, 0, c[0], c[1], j);
        }
        var G = t.g.p, W = r.g.c, X = 1;
        for (o = 0; o < G; o += 1) r.g._hasOpacity && r.g._collapsable && (X = r.g.o[2 * o + 1]), a.addColorStop(W[4 * o] / 100, "rgba(" + W[4 * o + 1] + "," + W[4 * o + 2] + "," + W[4 * o + 3] + "," + X + ")");
        s.grd = a;
      }
      s.coOp = r.o.v * n.opacity;
    }, CVShapeElement.prototype.renderStroke = function(t, r, n) {
      var a = r.style, s = r.d;
      s && (s._mdf || this._isFirstFrame) && (a.da = s.dashArray, a.do = s.dashoffset[0]), (r.c._mdf || this._isFirstFrame) && (a.co = "rgb(" + bmFloor(r.c.v[0]) + "," + bmFloor(r.c.v[1]) + "," + bmFloor(r.c.v[2]) + ")"), (r.o._mdf || n._opMdf || this._isFirstFrame) && (a.coOp = r.o.v * n.opacity), (r.w._mdf || this._isFirstFrame) && (a.wi = r.w.v);
    }, CVShapeElement.prototype.destroy = function() {
      this.shapesData = null, this.globalData = null, this.canvasContext = null, this.stylesList.length = 0, this.itemsData.length = 0;
    }, extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement, ITextElement], CVTextElement), CVTextElement.prototype.tHelper = createTag("canvas").getContext("2d"), CVTextElement.prototype.buildNewText = function() {
      var t = this.textProperty.currentData;
      this.renderedLetters = createSizedArray(t.l ? t.l.length : 0);
      var r = !1;
      t.fc ? (r = !0, this.values.fill = this.buildColor(t.fc)) : this.values.fill = "rgba(0,0,0,0)", this.fill = r;
      var n = !1;
      t.sc && (n = !0, this.values.stroke = this.buildColor(t.sc), this.values.sWidth = t.sw);
      var a, s, o, l, c, x, j, Z, V, U, $, Y, G = this.globalData.fontManager.getFontByName(t.f), W = t.l, X = this.mHelper;
      this.stroke = n, this.values.fValue = t.finalSize + "px " + this.globalData.fontManager.getFontByName(t.f).fFamily, s = t.finalText.length;
      var K = this.data.singleShape, J = 1e-3 * t.tr * t.finalSize, ee = 0, te = 0, ne = !0, re = 0;
      for (a = 0; a < s; a += 1) {
        l = (o = this.globalData.fontManager.getCharData(t.finalText[a], G.fStyle, this.globalData.fontManager.getFontByName(t.f).fFamily)) && o.data || {}, X.reset(), K && W[a].n && (ee = -J, te += t.yOffset, te += ne ? 1 : 0, ne = !1), V = (j = l.shapes ? l.shapes[0].it : []).length, X.scale(t.finalSize / 100, t.finalSize / 100), K && this.applyTextPropertiesToMatrix(t, X, W[a].line, ee, te), $ = createSizedArray(V - 1);
        var ie = 0;
        for (Z = 0; Z < V; Z += 1) if (j[Z].ty === "sh") {
          for (x = j[Z].ks.k.i.length, U = j[Z].ks.k, Y = [], c = 1; c < x; c += 1) c === 1 && Y.push(X.applyToX(U.v[0][0], U.v[0][1], 0), X.applyToY(U.v[0][0], U.v[0][1], 0)), Y.push(X.applyToX(U.o[c - 1][0], U.o[c - 1][1], 0), X.applyToY(U.o[c - 1][0], U.o[c - 1][1], 0), X.applyToX(U.i[c][0], U.i[c][1], 0), X.applyToY(U.i[c][0], U.i[c][1], 0), X.applyToX(U.v[c][0], U.v[c][1], 0), X.applyToY(U.v[c][0], U.v[c][1], 0));
          Y.push(X.applyToX(U.o[c - 1][0], U.o[c - 1][1], 0), X.applyToY(U.o[c - 1][0], U.o[c - 1][1], 0), X.applyToX(U.i[0][0], U.i[0][1], 0), X.applyToY(U.i[0][0], U.i[0][1], 0), X.applyToX(U.v[0][0], U.v[0][1], 0), X.applyToY(U.v[0][0], U.v[0][1], 0)), $[ie] = Y, ie += 1;
        }
        K && (ee += W[a].l, ee += J), this.textSpans[re] ? this.textSpans[re].elem = $ : this.textSpans[re] = { elem: $ }, re += 1;
      }
    }, CVTextElement.prototype.renderInnerContent = function() {
      var t, r, n, a, s, o;
      this.validateText(), this.canvasContext.font = this.values.fValue, this.globalData.renderer.ctxLineCap("butt"), this.globalData.renderer.ctxLineJoin("miter"), this.globalData.renderer.ctxMiterLimit(4), this.data.singleShape || this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
      var l, c = this.textAnimator.renderedLetters, x = this.textProperty.currentData.l;
      r = x.length;
      var j, Z, V = null, U = null, $ = null, Y = this.globalData.renderer;
      for (t = 0; t < r; t += 1) if (!x[t].n) {
        if ((l = c[t]) && (Y.save(), Y.ctxTransform(l.p), Y.ctxOpacity(l.o)), this.fill) {
          for (l && l.fc ? V !== l.fc && (Y.ctxFillStyle(l.fc), V = l.fc) : V !== this.values.fill && (V = this.values.fill, Y.ctxFillStyle(this.values.fill)), a = (j = this.textSpans[t].elem).length, this.globalData.canvasContext.beginPath(), n = 0; n < a; n += 1) for (o = (Z = j[n]).length, this.globalData.canvasContext.moveTo(Z[0], Z[1]), s = 2; s < o; s += 6) this.globalData.canvasContext.bezierCurveTo(Z[s], Z[s + 1], Z[s + 2], Z[s + 3], Z[s + 4], Z[s + 5]);
          this.globalData.canvasContext.closePath(), Y.ctxFill();
        }
        if (this.stroke) {
          for (l && l.sw ? $ !== l.sw && ($ = l.sw, Y.ctxLineWidth(l.sw)) : $ !== this.values.sWidth && ($ = this.values.sWidth, Y.ctxLineWidth(this.values.sWidth)), l && l.sc ? U !== l.sc && (U = l.sc, Y.ctxStrokeStyle(l.sc)) : U !== this.values.stroke && (U = this.values.stroke, Y.ctxStrokeStyle(this.values.stroke)), a = (j = this.textSpans[t].elem).length, this.globalData.canvasContext.beginPath(), n = 0; n < a; n += 1) for (o = (Z = j[n]).length, this.globalData.canvasContext.moveTo(Z[0], Z[1]), s = 2; s < o; s += 6) this.globalData.canvasContext.bezierCurveTo(Z[s], Z[s + 1], Z[s + 2], Z[s + 3], Z[s + 4], Z[s + 5]);
          this.globalData.canvasContext.closePath(), Y.ctxStroke();
        }
        l && this.globalData.renderer.restore();
      }
    }, extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVImageElement), CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVImageElement.prototype.createContent = function() {
      if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
        var t = createTag("canvas");
        t.width = this.assetData.w, t.height = this.assetData.h;
        var r, n, a = t.getContext("2d"), s = this.img.width, o = this.img.height, l = s / o, c = this.assetData.w / this.assetData.h, x = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
        l > c && x === "xMidYMid slice" || l < c && x !== "xMidYMid slice" ? r = (n = o) * c : n = (r = s) / c, a.drawImage(this.img, (s - r) / 2, (o - n) / 2, r, n, 0, 0, this.assetData.w, this.assetData.h), this.img = t;
      }
    }, CVImageElement.prototype.renderInnerContent = function() {
      this.canvasContext.drawImage(this.img, 0, 0);
    }, CVImageElement.prototype.destroy = function() {
      this.img = null;
    }, extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVSolidElement), CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVSolidElement.prototype.renderInnerContent = function() {
      this.globalData.renderer.ctxFillStyle(this.data.sc), this.globalData.renderer.ctxFillRect(0, 0, this.data.sw, this.data.sh);
    }, extendPrototype([BaseRenderer], CanvasRendererBase), CanvasRendererBase.prototype.createShape = function(t) {
      return new CVShapeElement(t, this.globalData, this);
    }, CanvasRendererBase.prototype.createText = function(t) {
      return new CVTextElement(t, this.globalData, this);
    }, CanvasRendererBase.prototype.createImage = function(t) {
      return new CVImageElement(t, this.globalData, this);
    }, CanvasRendererBase.prototype.createSolid = function(t) {
      return new CVSolidElement(t, this.globalData, this);
    }, CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, CanvasRendererBase.prototype.ctxTransform = function(t) {
      t[0] === 1 && t[1] === 0 && t[4] === 0 && t[5] === 1 && t[12] === 0 && t[13] === 0 || this.canvasContext.transform(t[0], t[1], t[4], t[5], t[12], t[13]);
    }, CanvasRendererBase.prototype.ctxOpacity = function(t) {
      this.canvasContext.globalAlpha *= t < 0 ? 0 : t;
    }, CanvasRendererBase.prototype.ctxFillStyle = function(t) {
      this.canvasContext.fillStyle = t;
    }, CanvasRendererBase.prototype.ctxStrokeStyle = function(t) {
      this.canvasContext.strokeStyle = t;
    }, CanvasRendererBase.prototype.ctxLineWidth = function(t) {
      this.canvasContext.lineWidth = t;
    }, CanvasRendererBase.prototype.ctxLineCap = function(t) {
      this.canvasContext.lineCap = t;
    }, CanvasRendererBase.prototype.ctxLineJoin = function(t) {
      this.canvasContext.lineJoin = t;
    }, CanvasRendererBase.prototype.ctxMiterLimit = function(t) {
      this.canvasContext.miterLimit = t;
    }, CanvasRendererBase.prototype.ctxFill = function(t) {
      this.canvasContext.fill(t);
    }, CanvasRendererBase.prototype.ctxFillRect = function(t, r, n, a) {
      this.canvasContext.fillRect(t, r, n, a);
    }, CanvasRendererBase.prototype.ctxStroke = function() {
      this.canvasContext.stroke();
    }, CanvasRendererBase.prototype.reset = function() {
      this.renderConfig.clearCanvas ? this.contextData.reset() : this.canvasContext.restore();
    }, CanvasRendererBase.prototype.save = function() {
      this.canvasContext.save();
    }, CanvasRendererBase.prototype.restore = function(t) {
      this.renderConfig.clearCanvas ? (t && (this.globalData.blendMode = "source-over"), this.contextData.restore(t)) : this.canvasContext.restore();
    }, CanvasRendererBase.prototype.configAnimation = function(t) {
      if (this.animationItem.wrapper) {
        this.animationItem.container = createTag("canvas");
        var r = this.animationItem.container.style;
        r.width = "100%", r.height = "100%";
        var n = "0px 0px 0px";
        r.transformOrigin = n, r.mozTransformOrigin = n, r.webkitTransformOrigin = n, r["-webkit-transform"] = n, r.contentVisibility = this.renderConfig.contentVisibility, this.animationItem.wrapper.appendChild(this.animationItem.container), this.canvasContext = this.animationItem.container.getContext("2d"), this.renderConfig.className && this.animationItem.container.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.animationItem.container.setAttribute("id", this.renderConfig.id);
      } else this.canvasContext = this.renderConfig.context;
      this.contextData.setContext(this.canvasContext), this.data = t, this.layers = t.layers, this.transformCanvas = { w: t.w, h: t.h, sx: 0, sy: 0, tx: 0, ty: 0 }, this.setupGlobalData(t, document.body), this.globalData.canvasContext = this.canvasContext, this.globalData.renderer = this, this.globalData.isDashed = !1, this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.globalData.transformCanvas = this.transformCanvas, this.elements = createSizedArray(t.layers.length), this.updateContainerSize();
    }, CanvasRendererBase.prototype.updateContainerSize = function(t, r) {
      var n, a, s, o;
      if (this.reset(), t ? (n = t, a = r, this.canvasContext.canvas.width = n, this.canvasContext.canvas.height = a) : (this.animationItem.wrapper && this.animationItem.container ? (n = this.animationItem.wrapper.offsetWidth, a = this.animationItem.wrapper.offsetHeight) : (n = this.canvasContext.canvas.width, a = this.canvasContext.canvas.height), this.canvasContext.canvas.width = n * this.renderConfig.dpr, this.canvasContext.canvas.height = a * this.renderConfig.dpr), this.renderConfig.preserveAspectRatio.indexOf("meet") !== -1 || this.renderConfig.preserveAspectRatio.indexOf("slice") !== -1) {
        var l = this.renderConfig.preserveAspectRatio.split(" "), c = l[1] || "meet", x = l[0] || "xMidYMid", j = x.substr(0, 4), Z = x.substr(4);
        s = n / a, (o = this.transformCanvas.w / this.transformCanvas.h) > s && c === "meet" || o < s && c === "slice" ? (this.transformCanvas.sx = n / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = n / (this.transformCanvas.w / this.renderConfig.dpr)) : (this.transformCanvas.sx = a / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.sy = a / (this.transformCanvas.h / this.renderConfig.dpr)), this.transformCanvas.tx = j === "xMid" && (o < s && c === "meet" || o > s && c === "slice") ? (n - this.transformCanvas.w * (a / this.transformCanvas.h)) / 2 * this.renderConfig.dpr : j === "xMax" && (o < s && c === "meet" || o > s && c === "slice") ? (n - this.transformCanvas.w * (a / this.transformCanvas.h)) * this.renderConfig.dpr : 0, this.transformCanvas.ty = Z === "YMid" && (o > s && c === "meet" || o < s && c === "slice") ? (a - this.transformCanvas.h * (n / this.transformCanvas.w)) / 2 * this.renderConfig.dpr : Z === "YMax" && (o > s && c === "meet" || o < s && c === "slice") ? (a - this.transformCanvas.h * (n / this.transformCanvas.w)) * this.renderConfig.dpr : 0;
      } else this.renderConfig.preserveAspectRatio === "none" ? (this.transformCanvas.sx = n / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = a / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.tx = 0, this.transformCanvas.ty = 0) : (this.transformCanvas.sx = this.renderConfig.dpr, this.transformCanvas.sy = this.renderConfig.dpr, this.transformCanvas.tx = 0, this.transformCanvas.ty = 0);
      this.transformCanvas.props = [this.transformCanvas.sx, 0, 0, 0, 0, this.transformCanvas.sy, 0, 0, 0, 0, 1, 0, this.transformCanvas.tx, this.transformCanvas.ty, 0, 1], this.ctxTransform(this.transformCanvas.props), this.canvasContext.beginPath(), this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h), this.canvasContext.closePath(), this.canvasContext.clip(), this.renderFrame(this.renderedFrame, !0);
    }, CanvasRendererBase.prototype.destroy = function() {
      var t;
      for (this.renderConfig.clearCanvas && this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), t = (this.layers ? this.layers.length : 0) - 1; t >= 0; t -= 1) this.elements[t] && this.elements[t].destroy && this.elements[t].destroy();
      this.elements.length = 0, this.globalData.canvasContext = null, this.animationItem.container = null, this.destroyed = !0;
    }, CanvasRendererBase.prototype.renderFrame = function(t, r) {
      if ((this.renderedFrame !== t || this.renderConfig.clearCanvas !== !0 || r) && !this.destroyed && t !== -1) {
        var n;
        this.renderedFrame = t, this.globalData.frameNum = t - this.animationItem._isFirstFrame, this.globalData.frameId += 1, this.globalData._mdf = !this.renderConfig.clearCanvas || r, this.globalData.projectInterface.currentFrame = t;
        var a = this.layers.length;
        for (this.completeLayers || this.checkLayers(t), n = a - 1; n >= 0; n -= 1) (this.completeLayers || this.elements[n]) && this.elements[n].prepareFrame(t - this.layers[n].st);
        if (this.globalData._mdf) {
          for (this.renderConfig.clearCanvas === !0 ? this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h) : this.save(), n = a - 1; n >= 0; n -= 1) (this.completeLayers || this.elements[n]) && this.elements[n].renderFrame();
          this.renderConfig.clearCanvas !== !0 && this.restore();
        }
      }
    }, CanvasRendererBase.prototype.buildItem = function(t) {
      var r = this.elements;
      if (!r[t] && this.layers[t].ty !== 99) {
        var n = this.createItem(this.layers[t], this, this.globalData);
        r[t] = n, n.initExpressions();
      }
    }, CanvasRendererBase.prototype.checkPendingElements = function() {
      for (; this.pendingElements.length; )
        this.pendingElements.pop().checkParenting();
    }, CanvasRendererBase.prototype.hide = function() {
      this.animationItem.container.style.display = "none";
    }, CanvasRendererBase.prototype.show = function() {
      this.animationItem.container.style.display = "block";
    }, CVContextData.prototype.duplicate = function() {
      var t = 2 * this._length, r = 0;
      for (r = this._length; r < t; r += 1) this.stack[r] = new CanvasContext();
      this._length = t;
    }, CVContextData.prototype.reset = function() {
      this.cArrPos = 0, this.cTr.reset(), this.stack[this.cArrPos].opacity = 1;
    }, CVContextData.prototype.restore = function(t) {
      this.cArrPos -= 1;
      var r, n = this.stack[this.cArrPos], a = n.transform, s = this.cTr.props;
      for (r = 0; r < 16; r += 1) s[r] = a[r];
      if (t) {
        this.nativeContext.restore();
        var o = this.stack[this.cArrPos + 1];
        this.appliedFillStyle = o.fillStyle, this.appliedStrokeStyle = o.strokeStyle, this.appliedLineWidth = o.lineWidth, this.appliedLineCap = o.lineCap, this.appliedLineJoin = o.lineJoin, this.appliedMiterLimit = o.miterLimit;
      }
      this.nativeContext.setTransform(a[0], a[1], a[4], a[5], a[12], a[13]), (t || n.opacity !== -1 && this.currentOpacity !== n.opacity) && (this.nativeContext.globalAlpha = n.opacity, this.currentOpacity = n.opacity), this.currentFillStyle = n.fillStyle, this.currentStrokeStyle = n.strokeStyle, this.currentLineWidth = n.lineWidth, this.currentLineCap = n.lineCap, this.currentLineJoin = n.lineJoin, this.currentMiterLimit = n.miterLimit;
    }, CVContextData.prototype.save = function(t) {
      t && this.nativeContext.save();
      var r = this.cTr.props;
      this._length <= this.cArrPos && this.duplicate();
      var n, a = this.stack[this.cArrPos];
      for (n = 0; n < 16; n += 1) a.transform[n] = r[n];
      this.cArrPos += 1;
      var s = this.stack[this.cArrPos];
      s.opacity = a.opacity, s.fillStyle = a.fillStyle, s.strokeStyle = a.strokeStyle, s.lineWidth = a.lineWidth, s.lineCap = a.lineCap, s.lineJoin = a.lineJoin, s.miterLimit = a.miterLimit;
    }, CVContextData.prototype.setOpacity = function(t) {
      this.stack[this.cArrPos].opacity = t;
    }, CVContextData.prototype.setContext = function(t) {
      this.nativeContext = t;
    }, CVContextData.prototype.fillStyle = function(t) {
      this.stack[this.cArrPos].fillStyle !== t && (this.currentFillStyle = t, this.stack[this.cArrPos].fillStyle = t);
    }, CVContextData.prototype.strokeStyle = function(t) {
      this.stack[this.cArrPos].strokeStyle !== t && (this.currentStrokeStyle = t, this.stack[this.cArrPos].strokeStyle = t);
    }, CVContextData.prototype.lineWidth = function(t) {
      this.stack[this.cArrPos].lineWidth !== t && (this.currentLineWidth = t, this.stack[this.cArrPos].lineWidth = t);
    }, CVContextData.prototype.lineCap = function(t) {
      this.stack[this.cArrPos].lineCap !== t && (this.currentLineCap = t, this.stack[this.cArrPos].lineCap = t);
    }, CVContextData.prototype.lineJoin = function(t) {
      this.stack[this.cArrPos].lineJoin !== t && (this.currentLineJoin = t, this.stack[this.cArrPos].lineJoin = t);
    }, CVContextData.prototype.miterLimit = function(t) {
      this.stack[this.cArrPos].miterLimit !== t && (this.currentMiterLimit = t, this.stack[this.cArrPos].miterLimit = t);
    }, CVContextData.prototype.transform = function(t) {
      this.transformMat.cloneFromProps(t);
      var r = this.cTr;
      this.transformMat.multiply(r), r.cloneFromProps(this.transformMat.props);
      var n = r.props;
      this.nativeContext.setTransform(n[0], n[1], n[4], n[5], n[12], n[13]);
    }, CVContextData.prototype.opacity = function(t) {
      var r = this.stack[this.cArrPos].opacity;
      r *= t < 0 ? 0 : t, this.stack[this.cArrPos].opacity !== r && (this.currentOpacity !== t && (this.nativeContext.globalAlpha = t, this.currentOpacity = t), this.stack[this.cArrPos].opacity = r);
    }, CVContextData.prototype.fill = function(t) {
      this.appliedFillStyle !== this.currentFillStyle && (this.appliedFillStyle = this.currentFillStyle, this.nativeContext.fillStyle = this.appliedFillStyle), this.nativeContext.fill(t);
    }, CVContextData.prototype.fillRect = function(t, r, n, a) {
      this.appliedFillStyle !== this.currentFillStyle && (this.appliedFillStyle = this.currentFillStyle, this.nativeContext.fillStyle = this.appliedFillStyle), this.nativeContext.fillRect(t, r, n, a);
    }, CVContextData.prototype.stroke = function() {
      this.appliedStrokeStyle !== this.currentStrokeStyle && (this.appliedStrokeStyle = this.currentStrokeStyle, this.nativeContext.strokeStyle = this.appliedStrokeStyle), this.appliedLineWidth !== this.currentLineWidth && (this.appliedLineWidth = this.currentLineWidth, this.nativeContext.lineWidth = this.appliedLineWidth), this.appliedLineCap !== this.currentLineCap && (this.appliedLineCap = this.currentLineCap, this.nativeContext.lineCap = this.appliedLineCap), this.appliedLineJoin !== this.currentLineJoin && (this.appliedLineJoin = this.currentLineJoin, this.nativeContext.lineJoin = this.appliedLineJoin), this.appliedMiterLimit !== this.currentMiterLimit && (this.appliedMiterLimit = this.currentMiterLimit, this.nativeContext.miterLimit = this.appliedMiterLimit), this.nativeContext.stroke();
    }, extendPrototype([CanvasRendererBase, ICompElement, CVBaseElement], CVCompElement), CVCompElement.prototype.renderInnerContent = function() {
      var t, r = this.canvasContext;
      for (r.beginPath(), r.moveTo(0, 0), r.lineTo(this.data.w, 0), r.lineTo(this.data.w, this.data.h), r.lineTo(0, this.data.h), r.lineTo(0, 0), r.clip(), t = this.layers.length - 1; t >= 0; t -= 1) (this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
    }, CVCompElement.prototype.destroy = function() {
      var t;
      for (t = this.layers.length - 1; t >= 0; t -= 1) this.elements[t] && this.elements[t].destroy();
      this.layers = null, this.elements = null;
    }, CVCompElement.prototype.createComp = function(t) {
      return new CVCompElement(t, this.globalData, this);
    }, extendPrototype([CanvasRendererBase], CanvasRenderer), CanvasRenderer.prototype.createComp = function(t) {
      return new CVCompElement(t, this.globalData, this);
    }, HBaseElement.prototype = { checkBlendMode: function() {
    }, initRendererElement: function() {
      this.baseElement = createTag(this.data.tg || "div"), this.data.hasMask ? (this.svgElement = createNS("svg"), this.layerElement = createNS("g"), this.maskedElement = this.layerElement, this.svgElement.appendChild(this.layerElement), this.baseElement.appendChild(this.svgElement)) : this.layerElement = this.baseElement, styleDiv(this.baseElement);
    }, createContainerElements: function() {
      this.renderableEffectsManager = new CVEffects(this), this.transformedElement = this.baseElement, this.maskedElement = this.layerElement, this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), this.data.bm !== 0 && this.setBlendMode();
    }, renderElement: function() {
      var t = this.transformedElement ? this.transformedElement.style : {};
      if (this.finalTransform._matMdf) {
        var r = this.finalTransform.mat.toCSS();
        t.transform = r, t.webkitTransform = r;
      }
      this.finalTransform._opMdf && (t.opacity = this.finalTransform.mProp.o.v);
    }, renderFrame: function() {
      this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
    }, destroy: function() {
      this.layerElement = null, this.transformedElement = null, this.matteElement && (this.matteElement = null), this.maskManager && (this.maskManager.destroy(), this.maskManager = null);
    }, createRenderableComponents: function() {
      this.maskManager = new MaskElement(this.data, this, this.globalData);
    }, addEffects: function() {
    }, setMatte: function() {
    } }, HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement, HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy, HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting, extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], HSolidElement), HSolidElement.prototype.createContent = function() {
      var t;
      this.data.hasMask ? ((t = createNS("rect")).setAttribute("width", this.data.sw), t.setAttribute("height", this.data.sh), t.setAttribute("fill", this.data.sc), this.svgElement.setAttribute("width", this.data.sw), this.svgElement.setAttribute("height", this.data.sh)) : ((t = createTag("div")).style.width = this.data.sw + "px", t.style.height = this.data.sh + "px", t.style.backgroundColor = this.data.sc), this.layerElement.appendChild(t);
    }, extendPrototype([BaseElement, TransformElement, HSolidElement, SVGShapeElement, HBaseElement, HierarchyElement, FrameElement, RenderableElement], HShapeElement), HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent, HShapeElement.prototype.createContent = function() {
      var t;
      if (this.baseElement.style.fontSize = 0, this.data.hasMask) this.layerElement.appendChild(this.shapesContainer), t = this.svgElement;
      else {
        t = createNS("svg");
        var r = this.comp.data ? this.comp.data : this.globalData.compSize;
        t.setAttribute("width", r.w), t.setAttribute("height", r.h), t.appendChild(this.shapesContainer), this.layerElement.appendChild(t);
      }
      this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], !0), this.filterUniqueShapes(), this.shapeCont = t;
    }, HShapeElement.prototype.getTransformedPoint = function(t, r) {
      var n, a = t.length;
      for (n = 0; n < a; n += 1) r = t[n].mProps.v.applyToPointArray(r[0], r[1], 0);
      return r;
    }, HShapeElement.prototype.calculateShapeBoundingBox = function(t, r) {
      var n, a, s, o, l, c = t.sh.v, x = t.transformers, j = c._length;
      if (!(j <= 1)) {
        for (n = 0; n < j - 1; n += 1) a = this.getTransformedPoint(x, c.v[n]), s = this.getTransformedPoint(x, c.o[n]), o = this.getTransformedPoint(x, c.i[n + 1]), l = this.getTransformedPoint(x, c.v[n + 1]), this.checkBounds(a, s, o, l, r);
        c.c && (a = this.getTransformedPoint(x, c.v[n]), s = this.getTransformedPoint(x, c.o[n]), o = this.getTransformedPoint(x, c.i[0]), l = this.getTransformedPoint(x, c.v[0]), this.checkBounds(a, s, o, l, r));
      }
    }, HShapeElement.prototype.checkBounds = function(t, r, n, a, s) {
      this.getBoundsOfCurve(t, r, n, a);
      var o = this.shapeBoundingBox;
      s.x = bmMin(o.left, s.x), s.xMax = bmMax(o.right, s.xMax), s.y = bmMin(o.top, s.y), s.yMax = bmMax(o.bottom, s.yMax);
    }, HShapeElement.prototype.shapeBoundingBox = { left: 0, right: 0, top: 0, bottom: 0 }, HShapeElement.prototype.tempBoundingBox = { x: 0, xMax: 0, y: 0, yMax: 0, width: 0, height: 0 }, HShapeElement.prototype.getBoundsOfCurve = function(t, r, n, a) {
      for (var s, o, l, c, x, j, Z, V = [[t[0], a[0]], [t[1], a[1]]], U = 0; U < 2; ++U) o = 6 * t[U] - 12 * r[U] + 6 * n[U], s = -3 * t[U] + 9 * r[U] - 9 * n[U] + 3 * a[U], l = 3 * r[U] - 3 * t[U], o |= 0, l |= 0, (s |= 0) === 0 && o === 0 || (s === 0 ? (c = -l / o) > 0 && c < 1 && V[U].push(this.calculateF(c, t, r, n, a, U)) : (x = o * o - 4 * l * s) >= 0 && ((j = (-o + bmSqrt(x)) / (2 * s)) > 0 && j < 1 && V[U].push(this.calculateF(j, t, r, n, a, U)), (Z = (-o - bmSqrt(x)) / (2 * s)) > 0 && Z < 1 && V[U].push(this.calculateF(Z, t, r, n, a, U))));
      this.shapeBoundingBox.left = bmMin.apply(null, V[0]), this.shapeBoundingBox.top = bmMin.apply(null, V[1]), this.shapeBoundingBox.right = bmMax.apply(null, V[0]), this.shapeBoundingBox.bottom = bmMax.apply(null, V[1]);
    }, HShapeElement.prototype.calculateF = function(t, r, n, a, s, o) {
      return bmPow(1 - t, 3) * r[o] + 3 * bmPow(1 - t, 2) * t * n[o] + 3 * (1 - t) * bmPow(t, 2) * a[o] + bmPow(t, 3) * s[o];
    }, HShapeElement.prototype.calculateBoundingBox = function(t, r) {
      var n, a = t.length;
      for (n = 0; n < a; n += 1) t[n] && t[n].sh ? this.calculateShapeBoundingBox(t[n], r) : t[n] && t[n].it ? this.calculateBoundingBox(t[n].it, r) : t[n] && t[n].style && t[n].w && this.expandStrokeBoundingBox(t[n].w, r);
    }, HShapeElement.prototype.expandStrokeBoundingBox = function(t, r) {
      var n = 0;
      if (t.keyframes) {
        for (var a = 0; a < t.keyframes.length; a += 1) {
          var s = t.keyframes[a].s;
          s > n && (n = s);
        }
        n *= t.mult;
      } else n = t.v * t.mult;
      r.x -= n, r.xMax += n, r.y -= n, r.yMax += n;
    }, HShapeElement.prototype.currentBoxContains = function(t) {
      return this.currentBBox.x <= t.x && this.currentBBox.y <= t.y && this.currentBBox.width + this.currentBBox.x >= t.x + t.width && this.currentBBox.height + this.currentBBox.y >= t.y + t.height;
    }, HShapeElement.prototype.renderInnerContent = function() {
      if (this._renderShapeFrame(), !this.hidden && (this._isFirstFrame || this._mdf)) {
        var t = this.tempBoundingBox, r = 999999;
        if (t.x = r, t.xMax = -r, t.y = r, t.yMax = -r, this.calculateBoundingBox(this.itemsData, t), t.width = t.xMax < t.x ? 0 : t.xMax - t.x, t.height = t.yMax < t.y ? 0 : t.yMax - t.y, this.currentBoxContains(t)) return;
        var n = !1;
        if (this.currentBBox.w !== t.width && (this.currentBBox.w = t.width, this.shapeCont.setAttribute("width", t.width), n = !0), this.currentBBox.h !== t.height && (this.currentBBox.h = t.height, this.shapeCont.setAttribute("height", t.height), n = !0), n || this.currentBBox.x !== t.x || this.currentBBox.y !== t.y) {
          this.currentBBox.w = t.width, this.currentBBox.h = t.height, this.currentBBox.x = t.x, this.currentBBox.y = t.y, this.shapeCont.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h);
          var a = this.shapeCont.style, s = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
          a.transform = s, a.webkitTransform = s;
        }
      }
    }, extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], HTextElement), HTextElement.prototype.createContent = function() {
      if (this.isMasked = this.checkMasks(), this.isMasked) {
        this.renderType = "svg", this.compW = this.comp.data.w, this.compH = this.comp.data.h, this.svgElement.setAttribute("width", this.compW), this.svgElement.setAttribute("height", this.compH);
        var t = createNS("g");
        this.maskedElement.appendChild(t), this.innerElem = t;
      } else this.renderType = "html", this.innerElem = this.layerElement;
      this.checkParenting();
    }, HTextElement.prototype.buildNewText = function() {
      var t = this.textProperty.currentData;
      this.renderedLetters = createSizedArray(t.l ? t.l.length : 0);
      var r = this.innerElem.style, n = t.fc ? this.buildColor(t.fc) : "rgba(0,0,0,0)";
      r.fill = n, r.color = n, t.sc && (r.stroke = this.buildColor(t.sc), r.strokeWidth = t.sw + "px");
      var a, s, o = this.globalData.fontManager.getFontByName(t.f);
      if (!this.globalData.fontManager.chars) if (r.fontSize = t.finalSize + "px", r.lineHeight = t.finalSize + "px", o.fClass) this.innerElem.className = o.fClass;
      else {
        r.fontFamily = o.fFamily;
        var l = t.fWeight, c = t.fStyle;
        r.fontStyle = c, r.fontWeight = l;
      }
      var x, j, Z, V = t.l;
      s = V.length;
      var U, $ = this.mHelper, Y = "", G = 0;
      for (a = 0; a < s; a += 1) {
        if (this.globalData.fontManager.chars ? (this.textPaths[G] ? x = this.textPaths[G] : ((x = createNS("path")).setAttribute("stroke-linecap", lineCapEnum[1]), x.setAttribute("stroke-linejoin", lineJoinEnum[2]), x.setAttribute("stroke-miterlimit", "4")), this.isMasked || (this.textSpans[G] ? Z = (j = this.textSpans[G]).children[0] : ((j = createTag("div")).style.lineHeight = 0, (Z = createNS("svg")).appendChild(x), styleDiv(j)))) : this.isMasked ? x = this.textPaths[G] ? this.textPaths[G] : createNS("text") : this.textSpans[G] ? (j = this.textSpans[G], x = this.textPaths[G]) : (styleDiv(j = createTag("span")), styleDiv(x = createTag("span")), j.appendChild(x)), this.globalData.fontManager.chars) {
          var W, X = this.globalData.fontManager.getCharData(t.finalText[a], o.fStyle, this.globalData.fontManager.getFontByName(t.f).fFamily);
          if (W = X ? X.data : null, $.reset(), W && W.shapes && W.shapes.length && (U = W.shapes[0].it, $.scale(t.finalSize / 100, t.finalSize / 100), Y = this.createPathShape($, U), x.setAttribute("d", Y)), this.isMasked) this.innerElem.appendChild(x);
          else {
            if (this.innerElem.appendChild(j), W && W.shapes) {
              document.body.appendChild(Z);
              var K = Z.getBBox();
              Z.setAttribute("width", K.width + 2), Z.setAttribute("height", K.height + 2), Z.setAttribute("viewBox", K.x - 1 + " " + (K.y - 1) + " " + (K.width + 2) + " " + (K.height + 2));
              var J = Z.style, ee = "translate(" + (K.x - 1) + "px," + (K.y - 1) + "px)";
              J.transform = ee, J.webkitTransform = ee, V[a].yOffset = K.y - 1;
            } else Z.setAttribute("width", 1), Z.setAttribute("height", 1);
            j.appendChild(Z);
          }
        } else if (x.textContent = V[a].val, x.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"), this.isMasked) this.innerElem.appendChild(x);
        else {
          this.innerElem.appendChild(j);
          var te = x.style, ne = "translate3d(0," + -t.finalSize / 1.2 + "px,0)";
          te.transform = ne, te.webkitTransform = ne;
        }
        this.isMasked ? this.textSpans[G] = x : this.textSpans[G] = j, this.textSpans[G].style.display = "block", this.textPaths[G] = x, G += 1;
      }
      for (; G < this.textSpans.length; ) this.textSpans[G].style.display = "none", G += 1;
    }, HTextElement.prototype.renderInnerContent = function() {
      var t;
      if (this.validateText(), this.data.singleShape) {
        if (!this._isFirstFrame && !this.lettersChangedFlag) return;
        if (this.isMasked && this.finalTransform._matMdf) {
          this.svgElement.setAttribute("viewBox", -this.finalTransform.mProp.p.v[0] + " " + -this.finalTransform.mProp.p.v[1] + " " + this.compW + " " + this.compH), t = this.svgElement.style;
          var r = "translate(" + -this.finalTransform.mProp.p.v[0] + "px," + -this.finalTransform.mProp.p.v[1] + "px)";
          t.transform = r, t.webkitTransform = r;
        }
      }
      if (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
        var n, a, s, o, l, c = 0, x = this.textAnimator.renderedLetters, j = this.textProperty.currentData.l;
        for (a = j.length, n = 0; n < a; n += 1) j[n].n ? c += 1 : (o = this.textSpans[n], l = this.textPaths[n], s = x[c], c += 1, s._mdf.m && (this.isMasked ? o.setAttribute("transform", s.m) : (o.style.webkitTransform = s.m, o.style.transform = s.m)), o.style.opacity = s.o, s.sw && s._mdf.sw && l.setAttribute("stroke-width", s.sw), s.sc && s._mdf.sc && l.setAttribute("stroke", s.sc), s.fc && s._mdf.fc && (l.setAttribute("fill", s.fc), l.style.color = s.fc));
        if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
          var Z = this.innerElem.getBBox();
          if (this.currentBBox.w !== Z.width && (this.currentBBox.w = Z.width, this.svgElement.setAttribute("width", Z.width)), this.currentBBox.h !== Z.height && (this.currentBBox.h = Z.height, this.svgElement.setAttribute("height", Z.height)), this.currentBBox.w !== Z.width + 2 || this.currentBBox.h !== Z.height + 2 || this.currentBBox.x !== Z.x - 1 || this.currentBBox.y !== Z.y - 1) {
            this.currentBBox.w = Z.width + 2, this.currentBBox.h = Z.height + 2, this.currentBBox.x = Z.x - 1, this.currentBBox.y = Z.y - 1, this.svgElement.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h), t = this.svgElement.style;
            var V = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
            t.transform = V, t.webkitTransform = V;
          }
        }
      }
    }, extendPrototype([BaseElement, FrameElement, HierarchyElement], HCameraElement), HCameraElement.prototype.setup = function() {
      var t, r, n, a, s = this.comp.threeDElements.length;
      for (t = 0; t < s; t += 1) if ((r = this.comp.threeDElements[t]).type === "3d") {
        n = r.perspectiveElem.style, a = r.container.style;
        var o = this.pe.v + "px", l = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
        n.perspective = o, n.webkitPerspective = o, a.transformOrigin = "0px 0px 0px", a.mozTransformOrigin = "0px 0px 0px", a.webkitTransformOrigin = "0px 0px 0px", n.transform = l, n.webkitTransform = l;
      }
    }, HCameraElement.prototype.createElements = function() {
    }, HCameraElement.prototype.hide = function() {
    }, HCameraElement.prototype.renderFrame = function() {
      var t, r, n = this._isFirstFrame;
      if (this.hierarchy) for (r = this.hierarchy.length, t = 0; t < r; t += 1) n = this.hierarchy[t].finalTransform.mProp._mdf || n;
      if (n || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
        if (this.mat.reset(), this.hierarchy) for (t = r = this.hierarchy.length - 1; t >= 0; t -= 1) {
          var a = this.hierarchy[t].finalTransform.mProp;
          this.mat.translate(-a.p.v[0], -a.p.v[1], a.p.v[2]), this.mat.rotateX(-a.or.v[0]).rotateY(-a.or.v[1]).rotateZ(a.or.v[2]), this.mat.rotateX(-a.rx.v).rotateY(-a.ry.v).rotateZ(a.rz.v), this.mat.scale(1 / a.s.v[0], 1 / a.s.v[1], 1 / a.s.v[2]), this.mat.translate(a.a.v[0], a.a.v[1], a.a.v[2]);
        }
        if (this.p ? this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]) : this.mat.translate(-this.px.v, -this.py.v, this.pz.v), this.a) {
          var s;
          s = this.p ? [this.p.v[0] - this.a.v[0], this.p.v[1] - this.a.v[1], this.p.v[2] - this.a.v[2]] : [this.px.v - this.a.v[0], this.py.v - this.a.v[1], this.pz.v - this.a.v[2]];
          var o = Math.sqrt(Math.pow(s[0], 2) + Math.pow(s[1], 2) + Math.pow(s[2], 2)), l = [s[0] / o, s[1] / o, s[2] / o], c = Math.sqrt(l[2] * l[2] + l[0] * l[0]), x = Math.atan2(l[1], c), j = Math.atan2(l[0], -l[2]);
          this.mat.rotateY(j).rotateX(-x);
        }
        this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v), this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]), this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0), this.mat.translate(0, 0, this.pe.v);
        var Z = !this._prevMat.equals(this.mat);
        if ((Z || this.pe._mdf) && this.comp.threeDElements) {
          var V, U, $;
          for (r = this.comp.threeDElements.length, t = 0; t < r; t += 1) if ((V = this.comp.threeDElements[t]).type === "3d") {
            if (Z) {
              var Y = this.mat.toCSS();
              ($ = V.container.style).transform = Y, $.webkitTransform = Y;
            }
            this.pe._mdf && ((U = V.perspectiveElem.style).perspective = this.pe.v + "px", U.webkitPerspective = this.pe.v + "px");
          }
          this.mat.clone(this._prevMat);
        }
      }
      this._isFirstFrame = !1;
    }, HCameraElement.prototype.prepareFrame = function(t) {
      this.prepareProperties(t, !0);
    }, HCameraElement.prototype.destroy = function() {
    }, HCameraElement.prototype.getBaseElement = function() {
      return null;
    }, extendPrototype([BaseElement, TransformElement, HBaseElement, HSolidElement, HierarchyElement, FrameElement, RenderableElement], HImageElement), HImageElement.prototype.createContent = function() {
      var t = this.globalData.getAssetsPath(this.assetData), r = new Image();
      this.data.hasMask ? (this.imageElem = createNS("image"), this.imageElem.setAttribute("width", this.assetData.w + "px"), this.imageElem.setAttribute("height", this.assetData.h + "px"), this.imageElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", t), this.layerElement.appendChild(this.imageElem), this.baseElement.setAttribute("width", this.assetData.w), this.baseElement.setAttribute("height", this.assetData.h)) : this.layerElement.appendChild(r), r.crossOrigin = "anonymous", r.src = t, this.data.ln && this.baseElement.setAttribute("id", this.data.ln);
    }, extendPrototype([BaseRenderer], HybridRendererBase), HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem, HybridRendererBase.prototype.checkPendingElements = function() {
      for (; this.pendingElements.length; )
        this.pendingElements.pop().checkParenting();
    }, HybridRendererBase.prototype.appendElementInPos = function(t, r) {
      var n = t.getBaseElement();
      if (n) {
        var a = this.layers[r];
        if (a.ddd && this.supports3d) this.addTo3dContainer(n, r);
        else if (this.threeDElements) this.addTo3dContainer(n, r);
        else {
          for (var s, o, l = 0; l < r; ) this.elements[l] && this.elements[l] !== !0 && this.elements[l].getBaseElement && (o = this.elements[l], s = (this.layers[l].ddd ? this.getThreeDContainerByPos(l) : o.getBaseElement()) || s), l += 1;
          s ? a.ddd && this.supports3d || this.layerElement.insertBefore(n, s) : a.ddd && this.supports3d || this.layerElement.appendChild(n);
        }
      }
    }, HybridRendererBase.prototype.createShape = function(t) {
      return this.supports3d ? new HShapeElement(t, this.globalData, this) : new SVGShapeElement(t, this.globalData, this);
    }, HybridRendererBase.prototype.createText = function(t) {
      return this.supports3d ? new HTextElement(t, this.globalData, this) : new SVGTextLottieElement(t, this.globalData, this);
    }, HybridRendererBase.prototype.createCamera = function(t) {
      return this.camera = new HCameraElement(t, this.globalData, this), this.camera;
    }, HybridRendererBase.prototype.createImage = function(t) {
      return this.supports3d ? new HImageElement(t, this.globalData, this) : new IImageElement(t, this.globalData, this);
    }, HybridRendererBase.prototype.createSolid = function(t) {
      return this.supports3d ? new HSolidElement(t, this.globalData, this) : new ISolidElement(t, this.globalData, this);
    }, HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, HybridRendererBase.prototype.getThreeDContainerByPos = function(t) {
      for (var r = 0, n = this.threeDElements.length; r < n; ) {
        if (this.threeDElements[r].startPos <= t && this.threeDElements[r].endPos >= t) return this.threeDElements[r].perspectiveElem;
        r += 1;
      }
      return null;
    }, HybridRendererBase.prototype.createThreeDContainer = function(t, r) {
      var n, a, s = createTag("div");
      styleDiv(s);
      var o = createTag("div");
      if (styleDiv(o), r === "3d") {
        (n = s.style).width = this.globalData.compSize.w + "px", n.height = this.globalData.compSize.h + "px", n.webkitTransformOrigin = "50% 50%", n.mozTransformOrigin = "50% 50%", n.transformOrigin = "50% 50%";
        var l = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
        (a = o.style).transform = l, a.webkitTransform = l;
      }
      s.appendChild(o);
      var c = { container: o, perspectiveElem: s, startPos: t, endPos: t, type: r };
      return this.threeDElements.push(c), c;
    }, HybridRendererBase.prototype.build3dContainers = function() {
      var t, r, n = this.layers.length, a = "";
      for (t = 0; t < n; t += 1) this.layers[t].ddd && this.layers[t].ty !== 3 ? (a !== "3d" && (a = "3d", r = this.createThreeDContainer(t, "3d")), r.endPos = Math.max(r.endPos, t)) : (a !== "2d" && (a = "2d", r = this.createThreeDContainer(t, "2d")), r.endPos = Math.max(r.endPos, t));
      for (t = (n = this.threeDElements.length) - 1; t >= 0; t -= 1) this.resizerElem.appendChild(this.threeDElements[t].perspectiveElem);
    }, HybridRendererBase.prototype.addTo3dContainer = function(t, r) {
      for (var n = 0, a = this.threeDElements.length; n < a; ) {
        if (r <= this.threeDElements[n].endPos) {
          for (var s, o = this.threeDElements[n].startPos; o < r; ) this.elements[o] && this.elements[o].getBaseElement && (s = this.elements[o].getBaseElement()), o += 1;
          s ? this.threeDElements[n].container.insertBefore(t, s) : this.threeDElements[n].container.appendChild(t);
          break;
        }
        n += 1;
      }
    }, HybridRendererBase.prototype.configAnimation = function(t) {
      var r = createTag("div"), n = this.animationItem.wrapper, a = r.style;
      a.width = t.w + "px", a.height = t.h + "px", this.resizerElem = r, styleDiv(r), a.transformStyle = "flat", a.mozTransformStyle = "flat", a.webkitTransformStyle = "flat", this.renderConfig.className && r.setAttribute("class", this.renderConfig.className), n.appendChild(r), a.overflow = "hidden";
      var s = createNS("svg");
      s.setAttribute("width", "1"), s.setAttribute("height", "1"), styleDiv(s), this.resizerElem.appendChild(s);
      var o = createNS("defs");
      s.appendChild(o), this.data = t, this.setupGlobalData(t, s), this.globalData.defs = o, this.layers = t.layers, this.layerElement = this.resizerElem, this.build3dContainers(), this.updateContainerSize();
    }, HybridRendererBase.prototype.destroy = function() {
      var t;
      this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.animationItem.container = null, this.globalData.defs = null;
      var r = this.layers ? this.layers.length : 0;
      for (t = 0; t < r; t += 1) this.elements[t] && this.elements[t].destroy && this.elements[t].destroy();
      this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
    }, HybridRendererBase.prototype.updateContainerSize = function() {
      var t, r, n, a, s = this.animationItem.wrapper.offsetWidth, o = this.animationItem.wrapper.offsetHeight, l = s / o;
      this.globalData.compSize.w / this.globalData.compSize.h > l ? (t = s / this.globalData.compSize.w, r = s / this.globalData.compSize.w, n = 0, a = (o - this.globalData.compSize.h * (s / this.globalData.compSize.w)) / 2) : (t = o / this.globalData.compSize.h, r = o / this.globalData.compSize.h, n = (s - this.globalData.compSize.w * (o / this.globalData.compSize.h)) / 2, a = 0);
      var c = this.resizerElem.style;
      c.webkitTransform = "matrix3d(" + t + ",0,0,0,0," + r + ",0,0,0,0,1,0," + n + "," + a + ",0,1)", c.transform = c.webkitTransform;
    }, HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame, HybridRendererBase.prototype.hide = function() {
      this.resizerElem.style.display = "none";
    }, HybridRendererBase.prototype.show = function() {
      this.resizerElem.style.display = "block";
    }, HybridRendererBase.prototype.initItems = function() {
      if (this.buildAllItems(), this.camera) this.camera.setup();
      else {
        var t, r = this.globalData.compSize.w, n = this.globalData.compSize.h, a = this.threeDElements.length;
        for (t = 0; t < a; t += 1) {
          var s = this.threeDElements[t].perspectiveElem.style;
          s.webkitPerspective = Math.sqrt(Math.pow(r, 2) + Math.pow(n, 2)) + "px", s.perspective = s.webkitPerspective;
        }
      }
    }, HybridRendererBase.prototype.searchExtraCompositions = function(t) {
      var r, n = t.length, a = createTag("div");
      for (r = 0; r < n; r += 1) if (t[r].xt) {
        var s = this.createComp(t[r], a, this.globalData.comp, null);
        s.initExpressions(), this.globalData.projectInterface.registerComposition(s);
      }
    }, extendPrototype([HybridRendererBase, ICompElement, HBaseElement], HCompElement), HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements, HCompElement.prototype.createContainerElements = function() {
      this._createBaseContainerElements(), this.data.hasMask ? (this.svgElement.setAttribute("width", this.data.w), this.svgElement.setAttribute("height", this.data.h), this.transformedElement = this.baseElement) : this.transformedElement = this.layerElement;
    }, HCompElement.prototype.addTo3dContainer = function(t, r) {
      for (var n, a = 0; a < r; ) this.elements[a] && this.elements[a].getBaseElement && (n = this.elements[a].getBaseElement()), a += 1;
      n ? this.layerElement.insertBefore(t, n) : this.layerElement.appendChild(t);
    }, HCompElement.prototype.createComp = function(t) {
      return this.supports3d ? new HCompElement(t, this.globalData, this) : new SVGCompElement(t, this.globalData, this);
    }, extendPrototype([HybridRendererBase], HybridRenderer), HybridRenderer.prototype.createComp = function(t) {
      return this.supports3d ? new HCompElement(t, this.globalData, this) : new SVGCompElement(t, this.globalData, this);
    };
    var CompExpressionInterface = function(t) {
      function r(n) {
        for (var a = 0, s = t.layers.length; a < s; ) {
          if (t.layers[a].nm === n || t.layers[a].ind === n) return t.elements[a].layerInterface;
          a += 1;
        }
        return null;
      }
      return Object.defineProperty(r, "_name", { value: t.data.nm }), r.layer = r, r.pixelAspect = 1, r.height = t.data.h || t.globalData.compSize.h, r.width = t.data.w || t.globalData.compSize.w, r.pixelAspect = 1, r.frameDuration = 1 / t.globalData.frameRate, r.displayStartTime = 0, r.numLayers = t.layers.length, r;
    };
    function _typeof$2(t) {
      return (_typeof$2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
        return typeof r;
      } : function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      })(t);
    }
    function seedRandom(t, r) {
      var n = this, a = r.pow(256, 6), s = r.pow(2, 52), o = 2 * s;
      function l(Z) {
        var V, U = Z.length, $ = this, Y = 0, G = $.i = $.j = 0, W = $.S = [];
        for (U || (Z = [U++]); Y < 256; ) W[Y] = Y++;
        for (Y = 0; Y < 256; Y++) W[Y] = W[G = 255 & G + Z[Y % U] + (V = W[Y])], W[G] = V;
        $.g = function(X) {
          for (var K, J = 0, ee = $.i, te = $.j, ne = $.S; X--; ) K = ne[ee = 255 & ee + 1], J = 256 * J + ne[255 & (ne[ee] = ne[te = 255 & te + K]) + (ne[te] = K)];
          return $.i = ee, $.j = te, J;
        };
      }
      function c(Z, V) {
        return V.i = Z.i, V.j = Z.j, V.S = Z.S.slice(), V;
      }
      function x(Z, V) {
        for (var U, $ = Z + "", Y = 0; Y < $.length; ) V[255 & Y] = 255 & (U ^= 19 * V[255 & Y]) + $.charCodeAt(Y++);
        return j(V);
      }
      function j(Z) {
        return String.fromCharCode.apply(0, Z);
      }
      r.seedrandom = function(Z, V, U) {
        var $ = [], Y = x((function X(K, J) {
          var ee, te = [], ne = _typeof$2(K);
          if (J && ne == "object") for (ee in K) try {
            te.push(X(K[ee], J - 1));
          } catch {
          }
          return te.length ? te : ne == "string" ? K : K + "\0";
        })((V = V === !0 ? { entropy: !0 } : V || {}).entropy ? [Z, j(t)] : Z === null ? (function() {
          try {
            var X = new Uint8Array(256);
            return (n.crypto || n.msCrypto).getRandomValues(X), j(X);
          } catch {
            var K = n.navigator, J = K && K.plugins;
            return [+/* @__PURE__ */ new Date(), n, J, n.screen, j(t)];
          }
        })() : Z, 3), $), G = new l($), W = function() {
          for (var X = G.g(6), K = a, J = 0; X < s; ) X = 256 * (X + J), K *= 256, J = G.g(1);
          for (; X >= o; ) X /= 2, K /= 2, J >>>= 1;
          return (X + J) / K;
        };
        return W.int32 = function() {
          return 0 | G.g(4);
        }, W.quick = function() {
          return G.g(4) / 4294967296;
        }, W.double = W, x(j(G.S), t), (V.pass || U || function(X, K, J, ee) {
          return ee && (ee.S && c(ee, G), X.state = function() {
            return c(G, {});
          }), J ? (r.random = X, K) : X;
        })(W, Y, "global" in V ? V.global : this == r, V.state);
      }, x(r.random(), t);
    }
    function initialize$2(t) {
      seedRandom([], t);
    }
    var propTypes = { SHAPE: "shape" };
    function _typeof$1(t) {
      return (_typeof$1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
        return typeof r;
      } : function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      })(t);
    }
    var ExpressionManager = (function() {
      var ob = {}, Math = BMMath, window = null, document = null, XMLHttpRequest = null, fetch = null, frames = null, _lottieGlobal = {};
      function resetFrame() {
        _lottieGlobal = {};
      }
      function $bm_isInstanceOfArray(t) {
        return t.constructor === Array || t.constructor === Float32Array;
      }
      function isNumerable(t, r) {
        return t === "number" || r instanceof Number || t === "boolean" || t === "string";
      }
      function $bm_neg(t) {
        var r = _typeof$1(t);
        if (r === "number" || t instanceof Number || r === "boolean") return -t;
        if ($bm_isInstanceOfArray(t)) {
          var n, a = t.length, s = [];
          for (n = 0; n < a; n += 1) s[n] = -t[n];
          return s;
        }
        return t.propType ? t.v : -t;
      }
      initialize$2(BMMath);
      var easeInBez = BezierFactory.getBezierEasing(0.333, 0, 0.833, 0.833, "easeIn").get, easeOutBez = BezierFactory.getBezierEasing(0.167, 0.167, 0.667, 1, "easeOut").get, easeInOutBez = BezierFactory.getBezierEasing(0.33, 0, 0.667, 1, "easeInOut").get;
      function sum(t, r) {
        var n = _typeof$1(t), a = _typeof$1(r);
        if (isNumerable(n, t) && isNumerable(a, r) || n === "string" || a === "string") return t + r;
        if ($bm_isInstanceOfArray(t) && isNumerable(a, r)) return (t = t.slice(0))[0] += r, t;
        if (isNumerable(n, t) && $bm_isInstanceOfArray(r)) return (r = r.slice(0))[0] = t + r[0], r;
        if ($bm_isInstanceOfArray(t) && $bm_isInstanceOfArray(r)) {
          for (var s = 0, o = t.length, l = r.length, c = []; s < o || s < l; ) (typeof t[s] == "number" || t[s] instanceof Number) && (typeof r[s] == "number" || r[s] instanceof Number) ? c[s] = t[s] + r[s] : c[s] = r[s] === void 0 ? t[s] : t[s] || r[s], s += 1;
          return c;
        }
        return 0;
      }
      var add = sum;
      function sub(t, r) {
        var n = _typeof$1(t), a = _typeof$1(r);
        if (isNumerable(n, t) && isNumerable(a, r)) return n === "string" && (t = parseInt(t, 10)), a === "string" && (r = parseInt(r, 10)), t - r;
        if ($bm_isInstanceOfArray(t) && isNumerable(a, r)) return (t = t.slice(0))[0] -= r, t;
        if (isNumerable(n, t) && $bm_isInstanceOfArray(r)) return (r = r.slice(0))[0] = t - r[0], r;
        if ($bm_isInstanceOfArray(t) && $bm_isInstanceOfArray(r)) {
          for (var s = 0, o = t.length, l = r.length, c = []; s < o || s < l; ) (typeof t[s] == "number" || t[s] instanceof Number) && (typeof r[s] == "number" || r[s] instanceof Number) ? c[s] = t[s] - r[s] : c[s] = r[s] === void 0 ? t[s] : t[s] || r[s], s += 1;
          return c;
        }
        return 0;
      }
      function mul(t, r) {
        var n, a, s, o = _typeof$1(t), l = _typeof$1(r);
        if (isNumerable(o, t) && isNumerable(l, r)) return t * r;
        if ($bm_isInstanceOfArray(t) && isNumerable(l, r)) {
          for (s = t.length, n = createTypedArray("float32", s), a = 0; a < s; a += 1) n[a] = t[a] * r;
          return n;
        }
        if (isNumerable(o, t) && $bm_isInstanceOfArray(r)) {
          for (s = r.length, n = createTypedArray("float32", s), a = 0; a < s; a += 1) n[a] = t * r[a];
          return n;
        }
        return 0;
      }
      function div(t, r) {
        var n, a, s, o = _typeof$1(t), l = _typeof$1(r);
        if (isNumerable(o, t) && isNumerable(l, r)) return t / r;
        if ($bm_isInstanceOfArray(t) && isNumerable(l, r)) {
          for (s = t.length, n = createTypedArray("float32", s), a = 0; a < s; a += 1) n[a] = t[a] / r;
          return n;
        }
        if (isNumerable(o, t) && $bm_isInstanceOfArray(r)) {
          for (s = r.length, n = createTypedArray("float32", s), a = 0; a < s; a += 1) n[a] = t / r[a];
          return n;
        }
        return 0;
      }
      function mod(t, r) {
        return typeof t == "string" && (t = parseInt(t, 10)), typeof r == "string" && (r = parseInt(r, 10)), t % r;
      }
      var $bm_sum = sum, $bm_sub = sub, $bm_mul = mul, $bm_div = div, $bm_mod = mod;
      function clamp(t, r, n) {
        if (r > n) {
          var a = n;
          n = r, r = a;
        }
        return Math.min(Math.max(t, r), n);
      }
      function radiansToDegrees(t) {
        return t / degToRads;
      }
      var radians_to_degrees = radiansToDegrees;
      function degreesToRadians(t) {
        return t * degToRads;
      }
      var degrees_to_radians = radiansToDegrees, helperLengthArray = [0, 0, 0, 0, 0, 0];
      function length(t, r) {
        if (typeof t == "number" || t instanceof Number) return r = r || 0, Math.abs(t - r);
        var n;
        r || (r = helperLengthArray);
        var a = Math.min(t.length, r.length), s = 0;
        for (n = 0; n < a; n += 1) s += Math.pow(r[n] - t[n], 2);
        return Math.sqrt(s);
      }
      function normalize(t) {
        return div(t, length(t));
      }
      function rgbToHsl(t) {
        var r, n, a = t[0], s = t[1], o = t[2], l = Math.max(a, s, o), c = Math.min(a, s, o), x = (l + c) / 2;
        if (l === c) r = 0, n = 0;
        else {
          var j = l - c;
          switch (n = x > 0.5 ? j / (2 - l - c) : j / (l + c), l) {
            case a:
              r = (s - o) / j + (s < o ? 6 : 0);
              break;
            case s:
              r = (o - a) / j + 2;
              break;
            case o:
              r = (a - s) / j + 4;
          }
          r /= 6;
        }
        return [r, n, x, t[3]];
      }
      function hue2rgb(t, r, n) {
        return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? t + 6 * (r - t) * n : n < 0.5 ? r : n < 2 / 3 ? t + (r - t) * (2 / 3 - n) * 6 : t;
      }
      function hslToRgb(t) {
        var r, n, a, s = t[0], o = t[1], l = t[2];
        if (o === 0) r = l, a = l, n = l;
        else {
          var c = l < 0.5 ? l * (1 + o) : l + o - l * o, x = 2 * l - c;
          r = hue2rgb(x, c, s + 1 / 3), n = hue2rgb(x, c, s), a = hue2rgb(x, c, s - 1 / 3);
        }
        return [r, n, a, t[3]];
      }
      function linear(t, r, n, a, s) {
        if (a !== void 0 && s !== void 0 || (a = r, s = n, r = 0, n = 1), n < r) {
          var o = n;
          n = r, r = o;
        }
        if (t <= r) return a;
        if (t >= n) return s;
        var l, c = n === r ? 0 : (t - r) / (n - r);
        if (!a.length) return a + (s - a) * c;
        var x = a.length, j = createTypedArray("float32", x);
        for (l = 0; l < x; l += 1) j[l] = a[l] + (s[l] - a[l]) * c;
        return j;
      }
      function random(t, r) {
        if (r === void 0 && (t === void 0 ? (t = 0, r = 1) : (r = t, t = void 0)), r.length) {
          var n, a = r.length;
          t || (t = createTypedArray("float32", a));
          var s = createTypedArray("float32", a), o = BMMath.random();
          for (n = 0; n < a; n += 1) s[n] = t[n] + o * (r[n] - t[n]);
          return s;
        }
        return t === void 0 && (t = 0), t + BMMath.random() * (r - t);
      }
      function createPath(t, r, n, a) {
        var s, o = t.length, l = shapePool.newElement();
        l.setPathData(!!a, o);
        var c, x, j = [0, 0];
        for (s = 0; s < o; s += 1) c = r && r[s] ? r[s] : j, x = n && n[s] ? n[s] : j, l.setTripleAt(t[s][0], t[s][1], x[0] + t[s][0], x[1] + t[s][1], c[0] + t[s][0], c[1] + t[s][1], s, !0);
        return l;
      }
      function initiateExpression(elem, data, property) {
        function noOp(t) {
          return t;
        }
        if (!elem.globalData.renderConfig.runExpressions) return noOp;
        var val = data.x, needsVelocity = /velocity(?![\w\d])/.test(val), _needsRandom = val.indexOf("random") !== -1, elemType = elem.data.ty, transform, $bm_transform, content, effect, thisProperty = property;
        thisProperty.valueAtTime = thisProperty.getValueAtTime, Object.defineProperty(thisProperty, "value", { get: function() {
          return thisProperty.v;
        } }), elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate, elem.comp.displayStartTime = 0;
        var inPoint = elem.data.ip / elem.comp.globalData.frameRate, outPoint = elem.data.op / elem.comp.globalData.frameRate, width = elem.data.sw ? elem.data.sw : 0, height = elem.data.sh ? elem.data.sh : 0, name = elem.data.nm, loopIn, loop_in, loopOut, loop_out, smooth, toWorld, fromWorld, fromComp, toComp, fromCompToSurface, position, rotation, anchorPoint, scale, thisLayer, thisComp, mask, valueAtTime, velocityAtTime, scoped_bm_rt, expression_function = eval("[function _expression_function(){" + val + ";scoped_bm_rt=$bm_rt}]")[0], numKeys = property.kf ? data.k.length : 0, active = !this.data || this.data.hd !== !0, wiggle = function(t, r) {
          var n, a, s = this.pv.length ? this.pv.length : 1, o = createTypedArray("float32", s), l = Math.floor(5 * time);
          for (n = 0, a = 0; n < l; ) {
            for (a = 0; a < s; a += 1) o[a] += -r + 2 * r * BMMath.random();
            n += 1;
          }
          var c = 5 * time, x = c - Math.floor(c), j = createTypedArray("float32", s);
          if (s > 1) {
            for (a = 0; a < s; a += 1) j[a] = this.pv[a] + o[a] + (-r + 2 * r * BMMath.random()) * x;
            return j;
          }
          return this.pv + o[0] + (-r + 2 * r * BMMath.random()) * x;
        }.bind(this);
        function loopInDuration(t, r) {
          return loopIn(t, r, !0);
        }
        function loopOutDuration(t, r) {
          return loopOut(t, r, !0);
        }
        thisProperty.loopIn && (loopIn = thisProperty.loopIn.bind(thisProperty), loop_in = loopIn), thisProperty.loopOut && (loopOut = thisProperty.loopOut.bind(thisProperty), loop_out = loopOut), thisProperty.smooth && (smooth = thisProperty.smooth.bind(thisProperty)), this.getValueAtTime && (valueAtTime = this.getValueAtTime.bind(this)), this.getVelocityAtTime && (velocityAtTime = this.getVelocityAtTime.bind(this));
        var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface), time, velocity, value, text, textIndex, textTotal, selectorValue;
        function lookAt(t, r) {
          var n = [r[0] - t[0], r[1] - t[1], r[2] - t[2]], a = Math.atan2(n[0], Math.sqrt(n[1] * n[1] + n[2] * n[2])) / degToRads;
          return [-Math.atan2(n[1], n[2]) / degToRads, a, 0];
        }
        function easeOut(t, r, n, a, s) {
          return applyEase(easeOutBez, t, r, n, a, s);
        }
        function easeIn(t, r, n, a, s) {
          return applyEase(easeInBez, t, r, n, a, s);
        }
        function ease(t, r, n, a, s) {
          return applyEase(easeInOutBez, t, r, n, a, s);
        }
        function applyEase(t, r, n, a, s, o) {
          s === void 0 ? (s = n, o = a) : r = (r - n) / (a - n), r > 1 ? r = 1 : r < 0 && (r = 0);
          var l = t(r);
          if ($bm_isInstanceOfArray(s)) {
            var c, x = s.length, j = createTypedArray("float32", x);
            for (c = 0; c < x; c += 1) j[c] = (o[c] - s[c]) * l + s[c];
            return j;
          }
          return (o - s) * l + s;
        }
        function nearestKey(t) {
          var r, n, a, s = data.k.length;
          if (data.k.length && typeof data.k[0] != "number") if (n = -1, (t *= elem.comp.globalData.frameRate) < data.k[0].t) n = 1, a = data.k[0].t;
          else {
            for (r = 0; r < s - 1; r += 1) {
              if (t === data.k[r].t) {
                n = r + 1, a = data.k[r].t;
                break;
              }
              if (t > data.k[r].t && t < data.k[r + 1].t) {
                t - data.k[r].t > data.k[r + 1].t - t ? (n = r + 2, a = data.k[r + 1].t) : (n = r + 1, a = data.k[r].t);
                break;
              }
            }
            n === -1 && (n = r + 1, a = data.k[r].t);
          }
          else n = 0, a = 0;
          var o = {};
          return o.index = n, o.time = a / elem.comp.globalData.frameRate, o;
        }
        function key(t) {
          var r, n, a;
          if (!data.k.length || typeof data.k[0] == "number") throw new Error("The property has no keyframe at index " + t);
          t -= 1, r = { time: data.k[t].t / elem.comp.globalData.frameRate, value: [] };
          var s = Object.prototype.hasOwnProperty.call(data.k[t], "s") ? data.k[t].s : data.k[t - 1].e;
          for (a = s.length, n = 0; n < a; n += 1) r[n] = s[n], r.value[n] = s[n];
          return r;
        }
        function framesToTime(t, r) {
          return r || (r = elem.comp.globalData.frameRate), t / r;
        }
        function timeToFrames(t, r) {
          return t || t === 0 || (t = time), r || (r = elem.comp.globalData.frameRate), t * r;
        }
        function seedRandom(t) {
          BMMath.seedrandom(randSeed + t);
        }
        function sourceRectAtTime() {
          return elem.sourceRectAtTime();
        }
        function substring(t, r) {
          return typeof value == "string" ? r === void 0 ? value.substring(t) : value.substring(t, r) : "";
        }
        function substr(t, r) {
          return typeof value == "string" ? r === void 0 ? value.substr(t) : value.substr(t, r) : "";
        }
        function posterizeTime(t) {
          time = t === 0 ? 0 : Math.floor(time * t) / t, value = valueAtTime(time);
        }
        var index = elem.data.ind;
        !elem.hierarchy || elem.hierarchy.length;
        var parent, randSeed = Math.floor(1e6 * Math.random()), globalData = elem.globalData;
        function executeExpression(t) {
          return value = t, this.frameExpressionId === elem.globalData.frameId && this.propType !== "textSelector" ? value : (this.propType === "textSelector" && (textIndex = this.textIndex, textTotal = this.textTotal, selectorValue = this.selectorValue), thisLayer || (text = elem.layerInterface.text, thisLayer = elem.layerInterface, thisComp = elem.comp.compInterface, toWorld = thisLayer.toWorld.bind(thisLayer), fromWorld = thisLayer.fromWorld.bind(thisLayer), fromComp = thisLayer.fromComp.bind(thisLayer), toComp = thisLayer.toComp.bind(thisLayer), mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null, fromCompToSurface = fromComp), transform || (transform = elem.layerInterface("ADBE Transform Group"), $bm_transform = transform, transform && (anchorPoint = transform.anchorPoint)), elemType !== 4 || content || (content = thisLayer("ADBE Root Vectors Group")), effect || (effect = thisLayer(4)), !(!elem.hierarchy || !elem.hierarchy.length) && !parent && (parent = elem.hierarchy[0].layerInterface), time = this.comp.renderedFrame / this.comp.globalData.frameRate, _needsRandom && seedRandom(randSeed + time), needsVelocity && (velocity = velocityAtTime(time)), expression_function(), this.frameExpressionId = elem.globalData.frameId, scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt);
        }
        return executeExpression.__preventDeadCodeRemoval = [$bm_transform, anchorPoint, time, velocity, inPoint, outPoint, width, height, name, loop_in, loop_out, smooth, toComp, fromCompToSurface, toWorld, fromWorld, mask, position, rotation, scale, thisComp, numKeys, active, wiggle, loopInDuration, loopOutDuration, comp, lookAt, easeOut, easeIn, ease, nearestKey, key, text, textIndex, textTotal, selectorValue, framesToTime, timeToFrames, sourceRectAtTime, substring, substr, posterizeTime, index, globalData], executeExpression;
      }
      return ob.initiateExpression = initiateExpression, ob.__preventDeadCodeRemoval = [window, document, XMLHttpRequest, fetch, frames, $bm_neg, add, $bm_sum, $bm_sub, $bm_mul, $bm_div, $bm_mod, clamp, radians_to_degrees, degreesToRadians, degrees_to_radians, normalize, rgbToHsl, hslToRgb, linear, random, createPath, _lottieGlobal], ob.resetFrame = resetFrame, ob;
    })(), Expressions = (function() {
      var t = {};
      return t.initExpressions = function(r) {
        var n = 0, a = [];
        r.renderer.compInterface = CompExpressionInterface(r.renderer), r.renderer.globalData.projectInterface.registerComposition(r.renderer), r.renderer.globalData.pushExpression = function() {
          n += 1;
        }, r.renderer.globalData.popExpression = function() {
          (n -= 1) === 0 && (function() {
            var s, o = a.length;
            for (s = 0; s < o; s += 1) a[s].release();
            a.length = 0;
          })();
        }, r.renderer.globalData.registerExpressionProperty = function(s) {
          a.indexOf(s) === -1 && a.push(s);
        };
      }, t.resetFrame = ExpressionManager.resetFrame, t;
    })(), MaskManagerInterface = (function() {
      function t(r, n) {
        this._mask = r, this._data = n;
      }
      return Object.defineProperty(t.prototype, "maskPath", { get: function() {
        return this._mask.prop.k && this._mask.prop.getValue(), this._mask.prop;
      } }), Object.defineProperty(t.prototype, "maskOpacity", { get: function() {
        return this._mask.op.k && this._mask.op.getValue(), 100 * this._mask.op.v;
      } }), function(r) {
        var n, a = createSizedArray(r.viewData.length), s = r.viewData.length;
        for (n = 0; n < s; n += 1) a[n] = new t(r.viewData[n], r.masksProperties[n]);
        return function(o) {
          for (n = 0; n < s; ) {
            if (r.masksProperties[n].nm === o) return a[n];
            n += 1;
          }
          return null;
        };
      };
    })(), ExpressionPropertyInterface = /* @__PURE__ */ (function() {
      var t = { pv: 0, v: 0, mult: 1 }, r = { pv: [0, 0, 0], v: [0, 0, 0], mult: 1 };
      function n(s, o, l) {
        Object.defineProperty(s, "velocity", { get: function() {
          return o.getVelocityAtTime(o.comp.currentFrame);
        } }), s.numKeys = o.keyframes ? o.keyframes.length : 0, s.key = function(c) {
          if (!s.numKeys) return 0;
          var x = "";
          x = "s" in o.keyframes[c - 1] ? o.keyframes[c - 1].s : "e" in o.keyframes[c - 2] ? o.keyframes[c - 2].e : o.keyframes[c - 2].s;
          var j = l === "unidimensional" ? new Number(x) : Object.assign({}, x);
          return j.time = o.keyframes[c - 1].t / o.elem.comp.globalData.frameRate, j.value = l === "unidimensional" ? x[0] : x, j;
        }, s.valueAtTime = o.getValueAtTime, s.speedAtTime = o.getSpeedAtTime, s.velocityAtTime = o.getVelocityAtTime, s.propertyGroup = o.propertyGroup;
      }
      function a() {
        return t;
      }
      return function(s) {
        return s ? s.propType === "unidimensional" ? (function(o) {
          o && "pv" in o || (o = t);
          var l = 1 / o.mult, c = o.pv * l, x = new Number(c);
          return x.value = c, n(x, o, "unidimensional"), function() {
            return o.k && o.getValue(), c = o.v * l, x.value !== c && ((x = new Number(c)).value = c, n(x, o, "unidimensional")), x;
          };
        })(s) : (function(o) {
          o && "pv" in o || (o = r);
          var l = 1 / o.mult, c = o.data && o.data.l || o.pv.length, x = createTypedArray("float32", c), j = createTypedArray("float32", c);
          return x.value = j, n(x, o, "multidimensional"), function() {
            o.k && o.getValue();
            for (var Z = 0; Z < c; Z += 1) j[Z] = o.v[Z] * l, x[Z] = j[Z];
            return x;
          };
        })(s) : a;
      };
    })(), TransformExpressionInterface = function(t) {
      function r(l) {
        switch (l) {
          case "scale":
          case "Scale":
          case "ADBE Scale":
          case 6:
            return r.scale;
          case "rotation":
          case "Rotation":
          case "ADBE Rotation":
          case "ADBE Rotate Z":
          case 10:
            return r.rotation;
          case "ADBE Rotate X":
            return r.xRotation;
          case "ADBE Rotate Y":
            return r.yRotation;
          case "position":
          case "Position":
          case "ADBE Position":
          case 2:
            return r.position;
          case "ADBE Position_0":
            return r.xPosition;
          case "ADBE Position_1":
            return r.yPosition;
          case "ADBE Position_2":
            return r.zPosition;
          case "anchorPoint":
          case "AnchorPoint":
          case "Anchor Point":
          case "ADBE AnchorPoint":
          case 1:
            return r.anchorPoint;
          case "opacity":
          case "Opacity":
          case 11:
            return r.opacity;
          default:
            return null;
        }
      }
      var n, a, s, o;
      return Object.defineProperty(r, "rotation", { get: ExpressionPropertyInterface(t.r || t.rz) }), Object.defineProperty(r, "zRotation", { get: ExpressionPropertyInterface(t.rz || t.r) }), Object.defineProperty(r, "xRotation", { get: ExpressionPropertyInterface(t.rx) }), Object.defineProperty(r, "yRotation", { get: ExpressionPropertyInterface(t.ry) }), Object.defineProperty(r, "scale", { get: ExpressionPropertyInterface(t.s) }), t.p ? o = ExpressionPropertyInterface(t.p) : (n = ExpressionPropertyInterface(t.px), a = ExpressionPropertyInterface(t.py), t.pz && (s = ExpressionPropertyInterface(t.pz))), Object.defineProperty(r, "position", { get: function() {
        return t.p ? o() : [n(), a(), s ? s() : 0];
      } }), Object.defineProperty(r, "xPosition", { get: ExpressionPropertyInterface(t.px) }), Object.defineProperty(r, "yPosition", { get: ExpressionPropertyInterface(t.py) }), Object.defineProperty(r, "zPosition", { get: ExpressionPropertyInterface(t.pz) }), Object.defineProperty(r, "anchorPoint", { get: ExpressionPropertyInterface(t.a) }), Object.defineProperty(r, "opacity", { get: ExpressionPropertyInterface(t.o) }), Object.defineProperty(r, "skew", { get: ExpressionPropertyInterface(t.sk) }), Object.defineProperty(r, "skewAxis", { get: ExpressionPropertyInterface(t.sa) }), Object.defineProperty(r, "orientation", { get: ExpressionPropertyInterface(t.or) }), r;
    }, LayerExpressionInterface = /* @__PURE__ */ (function() {
      function t(j) {
        var Z = new Matrix();
        return j !== void 0 ? this._elem.finalTransform.mProp.getValueAtTime(j).clone(Z) : this._elem.finalTransform.mProp.applyToMatrix(Z), Z;
      }
      function r(j, Z) {
        var V = this.getMatrix(Z);
        return V.props[12] = 0, V.props[13] = 0, V.props[14] = 0, this.applyPoint(V, j);
      }
      function n(j, Z) {
        var V = this.getMatrix(Z);
        return this.applyPoint(V, j);
      }
      function a(j, Z) {
        var V = this.getMatrix(Z);
        return V.props[12] = 0, V.props[13] = 0, V.props[14] = 0, this.invertPoint(V, j);
      }
      function s(j, Z) {
        var V = this.getMatrix(Z);
        return this.invertPoint(V, j);
      }
      function o(j, Z) {
        if (this._elem.hierarchy && this._elem.hierarchy.length) {
          var V, U = this._elem.hierarchy.length;
          for (V = 0; V < U; V += 1) this._elem.hierarchy[V].finalTransform.mProp.applyToMatrix(j);
        }
        return j.applyToPointArray(Z[0], Z[1], Z[2] || 0);
      }
      function l(j, Z) {
        if (this._elem.hierarchy && this._elem.hierarchy.length) {
          var V, U = this._elem.hierarchy.length;
          for (V = 0; V < U; V += 1) this._elem.hierarchy[V].finalTransform.mProp.applyToMatrix(j);
        }
        return j.inversePoint(Z);
      }
      function c(j) {
        var Z = new Matrix();
        if (Z.reset(), this._elem.finalTransform.mProp.applyToMatrix(Z), this._elem.hierarchy && this._elem.hierarchy.length) {
          var V, U = this._elem.hierarchy.length;
          for (V = 0; V < U; V += 1) this._elem.hierarchy[V].finalTransform.mProp.applyToMatrix(Z);
          return Z.inversePoint(j);
        }
        return Z.inversePoint(j);
      }
      function x() {
        return [1, 1, 1, 1];
      }
      return function(j) {
        var Z;
        function V($) {
          switch ($) {
            case "ADBE Root Vectors Group":
            case "Contents":
            case 2:
              return V.shapeInterface;
            case 1:
            case 6:
            case "Transform":
            case "transform":
            case "ADBE Transform Group":
              return Z;
            case 4:
            case "ADBE Effect Parade":
            case "effects":
            case "Effects":
              return V.effect;
            case "ADBE Text Properties":
              return V.textInterface;
            default:
              return null;
          }
        }
        V.getMatrix = t, V.invertPoint = l, V.applyPoint = o, V.toWorld = n, V.toWorldVec = r, V.fromWorld = s, V.fromWorldVec = a, V.toComp = n, V.fromComp = c, V.sampleImage = x, V.sourceRectAtTime = j.sourceRectAtTime.bind(j), V._elem = j;
        var U = getDescriptor(Z = TransformExpressionInterface(j.finalTransform.mProp), "anchorPoint");
        return Object.defineProperties(V, { hasParent: { get: function() {
          return j.hierarchy.length;
        } }, parent: { get: function() {
          return j.hierarchy[0].layerInterface;
        } }, rotation: getDescriptor(Z, "rotation"), scale: getDescriptor(Z, "scale"), position: getDescriptor(Z, "position"), opacity: getDescriptor(Z, "opacity"), anchorPoint: U, anchor_point: U, transform: { get: function() {
          return Z;
        } }, active: { get: function() {
          return j.isInRange;
        } } }), V.startTime = j.data.st, V.index = j.data.ind, V.source = j.data.refId, V.height = j.data.ty === 0 ? j.data.h : 100, V.width = j.data.ty === 0 ? j.data.w : 100, V.inPoint = j.data.ip / j.comp.globalData.frameRate, V.outPoint = j.data.op / j.comp.globalData.frameRate, V._name = j.data.nm, V.registerMaskInterface = function($) {
          V.mask = new MaskManagerInterface($, j);
        }, V.registerEffectsInterface = function($) {
          V.effect = $;
        }, V;
      };
    })(), propertyGroupFactory = function(t, r) {
      return function(n) {
        return (n = n === void 0 ? 1 : n) <= 0 ? t : r(n - 1);
      };
    }, PropertyInterface = function(t, r) {
      var n = { _name: t };
      return function(a) {
        return (a = a === void 0 ? 1 : a) <= 0 ? n : r(a - 1);
      };
    }, EffectsExpressionInterface = /* @__PURE__ */ (function() {
      function t(n, a, s, o) {
        function l(V) {
          for (var U = n.ef, $ = 0, Y = U.length; $ < Y; ) {
            if (V === U[$].nm || V === U[$].mn || V === U[$].ix) return U[$].ty === 5 ? j[$] : j[$]();
            $ += 1;
          }
          throw new Error();
        }
        var c, x = propertyGroupFactory(l, s), j = [], Z = n.ef.length;
        for (c = 0; c < Z; c += 1) n.ef[c].ty === 5 ? j.push(t(n.ef[c], a.effectElements[c], a.effectElements[c].propertyGroup, o)) : j.push(r(a.effectElements[c], n.ef[c].ty, o, x));
        return n.mn === "ADBE Color Control" && Object.defineProperty(l, "color", { get: function() {
          return j[0]();
        } }), Object.defineProperties(l, { numProperties: { get: function() {
          return n.np;
        } }, _name: { value: n.nm }, propertyGroup: { value: x } }), l.enabled = n.en !== 0, l.active = l.enabled, l;
      }
      function r(n, a, s, o) {
        var l = ExpressionPropertyInterface(n.p);
        return n.p.setGroupProperty && n.p.setGroupProperty(PropertyInterface("", o)), function() {
          return a === 10 ? s.comp.compInterface(n.p.v) : l();
        };
      }
      return { createEffectsInterface: function(n, a) {
        if (n.effectsManager) {
          var s, o = [], l = n.data.ef, c = n.effectsManager.effectElements.length;
          for (s = 0; s < c; s += 1) o.push(t(l[s], n.effectsManager.effectElements[s], a, n));
          var x = n.data.ef || [], j = function(Z) {
            for (s = 0, c = x.length; s < c; ) {
              if (Z === x[s].nm || Z === x[s].mn || Z === x[s].ix) return o[s];
              s += 1;
            }
            return null;
          };
          return Object.defineProperty(j, "numProperties", { get: function() {
            return x.length;
          } }), j;
        }
        return null;
      } };
    })(), ShapePathInterface = function(t, r, n) {
      var a = r.sh;
      function s(l) {
        return l === "Shape" || l === "shape" || l === "Path" || l === "path" || l === "ADBE Vector Shape" || l === 2 ? s.path : null;
      }
      var o = propertyGroupFactory(s, n);
      return a.setGroupProperty(PropertyInterface("Path", o)), Object.defineProperties(s, { path: { get: function() {
        return a.k && a.getValue(), a;
      } }, shape: { get: function() {
        return a.k && a.getValue(), a;
      } }, _name: { value: t.nm }, ix: { value: t.ix }, propertyIndex: { value: t.ix }, mn: { value: t.mn }, propertyGroup: { value: n } }), s;
    }, ShapeExpressionInterface = /* @__PURE__ */ (function() {
      function t($, Y, G) {
        var W, X = [], K = $ ? $.length : 0;
        for (W = 0; W < K; W += 1) $[W].ty === "gr" ? X.push(r($[W], Y[W], G)) : $[W].ty === "fl" ? X.push(n($[W], Y[W], G)) : $[W].ty === "st" ? X.push(o($[W], Y[W], G)) : $[W].ty === "tm" ? X.push(l($[W], Y[W], G)) : $[W].ty === "tr" || ($[W].ty === "el" ? X.push(x($[W], Y[W], G)) : $[W].ty === "sr" ? X.push(j($[W], Y[W], G)) : $[W].ty === "sh" ? X.push(ShapePathInterface($[W], Y[W], G)) : $[W].ty === "rc" ? X.push(Z($[W], Y[W], G)) : $[W].ty === "rd" ? X.push(V($[W], Y[W], G)) : $[W].ty === "rp" ? X.push(U($[W], Y[W], G)) : $[W].ty === "gf" ? X.push(a($[W], Y[W], G)) : X.push(s($[W], Y[W])));
        return X;
      }
      function r($, Y, G) {
        var W = function(J) {
          switch (J) {
            case "ADBE Vectors Group":
            case "Contents":
            case 2:
              return W.content;
            default:
              return W.transform;
          }
        };
        W.propertyGroup = propertyGroupFactory(W, G);
        var X = (function(J, ee, te) {
          var ne, re = function(ue) {
            for (var le = 0, oe = ne.length; le < oe; ) {
              if (ne[le]._name === ue || ne[le].mn === ue || ne[le].propertyIndex === ue || ne[le].ix === ue || ne[le].ind === ue) return ne[le];
              le += 1;
            }
            return typeof ue == "number" ? ne[ue - 1] : null;
          };
          re.propertyGroup = propertyGroupFactory(re, te), ne = t(J.it, ee.it, re.propertyGroup), re.numProperties = ne.length;
          var ie = c(J.it[J.it.length - 1], ee.it[ee.it.length - 1], re.propertyGroup);
          return re.transform = ie, re.propertyIndex = J.cix, re._name = J.nm, re;
        })($, Y, W.propertyGroup), K = c($.it[$.it.length - 1], Y.it[Y.it.length - 1], W.propertyGroup);
        return W.content = X, W.transform = K, Object.defineProperty(W, "_name", { get: function() {
          return $.nm;
        } }), W.numProperties = $.np, W.propertyIndex = $.ix, W.nm = $.nm, W.mn = $.mn, W;
      }
      function n($, Y, G) {
        function W(X) {
          return X === "Color" || X === "color" ? W.color : X === "Opacity" || X === "opacity" ? W.opacity : null;
        }
        return Object.defineProperties(W, { color: { get: ExpressionPropertyInterface(Y.c) }, opacity: { get: ExpressionPropertyInterface(Y.o) }, _name: { value: $.nm }, mn: { value: $.mn } }), Y.c.setGroupProperty(PropertyInterface("Color", G)), Y.o.setGroupProperty(PropertyInterface("Opacity", G)), W;
      }
      function a($, Y, G) {
        function W(X) {
          return X === "Start Point" || X === "start point" ? W.startPoint : X === "End Point" || X === "end point" ? W.endPoint : X === "Opacity" || X === "opacity" ? W.opacity : null;
        }
        return Object.defineProperties(W, { startPoint: { get: ExpressionPropertyInterface(Y.s) }, endPoint: { get: ExpressionPropertyInterface(Y.e) }, opacity: { get: ExpressionPropertyInterface(Y.o) }, type: { get: function() {
          return "a";
        } }, _name: { value: $.nm }, mn: { value: $.mn } }), Y.s.setGroupProperty(PropertyInterface("Start Point", G)), Y.e.setGroupProperty(PropertyInterface("End Point", G)), Y.o.setGroupProperty(PropertyInterface("Opacity", G)), W;
      }
      function s() {
        return function() {
          return null;
        };
      }
      function o($, Y, G) {
        var W, X = propertyGroupFactory(ne, G), K = propertyGroupFactory(te, X);
        function J(re) {
          Object.defineProperty(te, $.d[re].nm, { get: ExpressionPropertyInterface(Y.d.dataProps[re].p) });
        }
        var ee = $.d ? $.d.length : 0, te = {};
        for (W = 0; W < ee; W += 1) J(W), Y.d.dataProps[W].p.setGroupProperty(K);
        function ne(re) {
          return re === "Color" || re === "color" ? ne.color : re === "Opacity" || re === "opacity" ? ne.opacity : re === "Stroke Width" || re === "stroke width" ? ne.strokeWidth : null;
        }
        return Object.defineProperties(ne, { color: { get: ExpressionPropertyInterface(Y.c) }, opacity: { get: ExpressionPropertyInterface(Y.o) }, strokeWidth: { get: ExpressionPropertyInterface(Y.w) }, dash: { get: function() {
          return te;
        } }, _name: { value: $.nm }, mn: { value: $.mn } }), Y.c.setGroupProperty(PropertyInterface("Color", X)), Y.o.setGroupProperty(PropertyInterface("Opacity", X)), Y.w.setGroupProperty(PropertyInterface("Stroke Width", X)), ne;
      }
      function l($, Y, G) {
        function W(K) {
          return K === $.e.ix || K === "End" || K === "end" ? W.end : K === $.s.ix ? W.start : K === $.o.ix ? W.offset : null;
        }
        var X = propertyGroupFactory(W, G);
        return W.propertyIndex = $.ix, Y.s.setGroupProperty(PropertyInterface("Start", X)), Y.e.setGroupProperty(PropertyInterface("End", X)), Y.o.setGroupProperty(PropertyInterface("Offset", X)), W.propertyIndex = $.ix, W.propertyGroup = G, Object.defineProperties(W, { start: { get: ExpressionPropertyInterface(Y.s) }, end: { get: ExpressionPropertyInterface(Y.e) }, offset: { get: ExpressionPropertyInterface(Y.o) }, _name: { value: $.nm } }), W.mn = $.mn, W;
      }
      function c($, Y, G) {
        function W(K) {
          return $.a.ix === K || K === "Anchor Point" ? W.anchorPoint : $.o.ix === K || K === "Opacity" ? W.opacity : $.p.ix === K || K === "Position" ? W.position : $.r.ix === K || K === "Rotation" || K === "ADBE Vector Rotation" ? W.rotation : $.s.ix === K || K === "Scale" ? W.scale : $.sk && $.sk.ix === K || K === "Skew" ? W.skew : $.sa && $.sa.ix === K || K === "Skew Axis" ? W.skewAxis : null;
        }
        var X = propertyGroupFactory(W, G);
        return Y.transform.mProps.o.setGroupProperty(PropertyInterface("Opacity", X)), Y.transform.mProps.p.setGroupProperty(PropertyInterface("Position", X)), Y.transform.mProps.a.setGroupProperty(PropertyInterface("Anchor Point", X)), Y.transform.mProps.s.setGroupProperty(PropertyInterface("Scale", X)), Y.transform.mProps.r.setGroupProperty(PropertyInterface("Rotation", X)), Y.transform.mProps.sk && (Y.transform.mProps.sk.setGroupProperty(PropertyInterface("Skew", X)), Y.transform.mProps.sa.setGroupProperty(PropertyInterface("Skew Angle", X))), Y.transform.op.setGroupProperty(PropertyInterface("Opacity", X)), Object.defineProperties(W, { opacity: { get: ExpressionPropertyInterface(Y.transform.mProps.o) }, position: { get: ExpressionPropertyInterface(Y.transform.mProps.p) }, anchorPoint: { get: ExpressionPropertyInterface(Y.transform.mProps.a) }, scale: { get: ExpressionPropertyInterface(Y.transform.mProps.s) }, rotation: { get: ExpressionPropertyInterface(Y.transform.mProps.r) }, skew: { get: ExpressionPropertyInterface(Y.transform.mProps.sk) }, skewAxis: { get: ExpressionPropertyInterface(Y.transform.mProps.sa) }, _name: { value: $.nm } }), W.ty = "tr", W.mn = $.mn, W.propertyGroup = G, W;
      }
      function x($, Y, G) {
        function W(J) {
          return $.p.ix === J ? W.position : $.s.ix === J ? W.size : null;
        }
        var X = propertyGroupFactory(W, G);
        W.propertyIndex = $.ix;
        var K = Y.sh.ty === "tm" ? Y.sh.prop : Y.sh;
        return K.s.setGroupProperty(PropertyInterface("Size", X)), K.p.setGroupProperty(PropertyInterface("Position", X)), Object.defineProperties(W, { size: { get: ExpressionPropertyInterface(K.s) }, position: { get: ExpressionPropertyInterface(K.p) }, _name: { value: $.nm } }), W.mn = $.mn, W;
      }
      function j($, Y, G) {
        function W(J) {
          return $.p.ix === J ? W.position : $.r.ix === J ? W.rotation : $.pt.ix === J ? W.points : $.or.ix === J || J === "ADBE Vector Star Outer Radius" ? W.outerRadius : $.os.ix === J ? W.outerRoundness : !$.ir || $.ir.ix !== J && J !== "ADBE Vector Star Inner Radius" ? $.is && $.is.ix === J ? W.innerRoundness : null : W.innerRadius;
        }
        var X = propertyGroupFactory(W, G), K = Y.sh.ty === "tm" ? Y.sh.prop : Y.sh;
        return W.propertyIndex = $.ix, K.or.setGroupProperty(PropertyInterface("Outer Radius", X)), K.os.setGroupProperty(PropertyInterface("Outer Roundness", X)), K.pt.setGroupProperty(PropertyInterface("Points", X)), K.p.setGroupProperty(PropertyInterface("Position", X)), K.r.setGroupProperty(PropertyInterface("Rotation", X)), $.ir && (K.ir.setGroupProperty(PropertyInterface("Inner Radius", X)), K.is.setGroupProperty(PropertyInterface("Inner Roundness", X))), Object.defineProperties(W, { position: { get: ExpressionPropertyInterface(K.p) }, rotation: { get: ExpressionPropertyInterface(K.r) }, points: { get: ExpressionPropertyInterface(K.pt) }, outerRadius: { get: ExpressionPropertyInterface(K.or) }, outerRoundness: { get: ExpressionPropertyInterface(K.os) }, innerRadius: { get: ExpressionPropertyInterface(K.ir) }, innerRoundness: { get: ExpressionPropertyInterface(K.is) }, _name: { value: $.nm } }), W.mn = $.mn, W;
      }
      function Z($, Y, G) {
        function W(J) {
          return $.p.ix === J ? W.position : $.r.ix === J ? W.roundness : $.s.ix === J || J === "Size" || J === "ADBE Vector Rect Size" ? W.size : null;
        }
        var X = propertyGroupFactory(W, G), K = Y.sh.ty === "tm" ? Y.sh.prop : Y.sh;
        return W.propertyIndex = $.ix, K.p.setGroupProperty(PropertyInterface("Position", X)), K.s.setGroupProperty(PropertyInterface("Size", X)), K.r.setGroupProperty(PropertyInterface("Rotation", X)), Object.defineProperties(W, { position: { get: ExpressionPropertyInterface(K.p) }, roundness: { get: ExpressionPropertyInterface(K.r) }, size: { get: ExpressionPropertyInterface(K.s) }, _name: { value: $.nm } }), W.mn = $.mn, W;
      }
      function V($, Y, G) {
        function W(J) {
          return $.r.ix === J || J === "Round Corners 1" ? W.radius : null;
        }
        var X = propertyGroupFactory(W, G), K = Y;
        return W.propertyIndex = $.ix, K.rd.setGroupProperty(PropertyInterface("Radius", X)), Object.defineProperties(W, { radius: { get: ExpressionPropertyInterface(K.rd) }, _name: { value: $.nm } }), W.mn = $.mn, W;
      }
      function U($, Y, G) {
        function W(J) {
          return $.c.ix === J || J === "Copies" ? W.copies : $.o.ix === J || J === "Offset" ? W.offset : null;
        }
        var X = propertyGroupFactory(W, G), K = Y;
        return W.propertyIndex = $.ix, K.c.setGroupProperty(PropertyInterface("Copies", X)), K.o.setGroupProperty(PropertyInterface("Offset", X)), Object.defineProperties(W, { copies: { get: ExpressionPropertyInterface(K.c) }, offset: { get: ExpressionPropertyInterface(K.o) }, _name: { value: $.nm } }), W.mn = $.mn, W;
      }
      return function($, Y, G) {
        var W;
        function X(K) {
          if (typeof K == "number") return (K = K === void 0 ? 1 : K) === 0 ? G : W[K - 1];
          for (var J = 0, ee = W.length; J < ee; ) {
            if (W[J]._name === K) return W[J];
            J += 1;
          }
          return null;
        }
        return X.propertyGroup = propertyGroupFactory(X, (function() {
          return G;
        })), W = t($, Y, X.propertyGroup), X.numProperties = W.length, X._name = "Contents", X;
      };
    })(), TextExpressionInterface = function(t) {
      var r;
      function n(a) {
        return a === "ADBE Text Document" ? n.sourceText : null;
      }
      return Object.defineProperty(n, "sourceText", { get: function() {
        t.textProperty.getValue();
        var a = t.textProperty.currentData.t;
        return r && a === r.value || ((r = new String(a)).value = a || new String(a), Object.defineProperty(r, "style", { get: function() {
          return { fillColor: t.textProperty.currentData.fc };
        } })), r;
      } }), n;
    };
    function _typeof(t) {
      return (_typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
        return typeof r;
      } : function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      })(t);
    }
    var FootageInterface = (dataInterfaceFactory = function(t) {
      function r(n) {
        return n === "Outline" ? r.outlineInterface() : null;
      }
      return r._name = "Outline", r.outlineInterface = (function(n) {
        var a = "", s = n.getFootageData();
        function o(l) {
          if (s[l]) return a = l, _typeof(s = s[l]) === "object" ? o : s;
          var c = l.indexOf(a);
          if (c !== -1) {
            var x = parseInt(l.substr(c + a.length), 10);
            return _typeof(s = s[x]) === "object" ? o : s;
          }
          return "";
        }
        return function() {
          return a = "", s = n.getFootageData(), o;
        };
      })(t), r;
    }, function(t) {
      function r(n) {
        return n === "Data" ? r.dataInterface : null;
      }
      return r._name = "Data", r.dataInterface = dataInterfaceFactory(t), r;
    }), dataInterfaceFactory, interfaces = { layer: LayerExpressionInterface, effects: EffectsExpressionInterface, comp: CompExpressionInterface, shape: ShapeExpressionInterface, text: TextExpressionInterface, footage: FootageInterface };
    function getInterface(t) {
      return interfaces[t] || null;
    }
    var expressionHelpers = { searchExpressions: function(t, r, n) {
      r.x && (n.k = !0, n.x = !0, n.initiateExpression = ExpressionManager.initiateExpression, n.effectsSequence.push(n.initiateExpression(t, r, n).bind(n)));
    }, getSpeedAtTime: function(t) {
      var r = this.getValueAtTime(t), n = this.getValueAtTime(t + -0.01), a = 0;
      if (r.length) {
        var s;
        for (s = 0; s < r.length; s += 1) a += Math.pow(n[s] - r[s], 2);
        a = 100 * Math.sqrt(a);
      } else a = 0;
      return a;
    }, getVelocityAtTime: function(t) {
      if (this.vel !== void 0) return this.vel;
      var r, n, a = this.getValueAtTime(t), s = this.getValueAtTime(t + -1e-3);
      if (a.length) for (r = createTypedArray("float32", a.length), n = 0; n < a.length; n += 1) r[n] = (s[n] - a[n]) / -1e-3;
      else r = (s - a) / -1e-3;
      return r;
    }, getValueAtTime: function(t) {
      return t *= this.elem.globalData.frameRate, (t -= this.offsetTime) !== this._cachingAtTime.lastFrame && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < t ? this._cachingAtTime.lastIndex : 0, this._cachingAtTime.value = this.interpolateValue(t, this._cachingAtTime), this._cachingAtTime.lastFrame = t), this._cachingAtTime.value;
    }, getStaticValueAtTime: function() {
      return this.pv;
    }, setGroupProperty: function(t) {
      this.propertyGroup = t;
    } };
    function addPropertyDecorator() {
      function t(V, U, $) {
        if (!this.k || !this.keyframes) return this.pv;
        V = V ? V.toLowerCase() : "";
        var Y, G, W, X, K, J = this.comp.renderedFrame, ee = this.keyframes, te = ee[ee.length - 1].t;
        if (J <= te) return this.pv;
        if ($ ? G = te - (Y = U ? Math.abs(te - this.elem.comp.globalData.frameRate * U) : Math.max(0, te - this.elem.data.ip)) : ((!U || U > ee.length - 1) && (U = ee.length - 1), Y = te - (G = ee[ee.length - 1 - U].t)), V === "pingpong") {
          if (Math.floor((J - G) / Y) % 2 != 0) return this.getValueAtTime((Y - (J - G) % Y + G) / this.comp.globalData.frameRate, 0);
        } else {
          if (V === "offset") {
            var ne = this.getValueAtTime(G / this.comp.globalData.frameRate, 0), re = this.getValueAtTime(te / this.comp.globalData.frameRate, 0), ie = this.getValueAtTime(((J - G) % Y + G) / this.comp.globalData.frameRate, 0), ue = Math.floor((J - G) / Y);
            if (this.pv.length) {
              for (X = (K = new Array(ne.length)).length, W = 0; W < X; W += 1) K[W] = (re[W] - ne[W]) * ue + ie[W];
              return K;
            }
            return (re - ne) * ue + ie;
          }
          if (V === "continue") {
            var le = this.getValueAtTime(te / this.comp.globalData.frameRate, 0), oe = this.getValueAtTime((te - 1e-3) / this.comp.globalData.frameRate, 0);
            if (this.pv.length) {
              for (X = (K = new Array(le.length)).length, W = 0; W < X; W += 1) K[W] = le[W] + (le[W] - oe[W]) * ((J - te) / this.comp.globalData.frameRate) / 5e-4;
              return K;
            }
            return le + (J - te) / 1e-3 * (le - oe);
          }
        }
        return this.getValueAtTime(((J - G) % Y + G) / this.comp.globalData.frameRate, 0);
      }
      function r(V, U, $) {
        if (!this.k) return this.pv;
        V = V ? V.toLowerCase() : "";
        var Y, G, W, X, K, J = this.comp.renderedFrame, ee = this.keyframes, te = ee[0].t;
        if (J >= te) return this.pv;
        if ($ ? G = te + (Y = U ? Math.abs(this.elem.comp.globalData.frameRate * U) : Math.max(0, this.elem.data.op - te)) : ((!U || U > ee.length - 1) && (U = ee.length - 1), Y = (G = ee[U].t) - te), V === "pingpong") {
          if (Math.floor((te - J) / Y) % 2 == 0) return this.getValueAtTime(((te - J) % Y + te) / this.comp.globalData.frameRate, 0);
        } else {
          if (V === "offset") {
            var ne = this.getValueAtTime(te / this.comp.globalData.frameRate, 0), re = this.getValueAtTime(G / this.comp.globalData.frameRate, 0), ie = this.getValueAtTime((Y - (te - J) % Y + te) / this.comp.globalData.frameRate, 0), ue = Math.floor((te - J) / Y) + 1;
            if (this.pv.length) {
              for (X = (K = new Array(ne.length)).length, W = 0; W < X; W += 1) K[W] = ie[W] - (re[W] - ne[W]) * ue;
              return K;
            }
            return ie - (re - ne) * ue;
          }
          if (V === "continue") {
            var le = this.getValueAtTime(te / this.comp.globalData.frameRate, 0), oe = this.getValueAtTime((te + 1e-3) / this.comp.globalData.frameRate, 0);
            if (this.pv.length) {
              for (X = (K = new Array(le.length)).length, W = 0; W < X; W += 1) K[W] = le[W] + (le[W] - oe[W]) * (te - J) / 1e-3;
              return K;
            }
            return le + (le - oe) * (te - J) / 1e-3;
          }
        }
        return this.getValueAtTime((Y - ((te - J) % Y + te)) / this.comp.globalData.frameRate, 0);
      }
      function n(V, U) {
        if (!this.k) return this.pv;
        if (V = 0.5 * (V || 0.4), (U = Math.floor(U || 5)) <= 1) return this.pv;
        var $, Y, G = this.comp.renderedFrame / this.comp.globalData.frameRate, W = G - V, X = U > 1 ? (G + V - W) / (U - 1) : 1, K = 0, J = 0;
        for ($ = this.pv.length ? createTypedArray("float32", this.pv.length) : 0; K < U; ) {
          if (Y = this.getValueAtTime(W + K * X), this.pv.length) for (J = 0; J < this.pv.length; J += 1) $[J] += Y[J];
          else $ += Y;
          K += 1;
        }
        if (this.pv.length) for (J = 0; J < this.pv.length; J += 1) $[J] /= U;
        else $ /= U;
        return $;
      }
      function a(V) {
        this._transformCachingAtTime || (this._transformCachingAtTime = { v: new Matrix() });
        var U = this._transformCachingAtTime.v;
        if (U.cloneFromProps(this.pre.props), this.appliedTransformations < 1) {
          var $ = this.a.getValueAtTime(V);
          U.translate(-$[0] * this.a.mult, -$[1] * this.a.mult, $[2] * this.a.mult);
        }
        if (this.appliedTransformations < 2) {
          var Y = this.s.getValueAtTime(V);
          U.scale(Y[0] * this.s.mult, Y[1] * this.s.mult, Y[2] * this.s.mult);
        }
        if (this.sk && this.appliedTransformations < 3) {
          var G = this.sk.getValueAtTime(V), W = this.sa.getValueAtTime(V);
          U.skewFromAxis(-G * this.sk.mult, W * this.sa.mult);
        }
        if (this.r && this.appliedTransformations < 4) {
          var X = this.r.getValueAtTime(V);
          U.rotate(-X * this.r.mult);
        } else if (!this.r && this.appliedTransformations < 4) {
          var K = this.rz.getValueAtTime(V), J = this.ry.getValueAtTime(V), ee = this.rx.getValueAtTime(V), te = this.or.getValueAtTime(V);
          U.rotateZ(-K * this.rz.mult).rotateY(J * this.ry.mult).rotateX(ee * this.rx.mult).rotateZ(-te[2] * this.or.mult).rotateY(te[1] * this.or.mult).rotateX(te[0] * this.or.mult);
        }
        if (this.data.p && this.data.p.s) {
          var ne = this.px.getValueAtTime(V), re = this.py.getValueAtTime(V);
          if (this.data.p.z) {
            var ie = this.pz.getValueAtTime(V);
            U.translate(ne * this.px.mult, re * this.py.mult, -ie * this.pz.mult);
          } else U.translate(ne * this.px.mult, re * this.py.mult, 0);
        } else {
          var ue = this.p.getValueAtTime(V);
          U.translate(ue[0] * this.p.mult, ue[1] * this.p.mult, -ue[2] * this.p.mult);
        }
        return U;
      }
      function s() {
        return this.v.clone(new Matrix());
      }
      var o = TransformPropertyFactory.getTransformProperty;
      TransformPropertyFactory.getTransformProperty = function(V, U, $) {
        var Y = o(V, U, $);
        return Y.dynamicProperties.length ? Y.getValueAtTime = a.bind(Y) : Y.getValueAtTime = s.bind(Y), Y.setGroupProperty = expressionHelpers.setGroupProperty, Y;
      };
      var l = PropertyFactory.getProp;
      PropertyFactory.getProp = function(V, U, $, Y, G) {
        var W = l(V, U, $, Y, G);
        W.kf ? W.getValueAtTime = expressionHelpers.getValueAtTime.bind(W) : W.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(W), W.setGroupProperty = expressionHelpers.setGroupProperty, W.loopOut = t, W.loopIn = r, W.smooth = n, W.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(W), W.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(W), W.numKeys = U.a === 1 ? U.k.length : 0, W.propertyIndex = U.ix;
        var X = 0;
        return $ !== 0 && (X = createTypedArray("float32", U.a === 1 ? U.k[0].s.length : U.k.length)), W._cachingAtTime = { lastFrame: initialDefaultFrame, lastIndex: 0, value: X }, expressionHelpers.searchExpressions(V, U, W), W.k && G.addDynamicProperty(W), W;
      };
      var c = ShapePropertyFactory.getConstructorFunction(), x = ShapePropertyFactory.getKeyframedConstructorFunction();
      function j() {
      }
      j.prototype = { vertices: function(V, U) {
        this.k && this.getValue();
        var $, Y = this.v;
        U !== void 0 && (Y = this.getValueAtTime(U, 0));
        var G = Y._length, W = Y[V], X = Y.v, K = createSizedArray(G);
        for ($ = 0; $ < G; $ += 1) K[$] = V === "i" || V === "o" ? [W[$][0] - X[$][0], W[$][1] - X[$][1]] : [W[$][0], W[$][1]];
        return K;
      }, points: function(V) {
        return this.vertices("v", V);
      }, inTangents: function(V) {
        return this.vertices("i", V);
      }, outTangents: function(V) {
        return this.vertices("o", V);
      }, isClosed: function() {
        return this.v.c;
      }, pointOnPath: function(V, U) {
        var $ = this.v;
        U !== void 0 && ($ = this.getValueAtTime(U, 0)), this._segmentsLength || (this._segmentsLength = bez.getSegmentsLength($));
        for (var Y, G = this._segmentsLength, W = G.lengths, X = G.totalLength * V, K = 0, J = W.length, ee = 0; K < J; ) {
          if (ee + W[K].addedLength > X) {
            var te = K, ne = $.c && K === J - 1 ? 0 : K + 1, re = (X - ee) / W[K].addedLength;
            Y = bez.getPointInSegment($.v[te], $.v[ne], $.o[te], $.i[ne], re, W[K]);
            break;
          }
          ee += W[K].addedLength, K += 1;
        }
        return Y || (Y = $.c ? [$.v[0][0], $.v[0][1]] : [$.v[$._length - 1][0], $.v[$._length - 1][1]]), Y;
      }, vectorOnPath: function(V, U, $) {
        V == 1 ? V = this.v.c : V == 0 && (V = 0.999);
        var Y = this.pointOnPath(V, U), G = this.pointOnPath(V + 1e-3, U), W = G[0] - Y[0], X = G[1] - Y[1], K = Math.sqrt(Math.pow(W, 2) + Math.pow(X, 2));
        return K === 0 ? [0, 0] : $ === "tangent" ? [W / K, X / K] : [-X / K, W / K];
      }, tangentOnPath: function(V, U) {
        return this.vectorOnPath(V, U, "tangent");
      }, normalOnPath: function(V, U) {
        return this.vectorOnPath(V, U, "normal");
      }, setGroupProperty: expressionHelpers.setGroupProperty, getValueAtTime: expressionHelpers.getStaticValueAtTime }, extendPrototype([j], c), extendPrototype([j], x), x.prototype.getValueAtTime = function(V) {
        return this._cachingAtTime || (this._cachingAtTime = { shapeValue: shapePool.clone(this.pv), lastIndex: 0, lastTime: initialDefaultFrame }), V *= this.elem.globalData.frameRate, (V -= this.offsetTime) !== this._cachingAtTime.lastTime && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < V ? this._caching.lastIndex : 0, this._cachingAtTime.lastTime = V, this.interpolateShape(V, this._cachingAtTime.shapeValue, this._cachingAtTime)), this._cachingAtTime.shapeValue;
      }, x.prototype.initiateExpression = ExpressionManager.initiateExpression;
      var Z = ShapePropertyFactory.getShapeProp;
      ShapePropertyFactory.getShapeProp = function(V, U, $, Y, G) {
        var W = Z(V, U, $, Y, G);
        return W.propertyIndex = U.ix, W.lock = !1, $ === 3 ? expressionHelpers.searchExpressions(V, U.pt, W) : $ === 4 && expressionHelpers.searchExpressions(V, U.ks, W), W.k && V.addDynamicProperty(W), W;
      };
    }
    function initialize$1() {
      addPropertyDecorator();
    }
    function addDecorator() {
      TextProperty.prototype.getExpressionValue = function(t, r) {
        var n = this.calculateExpression(r);
        if (t.t !== n) {
          var a = {};
          return this.copyData(a, t), a.t = n.toString(), a.__complete = !1, a;
        }
        return t;
      }, TextProperty.prototype.searchProperty = function() {
        var t = this.searchKeyframes(), r = this.searchExpressions();
        return this.kf = t || r, this.kf;
      }, TextProperty.prototype.searchExpressions = function() {
        return this.data.d.x ? (this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this), this.addEffect(this.getExpressionValue.bind(this)), !0) : null;
      };
    }
    function initialize() {
      addDecorator();
    }
    function SVGComposableEffect() {
    }
    SVGComposableEffect.prototype = { createMergeNode: function(t, r) {
      var n, a, s = createNS("feMerge");
      for (s.setAttribute("result", t), a = 0; a < r.length; a += 1) (n = createNS("feMergeNode")).setAttribute("in", r[a]), s.appendChild(n), s.appendChild(n);
      return s;
    } };
    var linearFilterValue = "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0";
    function SVGTintFilter(t, r, n, a, s) {
      this.filterManager = r;
      var o = createNS("feColorMatrix");
      o.setAttribute("type", "matrix"), o.setAttribute("color-interpolation-filters", "linearRGB"), o.setAttribute("values", linearFilterValue + " 1 0"), this.linearFilter = o, o.setAttribute("result", a + "_tint_1"), t.appendChild(o), (o = createNS("feColorMatrix")).setAttribute("type", "matrix"), o.setAttribute("color-interpolation-filters", "sRGB"), o.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), o.setAttribute("result", a + "_tint_2"), t.appendChild(o), this.matrixFilter = o;
      var l = this.createMergeNode(a, [s, a + "_tint_1", a + "_tint_2"]);
      t.appendChild(l);
    }
    function SVGFillFilter(t, r, n, a) {
      this.filterManager = r;
      var s = createNS("feColorMatrix");
      s.setAttribute("type", "matrix"), s.setAttribute("color-interpolation-filters", "sRGB"), s.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), s.setAttribute("result", a), t.appendChild(s), this.matrixFilter = s;
    }
    function SVGStrokeEffect(t, r, n) {
      this.initialized = !1, this.filterManager = r, this.elem = n, this.paths = [];
    }
    function SVGTritoneFilter(t, r, n, a) {
      this.filterManager = r;
      var s = createNS("feColorMatrix");
      s.setAttribute("type", "matrix"), s.setAttribute("color-interpolation-filters", "linearRGB"), s.setAttribute("values", "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"), t.appendChild(s);
      var o = createNS("feComponentTransfer");
      o.setAttribute("color-interpolation-filters", "sRGB"), o.setAttribute("result", a), this.matrixFilter = o;
      var l = createNS("feFuncR");
      l.setAttribute("type", "table"), o.appendChild(l), this.feFuncR = l;
      var c = createNS("feFuncG");
      c.setAttribute("type", "table"), o.appendChild(c), this.feFuncG = c;
      var x = createNS("feFuncB");
      x.setAttribute("type", "table"), o.appendChild(x), this.feFuncB = x, t.appendChild(o);
    }
    function SVGProLevelsFilter(t, r, n, a) {
      this.filterManager = r;
      var s = this.filterManager.effectElements, o = createNS("feComponentTransfer");
      (s[10].p.k || s[10].p.v !== 0 || s[11].p.k || s[11].p.v !== 1 || s[12].p.k || s[12].p.v !== 1 || s[13].p.k || s[13].p.v !== 0 || s[14].p.k || s[14].p.v !== 1) && (this.feFuncR = this.createFeFunc("feFuncR", o)), (s[17].p.k || s[17].p.v !== 0 || s[18].p.k || s[18].p.v !== 1 || s[19].p.k || s[19].p.v !== 1 || s[20].p.k || s[20].p.v !== 0 || s[21].p.k || s[21].p.v !== 1) && (this.feFuncG = this.createFeFunc("feFuncG", o)), (s[24].p.k || s[24].p.v !== 0 || s[25].p.k || s[25].p.v !== 1 || s[26].p.k || s[26].p.v !== 1 || s[27].p.k || s[27].p.v !== 0 || s[28].p.k || s[28].p.v !== 1) && (this.feFuncB = this.createFeFunc("feFuncB", o)), (s[31].p.k || s[31].p.v !== 0 || s[32].p.k || s[32].p.v !== 1 || s[33].p.k || s[33].p.v !== 1 || s[34].p.k || s[34].p.v !== 0 || s[35].p.k || s[35].p.v !== 1) && (this.feFuncA = this.createFeFunc("feFuncA", o)), (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) && (o.setAttribute("color-interpolation-filters", "sRGB"), t.appendChild(o)), (s[3].p.k || s[3].p.v !== 0 || s[4].p.k || s[4].p.v !== 1 || s[5].p.k || s[5].p.v !== 1 || s[6].p.k || s[6].p.v !== 0 || s[7].p.k || s[7].p.v !== 1) && ((o = createNS("feComponentTransfer")).setAttribute("color-interpolation-filters", "sRGB"), o.setAttribute("result", a), t.appendChild(o), this.feFuncRComposed = this.createFeFunc("feFuncR", o), this.feFuncGComposed = this.createFeFunc("feFuncG", o), this.feFuncBComposed = this.createFeFunc("feFuncB", o));
    }
    function SVGDropShadowEffect(t, r, n, a, s) {
      var o = r.container.globalData.renderConfig.filterSize, l = r.data.fs || o;
      t.setAttribute("x", l.x || o.x), t.setAttribute("y", l.y || o.y), t.setAttribute("width", l.width || o.width), t.setAttribute("height", l.height || o.height), this.filterManager = r;
      var c = createNS("feGaussianBlur");
      c.setAttribute("in", "SourceAlpha"), c.setAttribute("result", a + "_drop_shadow_1"), c.setAttribute("stdDeviation", "0"), this.feGaussianBlur = c, t.appendChild(c);
      var x = createNS("feOffset");
      x.setAttribute("dx", "25"), x.setAttribute("dy", "0"), x.setAttribute("in", a + "_drop_shadow_1"), x.setAttribute("result", a + "_drop_shadow_2"), this.feOffset = x, t.appendChild(x);
      var j = createNS("feFlood");
      j.setAttribute("flood-color", "#00ff00"), j.setAttribute("flood-opacity", "1"), j.setAttribute("result", a + "_drop_shadow_3"), this.feFlood = j, t.appendChild(j);
      var Z = createNS("feComposite");
      Z.setAttribute("in", a + "_drop_shadow_3"), Z.setAttribute("in2", a + "_drop_shadow_2"), Z.setAttribute("operator", "in"), Z.setAttribute("result", a + "_drop_shadow_4"), t.appendChild(Z);
      var V = this.createMergeNode(a, [a + "_drop_shadow_4", s]);
      t.appendChild(V);
    }
    extendPrototype([SVGComposableEffect], SVGTintFilter), SVGTintFilter.prototype.renderFrame = function(t) {
      if (t || this.filterManager._mdf) {
        var r = this.filterManager.effectElements[0].p.v, n = this.filterManager.effectElements[1].p.v, a = this.filterManager.effectElements[2].p.v / 100;
        this.linearFilter.setAttribute("values", linearFilterValue + " " + a + " 0"), this.matrixFilter.setAttribute("values", n[0] - r[0] + " 0 0 0 " + r[0] + " " + (n[1] - r[1]) + " 0 0 0 " + r[1] + " " + (n[2] - r[2]) + " 0 0 0 " + r[2] + " 0 0 0 1 0");
      }
    }, SVGFillFilter.prototype.renderFrame = function(t) {
      if (t || this.filterManager._mdf) {
        var r = this.filterManager.effectElements[2].p.v, n = this.filterManager.effectElements[6].p.v;
        this.matrixFilter.setAttribute("values", "0 0 0 0 " + r[0] + " 0 0 0 0 " + r[1] + " 0 0 0 0 " + r[2] + " 0 0 0 " + n + " 0");
      }
    }, SVGStrokeEffect.prototype.initialize = function() {
      var t, r, n, a, s = this.elem.layerElement.children || this.elem.layerElement.childNodes;
      for (this.filterManager.effectElements[1].p.v === 1 ? (a = this.elem.maskManager.masksProperties.length, n = 0) : a = (n = this.filterManager.effectElements[0].p.v - 1) + 1, (r = createNS("g")).setAttribute("fill", "none"), r.setAttribute("stroke-linecap", "round"), r.setAttribute("stroke-dashoffset", 1); n < a; n += 1) t = createNS("path"), r.appendChild(t), this.paths.push({ p: t, m: n });
      if (this.filterManager.effectElements[10].p.v === 3) {
        var o = createNS("mask"), l = createElementID();
        o.setAttribute("id", l), o.setAttribute("mask-type", "alpha"), o.appendChild(r), this.elem.globalData.defs.appendChild(o);
        var c = createNS("g");
        for (c.setAttribute("mask", "url(" + getLocationHref() + "#" + l + ")"); s[0]; ) c.appendChild(s[0]);
        this.elem.layerElement.appendChild(c), this.masker = o, r.setAttribute("stroke", "#fff");
      } else if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
        if (this.filterManager.effectElements[10].p.v === 2) for (s = this.elem.layerElement.children || this.elem.layerElement.childNodes; s.length; ) this.elem.layerElement.removeChild(s[0]);
        this.elem.layerElement.appendChild(r), this.elem.layerElement.removeAttribute("mask"), r.setAttribute("stroke", "#fff");
      }
      this.initialized = !0, this.pathMasker = r;
    }, SVGStrokeEffect.prototype.renderFrame = function(t) {
      var r;
      this.initialized || this.initialize();
      var n, a, s = this.paths.length;
      for (r = 0; r < s; r += 1) if (this.paths[r].m !== -1 && (n = this.elem.maskManager.viewData[this.paths[r].m], a = this.paths[r].p, (t || this.filterManager._mdf || n.prop._mdf) && a.setAttribute("d", n.lastPath), t || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || n.prop._mdf)) {
        var o;
        if (this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100) {
          var l = 0.01 * Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v), c = 0.01 * Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v), x = a.getTotalLength();
          o = "0 0 0 " + x * l + " ";
          var j, Z = x * (c - l), V = 1 + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * 0.01, U = Math.floor(Z / V);
          for (j = 0; j < U; j += 1) o += "1 " + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * 0.01 + " ";
          o += "0 " + 10 * x + " 0 0";
        } else o = "1 " + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * 0.01;
        a.setAttribute("stroke-dasharray", o);
      }
      if ((t || this.filterManager.effectElements[4].p._mdf) && this.pathMasker.setAttribute("stroke-width", 2 * this.filterManager.effectElements[4].p.v), (t || this.filterManager.effectElements[6].p._mdf) && this.pathMasker.setAttribute("opacity", this.filterManager.effectElements[6].p.v), (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) && (t || this.filterManager.effectElements[3].p._mdf)) {
        var $ = this.filterManager.effectElements[3].p.v;
        this.pathMasker.setAttribute("stroke", "rgb(" + bmFloor(255 * $[0]) + "," + bmFloor(255 * $[1]) + "," + bmFloor(255 * $[2]) + ")");
      }
    }, SVGTritoneFilter.prototype.renderFrame = function(t) {
      if (t || this.filterManager._mdf) {
        var r = this.filterManager.effectElements[0].p.v, n = this.filterManager.effectElements[1].p.v, a = this.filterManager.effectElements[2].p.v, s = a[0] + " " + n[0] + " " + r[0], o = a[1] + " " + n[1] + " " + r[1], l = a[2] + " " + n[2] + " " + r[2];
        this.feFuncR.setAttribute("tableValues", s), this.feFuncG.setAttribute("tableValues", o), this.feFuncB.setAttribute("tableValues", l);
      }
    }, SVGProLevelsFilter.prototype.createFeFunc = function(t, r) {
      var n = createNS(t);
      return n.setAttribute("type", "table"), r.appendChild(n), n;
    }, SVGProLevelsFilter.prototype.getTableValue = function(t, r, n, a, s) {
      for (var o, l, c = 0, x = Math.min(t, r), j = Math.max(t, r), Z = Array.call(null, { length: 256 }), V = 0, U = s - a, $ = r - t; c <= 256; ) l = (o = c / 256) <= x ? $ < 0 ? s : a : o >= j ? $ < 0 ? a : s : a + U * Math.pow((o - t) / $, 1 / n), Z[V] = l, V += 1, c += 256 / 255;
      return Z.join(" ");
    }, SVGProLevelsFilter.prototype.renderFrame = function(t) {
      if (t || this.filterManager._mdf) {
        var r, n = this.filterManager.effectElements;
        this.feFuncRComposed && (t || n[3].p._mdf || n[4].p._mdf || n[5].p._mdf || n[6].p._mdf || n[7].p._mdf) && (r = this.getTableValue(n[3].p.v, n[4].p.v, n[5].p.v, n[6].p.v, n[7].p.v), this.feFuncRComposed.setAttribute("tableValues", r), this.feFuncGComposed.setAttribute("tableValues", r), this.feFuncBComposed.setAttribute("tableValues", r)), this.feFuncR && (t || n[10].p._mdf || n[11].p._mdf || n[12].p._mdf || n[13].p._mdf || n[14].p._mdf) && (r = this.getTableValue(n[10].p.v, n[11].p.v, n[12].p.v, n[13].p.v, n[14].p.v), this.feFuncR.setAttribute("tableValues", r)), this.feFuncG && (t || n[17].p._mdf || n[18].p._mdf || n[19].p._mdf || n[20].p._mdf || n[21].p._mdf) && (r = this.getTableValue(n[17].p.v, n[18].p.v, n[19].p.v, n[20].p.v, n[21].p.v), this.feFuncG.setAttribute("tableValues", r)), this.feFuncB && (t || n[24].p._mdf || n[25].p._mdf || n[26].p._mdf || n[27].p._mdf || n[28].p._mdf) && (r = this.getTableValue(n[24].p.v, n[25].p.v, n[26].p.v, n[27].p.v, n[28].p.v), this.feFuncB.setAttribute("tableValues", r)), this.feFuncA && (t || n[31].p._mdf || n[32].p._mdf || n[33].p._mdf || n[34].p._mdf || n[35].p._mdf) && (r = this.getTableValue(n[31].p.v, n[32].p.v, n[33].p.v, n[34].p.v, n[35].p.v), this.feFuncA.setAttribute("tableValues", r));
      }
    }, extendPrototype([SVGComposableEffect], SVGDropShadowEffect), SVGDropShadowEffect.prototype.renderFrame = function(t) {
      if (t || this.filterManager._mdf) {
        if ((t || this.filterManager.effectElements[4].p._mdf) && this.feGaussianBlur.setAttribute("stdDeviation", this.filterManager.effectElements[4].p.v / 4), t || this.filterManager.effectElements[0].p._mdf) {
          var r = this.filterManager.effectElements[0].p.v;
          this.feFlood.setAttribute("flood-color", rgbToHex(Math.round(255 * r[0]), Math.round(255 * r[1]), Math.round(255 * r[2])));
        }
        if ((t || this.filterManager.effectElements[1].p._mdf) && this.feFlood.setAttribute("flood-opacity", this.filterManager.effectElements[1].p.v / 255), t || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
          var n = this.filterManager.effectElements[3].p.v, a = (this.filterManager.effectElements[2].p.v - 90) * degToRads, s = n * Math.cos(a), o = n * Math.sin(a);
          this.feOffset.setAttribute("dx", s), this.feOffset.setAttribute("dy", o);
        }
      }
    };
    var _svgMatteSymbols = [];
    function SVGMatte3Effect(t, r, n) {
      this.initialized = !1, this.filterManager = r, this.filterElem = t, this.elem = n, n.matteElement = createNS("g"), n.matteElement.appendChild(n.layerElement), n.matteElement.appendChild(n.transformedElement), n.baseElement = n.matteElement;
    }
    function SVGGaussianBlurEffect(t, r, n, a) {
      t.setAttribute("x", "-100%"), t.setAttribute("y", "-100%"), t.setAttribute("width", "300%"), t.setAttribute("height", "300%"), this.filterManager = r;
      var s = createNS("feGaussianBlur");
      s.setAttribute("result", a), t.appendChild(s), this.feGaussianBlur = s;
    }
    function TransformEffect() {
    }
    function SVGTransformEffect(t, r) {
      this.init(r);
    }
    function CVTransformEffect(t) {
      this.init(t);
    }
    return SVGMatte3Effect.prototype.findSymbol = function(t) {
      for (var r = 0, n = _svgMatteSymbols.length; r < n; ) {
        if (_svgMatteSymbols[r] === t) return _svgMatteSymbols[r];
        r += 1;
      }
      return null;
    }, SVGMatte3Effect.prototype.replaceInParent = function(t, r) {
      var n = t.layerElement.parentNode;
      if (n) {
        for (var a, s = n.children, o = 0, l = s.length; o < l && s[o] !== t.layerElement; ) o += 1;
        o <= l - 2 && (a = s[o + 1]);
        var c = createNS("use");
        c.setAttribute("href", "#" + r), a ? n.insertBefore(c, a) : n.appendChild(c);
      }
    }, SVGMatte3Effect.prototype.setElementAsMask = function(t, r) {
      if (!this.findSymbol(r)) {
        var n = createElementID(), a = createNS("mask");
        a.setAttribute("id", r.layerId), a.setAttribute("mask-type", "alpha"), _svgMatteSymbols.push(r);
        var s = t.globalData.defs;
        s.appendChild(a);
        var o = createNS("symbol");
        o.setAttribute("id", n), this.replaceInParent(r, n), o.appendChild(r.layerElement), s.appendChild(o);
        var l = createNS("use");
        l.setAttribute("href", "#" + n), a.appendChild(l), r.data.hd = !1, r.show();
      }
      t.setMatte(r.layerId);
    }, SVGMatte3Effect.prototype.initialize = function() {
      for (var t = this.filterManager.effectElements[0].p.v, r = this.elem.comp.elements, n = 0, a = r.length; n < a; ) r[n] && r[n].data.ind === t && this.setElementAsMask(this.elem, r[n]), n += 1;
      this.initialized = !0;
    }, SVGMatte3Effect.prototype.renderFrame = function() {
      this.initialized || this.initialize();
    }, SVGGaussianBlurEffect.prototype.renderFrame = function(t) {
      if (t || this.filterManager._mdf) {
        var r = 0.3 * this.filterManager.effectElements[0].p.v, n = this.filterManager.effectElements[1].p.v, a = n == 3 ? 0 : r, s = n == 2 ? 0 : r;
        this.feGaussianBlur.setAttribute("stdDeviation", a + " " + s);
        var o = this.filterManager.effectElements[2].p.v == 1 ? "wrap" : "duplicate";
        this.feGaussianBlur.setAttribute("edgeMode", o);
      }
    }, TransformEffect.prototype.init = function(t) {
      this.effectsManager = t, this.type = effectTypes.TRANSFORM_EFFECT, this.matrix = new Matrix(), this.opacity = -1, this._mdf = !1, this._opMdf = !1;
    }, TransformEffect.prototype.renderFrame = function(t) {
      if (this._opMdf = !1, this._mdf = !1, t || this.effectsManager._mdf) {
        var r = this.effectsManager.effectElements, n = r[0].p.v, a = r[1].p.v, s = r[2].p.v === 1, o = r[3].p.v, l = s ? o : r[4].p.v, c = r[5].p.v, x = r[6].p.v, j = r[7].p.v;
        this.matrix.reset(), this.matrix.translate(-n[0], -n[1], n[2]), this.matrix.scale(0.01 * l, 0.01 * o, 1), this.matrix.rotate(-j * degToRads), this.matrix.skewFromAxis(-c * degToRads, (x + 90) * degToRads), this.matrix.translate(a[0], a[1], 0), this._mdf = !0, this.opacity !== r[8].p.v && (this.opacity = r[8].p.v, this._opMdf = !0);
      }
    }, extendPrototype([TransformEffect], SVGTransformEffect), extendPrototype([TransformEffect], CVTransformEffect), registerRenderer("canvas", CanvasRenderer), registerRenderer("html", HybridRenderer), registerRenderer("svg", SVGRenderer), ShapeModifiers.registerModifier("tm", TrimModifier), ShapeModifiers.registerModifier("pb", PuckerAndBloatModifier), ShapeModifiers.registerModifier("rp", RepeaterModifier), ShapeModifiers.registerModifier("rd", RoundCornersModifier), ShapeModifiers.registerModifier("zz", ZigZagModifier), ShapeModifiers.registerModifier("op", OffsetPathModifier), setExpressionsPlugin(Expressions), setExpressionInterfaces(getInterface), initialize$1(), initialize(), registerEffect$1(20, SVGTintFilter, !0), registerEffect$1(21, SVGFillFilter, !0), registerEffect$1(22, SVGStrokeEffect, !1), registerEffect$1(23, SVGTritoneFilter, !0), registerEffect$1(24, SVGProLevelsFilter, !0), registerEffect$1(25, SVGDropShadowEffect, !0), registerEffect$1(28, SVGMatte3Effect, !1), registerEffect$1(29, SVGGaussianBlurEffect, !0), registerEffect$1(35, SVGTransformEffect, !1), registerEffect(35, CVTransformEffect), lottie;
  }));
})), REACT_LOTTIE_PLAYER_VERSION = "3.6.0", LOTTIE_WEB_VERSION = "^5.12.2", PlayerState, PlayerEvent;
function parseSrc(t) {
  if (typeof t == "object") return t;
  try {
    return JSON.parse(t);
  } catch {
  }
  try {
    return new URL(t).toString();
  } catch {
  }
  return t;
}
(function(t) {
  t.Loading = "loading", t.Playing = "playing", t.Paused = "paused", t.Stopped = "stopped", t.Frozen = "frozen", t.Error = "error";
})(PlayerState || (PlayerState = {})), (function(t) {
  t.Load = "load", t.InstanceSaved = "instanceSaved", t.Error = "error", t.Ready = "ready", t.Play = "play", t.Pause = "pause", t.Stop = "stop", t.Freeze = "freeze", t.Loop = "loop", t.Complete = "complete", t.Frame = "frame";
})(PlayerEvent || (PlayerEvent = {}));
var defaultOptions = { clearCanvas: !1, hideOnTransparent: !0, progressiveLoad: !0 }, Player = (function(t) {
  function r(n) {
    var a = t.call(this, n) || this;
    return a.container = null, a.unmounted = !1, a.handleBgChange = function(s) {
      a.setState({ background: s });
    }, a.triggerDownload = function(s, o) {
      var l = document.createElement("a");
      l.href = s, l.download = o, document.body.appendChild(l), l.click(), document.body.removeChild(l);
    }, a.snapshot = function(s) {
      var o;
      s === void 0 && (s = !0);
      var l = a.props.id ? a.props.id : "lottie", c = document.getElementById(l);
      if (a.props.renderer === "svg") {
        if (c) {
          var x = c.querySelector("svg");
          if (x) {
            var j = new XMLSerializer().serializeToString(x);
            o = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(j);
          }
        }
        s && a.triggerDownload(o, "snapshot.svg");
      } else if (a.props.renderer === "canvas") {
        if (c) {
          var Z = c.querySelector("canvas");
          Z && (o = Z.toDataURL("image/png"));
        }
        s && a.triggerDownload(o, "snapshot.png");
      }
      return o;
    }, typeof window != "undefined" && (window.lottie = lottie), a.state = { animationData: null, background: "transparent", containerRef: React.createRef(), debug: !0, instance: null, playerState: PlayerState.Loading, seeker: 0 }, a;
  }
  return __extends$1(r, t), r.getDerivedStateFromProps = function(n, a) {
    return __awaiter(this, void 0, void 0, (function() {
      return __generator(this, (function(s) {
        return n.background !== a.background ? [2, { background: n.background }] : [2, null];
      }));
    }));
  }, r.prototype.getVersions = function() {
    return { lottieWebVersion: LOTTIE_WEB_VERSION, lottiePlayerVersion: REACT_LOTTIE_PLAYER_VERSION };
  }, r.prototype.componentDidMount = function() {
    return __awaiter(this, void 0, void 0, (function() {
      return __generator(this, (function(n) {
        switch (n.label) {
          case 0:
            return this.unmounted ? [3, 2] : [4, this.createLottie()];
          case 1:
            n.sent(), n.label = 2;
          case 2:
            return [2];
        }
      }));
    }));
  }, r.prototype.componentWillUnmount = function() {
    this.unmounted = !0, this.state.instance && this.state.instance.destroy();
  }, r.prototype.componentDidUpdate = function(n) {
    return __awaiter(this, void 0, void 0, (function() {
      return __generator(this, (function(a) {
        switch (a.label) {
          case 0:
            return this.props.src === n.src ? [3, 2] : (this.state.instance && this.state.instance.destroy(), [4, this.createLottie()]);
          case 1:
            a.sent(), a.label = 2;
          case 2:
            return [2];
        }
      }));
    }));
  }, r.prototype.render = function() {
    var n = this, a = this.props, s = a.children, o = a.loop, l = a.style, c = a.onBackgroundChange, x = a.className, j = this.state, Z = j.animationData, V = j.instance, U = j.playerState, $ = j.seeker, Y = j.debug, G = j.background;
    return React.createElement("div", { className: "lf-player-container" }, this.state.playerState === PlayerState.Error ? React.createElement("div", { className: "lf-error" }, React.createElement("span", { "aria-label": "error-symbol", role: "img" }, "⚠️")) : React.createElement("div", { id: this.props.id ? this.props.id : "lottie", ref: function(W) {
      return n.container = W;
    }, style: __assign$1({ background: G, margin: "0 auto", outline: "none", overflow: "hidden" }, l), className: x }), React.Children.map(s, (function(W) {
      return React.isValidElement(W) ? React.cloneElement(W, { animationData: Z, background: G, debug: Y, instance: V, loop: o, pause: function() {
        return n.pause();
      }, play: function() {
        return n.play();
      }, playerState: U, seeker: $, setBackground: function(X) {
        n.setState({ background: X }), typeof c == "function" && c(X);
      }, setSeeker: function(X, K) {
        return n.setSeeker(X, K);
      }, stop: function() {
        return n.stop();
      }, toggleDebug: function() {
        return n.toggleDebug();
      }, setLoop: function(X) {
        return n.setLoop(X);
      }, colorChangedEvent: function(X) {
        n.handleBgChange(X);
      }, snapshot: function() {
        n.snapshot();
      } }) : null;
    })));
  }, r.prototype.toggleDebug = function() {
    this.setState({ debug: !this.state.debug });
  }, r.prototype.createLottie = function() {
    return __awaiter(this, void 0, void 0, (function() {
      var n, a, s, o, l, c, x, j, Z, V, U, $, Y, G, W = this;
      return __generator(this, (function(X) {
        switch (X.label) {
          case 0:
            if (n = this.props, a = n.autoplay, s = n.direction, o = n.loop, l = n.lottieRef, c = n.renderer, x = n.speed, j = n.src, Z = n.background, V = n.rendererSettings, U = n.hover, $ = this.state.instance, !j || !this.container) return [2];
            X.label = 1;
          case 1:
            return X.trys.push([1, 5, , 6]), typeof (Y = parseSrc(j)) != "string" ? [3, 4] : [4, fetch(Y).catch((function() {
              throw W.setState({ playerState: PlayerState.Error }), W.triggerEvent(PlayerEvent.Error), new Error("@LottieFiles/lottie-react: Animation data could not be fetched.");
            }))];
          case 2:
            return [4, X.sent().json().catch((function() {
              throw W.setState({ playerState: PlayerState.Error }), W.triggerEvent(PlayerEvent.Error), new Error("@LottieFiles/lottie-react: Animation data could not be fetched.");
            }))];
          case 3:
            Y = X.sent(), X.label = 4;
          case 4:
            return $ && $.destroy(), G = lottie.loadAnimation({ rendererSettings: V || defaultOptions, animationData: Y, autoplay: a || !1, container: this.container, loop: o || !1, renderer: c }), x && G.setSpeed(x), this.setState({ animationData: Y }), this.setState({ instance: G }, (function() {
              W.triggerEvent(PlayerEvent.InstanceSaved), typeof l == "function" && l(G), a && W.play();
            })), G.addEventListener("enterFrame", (function() {
              W.triggerEvent(PlayerEvent.Frame), W.setState({ seeker: Math.floor(G.currentFrame) });
            })), G.addEventListener("DOMLoaded", (function() {
              W.triggerEvent(PlayerEvent.Load);
            })), G.addEventListener("data_ready", (function() {
              W.triggerEvent(PlayerEvent.Ready);
            })), G.addEventListener("data_failed", (function() {
              W.setState({ playerState: PlayerState.Error }), W.triggerEvent(PlayerEvent.Error);
            })), G.addEventListener("loopComplete", (function() {
              W.triggerEvent(PlayerEvent.Loop);
            })), G.addEventListener("complete", (function() {
              W.triggerEvent(PlayerEvent.Complete), W.setState({ playerState: PlayerState.Paused }), W.props.keepLastFrame && !W.props.loop || W.setSeeker(0);
            })), this.container && (this.container.addEventListener("mouseenter", (function() {
              U && W.state.playerState !== PlayerState.Playing && (W.props.keepLastFrame && W.stop(), W.play());
            })), this.container.addEventListener("mouseleave", (function() {
              U && W.state.playerState === PlayerState.Playing && W.stop();
            }))), x && this.setPlayerSpeed(x), s && this.setPlayerDirection(s), Z && this.setState({ background: Z }), [3, 6];
          case 5:
            return X.sent(), this.setState({ playerState: PlayerState.Error }), this.triggerEvent(PlayerEvent.Error), [3, 6];
          case 6:
            return [2];
        }
      }));
    }));
  }, r.prototype.play = function() {
    var n = this.state.instance;
    n && (this.triggerEvent(PlayerEvent.Play), n.play(), this.setState({ playerState: PlayerState.Playing }));
  }, r.prototype.pause = function() {
    var n = this.state.instance;
    n && (this.triggerEvent(PlayerEvent.Pause), n.pause(), this.setState({ playerState: PlayerState.Paused }));
  }, r.prototype.stop = function() {
    var n = this.state.instance;
    n && (this.triggerEvent(PlayerEvent.Stop), n.stop(), this.setState({ playerState: PlayerState.Stopped }));
  }, r.prototype.setPlayerSpeed = function(n) {
    var a = this.state.instance;
    a && a.setSpeed(n);
  }, r.prototype.setPlayerDirection = function(n) {
    var a = this.state.instance;
    a && a.setDirection(n);
  }, r.prototype.setSeeker = function(n, a) {
    a === void 0 && (a = !1);
    var s = this.state, o = s.instance, l = s.playerState;
    o && (a && l === PlayerState.Playing ? o.goToAndPlay(n, !0) : (o.goToAndStop(n, !0), this.triggerEvent(PlayerEvent.Pause), this.setState({ playerState: PlayerState.Paused })));
  }, r.prototype.setLoop = function(n) {
    var a = this.state.instance;
    a && (a.loop = n, this.setState({ instance: a }));
  }, r.prototype.triggerEvent = function(n) {
    var a = this.props.onEvent;
    a && a(n);
  }, r.defaultProps = { loop: !1 }, r;
})(React.Component);
function styleInject(t, r) {
  r === void 0 && (r = {});
  var n = r.insertAt;
  if (typeof document != "undefined") {
    var a = document.head || document.getElementsByTagName("head")[0], s = document.createElement("style");
    s.type = "text/css", n === "top" && a.firstChild ? a.insertBefore(s, a.firstChild) : a.appendChild(s), s.styleSheet ? s.styleSheet.cssText = t : s.appendChild(document.createTextNode(t));
  }
}
var css_248z = `.lf-progress {
  -webkit-appearance: none;
  -moz-apperance: none;
  width: 100%;
  /* margin: 0 10px; */
  height: 4px;
  border-radius: 3px;
  cursor: pointer;
}
.lf-progress:focus {
  outline: none;
  border: none;
}
.lf-progress::-moz-range-track {
  cursor: pointer;
  background: none;
  border: none;
  outline: none;
}
.lf-progress::-webkit-slider-thumb {
  -webkit-appearance: none !important;
  height: 13px;
  width: 13px;
  border: 0;
  border-radius: 50%;
  background: #0fccce;
  cursor: pointer;
}
.lf-progress::-moz-range-thumb {
  -moz-appearance: none !important;
  height: 13px;
  width: 13px;
  border: 0;
  border-radius: 50%;
  background: #0fccce;
  cursor: pointer;
}
.lf-progress::-ms-track {
  width: 100%;
  height: 3px;
  cursor: pointer;
  background: transparent;
  border-color: transparent;
  color: transparent;
}
.lf-progress::-ms-fill-lower {
  background: #ccc;
  border-radius: 3px;
}
.lf-progress::-ms-fill-upper {
  background: #ccc;
  border-radius: 3px;
}
.lf-progress::-ms-thumb {
  border: 0;
  height: 15px;
  width: 15px;
  border-radius: 50%;
  background: #0fccce;
  cursor: pointer;
}
.lf-progress:focus::-ms-fill-lower {
  background: #ccc;
}
.lf-progress:focus::-ms-fill-upper {
  background: #ccc;
}
.lf-player-container :focus {
  outline: 0;
}
.lf-popover {
  position: relative;
}

.lf-popover-content {
  display: inline-block;
  position: absolute;
  opacity: 1;
  visibility: visible;
  transform: translate(0, -10px);
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
  transition: all 0.3s cubic-bezier(0.75, -0.02, 0.2, 0.97);
}

.lf-popover-content.hidden {
  opacity: 0;
  visibility: hidden;
  transform: translate(0, 0px);
}

.lf-player-btn-container {
  display: flex;
  align-items: center;
}
.lf-player-btn {
  cursor: pointer;
  fill: #999;
  width: 14px;
}

.lf-player-btn.active {
  fill: #555;
}

.lf-popover {
  position: relative;
}

.lf-popover-content {
  display: inline-block;
  position: absolute;
  background-color: #ffffff;
  opacity: 1;

  transform: translate(0, -10px);
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
  transition: all 0.3s cubic-bezier(0.75, -0.02, 0.2, 0.97);
  padding: 10px;
}

.lf-popover-content.hidden {
  opacity: 0;
  visibility: hidden;
  transform: translate(0, 0px);
}

.lf-arrow {
  position: absolute;
  z-index: -1;
  content: '';
  bottom: -9px;
  border-style: solid;
  border-width: 10px 10px 0px 10px;
}

.lf-left-align,
.lf-left-align .lfarrow {
  left: 0;
  right: unset;
}

.lf-right-align,
.lf-right-align .lf-arrow {
  right: 0;
  left: unset;
}

.lf-text-input {
  border: 1px #ccc solid;
  border-radius: 5px;
  padding: 3px;
  width: 60px;
  margin: 0;
}

.lf-color-picker {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 90px;
}

.lf-color-selectors {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.lf-color-component {
  display: flex;
  flex-direction: row;
  font-size: 12px;
  align-items: center;
  justify-content: center;
}

.lf-color-component strong {
  width: 40px;
}

.lf-color-component input[type='range'] {
  margin: 0 0 0 10px;
}

.lf-color-component input[type='number'] {
  width: 50px;
  margin: 0 0 0 10px;
}

.lf-color-preview {
  font-size: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding-left: 5px;
}

.lf-preview {
  height: 60px;
  width: 60px;
}

.lf-popover-snapshot {
  width: 150px;
}
.lf-popover-snapshot h5 {
  margin: 5px 0 10px 0;
  font-size: 0.75rem;
}
.lf-popover-snapshot a {
  display: block;
  text-decoration: none;
}
.lf-popover-snapshot a:before {
  content: '⥼';
  margin-right: 5px;
}
.lf-popover-snapshot .lf-note {
  display: block;
  margin-top: 10px;
  color: #999;
}
.lf-player-controls > div {
  margin-right: 5px;
  margin-left: 5px;
}
.lf-player-controls > div:first-child {
  margin-left: 0px;
}
.lf-player-controls > div:last-child {
  margin-right: 0px;
}
`;
styleInject(css_248z);
var ColorPicker = (function(t) {
  function r() {
    var n = t !== null && t.apply(this, arguments) || this;
    return n.state = { red: 0, green: 0, blue: 0, rgba: null, hex: "#000000", colorComponents: [] }, n.handleChange = function(a, s) {
      if (a === "r") {
        var o = "#" + (256 | s).toString(16).slice(1) + (256 | n.state.green).toString(16).slice(1) + (256 | n.state.blue).toString(16).slice(1);
        n.setState({ hex: o });
      } else a === "g" ? (o = "#" + (256 | n.state.red).toString(16).slice(1) + (256 | s).toString(16).slice(1) + (256 | n.state.blue).toString(16).slice(1), n.setState({ hex: o })) : a === "b" && (o = "#" + (256 | n.state.red).toString(16).slice(1) + (256 | n.state.green).toString(16).slice(1) + (256 | s).toString(16).slice(1), n.setState({ hex: o }));
    }, n.parseColor = function(a) {
      var s;
      if (typeof a == "string") {
        if (a[0] === "#") {
          var o = a.length === 4 ? [a.slice(1, 2), a.slice(2, 3), a.slice(3, 4)].map((function(l) {
            return parseInt("" + l + l, 16);
          })) : [a.slice(1, 3), a.slice(3, 5), a.slice(5, 7)].map((function(l) {
            return parseInt(l, 16);
          }));
          n.setState({ colorComponents: o });
        } else a.startsWith("rgb") && (o = (s = a.match(/\d+/g)) === null || s === void 0 ? void 0 : s.map((function(l) {
          return parseInt(l);
        }))) !== void 0 && n.setState({ colorComponents: o });
        n.state.colorComponents.length && (n.setState({ red: n.state.colorComponents[0] }), n.setState({ green: n.state.colorComponents[1] }), n.setState({ blue: n.state.colorComponents[2] }));
      }
    }, n;
  }
  return __extends$1(r, t), r.prototype.componentDidUpdate = function(n, a) {
    return this.props.colorChangedEvent && this.state.hex !== a.hex && this.props.colorChangedEvent(this.state.hex), !0;
  }, r.prototype.render = function() {
    var n = this;
    return React.createElement("div", { className: "lf-color-picker" }, React.createElement("div", { className: "lf-color-selectors" }, React.createElement("div", { className: "lf-color-component" }, React.createElement("strong", null, "Red"), React.createElement("input", { type: "range", min: "0", max: "255", value: this.state.red, onChange: function(a) {
      n.setState({ red: a.target.value }), n.handleChange("r", a.target.value);
    } }), React.createElement("input", { className: "lf-text-input", type: "number", min: "0", max: "255", value: this.state.red, onChange: function(a) {
      n.setState({ red: a.target.value }), n.handleChange("r", a.target.value);
    } })), React.createElement("div", { className: "lf-color-component" }, React.createElement("strong", null, "Green"), React.createElement("input", { type: "range", min: "0", max: "255", value: this.state.green, onChange: function(a) {
      n.setState({ green: a.target.value }), n.handleChange("g", a.target.value);
    } }), React.createElement("input", { className: "lf-text-input", type: "number", min: "0", max: "255", value: this.state.green, onChange: function(a) {
      n.setState({ green: a.target.value }), n.handleChange("g", a.target.value);
    } })), React.createElement("div", { className: "lf-color-component" }, React.createElement("strong", null, "Blue"), React.createElement("input", { type: "range", min: "0", max: "255", value: this.state.blue, onChange: function(a) {
      n.setState({ blue: a.target.value }), n.handleChange("b", a.target.value);
    } }), React.createElement("input", { className: "lf-text-input", type: "number", min: "0", max: "255", value: this.state.blue, onChange: function(a) {
      n.setState({ blue: a.target.value }), n.handleChange("b", a.target.value);
    } }))), React.createElement("div", { className: "lf-color-preview" }, React.createElement("div", { className: "lf-preview", style: { background: "rgb(" + this.state.red + ", " + this.state.green + ", " + this.state.blue + ")" } }), React.createElement("div", null, React.createElement("input", { className: "lf-text-input", type: "text", value: this.state.hex, onChange: function(a) {
      n.setState({ hex: a.target.value }), n.parseColor(a.target.value);
    } }))));
  }, r;
})(React.Component), Popover = function(t) {
  var r = t.children, n = t.icon, a = useState$1(null), s = a[0], o = a[1], l = useState$1(null), c = l[0], x = l[1], j = useState$1(null), Z = j[0], V = j[1], U = useState$1(!1), $ = U[0], Y = U[1];
  return useEffect((function() {
    if (s && c) {
      var G = s.getBoundingClientRect(), W = c.getBoundingClientRect(), X = G.left + W.width > window.innerWidth ? -1 : 0;
      V(X);
    }
  }), [Z, c, s]), React.createElement("div", { className: "lf-popover", onMouseOver: function() {
    Y(!0);
  }, onMouseLeave: function() {
    Y(!1);
  }, ref: function(G) {
    o(G);
  } }, React.createElement("div", { className: " lf-player-btn" }, n), React.createElement("div", { className: "lf-popover-content", ref: function(G) {
    x(G);
  }, style: { bottom: "22px", right: "0px", zIndex: 2, visibility: $ ? "visible" : "hidden" } }, r));
}, Seeker = (function(t) {
  function r(n) {
    var a = t.call(this, n) || this;
    return a.inputRef = React.createRef(), a.handleChange = function() {
      return function(s) {
        var o = s.target.value, l = Math.floor(o / 100 * a.props.max);
        a.props.onChange(l);
      };
    }, a.state = { value: 0 }, a;
  }
  return __extends$1(r, t), r.prototype.render = function() {
    var n = this.props.value / this.props.max * 100, a = { backgroundImage: "-webkit-gradient(linear, left top, right top, color-stop(" + n + "%, rgba(15, 204, 206, 0.4)), color-stop(" + n + "%, #DAE1E7))" }, s = { position: "absolute", left: 0, marginTop: "8px", width: "20px", display: "block", border: "0px", backgroundColor: this.props.darkTheme ? "#505050" : "rgb(218, 225, 231)", color: this.props.darkTheme ? "#B9B9B9" : "#555", padding: "2px", textAlign: "center", borderRadius: "3px", fontSize: "8px", fontWeight: "bold" }, o = { position: "absolute", right: 0, marginTop: "8px", width: "20px", display: "block", border: "0px", backgroundColor: this.props.darkTheme ? "#505050" : "rgb(218, 225, 231)", color: this.props.darkTheme ? "#B9B9B9" : "#555", padding: "2px", textAlign: "center", borderRadius: "3px", fontSize: "8px", fontWeight: "bold" };
    return React.createElement("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", width: "100%", marginRight: "5px", marginLeft: "5px", position: "relative" } }, React.createElement("input", { ref: this.inputRef, id: "track", className: "lf-progress", name: "progress", "aria-label": "progress", type: "range", min: "0", max: "100", step: "0.1", value: n, onInput: this.handleChange(), onChange: this.handleChange(), style: a }), this.props.showLabels && React.createElement("div", { style: { display: "flex", justifyContent: "space-between" } }, React.createElement("div", { style: s }, this.props.min), React.createElement("div", { style: o }, this.props.max)));
  }, r;
})(React.Component), ControlButtonStyle = { display: "inline-flex", cursor: "pointer" };
(function(t) {
  function r(n) {
    var a = t.call(this, n) || this;
    return a.state = { activeFrame: 0, mouseDown: !1 }, a;
  }
  return __extends$1(r, t), r.prototype.render = function() {
    var n = this, a = this.props, s = a.instance, o = a.playerState, l = a.seeker, c = a.setLoop, x = a.setSeeker, j = a.play, Z = a.pause, V = a.stop, U = a.visible, $ = a.buttons;
    if (!s || !U) return null;
    var Y = !$ || $.includes("play"), G = !$ || $.includes("stop"), W = !$ || $.includes("repeat"), X = !$ || $.includes("frame"), K = !$ || $.includes("background"), J = !$ || $.includes("snapshot"), ee = { width: 14, height: 14, viewBox: "0 0 24 24" }, te = Math.round(s.currentFrame);
    return React.createElement("div", { className: "lf-player-controls", style: { display: "flex", justifyContent: "space-between", height: "60px", alignItems: "center", backgroundColor: this.props.transparentTheme ? "transparent" : this.props.darkTheme ? "#3C3C3C" : "#ffffff", paddingLeft: "10px", paddingRight: "10px" } }, Y && React.createElement("div", { role: "button", "aria-label": o === PlayerState.Playing ? PlayerEvent.Pause : PlayerEvent.Play, tabIndex: 0, onClick: function() {
      o === PlayerState.Playing ? typeof Z == "function" && Z() : typeof j == "function" && j();
    }, onKeyDown: function() {
      o === PlayerState.Playing ? typeof Z == "function" && Z() : typeof j == "function" && j();
    }, className: "lf-player-btn", style: ControlButtonStyle }, o === PlayerState.Playing ? React.createElement("svg", __assign$1({}, ee), React.createElement("rect", { height: "22.9", rx: "1.9", width: "7.6", x: "14", y: ".5" }), React.createElement("rect", { height: "22.9", rx: "1.9", width: "7.6", x: "2", y: ".5" })) : React.createElement("svg", __assign$1({}, ee), React.createElement("path", { d: "M2 3.4C2 1.9 3.5 1 4.8 1.8l16.5 9.6c1.2.7 1.2 2.5 0 3.2L4.8 24.2C3.5 25 2 24.1 2 22.6V3.4z" }))), G && React.createElement("div", { tabIndex: 0, role: "button", "aria-label": PlayerEvent.Stop, onClick: function() {
      return V && V();
    }, onKeyDown: function() {
      return V && V();
    }, className: o === PlayerState.Stopped ? "lf-player-btn active" : "lf-player-btn", style: ControlButtonStyle }, React.createElement("svg", __assign$1({}, ee), React.createElement("path", { d: `M2 3.667A1.67 1.67 0 0 1 3.667 2h16.666A1.67 1.67 0 0 1 22 3.667v16.666A1.67 1.67 0 0 1 20.333
            22H3.667A1.67 1.67 0 0 1 2 20.333z` }))), React.createElement(Seeker, { min: 0, step: 1, max: s ? s.totalFrames : 1, value: l || 0, onChange: function(ne) {
      x && n.setState({ activeFrame: ne }, (function() {
        x(ne, !1);
      }));
    }, onChangeEnd: function(ne) {
      x && n.setState({ activeFrame: ne }, (function() {
        x(ne, !1);
      }));
    }, showLabels: this.props.showLabels, darkTheme: this.props.darkTheme }), X && React.createElement("div", { role: "button", className: "lf-player-btn-container" }, React.createElement("input", { style: { outline: "none", border: this.props.darkTheme ? "1px #505050 solid" : "1px #ccc solid", borderRadius: "3px", width: "40px", textAlign: "center", backgroundColor: this.props.darkTheme ? "#505050" : "#ffffff", color: this.props.darkTheme ? "#B9B9B9" : "#999", fontSize: "0.7rem", padding: "0", fontFamily: "inherit" }, type: "text", value: te, readOnly: !0 })), W && React.createElement("div", { role: "button", "aria-label": PlayerEvent.Loop, tabIndex: 0, onClick: function() {
      s && c && c(!s.loop);
    }, onKeyDown: function() {
      s && c && c(!s.loop);
    }, className: s.loop ? "lf-player-btn active" : "lf-player-btn", style: ControlButtonStyle }, React.createElement("svg", __assign$1({}, ee), React.createElement("path", { d: `M12.5 16.8137h-.13v1.8939h4.9696c3.6455 0 6.6113-2.9658 6.6113-6.6116
            0-3.64549-2.9658-6.61131-6.6113-6.61131-.5231 0-.947.42391-.947.94696 0 .52304.4239.94696.947.94696 2.6011 0
            4.7174 2.11634 4.7174 4.71739 0 2.6014-2.1166 4.7177-4.7174 4.7177H12.5zM13.6025
            5.61469v-.13H7.48137C3.83582 5.48469.87 8.45051.87 12.096c0 3.6509 3.17269 6.6117 6.81304 6.6117.52304 0
            .94696-.424.94696-.947 0-.5231-.42392-.947-.94696-.947-2.60804 0-4.91907-2.1231-4.91907-4.7176 0-2.60115
            2.11634-4.71744 4.7174-4.71744h6.12113V5.61469z`, stroke: "#8795A1", strokeWidth: ".26" }), React.createElement("path", { d: `M11.1482
            2.20355h0l-.001-.00116c-.3412-.40061-.9405-.44558-1.33668-.0996h-.00001c-.39526.34519-.43936.94795-.09898
            1.34767l2.51487 3.03683-2.51894 3.06468c-.33872.40088-.29282 1.00363.10347
            1.34723l.08517-.0982-.08517.0982c.17853.1549.39807.2308.61647.2308.2671 0 .5328-.114.72-.3347h0l.0011-.0014
            3.0435-3.68655.0006-.00068c.3035-.35872.3025-.88754-.0019-1.24526l-3.0425-3.65786zM13.9453
            21.7965h0l.001.0011c.3413.4006.9407.4456 1.337.0996h0c.3953-.3452.4395-.9479.099-1.3477l-2.5154-3.0368
            2.5195-3.0647c.3388-.4008.2929-1.0036-.1035-1.3472l-.0852.0982.0852-.0982c-.1786-.1549-.3981-.2308-.6166-.2308-.2671
            0-.5329.114-.7202.3347h0l-.0011.0014-3.0442
            3.6865c-.0001.0003-.0003.0005-.0005.0007-.3036.3587-.3027.8876.0019 1.2453l3.0431 3.6579z`, fill: "#8795A1", stroke: "#8795A1", strokeWidth: ".26" }))), K && React.createElement(Popover, { icon: React.createElement("svg", __assign$1({}, ee), React.createElement("path", { d: `M12 3.1L6.1 8.6a7.6 7.6 0 00-2.2 4 7.2 7.2 0 00.4 4.4 7.9 7.9 0 003 3.5 8.7 8.7 0 004.7 1.3c1.6 0
            3.2-.5 4.6-1.3s2.4-2 3-3.5a7.2 7.2 0 00.5-4.5 7.6 7.6 0 00-2.2-4L12 3.2zM12 0l7.5 7a9.8 9.8 0 013 5.1
            9.3 9.3 0 01-.6 5.8c-.9 1.8-2.2 3.3-4 4.4A11.2 11.2 0 0112 24a11.2 11.2 0
            01-6-1.7c-1.7-1-3-2.6-3.9-4.4a9.3 9.3 0 01-.6-5.8c.4-2 1.5-3.7 3-5L12 0zM6 14h12c0 1.5-.7 3-1.8 4s-2.6
            1.6-4.2 1.6S9 19 7.8 18s-1.7-2.5-1.7-4z` })) }, React.createElement("div", { slot: "content", className: "lf-popover popover-background" }, React.createElement(ColorPicker, { colorChangedEvent: this.props.colorChangedEvent }))), J && React.createElement(Popover, { icon: React.createElement("svg", __assign$1({}, ee), React.createElement("path", { clipRule: "evenodd", d: `M0 3.01A2.983 2.983 0 012.983.027H16.99a2.983 2.983 0 012.983 2.983v14.008a2.982 2.982 0 01-2.983
              2.983H2.983A2.983 2.983 0 010 17.018zm2.983-.941a.941.941 0 00-.942.94v14.01c0
              .52.422.94.942.94H16.99a.94.94 0 00.941-.94V3.008a.941.941 0 00-.94-.94H2.981z`, fillRule: "evenodd" }), React.createElement("path", { d: "M12.229 7.945l-2.07 4.598-2.586-2.605-2.414 2.758v2.146h9.656V11.93z" }), React.createElement("circle", { cx: "7.444", cy: "6.513", r: "2.032" }), React.createElement("path", { d: `M9.561 23.916h11.25a2.929 2.929 0 002.926-2.927V9.954a1.06 1.06 0 10-2.122 0v11.035a.805.805 0
              01-.803.804H9.562a1.061 1.061 0 100 2.123z`, stroke: "#8795a1", strokeWidth: ".215" })) }, React.createElement("div", { slot: "content", className: "lf-popover lf-popover-snapshot", onWheel: function(ne) {
      x && x(te + (ne.deltaY > 0 ? -1 : 1), !1);
    } }, React.createElement("h5", null, "Frame ", te), React.createElement("div", { style: { cursor: "pointer", color: "#0FCCCE" }, onClick: this.props.snapshot }, "Download SVG"), React.createElement("div", { style: { cursor: "pointer", color: "#0FCCCE" }, onClick: this.props.snapshot }, "Download PNG"), React.createElement("i", { className: "lf-note" }, "Scroll with mousewheel to find exact frame"))));
  }, r;
})(React.Component);
const v$1 = "4.8.0", meta = { g: "LottieFiles AE 3.4.5", a: "", k: "", d: "", tc: "" }, fr = 60, ip = 0, op = 180, w$1 = 400, h$1 = 400, nm = "Comp 1", ddd = 0, assets = [], layers = [{ ddd: 0, ind: 1, ty: 4, nm: "White", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [200, 200, 0], ix: 2 }, a: { a: 0, k: [0, 0, 0], ix: 1 }, s: { a: 0, k: [100, 100, 100], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ d: 1, ty: "el", s: { a: 0, k: [193.48, 193.48], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, nm: "Контур эллипса 1", mn: "ADBE Vector Shape - Ellipse", hd: !1 }, { ty: "tm", s: { a: 1, k: [{ i: { x: [0.584], y: [1] }, o: { x: [0.166], y: [0] }, t: 0, s: [50.1] }, { i: { x: [0.833], y: [1] }, o: { x: [0.417], y: [0] }, t: 91, s: [91] }, { t: 179, s: [50.1] }], ix: 1 }, e: { a: 1, k: [{ i: { x: [0.584], y: [1] }, o: { x: [0.166], y: [0] }, t: 0, s: [49.9] }, { i: { x: [0.833], y: [1] }, o: { x: [0.417], y: [0] }, t: 91, s: [69.9] }, { t: 179, s: [49.9] }], ix: 2 }, o: { a: 1, k: [{ i: { x: [0.849], y: [0.886] }, o: { x: [0.218], y: [0.164] }, t: 0, s: [-180] }, { t: 179, s: [540] }], ix: 3 }, m: 1, ix: 2, nm: "Обрезать контуры 1", mn: "ADBE Vector Filter - Trim", hd: !1 }, { ty: "st", c: { a: 0, k: [1, 1, 1, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 32, ix: 5 }, lc: 2, lj: 2, bm: 0, nm: "Обводка 1", mn: "ADBE Vector Graphic - Stroke", hd: !1 }, { ty: "fl", c: { a: 0, k: [1, 1, 1, 1], ix: 4 }, o: { a: 0, k: 0, ix: 5 }, r: 1, bm: 0, nm: "Заливка 1", mn: "ADBE Vector Graphic - Fill", hd: !1 }, { ty: "tr", p: { a: 0, k: [-0.267, 3.317], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [165.707, 165.707], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Преобразовать" }], nm: "Эллипс 1", np: 4, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: !1 }], ip: 0, op: 192, st: 0, bm: 0 }, { ddd: 0, ind: 2, ty: 4, nm: "blue", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [200, 200, 0], ix: 2 }, a: { a: 0, k: [0, 0, 0], ix: 1 }, s: { a: 0, k: [100, 100, 100], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ d: 1, ty: "el", s: { a: 0, k: [193.48, 193.48], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, nm: "Контур эллипса 1", mn: "ADBE Vector Shape - Ellipse", hd: !1 }, { ty: "tm", s: { a: 1, k: [{ i: { x: [0.584], y: [1] }, o: { x: [0.166], y: [0] }, t: 0, s: [50.1] }, { i: { x: [0.833], y: [1] }, o: { x: [0.417], y: [0] }, t: 91, s: [85] }, { t: 179, s: [50.1] }], ix: 1 }, e: { a: 1, k: [{ i: { x: [0.584], y: [1.109] }, o: { x: [0.166], y: [0] }, t: 0, s: [49.9] }, { i: { x: [0.833], y: [1] }, o: { x: [0.417], y: [0.106] }, t: 91, s: [56.89] }, { t: 179, s: [49.9] }], ix: 2 }, o: { a: 1, k: [{ i: { x: [0.843], y: [0.941] }, o: { x: [0.2], y: [0.075] }, t: 0, s: [-540] }, { t: 179, s: [900] }], ix: 3 }, m: 1, ix: 2, nm: "Обрезать контуры 1", mn: "ADBE Vector Filter - Trim", hd: !1 }, { ty: "st", c: { a: 0, k: [0.223529413342, 0.329411774874, 0.815686285496, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 32, ix: 5 }, lc: 2, lj: 2, bm: 0, nm: "Обводка 1", mn: "ADBE Vector Graphic - Stroke", hd: !1 }, { ty: "fl", c: { a: 0, k: [1, 1, 1, 1], ix: 4 }, o: { a: 0, k: 0, ix: 5 }, r: 1, bm: 0, nm: "Заливка 1", mn: "ADBE Vector Graphic - Fill", hd: !1 }, { ty: "tr", p: { a: 0, k: [-0.267, 3.317], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [165.707, 165.707], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Преобразовать" }], nm: "Эллипс 1", np: 4, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: !1 }], ip: 0, op: 197, st: 0, bm: 0 }, { ddd: 0, ind: 3, ty: 4, nm: "Dark", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [200, 200, 0], ix: 2 }, a: { a: 0, k: [0, 0, 0], ix: 1 }, s: { a: 0, k: [100, 100, 100], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ d: 1, ty: "el", s: { a: 0, k: [193.48, 193.48], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, nm: "Контур эллипса 1", mn: "ADBE Vector Shape - Ellipse", hd: !1 }, { ty: "tm", s: { a: 1, k: [{ i: { x: [0.584], y: [1] }, o: { x: [0.166], y: [0] }, t: 0, s: [50.1] }, { i: { x: [0.833], y: [1] }, o: { x: [0.417], y: [0] }, t: 91, s: [70] }, { t: 179, s: [50.1] }], ix: 1 }, e: { a: 1, k: [{ i: { x: [0.584], y: [1] }, o: { x: [0.166], y: [0] }, t: 0, s: [49.9] }, { i: { x: [0.833], y: [1] }, o: { x: [0.417], y: [0] }, t: 91, s: [36.9] }, { t: 179, s: [49.9] }], ix: 2 }, o: { a: 1, k: [{ i: { x: [0.601], y: [0.735] }, o: { x: [0.194], y: [0.058] }, t: 0, s: [-900] }, { t: 179, s: [900] }], ix: 3 }, m: 1, ix: 2, nm: "Обрезать контуры 1", mn: "ADBE Vector Filter - Trim", hd: !1 }, { ty: "st", c: { a: 0, k: [0.156862750649, 0.168627455831, 0.192156866193, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 32, ix: 5 }, lc: 2, lj: 2, bm: 0, nm: "Обводка 1", mn: "ADBE Vector Graphic - Stroke", hd: !1 }, { ty: "fl", c: { a: 0, k: [1, 1, 1, 1], ix: 4 }, o: { a: 0, k: 0, ix: 5 }, r: 1, bm: 0, nm: "Заливка 1", mn: "ADBE Vector Graphic - Fill", hd: !1 }, { ty: "tr", p: { a: 0, k: [-0.267, 3.317], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [165.707, 165.707], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Преобразовать" }], nm: "Эллипс 1", np: 4, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: !1 }], ip: 0, op: 182, st: 0, bm: 0 }, { ddd: 0, ind: 4, ty: 4, nm: "bg", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [200, 200, 0], ix: 2 }, a: { a: 0, k: [0, 0, 0], ix: 1 }, s: { a: 0, k: [100, 100, 100], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ d: 1, ty: "el", s: { a: 0, k: [193.48, 193.48], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, nm: "Контур эллипса 1", mn: "ADBE Vector Shape - Ellipse", hd: !1 }, { ty: "st", c: { a: 0, k: [0.541176497936, 0.666666686535, 0.858823537827, 1], ix: 3 }, o: { a: 0, k: 35, ix: 4 }, w: { a: 0, k: 38, ix: 5 }, lc: 2, lj: 2, bm: 0, nm: "Обводка 1", mn: "ADBE Vector Graphic - Stroke", hd: !1 }, { ty: "fl", c: { a: 0, k: [1, 1, 1, 1], ix: 4 }, o: { a: 0, k: 0, ix: 5 }, r: 1, bm: 0, nm: "Заливка 1", mn: "ADBE Vector Graphic - Fill", hd: !1 }, { ty: "tr", p: { a: 0, k: [-0.267, 3.317], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [165.707, 165.707], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Преобразовать" }], nm: "Эллипс 1", np: 3, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: !1 }], ip: 0, op: 208, st: 0, bm: 0 }], markers = [], loaderSrc = {
  v: v$1,
  meta,
  fr,
  ip,
  op,
  w: w$1,
  h: h$1,
  nm,
  ddd,
  assets,
  layers,
  markers
}, loaderSizeClassNames = {
  s: "go-loader__icon_size_s",
  m: "go-loader__icon_size_m",
  l: "go-loader__icon_size_l"
}, LoaderIcon = ({ size: t = "m", className: r, style: n }) => /* @__PURE__ */ jsx("div", { className: clsx(r, "go-loader__icon", loaderSizeClassNames[t]), style: n, children: /* @__PURE__ */ jsx(Player, { src: loaderSrc, autoplay: !0, loop: !0, renderer: "svg", speed: 1 }) }), Loader = ({ size: t = "m", className: r, style: n }) => /* @__PURE__ */ jsx("div", { className: clsx(r, "go-loader"), style: n, children: /* @__PURE__ */ jsx(LoaderIcon, { size: t }) });
function getIcons({
  suffixIcon: t,
  clearIcon: r,
  menuItemSelectedIcon: n,
  removeIcon: a,
  loading: s,
  multiple: o,
  hasFeedback: l,
  prefixCls: c,
  showArrow: x,
  feedbackIcon: j
}) {
  const Z = r != null ? r : /* @__PURE__ */ jsx(CloseMiniLine, {}), V = (G) => /* @__PURE__ */ jsxs(Fragment, { children: [
    G,
    l && j
  ] });
  let U = null;
  if (t !== void 0)
    U = V(t);
  else if (s)
    U = V(/* @__PURE__ */ jsx(LoaderIcon, { size: "s" }));
  else {
    const G = `${c}-suffix`;
    U = ({ open: W, showSearch: X }) => V(W && X ? /* @__PURE__ */ jsx(SearchLight, { className: G }) : /* @__PURE__ */ jsx(ArrowDropDown, { className: G }));
  }
  let $ = null;
  n !== void 0 ? $ = n : o ? $ = /* @__PURE__ */ jsx(DoneRoundLight, {}) : $ = null;
  let Y = null;
  return a !== void 0 ? Y = a : Y = /* @__PURE__ */ jsx(CloseMiniLine, {}), {
    clearIcon: Z,
    suffixIcon: U,
    itemIcon: $,
    removeIcon: Y
  };
}
const inputSizeClassNames$1 = {
  s: "go-select_size_s",
  m: "go-select_size_m"
}, statusClassNames$3 = {
  error: "go-select-status-error"
}, prefixCls = "go-select";
function naturalSort(t) {
  return [...t].sort((r, n) => {
    var c, x;
    const a = typeof r.label == "string" ? r.label : ((c = r.label) == null ? void 0 : c.toString()) || "", s = typeof n.label == "string" ? n.label : ((x = n.label) == null ? void 0 : x.toString()) || "", o = a.split(/(\d+)/).filter(Boolean), l = s.split(/(\d+)/).filter(Boolean);
    for (let j = 0; j < Math.min(o.length, l.length); j++)
      if (!isNaN(Number(o[j])) && !isNaN(Number(l[j]))) {
        const Z = parseInt(o[j], 10) - parseInt(l[j], 10);
        if (Z !== 0)
          return Z;
      } else {
        const Z = o[j].localeCompare(l[j], void 0, { sensitivity: "base" });
        if (Z !== 0)
          return Z;
      }
    return o.length - l.length;
  });
}
const InternalSelect = ({
  className: t,
  getPopupContainer: r,
  popupClassName: n,
  listHeight: a = 256,
  placement: s,
  listItemHeight: o = 24,
  size: l,
  disabled: c,
  notFoundContent: x,
  status: j,
  virtual: Z,
  mode: V,
  sortOptions: U,
  options: $,
  maxTagPlaceholder: Y,
  ...G
}, W) => {
  const X = useContext(ConfigContext), K = V === "multiple" || V === "tags", { size: J } = useGlobalComponentConfig({ size: l }), { suffixIcon: ee, itemIcon: te, removeIcon: ne, clearIcon: re } = getIcons({
    ...G,
    multiple: K,
    showArrow: !0,
    prefixCls: "go-icon"
  }), ie = useMemo$1(() => {
    if (!($ != null && $.length))
      return $;
    const fe = !hasValue(G.value) || Array.isArray(G.value) && !G.value.length ? [] : Array.isArray(G.value) ? G.value : (() => {
      if (["string", "number"].includes(typeof G.value))
        return [G.value];
      if (typeof G.value == "object" && "value" in G.value)
        return [G.value.value];
    })();
    if (K) {
      const { selectedOptions: ce, unSelectedOptions: se } = fe != null && fe.length ? $.reduce(
        (pe, ve) => (fe.includes(ve.value) ? pe.selectedOptions.push(ve) : pe.unSelectedOptions.push(ve), pe),
        { selectedOptions: [], unSelectedOptions: [] }
      ) : { selectedOptions: [], unSelectedOptions: $ };
      return U ? [...naturalSort([...ce]), ...naturalSort([...se])] : [...ce, ...se];
    } else
      return U ? naturalSort($) : $;
  }, [U, $, G.value, K]), ue = omit(G, ["suffixIcon", "itemIcon"]), le = clsx("go-select", inputSizeClassNames$1[J], j && statusClassNames$3[j], t), oe = useCallback(
    (fe) => Y === void 0 ? /* @__PURE__ */ jsxs("span", { children: [
      "+",
      fe.length
    ] }) : typeof Y == "function" ? Y(fe) : Y,
    [Y]
  ), he = useMemo$1(() => {
    if (r)
      return r;
    if (X.rootElement)
      return () => X.rootElement;
  }, [r, X.rootElement]);
  return /* @__PURE__ */ jsx(
    TypedSelect,
    {
      ref: W,
      virtual: Z,
      dropdownMatchSelectWidth: !0,
      options: ie,
      ...ue,
      listHeight: a,
      listItemHeight: o,
      mode: V,
      prefixCls,
      placement: s != null ? s : "bottomLeft",
      suffixIcon: ee,
      menuItemSelectedIcon: te,
      removeIcon: ne,
      allowClear: ue.allowClear && { clearIcon: re },
      notFoundContent: x,
      className: le,
      getPopupContainer: he,
      dropdownClassName: clsx(
        X.theme === "dark" && "go-theme_dark",
        X.theme === "light" && "go-theme_light",
        n
      ),
      disabled: c,
      maxTagPlaceholder: oe
    }
  );
}, Select = forwardRef(InternalSelect);
Select.Option = Option;
Select.OptGroup = OptGroup;
const InternalAutoComplete = (t, r) => {
  const { className: n, popupClassName: a, children: s } = t, o = toArray$3(s);
  let l;
  o.length === 1 && isValidElement(o[0]) && ([l] = o);
  const c = l ? () => l : void 0;
  return /* @__PURE__ */ jsx(
    Select,
    {
      ref: r,
      ...t,
      popupClassName: a,
      className: clsx("go-select-auto-complete", n),
      mode: "combobox",
      // Internal api
      getInputElement: c
    }
  );
}, AutoComplete = forwardRef(InternalAutoComplete), buttonVariantStyles = {
  primary: "go-button_variant_primary",
  secondary: "go-button_variant_secondary",
  flat: "go-button_variant_flat",
  danger: "go-button_variant_danger",
  success: "go-button_variant_success"
}, buttonSizeStyles = {
  s: "go-button_size_s",
  m: "go-button_size_m"
}, iconPositionClassNames = {
  before: "go-button_icon-position_before",
  after: "go-button_icon-position_after"
}, Button = forwardRef(
  ({
    variant: t = "primary",
    size: r,
    className: n,
    type: a,
    title: s,
    icon: o,
    iconPosition: l = "before",
    style: c,
    disabled: x,
    loading: j = !1,
    children: Z,
    onPointerDown: V,
    onPointerUp: U,
    onClick: $
  }, Y) => {
    const { size: G } = useGlobalComponentConfig({ size: r });
    return /* @__PURE__ */ jsxs(
      "button",
      {
        ref: Y,
        className: clsx(
          n,
          "go-button",
          buttonVariantStyles[t],
          buttonSizeStyles[G],
          iconPositionClassNames[l],
          j && "go-button_loading",
          !Z && "go-button_without-content"
        ),
        title: s,
        type: a,
        disabled: x,
        style: c,
        onClick: $,
        onPointerDown: V,
        onPointerUp: U,
        children: [
          (!!o || j) && /* @__PURE__ */ jsx("div", { className: "go-button__icon-wrapper", children: j ? /* @__PURE__ */ jsx(LoaderIcon, {}) : o }),
          !!Z && /* @__PURE__ */ jsx("div", { className: "go-button__inner", children: Z })
        ]
      }
    );
  }
);
Button.displayName = "Button";
const CLICK_DISTANCE_SQUARED = Math.pow(15, 2);
function useScroll({ element: t, scrollDistance: r = 40, onMove: n, onMoveEnd: a, onScroll: s }) {
  const o = useRef({ x: 0, y: 0 }), l = useRef(0), c = useRef(null), x = useRef(null), j = useRef(!1), Z = useCallback(
    (Y) => {
      t && (c.current = {
        id: Y.pointerId,
        coordinate: {
          x: Y.clientX,
          y: Y.clientY
        }
      }, j.current = !1);
    },
    [t]
  ), V = useCallback(
    (Y) => {
      const G = c.current;
      !t || !G || (x.current !== null && cancelAnimationFrame(x.current), x.current = requestAnimationFrame(() => {
        t.setPointerCapture(Y.pointerId);
        const W = G.coordinate.x, X = Y.clientX, K = X - W, J = G.coordinate.y, ee = Y.clientY, te = J - ee;
        if (o.current = {
          x: o.current.x + K,
          y: o.current.y + te
        }, Math.pow(o.current.x, 2) + Math.pow(o.current.y, 2) < CLICK_DISTANCE_SQUARED && !j.current) {
          t.releasePointerCapture(Y.pointerId);
          return;
        }
        j.current = !0, n == null || n({ x: K, y: te }, { ...o.current }), c.current = {
          id: Y.pointerId,
          coordinate: {
            x: X,
            y: ee
          }
        };
      }));
    },
    [t, n]
  ), U = useCallback(() => {
    x.current !== null && cancelAnimationFrame(x.current), c.current = null, o.current = { x: 0, y: 0 }, j.current = !1, x.current = requestAnimationFrame(() => {
      a == null || a();
    });
  }, [a]), $ = useCallback(
    (Y) => {
      Y.preventDefault(), !j.current && (x.current !== null && cancelAnimationFrame(x.current), x.current = requestAnimationFrame(() => {
        l.current += Y.deltaY, Math.abs(l.current) > Math.abs(r) && (s == null || s(Y.deltaY, l.current), l.current = 0);
      }));
    },
    [s, r]
  );
  useEffect(() => {
    if (t)
      return t.addEventListener("pointerdown", Z), t.addEventListener("pointermove", V), t.addEventListener("pointerup", U), t.addEventListener("pointercancel", U), t.addEventListener("wheel", $, { passive: !1 }), () => {
        t.removeEventListener("pointerdown", Z), t.removeEventListener("pointermove", V), t.removeEventListener("pointerup", U), t.removeEventListener("pointercancel", U), t.removeEventListener("wheel", $);
      };
  }, [t, Z, V, U, $]);
}
const getRemainingTime = (t, r) => {
  const n = Date.now() - t, a = r - n;
  return a < 0 ? 0 : a;
};
function useThrottledFn(t, r) {
  const n = useRef(Date.now()), a = useRef(null), s = useCallback(() => {
    a.current && (clearTimeout(a.current), a.current = null);
  }, []), o = useCallback(
    (...l) => {
      let c = getRemainingTime(n.current, r);
      c === 0 ? (n.current = Date.now(), t(...l), s()) : a.current || (a.current = setTimeout(() => {
        c = getRemainingTime(n.current, r), c === 0 && (n.current = Date.now(), t(...l), s());
      }, c));
    },
    [t, s, r]
  );
  return useEffect(() => s, [s]), o;
}
const NUMBER_OF_WEEKS_ON_PAGE = 6, YEARS_IN_ROW = 4, DEFAULT_CALENDAR_CONFIG = {
  weekRowHeight: 24
}, DEFAULT_YEARS_CALENDAR_CONFIG = {
  rowHeight: 40,
  numberOfYearsInRow: 3,
  numberOfRows: 5
};
function numberRangeMap(t, r, n) {
  const a = [];
  for (let s = t; s <= r; s++)
    a.push(n(s));
  return a;
}
function numberRange(t, r) {
  const n = [];
  for (let a = t; a <= r; a++)
    n.push(a);
  return n;
}
function getCalendarYearPage() {
  return {
    months: numberRangeMap(0, 11, (t) => ({
      key: t.toString(),
      value: t
    }))
  };
}
function getYears(t, r) {
  return numberRange(t, t + r - 1);
}
function getTimeOptions() {
  return {
    hours: numberRangeMap(0, 23, (t) => ({
      key: t.toString(),
      value: t
    })),
    minutes: numberRangeMap(0, 59, (t) => ({
      key: t.toString(),
      value: t
    }))
  };
}
function isSelectedDate(t, r) {
  return r === null ? !1 : isSameDay(t, r);
}
function extractTime(t) {
  return {
    hours: getHours(t),
    minutes: getMinutes(t)
  };
}
function applyTime(t, r, n) {
  let a = t;
  return r !== null && (a = setHours(a, r)), n !== null && (a = setMinutes(a, n)), a;
}
function applyTimeV2(t, r, n) {
  let a = t;
  return r !== null && (a = setHours(a, r).getTime()), n !== null && (a = setMinutes(a, n).getTime()), a;
}
function isActiveMonth(t, r) {
  return t === getMonth(r);
}
function getWeeks(t, r) {
  const n = startOfWeek(sub$1(t, { weeks: 6 }), { locale: r }), a = add$1(t, { weeks: 10 });
  return eachDayOfInterval({ start: n, end: a }, { step: 7 }).map((s) => s.getTime());
}
function getStartOfMonth(t, r) {
  const n = new Date(r, t), a = isNaN(n.getTime()) ? /* @__PURE__ */ new Date() : n;
  return startOfMonth(a).getTime();
}
function getViewportByDate(t, r, n, a) {
  const s = startOfWeek(startOfMonth(t), { locale: a });
  return differenceInWeeks(s, r, { roundingMethod: "round" }) * n;
}
function getViewportPoint(t, r, n) {
  return differenceInWeeks(t, r, { roundingMethod: "round" }) * n;
}
function getStartOfYearRow(t, r, n) {
  const a = (r - t) / n;
  return t + Math.floor(a) * n;
}
function getYearRowStartPoints(t, r, n) {
  const a = [];
  let s = 0, o = t;
  for (; o <= r; )
    a.push(o), s += 1, o = t + s * n;
  return a;
}
const CalendarDate = ({ value: t, onClick: r, isSelected: n, isActive: a, disabled: s }) => {
  var l;
  const { localization: o } = useContext(ConfigContext);
  return /* @__PURE__ */ jsx(
    "button",
    {
      disabled: s,
      className: clsx(
        "go-calendar__date",
        isWeekend(t) && "go-calendar__date_weekend",
        n && "go-calendar__date_selected",
        a && "go-calendar__date_in-view"
      ),
      onClick: r,
      children: /* @__PURE__ */ jsx("span", { className: "go-calendar__date-inner", children: format(t, "d", { locale: (l = o == null ? void 0 : o.calendar) == null ? void 0 : l.locale }) })
    }
  );
}, Week = forwardRef(function t({ weekStart: r, month: n, selectedDate: a, isDateDisabled: s, onDateChange: o, config: l, onUnmount: c }, x) {
  var V;
  const { localization: j } = useContext(ConfigContext), Z = useMemo$1(() => {
    var Y, G;
    const U = startOfWeek(toDate(r), { locale: (Y = j == null ? void 0 : j.calendar) == null ? void 0 : Y.locale }), $ = endOfWeek(U, { locale: (G = j == null ? void 0 : j.calendar) == null ? void 0 : G.locale });
    return eachDayOfInterval({ start: U, end: $ });
  }, [(V = j == null ? void 0 : j.calendar) == null ? void 0 : V.locale, r]);
  return useEffect(() => () => c(r), [c, r]), /* @__PURE__ */ jsx(
    "div",
    {
      ref: x,
      id: `${format(r, "dd.MM.yyyy")}`,
      className: "go-calendar__week-row",
      style: { height: `${l.weekRowHeight}px` },
      children: Z.map((U) => {
        var $;
        return /* @__PURE__ */ jsx(
          CalendarDate,
          {
            value: U,
            onClick: () => o(U),
            isSelected: isSelectedDate(U, a),
            isActive: isActiveMonth(n, U),
            disabled: ($ = s == null ? void 0 : s(U)) != null ? $ : !1
          },
          U.getTime().toString()
        );
      })
    }
  );
});
function moveWeekRows$1(t, r, n, a) {
  for (const [s, o] of t) {
    const l = getViewportPoint(s, r, a);
    o.style.transform = `translateY(${l - n}px)`;
  }
}
const CalendarDates = ({
  month: t,
  year: r,
  selectedDate: n,
  config: a,
  onDateChange: s,
  onMonthChange: o,
  isDateDisabled: l
}) => {
  var le, oe;
  const { localization: c } = useContext(ConfigContext), x = (le = c == null ? void 0 : c.calendar) == null ? void 0 : le.locale, j = useRef(startOfWeek(startOfMonth(/* @__PURE__ */ new Date()), { locale: x })), [Z, V] = useState$1(() => getStartOfMonth(t, r));
  useEffect(() => V(getStartOfMonth(t, r)), [t, r]);
  const [U, $] = useState$1(() => getWeeks(Z, x));
  useEffect(() => $(getWeeks(Z, x)), [x, Z]);
  const Y = useRef(/* @__PURE__ */ new Map()), G = useRef(null), W = useRef(
    // eslint-disable-next-line react-hooks/refs
    getViewportByDate(Z, j.current, a.weekRowHeight, x)
  ), X = useRef(null), [K, J] = useState$1(!1);
  useEffect(() => {
    var ce;
    if (K)
      return;
    const he = W.current, fe = getViewportByDate(Z, j.current, a.weekRowHeight, x);
    (ce = X.current) == null || ce.call(X), X.current = animate(
      he,
      fe,
      (se) => {
        W.current = se, moveWeekRows$1(Y.current, j.current, se, a.weekRowHeight);
      },
      (se) => W.current = se
    );
  }, [a.weekRowHeight, Z, K, x]);
  const ee = useCallback(
    ({ y: he }) => {
      J(!0), W.current += he;
      const fe = Math.ceil(W.current / a.weekRowHeight), ce = startOfWeek(
        // Add (NUMBER_OF_WEEKS_ON_PAGE / 2) weeks to switch months in header when month is half displayed.
        startOfMonth(add$1(j.current, { weeks: fe + NUMBER_OF_WEEKS_ON_PAGE / 2 })),
        {
          locale: x
        }
      );
      moveWeekRows$1(Y.current, j.current, W.current, a.weekRowHeight);
      const se = endOfWeek(ce, { locale: x }), pe = getMonth(se), ve = getYear(se);
      V(getStartOfMonth(getMonth(se), getYear(se))), o(pe, ve);
    },
    [a.weekRowHeight, x, o]
  ), te = useCallback(() => {
    J(!1);
  }, []), ne = useThrottledFn((he) => {
    const fe = he > 0 ? 1 : -1, ce = startOfWeek(startOfMonth(add$1(Z, { months: 1 * fe })), {
      locale: x
    }).getTime();
    if (Y.current.get(ce)) {
      const pe = endOfWeek(ce, { locale: x });
      o(getMonth(pe), getYear(pe));
    }
  }, 300);
  useScroll({
    // eslint-disable-next-line react-hooks/refs
    element: (oe = G.current) != null ? oe : null,
    onMove: ee,
    onMoveEnd: te,
    onScroll: ne
  });
  const re = (he, fe) => {
    if (he !== null) {
      Y.current.set(fe, he);
      const ce = W.current, se = getViewportPoint(fe, j.current, a.weekRowHeight);
      he.style.transform = `translateY(${se - ce}px)`;
    }
  }, ie = useCallback((he) => {
    Y.current.delete(he);
  }, []), ue = useMemo$1(() => eachDayOfInterval({
    start: startOfWeek(Z, { locale: x }),
    end: endOfWeek(Z, { locale: x })
  }), [Z, x]);
  return /* @__PURE__ */ jsxs("div", { className: "go-calendar__dates-container", children: [
    /* @__PURE__ */ jsx("div", { className: "go-calendar__week-days-row", children: ue.map((he) => /* @__PURE__ */ jsx(
      "div",
      {
        className: clsx("go-calendar__week-day", isWeekend(he) && "go-calendar__date_weekend"),
        children: /* @__PURE__ */ jsx("span", { className: "go-calendar__week-day-inner", children: format(he, "cccccc", { locale: x }) })
      },
      he.getTime().toString()
    )) }),
    /* @__PURE__ */ jsx("div", { ref: G, className: "go-calendar__dates", children: U.map((he) => /* @__PURE__ */ jsx(
      Week,
      {
        ref: (fe) => re(fe, he),
        onUnmount: ie,
        selectedDate: n,
        month: t,
        weekStart: he,
        config: a,
        onDateChange: s,
        isDateDisabled: l
      },
      he.toString()
    )) })
  ] });
}, CalendarMonthPage = ({
  month: t,
  year: r,
  selectedDate: n,
  config: a,
  onDateChange: s,
  onMonthChange: o,
  isDateDisabled: l
}) => /* @__PURE__ */ jsx("div", { className: "go-calendar__month-page", children: /* @__PURE__ */ jsx(
  CalendarDates,
  {
    month: t,
    year: r,
    selectedDate: n,
    config: a,
    onDateChange: s,
    onMonthChange: o,
    isDateDisabled: l
  }
) }), yearPage = getCalendarYearPage(), CalendarMonths = ({ selectedMonth: t, onChange: r }) => {
  const { localization: n } = useContext(ConfigContext);
  return /* @__PURE__ */ jsx("div", { className: "go-calendar__month-container", children: yearPage.months.map((a) => {
    var s;
    return /* @__PURE__ */ jsx(
      "button",
      {
        className: clsx("go-calendar__month", t === a.value && "go-calendar__month_selected"),
        onClick: () => r(a.value),
        children: /* @__PURE__ */ jsx("span", { className: "go-calendar__month-inner", children: format(setMonth(/* @__PURE__ */ new Date(), a.value), "LLLL", { locale: (s = n == null ? void 0 : n.calendar) == null ? void 0 : s.locale }) })
      },
      a.key
    );
  }) });
}, CalendarYear = forwardRef(function t({ value: r, isSelected: n, onClick: a, onUnmount: s }, o) {
  return useEffect(() => () => s(r), [s, r]), /* @__PURE__ */ jsx(
    "button",
    {
      ref: o,
      onClick: a,
      className: clsx("go-calendar__year", n && "go-calendar__year_selected"),
      style: { width: `${100 / YEARS_IN_ROW}%` },
      children: /* @__PURE__ */ jsx("span", { className: "go-calendar__year-inner", children: r })
    }
  );
});
function normalizeViewport(t) {
  const r = t % 100;
  return Math.abs(r) <= 50 ? t - r : t >= 0 ? t + (100 - r) : t - (100 + r);
}
function moveYears(t, r, n) {
  for (const [a, s] of t) {
    const o = (a - r) * 100;
    s.style.transform = `translateX(${o - n}%)`;
  }
}
const CalendarYears = ({ selectedYear: t, onChange: r }) => {
  const n = useRef(null), a = useRef(t != null ? t : getYear(/* @__PURE__ */ new Date())), s = useRef(0), o = useRef(/* @__PURE__ */ new Map()), l = useRef(null), [c, x] = useState$1(() => getYears(a.current - YEARS_IN_ROW * 2, YEARS_IN_ROW * 4)), [j, Z] = useState$1(null);
  useEffect(() => {
    const K = n.current;
    if (K) {
      const J = new IntersectionObserver((ee) => {
        const te = ee.at(0);
        te && Z(te.boundingClientRect);
      });
      return J.observe(K), () => J.unobserve(K);
    }
  }, []);
  const V = useThrottledFn(() => {
    var ne;
    if (!j)
      return;
    const K = s.current, ee = a.current + normalizeViewport(s.current) / 100 - YEARS_IN_ROW, te = (ee - a.current) * 100;
    x(getYears(ee - YEARS_IN_ROW * 2, YEARS_IN_ROW * 4)), (ne = l.current) == null || ne.call(l), l.current = animate(
      K,
      te,
      (re) => {
        s.current = re, moveYears(o.current, a.current, re);
      },
      (re) => {
        s.current = normalizeViewport(re);
      }
    );
  }, 200), U = useThrottledFn(() => {
    var ne;
    if (!j)
      return;
    const K = s.current, ee = a.current + normalizeViewport(s.current) / 100 + YEARS_IN_ROW, te = (ee - a.current) * 100;
    x(getYears(ee - YEARS_IN_ROW * 2, YEARS_IN_ROW * 4)), (ne = l.current) == null || ne.call(l), l.current = animate(
      K,
      te,
      (re) => {
        s.current = re, moveYears(o.current, a.current, re);
      },
      (re) => {
        s.current = normalizeViewport(re);
      }
    );
  }, 200), $ = useCallback(
    ({ x: K }) => {
      if (!j || K === 0)
        return;
      const J = j.width * K / 100;
      s.current -= J;
      const te = a.current + normalizeViewport(s.current) / 100 - YEARS_IN_ROW;
      x(getYears(te - YEARS_IN_ROW, YEARS_IN_ROW * 4)), moveYears(o.current, a.current, s.current);
    },
    [j]
  ), Y = useCallback(() => {
    var ee;
    const K = s.current, J = normalizeViewport(s.current);
    (ee = l.current) == null || ee.call(l), l.current = animate(
      K,
      J,
      (te) => {
        s.current = te, moveYears(o.current, a.current, te);
      },
      (te) => {
        s.current = te;
      }
    );
  }, []), G = useThrottledFn((K) => {
    var ie;
    const J = K > 0 ? 1 : -1, ee = s.current, ne = a.current + normalizeViewport(s.current) / 100 + YEARS_IN_ROW * J, re = (ne - a.current) * 100;
    x(getYears(ne - YEARS_IN_ROW * 2, YEARS_IN_ROW * 4)), (ie = l.current) == null || ie.call(l), l.current = animate(
      ee,
      re,
      (ue) => {
        s.current = ue, moveYears(o.current, a.current, ue);
      },
      (ue) => {
        s.current = normalizeViewport(ue);
      }
    );
  }, 200);
  useScroll({
    // eslint-disable-next-line react-hooks/refs
    element: n.current,
    onMove: $,
    onMoveEnd: Y,
    onScroll: G
  }), useEffect(() => {
    var K;
    return (K = l.current) == null ? void 0 : K.call(l);
  }, []);
  const W = (K, J) => {
    if (K !== null) {
      o.current.set(J, K);
      const ee = (J - a.current) * 100;
      K.style.transform = `translateX(${ee - s.current}%)`;
    }
  }, X = useCallback((K) => {
    o.current.delete(K);
  }, []);
  return /* @__PURE__ */ jsxs("div", { className: "go-calendar__years", children: [
    /* @__PURE__ */ jsx("button", { className: "go-calendar__header-navigation-button", onClick: V, children: /* @__PURE__ */ jsx(ArrowLeftLight, {}) }),
    /* @__PURE__ */ jsx("div", { ref: n, className: "go-calendar__years-container", children: c.map((K) => /* @__PURE__ */ jsx(
      CalendarYear,
      {
        ref: (J) => W(J, K),
        value: K,
        isSelected: K === t,
        onClick: () => r(K),
        onUnmount: X
      },
      K.toString()
    )) }),
    /* @__PURE__ */ jsx("button", { className: "go-calendar__header-navigation-button", onClick: U, children: /* @__PURE__ */ jsx(ArrowRightLight, {}) })
  ] });
}, CalendarYearPage = ({ month: t, year: r, onMonthChange: n, onYearChange: a }) => /* @__PURE__ */ jsxs("div", { className: "go-calendar__year-page", children: [
  /* @__PURE__ */ jsx(CalendarYears, { selectedYear: r, onChange: a }),
  /* @__PURE__ */ jsx(CalendarMonths, { selectedMonth: t, onChange: n })
] });
function exhaustiveCheck(t) {
  throw new Error(`Unreachable case: ${t}`);
}
const initialState = {
  mode: "month",
  hours: null,
  minutes: null,
  month: getMonth(/* @__PURE__ */ new Date()),
  year: getYear(/* @__PURE__ */ new Date())
};
function initStore(t, r, n, a, s) {
  var l;
  const o = (l = r != null ? r : a) != null ? l : n;
  if (s === "year")
    return {
      ...t,
      mode: s,
      year: o && getYear(o),
      month: o && getMonth(o),
      hours: o && getHours(o),
      minutes: o && getMinutes(o)
    };
  if (s === "month") {
    const c = /* @__PURE__ */ new Date();
    return {
      ...t,
      mode: s,
      year: o ? getYear(o) : getYear(c),
      month: o ? getMonth(o) : getMonth(c),
      hours: o && getHours(o),
      minutes: o && getMinutes(o)
    };
  }
  if (s === "years")
    return t;
  exhaustiveCheck(s);
}
function reducer(t, r) {
  var n, a, s, o;
  if (r.type === "SET_MINUTES")
    return {
      ...t,
      minutes: r.payload
    };
  if (r.type === "SET_HOURS")
    return {
      ...t,
      hours: r.payload
    };
  if (r.type === "SET_MONTH")
    return {
      ...t,
      mode: "month",
      month: r.payload.month,
      year: (a = (n = r.payload.year) != null ? n : t.year) != null ? a : getYear(/* @__PURE__ */ new Date())
    };
  if (r.type === "SET_YEAR")
    return {
      ...t,
      year: r.payload
    };
  if (r.type === "SET_DATE") {
    const { hours: l, minutes: c } = extractTime(r.payload);
    return {
      ...t,
      hours: l,
      minutes: c,
      month: getMonth(r.payload),
      year: getYear(r.payload)
    };
  }
  return r.type === "TOGGLE_MODE" ? t.mode === r.payload ? t : r.payload === "year" || !r.payload && t.mode === "month" ? {
    ...t,
    mode: "year"
  } : r.payload === "month" || !r.payload && t.mode === "year" ? {
    ...t,
    mode: "month",
    year: (s = t.year) != null ? s : getYear(/* @__PURE__ */ new Date()),
    month: (o = t.month) != null ? o : getMonth(/* @__PURE__ */ new Date())
  } : t : t;
}
const CalendarHeader = ({ month: t, year: r, mode: n, onChange: a, onTitleClick: s }) => {
  var j, Z;
  const { localization: o } = useContext(ConfigContext), l = new Date(r, t), c = useThrottledFn(() => {
    const V = sub$1(l, { months: 1 });
    a(getMonth(V), getYear(V));
  }, 300), x = useThrottledFn(() => {
    const V = add$1(l, { months: 1 });
    a(getMonth(V), getYear(V));
  }, 300);
  return /* @__PURE__ */ jsxs("div", { className: "go-calendar__header", children: [
    n === "month" && /* @__PURE__ */ jsx("button", { className: "go-calendar__header-navigation-button", onClick: c, tabIndex: -1, children: /* @__PURE__ */ jsx(ArrowLeftLight, {}) }),
    /* @__PURE__ */ jsxs("button", { className: "go-calendar__header-title", onClick: s, children: [
      /* @__PURE__ */ jsx("span", { className: "go-calendar__header-month", children: format(l, "LLLL", { locale: (j = o == null ? void 0 : o.calendar) == null ? void 0 : j.locale }) }),
      /* @__PURE__ */ jsx("span", { className: "go-calendar__header-year", children: format(l, "yyyy", { locale: (Z = o == null ? void 0 : o.calendar) == null ? void 0 : Z.locale }) }),
      /* @__PURE__ */ jsx(
        ArrowDropUp,
        {
          className: clsx("go-calendar__header-arrow", n === "month" && "go-calendar__header-arrow_down")
        }
      )
    ] }),
    n === "month" && /* @__PURE__ */ jsx("button", { className: "go-calendar__header-navigation-button", onClick: x, tabIndex: -1, children: /* @__PURE__ */ jsx(ArrowRightLight, {}) })
  ] });
};
var isArray = Array.isArray, toClassName = function(t) {
  var r = "";
  if (typeof t == "string")
    r += t;
  else if (typeof t == "object") {
    var n = void 0;
    if (isArray(t))
      for (var a = 0, s = t.length; a < s; )
        n = toClassName(t[a++]), n && (r && (r += " "), r += n);
    else
      for (n in t)
        n && t[n] && (r && (r += " "), r += n);
  }
  return r;
};
function cnb() {
  for (var t = arguments.length, r = 0, n, a, s = ""; r < t; )
    n = arguments[r++], n && (a = toClassName(n), a && (s && (s += " "), s += a));
  return s;
}
function e(t, r, n, a) {
  for (; r >= n && !t("(min-resolution: " + r / a + "dppx)").matches; ) r--;
  return r;
}
function i(t) {
  if (t === void 0 && (t = window), !t) return 1;
  if (t.devicePixelRatio !== void 0) return t.devicePixelRatio;
  var r = t.document.frames;
  return r !== void 0 ? r.devicePixelRatio !== void 0 ? r.devicePixelRatio : r.screen.deviceXDPI / r.screen.systemXDPI : t.matchMedia !== void 0 ? (function(n) {
    for (var a = n.matchMedia, s = 10, o = 0.1, l = 1, c = s, x = 0; x < 4; x++) s = (c = 10 * e(a, s, o, l)) + 9, o = c, l *= 10;
    return c / l;
  })(t) : 1;
}
var cjs = { exports: {} }, Draggable = {}, propTypes = { exports: {} }, reactIs = { exports: {} }, reactIs_production_min = {};
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var t = typeof Symbol == "function" && Symbol.for, r = t ? /* @__PURE__ */ Symbol.for("react.element") : 60103, n = t ? /* @__PURE__ */ Symbol.for("react.portal") : 60106, a = t ? /* @__PURE__ */ Symbol.for("react.fragment") : 60107, s = t ? /* @__PURE__ */ Symbol.for("react.strict_mode") : 60108, o = t ? /* @__PURE__ */ Symbol.for("react.profiler") : 60114, l = t ? /* @__PURE__ */ Symbol.for("react.provider") : 60109, c = t ? /* @__PURE__ */ Symbol.for("react.context") : 60110, x = t ? /* @__PURE__ */ Symbol.for("react.async_mode") : 60111, j = t ? /* @__PURE__ */ Symbol.for("react.concurrent_mode") : 60111, Z = t ? /* @__PURE__ */ Symbol.for("react.forward_ref") : 60112, V = t ? /* @__PURE__ */ Symbol.for("react.suspense") : 60113, U = t ? /* @__PURE__ */ Symbol.for("react.suspense_list") : 60120, $ = t ? /* @__PURE__ */ Symbol.for("react.memo") : 60115, Y = t ? /* @__PURE__ */ Symbol.for("react.lazy") : 60116, G = t ? /* @__PURE__ */ Symbol.for("react.block") : 60121, W = t ? /* @__PURE__ */ Symbol.for("react.fundamental") : 60117, X = t ? /* @__PURE__ */ Symbol.for("react.responder") : 60118, K = t ? /* @__PURE__ */ Symbol.for("react.scope") : 60119;
  function J(te) {
    if (typeof te == "object" && te !== null) {
      var ne = te.$$typeof;
      switch (ne) {
        case r:
          switch (te = te.type, te) {
            case x:
            case j:
            case a:
            case o:
            case s:
            case V:
              return te;
            default:
              switch (te = te && te.$$typeof, te) {
                case c:
                case Z:
                case Y:
                case $:
                case l:
                  return te;
                default:
                  return ne;
              }
          }
        case n:
          return ne;
      }
    }
  }
  function ee(te) {
    return J(te) === j;
  }
  return reactIs_production_min.AsyncMode = x, reactIs_production_min.ConcurrentMode = j, reactIs_production_min.ContextConsumer = c, reactIs_production_min.ContextProvider = l, reactIs_production_min.Element = r, reactIs_production_min.ForwardRef = Z, reactIs_production_min.Fragment = a, reactIs_production_min.Lazy = Y, reactIs_production_min.Memo = $, reactIs_production_min.Portal = n, reactIs_production_min.Profiler = o, reactIs_production_min.StrictMode = s, reactIs_production_min.Suspense = V, reactIs_production_min.isAsyncMode = function(te) {
    return ee(te) || J(te) === x;
  }, reactIs_production_min.isConcurrentMode = ee, reactIs_production_min.isContextConsumer = function(te) {
    return J(te) === c;
  }, reactIs_production_min.isContextProvider = function(te) {
    return J(te) === l;
  }, reactIs_production_min.isElement = function(te) {
    return typeof te == "object" && te !== null && te.$$typeof === r;
  }, reactIs_production_min.isForwardRef = function(te) {
    return J(te) === Z;
  }, reactIs_production_min.isFragment = function(te) {
    return J(te) === a;
  }, reactIs_production_min.isLazy = function(te) {
    return J(te) === Y;
  }, reactIs_production_min.isMemo = function(te) {
    return J(te) === $;
  }, reactIs_production_min.isPortal = function(te) {
    return J(te) === n;
  }, reactIs_production_min.isProfiler = function(te) {
    return J(te) === o;
  }, reactIs_production_min.isStrictMode = function(te) {
    return J(te) === s;
  }, reactIs_production_min.isSuspense = function(te) {
    return J(te) === V;
  }, reactIs_production_min.isValidElementType = function(te) {
    return typeof te == "string" || typeof te == "function" || te === a || te === j || te === o || te === s || te === V || te === U || typeof te == "object" && te !== null && (te.$$typeof === Y || te.$$typeof === $ || te.$$typeof === l || te.$$typeof === c || te.$$typeof === Z || te.$$typeof === W || te.$$typeof === X || te.$$typeof === K || te.$$typeof === G);
  }, reactIs_production_min.typeOf = J, reactIs_production_min;
}
var reactIs_development = {};
var hasRequiredReactIs_development;
function requireReactIs_development() {
  return hasRequiredReactIs_development || (hasRequiredReactIs_development = 1, process.env.NODE_ENV !== "production" && (function() {
    var t = typeof Symbol == "function" && Symbol.for, r = t ? /* @__PURE__ */ Symbol.for("react.element") : 60103, n = t ? /* @__PURE__ */ Symbol.for("react.portal") : 60106, a = t ? /* @__PURE__ */ Symbol.for("react.fragment") : 60107, s = t ? /* @__PURE__ */ Symbol.for("react.strict_mode") : 60108, o = t ? /* @__PURE__ */ Symbol.for("react.profiler") : 60114, l = t ? /* @__PURE__ */ Symbol.for("react.provider") : 60109, c = t ? /* @__PURE__ */ Symbol.for("react.context") : 60110, x = t ? /* @__PURE__ */ Symbol.for("react.async_mode") : 60111, j = t ? /* @__PURE__ */ Symbol.for("react.concurrent_mode") : 60111, Z = t ? /* @__PURE__ */ Symbol.for("react.forward_ref") : 60112, V = t ? /* @__PURE__ */ Symbol.for("react.suspense") : 60113, U = t ? /* @__PURE__ */ Symbol.for("react.suspense_list") : 60120, $ = t ? /* @__PURE__ */ Symbol.for("react.memo") : 60115, Y = t ? /* @__PURE__ */ Symbol.for("react.lazy") : 60116, G = t ? /* @__PURE__ */ Symbol.for("react.block") : 60121, W = t ? /* @__PURE__ */ Symbol.for("react.fundamental") : 60117, X = t ? /* @__PURE__ */ Symbol.for("react.responder") : 60118, K = t ? /* @__PURE__ */ Symbol.for("react.scope") : 60119;
    function J(be) {
      return typeof be == "string" || typeof be == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      be === a || be === j || be === o || be === s || be === V || be === U || typeof be == "object" && be !== null && (be.$$typeof === Y || be.$$typeof === $ || be.$$typeof === l || be.$$typeof === c || be.$$typeof === Z || be.$$typeof === W || be.$$typeof === X || be.$$typeof === K || be.$$typeof === G);
    }
    function ee(be) {
      if (typeof be == "object" && be !== null) {
        var Pe = be.$$typeof;
        switch (Pe) {
          case r:
            var ye = be.type;
            switch (ye) {
              case x:
              case j:
              case a:
              case o:
              case s:
              case V:
                return ye;
              default:
                var Ae = ye && ye.$$typeof;
                switch (Ae) {
                  case c:
                  case Z:
                  case Y:
                  case $:
                  case l:
                    return Ae;
                  default:
                    return Pe;
                }
            }
          case n:
            return Pe;
        }
      }
    }
    var te = x, ne = j, re = c, ie = l, ue = r, le = Z, oe = a, he = Y, fe = $, ce = n, se = o, pe = s, ve = V, ae = !1;
    function me(be) {
      return ae || (ae = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), de(be) || ee(be) === x;
    }
    function de(be) {
      return ee(be) === j;
    }
    function ge(be) {
      return ee(be) === c;
    }
    function Se(be) {
      return ee(be) === l;
    }
    function xe(be) {
      return typeof be == "object" && be !== null && be.$$typeof === r;
    }
    function Ee(be) {
      return ee(be) === Z;
    }
    function Ce(be) {
      return ee(be) === a;
    }
    function ke(be) {
      return ee(be) === Y;
    }
    function Re(be) {
      return ee(be) === $;
    }
    function _e(be) {
      return ee(be) === n;
    }
    function Me(be) {
      return ee(be) === o;
    }
    function we(be) {
      return ee(be) === s;
    }
    function Te(be) {
      return ee(be) === V;
    }
    reactIs_development.AsyncMode = te, reactIs_development.ConcurrentMode = ne, reactIs_development.ContextConsumer = re, reactIs_development.ContextProvider = ie, reactIs_development.Element = ue, reactIs_development.ForwardRef = le, reactIs_development.Fragment = oe, reactIs_development.Lazy = he, reactIs_development.Memo = fe, reactIs_development.Portal = ce, reactIs_development.Profiler = se, reactIs_development.StrictMode = pe, reactIs_development.Suspense = ve, reactIs_development.isAsyncMode = me, reactIs_development.isConcurrentMode = de, reactIs_development.isContextConsumer = ge, reactIs_development.isContextProvider = Se, reactIs_development.isElement = xe, reactIs_development.isForwardRef = Ee, reactIs_development.isFragment = Ce, reactIs_development.isLazy = ke, reactIs_development.isMemo = Re, reactIs_development.isPortal = _e, reactIs_development.isProfiler = Me, reactIs_development.isStrictMode = we, reactIs_development.isSuspense = Te, reactIs_development.isValidElementType = J, reactIs_development.typeOf = ee;
  })()), reactIs_development;
}
var hasRequiredReactIs;
function requireReactIs() {
  return hasRequiredReactIs || (hasRequiredReactIs = 1, process.env.NODE_ENV === "production" ? reactIs.exports = requireReactIs_production_min() : reactIs.exports = requireReactIs_development()), reactIs.exports;
}
var objectAssign, hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  var t = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function a(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function s() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var l = {}, c = 0; c < 10; c++)
        l["_" + String.fromCharCode(c)] = c;
      var x = Object.getOwnPropertyNames(l).map(function(Z) {
        return l[Z];
      });
      if (x.join("") !== "0123456789")
        return !1;
      var j = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(Z) {
        j[Z] = Z;
      }), Object.keys(Object.assign({}, j)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return objectAssign = s() ? Object.assign : function(o, l) {
    for (var c, x = a(o), j, Z = 1; Z < arguments.length; Z++) {
      c = Object(arguments[Z]);
      for (var V in c)
        r.call(c, V) && (x[V] = c[V]);
      if (t) {
        j = t(c);
        for (var U = 0; U < j.length; U++)
          n.call(c, j[U]) && (x[j[U]] = c[j[U]]);
      }
    }
    return x;
  }, objectAssign;
}
var ReactPropTypesSecret_1, hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ReactPropTypesSecret_1 = t, ReactPropTypesSecret_1;
}
var has, hasRequiredHas;
function requireHas() {
  return hasRequiredHas || (hasRequiredHas = 1, has = Function.call.bind(Object.prototype.hasOwnProperty)), has;
}
var checkPropTypes_1, hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var t = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var r = /* @__PURE__ */ requireReactPropTypesSecret(), n = {}, a = /* @__PURE__ */ requireHas();
    t = function(o) {
      var l = "Warning: " + o;
      typeof console != "undefined" && console.error(l);
      try {
        throw new Error(l);
      } catch {
      }
    };
  }
  function s(o, l, c, x, j) {
    if (process.env.NODE_ENV !== "production") {
      for (var Z in o)
        if (a(o, Z)) {
          var V;
          try {
            if (typeof o[Z] != "function") {
              var U = Error(
                (x || "React class") + ": " + c + " type `" + Z + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[Z] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw U.name = "Invariant Violation", U;
            }
            V = o[Z](l, Z, x, c, null, r);
          } catch (Y) {
            V = Y;
          }
          if (V && !(V instanceof Error) && t(
            (x || "React class") + ": type specification of " + c + " `" + Z + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof V + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), V instanceof Error && !(V.message in n)) {
            n[V.message] = !0;
            var $ = j ? j() : "";
            t(
              "Failed " + c + " type: " + V.message + ($ != null ? $ : "")
            );
          }
        }
    }
  }
  return s.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, checkPropTypes_1 = s, checkPropTypes_1;
}
var factoryWithTypeCheckers, hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var t = requireReactIs(), r = requireObjectAssign(), n = /* @__PURE__ */ requireReactPropTypesSecret(), a = /* @__PURE__ */ requireHas(), s = /* @__PURE__ */ requireCheckPropTypes(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(c) {
    var x = "Warning: " + c;
    typeof console != "undefined" && console.error(x);
    try {
      throw new Error(x);
    } catch {
    }
  });
  function l() {
    return null;
  }
  return factoryWithTypeCheckers = function(c, x) {
    var j = typeof Symbol == "function" && Symbol.iterator, Z = "@@iterator";
    function V(de) {
      var ge = de && (j && de[j] || de[Z]);
      if (typeof ge == "function")
        return ge;
    }
    var U = "<<anonymous>>", $ = {
      array: X("array"),
      bigint: X("bigint"),
      bool: X("boolean"),
      func: X("function"),
      number: X("number"),
      object: X("object"),
      string: X("string"),
      symbol: X("symbol"),
      any: K(),
      arrayOf: J,
      element: ee(),
      elementType: te(),
      instanceOf: ne,
      node: le(),
      objectOf: ie,
      oneOf: re,
      oneOfType: ue,
      shape: he,
      exact: fe
    };
    function Y(de, ge) {
      return de === ge ? de !== 0 || 1 / de === 1 / ge : de !== de && ge !== ge;
    }
    function G(de, ge) {
      this.message = de, this.data = ge && typeof ge == "object" ? ge : {}, this.stack = "";
    }
    G.prototype = Error.prototype;
    function W(de) {
      if (process.env.NODE_ENV !== "production")
        var ge = {}, Se = 0;
      function xe(Ce, ke, Re, _e, Me, we, Te) {
        if (_e = _e || U, we = we || Re, Te !== n) {
          if (x) {
            var be = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw be.name = "Invariant Violation", be;
          } else if (process.env.NODE_ENV !== "production" && typeof console != "undefined") {
            var Pe = _e + ":" + Re;
            !ge[Pe] && // Avoid spamming the console because they are often not actionable except for lib authors
            Se < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + we + "` prop on `" + _e + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), ge[Pe] = !0, Se++);
          }
        }
        return ke[Re] == null ? Ce ? ke[Re] === null ? new G("The " + Me + " `" + we + "` is marked as required " + ("in `" + _e + "`, but its value is `null`.")) : new G("The " + Me + " `" + we + "` is marked as required in " + ("`" + _e + "`, but its value is `undefined`.")) : null : de(ke, Re, _e, Me, we);
      }
      var Ee = xe.bind(null, !1);
      return Ee.isRequired = xe.bind(null, !0), Ee;
    }
    function X(de) {
      function ge(Se, xe, Ee, Ce, ke, Re) {
        var _e = Se[xe], Me = pe(_e);
        if (Me !== de) {
          var we = ve(_e);
          return new G(
            "Invalid " + Ce + " `" + ke + "` of type " + ("`" + we + "` supplied to `" + Ee + "`, expected ") + ("`" + de + "`."),
            { expectedType: de }
          );
        }
        return null;
      }
      return W(ge);
    }
    function K() {
      return W(l);
    }
    function J(de) {
      function ge(Se, xe, Ee, Ce, ke) {
        if (typeof de != "function")
          return new G("Property `" + ke + "` of component `" + Ee + "` has invalid PropType notation inside arrayOf.");
        var Re = Se[xe];
        if (!Array.isArray(Re)) {
          var _e = pe(Re);
          return new G("Invalid " + Ce + " `" + ke + "` of type " + ("`" + _e + "` supplied to `" + Ee + "`, expected an array."));
        }
        for (var Me = 0; Me < Re.length; Me++) {
          var we = de(Re, Me, Ee, Ce, ke + "[" + Me + "]", n);
          if (we instanceof Error)
            return we;
        }
        return null;
      }
      return W(ge);
    }
    function ee() {
      function de(ge, Se, xe, Ee, Ce) {
        var ke = ge[Se];
        if (!c(ke)) {
          var Re = pe(ke);
          return new G("Invalid " + Ee + " `" + Ce + "` of type " + ("`" + Re + "` supplied to `" + xe + "`, expected a single ReactElement."));
        }
        return null;
      }
      return W(de);
    }
    function te() {
      function de(ge, Se, xe, Ee, Ce) {
        var ke = ge[Se];
        if (!t.isValidElementType(ke)) {
          var Re = pe(ke);
          return new G("Invalid " + Ee + " `" + Ce + "` of type " + ("`" + Re + "` supplied to `" + xe + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return W(de);
    }
    function ne(de) {
      function ge(Se, xe, Ee, Ce, ke) {
        if (!(Se[xe] instanceof de)) {
          var Re = de.name || U, _e = me(Se[xe]);
          return new G("Invalid " + Ce + " `" + ke + "` of type " + ("`" + _e + "` supplied to `" + Ee + "`, expected ") + ("instance of `" + Re + "`."));
        }
        return null;
      }
      return W(ge);
    }
    function re(de) {
      if (!Array.isArray(de))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), l;
      function ge(Se, xe, Ee, Ce, ke) {
        for (var Re = Se[xe], _e = 0; _e < de.length; _e++)
          if (Y(Re, de[_e]))
            return null;
        var Me = JSON.stringify(de, function(Te, be) {
          var Pe = ve(be);
          return Pe === "symbol" ? String(be) : be;
        });
        return new G("Invalid " + Ce + " `" + ke + "` of value `" + String(Re) + "` " + ("supplied to `" + Ee + "`, expected one of " + Me + "."));
      }
      return W(ge);
    }
    function ie(de) {
      function ge(Se, xe, Ee, Ce, ke) {
        if (typeof de != "function")
          return new G("Property `" + ke + "` of component `" + Ee + "` has invalid PropType notation inside objectOf.");
        var Re = Se[xe], _e = pe(Re);
        if (_e !== "object")
          return new G("Invalid " + Ce + " `" + ke + "` of type " + ("`" + _e + "` supplied to `" + Ee + "`, expected an object."));
        for (var Me in Re)
          if (a(Re, Me)) {
            var we = de(Re, Me, Ee, Ce, ke + "." + Me, n);
            if (we instanceof Error)
              return we;
          }
        return null;
      }
      return W(ge);
    }
    function ue(de) {
      if (!Array.isArray(de))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), l;
      for (var ge = 0; ge < de.length; ge++) {
        var Se = de[ge];
        if (typeof Se != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ae(Se) + " at index " + ge + "."
          ), l;
      }
      function xe(Ee, Ce, ke, Re, _e) {
        for (var Me = [], we = 0; we < de.length; we++) {
          var Te = de[we], be = Te(Ee, Ce, ke, Re, _e, n);
          if (be == null)
            return null;
          be.data && a(be.data, "expectedType") && Me.push(be.data.expectedType);
        }
        var Pe = Me.length > 0 ? ", expected one of type [" + Me.join(", ") + "]" : "";
        return new G("Invalid " + Re + " `" + _e + "` supplied to " + ("`" + ke + "`" + Pe + "."));
      }
      return W(xe);
    }
    function le() {
      function de(ge, Se, xe, Ee, Ce) {
        return ce(ge[Se]) ? null : new G("Invalid " + Ee + " `" + Ce + "` supplied to " + ("`" + xe + "`, expected a ReactNode."));
      }
      return W(de);
    }
    function oe(de, ge, Se, xe, Ee) {
      return new G(
        (de || "React class") + ": " + ge + " type `" + Se + "." + xe + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + Ee + "`."
      );
    }
    function he(de) {
      function ge(Se, xe, Ee, Ce, ke) {
        var Re = Se[xe], _e = pe(Re);
        if (_e !== "object")
          return new G("Invalid " + Ce + " `" + ke + "` of type `" + _e + "` " + ("supplied to `" + Ee + "`, expected `object`."));
        for (var Me in de) {
          var we = de[Me];
          if (typeof we != "function")
            return oe(Ee, Ce, ke, Me, ve(we));
          var Te = we(Re, Me, Ee, Ce, ke + "." + Me, n);
          if (Te)
            return Te;
        }
        return null;
      }
      return W(ge);
    }
    function fe(de) {
      function ge(Se, xe, Ee, Ce, ke) {
        var Re = Se[xe], _e = pe(Re);
        if (_e !== "object")
          return new G("Invalid " + Ce + " `" + ke + "` of type `" + _e + "` " + ("supplied to `" + Ee + "`, expected `object`."));
        var Me = r({}, Se[xe], de);
        for (var we in Me) {
          var Te = de[we];
          if (a(de, we) && typeof Te != "function")
            return oe(Ee, Ce, ke, we, ve(Te));
          if (!Te)
            return new G(
              "Invalid " + Ce + " `" + ke + "` key `" + we + "` supplied to `" + Ee + "`.\nBad object: " + JSON.stringify(Se[xe], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(de), null, "  ")
            );
          var be = Te(Re, we, Ee, Ce, ke + "." + we, n);
          if (be)
            return be;
        }
        return null;
      }
      return W(ge);
    }
    function ce(de) {
      switch (typeof de) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !de;
        case "object":
          if (Array.isArray(de))
            return de.every(ce);
          if (de === null || c(de))
            return !0;
          var ge = V(de);
          if (ge) {
            var Se = ge.call(de), xe;
            if (ge !== de.entries) {
              for (; !(xe = Se.next()).done; )
                if (!ce(xe.value))
                  return !1;
            } else
              for (; !(xe = Se.next()).done; ) {
                var Ee = xe.value;
                if (Ee && !ce(Ee[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function se(de, ge) {
      return de === "symbol" ? !0 : ge ? ge["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && ge instanceof Symbol : !1;
    }
    function pe(de) {
      var ge = typeof de;
      return Array.isArray(de) ? "array" : de instanceof RegExp ? "object" : se(ge, de) ? "symbol" : ge;
    }
    function ve(de) {
      if (typeof de == "undefined" || de === null)
        return "" + de;
      var ge = pe(de);
      if (ge === "object") {
        if (de instanceof Date)
          return "date";
        if (de instanceof RegExp)
          return "regexp";
      }
      return ge;
    }
    function ae(de) {
      var ge = ve(de);
      switch (ge) {
        case "array":
        case "object":
          return "an " + ge;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + ge;
        default:
          return ge;
      }
    }
    function me(de) {
      return !de.constructor || !de.constructor.name ? U : de.constructor.name;
    }
    return $.checkPropTypes = s, $.resetWarningCache = s.resetWarningCache, $.PropTypes = $, $;
  }, factoryWithTypeCheckers;
}
var factoryWithThrowingShims, hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var t = /* @__PURE__ */ requireReactPropTypesSecret();
  function r() {
  }
  function n() {
  }
  return n.resetWarningCache = r, factoryWithThrowingShims = function() {
    function a(l, c, x, j, Z, V) {
      if (V !== t) {
        var U = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw U.name = "Invariant Violation", U;
      }
    }
    a.isRequired = a;
    function s() {
      return a;
    }
    var o = {
      array: a,
      bigint: a,
      bool: a,
      func: a,
      number: a,
      object: a,
      string: a,
      symbol: a,
      any: a,
      arrayOf: s,
      element: a,
      elementType: a,
      instanceOf: s,
      node: a,
      objectOf: s,
      oneOf: s,
      oneOfType: s,
      shape: s,
      exact: s,
      checkPropTypes: n,
      resetWarningCache: r
    };
    return o.PropTypes = o, o;
  }, factoryWithThrowingShims;
}
var hasRequiredPropTypes;
function requirePropTypes() {
  if (hasRequiredPropTypes) return propTypes.exports;
  if (hasRequiredPropTypes = 1, process.env.NODE_ENV !== "production") {
    var t = requireReactIs(), r = !0;
    propTypes.exports = /* @__PURE__ */ requireFactoryWithTypeCheckers()(t.isElement, r);
  } else
    propTypes.exports = /* @__PURE__ */ requireFactoryWithThrowingShims()();
  return propTypes.exports;
}
var domFns = {}, shims = {}, hasRequiredShims;
function requireShims() {
  if (hasRequiredShims) return shims;
  hasRequiredShims = 1, Object.defineProperty(shims, "__esModule", {
    value: !0
  }), shims.dontSetMe = s, shims.findInArray = t, shims.int = a, shims.isFunction = r, shims.isNum = n;
  function t(o, l) {
    for (let c = 0, x = o.length; c < x; c++)
      if (l.apply(l, [o[c], c, o])) return o[c];
  }
  function r(o) {
    return typeof o == "function" || Object.prototype.toString.call(o) === "[object Function]";
  }
  function n(o) {
    return typeof o == "number" && !isNaN(o);
  }
  function a(o) {
    return parseInt(o, 10);
  }
  function s(o, l, c) {
    if (o[l])
      return new Error(`Invalid prop ${l} passed to ${c} - do not set this, set it on the child.`);
  }
  return shims;
}
var getPrefix = {}, hasRequiredGetPrefix;
function requireGetPrefix() {
  if (hasRequiredGetPrefix) return getPrefix;
  hasRequiredGetPrefix = 1, Object.defineProperty(getPrefix, "__esModule", {
    value: !0
  }), getPrefix.browserPrefixToKey = n, getPrefix.browserPrefixToStyle = a, getPrefix.default = void 0, getPrefix.getPrefix = r;
  const t = ["Moz", "Webkit", "O", "ms"];
  function r() {
    var c, x;
    let o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "transform";
    if (typeof window == "undefined") return "";
    const l = (x = (c = window.document) == null ? void 0 : c.documentElement) == null ? void 0 : x.style;
    if (!l || o in l) return "";
    for (let j = 0; j < t.length; j++)
      if (n(o, t[j]) in l) return t[j];
    return "";
  }
  function n(o, l) {
    return l ? `${l}${s(o)}` : o;
  }
  function a(o, l) {
    return l ? `-${l.toLowerCase()}-${o}` : o;
  }
  function s(o) {
    let l = "", c = !0;
    for (let x = 0; x < o.length; x++)
      c ? (l += o[x].toUpperCase(), c = !1) : o[x] === "-" ? c = !0 : l += o[x];
    return l;
  }
  return getPrefix.default = r(), getPrefix;
}
var hasRequiredDomFns;
function requireDomFns() {
  if (hasRequiredDomFns) return domFns;
  hasRequiredDomFns = 1, Object.defineProperty(domFns, "__esModule", {
    value: !0
  }), domFns.addClassName = te, domFns.addEvent = l, domFns.addUserSelectStyles = K, domFns.createCSSTransform = $, domFns.createSVGTransform = Y, domFns.getTouch = W, domFns.getTouchIdentifier = X, domFns.getTranslation = G, domFns.innerHeight = Z, domFns.innerWidth = V, domFns.matchesSelector = s, domFns.matchesSelectorAndParentsTo = o, domFns.offsetXYFromParent = U, domFns.outerHeight = x, domFns.outerWidth = j, domFns.removeClassName = ne, domFns.removeEvent = c, domFns.scheduleRemoveUserSelectStyles = J;
  var t = requireShims(), r = n(requireGetPrefix());
  function n(re, ie) {
    if (typeof WeakMap == "function") var ue = /* @__PURE__ */ new WeakMap(), le = /* @__PURE__ */ new WeakMap();
    return (n = function(oe, he) {
      if (!he && oe && oe.__esModule) return oe;
      var fe, ce, se = { __proto__: null, default: oe };
      if (oe === null || typeof oe != "object" && typeof oe != "function") return se;
      if (fe = he ? le : ue) {
        if (fe.has(oe)) return fe.get(oe);
        fe.set(oe, se);
      }
      for (const pe in oe) pe !== "default" && {}.hasOwnProperty.call(oe, pe) && ((ce = (fe = Object.defineProperty) && Object.getOwnPropertyDescriptor(oe, pe)) && (ce.get || ce.set) ? fe(se, pe, ce) : se[pe] = oe[pe]);
      return se;
    })(re, ie);
  }
  let a = "";
  function s(re, ie) {
    return a || (a = (0, t.findInArray)(["matches", "webkitMatchesSelector", "mozMatchesSelector", "msMatchesSelector", "oMatchesSelector"], function(ue) {
      return (0, t.isFunction)(re[ue]);
    })), (0, t.isFunction)(re[a]) ? re[a](ie) : !1;
  }
  function o(re, ie, ue) {
    let le = re;
    do {
      if (s(le, ie)) return !0;
      if (le === ue) return !1;
      le = le.parentNode;
    } while (le);
    return !1;
  }
  function l(re, ie, ue, le) {
    if (!re) return;
    const oe = {
      capture: !0,
      ...le
    };
    re.addEventListener ? re.addEventListener(ie, ue, oe) : re.attachEvent ? re.attachEvent("on" + ie, ue) : re["on" + ie] = ue;
  }
  function c(re, ie, ue, le) {
    if (!re) return;
    const oe = {
      capture: !0,
      ...le
    };
    re.removeEventListener ? re.removeEventListener(ie, ue, oe) : re.detachEvent ? re.detachEvent("on" + ie, ue) : re["on" + ie] = null;
  }
  function x(re) {
    let ie = re.clientHeight;
    const ue = re.ownerDocument.defaultView.getComputedStyle(re);
    return ie += (0, t.int)(ue.borderTopWidth), ie += (0, t.int)(ue.borderBottomWidth), ie;
  }
  function j(re) {
    let ie = re.clientWidth;
    const ue = re.ownerDocument.defaultView.getComputedStyle(re);
    return ie += (0, t.int)(ue.borderLeftWidth), ie += (0, t.int)(ue.borderRightWidth), ie;
  }
  function Z(re) {
    let ie = re.clientHeight;
    const ue = re.ownerDocument.defaultView.getComputedStyle(re);
    return ie -= (0, t.int)(ue.paddingTop), ie -= (0, t.int)(ue.paddingBottom), ie;
  }
  function V(re) {
    let ie = re.clientWidth;
    const ue = re.ownerDocument.defaultView.getComputedStyle(re);
    return ie -= (0, t.int)(ue.paddingLeft), ie -= (0, t.int)(ue.paddingRight), ie;
  }
  function U(re, ie, ue) {
    const oe = ie === ie.ownerDocument.body ? {
      left: 0,
      top: 0
    } : ie.getBoundingClientRect(), he = (re.clientX + ie.scrollLeft - oe.left) / ue, fe = (re.clientY + ie.scrollTop - oe.top) / ue;
    return {
      x: he,
      y: fe
    };
  }
  function $(re, ie) {
    const ue = G(re, ie, "px");
    return {
      [(0, r.browserPrefixToKey)("transform", r.default)]: ue
    };
  }
  function Y(re, ie) {
    return G(re, ie, "");
  }
  function G(re, ie, ue) {
    let {
      x: le,
      y: oe
    } = re, he = `translate(${le}${ue},${oe}${ue})`;
    if (ie) {
      const fe = `${typeof ie.x == "string" ? ie.x : ie.x + ue}`, ce = `${typeof ie.y == "string" ? ie.y : ie.y + ue}`;
      he = `translate(${fe}, ${ce})` + he;
    }
    return he;
  }
  function W(re, ie) {
    return re.targetTouches && (0, t.findInArray)(re.targetTouches, (ue) => ie === ue.identifier) || re.changedTouches && (0, t.findInArray)(re.changedTouches, (ue) => ie === ue.identifier);
  }
  function X(re) {
    if (re.targetTouches && re.targetTouches[0]) return re.targetTouches[0].identifier;
    if (re.changedTouches && re.changedTouches[0]) return re.changedTouches[0].identifier;
  }
  function K(re) {
    if (!re) return;
    let ie = re.getElementById("react-draggable-style-el");
    ie || (ie = re.createElement("style"), ie.type = "text/css", ie.id = "react-draggable-style-el", ie.innerHTML = `.react-draggable-transparent-selection *::-moz-selection {all: inherit;}
`, ie.innerHTML += `.react-draggable-transparent-selection *::selection {all: inherit;}
`, re.getElementsByTagName("head")[0].appendChild(ie)), re.body && te(re.body, "react-draggable-transparent-selection");
  }
  function J(re) {
    window.requestAnimationFrame ? window.requestAnimationFrame(() => {
      ee(re);
    }) : ee(re);
  }
  function ee(re) {
    if (re)
      try {
        if (re.body && ne(re.body, "react-draggable-transparent-selection"), re.selection)
          re.selection.empty();
        else {
          const ie = (re.defaultView || window).getSelection();
          ie && ie.type !== "Caret" && ie.removeAllRanges();
        }
      } catch {
      }
  }
  function te(re, ie) {
    re.classList ? re.classList.add(ie) : re.className.match(new RegExp(`(?:^|\\s)${ie}(?!\\S)`)) || (re.className += ` ${ie}`);
  }
  function ne(re, ie) {
    re.classList ? re.classList.remove(ie) : re.className = re.className.replace(new RegExp(`(?:^|\\s)${ie}(?!\\S)`, "g"), "");
  }
  return domFns;
}
var positionFns = {}, hasRequiredPositionFns;
function requirePositionFns() {
  if (hasRequiredPositionFns) return positionFns;
  hasRequiredPositionFns = 1, Object.defineProperty(positionFns, "__esModule", {
    value: !0
  }), positionFns.canDragX = s, positionFns.canDragY = o, positionFns.createCoreData = c, positionFns.createDraggableData = x, positionFns.getBoundPosition = n, positionFns.getControlPosition = l, positionFns.snapToGrid = a;
  var t = requireShims(), r = requireDomFns();
  function n(V, U, $) {
    if (!V.props.bounds) return [U, $];
    let {
      bounds: Y
    } = V.props;
    Y = typeof Y == "string" ? Y : j(Y);
    const G = Z(V);
    if (typeof Y == "string") {
      const {
        ownerDocument: W
      } = G, X = W.defaultView;
      let K;
      if (Y === "parent" ? K = G.parentNode : K = G.getRootNode().querySelector(Y), !(K instanceof X.HTMLElement))
        throw new Error('Bounds selector "' + Y + '" could not find an element.');
      const J = K, ee = X.getComputedStyle(G), te = X.getComputedStyle(J);
      Y = {
        left: -G.offsetLeft + (0, t.int)(te.paddingLeft) + (0, t.int)(ee.marginLeft),
        top: -G.offsetTop + (0, t.int)(te.paddingTop) + (0, t.int)(ee.marginTop),
        right: (0, r.innerWidth)(J) - (0, r.outerWidth)(G) - G.offsetLeft + (0, t.int)(te.paddingRight) - (0, t.int)(ee.marginRight),
        bottom: (0, r.innerHeight)(J) - (0, r.outerHeight)(G) - G.offsetTop + (0, t.int)(te.paddingBottom) - (0, t.int)(ee.marginBottom)
      };
    }
    return (0, t.isNum)(Y.right) && (U = Math.min(U, Y.right)), (0, t.isNum)(Y.bottom) && ($ = Math.min($, Y.bottom)), (0, t.isNum)(Y.left) && (U = Math.max(U, Y.left)), (0, t.isNum)(Y.top) && ($ = Math.max($, Y.top)), [U, $];
  }
  function a(V, U, $) {
    const Y = Math.round(U / V[0]) * V[0], G = Math.round($ / V[1]) * V[1];
    return [Y, G];
  }
  function s(V) {
    return V.props.axis === "both" || V.props.axis === "x";
  }
  function o(V) {
    return V.props.axis === "both" || V.props.axis === "y";
  }
  function l(V, U, $) {
    const Y = typeof U == "number" ? (0, r.getTouch)(V, U) : null;
    if (typeof U == "number" && !Y) return null;
    const G = Z($), W = $.props.offsetParent || G.offsetParent || G.ownerDocument.body;
    return (0, r.offsetXYFromParent)(Y || V, W, $.props.scale);
  }
  function c(V, U, $) {
    const Y = !(0, t.isNum)(V.lastX), G = Z(V);
    return Y ? {
      node: G,
      deltaX: 0,
      deltaY: 0,
      lastX: U,
      lastY: $,
      x: U,
      y: $
    } : {
      node: G,
      deltaX: U - V.lastX,
      deltaY: $ - V.lastY,
      lastX: V.lastX,
      lastY: V.lastY,
      x: U,
      y: $
    };
  }
  function x(V, U) {
    const $ = V.props.scale;
    return {
      node: U.node,
      x: V.state.x + U.deltaX / $,
      y: V.state.y + U.deltaY / $,
      deltaX: U.deltaX / $,
      deltaY: U.deltaY / $,
      lastX: V.state.x,
      lastY: V.state.y
    };
  }
  function j(V) {
    return {
      left: V.left,
      top: V.top,
      right: V.right,
      bottom: V.bottom
    };
  }
  function Z(V) {
    const U = V.findDOMNode();
    if (!U)
      throw new Error("<DraggableCore>: Unmounted during event!");
    return U;
  }
  return positionFns;
}
var DraggableCore = {}, log$1 = {}, hasRequiredLog;
function requireLog() {
  if (hasRequiredLog) return log$1;
  hasRequiredLog = 1, Object.defineProperty(log$1, "__esModule", {
    value: !0
  }), log$1.default = t;
  function t() {
  }
  return log$1;
}
var hasRequiredDraggableCore;
function requireDraggableCore() {
  if (hasRequiredDraggableCore) return DraggableCore;
  hasRequiredDraggableCore = 1, Object.defineProperty(DraggableCore, "__esModule", {
    value: !0
  }), DraggableCore.default = void 0;
  var t = x(React__default), r = c(/* @__PURE__ */ requirePropTypes()), n = c(ReactDOM__default), a = requireDomFns(), s = requirePositionFns(), o = requireShims(), l = c(requireLog());
  function c(G) {
    return G && G.__esModule ? G : { default: G };
  }
  function x(G, W) {
    if (typeof WeakMap == "function") var X = /* @__PURE__ */ new WeakMap(), K = /* @__PURE__ */ new WeakMap();
    return (x = function(J, ee) {
      if (!ee && J && J.__esModule) return J;
      var te, ne, re = { __proto__: null, default: J };
      if (J === null || typeof J != "object" && typeof J != "function") return re;
      if (te = ee ? K : X) {
        if (te.has(J)) return te.get(J);
        te.set(J, re);
      }
      for (const ie in J) ie !== "default" && {}.hasOwnProperty.call(J, ie) && ((ne = (te = Object.defineProperty) && Object.getOwnPropertyDescriptor(J, ie)) && (ne.get || ne.set) ? te(re, ie, ne) : re[ie] = J[ie]);
      return re;
    })(G, W);
  }
  function j(G, W, X) {
    return (W = Z(W)) in G ? Object.defineProperty(G, W, { value: X, enumerable: !0, configurable: !0, writable: !0 }) : G[W] = X, G;
  }
  function Z(G) {
    var W = V(G, "string");
    return typeof W == "symbol" ? W : W + "";
  }
  function V(G, W) {
    if (typeof G != "object" || !G) return G;
    var X = G[Symbol.toPrimitive];
    if (X !== void 0) {
      var K = X.call(G, W);
      if (typeof K != "object") return K;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (W === "string" ? String : Number)(G);
  }
  const U = {
    touch: {
      start: "touchstart",
      move: "touchmove",
      stop: "touchend"
    },
    mouse: {
      start: "mousedown",
      move: "mousemove",
      stop: "mouseup"
    }
  };
  let $ = U.mouse, Y = class extends t.Component {
    constructor() {
      super(...arguments), j(this, "dragging", !1), j(this, "lastX", NaN), j(this, "lastY", NaN), j(this, "touchIdentifier", null), j(this, "mounted", !1), j(this, "handleDragStart", (W) => {
        if (this.props.onMouseDown(W), !this.props.allowAnyClick && typeof W.button == "number" && W.button !== 0) return !1;
        const X = this.findDOMNode();
        if (!X || !X.ownerDocument || !X.ownerDocument.body)
          throw new Error("<DraggableCore> not mounted on DragStart!");
        const {
          ownerDocument: K
        } = X;
        if (this.props.disabled || !(W.target instanceof K.defaultView.Node) || this.props.handle && !(0, a.matchesSelectorAndParentsTo)(W.target, this.props.handle, X) || this.props.cancel && (0, a.matchesSelectorAndParentsTo)(W.target, this.props.cancel, X))
          return;
        W.type === "touchstart" && !this.props.allowMobileScroll && W.preventDefault();
        const J = (0, a.getTouchIdentifier)(W);
        this.touchIdentifier = J;
        const ee = (0, s.getControlPosition)(W, J, this);
        if (ee == null) return;
        const {
          x: te,
          y: ne
        } = ee, re = (0, s.createCoreData)(this, te, ne);
        (0, l.default)("DraggableCore: handleDragStart: %j", re), (0, l.default)("calling", this.props.onStart), !(this.props.onStart(W, re) === !1 || this.mounted === !1) && (this.props.enableUserSelectHack && (0, a.addUserSelectStyles)(K), this.dragging = !0, this.lastX = te, this.lastY = ne, (0, a.addEvent)(K, $.move, this.handleDrag), (0, a.addEvent)(K, $.stop, this.handleDragStop));
      }), j(this, "handleDrag", (W) => {
        const X = (0, s.getControlPosition)(W, this.touchIdentifier, this);
        if (X == null) return;
        let {
          x: K,
          y: J
        } = X;
        if (Array.isArray(this.props.grid)) {
          let ne = K - this.lastX, re = J - this.lastY;
          if ([ne, re] = (0, s.snapToGrid)(this.props.grid, ne, re), !ne && !re) return;
          K = this.lastX + ne, J = this.lastY + re;
        }
        const ee = (0, s.createCoreData)(this, K, J);
        if ((0, l.default)("DraggableCore: handleDrag: %j", ee), this.props.onDrag(W, ee) === !1 || this.mounted === !1) {
          try {
            this.handleDragStop(new MouseEvent("mouseup"));
          } catch {
            const re = document.createEvent("MouseEvents");
            re.initMouseEvent("mouseup", !0, !0, window, 0, 0, 0, 0, 0, !1, !1, !1, !1, 0, null), this.handleDragStop(re);
          }
          return;
        }
        this.lastX = K, this.lastY = J;
      }), j(this, "handleDragStop", (W) => {
        if (!this.dragging) return;
        const X = (0, s.getControlPosition)(W, this.touchIdentifier, this);
        if (X == null) return;
        let {
          x: K,
          y: J
        } = X;
        if (Array.isArray(this.props.grid)) {
          let re = K - this.lastX || 0, ie = J - this.lastY || 0;
          [re, ie] = (0, s.snapToGrid)(this.props.grid, re, ie), K = this.lastX + re, J = this.lastY + ie;
        }
        const ee = (0, s.createCoreData)(this, K, J);
        if (this.props.onStop(W, ee) === !1 || this.mounted === !1) return !1;
        const ne = this.findDOMNode();
        ne && this.props.enableUserSelectHack && (0, a.scheduleRemoveUserSelectStyles)(ne.ownerDocument), (0, l.default)("DraggableCore: handleDragStop: %j", ee), this.dragging = !1, this.lastX = NaN, this.lastY = NaN, ne && ((0, l.default)("DraggableCore: Removing handlers"), (0, a.removeEvent)(ne.ownerDocument, $.move, this.handleDrag), (0, a.removeEvent)(ne.ownerDocument, $.stop, this.handleDragStop));
      }), j(this, "onMouseDown", (W) => ($ = U.mouse, this.handleDragStart(W))), j(this, "onMouseUp", (W) => ($ = U.mouse, this.handleDragStop(W))), j(this, "onTouchStart", (W) => ($ = U.touch, this.handleDragStart(W))), j(this, "onTouchEnd", (W) => ($ = U.touch, this.handleDragStop(W)));
    }
    componentDidMount() {
      this.mounted = !0;
      const W = this.findDOMNode();
      W && (0, a.addEvent)(W, U.touch.start, this.onTouchStart, {
        passive: !1
      });
    }
    componentWillUnmount() {
      this.mounted = !1;
      const W = this.findDOMNode();
      if (W) {
        const {
          ownerDocument: X
        } = W;
        (0, a.removeEvent)(X, U.mouse.move, this.handleDrag), (0, a.removeEvent)(X, U.touch.move, this.handleDrag), (0, a.removeEvent)(X, U.mouse.stop, this.handleDragStop), (0, a.removeEvent)(X, U.touch.stop, this.handleDragStop), (0, a.removeEvent)(W, U.touch.start, this.onTouchStart, {
          passive: !1
        }), this.props.enableUserSelectHack && (0, a.scheduleRemoveUserSelectStyles)(X);
      }
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
    findDOMNode() {
      var W, X, K;
      return (W = this.props) != null && W.nodeRef ? (K = (X = this.props) == null ? void 0 : X.nodeRef) == null ? void 0 : K.current : n.default.findDOMNode(this);
    }
    render() {
      return /* @__PURE__ */ t.cloneElement(t.Children.only(this.props.children), {
        // Note: mouseMove handler is attached to document so it will still function
        // when the user drags quickly and leaves the bounds of the element.
        onMouseDown: this.onMouseDown,
        onMouseUp: this.onMouseUp,
        // onTouchStart is added on `componentDidMount` so they can be added with
        // {passive: false}, which allows it to cancel. See
        // https://developers.google.com/web/updates/2017/01/scrolling-intervention
        onTouchEnd: this.onTouchEnd
      });
    }
  };
  return DraggableCore.default = Y, j(Y, "displayName", "DraggableCore"), j(Y, "propTypes", {
    /**
     * `allowAnyClick` allows dragging using any mouse button.
     * By default, we only accept the left button.
     *
     * Defaults to `false`.
     */
    allowAnyClick: r.default.bool,
    /**
     * `allowMobileScroll` turns off cancellation of the 'touchstart' event
     * on mobile devices. Only enable this if you are having trouble with click
     * events. Prefer using 'handle' / 'cancel' instead.
     *
     * Defaults to `false`.
     */
    allowMobileScroll: r.default.bool,
    children: r.default.node.isRequired,
    /**
     * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
     * with the exception of `onMouseDown`, will not fire.
     */
    disabled: r.default.bool,
    /**
     * By default, we add 'user-select:none' attributes to the document body
     * to prevent ugly text selection during drag. If this is causing problems
     * for your app, set this to `false`.
     */
    enableUserSelectHack: r.default.bool,
    /**
     * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
     * instead of using the parent node.
     */
    offsetParent: function(G, W) {
      if (G[W] && G[W].nodeType !== 1)
        throw new Error("Draggable's offsetParent must be a DOM Node.");
    },
    /**
     * `grid` specifies the x and y that dragging should snap to.
     */
    grid: r.default.arrayOf(r.default.number),
    /**
     * `handle` specifies a selector to be used as the handle that initiates drag.
     *
     * Example:
     *
     * ```jsx
     *   let App = React.createClass({
     *       render: function () {
     *         return (
     *            <Draggable handle=".handle">
     *              <div>
     *                  <div className="handle">Click me to drag</div>
     *                  <div>This is some other content</div>
     *              </div>
     *           </Draggable>
     *         );
     *       }
     *   });
     * ```
     */
    handle: r.default.string,
    /**
     * `cancel` specifies a selector to be used to prevent drag initialization.
     *
     * Example:
     *
     * ```jsx
     *   let App = React.createClass({
     *       render: function () {
     *           return(
     *               <Draggable cancel=".cancel">
     *                   <div>
     *                     <div className="cancel">You can't drag from here</div>
     *                     <div>Dragging here works fine</div>
     *                   </div>
     *               </Draggable>
     *           );
     *       }
     *   });
     * ```
     */
    cancel: r.default.string,
    /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
     * Unfortunately, in order for <Draggable> to work properly, we need raw access
     * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
     * as in this example:
     *
     * function MyComponent() {
     *   const nodeRef = React.useRef(null);
     *   return (
     *     <Draggable nodeRef={nodeRef}>
     *       <div ref={nodeRef}>Example Target</div>
     *     </Draggable>
     *   );
     * }
     *
     * This can be used for arbitrarily nested components, so long as the ref ends up
     * pointing to the actual child DOM node and not a custom component.
     */
    nodeRef: r.default.object,
    /**
     * Called when dragging starts.
     * If this function returns the boolean false, dragging will be canceled.
     */
    onStart: r.default.func,
    /**
     * Called while dragging.
     * If this function returns the boolean false, dragging will be canceled.
     */
    onDrag: r.default.func,
    /**
     * Called when dragging stops.
     * If this function returns the boolean false, the drag will remain active.
     */
    onStop: r.default.func,
    /**
     * A workaround option which can be passed if onMouseDown needs to be accessed,
     * since it'll always be blocked (as there is internal use of onMouseDown)
     */
    onMouseDown: r.default.func,
    /**
     * `scale`, if set, applies scaling while dragging an element
     */
    scale: r.default.number,
    /**
     * These properties should be defined on the child, not here.
     */
    className: o.dontSetMe,
    style: o.dontSetMe,
    transform: o.dontSetMe
  }), j(Y, "defaultProps", {
    allowAnyClick: !1,
    // by default only accept left click
    allowMobileScroll: !1,
    disabled: !1,
    enableUserSelectHack: !0,
    onStart: function() {
    },
    onDrag: function() {
    },
    onStop: function() {
    },
    onMouseDown: function() {
    },
    scale: 1
  }), DraggableCore;
}
var hasRequiredDraggable;
function requireDraggable() {
  return hasRequiredDraggable || (hasRequiredDraggable = 1, (function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "DraggableCore", {
      enumerable: !0,
      get: function() {
        return x.default;
      }
    }), t.default = void 0;
    var r = V(React__default), n = Z(/* @__PURE__ */ requirePropTypes()), a = Z(ReactDOM__default), s = clsx, o = requireDomFns(), l = requirePositionFns(), c = requireShims(), x = Z(requireDraggableCore()), j = Z(requireLog());
    function Z(X) {
      return X && X.__esModule ? X : { default: X };
    }
    function V(X, K) {
      if (typeof WeakMap == "function") var J = /* @__PURE__ */ new WeakMap(), ee = /* @__PURE__ */ new WeakMap();
      return (V = function(te, ne) {
        if (!ne && te && te.__esModule) return te;
        var re, ie, ue = { __proto__: null, default: te };
        if (te === null || typeof te != "object" && typeof te != "function") return ue;
        if (re = ne ? ee : J) {
          if (re.has(te)) return re.get(te);
          re.set(te, ue);
        }
        for (const le in te) le !== "default" && {}.hasOwnProperty.call(te, le) && ((ie = (re = Object.defineProperty) && Object.getOwnPropertyDescriptor(te, le)) && (ie.get || ie.set) ? re(ue, le, ie) : ue[le] = te[le]);
        return ue;
      })(X, K);
    }
    function U() {
      return U = Object.assign ? Object.assign.bind() : function(X) {
        for (var K = 1; K < arguments.length; K++) {
          var J = arguments[K];
          for (var ee in J) ({}).hasOwnProperty.call(J, ee) && (X[ee] = J[ee]);
        }
        return X;
      }, U.apply(null, arguments);
    }
    function $(X, K, J) {
      return (K = Y(K)) in X ? Object.defineProperty(X, K, { value: J, enumerable: !0, configurable: !0, writable: !0 }) : X[K] = J, X;
    }
    function Y(X) {
      var K = G(X, "string");
      return typeof K == "symbol" ? K : K + "";
    }
    function G(X, K) {
      if (typeof X != "object" || !X) return X;
      var J = X[Symbol.toPrimitive];
      if (J !== void 0) {
        var ee = J.call(X, K);
        if (typeof ee != "object") return ee;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (K === "string" ? String : Number)(X);
    }
    class W extends r.Component {
      // React 16.3+
      // Arity (props, state)
      static getDerivedStateFromProps(K, J) {
        let {
          position: ee
        } = K, {
          prevPropsPosition: te
        } = J;
        return ee && (!te || ee.x !== te.x || ee.y !== te.y) ? ((0, j.default)("Draggable: getDerivedStateFromProps %j", {
          position: ee,
          prevPropsPosition: te
        }), {
          x: ee.x,
          y: ee.y,
          prevPropsPosition: {
            ...ee
          }
        }) : null;
      }
      constructor(K) {
        super(K), $(this, "onDragStart", (J, ee) => {
          if ((0, j.default)("Draggable: onDragStart: %j", ee), this.props.onStart(J, (0, l.createDraggableData)(this, ee)) === !1) return !1;
          this.setState({
            dragging: !0,
            dragged: !0
          });
        }), $(this, "onDrag", (J, ee) => {
          if (!this.state.dragging) return !1;
          (0, j.default)("Draggable: onDrag: %j", ee);
          const te = (0, l.createDraggableData)(this, ee), ne = {
            x: te.x,
            y: te.y,
            slackX: 0,
            slackY: 0
          };
          if (this.props.bounds) {
            const {
              x: ie,
              y: ue
            } = ne;
            ne.x += this.state.slackX, ne.y += this.state.slackY;
            const [le, oe] = (0, l.getBoundPosition)(this, ne.x, ne.y);
            ne.x = le, ne.y = oe, ne.slackX = this.state.slackX + (ie - ne.x), ne.slackY = this.state.slackY + (ue - ne.y), te.x = ne.x, te.y = ne.y, te.deltaX = ne.x - this.state.x, te.deltaY = ne.y - this.state.y;
          }
          if (this.props.onDrag(J, te) === !1) return !1;
          this.setState(ne);
        }), $(this, "onDragStop", (J, ee) => {
          if (!this.state.dragging || this.props.onStop(J, (0, l.createDraggableData)(this, ee)) === !1) return !1;
          (0, j.default)("Draggable: onDragStop: %j", ee);
          const ne = {
            dragging: !1,
            slackX: 0,
            slackY: 0
          };
          if (!!this.props.position) {
            const {
              x: ie,
              y: ue
            } = this.props.position;
            ne.x = ie, ne.y = ue;
          }
          this.setState(ne);
        }), this.state = {
          // Whether or not we are currently dragging.
          dragging: !1,
          // Whether or not we have been dragged before.
          dragged: !1,
          // Current transform x and y.
          x: K.position ? K.position.x : K.defaultPosition.x,
          y: K.position ? K.position.y : K.defaultPosition.y,
          prevPropsPosition: {
            ...K.position
          },
          // Used for compensating for out-of-bounds drags
          slackX: 0,
          slackY: 0,
          // Can only determine if SVG after mounting
          isElementSVG: !1
        }, K.position && !(K.onDrag || K.onStop) && console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element.");
      }
      componentDidMount() {
        typeof window.SVGElement != "undefined" && this.findDOMNode() instanceof window.SVGElement && this.setState({
          isElementSVG: !0
        });
      }
      componentWillUnmount() {
        this.state.dragging && this.setState({
          dragging: !1
        });
      }
      // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
      // the underlying DOM node ourselves. See the README for more information.
      findDOMNode() {
        var K, J, ee;
        return (ee = (J = (K = this.props) == null ? void 0 : K.nodeRef) == null ? void 0 : J.current) != null ? ee : a.default.findDOMNode(this);
      }
      render() {
        const {
          axis: K,
          bounds: J,
          children: ee,
          defaultPosition: te,
          defaultClassName: ne,
          defaultClassNameDragging: re,
          defaultClassNameDragged: ie,
          position: ue,
          positionOffset: le,
          scale: oe,
          ...he
        } = this.props;
        let fe = {}, ce = null;
        const pe = !!!ue || this.state.dragging, ve = ue || te, ae = {
          // Set left if horizontal drag is enabled
          x: (0, l.canDragX)(this) && pe ? this.state.x : ve.x,
          // Set top if vertical drag is enabled
          y: (0, l.canDragY)(this) && pe ? this.state.y : ve.y
        };
        this.state.isElementSVG ? ce = (0, o.createSVGTransform)(ae, le) : fe = (0, o.createCSSTransform)(ae, le);
        const me = (0, s.clsx)(ee.props.className || "", ne, {
          [re]: this.state.dragging,
          [ie]: this.state.dragged
        });
        return /* @__PURE__ */ r.createElement(x.default, U({}, he, {
          onStart: this.onDragStart,
          onDrag: this.onDrag,
          onStop: this.onDragStop
        }), /* @__PURE__ */ r.cloneElement(r.Children.only(ee), {
          className: me,
          style: {
            ...ee.props.style,
            ...fe
          },
          transform: ce
        }));
      }
    }
    t.default = W, $(W, "displayName", "Draggable"), $(W, "propTypes", {
      // Accepts all props <DraggableCore> accepts.
      ...x.default.propTypes,
      /**
       * `axis` determines which axis the draggable can move.
       *
       *  Note that all callbacks will still return data as normal. This only
       *  controls flushing to the DOM.
       *
       * 'both' allows movement horizontally and vertically.
       * 'x' limits movement to horizontal axis.
       * 'y' limits movement to vertical axis.
       * 'none' limits all movement.
       *
       * Defaults to 'both'.
       */
      axis: n.default.oneOf(["both", "x", "y", "none"]),
      /**
       * `bounds` determines the range of movement available to the element.
       * Available values are:
       *
       * 'parent' restricts movement within the Draggable's parent node.
       *
       * Alternatively, pass an object with the following properties, all of which are optional:
       *
       * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
       *
       * All values are in px.
       *
       * Example:
       *
       * ```jsx
       *   let App = React.createClass({
       *       render: function () {
       *         return (
       *            <Draggable bounds={{right: 300, bottom: 300}}>
       *              <div>Content</div>
       *           </Draggable>
       *         );
       *       }
       *   });
       * ```
       */
      bounds: n.default.oneOfType([n.default.shape({
        left: n.default.number,
        right: n.default.number,
        top: n.default.number,
        bottom: n.default.number
      }), n.default.string, n.default.oneOf([!1])]),
      defaultClassName: n.default.string,
      defaultClassNameDragging: n.default.string,
      defaultClassNameDragged: n.default.string,
      /**
       * `defaultPosition` specifies the x and y that the dragged item should start at
       *
       * Example:
       *
       * ```jsx
       *      let App = React.createClass({
       *          render: function () {
       *              return (
       *                  <Draggable defaultPosition={{x: 25, y: 25}}>
       *                      <div>I start with transformX: 25px and transformY: 25px;</div>
       *                  </Draggable>
       *              );
       *          }
       *      });
       * ```
       */
      defaultPosition: n.default.shape({
        x: n.default.number,
        y: n.default.number
      }),
      positionOffset: n.default.shape({
        x: n.default.oneOfType([n.default.number, n.default.string]),
        y: n.default.oneOfType([n.default.number, n.default.string])
      }),
      /**
       * `position`, if present, defines the current position of the element.
       *
       *  This is similar to how form elements in React work - if no `position` is supplied, the component
       *  is uncontrolled.
       *
       * Example:
       *
       * ```jsx
       *      let App = React.createClass({
       *          render: function () {
       *              return (
       *                  <Draggable position={{x: 25, y: 25}}>
       *                      <div>I start with transformX: 25px and transformY: 25px;</div>
       *                  </Draggable>
       *              );
       *          }
       *      });
       * ```
       */
      position: n.default.shape({
        x: n.default.number,
        y: n.default.number
      }),
      /**
       * These properties should be defined on the child, not here.
       */
      className: c.dontSetMe,
      style: c.dontSetMe,
      transform: c.dontSetMe
    }), $(W, "defaultProps", {
      ...x.default.defaultProps,
      axis: "both",
      bounds: !1,
      defaultClassName: "react-draggable",
      defaultClassNameDragging: "react-draggable-dragging",
      defaultClassNameDragged: "react-draggable-dragged",
      defaultPosition: {
        x: 0,
        y: 0
      },
      scale: 1
    });
  })(Draggable)), Draggable;
}
var hasRequiredCjs;
function requireCjs() {
  if (hasRequiredCjs) return cjs.exports;
  hasRequiredCjs = 1;
  const {
    default: t,
    DraggableCore: r
  } = requireDraggable();
  return cjs.exports = t, cjs.exports.default = t, cjs.exports.DraggableCore = r, cjs.exports;
}
var cjsExports = requireCjs(), extendStatics = function(t, r) {
  return extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, a) {
    n.__proto__ = a;
  } || function(n, a) {
    for (var s in a) Object.prototype.hasOwnProperty.call(a, s) && (n[s] = a[s]);
  }, extendStatics(t, r);
};
function __extends(t, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
  extendStatics(t, r);
  function n() {
    this.constructor = t;
  }
  t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
}
var __assign = function() {
  return __assign = Object.assign || function(r) {
    for (var n, a = 1, s = arguments.length; a < s; a++) {
      n = arguments[a];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (r[o] = n[o]);
    }
    return r;
  }, __assign.apply(this, arguments);
};
function __rest(t, r) {
  var n = {};
  for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && r.indexOf(a) < 0 && (n[a] = t[a]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var s = 0, a = Object.getOwnPropertySymbols(t); s < a.length; s++)
      r.indexOf(a[s]) < 0 && Object.prototype.propertyIsEnumerable.call(t, a[s]) && (n[a[s]] = t[a[s]]);
  return n;
}
function __spreadArray(t, r, n) {
  for (var a = 0, s = r.length, o; a < s; a++)
    (o || !(a in r)) && (o || (o = Array.prototype.slice.call(r, 0, a)), o[a] = r[a]);
  return t.concat(o || Array.prototype.slice.call(r));
}
function _typeof(t) {
  "@babel/helpers - typeof";
  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, _typeof(t);
}
var doc = (typeof document == "undefined" ? "undefined" : _typeof(document)) === "object" ? document : null, isBrowser = typeof window != "undefined" && typeof navigator != "undefined" && typeof document != "undefined", isUndef = function t(r) {
  return typeof r == "undefined";
}, isFun = function t(r) {
  return typeof r == "function";
}, isNum = function t(r) {
  return typeof r == "number";
}, renderDivWithRenderer = function t(r, n) {
  if (isFun(r.renderer)) {
    r.elementRef = n;
    var a = r.renderer;
    return delete r.renderer, a(r);
  }
  return delete r.elementRef, React.createElement("div", __assign({}, r, {
    ref: n
  }));
}, getInnerSize = function t(r, n, a, s) {
  var o = getComputedStyle(r);
  return o.boxSizing === "border-box" ? Math.max(0, (Number.parseFloat(o[n]) || 0) - (Number.parseFloat(o[a]) || 0) - (Number.parseFloat(o[s]) || 0)) : Number.parseFloat(o[n]) || 0;
}, getInnerHeight = function t(r) {
  return getInnerSize(r, "height", "paddingTop", "paddingBottom");
}, getInnerWidth = function t(r) {
  return getInnerSize(r, "width", "paddingLeft", "paddingRight");
}, uuid = function t() {
  for (var r = "", n = 0; n < 32; n++)
    switch (n) {
      case 8:
      case 20: {
        r += "-".concat(Math.trunc(Math.random() * 16).toString(16));
        break;
      }
      case 12: {
        r += "-4";
        break;
      }
      case 16: {
        r += "-".concat((Math.random() * 16 | 0 | 8).toString(16));
        break;
      }
      default:
        r += Math.trunc(Math.random() * 16).toString(16);
    }
  return r;
}, calcThumbSize = function t(r, n, a, s, o) {
  if (n >= r)
    return 0;
  var l = n / r * a;
  return isNum(o) && (l = Math.min(o, l)), isNum(s) && (l = Math.max(s, l)), l;
}, calcThumbOffset = function t(r, n, a, s, o) {
  return !o || !s || n >= r ? 0 : (a - s) * o / (r - n);
}, calcScrollForThumbOffset = function t(r, n, a, s, o) {
  return !o || !s || n >= r ? 0 : o * (r - n) / (a - s);
}, getScrollbarWidth = function t(r) {
  if (r === void 0 && (r = !1), !doc)
    return t._cache = 0, t._cache;
  if (!r && !isUndef(t._cache))
    return t._cache;
  var n = doc.createElement("div");
  if (n.setAttribute("style", "position:absolute;width:100px;height:100px;top:-999px;left:-999px;overflow:scroll;"), doc.body.append(n), n.clientWidth === 0) {
    n.remove();
    return;
  }
  return t._cache = 100 - n.clientWidth, n.remove(), t._cache;
}, shouldReverseRtlScroll = function t(r) {
  if (r === void 0 && (r = !1), !r && !isUndef(t._cache))
    return t._cache;
  if (!doc)
    return t._cache = !1, t._cache;
  var n = doc.createElement("div"), a = doc.createElement("div");
  return n.append(a), n.setAttribute("style", "position:absolute;width:100px;height:100px;top:-999px;left:-999px;overflow:scroll;direction:rtl"), a.setAttribute("style", "width:1000px;height:1000px"), doc.body.append(n), n.scrollLeft = -50, t._cache = n.scrollLeft === -50, n.remove(), t._cache;
}, Emittr = (
  /** @class */
  (function() {
    function t(r) {
      r === void 0 && (r = 10), this.setMaxHandlers(r), this._handlers = /* @__PURE__ */ Object.create(null);
    }
    return t._callEventHandlers = function(r, n, a) {
      if (n.length) {
        if (n.length === 1) {
          Reflect.apply(n[0], r, a);
          return;
        }
        n = __spreadArray([], n);
        var s;
        for (s = 0; s < n.length; s++)
          Reflect.apply(n[s], r, a);
      }
    }, t.prototype.setMaxHandlers = function(r) {
      if (!isNum(r) || r <= 0)
        throw new TypeError("Expected maxHandlers to be a positive number, got '".concat(r, "' of type ").concat(_typeof(r)));
      return this._maxHandlers = r, this;
    }, t.prototype.getMaxHandlers = function() {
      return this._maxHandlers;
    }, t.prototype.emit = function(r) {
      for (var n = [], a = 1; a < arguments.length; a++)
        n[a - 1] = arguments[a];
      return _typeof(this._handlers[r]) !== "object" || !Array.isArray(this._handlers[r]) ? !1 : (t._callEventHandlers(this, this._handlers[r], n), !0);
    }, t.prototype.on = function(r, n) {
      return t._addHandler(this, r, n), this;
    }, t.prototype.prependOn = function(r, n) {
      return t._addHandler(this, r, n, !0), this;
    }, t.prototype.once = function(r, n) {
      if (!isFun(n))
        throw new TypeError("Expected event handler to be a function, got ".concat(_typeof(n)));
      return t._addHandler(this, r, this._wrapOnceHandler(r, n)), this;
    }, t.prototype.prependOnce = function(r, n) {
      if (!isFun(n))
        throw new TypeError("Expected event handler to be a function, got ".concat(_typeof(n)));
      return t._addHandler(this, r, this._wrapOnceHandler(r, n), !0), this;
    }, t.prototype.off = function(r, n) {
      return t._removeHandler(this, r, n), this;
    }, t.prototype.removeAllHandlers = function() {
      var r = this._handlers;
      this._handlers = /* @__PURE__ */ Object.create(null);
      var n = r.removeHandler;
      delete r.removeHandler;
      var a, s;
      for (s in r)
        for (a = r[s].length - 1; a >= 0; a--)
          t._callEventHandlers(this, n, [s, r[s][a].handler || r[s][a]]);
      return this;
    }, t.prototype._wrapOnceHandler = function(r, n) {
      var a = {
        fired: !1,
        handler: n,
        wrappedHandler: void 0,
        emitter: this,
        event: r
      }, s = t._onceWrapper.bind(a);
      return a.wrappedHandler = s, s.handler = n, s.event = r, s;
    }, t._addHandler = function(r, n, a, s) {
      if (s === void 0 && (s = !1), !isFun(a))
        throw new TypeError("Expected event handler to be a function, got ".concat(_typeof(a)));
      return r._handlers[n] = r._handlers[n] || [], r.emit("addHandler", n, a), s ? r._handlers[n].unshift(a) : r._handlers[n].push(a), r;
    }, t._onceWrapper = function() {
      for (var n = [], a = 0; a < arguments.length; a++)
        n[a] = arguments[a];
      this.fired || (this.fired = !0, this.emitter.off(this.event, this.wrappedHandler), Reflect.apply(this.handler, this.emitter, n));
    }, t._removeHandler = function(r, n, a) {
      if (!isFun(a))
        throw new TypeError("Expected event handler to be a function, got ".concat(_typeof(a)));
      if (isUndef(r._handlers[n]) || !r._handlers[n].length)
        return r;
      var s = -1;
      if (r._handlers[n].length === 1)
        (r._handlers[n][0] === a || r._handlers[n][0].handler === a) && (s = 0, a = r._handlers[n][0].handler || r._handlers[n][0]);
      else
        for (s = r._handlers[n].length - 1; s >= 0; s--)
          if (r._handlers[n][s] === a || r._handlers[n][s].handler === a) {
            a = r._handlers[n][s].handler || r._handlers[n][s];
            break;
          }
      return s === -1 || (s === 0 ? r._handlers[n].shift() : r._handlers[n].splice(s, 1), r.emit("removeHandler", n, a)), r;
    }, t;
  })()
), RAFLoop = (
  /** @class */
  (function() {
    function t() {
      var r = this;
      this.targets = [], this.animationFrameID = 0, this._isActive = !1, this.start = function() {
        return !r._isActive && r.targets.length && (r._isActive = !0, r.animationFrameID && cancelAnimationFrame(r.animationFrameID), r.animationFrameID = requestAnimationFrame(r.rafCallback)), r;
      }, this.stop = function() {
        return r._isActive && (r._isActive = !1, r.animationFrameID && cancelAnimationFrame(r.animationFrameID), r.animationFrameID = 0), r;
      }, this.addTarget = function(n, a) {
        return a === void 0 && (a = !1), r.targets.includes(n) || (r.targets.push(n), r.targets.length === 1 && !a && r.start()), r;
      }, this.removeTarget = function(n) {
        var a = r.targets.indexOf(n);
        return a !== -1 && (r.targets.splice(a, 1), r.targets.length === 0 && r.stop()), r;
      }, this.rafCallback = function() {
        if (!r._isActive)
          return 0;
        for (var n = 0; n < r.targets.length; n++)
          r.targets[n]._unmounted || r.targets[n].update();
        return r.animationFrameID = requestAnimationFrame(r.rafCallback), r.animationFrameID;
      };
    }
    return Object.defineProperty(t.prototype, "isActive", {
      /**
       * @description Loop's state.
       */
      get: function() {
        return this._isActive;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  })()
), Loop = new RAFLoop(), AXIS_DIRECTION;
(function(t) {
  t.X = "x", t.Y = "y";
})(AXIS_DIRECTION || (AXIS_DIRECTION = {}));
var TRACK_CLICK_BEHAVIOR;
(function(t) {
  t.JUMP = "jump", t.STEP = "step";
})(TRACK_CLICK_BEHAVIOR || (TRACK_CLICK_BEHAVIOR = {}));
var ScrollbarThumb = (
  /** @class */
  (function(t) {
    __extends(r, t);
    function r() {
      var n = t !== null && t.apply(this, arguments) || this;
      return n.element = null, n.initialOffsetX = 0, n.initialOffsetY = 0, n.elementRefHack = React.createRef(), n.lastDragData = {
        x: 0,
        y: 0,
        deltaX: 0,
        deltaY: 0,
        lastX: 0,
        lastY: 0
      }, n.handleOnDragStart = function(a, s) {
        if (!n.element) {
          n.handleOnDragStop(a, s);
          return;
        }
        isBrowser && (n.prevUserSelect = document.body.style.userSelect, document.body.style.userSelect = "none", n.prevOnSelectStart = document.onselectstart, document.addEventListener("selectstart", r.selectStartReplacer)), n.props.onDragStart && n.props.onDragStart(n.lastDragData = {
          x: s.x - n.initialOffsetX,
          y: s.y - n.initialOffsetY,
          lastX: s.lastX - n.initialOffsetX,
          lastY: s.lastY - n.initialOffsetY,
          deltaX: s.deltaX,
          deltaY: s.deltaY
        }), n.element.classList.add("dragging");
      }, n.handleOnDrag = function(a, s) {
        if (!n.element) {
          n.handleOnDragStop(a, s);
          return;
        }
        n.props.onDrag && n.props.onDrag(n.lastDragData = {
          x: s.x - n.initialOffsetX,
          y: s.y - n.initialOffsetY,
          lastX: s.lastX - n.initialOffsetX,
          lastY: s.lastY - n.initialOffsetY,
          deltaX: s.deltaX,
          deltaY: s.deltaY
        });
      }, n.handleOnDragStop = function(a, s) {
        var o = s ? {
          x: s.x - n.initialOffsetX,
          y: s.y - n.initialOffsetY,
          lastX: s.lastX - n.initialOffsetX,
          lastY: s.lastY - n.initialOffsetY,
          deltaX: s.deltaX,
          deltaY: s.deltaY
        } : n.lastDragData;
        n.props.onDragEnd && n.props.onDragEnd(o), n.element && n.element.classList.remove("dragging"), isBrowser && (document.body.style.userSelect = n.prevUserSelect, n.prevOnSelectStart && document.addEventListener("selectstart", n.prevOnSelectStart), n.prevOnSelectStart = null), n.initialOffsetX = 0, n.initialOffsetY = 0, n.lastDragData = {
          x: 0,
          y: 0,
          deltaX: 0,
          deltaY: 0,
          lastX: 0,
          lastY: 0
        };
      }, n.handleOnMouseDown = function(a) {
        if (n.element)
          if (a.preventDefault(), a.stopPropagation(), !isUndef(a.offsetX))
            n.initialOffsetX = a.offsetX, n.initialOffsetY = a.offsetY;
          else {
            var s = n.element.getBoundingClientRect();
            n.initialOffsetX = (a.clientX || a.touches[0].clientX) - s.left, n.initialOffsetY = (a.clientY || a.touches[0].clientY) - s.top;
          }
      }, n.elementRef = function(a) {
        isFun(n.props.elementRef) && n.props.elementRef(a), n.element = a, n.elementRefHack.current = a;
      }, n;
    }
    return r.prototype.componentDidMount = function() {
      this.element || this.setState(function() {
        throw new Error("<ScrollbarThumb> Element was not created. Possibly you haven't provided HTMLDivElement to renderer's `elementRef` function.");
      });
    }, r.prototype.componentWillUnmount = function() {
      this.handleOnDragStop(), this.elementRef(null);
    }, r.prototype.render = function() {
      var n = this.props;
      n.elementRef;
      var a = n.axis;
      n.onDrag, n.onDragEnd, n.onDragStart;
      var s = __rest(n, ["elementRef", "axis", "onDrag", "onDragEnd", "onDragStart"]);
      return s.className = cnb("ScrollbarsCustom-Thumb", a === AXIS_DIRECTION.X ? "ScrollbarsCustom-ThumbX" : "ScrollbarsCustom-ThumbY", s.className), s.renderer && (s.axis = a), React.createElement(cjsExports.DraggableCore, {
        allowAnyClick: !1,
        enableUserSelectHack: !1,
        onMouseDown: this.handleOnMouseDown,
        onDrag: this.handleOnDrag,
        onStart: this.handleOnDragStart,
        onStop: this.handleOnDragStop,
        nodeRef: this.elementRefHack
      }, renderDivWithRenderer(s, this.elementRef));
    }, r.selectStartReplacer = function() {
      return !1;
    }, r;
  })(React.Component)
), ScrollbarTrack = (
  /** @class */
  (function(t) {
    __extends(r, t);
    function r() {
      var n = t !== null && t.apply(this, arguments) || this;
      return n.element = null, n.elementRef = function(a) {
        isFun(n.props.elementRef) && n.props.elementRef(a), n.element = a;
      }, n.handleClick = function(a) {
        if (!(!a || !n.element || a.button !== 0)) {
          if (isFun(n.props.onClick) && a.target === n.element)
            if (!isUndef(a.offsetX))
              n.props.onClick(a, {
                axis: n.props.axis,
                offset: n.props.axis === AXIS_DIRECTION.X ? a.offsetX : a.offsetY
              });
            else {
              var s = n.element.getBoundingClientRect();
              n.props.onClick(a, {
                axis: n.props.axis,
                offset: n.props.axis === AXIS_DIRECTION.X ? (a.clientX || a.touches[0].clientX) - s.left : (a.clientY || a.touches[0].clientY) - s.top
              });
            }
          return !0;
        }
      }, n;
    }
    return r.prototype.componentDidMount = function() {
      if (!this.element) {
        this.setState(function() {
          throw new Error("Element was not created. Possibly you haven't provided HTMLDivElement to renderer's `elementRef` function.");
        });
        return;
      }
      this.element.addEventListener("click", this.handleClick);
    }, r.prototype.componentWillUnmount = function() {
      this.element && (this.element.removeEventListener("click", this.handleClick), this.element = null, this.elementRef(null));
    }, r.prototype.render = function() {
      var n = this.props;
      n.elementRef;
      var a = n.axis;
      n.onClick;
      var s = __rest(n, ["elementRef", "axis", "onClick"]);
      return s.className = cnb("ScrollbarsCustom-Track", a === AXIS_DIRECTION.X ? "ScrollbarsCustom-TrackX" : "ScrollbarsCustom-TrackY", s.className), s.renderer && (s.axis = a), renderDivWithRenderer(s, this.elementRef);
    }, r;
  })(React.Component)
), style = {
  holder: {
    position: "relative",
    width: "100%",
    height: "100%"
  },
  wrapper: {
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
  },
  content: {
    boxSizing: "border-box"
  },
  track: {
    common: {
      position: "absolute",
      overflow: "hidden",
      borderRadius: 4,
      background: "rgba(0,0,0,.1)",
      userSelect: "none"
    },
    x: {
      height: 10,
      width: "calc(100% - 20px)",
      bottom: 0,
      left: 10
    },
    y: {
      width: 10,
      height: "calc(100% - 20px)",
      top: 10
    }
  },
  thumb: {
    common: {
      cursor: "pointer",
      borderRadius: 4,
      background: "rgba(0,0,0,.4)"
    },
    x: {
      height: "100%",
      width: 0
    },
    y: {
      width: "100%",
      height: 0
    }
  }
}, pageZoomLevel = isBrowser ? i() : 1;
isBrowser && window.addEventListener("resize", function() {
  pageZoomLevel = i();
}, {
  passive: !0
});
var ScrollbarContext = React.createContext({
  parentScrollbar: null
}), Scrollbar$1 = (
  /** @class */
  (function(t) {
    __extends(r, t);
    function r(n) {
      var a = t.call(this, n) || this;
      return a.getScrollState = function(s) {
        if (s === void 0 && (s = !1), a.scrollValues && !s)
          return __assign({}, a.scrollValues);
        var o = {
          clientHeight: 0,
          clientWidth: 0,
          contentScrollHeight: 0,
          contentScrollWidth: 0,
          scrollHeight: 0,
          scrollWidth: 0,
          scrollTop: 0,
          scrollLeft: 0,
          scrollYBlocked: !1,
          scrollXBlocked: !1,
          scrollYPossible: !1,
          scrollXPossible: !1,
          trackYVisible: !1,
          trackXVisible: !1,
          zoomLevel: pageZoomLevel * 1,
          isRTL: void 0
        }, l = a.props;
        return o.isRTL = a.state.isRTL, o.scrollYBlocked = l.noScroll || l.noScrollY, o.scrollXBlocked = l.noScroll || l.noScrollX, a.scrollerElement && (o.clientHeight = a.scrollerElement.clientHeight, o.clientWidth = a.scrollerElement.clientWidth, o.scrollHeight = a.scrollerElement.scrollHeight, o.scrollWidth = a.scrollerElement.scrollWidth, o.scrollTop = a.scrollerElement.scrollTop, o.scrollLeft = a.scrollerElement.scrollLeft, o.scrollYPossible = !o.scrollYBlocked && o.scrollHeight > o.clientHeight, o.scrollXPossible = !o.scrollXBlocked && o.scrollWidth > o.clientWidth, o.trackYVisible = o.scrollYPossible || l.permanentTracks || l.permanentTrackY, o.trackXVisible = o.scrollXPossible || l.permanentTracks || l.permanentTrackX), a.contentElement && (o.contentScrollHeight = a.contentElement.scrollHeight, o.contentScrollWidth = a.contentElement.scrollWidth), o;
      }, a.scrollToTop = function() {
        return a.scrollerElement && (a.scrollerElement.scrollTop = 0), a;
      }, a.scrollToLeft = function() {
        return a.scrollerElement && (a.scrollerElement.scrollLeft = 0), a;
      }, a.scrollToBottom = function() {
        return a.scrollerElement && (a.scrollerElement.scrollTop = a.scrollerElement.scrollHeight - a.scrollerElement.clientHeight), a;
      }, a.scrollToRight = function() {
        return a.scrollerElement && (a.scrollerElement.scrollLeft = a.scrollerElement.scrollWidth - a.scrollerElement.clientWidth), a;
      }, a.scrollTo = function(s, o) {
        return a.scrollerElement && (isNum(s) && (a.scrollerElement.scrollLeft = s), isNum(o) && (a.scrollerElement.scrollTop = o)), a;
      }, a.centerAt = function(s, o) {
        return a.scrollerElement && (isNum(s) && (a.scrollerElement.scrollLeft = s - a.scrollerElement.clientWidth / 2), isNum(o) && (a.scrollerElement.scrollTop = o - a.scrollerElement.clientHeight / 2)), a;
      }, a.update = function(s) {
        if (s === void 0 && (s = !1), !!a.scrollerElement) {
          if (isUndef(a.state.isRTL))
            return a.setState({
              isRTL: getComputedStyle(a.scrollerElement).direction === "rtl"
            }), a.getScrollState();
          var o = a.getScrollState(!0), l = __assign({}, a.scrollValues), c = a.props, x = 0;
          if (s)
            x = 32767;
          else if (l.clientHeight !== o.clientHeight && (x |= Math.trunc(1)), l.clientWidth !== o.clientWidth && (x |= 2), l.scrollHeight !== o.scrollHeight && (x |= 4), l.scrollWidth !== o.scrollWidth && (x |= 8), l.scrollTop !== o.scrollTop && (x |= 16), l.scrollLeft !== o.scrollLeft && (x |= 32), l.scrollYBlocked !== o.scrollYBlocked && (x |= 64), l.scrollXBlocked !== o.scrollXBlocked && (x |= 128), l.scrollYPossible !== o.scrollYPossible && (x |= 256), l.scrollXPossible !== o.scrollXPossible && (x |= 512), l.trackYVisible !== o.trackYVisible && (x |= 1024), l.trackXVisible !== o.trackXVisible && (x |= 2048), l.isRTL !== o.isRTL && (x |= 4096), l.contentScrollHeight !== o.contentScrollHeight && (x |= 8192), l.contentScrollWidth !== o.contentScrollWidth && (x |= 16384), l.zoomLevel !== o.zoomLevel && (x |= 32768), x === 0)
            return l;
          if (!(!c.native && a.holderElement && (x & 8192 && (c.translateContentSizesToHolder || c.translateContentSizeYToHolder) && (a.holderElement.style.height = "".concat(o.contentScrollHeight, "px")), x & 16384 && (c.translateContentSizesToHolder || c.translateContentSizeXToHolder) && (a.holderElement.style.width = "".concat(o.contentScrollWidth, "px")), (c.translateContentSizesToHolder || c.translateContentSizeYToHolder || c.translateContentSizeXToHolder) && (!o.clientHeight && o.contentScrollHeight || !o.clientWidth && o.contentScrollWidth)))) {
            if (x & 1024 || x & 2048) {
              l.scrollYBlocked = o.scrollYBlocked, l.scrollXBlocked = o.scrollXBlocked, l.scrollYPossible = o.scrollYPossible, l.scrollXPossible = o.scrollXPossible, a.trackYElement && x & 1024 && (a.trackYElement.style.display = o.trackYVisible ? "" : "none"), a.trackXElement && x & 2048 && (a.trackXElement.style.display = o.trackXVisible ? "" : "none"), a.scrollValues = l, a.setState({
                trackYVisible: a.scrollValues.trackYVisible = o.trackYVisible,
                trackXVisible: a.scrollValues.trackXVisible = o.trackXVisible
              });
              return;
            }
            return (c.native ? a.updaterNative : a.updaterCustom)(x, o), a.scrollValues = o, !c.native && x & 32768 && (getScrollbarWidth(!0), a.forceUpdate()), a.eventEmitter.emit("update", __assign({}, o), l), (x & 16 || x & 32) && a.eventEmitter.emit("scroll", __assign({}, o), l), a.scrollValues;
          }
        }
      }, a.updaterNative = function() {
        return !0;
      }, a.updaterCustom = function(s, o) {
        var l = a.props;
        if (a.trackYElement && a.thumbYElement && (s & Math.trunc(1) || s & 4 || s & 16 || s & 64 || s & 256))
          if (o.scrollYPossible) {
            var c = getInnerHeight(a.trackYElement), x = calcThumbSize(o.scrollHeight, o.clientHeight, c, l.minimalThumbYSize || l.minimalThumbSize, l.maximalThumbYSize || l.maximalThumbSize), j = calcThumbOffset(o.scrollHeight, o.clientHeight, c, x, o.scrollTop);
            a.thumbYElement.style.transform = "translateY(".concat(j, "px)"), a.thumbYElement.style.height = "".concat(x, "px"), a.thumbYElement.style.display = "";
          } else
            a.thumbYElement.style.transform = "", a.thumbYElement.style.height = "0px", a.thumbYElement.style.display = "none";
        if (a.trackXElement && a.thumbXElement && (s & 2 || s & 8 || s & 32 || s & 128 || s & 512 || s & 4096))
          if (o.scrollXPossible) {
            var c = getInnerWidth(a.trackXElement), x = calcThumbSize(o.scrollWidth, o.clientWidth, c, l.minimalThumbXSize || l.minimalThumbSize, l.maximalThumbXSize || l.maximalThumbSize), j = calcThumbOffset(o.scrollWidth, o.clientWidth, c, x, o.scrollLeft);
            a.state.isRTL && shouldReverseRtlScroll() && (j += c - x), a.thumbXElement.style.transform = "translateX(".concat(j, "px)"), a.thumbXElement.style.width = "".concat(x, "px"), a.thumbXElement.style.display = "";
          } else
            a.thumbXElement.style.transform = "", a.thumbXElement.style.width = "0px", a.thumbXElement.style.display = "none";
        return !0;
      }, a.elementRefHolder = function(s) {
        a.holderElement = s, isFun(a.props.elementRef) && a.props.elementRef(s);
      }, a.elementRefWrapper = function(s) {
        a.wrapperElement = s, isFun(a.props.wrapperProps.elementRef) && a.props.wrapperProps.elementRef(s);
      }, a.elementRefScroller = function(s) {
        a.scrollerElement = s, isFun(a.props.scrollerProps.elementRef) && a.props.scrollerProps.elementRef(s);
      }, a.elementRefContent = function(s) {
        a.contentElement = s, isFun(a.props.contentProps.elementRef) && a.props.contentProps.elementRef(s);
      }, a.elementRefTrackX = function(s) {
        a.trackXElement = s, isFun(a.props.trackXProps.elementRef) && a.props.trackXProps.elementRef(s);
      }, a.elementRefTrackY = function(s) {
        a.trackYElement = s, isFun(a.props.trackYProps.elementRef) && a.props.trackYProps.elementRef(s);
      }, a.elementRefThumbX = function(s) {
        a.thumbXElement = s, isFun(a.props.thumbXProps.elementRef) && a.props.thumbXProps.elementRef(s);
      }, a.elementRefThumbY = function(s) {
        a.thumbYElement = s, isFun(a.props.thumbYProps.elementRef) && a.props.thumbYProps.elementRef(s);
      }, a.handleTrackXClick = function(s, o) {
        if (a.props.trackXProps.onClick && a.props.trackXProps.onClick(s, o), !(!a.scrollerElement || !a.trackXElement || !a.thumbXElement || !a.scrollValues || !a.scrollValues.scrollXPossible)) {
          a._scrollDetection();
          var l = a.thumbXElement.clientWidth, c = getInnerWidth(a.trackXElement), x = (a.scrollValues.isRTL && shouldReverseRtlScroll() ? o.offset + l / 2 - c : o.offset - l / 2) - (Number.parseFloat(getComputedStyle(a.trackXElement).paddingLeft) || 0), j = calcScrollForThumbOffset(a.scrollValues.scrollWidth, a.scrollValues.clientWidth, c, l, x);
          a.props.trackClickBehavior === TRACK_CLICK_BEHAVIOR.STEP && (j = (a.scrollValues.isRTL ? a.scrollValues.scrollLeft > j : a.scrollValues.scrollLeft < j) ? a.scrollValues.scrollLeft + a.scrollValues.clientWidth : a.scrollValues.scrollLeft - a.scrollValues.clientWidth), a.scrollerElement.scrollLeft = j;
        }
      }, a.handleTrackYClick = function(s, o) {
        if (a.props.trackYProps.onClick && a.props.trackYProps.onClick(s, o), !(!a.scrollerElement || !a.trackYElement || !a.thumbYElement || !a.scrollValues || !a.scrollValues.scrollYPossible)) {
          a._scrollDetection();
          var l = a.thumbYElement.clientHeight, c = calcScrollForThumbOffset(a.scrollValues.scrollHeight, a.scrollValues.clientHeight, getInnerHeight(a.trackYElement), l, o.offset - l / 2) - (Number.parseFloat(getComputedStyle(a.trackYElement).paddingTop) || 0);
          a.props.trackClickBehavior === TRACK_CLICK_BEHAVIOR.JUMP ? a.scrollerElement.scrollTop = c : a.scrollerElement.scrollTop = a.scrollValues.scrollTop < c ? a.scrollValues.scrollTop + a.scrollValues.clientHeight : a.scrollValues.scrollTop - a.scrollValues.clientHeight;
        }
      }, a.handleTrackYMouseWheel = function(s) {
        var o = a.props;
        o.trackYProps && o.trackYProps.onWheel && o.trackYProps.onWheel(s), !(o.disableTracksMousewheelScrolling || o.disableTrackYMousewheelScrolling) && (a._scrollDetection(), !(!a.scrollerElement || a.scrollValues.scrollYBlocked) && (a.scrollTop += s.deltaY));
      }, a.handleTrackXMouseWheel = function(s) {
        var o = a.props;
        o.trackXProps && o.trackXProps.onWheel && o.trackXProps.onWheel(s), !(o.disableTracksMousewheelScrolling || o.disableTrackXMousewheelScrolling) && (a._scrollDetection(), !(!a.scrollerElement || a.scrollValues.scrollXBlocked) && (a.scrollLeft += s.deltaX));
      }, a.handleThumbXDrag = function(s) {
        var o;
        if (!(!a.trackXElement || !a.thumbXElement || !a.scrollerElement || !a.scrollValues || !a.scrollValues.scrollXPossible)) {
          a._scrollDetection();
          var l = a.trackXElement.getBoundingClientRect(), c = getComputedStyle(a.trackXElement), x = Number.parseFloat(c.paddingLeft) || 0, j = Number.parseFloat(c.paddingRight) || 0, Z = l.width - x - j, V = a.thumbXElement.clientWidth, U = a.scrollValues.isRTL && shouldReverseRtlScroll() ? s.x + V - Z + x : s.lastX - x;
          a.scrollerElement.scrollLeft = calcScrollForThumbOffset(a.scrollValues.scrollWidth, a.scrollValues.clientWidth, Z, V, U), !((o = a.props.thumbXProps) === null || o === void 0) && o.onDrag && a.props.thumbXProps.onDrag(s);
        }
      }, a.handleThumbXDragEnd = function(s) {
        var o;
        a.handleThumbXDrag(s), !((o = a.props.thumbXProps) === null || o === void 0) && o.onDragEnd && a.props.thumbXProps.onDragEnd(s);
      }, a.handleThumbYDrag = function(s) {
        var o;
        if (!(!a.scrollerElement || !a.trackYElement || !a.thumbYElement || !a.scrollValues || !a.scrollValues.scrollYPossible)) {
          a._scrollDetection();
          var l = a.trackYElement.getBoundingClientRect(), c = getComputedStyle(a.trackYElement), x = Number.parseFloat(c.paddingTop) || 0, j = Number.parseFloat(c.paddingBottom) || 0, Z = l.height - x - j, V = a.thumbYElement.clientHeight, U = s.y - x;
          a.scrollerElement.scrollTop = calcScrollForThumbOffset(a.scrollValues.scrollHeight, a.scrollValues.clientHeight, Z, V, U), !((o = a.props.thumbYProps) === null || o === void 0) && o.onDrag && a.props.thumbYProps.onDrag(s);
        }
      }, a.handleThumbYDragEnd = function(s) {
        var o;
        a.handleThumbYDrag(s), !((o = a.props.thumbYProps) === null || o === void 0) && o.onDragEnd && a.props.thumbYProps.onDragEnd(s);
      }, a.handleScrollerScroll = function() {
        a._scrollDetection();
      }, a._scrollDetection = function() {
        a._scrollDetectionTO ? isBrowser && window.clearTimeout(a._scrollDetectionTO) : a.eventEmitter.emit("scrollStart", a.getScrollState()), a._scrollDetectionTO = isBrowser ? window.setTimeout(a._scrollDetectionCallback, a.props.scrollDetectionThreshold || 0) : null;
      }, a._scrollDetectionCallback = function() {
        a._scrollDetectionTO = null, a.eventEmitter.emit("scrollStop", a.getScrollState());
      }, a.state = {
        trackXVisible: !1,
        trackYVisible: !1,
        isRTL: n.rtl
      }, a.scrollValues = a.getScrollState(!0), a.eventEmitter = new Emittr(15), n.onUpdate && a.eventEmitter.on("update", n.onUpdate), n.onScroll && a.eventEmitter.on("scroll", n.onScroll), n.onScrollStart && a.eventEmitter.on("scrollStart", n.onScrollStart), n.onScrollStop && a.eventEmitter.on("scrollStop", n.onScrollStop), a.id = uuid(), a;
    }
    return Object.defineProperty(r.prototype, "scrollTop", {
      // eslint-disable-next-line react/sort-comp
      get: function() {
        return this.scrollerElement ? this.scrollerElement.scrollTop : 0;
      },
      set: function(a) {
        this.scrollerElement && (this.scrollerElement.scrollTop = a, this.update());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "scrollLeft", {
      get: function() {
        return this.scrollerElement ? this.scrollerElement.scrollLeft : 0;
      },
      set: function(a) {
        this.scrollerElement && (this.scrollerElement.scrollLeft = a);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "scrollHeight", {
      get: function() {
        return this.scrollerElement ? this.scrollerElement.scrollHeight : 0;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "scrollWidth", {
      get: function() {
        return this.scrollerElement ? this.scrollerElement.scrollWidth : 0;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "clientHeight", {
      get: function() {
        return this.scrollerElement ? this.scrollerElement.clientHeight : 0;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "clientWidth", {
      get: function() {
        return this.scrollerElement ? this.scrollerElement.clientWidth : 0;
      },
      enumerable: !1,
      configurable: !0
    }), r.calculateStyles = function(n, a, s, o) {
      var l, c, x, j, Z = !n.noDefaultStyles;
      return {
        holder: __assign(__assign(__assign({}, Z && style.holder), {
          position: "relative"
        }), n.style),
        wrapper: __assign(__assign(__assign({}, Z && __assign(__assign(__assign({}, style.wrapper), !n.disableTracksWidthCompensation && !n.disableTrackYWidthCompensation && (l = {}, l[a.isRTL ? "left" : "right"] = a.trackYVisible ? 10 : 0, l)), !n.disableTracksWidthCompensation && !n.disableTrackXWidthCompensation && {
          bottom: a.trackXVisible ? 10 : 0
        })), n.wrapperProps.style), {
          position: "absolute",
          overflow: "hidden"
        }),
        content: __assign(__assign(__assign(__assign(__assign({}, Z && style.content), n.translateContentSizesToHolder || n.translateContentSizeYToHolder || n.translateContentSizeXToHolder ? {
          display: "table-cell"
        } : {
          padding: 0.05
          // needed to disable margin collapsing without flexboxes, other possible solutions here: https://stackoverflow.com/questions/19718634/how-to-disable-margin-collapsing
        }), Z && !(n.translateContentSizesToHolder || n.translateContentSizeYToHolder) && {
          minHeight: "100%"
        }), Z && !(n.translateContentSizesToHolder || n.translateContentSizeXToHolder) && {
          minWidth: "100%"
        }), n.contentProps.style),
        scroller: __assign(__assign(__assign(__assign((c = {
          position: "absolute",
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          paddingBottom: !o && s.scrollXPossible ? n.fallbackScrollbarWidth : void 0
        }, c[a.isRTL ? "paddingLeft" : "paddingRight"] = !o && s.scrollYPossible ? n.fallbackScrollbarWidth : void 0, c), n.scrollerProps.style), !isUndef(n.rtl) && {
          direction: n.rtl ? "rtl" : "ltr"
        }), n.momentum && {
          WebkitOverflowScrolling: "touch"
        }), (x = {
          overflowY: s.scrollYPossible ? "scroll" : "hidden",
          overflowX: s.scrollXPossible ? "scroll" : "hidden",
          marginBottom: s.scrollXPossible ? -(o || n.fallbackScrollbarWidth) - +(s.zoomLevel !== 1) : void 0
        }, x[a.isRTL ? "marginLeft" : "marginRight"] = s.scrollYPossible ? -(o || n.fallbackScrollbarWidth) - +(s.zoomLevel !== 1) : void 0, x)),
        trackX: __assign(__assign(__assign(__assign({}, Z && style.track.common), Z && style.track.x), n.trackXProps.style), !a.trackXVisible && {
          display: "none"
        }),
        trackY: __assign(__assign(__assign(__assign(__assign({}, Z && style.track.common), Z && style.track.y), Z && (j = {}, j[a.isRTL ? "left" : "right"] = 0, j)), n.trackYProps.style), !a.trackYVisible && {
          display: "none"
        }),
        thumbX: __assign(__assign(__assign({}, Z && style.thumb.common), Z && style.thumb.x), n.thumbXProps.style),
        thumbY: __assign(__assign(__assign({}, Z && style.thumb.common), Z && style.thumb.y), n.thumbYProps.style)
      };
    }, r.prototype.componentDidMount = function() {
      if (!this.scrollerElement) {
        this.setState(function() {
          throw new Error("scroller element was not created. Possibly you haven't provided HTMLDivElement to renderer's `elementRef` function.");
        });
        return;
      }
      if (!this.contentElement) {
        this.setState(function() {
          throw new Error("content element was not created. Possibly you haven't provided HTMLDivElement to renderer's `elementRef` function.");
        });
        return;
      }
      var n = this.props;
      if (!n.native && !n.mobileNative) {
        if (!this.holderElement) {
          this.setState(function() {
            throw new Error("holder element was not created. Possibly you haven't provided HTMLDivElement to renderer's `elementRef` function.");
          });
          return;
        }
        if (!this.wrapperElement) {
          this.setState(function() {
            throw new Error("wrapper element was not created. Possibly you haven't provided HTMLDivElement to renderer's `elementRef` function.");
          });
          return;
        }
      }
      Loop.addTarget(this), isUndef(n.scrollTop) || (this.scrollerElement.scrollTop = n.scrollTop), isUndef(n.scrollLeft) || (this.scrollerElement.scrollLeft = n.scrollLeft), this.update(!0);
    }, r.prototype.componentWillUnmount = function() {
      Loop.removeTarget(this);
    }, r.prototype.componentDidUpdate = function(n, a) {
      if (this.scrollerElement) {
        var s = this.props;
        s.rtl !== n.rtl && s.rtl !== this.state.isRTL && this.setState({
          isRTL: s.rtl
        }), this.state.isRTL !== a.isRTL && this.update(), !isUndef(s.scrollTop) && s.scrollTop !== this.scrollerElement.scrollTop && (this.scrollerElement.scrollTop = s.scrollTop), !isUndef(s.scrollLeft) && s.scrollLeft !== this.scrollerElement.scrollLeft && (this.scrollerElement.scrollLeft = s.scrollLeft), n.onUpdate !== s.onUpdate && (n.onUpdate && this.eventEmitter.off("update", n.onUpdate), s.onUpdate && this.eventEmitter.on("update", s.onUpdate)), n.onScroll !== s.onScroll && (n.onScroll && this.eventEmitter.off("scroll", n.onScroll), s.onScroll && this.eventEmitter.on("scroll", s.onScroll)), n.onScrollStart !== s.onScrollStart && (n.onScrollStart && this.eventEmitter.off("scrollStart", n.onScrollStart), s.onScrollStart && this.eventEmitter.on("scrollStart", s.onScrollStart)), n.onScrollStop !== s.onScrollStop && (n.onScrollStop && this.eventEmitter.off("scrollStop", n.onScrollStop), s.onScrollStop && this.eventEmitter.on("scrollStop", s.onScrollStop));
      }
    }, r.prototype.render = function() {
      var n = this.props, a = n.createContext, s = n.rtl, o = n.native, l = n.mobileNative, c = n.momentum;
      n.noDefaultStyles;
      var x = n.disableTracksMousewheelScrolling, j = n.disableTrackXMousewheelScrolling, Z = n.disableTrackYMousewheelScrolling;
      n.disableTracksWidthCompensation, n.disableTrackXWidthCompensation, n.disableTrackYWidthCompensation;
      var V = n.noScrollX, U = n.noScrollY, $ = n.noScroll, Y = n.permanentTrackX, G = n.permanentTrackY, W = n.permanentTracks, X = n.removeTracksWhenNotUsed, K = n.removeTrackYWhenNotUsed, J = n.removeTrackXWhenNotUsed;
      n.minimalThumbSize, n.maximalThumbSize, n.minimalThumbXSize, n.maximalThumbXSize, n.minimalThumbYSize, n.maximalThumbYSize, n.fallbackScrollbarWidth, n.scrollTop, n.scrollLeft, n.trackClickBehavior, n.scrollDetectionThreshold;
      var ee = n.wrapperProps, te = n.scrollerProps, ne = n.contentProps, re = n.trackXProps, ie = n.trackYProps, ue = n.thumbXProps, le = n.thumbYProps, oe = n.scrollbarWidth;
      n.elementRef, n.onUpdate, n.onScroll, n.onScrollStart, n.onScrollStop, n.translateContentSizesToHolder, n.translateContentSizeYToHolder, n.translateContentSizeXToHolder;
      var he = n.children, fe = __rest(n, ["createContext", "rtl", "native", "mobileNative", "momentum", "noDefaultStyles", "disableTracksMousewheelScrolling", "disableTrackXMousewheelScrolling", "disableTrackYMousewheelScrolling", "disableTracksWidthCompensation", "disableTrackXWidthCompensation", "disableTrackYWidthCompensation", "noScrollX", "noScrollY", "noScroll", "permanentTrackX", "permanentTrackY", "permanentTracks", "removeTracksWhenNotUsed", "removeTrackYWhenNotUsed", "removeTrackXWhenNotUsed", "minimalThumbSize", "maximalThumbSize", "minimalThumbXSize", "maximalThumbXSize", "minimalThumbYSize", "maximalThumbYSize", "fallbackScrollbarWidth", "scrollTop", "scrollLeft", "trackClickBehavior", "scrollDetectionThreshold", "wrapperProps", "scrollerProps", "contentProps", "trackXProps", "trackYProps", "thumbXProps", "thumbYProps", "scrollbarWidth", "elementRef", "onUpdate", "onScroll", "onScrollStart", "onScrollStop", "translateContentSizesToHolder", "translateContentSizeYToHolder", "translateContentSizeXToHolder", "children"]), ce = isUndef(oe) ? getScrollbarWidth() || 0 : oe;
      if (o || !ce && l) {
        this.elementRefHolder(null), this.elementRefWrapper(null), this.elementRefTrackX(null), this.elementRefTrackY(null), this.elementRefThumbX(null), this.elementRefThumbY(null);
        var se = __assign(__assign({}, ne), {
          key: "ScrollbarsCustom-Content",
          className: cnb("ScrollbarsCustom-Content", ne.className),
          children: he
        }), pe = __assign(__assign({}, fe), {
          className: cnb("ScrollbarsCustom native", this.state.trackYVisible && "trackYVisible", this.state.trackXVisible && "trackXVisible", this.state.isRTL && "rtl", fe.className),
          style: __assign(__assign(__assign(__assign({}, fe.style), !isUndef(s) && {
            direction: s ? "rtl" : "ltr"
          }), c && {
            WebkitOverflowScrolling: "touch"
          }), {
            overflowX: $ || V ? "hidden" : W || Y ? "scroll" : "auto",
            overflowY: $ || U ? "hidden" : W || G ? "scroll" : "auto"
          }),
          onScroll: this.handleScrollerScroll,
          children: renderDivWithRenderer(se, this.elementRefContent),
          renderer: te.renderer,
          elementRef: te.elementRef
        });
        return renderDivWithRenderer(pe, this.elementRefScroller);
      }
      var ve = r.calculateStyles(this.props, this.state, this.scrollValues, ce), ae = [], me = __assign(__assign({}, ne), {
        key: "ScrollbarsCustom-Content",
        className: cnb("ScrollbarsCustom-Content", ne.className),
        style: ve.content,
        children: a ? (
          // eslint-disable-next-line react/jsx-no-constructed-context-values
          React.createElement(ScrollbarContext.Provider, {
            value: {
              parentScrollbar: this
            }
          }, he)
        ) : he
      }), de = __assign(__assign({}, te), {
        key: "ScrollbarsCustom-Scroller",
        className: cnb("ScrollbarsCustom-Scroller", te.className),
        style: ve.scroller,
        children: renderDivWithRenderer(me, this.elementRefContent),
        onScroll: this.handleScrollerScroll
      }), ge = __assign(__assign({}, ee), {
        key: "ScrollbarsCustom-Wrapper",
        className: cnb("ScrollbarsCustom-Wrapper", ee.className),
        style: ve.wrapper,
        children: renderDivWithRenderer(de, this.elementRefScroller)
      });
      if (ae.push(renderDivWithRenderer(ge, this.elementRefWrapper)), this.state.trackYVisible || !X && !K) {
        var Se = __assign(__assign({}, le), {
          key: "ScrollbarsCustom-ThumbY",
          style: ve.thumbY,
          elementRef: this.elementRefThumbY,
          onDrag: this.handleThumbYDrag,
          onDragEnd: this.handleThumbYDragEnd,
          axis: AXIS_DIRECTION.Y
        }), xe = __assign(__assign(__assign(__assign({}, ie), {
          key: "ScrollbarsCustom-TrackY",
          style: ve.trackY,
          elementRef: this.elementRefTrackY,
          onClick: this.handleTrackYClick
        }), (x || Z) && {
          onWheel: this.handleTrackYMouseWheel
        }), {
          axis: AXIS_DIRECTION.Y
        });
        xe.children = React.createElement(ScrollbarThumb, __assign({}, Se)), ae.push(React.createElement(ScrollbarTrack, __assign({}, xe)));
      } else
        this.elementRefTrackY(null), this.elementRefThumbY(null);
      if (this.state.trackXVisible || !X && !J) {
        var Ee = __assign(__assign({}, ue), {
          key: "ScrollbarsCustom-ThumbX",
          style: ve.thumbX,
          elementRef: this.elementRefThumbX,
          onDrag: this.handleThumbXDrag,
          onDragEnd: this.handleThumbXDragEnd,
          axis: AXIS_DIRECTION.X
        }), Ce = __assign(__assign(__assign(__assign({}, re), {
          key: "ScrollbarsCustom-TrackX",
          style: ve.trackX,
          elementRef: this.elementRefTrackX,
          onClick: this.handleTrackXClick
        }), (x || j) && {
          onWheel: this.handleTrackXMouseWheel
        }), {
          axis: AXIS_DIRECTION.X
        });
        Ce.children = React.createElement(ScrollbarThumb, __assign({}, Ee)), ae.push(React.createElement(ScrollbarTrack, __assign({}, Ce)));
      } else
        this.elementRefTrackX(null), this.elementRefThumbX(null);
      var ke = __assign(__assign({}, fe), {
        className: cnb("ScrollbarsCustom", this.state.trackYVisible && "trackYVisible", this.state.trackXVisible && "trackXVisible", this.state.isRTL && "rtl", fe.className),
        style: ve.holder,
        children: ae
      });
      return renderDivWithRenderer(ke, this.elementRefHolder);
    }, r.contextType = ScrollbarContext, r.defaultProps = {
      momentum: !0,
      minimalThumbSize: 30,
      fallbackScrollbarWidth: 20,
      trackClickBehavior: TRACK_CLICK_BEHAVIOR.JUMP,
      scrollDetectionThreshold: 100,
      wrapperProps: {},
      scrollerProps: {},
      contentProps: {},
      trackXProps: {},
      trackYProps: {},
      thumbXProps: {},
      thumbYProps: {}
    }, r;
  })(React.Component)
);
function Scrollbar({
  className: t,
  style: r,
  noScrollX: n,
  noScrollY: a,
  wrapperClassName: s,
  contentClassName: o,
  createContext: l,
  scrollTop: c,
  scrollLeft: x,
  scrollDetectionThreshold: j,
  onUpdate: Z,
  onScroll: V,
  onScrollStart: U,
  onScrollStop: $,
  children: Y
}) {
  const [G, W] = useState$1(!1), [X, K] = useState$1(!1), J = G || X, ee = useCallback(() => W(!0), []), te = useCallback(() => W(!1), []), ne = useCallback(() => K(!0), []), re = useCallback(() => K(!1), []);
  return /* @__PURE__ */ jsx(
    Scrollbar$1,
    {
      className: t,
      style: r,
      noScrollX: n,
      noScrollY: a,
      createContext: l,
      scrollTop: c,
      scrollLeft: x,
      scrollDetectionThreshold: j,
      onUpdate: Z,
      onScroll: V,
      onScrollStart: U,
      onScrollStop: $,
      wrapperProps: {
        className: clsx(s, "go-scrollbar__wrapper"),
        onMouseEnter: ee,
        onMouseLeave: te
      },
      scrollerProps: {
        onTouchStart: ee,
        onTouchEnd: te,
        onTouchCancel: te
      },
      contentProps: {
        className: clsx(o, "go-scrollbar__content")
      },
      trackYProps: {
        className: clsx(
          "go-scrollbar__track",
          "go-scrollbar__track_orientation_vertical",
          !J && "go-scrollbar__track_hidden"
        ),
        onMouseEnter: ne,
        onMouseLeave: re
      },
      trackXProps: {
        className: clsx(
          "go-scrollbar__track",
          "go-scrollbar__track_orientation_horizontal",
          !J && "go-scrollbar__track_hidden"
        ),
        onMouseEnter: ne,
        onMouseLeave: re
      },
      thumbXProps: {
        style: {
          background: "var(--go-scrollbar-thumb-bg)",
          border: "var(--go-scrollbar-thumb-border)"
        }
      },
      thumbYProps: {
        style: {
          background: "var(--go-scrollbar-thumb-bg)",
          border: "var(--go-scrollbar-thumb-border)"
        }
      },
      children: Y
    }
  );
}
const KEY_DIVIDER = "_";
function generateId(t, r) {
  return `${t}${KEY_DIVIDER}${r}`;
}
function CalendarTimeOptions({
  options: t,
  selectedOption: r,
  onChange: n,
  title: a,
  disabled: s,
  isOptionDisabled: o = () => !1
}) {
  const c = `go-calendar-time-option-${useId$3()}`, x = useRef(null), [j, Z] = useState$1(0), V = useRef(0);
  useEffect(() => {
    const $ = x.current;
    if (!r || !$)
      return;
    const Y = document.getElementById(generateId(c, r.key));
    if (!Y)
      return;
    const G = $.getBoundingClientRect(), W = Y.getBoundingClientRect(), X = animate(
      V.current,
      W.top - G.top,
      Z,
      (K) => {
        V.current = K;
      }
    );
    return () => X();
  }, [c, r]);
  const U = useCallback(($) => {
    "scrollTop" in $ && (V.current = $.scrollTop, Z($.scrollTop));
  }, []);
  return /* @__PURE__ */ jsxs("div", { className: "go-calendar__time-options-wrapper", children: [
    renderNode(a, "p", "go-calendar__time-options-header"),
    /* @__PURE__ */ jsx(Scrollbar, { noScrollX: !0, scrollTop: j, onScroll: U, children: /* @__PURE__ */ jsx("div", { ref: x, className: "go-calendar__time-options", children: t.map(($) => /* @__PURE__ */ jsx(
      "button",
      {
        id: generateId(c, $.key),
        disabled: s || o($.value),
        className: clsx(
          "go-calendar__time-option",
          $.key === (r == null ? void 0 : r.key) && "go-calendar__time-option_selected"
        ),
        onClick: () => n($),
        children: /* @__PURE__ */ jsx("span", { className: "go-calendar__time-option-inner", children: $.value })
      },
      $.key
    )) }) })
  ] });
}
const { hours: hourOptions, minutes: minuteOptions } = getTimeOptions();
function CalendarTime({
  hours: t,
  minutes: r,
  viewSettings: n = { hours: !0, minutes: !0 },
  className: a,
  disabled: s,
  onHourChange: o,
  onMinuteChange: l,
  isHourDisabled: c = () => !1,
  isMinuteDisabled: x = () => !1
}) {
  var U, $, Y, G;
  const { localization: j } = useContext(ConfigContext), Z = hourOptions.find((W) => W.value === t), V = minuteOptions.find((W) => W.value === r);
  return /* @__PURE__ */ jsxs("div", { className: clsx("go-calendar__time-wrapper", s && "go-calendar__time-wrapper_disabled", a), children: [
    n.hours && /* @__PURE__ */ jsx(
      CalendarTimeOptions,
      {
        options: hourOptions,
        selectedOption: Z,
        title: ($ = (U = j == null ? void 0 : j.calendar) == null ? void 0 : U.values) == null ? void 0 : $.hour,
        onChange: o,
        isOptionDisabled: c,
        disabled: s
      }
    ),
    n.minutes && /* @__PURE__ */ jsx(
      CalendarTimeOptions,
      {
        options: minuteOptions,
        selectedOption: V,
        title: (G = (Y = j == null ? void 0 : j.calendar) == null ? void 0 : Y.values) == null ? void 0 : G.minuteShort,
        onChange: l,
        isOptionDisabled: x,
        disabled: s
      }
    )
  ] });
}
function shouldShowTime$1(t) {
  return typeof t == "boolean" ? t : typeof t == "object" ? !!t.hours || !!t.minutes : !1;
}
const Calendar$1 = ({
  value: t = null,
  defaultValue: r = null,
  showTime: n = !1,
  mode: a = "month",
  config: s,
  className: o,
  style: l,
  onChange: c,
  isDateDisabled: x,
  isHourDisabled: j,
  isMinuteDisabled: Z
}) => {
  var te, ne;
  const [V, U] = useReducer(
    reducer,
    initialState,
    (re) => initStore(re, t, r, null, a)
  );
  useEffect(() => {
    t !== null && U({ type: "SET_DATE", payload: t });
  }, [t]);
  const $ = useMemo$1(
    () => ({ ...DEFAULT_CALENDAR_CONFIG, ...s }),
    [s]
  ), Y = useCallback(
    (re) => {
      var le, oe, he;
      const ie = /* @__PURE__ */ new Date(), ue = applyTime(re, (le = V.hours) != null ? le : getHours(ie), (oe = V.minutes) != null ? oe : getMinutes(ie));
      c == null || c((he = ue == null ? void 0 : ue.getTime()) != null ? he : null);
    },
    [c, V.hours, V.minutes]
  ), G = useCallback(
    (re) => {
      var ue;
      if (U({ type: "SET_HOURS", payload: re.value }), V.mode !== "month" || V.minutes === null || t === null)
        return;
      const ie = applyTime(toDate(t), re.value, V.minutes);
      c == null || c((ue = ie == null ? void 0 : ie.getTime()) != null ? ue : null);
    },
    [c, t, V.minutes, V.mode]
  ), W = useCallback(
    (re) => {
      var ue;
      if (U({ type: "SET_MINUTES", payload: re.value }), V.mode !== "month" || V.hours === null || t === null)
        return;
      const ie = applyTime(toDate(t), V.hours, re.value);
      c == null || c((ue = ie == null ? void 0 : ie.getTime()) != null ? ue : null);
    },
    [c, V.hours, V.mode, t]
  ), X = useCallback(
    (re) => j ? V.mode === "year" ? !0 : j(re, t !== null ? applyTime(toDate(t), re, V.minutes) : null) : !1,
    [j, V.minutes, V.mode, t]
  ), K = useCallback(
    (re) => Z ? V.mode === "year" ? !0 : Z(
      re,
      V.hours,
      t !== null ? applyTime(toDate(t), V.hours, re) : null
    ) : !1,
    [Z, V.hours, V.mode, t]
  ), J = useCallback((re, ie) => {
    U({ type: "SET_MONTH", payload: { month: re, year: ie } });
  }, []), ee = shouldShowTime$1(n);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: clsx("go-calendar", ee && "go-calendar_with-time", o),
      style: {
        ...l,
        "--dates-container-height": `${$.weekRowHeight * NUMBER_OF_WEEKS_ON_PAGE}px`
      },
      children: [
        /* @__PURE__ */ jsx(
          CalendarHeader,
          {
            month: (te = V.month) != null ? te : getMonth(/* @__PURE__ */ new Date()),
            year: (ne = V.year) != null ? ne : getYear(/* @__PURE__ */ new Date()),
            mode: V.mode,
            onChange: (re, ie) => {
              U({ type: "SET_MONTH", payload: { month: re, year: ie } });
            },
            onTitleClick: () => {
              U({ type: "TOGGLE_MODE" });
            }
          }
        ),
        V.mode === "month" && /* @__PURE__ */ jsx(
          CalendarMonthPage,
          {
            month: V.month,
            year: V.year,
            selectedDate: t,
            config: $,
            onDateChange: Y,
            onMonthChange: J,
            isDateDisabled: x
          }
        ),
        V.mode === "year" && /* @__PURE__ */ jsx(
          CalendarYearPage,
          {
            month: V.month,
            year: V.year,
            onYearChange: (re) => {
              U({ type: "SET_YEAR", payload: re });
            },
            onMonthChange: (re) => {
              U({ type: "SET_MONTH", payload: { month: re } });
            }
          }
        ),
        ee && /* @__PURE__ */ jsx(
          CalendarTime,
          {
            hours: V.hours,
            minutes: V.minutes,
            onHourChange: G,
            onMinuteChange: W,
            viewSettings: typeof n == "object" ? n : void 0,
            isHourDisabled: X,
            isMinuteDisabled: K,
            disabled: V.mode === "year"
          }
        )
      ]
    }
  );
};
function toUnix(t) {
  return t == null || Number.isNaN(t) || typeof t == "number" && !Number.isFinite(t) ? null : toDate(t).getTime();
}
function useDisabledRange({ minDate: t, maxDate: r }) {
  const n = toUnix(t), a = toUnix(r);
  return useMemo$1(
    () => ({
      isDateDisabled(s) {
        return n !== null && isBefore(s, startOfDay(n)) || a !== null && isAfter(s, endOfDay(a));
      },
      isHourDisabled(s, o) {
        return o === null ? !1 : n !== null && isBefore(o, startOfHour(n)) || a !== null && isAfter(o, endOfHour(a));
      },
      isMinuteDisabled(s, o, l) {
        return l === null ? !1 : n !== null && isBefore(l, startOfMinute(n)) || a !== null && isAfter(l, endOfMinute(a));
      }
    }),
    [a, n]
  );
}
const stateClassNames = {
  checked: "go-checkbox_state_checked",
  unchecked: "go-checkbox_state_unchecked",
  intermediate: "go-checkbox_state_intermediate"
}, sizeClassNames$4 = {
  s: "go-checkbox_size_s",
  m: "go-checkbox_size_m"
};
function getCheckboxState(t, r) {
  return r ? "intermediate" : t ? "checked" : "unchecked";
}
const Checkbox = forwardRef(function t({
  initialValue: r = !1,
  checked: n,
  intermediate: a = !1,
  name: s,
  disabled: o,
  className: l,
  labelClassName: c,
  style: x,
  size: j,
  loading: Z = !1,
  onChange: V,
  children: U,
  tabIndex: $,
  autoFocus: Y,
  onKeyDown: G
}, W) {
  const { size: X } = useGlobalComponentConfig({ size: j }), J = `go-checkbox-${useId$3()}`, [ee, te] = useState$1(r);
  useEffect(() => {
    te(r);
  }, [r]);
  const ne = useMemo$1(
    () => getCheckboxState(n != null ? n : ee, a),
    [a, n, ee]
  ), re = (ie) => {
    const { checked: ue } = ie.currentTarget;
    n == null && te(ue), V && V(ue, ie);
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: clsx(
        l,
        "go-checkbox",
        stateClassNames[ne],
        sizeClassNames$4[X],
        Z && "go-checkbox_loading"
      ),
      style: x,
      children: [
        Z ? /* @__PURE__ */ jsx(LoaderIcon, { size: "s" }) : /* @__PURE__ */ jsxs("div", { className: "go-checkbox__field", children: [
          /* @__PURE__ */ jsx(
            "input",
            {
              ref: W,
              id: J,
              type: "checkbox",
              name: s,
              checked: n != null ? n : ee,
              disabled: o,
              className: "go-checkbox__input",
              tabIndex: $,
              autoFocus: Y,
              onChange: re,
              onKeyDown: G
            }
          ),
          /* @__PURE__ */ jsx("label", { htmlFor: J, className: "go-checkbox__container" }),
          /* @__PURE__ */ jsx("div", { className: clsx("go-checkbox__inner") })
        ] }),
        !!U && /* @__PURE__ */ jsx("label", { htmlFor: J, className: clsx("go-checkbox__label", c), children: U })
      ]
    }
  );
}), CheckboxGroup = ({
  value: t,
  name: r,
  items: n,
  itemClassName: a,
  onChange: s,
  style: o,
  className: l
}) => {
  const [c, x] = useState$1(t || []);
  useEffect(() => {
    t && x(t);
  }, [t]);
  const j = (Z) => {
    const V = c.indexOf(Z.value), U = [...c];
    V === -1 ? U.push(Z.value) : U.splice(V, 1), t || x(U), s == null || s(
      U.sort(($, Y) => {
        const G = n.findIndex((X) => X.value === $), W = n.findIndex((X) => X.value === Y);
        return G - W;
      })
    );
  };
  return /* @__PURE__ */ jsx("div", { style: o, className: clsx("go-checkbox-group", l), children: n.map((Z) => /* @__PURE__ */ jsx(
    Checkbox,
    {
      checked: c.includes(Z.value),
      onChange: () => j(Z),
      className: a,
      disabled: Z.disabled,
      name: r,
      ref: Z.ref,
      style: Z.style,
      loading: Z.loading,
      children: Z.label
    },
    Z.value.toString()
  )) });
};
var useMergedState$1 = {}, slicedToArray = { exports: {} }, arrayWithHoles = { exports: {} }, hasRequiredArrayWithHoles;
function requireArrayWithHoles() {
  return hasRequiredArrayWithHoles || (hasRequiredArrayWithHoles = 1, (function(t) {
    function r(n) {
      if (Array.isArray(n)) return n;
    }
    t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
  })(arrayWithHoles)), arrayWithHoles.exports;
}
var iterableToArrayLimit = { exports: {} }, hasRequiredIterableToArrayLimit;
function requireIterableToArrayLimit() {
  return hasRequiredIterableToArrayLimit || (hasRequiredIterableToArrayLimit = 1, (function(t) {
    function r(n, a) {
      var s = n == null ? null : typeof Symbol != "undefined" && n[Symbol.iterator] || n["@@iterator"];
      if (s != null) {
        var o, l, c, x, j = [], Z = !0, V = !1;
        try {
          if (c = (s = s.call(n)).next, a === 0) {
            if (Object(s) !== s) return;
            Z = !1;
          } else for (; !(Z = (o = c.call(s)).done) && (j.push(o.value), j.length !== a); Z = !0) ;
        } catch (U) {
          V = !0, l = U;
        } finally {
          try {
            if (!Z && s.return != null && (x = s.return(), Object(x) !== x)) return;
          } finally {
            if (V) throw l;
          }
        }
        return j;
      }
    }
    t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
  })(iterableToArrayLimit)), iterableToArrayLimit.exports;
}
var unsupportedIterableToArray = { exports: {} }, arrayLikeToArray = { exports: {} }, hasRequiredArrayLikeToArray;
function requireArrayLikeToArray() {
  return hasRequiredArrayLikeToArray || (hasRequiredArrayLikeToArray = 1, (function(t) {
    function r(n, a) {
      (a == null || a > n.length) && (a = n.length);
      for (var s = 0, o = Array(a); s < a; s++) o[s] = n[s];
      return o;
    }
    t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
  })(arrayLikeToArray)), arrayLikeToArray.exports;
}
var hasRequiredUnsupportedIterableToArray;
function requireUnsupportedIterableToArray() {
  return hasRequiredUnsupportedIterableToArray || (hasRequiredUnsupportedIterableToArray = 1, (function(t) {
    var r = requireArrayLikeToArray();
    function n(a, s) {
      if (a) {
        if (typeof a == "string") return r(a, s);
        var o = {}.toString.call(a).slice(8, -1);
        return o === "Object" && a.constructor && (o = a.constructor.name), o === "Map" || o === "Set" ? Array.from(a) : o === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? r(a, s) : void 0;
      }
    }
    t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
  })(unsupportedIterableToArray)), unsupportedIterableToArray.exports;
}
var nonIterableRest = { exports: {} }, hasRequiredNonIterableRest;
function requireNonIterableRest() {
  return hasRequiredNonIterableRest || (hasRequiredNonIterableRest = 1, (function(t) {
    function r() {
      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
  })(nonIterableRest)), nonIterableRest.exports;
}
var hasRequiredSlicedToArray;
function requireSlicedToArray() {
  return hasRequiredSlicedToArray || (hasRequiredSlicedToArray = 1, (function(t) {
    var r = requireArrayWithHoles(), n = requireIterableToArrayLimit(), a = requireUnsupportedIterableToArray(), s = requireNonIterableRest();
    function o(l, c) {
      return r(l) || n(l, c) || a(l, c) || s();
    }
    t.exports = o, t.exports.__esModule = !0, t.exports.default = t.exports;
  })(slicedToArray)), slicedToArray.exports;
}
var useEvent = {}, interopRequireWildcard = { exports: {} }, hasRequiredInteropRequireWildcard;
function requireInteropRequireWildcard() {
  return hasRequiredInteropRequireWildcard || (hasRequiredInteropRequireWildcard = 1, (function(t) {
    var r = require_typeof().default;
    function n(a, s) {
      if (typeof WeakMap == "function") var o = /* @__PURE__ */ new WeakMap(), l = /* @__PURE__ */ new WeakMap();
      return (t.exports = n = function(x, j) {
        if (!j && x && x.__esModule) return x;
        var Z, V, U = {
          __proto__: null,
          default: x
        };
        if (x === null || r(x) != "object" && typeof x != "function") return U;
        if (Z = j ? l : o) {
          if (Z.has(x)) return Z.get(x);
          Z.set(x, U);
        }
        for (var $ in x) $ !== "default" && {}.hasOwnProperty.call(x, $) && ((V = (Z = Object.defineProperty) && Object.getOwnPropertyDescriptor(x, $)) && (V.get || V.set) ? Z(U, $, V) : U[$] = x[$]);
        return U;
      }, t.exports.__esModule = !0, t.exports.default = t.exports)(a, s);
    }
    t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
  })(interopRequireWildcard)), interopRequireWildcard.exports;
}
var hasRequiredUseEvent;
function requireUseEvent() {
  if (hasRequiredUseEvent) return useEvent;
  hasRequiredUseEvent = 1;
  var t = requireInteropRequireWildcard().default;
  Object.defineProperty(useEvent, "__esModule", {
    value: !0
  }), useEvent.default = n;
  var r = t(React__default);
  function n(a) {
    var s = r.useRef();
    s.current = a;
    var o = r.useCallback(function() {
      for (var l, c = arguments.length, x = new Array(c), j = 0; j < c; j++)
        x[j] = arguments[j];
      return (l = s.current) === null || l === void 0 ? void 0 : l.call.apply(l, [s].concat(x));
    }, []);
    return o;
  }
  return useEvent;
}
var useLayoutEffect = {}, canUseDom = {}, hasRequiredCanUseDom;
function requireCanUseDom() {
  if (hasRequiredCanUseDom) return canUseDom;
  hasRequiredCanUseDom = 1, Object.defineProperty(canUseDom, "__esModule", {
    value: !0
  }), canUseDom.default = t;
  function t() {
    return !!(typeof window != "undefined" && window.document && window.document.createElement);
  }
  return canUseDom;
}
var hasRequiredUseLayoutEffect;
function requireUseLayoutEffect() {
  if (hasRequiredUseLayoutEffect) return useLayoutEffect;
  hasRequiredUseLayoutEffect = 1;
  var t = requireInteropRequireDefault().default, r = requireInteropRequireWildcard().default;
  Object.defineProperty(useLayoutEffect, "__esModule", {
    value: !0
  }), useLayoutEffect.useLayoutUpdateEffect = useLayoutEffect.default = void 0;
  var n = r(React__default), a = t(requireCanUseDom()), s = process.env.NODE_ENV !== "test" && (0, a.default)() ? n.useLayoutEffect : n.useEffect, o = function(c, x) {
    var j = n.useRef(!0);
    s(function() {
      return c(j.current);
    }, x), s(function() {
      return j.current = !1, function() {
        j.current = !0;
      };
    }, []);
  };
  return useLayoutEffect.useLayoutUpdateEffect = function(c, x) {
    o(function(j) {
      if (!j)
        return c();
    }, x);
  }, useLayoutEffect.default = o, useLayoutEffect;
}
var useState = {}, hasRequiredUseState;
function requireUseState() {
  if (hasRequiredUseState) return useState;
  hasRequiredUseState = 1;
  var t = requireInteropRequireWildcard().default, r = requireInteropRequireDefault().default;
  Object.defineProperty(useState, "__esModule", {
    value: !0
  }), useState.default = s;
  var n = r(requireSlicedToArray()), a = t(React__default);
  function s(o) {
    var l = a.useRef(!1), c = a.useState(o), x = (0, n.default)(c, 2), j = x[0], Z = x[1];
    a.useEffect(function() {
      return l.current = !1, function() {
        l.current = !0;
      };
    }, []);
    function V(U, $) {
      $ && l.current || Z(U);
    }
    return [j, V];
  }
  return useState;
}
var hasRequiredUseMergedState;
function requireUseMergedState() {
  if (hasRequiredUseMergedState) return useMergedState$1;
  hasRequiredUseMergedState = 1;
  var t = requireInteropRequireDefault().default;
  Object.defineProperty(useMergedState$1, "__esModule", {
    value: !0
  }), useMergedState$1.default = l;
  var r = t(requireSlicedToArray()), n = t(requireUseEvent()), a = requireUseLayoutEffect(), s = t(requireUseState());
  function o(c) {
    return c !== void 0;
  }
  function l(c, x) {
    var j = x || {}, Z = j.defaultValue, V = j.value, U = j.onChange, $ = j.postState, Y = (0, s.default)(function() {
      return o(V) ? V : o(Z) ? typeof Z == "function" ? Z() : Z : typeof c == "function" ? c() : c;
    }), G = (0, r.default)(Y, 2), W = G[0], X = G[1], K = V !== void 0 ? V : W, J = $ ? $(K) : K, ee = (0, n.default)(U), te = (0, s.default)([K]), ne = (0, r.default)(te, 2), re = ne[0], ie = ne[1];
    (0, a.useLayoutUpdateEffect)(function() {
      var le = re[0];
      W !== le && ee(W, le);
    }, [re]), (0, a.useLayoutUpdateEffect)(function() {
      o(V) || X(V);
    }, [V]);
    var ue = (0, n.default)(function(le, oe) {
      X(le, oe), ie([K], oe);
    });
    return [J, ue];
  }
  return useMergedState$1;
}
var useMergedStateExports = requireUseMergedState();
const useMergedState = /* @__PURE__ */ getDefaultExportFromCjs(useMergedStateExports), DefaultHeader = ({ text: t, open: r, iconOpen: n, iconClosed: a, iconPlacement: s = "start" }) => {
  const o = n && a && r ? a : n;
  return /* @__PURE__ */ jsxs("div", { className: clsx("go-collapse__default-header", s === "end" && "space-between"), children: [
    s === "end" && t,
    /* @__PURE__ */ jsx("div", { className: clsx("go-collapse__expand-button", r && !a && "open"), children: n ? o : /* @__PURE__ */ jsx(ExpandDown, {}) }),
    s === "start" && t
  ] });
}, CollapsePanel = ({
  onItemClick: t,
  panelKey: r,
  children: n,
  header: a,
  styleHeader: s,
  styleBody: o,
  styleWrapper: l,
  className: c,
  disabled: x,
  iconOpen: j,
  iconClosed: Z,
  stickyHeader: V,
  isActive: U,
  iconPlacement: $
}) => {
  const [Y, G] = useState$1(U != null ? U : !1), W = typeof a == "number" || typeof a == "string" || typeof a == "boolean", X = () => {
    x || G((K) => !K);
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      style: l,
      className: clsx("go-collapse__panel", c, x && "go-collapse__panel_disabled"),
      children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            className: clsx(V && "go-collapse__header_sticky"),
            style: s,
            onClick: () => {
              t && !x ? t(r) : X();
            },
            children: W || !a ? /* @__PURE__ */ jsx(
              DefaultHeader,
              {
                iconPlacement: $,
                iconOpen: j,
                iconClosed: Z,
                open: U != null ? U : Y,
                text: a ? String(a) : ""
              }
            ) : a
          }
        ),
        /* @__PURE__ */ jsx(CollapseBody, { styleBody: o, open: U != null ? U : Y, children: n })
      ]
    },
    r
  );
}, Collapse = ({
  activeKeys: t,
  onChange: r,
  children: n,
  collapseClassname: a,
  collapseStyle: s,
  defaultValue: o
}) => {
  const [l, c] = useMergedState([], {
    defaultValue: o,
    value: t,
    onChange: (j) => r == null ? void 0 : r(j)
  }), x = (j) => {
    c(() => l.indexOf(j) > -1 ? l.filter((U) => U !== j) : [...l, j]);
  };
  return /* @__PURE__ */ jsx("div", { className: clsx("go-collapse", a), style: s, children: Array.isArray(n) ? n.map((j) => /* @__PURE__ */ jsx(
    CollapsePanel,
    {
      onItemClick: x,
      isActive: l.includes(j.props.panelKey),
      ...j.props,
      children: j.props.children
    },
    j.props.panelKey
  )) : /* @__PURE__ */ jsx(
    CollapsePanel,
    {
      onItemClick: x,
      isActive: l.includes(n.props.panelKey),
      ...n.props,
      children: n.props.children
    },
    n.props.panelKey
  ) });
}, CollapseBody = ({ styleBody: t, classNameBody: r, open: n, children: a }) => /* @__PURE__ */ jsx("div", { style: t, className: clsx("go-collapse__body", n && "open", r), children: /* @__PURE__ */ jsx("div", { style: { minHeight: 0 }, children: a }) }), collapse = Object.assign(Collapse, { Panel: CollapsePanel, Body: CollapseBody });
function hasWindow() {
  return typeof window != "undefined";
}
function getNodeName(t) {
  return isNode(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function getWindow(t) {
  var r;
  return (t == null || (r = t.ownerDocument) == null ? void 0 : r.defaultView) || window;
}
function getDocumentElement(t) {
  var r;
  return (r = (isNode(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : r.documentElement;
}
function isNode(t) {
  return hasWindow() ? t instanceof Node || t instanceof getWindow(t).Node : !1;
}
function isElement(t) {
  return hasWindow() ? t instanceof Element || t instanceof getWindow(t).Element : !1;
}
function isHTMLElement(t) {
  return hasWindow() ? t instanceof HTMLElement || t instanceof getWindow(t).HTMLElement : !1;
}
function isShadowRoot(t) {
  return !hasWindow() || typeof ShadowRoot == "undefined" ? !1 : t instanceof ShadowRoot || t instanceof getWindow(t).ShadowRoot;
}
function isOverflowElement(t) {
  const {
    overflow: r,
    overflowX: n,
    overflowY: a,
    display: s
  } = getComputedStyle$1(t);
  return /auto|scroll|overlay|hidden|clip/.test(r + a + n) && s !== "inline" && s !== "contents";
}
function isTableElement(t) {
  return /^(table|td|th)$/.test(getNodeName(t));
}
function isTopLayer(t) {
  try {
    if (t.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return t.matches(":modal");
  } catch {
    return !1;
  }
}
const willChangeRe = /transform|translate|scale|rotate|perspective|filter/, containRe = /paint|layout|strict|content/, isNotNone = (t) => !!t && t !== "none";
let isWebKitValue;
function isContainingBlock(t) {
  const r = isElement(t) ? getComputedStyle$1(t) : t;
  return isNotNone(r.transform) || isNotNone(r.translate) || isNotNone(r.scale) || isNotNone(r.rotate) || isNotNone(r.perspective) || !isWebKit() && (isNotNone(r.backdropFilter) || isNotNone(r.filter)) || willChangeRe.test(r.willChange || "") || containRe.test(r.contain || "");
}
function getContainingBlock(t) {
  let r = getParentNode(t);
  for (; isHTMLElement(r) && !isLastTraversableNode(r); ) {
    if (isContainingBlock(r))
      return r;
    if (isTopLayer(r))
      return null;
    r = getParentNode(r);
  }
  return null;
}
function isWebKit() {
  return isWebKitValue == null && (isWebKitValue = typeof CSS != "undefined" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), isWebKitValue;
}
function isLastTraversableNode(t) {
  return /^(html|body|#document)$/.test(getNodeName(t));
}
function getComputedStyle$1(t) {
  return getWindow(t).getComputedStyle(t);
}
function getNodeScroll(t) {
  return isElement(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function getParentNode(t) {
  if (getNodeName(t) === "html")
    return t;
  const r = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    isShadowRoot(t) && t.host || // Fallback.
    getDocumentElement(t)
  );
  return isShadowRoot(r) ? r.host : r;
}
function getNearestOverflowAncestor(t) {
  const r = getParentNode(t);
  return isLastTraversableNode(r) ? t.ownerDocument ? t.ownerDocument.body : t.body : isHTMLElement(r) && isOverflowElement(r) ? r : getNearestOverflowAncestor(r);
}
function getOverflowAncestors(t, r, n) {
  var a;
  r === void 0 && (r = []), n === void 0 && (n = !0);
  const s = getNearestOverflowAncestor(t), o = s === ((a = t.ownerDocument) == null ? void 0 : a.body), l = getWindow(s);
  if (o) {
    const c = getFrameElement(l);
    return r.concat(l, l.visualViewport || [], isOverflowElement(s) ? s : [], c && n ? getOverflowAncestors(c) : []);
  } else
    return r.concat(s, getOverflowAncestors(s, [], n));
}
function getFrameElement(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
const min$1 = Math.min, max$1 = Math.max, round$1 = Math.round, floor$1 = Math.floor, createCoords = (t) => ({
  x: t,
  y: t
}), oppositeSideMap = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function clamp$1(t, r, n) {
  return max$1(t, min$1(r, n));
}
function evaluate(t, r) {
  return typeof t == "function" ? t(r) : t;
}
function getSide(t) {
  return t.split("-")[0];
}
function getAlignment(t) {
  return t.split("-")[1];
}
function getOppositeAxis(t) {
  return t === "x" ? "y" : "x";
}
function getAxisLength(t) {
  return t === "y" ? "height" : "width";
}
function getSideAxis(t) {
  const r = t[0];
  return r === "t" || r === "b" ? "y" : "x";
}
function getAlignmentAxis(t) {
  return getOppositeAxis(getSideAxis(t));
}
function getAlignmentSides(t, r, n) {
  n === void 0 && (n = !1);
  const a = getAlignment(t), s = getAlignmentAxis(t), o = getAxisLength(s);
  let l = s === "x" ? a === (n ? "end" : "start") ? "right" : "left" : a === "start" ? "bottom" : "top";
  return r.reference[o] > r.floating[o] && (l = getOppositePlacement(l)), [l, getOppositePlacement(l)];
}
function getExpandedPlacements(t) {
  const r = getOppositePlacement(t);
  return [getOppositeAlignmentPlacement(t), r, getOppositeAlignmentPlacement(r)];
}
function getOppositeAlignmentPlacement(t) {
  return t.includes("start") ? t.replace("start", "end") : t.replace("end", "start");
}
const lrPlacement = ["left", "right"], rlPlacement = ["right", "left"], tbPlacement = ["top", "bottom"], btPlacement = ["bottom", "top"];
function getSideList(t, r, n) {
  switch (t) {
    case "top":
    case "bottom":
      return n ? r ? rlPlacement : lrPlacement : r ? lrPlacement : rlPlacement;
    case "left":
    case "right":
      return r ? tbPlacement : btPlacement;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(t, r, n, a) {
  const s = getAlignment(t);
  let o = getSideList(getSide(t), n === "start", a);
  return s && (o = o.map((l) => l + "-" + s), r && (o = o.concat(o.map(getOppositeAlignmentPlacement)))), o;
}
function getOppositePlacement(t) {
  const r = getSide(t);
  return oppositeSideMap[r] + t.slice(r.length);
}
function expandPaddingObject(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function getPaddingObject(t) {
  return typeof t != "number" ? expandPaddingObject(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function rectToClientRect(t) {
  const {
    x: r,
    y: n,
    width: a,
    height: s
  } = t;
  return {
    width: a,
    height: s,
    top: n,
    left: r,
    right: r + a,
    bottom: n + s,
    x: r,
    y: n
  };
}
var candidateSelectors = ["input:not([inert]):not([inert] *)", "select:not([inert]):not([inert] *)", "textarea:not([inert]):not([inert] *)", "a[href]:not([inert]):not([inert] *)", "button:not([inert]):not([inert] *)", "[tabindex]:not(slot):not([inert]):not([inert] *)", "audio[controls]:not([inert]):not([inert] *)", "video[controls]:not([inert]):not([inert] *)", '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)', "details>summary:first-of-type:not([inert]):not([inert] *)", "details:not([inert]):not([inert] *)"], candidateSelector = /* @__PURE__ */ candidateSelectors.join(","), NoElement = typeof Element == "undefined", matches = NoElement ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, getRootNode = !NoElement && Element.prototype.getRootNode ? function(t) {
  var r;
  return t == null || (r = t.getRootNode) === null || r === void 0 ? void 0 : r.call(t);
} : function(t) {
  return t == null ? void 0 : t.ownerDocument;
}, _isInert = function t(r, n) {
  var a;
  n === void 0 && (n = !0);
  var s = r == null || (a = r.getAttribute) === null || a === void 0 ? void 0 : a.call(r, "inert"), o = s === "" || s === "true", l = o || n && r && // closest does not exist on shadow roots, so we fall back to a manual
  // lookup upward, in case it is not defined.
  (typeof r.closest == "function" ? r.closest("[inert]") : _isInert(r.parentNode));
  return l;
}, isContentEditable = function t(r) {
  var n, a = r == null || (n = r.getAttribute) === null || n === void 0 ? void 0 : n.call(r, "contenteditable");
  return a === "" || a === "true";
}, getCandidates = function t(r, n, a) {
  if (_isInert(r))
    return [];
  var s = Array.prototype.slice.apply(r.querySelectorAll(candidateSelector));
  return n && matches.call(r, candidateSelector) && s.unshift(r), s = s.filter(a), s;
}, _getCandidatesIteratively = function t(r, n, a) {
  for (var s = [], o = Array.from(r); o.length; ) {
    var l = o.shift();
    if (!_isInert(l, !1))
      if (l.tagName === "SLOT") {
        var c = l.assignedElements(), x = c.length ? c : l.children, j = _getCandidatesIteratively(x, !0, a);
        a.flatten ? s.push.apply(s, j) : s.push({
          scopeParent: l,
          candidates: j
        });
      } else {
        var Z = matches.call(l, candidateSelector);
        Z && a.filter(l) && (n || !r.includes(l)) && s.push(l);
        var V = l.shadowRoot || // check for an undisclosed shadow
        typeof a.getShadowRoot == "function" && a.getShadowRoot(l), U = !_isInert(V, !1) && (!a.shadowRootFilter || a.shadowRootFilter(l));
        if (V && U) {
          var $ = _getCandidatesIteratively(V === !0 ? l.children : V.children, !0, a);
          a.flatten ? s.push.apply(s, $) : s.push({
            scopeParent: l,
            candidates: $
          });
        } else
          o.unshift.apply(o, l.children);
      }
  }
  return s;
}, hasTabIndex = function t(r) {
  return !isNaN(parseInt(r.getAttribute("tabindex"), 10));
}, getTabIndex = function t(r) {
  if (!r)
    throw new Error("No node provided");
  return r.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(r.tagName) || isContentEditable(r)) && !hasTabIndex(r) ? 0 : r.tabIndex;
}, getSortOrderTabIndex = function t(r, n) {
  var a = getTabIndex(r);
  return a < 0 && n && !hasTabIndex(r) ? 0 : a;
}, sortOrderedTabbables = function t(r, n) {
  return r.tabIndex === n.tabIndex ? r.documentOrder - n.documentOrder : r.tabIndex - n.tabIndex;
}, isInput = function t(r) {
  return r.tagName === "INPUT";
}, isHiddenInput = function t(r) {
  return isInput(r) && r.type === "hidden";
}, isDetailsWithSummary = function t(r) {
  var n = r.tagName === "DETAILS" && Array.prototype.slice.apply(r.children).some(function(a) {
    return a.tagName === "SUMMARY";
  });
  return n;
}, getCheckedRadio = function t(r, n) {
  for (var a = 0; a < r.length; a++)
    if (r[a].checked && r[a].form === n)
      return r[a];
}, isTabbableRadio = function t(r) {
  if (!r.name)
    return !0;
  var n = r.form || getRootNode(r), a = function(c) {
    return n.querySelectorAll('input[type="radio"][name="' + c + '"]');
  }, s;
  if (typeof window != "undefined" && typeof window.CSS != "undefined" && typeof window.CSS.escape == "function")
    s = a(window.CSS.escape(r.name));
  else
    try {
      s = a(r.name);
    } catch (l) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", l.message), !1;
    }
  var o = getCheckedRadio(s, r.form);
  return !o || o === r;
}, isRadio = function t(r) {
  return isInput(r) && r.type === "radio";
}, isNonTabbableRadio = function t(r) {
  return isRadio(r) && !isTabbableRadio(r);
}, isNodeAttached = function t(r) {
  var n, a = r && getRootNode(r), s = (n = a) === null || n === void 0 ? void 0 : n.host, o = !1;
  if (a && a !== r) {
    var l, c, x;
    for (o = !!((l = s) !== null && l !== void 0 && (c = l.ownerDocument) !== null && c !== void 0 && c.contains(s) || r != null && (x = r.ownerDocument) !== null && x !== void 0 && x.contains(r)); !o && s; ) {
      var j, Z, V;
      a = getRootNode(s), s = (j = a) === null || j === void 0 ? void 0 : j.host, o = !!((Z = s) !== null && Z !== void 0 && (V = Z.ownerDocument) !== null && V !== void 0 && V.contains(s));
    }
  }
  return o;
}, isZeroArea = function t(r) {
  var n = r.getBoundingClientRect(), a = n.width, s = n.height;
  return a === 0 && s === 0;
}, isHidden = function t(r, n) {
  var a = n.displayCheck, s = n.getShadowRoot;
  if (a === "full-native" && "checkVisibility" in r) {
    var o = r.checkVisibility({
      // Checking opacity might be desirable for some use cases, but natively,
      // opacity zero elements _are_ focusable and tabbable.
      checkOpacity: !1,
      opacityProperty: !1,
      contentVisibilityAuto: !0,
      visibilityProperty: !0,
      // This is an alias for `visibilityProperty`. Contemporary browsers
      // support both. However, this alias has wider browser support (Chrome
      // >= 105 and Firefox >= 106, vs. Chrome >= 121 and Firefox >= 122), so
      // we include it anyway.
      checkVisibilityCSS: !0
    });
    return !o;
  }
  if (getComputedStyle(r).visibility === "hidden")
    return !0;
  var l = matches.call(r, "details>summary:first-of-type"), c = l ? r.parentElement : r;
  if (matches.call(c, "details:not([open]) *"))
    return !0;
  if (!a || a === "full" || // full-native can run this branch when it falls through in case
  // Element#checkVisibility is unsupported
  a === "full-native" || a === "legacy-full") {
    if (typeof s == "function") {
      for (var x = r; r; ) {
        var j = r.parentElement, Z = getRootNode(r);
        if (j && !j.shadowRoot && s(j) === !0)
          return isZeroArea(r);
        r.assignedSlot ? r = r.assignedSlot : !j && Z !== r.ownerDocument ? r = Z.host : r = j;
      }
      r = x;
    }
    if (isNodeAttached(r))
      return !r.getClientRects().length;
    if (a !== "legacy-full")
      return !0;
  } else if (a === "non-zero-area")
    return isZeroArea(r);
  return !1;
}, isDisabledFromFieldset = function t(r) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(r.tagName))
    for (var n = r.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var a = 0; a < n.children.length; a++) {
          var s = n.children.item(a);
          if (s.tagName === "LEGEND")
            return matches.call(n, "fieldset[disabled] *") ? !0 : !s.contains(r);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, isNodeMatchingSelectorFocusable = function t(r, n) {
  return !(n.disabled || isHiddenInput(n) || isHidden(n, r) || // For a details element with a summary, the summary element gets the focus
  isDetailsWithSummary(n) || isDisabledFromFieldset(n));
}, isNodeMatchingSelectorTabbable = function t(r, n) {
  return !(isNonTabbableRadio(n) || getTabIndex(n) < 0 || !isNodeMatchingSelectorFocusable(r, n));
}, isShadowRootTabbable = function t(r) {
  var n = parseInt(r.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, _sortByOrder = function t(r) {
  var n = [], a = [];
  return r.forEach(function(s, o) {
    var l = !!s.scopeParent, c = l ? s.scopeParent : s, x = getSortOrderTabIndex(c, l), j = l ? _sortByOrder(s.candidates) : c;
    x === 0 ? l ? n.push.apply(n, j) : n.push(c) : a.push({
      documentOrder: o,
      tabIndex: x,
      item: s,
      isScope: l,
      content: j
    });
  }), a.sort(sortOrderedTabbables).reduce(function(s, o) {
    return o.isScope ? s.push.apply(s, o.content) : s.push(o.content), s;
  }, []).concat(n);
}, tabbable = function t(r, n) {
  n = n || {};
  var a;
  return n.getShadowRoot ? a = _getCandidatesIteratively([r], n.includeContainer, {
    filter: isNodeMatchingSelectorTabbable.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: isShadowRootTabbable
  }) : a = getCandidates(r, n.includeContainer, isNodeMatchingSelectorTabbable.bind(null, n)), _sortByOrder(a);
}, focusable = function t(r, n) {
  n = n || {};
  var a;
  return n.getShadowRoot ? a = _getCandidatesIteratively([r], n.includeContainer, {
    filter: isNodeMatchingSelectorFocusable.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : a = getCandidates(r, n.includeContainer, isNodeMatchingSelectorFocusable.bind(null, n)), a;
}, isTabbable = function t(r, n) {
  if (n = n || {}, !r)
    throw new Error("No node provided");
  return matches.call(r, candidateSelector) === !1 ? !1 : isNodeMatchingSelectorTabbable(n, r);
};
function getPlatform() {
  const t = navigator.userAgentData;
  return t != null && t.platform ? t.platform : navigator.platform;
}
function getUserAgent() {
  const t = navigator.userAgentData;
  return t && Array.isArray(t.brands) ? t.brands.map((r) => {
    let {
      brand: n,
      version: a
    } = r;
    return n + "/" + a;
  }).join(" ") : navigator.userAgent;
}
function isSafari() {
  return /apple/i.test(navigator.vendor);
}
function isAndroid() {
  const t = /android/i;
  return t.test(getPlatform()) || t.test(getUserAgent());
}
function isMac() {
  return getPlatform().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function isJSDOM() {
  return getUserAgent().includes("jsdom/");
}
const FOCUSABLE_ATTRIBUTE$1 = "data-floating-ui-focusable", TYPEABLE_SELECTOR = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function activeElement(t) {
  let r = t.activeElement;
  for (; ((n = r) == null || (n = n.shadowRoot) == null ? void 0 : n.activeElement) != null; ) {
    var n;
    r = r.shadowRoot.activeElement;
  }
  return r;
}
function contains$1(t, r) {
  if (!t || !r)
    return !1;
  const n = r.getRootNode == null ? void 0 : r.getRootNode();
  if (t.contains(r))
    return !0;
  if (n && isShadowRoot(n)) {
    let a = r;
    for (; a; ) {
      if (t === a)
        return !0;
      a = a.parentNode || a.host;
    }
  }
  return !1;
}
function getTarget$1(t) {
  return "composedPath" in t ? t.composedPath()[0] : t.target;
}
function isEventTargetWithin(t, r) {
  if (r == null)
    return !1;
  if ("composedPath" in t)
    return t.composedPath().includes(r);
  const n = t;
  return n.target != null && r.contains(n.target);
}
function isRootElement(t) {
  return t.matches("html,body");
}
function getDocument$1(t) {
  return (t == null ? void 0 : t.ownerDocument) || document;
}
function isTypeableElement(t) {
  return isHTMLElement(t) && t.matches(TYPEABLE_SELECTOR);
}
function isTypeableCombobox(t) {
  return t ? t.getAttribute("role") === "combobox" && isTypeableElement(t) : !1;
}
function matchesFocusVisible(t) {
  if (!t || isJSDOM()) return !0;
  try {
    return t.matches(":focus-visible");
  } catch {
    return !0;
  }
}
function getFloatingFocusElement(t) {
  return t ? t.hasAttribute(FOCUSABLE_ATTRIBUTE$1) ? t : t.querySelector("[" + FOCUSABLE_ATTRIBUTE$1 + "]") || t : null;
}
function getNodeChildren$1(t, r, n) {
  return n === void 0 && (n = !0), t.filter((s) => {
    var o;
    return s.parentId === r && (!n || ((o = s.context) == null ? void 0 : o.open));
  }).flatMap((s) => [s, ...getNodeChildren$1(t, s.id, n)]);
}
function getNodeAncestors(t, r) {
  var n;
  let a = [], s = (n = t.find((o) => o.id === r)) == null ? void 0 : n.parentId;
  for (; s; ) {
    const o = t.find((l) => l.id === s);
    s = o == null ? void 0 : o.parentId, o && (a = a.concat(o));
  }
  return a;
}
function stopEvent(t) {
  t.preventDefault(), t.stopPropagation();
}
function isReactEvent(t) {
  return "nativeEvent" in t;
}
function isVirtualClick(t) {
  return t.mozInputSource === 0 && t.isTrusted ? !0 : isAndroid() && t.pointerType ? t.type === "click" && t.buttons === 1 : t.detail === 0 && !t.pointerType;
}
function isVirtualPointerEvent(t) {
  return isJSDOM() ? !1 : !isAndroid() && t.width === 0 && t.height === 0 || isAndroid() && t.width === 1 && t.height === 1 && t.pressure === 0 && t.detail === 0 && t.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  t.width < 1 && t.height < 1 && t.pressure === 0 && t.detail === 0 && t.pointerType === "touch";
}
function isMouseLikePointerType(t, r) {
  const n = ["mouse", "pen"];
  return r || n.push("", void 0), n.includes(t);
}
var isClient$1 = typeof document != "undefined", noop$1 = function t() {
}, index$1 = isClient$1 ? useLayoutEffect$3 : noop$1;
const SafeReact$1 = {
  ...React
};
function useLatestRef$1(t) {
  const r = React.useRef(t);
  return index$1(() => {
    r.current = t;
  }), r;
}
const useInsertionEffect = SafeReact$1.useInsertionEffect, useSafeInsertionEffect = useInsertionEffect || ((t) => t());
function useEffectEvent(t) {
  const r = React.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return useSafeInsertionEffect(() => {
    r.current = t;
  }), React.useCallback(function() {
    for (var n = arguments.length, a = new Array(n), s = 0; s < n; s++)
      a[s] = arguments[s];
    return r.current == null ? void 0 : r.current(...a);
  }, []);
}
const getTabbableOptions = () => ({
  getShadowRoot: !0,
  displayCheck: (
    // JSDOM does not support the `tabbable` library. To solve this we can
    // check if `ResizeObserver` is a real function (not polyfilled), which
    // determines if the current environment is JSDOM-like.
    typeof ResizeObserver == "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
  )
});
function getTabbableIn(t, r) {
  const n = tabbable(t, getTabbableOptions()), a = n.length;
  if (a === 0) return;
  const s = activeElement(getDocument$1(t)), o = n.indexOf(s), l = o === -1 ? r === 1 ? 0 : a - 1 : o + r;
  return n[l];
}
function getNextTabbable(t) {
  return getTabbableIn(getDocument$1(t).body, 1) || t;
}
function getPreviousTabbable(t) {
  return getTabbableIn(getDocument$1(t).body, -1) || t;
}
function isOutsideEvent(t, r) {
  const n = r || t.currentTarget, a = t.relatedTarget;
  return !a || !contains$1(n, a);
}
function disableFocusInside(t) {
  tabbable(t, getTabbableOptions()).forEach((n) => {
    n.dataset.tabindex = n.getAttribute("tabindex") || "", n.setAttribute("tabindex", "-1");
  });
}
function enableFocusInside(t) {
  t.querySelectorAll("[data-tabindex]").forEach((n) => {
    const a = n.dataset.tabindex;
    delete n.dataset.tabindex, a ? n.setAttribute("tabindex", a) : n.removeAttribute("tabindex");
  });
}
function computeCoordsFromPlacement(t, r, n) {
  let {
    reference: a,
    floating: s
  } = t;
  const o = getSideAxis(r), l = getAlignmentAxis(r), c = getAxisLength(l), x = getSide(r), j = o === "y", Z = a.x + a.width / 2 - s.width / 2, V = a.y + a.height / 2 - s.height / 2, U = a[c] / 2 - s[c] / 2;
  let $;
  switch (x) {
    case "top":
      $ = {
        x: Z,
        y: a.y - s.height
      };
      break;
    case "bottom":
      $ = {
        x: Z,
        y: a.y + a.height
      };
      break;
    case "right":
      $ = {
        x: a.x + a.width,
        y: V
      };
      break;
    case "left":
      $ = {
        x: a.x - s.width,
        y: V
      };
      break;
    default:
      $ = {
        x: a.x,
        y: a.y
      };
  }
  switch (getAlignment(r)) {
    case "start":
      $[l] -= U * (n && j ? -1 : 1);
      break;
    case "end":
      $[l] += U * (n && j ? -1 : 1);
      break;
  }
  return $;
}
async function detectOverflow(t, r) {
  var n;
  r === void 0 && (r = {});
  const {
    x: a,
    y: s,
    platform: o,
    rects: l,
    elements: c,
    strategy: x
  } = t, {
    boundary: j = "clippingAncestors",
    rootBoundary: Z = "viewport",
    elementContext: V = "floating",
    altBoundary: U = !1,
    padding: $ = 0
  } = evaluate(r, t), Y = getPaddingObject($), W = c[U ? V === "floating" ? "reference" : "floating" : V], X = rectToClientRect(await o.getClippingRect({
    element: (n = await (o.isElement == null ? void 0 : o.isElement(W))) == null || n ? W : W.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(c.floating)),
    boundary: j,
    rootBoundary: Z,
    strategy: x
  })), K = V === "floating" ? {
    x: a,
    y: s,
    width: l.floating.width,
    height: l.floating.height
  } : l.reference, J = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(c.floating)), ee = await (o.isElement == null ? void 0 : o.isElement(J)) ? await (o.getScale == null ? void 0 : o.getScale(J)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, te = rectToClientRect(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: c,
    rect: K,
    offsetParent: J,
    strategy: x
  }) : K);
  return {
    top: (X.top - te.top + Y.top) / ee.y,
    bottom: (te.bottom - X.bottom + Y.bottom) / ee.y,
    left: (X.left - te.left + Y.left) / ee.x,
    right: (te.right - X.right + Y.right) / ee.x
  };
}
const MAX_RESET_COUNT = 50, computePosition$1 = async (t, r, n) => {
  const {
    placement: a = "bottom",
    strategy: s = "absolute",
    middleware: o = [],
    platform: l
  } = n, c = l.detectOverflow ? l : {
    ...l,
    detectOverflow
  }, x = await (l.isRTL == null ? void 0 : l.isRTL(r));
  let j = await l.getElementRects({
    reference: t,
    floating: r,
    strategy: s
  }), {
    x: Z,
    y: V
  } = computeCoordsFromPlacement(j, a, x), U = a, $ = 0;
  const Y = {};
  for (let G = 0; G < o.length; G++) {
    const W = o[G];
    if (!W)
      continue;
    const {
      name: X,
      fn: K
    } = W, {
      x: J,
      y: ee,
      data: te,
      reset: ne
    } = await K({
      x: Z,
      y: V,
      initialPlacement: a,
      placement: U,
      strategy: s,
      middlewareData: Y,
      rects: j,
      platform: c,
      elements: {
        reference: t,
        floating: r
      }
    });
    Z = J != null ? J : Z, V = ee != null ? ee : V, Y[X] = {
      ...Y[X],
      ...te
    }, ne && $ < MAX_RESET_COUNT && ($++, typeof ne == "object" && (ne.placement && (U = ne.placement), ne.rects && (j = ne.rects === !0 ? await l.getElementRects({
      reference: t,
      floating: r,
      strategy: s
    }) : ne.rects), {
      x: Z,
      y: V
    } = computeCoordsFromPlacement(j, U, x)), G = -1);
  }
  return {
    x: Z,
    y: V,
    placement: U,
    strategy: s,
    middlewareData: Y
  };
}, arrow$3 = (t) => ({
  name: "arrow",
  options: t,
  async fn(r) {
    const {
      x: n,
      y: a,
      placement: s,
      rects: o,
      platform: l,
      elements: c,
      middlewareData: x
    } = r, {
      element: j,
      padding: Z = 0
    } = evaluate(t, r) || {};
    if (j == null)
      return {};
    const V = getPaddingObject(Z), U = {
      x: n,
      y: a
    }, $ = getAlignmentAxis(s), Y = getAxisLength($), G = await l.getDimensions(j), W = $ === "y", X = W ? "top" : "left", K = W ? "bottom" : "right", J = W ? "clientHeight" : "clientWidth", ee = o.reference[Y] + o.reference[$] - U[$] - o.floating[Y], te = U[$] - o.reference[$], ne = await (l.getOffsetParent == null ? void 0 : l.getOffsetParent(j));
    let re = ne ? ne[J] : 0;
    (!re || !await (l.isElement == null ? void 0 : l.isElement(ne))) && (re = c.floating[J] || o.floating[Y]);
    const ie = ee / 2 - te / 2, ue = re / 2 - G[Y] / 2 - 1, le = min$1(V[X], ue), oe = min$1(V[K], ue), he = le, fe = re - G[Y] - oe, ce = re / 2 - G[Y] / 2 + ie, se = clamp$1(he, ce, fe), pe = !x.arrow && getAlignment(s) != null && ce !== se && o.reference[Y] / 2 - (ce < he ? le : oe) - G[Y] / 2 < 0, ve = pe ? ce < he ? ce - he : ce - fe : 0;
    return {
      [$]: U[$] + ve,
      data: {
        [$]: se,
        centerOffset: ce - se - ve,
        ...pe && {
          alignmentOffset: ve
        }
      },
      reset: pe
    };
  }
}), flip$2 = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(r) {
      var n, a;
      const {
        placement: s,
        middlewareData: o,
        rects: l,
        initialPlacement: c,
        platform: x,
        elements: j
      } = r, {
        mainAxis: Z = !0,
        crossAxis: V = !0,
        fallbackPlacements: U,
        fallbackStrategy: $ = "bestFit",
        fallbackAxisSideDirection: Y = "none",
        flipAlignment: G = !0,
        ...W
      } = evaluate(t, r);
      if ((n = o.arrow) != null && n.alignmentOffset)
        return {};
      const X = getSide(s), K = getSideAxis(c), J = getSide(c) === c, ee = await (x.isRTL == null ? void 0 : x.isRTL(j.floating)), te = U || (J || !G ? [getOppositePlacement(c)] : getExpandedPlacements(c)), ne = Y !== "none";
      !U && ne && te.push(...getOppositeAxisPlacements(c, G, Y, ee));
      const re = [c, ...te], ie = await x.detectOverflow(r, W), ue = [];
      let le = ((a = o.flip) == null ? void 0 : a.overflows) || [];
      if (Z && ue.push(ie[X]), V) {
        const ce = getAlignmentSides(s, l, ee);
        ue.push(ie[ce[0]], ie[ce[1]]);
      }
      if (le = [...le, {
        placement: s,
        overflows: ue
      }], !ue.every((ce) => ce <= 0)) {
        var oe, he;
        const ce = (((oe = o.flip) == null ? void 0 : oe.index) || 0) + 1, se = re[ce];
        if (se && (!(V === "alignment" ? K !== getSideAxis(se) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        le.every((ae) => getSideAxis(ae.placement) === K ? ae.overflows[0] > 0 : !0)))
          return {
            data: {
              index: ce,
              overflows: le
            },
            reset: {
              placement: se
            }
          };
        let pe = (he = le.filter((ve) => ve.overflows[0] <= 0).sort((ve, ae) => ve.overflows[1] - ae.overflows[1])[0]) == null ? void 0 : he.placement;
        if (!pe)
          switch ($) {
            case "bestFit": {
              var fe;
              const ve = (fe = le.filter((ae) => {
                if (ne) {
                  const me = getSideAxis(ae.placement);
                  return me === K || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  me === "y";
                }
                return !0;
              }).map((ae) => [ae.placement, ae.overflows.filter((me) => me > 0).reduce((me, de) => me + de, 0)]).sort((ae, me) => ae[1] - me[1])[0]) == null ? void 0 : fe[0];
              ve && (pe = ve);
              break;
            }
            case "initialPlacement":
              pe = c;
              break;
          }
        if (s !== pe)
          return {
            reset: {
              placement: pe
            }
          };
      }
      return {};
    }
  };
}, originSides = /* @__PURE__ */ new Set(["left", "top"]);
async function convertValueToCoords(t, r) {
  const {
    placement: n,
    platform: a,
    elements: s
  } = t, o = await (a.isRTL == null ? void 0 : a.isRTL(s.floating)), l = getSide(n), c = getAlignment(n), x = getSideAxis(n) === "y", j = originSides.has(l) ? -1 : 1, Z = o && x ? -1 : 1, V = evaluate(r, t);
  let {
    mainAxis: U,
    crossAxis: $,
    alignmentAxis: Y
  } = typeof V == "number" ? {
    mainAxis: V,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: V.mainAxis || 0,
    crossAxis: V.crossAxis || 0,
    alignmentAxis: V.alignmentAxis
  };
  return c && typeof Y == "number" && ($ = c === "end" ? Y * -1 : Y), x ? {
    x: $ * Z,
    y: U * j
  } : {
    x: U * j,
    y: $ * Z
  };
}
const offset$2 = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(r) {
      var n, a;
      const {
        x: s,
        y: o,
        placement: l,
        middlewareData: c
      } = r, x = await convertValueToCoords(r, t);
      return l === ((n = c.offset) == null ? void 0 : n.placement) && (a = c.arrow) != null && a.alignmentOffset ? {} : {
        x: s + x.x,
        y: o + x.y,
        data: {
          ...x,
          placement: l
        }
      };
    }
  };
}, shift$2 = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(r) {
      const {
        x: n,
        y: a,
        placement: s,
        platform: o
      } = r, {
        mainAxis: l = !0,
        crossAxis: c = !1,
        limiter: x = {
          fn: (X) => {
            let {
              x: K,
              y: J
            } = X;
            return {
              x: K,
              y: J
            };
          }
        },
        ...j
      } = evaluate(t, r), Z = {
        x: n,
        y: a
      }, V = await o.detectOverflow(r, j), U = getSideAxis(getSide(s)), $ = getOppositeAxis(U);
      let Y = Z[$], G = Z[U];
      if (l) {
        const X = $ === "y" ? "top" : "left", K = $ === "y" ? "bottom" : "right", J = Y + V[X], ee = Y - V[K];
        Y = clamp$1(J, Y, ee);
      }
      if (c) {
        const X = U === "y" ? "top" : "left", K = U === "y" ? "bottom" : "right", J = G + V[X], ee = G - V[K];
        G = clamp$1(J, G, ee);
      }
      const W = x.fn({
        ...r,
        [$]: Y,
        [U]: G
      });
      return {
        ...W,
        data: {
          x: W.x - n,
          y: W.y - a,
          enabled: {
            [$]: l,
            [U]: c
          }
        }
      };
    }
  };
};
function getCssDimensions(t) {
  const r = getComputedStyle$1(t);
  let n = parseFloat(r.width) || 0, a = parseFloat(r.height) || 0;
  const s = isHTMLElement(t), o = s ? t.offsetWidth : n, l = s ? t.offsetHeight : a, c = round$1(n) !== o || round$1(a) !== l;
  return c && (n = o, a = l), {
    width: n,
    height: a,
    $: c
  };
}
function unwrapElement(t) {
  return isElement(t) ? t : t.contextElement;
}
function getScale(t) {
  const r = unwrapElement(t);
  if (!isHTMLElement(r))
    return createCoords(1);
  const n = r.getBoundingClientRect(), {
    width: a,
    height: s,
    $: o
  } = getCssDimensions(r);
  let l = (o ? round$1(n.width) : n.width) / a, c = (o ? round$1(n.height) : n.height) / s;
  return (!l || !Number.isFinite(l)) && (l = 1), (!c || !Number.isFinite(c)) && (c = 1), {
    x: l,
    y: c
  };
}
const noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(t) {
  const r = getWindow(t);
  return !isWebKit() || !r.visualViewport ? noOffsets : {
    x: r.visualViewport.offsetLeft,
    y: r.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(t, r, n) {
  return r === void 0 && (r = !1), !n || r && n !== getWindow(t) ? !1 : r;
}
function getBoundingClientRect(t, r, n, a) {
  r === void 0 && (r = !1), n === void 0 && (n = !1);
  const s = t.getBoundingClientRect(), o = unwrapElement(t);
  let l = createCoords(1);
  r && (a ? isElement(a) && (l = getScale(a)) : l = getScale(t));
  const c = shouldAddVisualOffsets(o, n, a) ? getVisualOffsets(o) : createCoords(0);
  let x = (s.left + c.x) / l.x, j = (s.top + c.y) / l.y, Z = s.width / l.x, V = s.height / l.y;
  if (o) {
    const U = getWindow(o), $ = a && isElement(a) ? getWindow(a) : a;
    let Y = U, G = getFrameElement(Y);
    for (; G && a && $ !== Y; ) {
      const W = getScale(G), X = G.getBoundingClientRect(), K = getComputedStyle$1(G), J = X.left + (G.clientLeft + parseFloat(K.paddingLeft)) * W.x, ee = X.top + (G.clientTop + parseFloat(K.paddingTop)) * W.y;
      x *= W.x, j *= W.y, Z *= W.x, V *= W.y, x += J, j += ee, Y = getWindow(G), G = getFrameElement(Y);
    }
  }
  return rectToClientRect({
    width: Z,
    height: V,
    x,
    y: j
  });
}
function getWindowScrollBarX(t, r) {
  const n = getNodeScroll(t).scrollLeft;
  return r ? r.left + n : getBoundingClientRect(getDocumentElement(t)).left + n;
}
function getHTMLOffset(t, r) {
  const n = t.getBoundingClientRect(), a = n.left + r.scrollLeft - getWindowScrollBarX(t, n), s = n.top + r.scrollTop;
  return {
    x: a,
    y: s
  };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(t) {
  let {
    elements: r,
    rect: n,
    offsetParent: a,
    strategy: s
  } = t;
  const o = s === "fixed", l = getDocumentElement(a), c = r ? isTopLayer(r.floating) : !1;
  if (a === l || c && o)
    return n;
  let x = {
    scrollLeft: 0,
    scrollTop: 0
  }, j = createCoords(1);
  const Z = createCoords(0), V = isHTMLElement(a);
  if ((V || !V && !o) && ((getNodeName(a) !== "body" || isOverflowElement(l)) && (x = getNodeScroll(a)), V)) {
    const $ = getBoundingClientRect(a);
    j = getScale(a), Z.x = $.x + a.clientLeft, Z.y = $.y + a.clientTop;
  }
  const U = l && !V && !o ? getHTMLOffset(l, x) : createCoords(0);
  return {
    width: n.width * j.x,
    height: n.height * j.y,
    x: n.x * j.x - x.scrollLeft * j.x + Z.x + U.x,
    y: n.y * j.y - x.scrollTop * j.y + Z.y + U.y
  };
}
function getClientRects(t) {
  return Array.from(t.getClientRects());
}
function getDocumentRect(t) {
  const r = getDocumentElement(t), n = getNodeScroll(t), a = t.ownerDocument.body, s = max$1(r.scrollWidth, r.clientWidth, a.scrollWidth, a.clientWidth), o = max$1(r.scrollHeight, r.clientHeight, a.scrollHeight, a.clientHeight);
  let l = -n.scrollLeft + getWindowScrollBarX(t);
  const c = -n.scrollTop;
  return getComputedStyle$1(a).direction === "rtl" && (l += max$1(r.clientWidth, a.clientWidth) - s), {
    width: s,
    height: o,
    x: l,
    y: c
  };
}
const SCROLLBAR_MAX = 25;
function getViewportRect(t, r) {
  const n = getWindow(t), a = getDocumentElement(t), s = n.visualViewport;
  let o = a.clientWidth, l = a.clientHeight, c = 0, x = 0;
  if (s) {
    o = s.width, l = s.height;
    const Z = isWebKit();
    (!Z || Z && r === "fixed") && (c = s.offsetLeft, x = s.offsetTop);
  }
  const j = getWindowScrollBarX(a);
  if (j <= 0) {
    const Z = a.ownerDocument, V = Z.body, U = getComputedStyle(V), $ = Z.compatMode === "CSS1Compat" && parseFloat(U.marginLeft) + parseFloat(U.marginRight) || 0, Y = Math.abs(a.clientWidth - V.clientWidth - $);
    Y <= SCROLLBAR_MAX && (o -= Y);
  } else j <= SCROLLBAR_MAX && (o += j);
  return {
    width: o,
    height: l,
    x: c,
    y: x
  };
}
function getInnerBoundingClientRect(t, r) {
  const n = getBoundingClientRect(t, !0, r === "fixed"), a = n.top + t.clientTop, s = n.left + t.clientLeft, o = isHTMLElement(t) ? getScale(t) : createCoords(1), l = t.clientWidth * o.x, c = t.clientHeight * o.y, x = s * o.x, j = a * o.y;
  return {
    width: l,
    height: c,
    x,
    y: j
  };
}
function getClientRectFromClippingAncestor(t, r, n) {
  let a;
  if (r === "viewport")
    a = getViewportRect(t, n);
  else if (r === "document")
    a = getDocumentRect(getDocumentElement(t));
  else if (isElement(r))
    a = getInnerBoundingClientRect(r, n);
  else {
    const s = getVisualOffsets(t);
    a = {
      x: r.x - s.x,
      y: r.y - s.y,
      width: r.width,
      height: r.height
    };
  }
  return rectToClientRect(a);
}
function hasFixedPositionAncestor(t, r) {
  const n = getParentNode(t);
  return n === r || !isElement(n) || isLastTraversableNode(n) ? !1 : getComputedStyle$1(n).position === "fixed" || hasFixedPositionAncestor(n, r);
}
function getClippingElementAncestors(t, r) {
  const n = r.get(t);
  if (n)
    return n;
  let a = getOverflowAncestors(t, [], !1).filter((c) => isElement(c) && getNodeName(c) !== "body"), s = null;
  const o = getComputedStyle$1(t).position === "fixed";
  let l = o ? getParentNode(t) : t;
  for (; isElement(l) && !isLastTraversableNode(l); ) {
    const c = getComputedStyle$1(l), x = isContainingBlock(l);
    !x && c.position === "fixed" && (s = null), (o ? !x && !s : !x && c.position === "static" && !!s && (s.position === "absolute" || s.position === "fixed") || isOverflowElement(l) && !x && hasFixedPositionAncestor(t, l)) ? a = a.filter((Z) => Z !== l) : s = c, l = getParentNode(l);
  }
  return r.set(t, a), a;
}
function getClippingRect(t) {
  let {
    element: r,
    boundary: n,
    rootBoundary: a,
    strategy: s
  } = t;
  const l = [...n === "clippingAncestors" ? isTopLayer(r) ? [] : getClippingElementAncestors(r, this._c) : [].concat(n), a], c = getClientRectFromClippingAncestor(r, l[0], s);
  let x = c.top, j = c.right, Z = c.bottom, V = c.left;
  for (let U = 1; U < l.length; U++) {
    const $ = getClientRectFromClippingAncestor(r, l[U], s);
    x = max$1($.top, x), j = min$1($.right, j), Z = min$1($.bottom, Z), V = max$1($.left, V);
  }
  return {
    width: j - V,
    height: Z - x,
    x: V,
    y: x
  };
}
function getDimensions(t) {
  const {
    width: r,
    height: n
  } = getCssDimensions(t);
  return {
    width: r,
    height: n
  };
}
function getRectRelativeToOffsetParent(t, r, n) {
  const a = isHTMLElement(r), s = getDocumentElement(r), o = n === "fixed", l = getBoundingClientRect(t, !0, o, r);
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const x = createCoords(0);
  function j() {
    x.x = getWindowScrollBarX(s);
  }
  if (a || !a && !o)
    if ((getNodeName(r) !== "body" || isOverflowElement(s)) && (c = getNodeScroll(r)), a) {
      const $ = getBoundingClientRect(r, !0, o, r);
      x.x = $.x + r.clientLeft, x.y = $.y + r.clientTop;
    } else s && j();
  o && !a && s && j();
  const Z = s && !a && !o ? getHTMLOffset(s, c) : createCoords(0), V = l.left + c.scrollLeft - x.x - Z.x, U = l.top + c.scrollTop - x.y - Z.y;
  return {
    x: V,
    y: U,
    width: l.width,
    height: l.height
  };
}
function isStaticPositioned(t) {
  return getComputedStyle$1(t).position === "static";
}
function getTrueOffsetParent(t, r) {
  if (!isHTMLElement(t) || getComputedStyle$1(t).position === "fixed")
    return null;
  if (r)
    return r(t);
  let n = t.offsetParent;
  return getDocumentElement(t) === n && (n = n.ownerDocument.body), n;
}
function getOffsetParent(t, r) {
  const n = getWindow(t);
  if (isTopLayer(t))
    return n;
  if (!isHTMLElement(t)) {
    let s = getParentNode(t);
    for (; s && !isLastTraversableNode(s); ) {
      if (isElement(s) && !isStaticPositioned(s))
        return s;
      s = getParentNode(s);
    }
    return n;
  }
  let a = getTrueOffsetParent(t, r);
  for (; a && isTableElement(a) && isStaticPositioned(a); )
    a = getTrueOffsetParent(a, r);
  return a && isLastTraversableNode(a) && isStaticPositioned(a) && !isContainingBlock(a) ? n : a || getContainingBlock(t) || n;
}
const getElementRects = async function(t) {
  const r = this.getOffsetParent || getOffsetParent, n = this.getDimensions, a = await n(t.floating);
  return {
    reference: getRectRelativeToOffsetParent(t.reference, await r(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: a.width,
      height: a.height
    }
  };
};
function isRTL(t) {
  return getComputedStyle$1(t).direction === "rtl";
}
const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement,
  isRTL
};
function rectsAreEqual(t, r) {
  return t.x === r.x && t.y === r.y && t.width === r.width && t.height === r.height;
}
function observeMove(t, r) {
  let n = null, a;
  const s = getDocumentElement(t);
  function o() {
    var c;
    clearTimeout(a), (c = n) == null || c.disconnect(), n = null;
  }
  function l(c, x) {
    c === void 0 && (c = !1), x === void 0 && (x = 1), o();
    const j = t.getBoundingClientRect(), {
      left: Z,
      top: V,
      width: U,
      height: $
    } = j;
    if (c || r(), !U || !$)
      return;
    const Y = floor$1(V), G = floor$1(s.clientWidth - (Z + U)), W = floor$1(s.clientHeight - (V + $)), X = floor$1(Z), J = {
      rootMargin: -Y + "px " + -G + "px " + -W + "px " + -X + "px",
      threshold: max$1(0, min$1(1, x)) || 1
    };
    let ee = !0;
    function te(ne) {
      const re = ne[0].intersectionRatio;
      if (re !== x) {
        if (!ee)
          return l();
        re ? l(!1, re) : a = setTimeout(() => {
          l(!1, 1e-7);
        }, 1e3);
      }
      re === 1 && !rectsAreEqual(j, t.getBoundingClientRect()) && l(), ee = !1;
    }
    try {
      n = new IntersectionObserver(te, {
        ...J,
        // Handle <iframe>s
        root: s.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(te, J);
    }
    n.observe(t);
  }
  return l(!0), o;
}
function autoUpdate(t, r, n, a) {
  a === void 0 && (a = {});
  const {
    ancestorScroll: s = !0,
    ancestorResize: o = !0,
    elementResize: l = typeof ResizeObserver == "function",
    layoutShift: c = typeof IntersectionObserver == "function",
    animationFrame: x = !1
  } = a, j = unwrapElement(t), Z = s || o ? [...j ? getOverflowAncestors(j) : [], ...r ? getOverflowAncestors(r) : []] : [];
  Z.forEach((X) => {
    s && X.addEventListener("scroll", n, {
      passive: !0
    }), o && X.addEventListener("resize", n);
  });
  const V = j && c ? observeMove(j, n) : null;
  let U = -1, $ = null;
  l && ($ = new ResizeObserver((X) => {
    let [K] = X;
    K && K.target === j && $ && r && ($.unobserve(r), cancelAnimationFrame(U), U = requestAnimationFrame(() => {
      var J;
      (J = $) == null || J.observe(r);
    })), n();
  }), j && !x && $.observe(j), r && $.observe(r));
  let Y, G = x ? getBoundingClientRect(t) : null;
  x && W();
  function W() {
    const X = getBoundingClientRect(t);
    G && !rectsAreEqual(G, X) && n(), G = X, Y = requestAnimationFrame(W);
  }
  return n(), () => {
    var X;
    Z.forEach((K) => {
      s && K.removeEventListener("scroll", n), o && K.removeEventListener("resize", n);
    }), V == null || V(), (X = $) == null || X.disconnect(), $ = null, x && cancelAnimationFrame(Y);
  };
}
const offset$1 = offset$2, shift$1 = shift$2, flip$1 = flip$2, arrow$2 = arrow$3, computePosition = (t, r, n) => {
  const a = /* @__PURE__ */ new Map(), s = {
    platform,
    ...n
  }, o = {
    ...s.platform,
    _c: a
  };
  return computePosition$1(t, r, {
    ...s,
    platform: o
  });
};
var isClient = typeof document != "undefined", noop = function t() {
}, index = isClient ? useLayoutEffect$3 : noop;
function deepEqual(t, r) {
  if (t === r)
    return !0;
  if (typeof t != typeof r)
    return !1;
  if (typeof t == "function" && t.toString() === r.toString())
    return !0;
  let n, a, s;
  if (t && r && typeof t == "object") {
    if (Array.isArray(t)) {
      if (n = t.length, n !== r.length) return !1;
      for (a = n; a-- !== 0; )
        if (!deepEqual(t[a], r[a]))
          return !1;
      return !0;
    }
    if (s = Object.keys(t), n = s.length, n !== Object.keys(r).length)
      return !1;
    for (a = n; a-- !== 0; )
      if (!{}.hasOwnProperty.call(r, s[a]))
        return !1;
    for (a = n; a-- !== 0; ) {
      const o = s[a];
      if (!(o === "_owner" && t.$$typeof) && !deepEqual(t[o], r[o]))
        return !1;
    }
    return !0;
  }
  return t !== t && r !== r;
}
function getDPR(t) {
  return typeof window == "undefined" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function roundByDPR(t, r) {
  const n = getDPR(t);
  return Math.round(r * n) / n;
}
function useLatestRef(t) {
  const r = React.useRef(t);
  return index(() => {
    r.current = t;
  }), r;
}
function useFloating$1(t) {
  t === void 0 && (t = {});
  const {
    placement: r = "bottom",
    strategy: n = "absolute",
    middleware: a = [],
    platform: s,
    elements: {
      reference: o,
      floating: l
    } = {},
    transform: c = !0,
    whileElementsMounted: x,
    open: j
  } = t, [Z, V] = React.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: r,
    middlewareData: {},
    isPositioned: !1
  }), [U, $] = React.useState(a);
  deepEqual(U, a) || $(a);
  const [Y, G] = React.useState(null), [W, X] = React.useState(null), K = React.useCallback((ae) => {
    ae !== ne.current && (ne.current = ae, G(ae));
  }, []), J = React.useCallback((ae) => {
    ae !== re.current && (re.current = ae, X(ae));
  }, []), ee = o || Y, te = l || W, ne = React.useRef(null), re = React.useRef(null), ie = React.useRef(Z), ue = x != null, le = useLatestRef(x), oe = useLatestRef(s), he = useLatestRef(j), fe = React.useCallback(() => {
    if (!ne.current || !re.current)
      return;
    const ae = {
      placement: r,
      strategy: n,
      middleware: U
    };
    oe.current && (ae.platform = oe.current), computePosition(ne.current, re.current, ae).then((me) => {
      const de = {
        ...me,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: he.current !== !1
      };
      ce.current && !deepEqual(ie.current, de) && (ie.current = de, ReactDOM.flushSync(() => {
        V(de);
      }));
    });
  }, [U, r, n, oe, he]);
  index(() => {
    j === !1 && ie.current.isPositioned && (ie.current.isPositioned = !1, V((ae) => ({
      ...ae,
      isPositioned: !1
    })));
  }, [j]);
  const ce = React.useRef(!1);
  index(() => (ce.current = !0, () => {
    ce.current = !1;
  }), []), index(() => {
    if (ee && (ne.current = ee), te && (re.current = te), ee && te) {
      if (le.current)
        return le.current(ee, te, fe);
      fe();
    }
  }, [ee, te, fe, le, ue]);
  const se = React.useMemo(() => ({
    reference: ne,
    floating: re,
    setReference: K,
    setFloating: J
  }), [K, J]), pe = React.useMemo(() => ({
    reference: ee,
    floating: te
  }), [ee, te]), ve = React.useMemo(() => {
    const ae = {
      position: n,
      left: 0,
      top: 0
    };
    if (!pe.floating)
      return ae;
    const me = roundByDPR(pe.floating, Z.x), de = roundByDPR(pe.floating, Z.y);
    return c ? {
      ...ae,
      transform: "translate(" + me + "px, " + de + "px)",
      ...getDPR(pe.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: me,
      top: de
    };
  }, [n, c, pe.floating, Z.x, Z.y]);
  return React.useMemo(() => ({
    ...Z,
    update: fe,
    refs: se,
    elements: pe,
    floatingStyles: ve
  }), [Z, fe, se, pe, ve]);
}
const arrow$1 = (t) => {
  function r(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: t,
    fn(n) {
      const {
        element: a,
        padding: s
      } = typeof t == "function" ? t(n) : t;
      return a && r(a) ? a.current != null ? arrow$2({
        element: a.current,
        padding: s
      }).fn(n) : {} : a ? arrow$2({
        element: a,
        padding: s
      }).fn(n) : {};
    }
  };
}, offset = (t, r) => {
  const n = offset$1(t);
  return {
    name: n.name,
    fn: n.fn,
    options: [t, r]
  };
}, shift = (t, r) => {
  const n = shift$1(t);
  return {
    name: n.name,
    fn: n.fn,
    options: [t, r]
  };
}, flip = (t, r) => {
  const n = flip$1(t);
  return {
    name: n.name,
    fn: n.fn,
    options: [t, r]
  };
}, arrow = (t, r) => {
  const n = arrow$1(t);
  return {
    name: n.name,
    fn: n.fn,
    options: [t, r]
  };
};
function useMergeRefs(t) {
  const r = React.useRef(void 0), n = React.useCallback((a) => {
    const s = t.map((o) => {
      if (o != null) {
        if (typeof o == "function") {
          const l = o, c = l(a);
          return typeof c == "function" ? c : () => {
            l(null);
          };
        }
        return o.current = a, () => {
          o.current = null;
        };
      }
    });
    return () => {
      s.forEach((o) => o == null ? void 0 : o());
    };
  }, t);
  return React.useMemo(() => t.every((a) => a == null) ? null : (a) => {
    r.current && (r.current(), r.current = void 0), a != null && (r.current = n(a));
  }, t);
}
const FOCUSABLE_ATTRIBUTE = "data-floating-ui-focusable", ACTIVE_KEY = "active", SELECTED_KEY = "selected", SafeReact = {
  ...React
};
let serverHandoffComplete = !1, count = 0;
const genId = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + count++
);
function useFloatingId() {
  const [t, r] = React.useState(() => serverHandoffComplete ? genId() : void 0);
  return index$1(() => {
    t == null && r(genId());
  }, []), React.useEffect(() => {
    serverHandoffComplete = !0;
  }, []), t;
}
const useReactId = SafeReact.useId, useId = useReactId || useFloatingId;
let devMessageSet;
process.env.NODE_ENV !== "production" && (devMessageSet = /* @__PURE__ */ new Set());
function warn() {
  for (var t, r = arguments.length, n = new Array(r), a = 0; a < r; a++)
    n[a] = arguments[a];
  const s = "Floating UI: " + n.join(" ");
  if (!((t = devMessageSet) != null && t.has(s))) {
    var o;
    (o = devMessageSet) == null || o.add(s), console.warn(s);
  }
}
function error() {
  for (var t, r = arguments.length, n = new Array(r), a = 0; a < r; a++)
    n[a] = arguments[a];
  const s = "Floating UI: " + n.join(" ");
  if (!((t = devMessageSet) != null && t.has(s))) {
    var o;
    (o = devMessageSet) == null || o.add(s), console.error(s);
  }
}
const FloatingArrow = /* @__PURE__ */ React.forwardRef(function t(r, n) {
  const {
    context: {
      placement: a,
      elements: {
        floating: s
      },
      middlewareData: {
        arrow: o,
        shift: l
      }
    },
    width: c = 14,
    height: x = 7,
    tipRadius: j = 0,
    strokeWidth: Z = 0,
    staticOffset: V,
    stroke: U,
    d: $,
    style: {
      transform: Y,
      ...G
    } = {},
    ...W
  } = r;
  process.env.NODE_ENV !== "production" && (n || warn("The `ref` prop is required for `FloatingArrow`."));
  const X = useId(), [K, J] = React.useState(!1);
  if (index$1(() => {
    if (!s) return;
    getComputedStyle$1(s).direction === "rtl" && J(!0);
  }, [s]), !s)
    return null;
  const [ee, te] = a.split("-"), ne = ee === "top" || ee === "bottom";
  let re = V;
  (ne && l != null && l.x || !ne && l != null && l.y) && (re = null);
  const ie = Z * 2, ue = ie / 2, le = c / 2 * (j / -8 + 1), oe = x / 2 * j / 4, he = !!$, fe = re && te === "end" ? "bottom" : "top";
  let ce = re && te === "end" ? "right" : "left";
  re && K && (ce = te === "end" ? "left" : "right");
  const se = (o == null ? void 0 : o.x) != null ? re || o.x : "", pe = (o == null ? void 0 : o.y) != null ? re || o.y : "", ve = $ || "M0,0" + (" H" + c) + (" L" + (c - le) + "," + (x - oe)) + (" Q" + c / 2 + "," + x + " " + le + "," + (x - oe)) + " Z", ae = {
    top: he ? "rotate(180deg)" : "",
    left: he ? "rotate(90deg)" : "rotate(-90deg)",
    bottom: he ? "" : "rotate(180deg)",
    right: he ? "rotate(-90deg)" : "rotate(90deg)"
  }[ee];
  return /* @__PURE__ */ jsxs("svg", {
    ...W,
    "aria-hidden": !0,
    ref: n,
    width: he ? c : c + ie,
    height: c,
    viewBox: "0 0 " + c + " " + (x > c ? x : c),
    style: {
      position: "absolute",
      pointerEvents: "none",
      [ce]: se,
      [fe]: pe,
      [ee]: ne || he ? "100%" : "calc(100% - " + ie / 2 + "px)",
      transform: [ae, Y].filter((me) => !!me).join(" "),
      ...G
    },
    children: [ie > 0 && /* @__PURE__ */ jsx("path", {
      clipPath: "url(#" + X + ")",
      fill: "none",
      stroke: U,
      strokeWidth: ie + ($ ? 0 : 1),
      d: ve
    }), /* @__PURE__ */ jsx("path", {
      stroke: ie && !$ ? W.fill : "none",
      d: ve
    }), /* @__PURE__ */ jsx("clipPath", {
      id: X,
      children: /* @__PURE__ */ jsx("rect", {
        x: -ue,
        y: ue * (he ? -1 : 1),
        width: c + ie,
        height: c
      })
    })]
  });
});
function createEventEmitter() {
  const t = /* @__PURE__ */ new Map();
  return {
    emit(r, n) {
      var a;
      (a = t.get(r)) == null || a.forEach((s) => s(n));
    },
    on(r, n) {
      t.has(r) || t.set(r, /* @__PURE__ */ new Set()), t.get(r).add(n);
    },
    off(r, n) {
      var a;
      (a = t.get(r)) == null || a.delete(n);
    }
  };
}
const FloatingNodeContext = /* @__PURE__ */ React.createContext(null), FloatingTreeContext = /* @__PURE__ */ React.createContext(null), useFloatingParentNodeId = () => {
  var t;
  return ((t = React.useContext(FloatingNodeContext)) == null ? void 0 : t.id) || null;
}, useFloatingTree = () => React.useContext(FloatingTreeContext);
function useFloatingNodeId(t) {
  const r = useId(), n = useFloatingTree(), a = useFloatingParentNodeId(), s = t || a;
  return index$1(() => {
    if (!r) return;
    const o = {
      id: r,
      parentId: s
    };
    return n == null || n.addNode(o), () => {
      n == null || n.removeNode(o);
    };
  }, [n, r, s]), r;
}
function FloatingNode(t) {
  const {
    children: r,
    id: n
  } = t, a = useFloatingParentNodeId();
  return /* @__PURE__ */ jsx(FloatingNodeContext.Provider, {
    value: React.useMemo(() => ({
      id: n,
      parentId: a
    }), [n, a]),
    children: r
  });
}
function FloatingTree(t) {
  const {
    children: r
  } = t, n = React.useRef([]), a = React.useCallback((l) => {
    n.current = [...n.current, l];
  }, []), s = React.useCallback((l) => {
    n.current = n.current.filter((c) => c !== l);
  }, []), [o] = React.useState(() => createEventEmitter());
  return /* @__PURE__ */ jsx(FloatingTreeContext.Provider, {
    value: React.useMemo(() => ({
      nodesRef: n,
      addNode: a,
      removeNode: s,
      events: o
    }), [a, s, o]),
    children: r
  });
}
function createAttribute(t) {
  return "data-floating-ui-" + t;
}
function clearTimeoutIfSet(t) {
  t.current !== -1 && (clearTimeout(t.current), t.current = -1);
}
const safePolygonIdentifier = /* @__PURE__ */ createAttribute("safe-polygon");
function getDelay(t, r, n) {
  if (n && !isMouseLikePointerType(n))
    return 0;
  if (typeof t == "number")
    return t;
  if (typeof t == "function") {
    const a = t();
    return typeof a == "number" ? a : a == null ? void 0 : a[r];
  }
  return t == null ? void 0 : t[r];
}
function getRestMs(t) {
  return typeof t == "function" ? t() : t;
}
function useHover(t, r) {
  r === void 0 && (r = {});
  const {
    open: n,
    onOpenChange: a,
    dataRef: s,
    events: o,
    elements: l
  } = t, {
    enabled: c = !0,
    delay: x = 0,
    handleClose: j = null,
    mouseOnly: Z = !1,
    restMs: V = 0,
    move: U = !0
  } = r, $ = useFloatingTree(), Y = useFloatingParentNodeId(), G = useLatestRef$1(j), W = useLatestRef$1(x), X = useLatestRef$1(n), K = useLatestRef$1(V), J = React.useRef(), ee = React.useRef(-1), te = React.useRef(), ne = React.useRef(-1), re = React.useRef(!0), ie = React.useRef(!1), ue = React.useRef(() => {
  }), le = React.useRef(!1), oe = useEffectEvent(() => {
    var ve;
    const ae = (ve = s.current.openEvent) == null ? void 0 : ve.type;
    return (ae == null ? void 0 : ae.includes("mouse")) && ae !== "mousedown";
  });
  React.useEffect(() => {
    if (!c) return;
    function ve(ae) {
      let {
        open: me
      } = ae;
      me || (clearTimeoutIfSet(ee), clearTimeoutIfSet(ne), re.current = !0, le.current = !1);
    }
    return o.on("openchange", ve), () => {
      o.off("openchange", ve);
    };
  }, [c, o]), React.useEffect(() => {
    if (!c || !G.current || !n) return;
    function ve(me) {
      oe() && a(!1, me, "hover");
    }
    const ae = getDocument$1(l.floating).documentElement;
    return ae.addEventListener("mouseleave", ve), () => {
      ae.removeEventListener("mouseleave", ve);
    };
  }, [l.floating, n, a, c, G, oe]);
  const he = React.useCallback(function(ve, ae, me) {
    ae === void 0 && (ae = !0), me === void 0 && (me = "hover");
    const de = getDelay(W.current, "close", J.current);
    de && !te.current ? (clearTimeoutIfSet(ee), ee.current = window.setTimeout(() => a(!1, ve, me), de)) : ae && (clearTimeoutIfSet(ee), a(!1, ve, me));
  }, [W, a]), fe = useEffectEvent(() => {
    ue.current(), te.current = void 0;
  }), ce = useEffectEvent(() => {
    if (ie.current) {
      const ve = getDocument$1(l.floating).body;
      ve.style.pointerEvents = "", ve.removeAttribute(safePolygonIdentifier), ie.current = !1;
    }
  }), se = useEffectEvent(() => s.current.openEvent ? ["click", "mousedown"].includes(s.current.openEvent.type) : !1);
  React.useEffect(() => {
    if (!c) return;
    function ve(Se) {
      if (clearTimeoutIfSet(ee), re.current = !1, Z && !isMouseLikePointerType(J.current) || getRestMs(K.current) > 0 && !getDelay(W.current, "open"))
        return;
      const xe = getDelay(W.current, "open", J.current);
      xe ? ee.current = window.setTimeout(() => {
        X.current || a(!0, Se, "hover");
      }, xe) : n || a(!0, Se, "hover");
    }
    function ae(Se) {
      if (se()) {
        ce();
        return;
      }
      ue.current();
      const xe = getDocument$1(l.floating);
      if (clearTimeoutIfSet(ne), le.current = !1, G.current && s.current.floatingContext) {
        n || clearTimeoutIfSet(ee), te.current = G.current({
          ...s.current.floatingContext,
          tree: $,
          x: Se.clientX,
          y: Se.clientY,
          onClose() {
            ce(), fe(), se() || he(Se, !0, "safe-polygon");
          }
        });
        const Ce = te.current;
        xe.addEventListener("mousemove", Ce), ue.current = () => {
          xe.removeEventListener("mousemove", Ce);
        };
        return;
      }
      (J.current !== "touch" || !contains$1(l.floating, Se.relatedTarget)) && he(Se);
    }
    function me(Se) {
      se() || s.current.floatingContext && (G.current == null || G.current({
        ...s.current.floatingContext,
        tree: $,
        x: Se.clientX,
        y: Se.clientY,
        onClose() {
          ce(), fe(), se() || he(Se);
        }
      })(Se));
    }
    function de() {
      clearTimeoutIfSet(ee);
    }
    function ge(Se) {
      se() || he(Se, !1);
    }
    if (isElement(l.domReference)) {
      const Se = l.domReference, xe = l.floating;
      return n && Se.addEventListener("mouseleave", me), U && Se.addEventListener("mousemove", ve, {
        once: !0
      }), Se.addEventListener("mouseenter", ve), Se.addEventListener("mouseleave", ae), xe && (xe.addEventListener("mouseleave", me), xe.addEventListener("mouseenter", de), xe.addEventListener("mouseleave", ge)), () => {
        n && Se.removeEventListener("mouseleave", me), U && Se.removeEventListener("mousemove", ve), Se.removeEventListener("mouseenter", ve), Se.removeEventListener("mouseleave", ae), xe && (xe.removeEventListener("mouseleave", me), xe.removeEventListener("mouseenter", de), xe.removeEventListener("mouseleave", ge));
      };
    }
  }, [l, c, t, Z, U, he, fe, ce, a, n, X, $, W, G, s, se, K]), index$1(() => {
    var ve;
    if (c && n && (ve = G.current) != null && (ve = ve.__options) != null && ve.blockPointerEvents && oe()) {
      ie.current = !0;
      const me = l.floating;
      if (isElement(l.domReference) && me) {
        var ae;
        const de = getDocument$1(l.floating).body;
        de.setAttribute(safePolygonIdentifier, "");
        const ge = l.domReference, Se = $ == null || (ae = $.nodesRef.current.find((xe) => xe.id === Y)) == null || (ae = ae.context) == null ? void 0 : ae.elements.floating;
        return Se && (Se.style.pointerEvents = ""), de.style.pointerEvents = "none", ge.style.pointerEvents = "auto", me.style.pointerEvents = "auto", () => {
          de.style.pointerEvents = "", ge.style.pointerEvents = "", me.style.pointerEvents = "";
        };
      }
    }
  }, [c, n, Y, l, $, G, oe]), index$1(() => {
    n || (J.current = void 0, le.current = !1, fe(), ce());
  }, [n, fe, ce]), React.useEffect(() => () => {
    fe(), clearTimeoutIfSet(ee), clearTimeoutIfSet(ne), ce();
  }, [c, l.domReference, fe, ce]);
  const pe = React.useMemo(() => {
    function ve(ae) {
      J.current = ae.pointerType;
    }
    return {
      onPointerDown: ve,
      onPointerEnter: ve,
      onMouseMove(ae) {
        const {
          nativeEvent: me
        } = ae;
        function de() {
          !re.current && !X.current && a(!0, me, "hover");
        }
        Z && !isMouseLikePointerType(J.current) || n || getRestMs(K.current) === 0 || le.current && ae.movementX ** 2 + ae.movementY ** 2 < 2 || (clearTimeoutIfSet(ne), J.current === "touch" ? de() : (le.current = !0, ne.current = window.setTimeout(de, getRestMs(K.current))));
      }
    };
  }, [Z, a, n, X, K]);
  return React.useMemo(() => c ? {
    reference: pe
  } : {}, [c, pe]);
}
let rafId = 0;
function enqueueFocus(t, r) {
  r === void 0 && (r = {});
  const {
    preventScroll: n = !1,
    cancelPrevious: a = !0,
    sync: s = !1
  } = r;
  a && cancelAnimationFrame(rafId);
  const o = () => t == null ? void 0 : t.focus({
    preventScroll: n
  });
  s ? o() : rafId = requestAnimationFrame(o);
}
function contains(t, r) {
  if (!t || !r)
    return !1;
  const n = r.getRootNode == null ? void 0 : r.getRootNode();
  if (t.contains(r))
    return !0;
  if (n && isShadowRoot(n)) {
    let a = r;
    for (; a; ) {
      if (t === a)
        return !0;
      a = a.parentNode || a.host;
    }
  }
  return !1;
}
function getTarget(t) {
  return "composedPath" in t ? t.composedPath()[0] : t.target;
}
function getDocument(t) {
  return (t == null ? void 0 : t.ownerDocument) || document;
}
const counters = {
  inert: /* @__PURE__ */ new WeakMap(),
  "aria-hidden": /* @__PURE__ */ new WeakMap(),
  none: /* @__PURE__ */ new WeakMap()
};
function getCounterMap(t) {
  return t === "inert" ? counters.inert : t === "aria-hidden" ? counters["aria-hidden"] : counters.none;
}
let uncontrolledElementsSet = /* @__PURE__ */ new WeakSet(), markerMap = {}, lockCount$1 = 0;
const supportsInert = () => typeof HTMLElement != "undefined" && "inert" in HTMLElement.prototype, unwrapHost = (t) => t && (t.host || unwrapHost(t.parentNode)), correctElements = (t, r) => r.map((n) => {
  if (t.contains(n))
    return n;
  const a = unwrapHost(n);
  return t.contains(a) ? a : null;
}).filter((n) => n != null);
function applyAttributeToOthers(t, r, n, a) {
  const s = "data-floating-ui-inert", o = a ? "inert" : n ? "aria-hidden" : null, l = correctElements(r, t), c = /* @__PURE__ */ new Set(), x = new Set(l), j = [];
  markerMap[s] || (markerMap[s] = /* @__PURE__ */ new WeakMap());
  const Z = markerMap[s];
  l.forEach(V), U(r), c.clear();
  function V($) {
    !$ || c.has($) || (c.add($), $.parentNode && V($.parentNode));
  }
  function U($) {
    !$ || x.has($) || [].forEach.call($.children, (Y) => {
      if (getNodeName(Y) !== "script")
        if (c.has(Y))
          U(Y);
        else {
          const G = o ? Y.getAttribute(o) : null, W = G !== null && G !== "false", X = getCounterMap(o), K = (X.get(Y) || 0) + 1, J = (Z.get(Y) || 0) + 1;
          X.set(Y, K), Z.set(Y, J), j.push(Y), K === 1 && W && uncontrolledElementsSet.add(Y), J === 1 && Y.setAttribute(s, ""), !W && o && Y.setAttribute(o, o === "inert" ? "" : "true");
        }
    });
  }
  return lockCount$1++, () => {
    j.forEach(($) => {
      const Y = getCounterMap(o), W = (Y.get($) || 0) - 1, X = (Z.get($) || 0) - 1;
      Y.set($, W), Z.set($, X), W || (!uncontrolledElementsSet.has($) && o && $.removeAttribute(o), uncontrolledElementsSet.delete($)), X || $.removeAttribute(s);
    }), lockCount$1--, lockCount$1 || (counters.inert = /* @__PURE__ */ new WeakMap(), counters["aria-hidden"] = /* @__PURE__ */ new WeakMap(), counters.none = /* @__PURE__ */ new WeakMap(), uncontrolledElementsSet = /* @__PURE__ */ new WeakSet(), markerMap = {});
  };
}
function markOthers(t, r, n) {
  r === void 0 && (r = !1), n === void 0 && (n = !1);
  const a = getDocument(t[0]).body;
  return applyAttributeToOthers(t.concat(Array.from(a.querySelectorAll('[aria-live],[role="status"],output'))), a, r, n);
}
const HIDDEN_STYLES = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "fixed",
  whiteSpace: "nowrap",
  width: "1px",
  top: 0,
  left: 0
}, FocusGuard = /* @__PURE__ */ React.forwardRef(function t(r, n) {
  const [a, s] = React.useState();
  index$1(() => {
    isSafari() && s("button");
  }, []);
  const o = {
    ref: n,
    tabIndex: 0,
    // Role is only for VoiceOver
    role: a,
    "aria-hidden": a ? void 0 : !0,
    [createAttribute("focus-guard")]: "",
    style: HIDDEN_STYLES
  };
  return /* @__PURE__ */ jsx("span", {
    ...r,
    ...o
  });
}), PortalContext = /* @__PURE__ */ React.createContext(null), attr = /* @__PURE__ */ createAttribute("portal");
function useFloatingPortalNode(t) {
  t === void 0 && (t = {});
  const {
    id: r,
    root: n
  } = t, a = useId(), s = usePortalContext(), [o, l] = React.useState(null), c = React.useRef(null);
  return index$1(() => () => {
    o == null || o.remove(), queueMicrotask(() => {
      c.current = null;
    });
  }, [o]), index$1(() => {
    if (!a || c.current) return;
    const x = r ? document.getElementById(r) : null;
    if (!x) return;
    const j = document.createElement("div");
    j.id = a, j.setAttribute(attr, ""), x.appendChild(j), c.current = j, l(j);
  }, [r, a]), index$1(() => {
    if (n === null || !a || c.current) return;
    let x = n || (s == null ? void 0 : s.portalNode);
    x && !isNode(x) && (x = x.current), x = x || document.body;
    let j = null;
    r && (j = document.createElement("div"), j.id = r, x.appendChild(j));
    const Z = document.createElement("div");
    Z.id = a, Z.setAttribute(attr, ""), x = j || x, x.appendChild(Z), c.current = Z, l(Z);
  }, [r, n, a, s]), o;
}
function FloatingPortal(t) {
  const {
    children: r,
    id: n,
    root: a,
    preserveTabOrder: s = !0
  } = t, o = useFloatingPortalNode({
    id: n,
    root: a
  }), [l, c] = React.useState(null), x = React.useRef(null), j = React.useRef(null), Z = React.useRef(null), V = React.useRef(null), U = l == null ? void 0 : l.modal, $ = l == null ? void 0 : l.open, Y = (
    // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!l && // Guards are only for non-modal focus management.
    !l.modal && // Don't render if unmount is transitioning.
    l.open && s && !!(a || o)
  );
  return React.useEffect(() => {
    if (!o || !s || U)
      return;
    function G(W) {
      o && isOutsideEvent(W) && (W.type === "focusin" ? enableFocusInside : disableFocusInside)(o);
    }
    return o.addEventListener("focusin", G, !0), o.addEventListener("focusout", G, !0), () => {
      o.removeEventListener("focusin", G, !0), o.removeEventListener("focusout", G, !0);
    };
  }, [o, s, U]), React.useEffect(() => {
    o && ($ || enableFocusInside(o));
  }, [$, o]), /* @__PURE__ */ jsxs(PortalContext.Provider, {
    value: React.useMemo(() => ({
      preserveTabOrder: s,
      beforeOutsideRef: x,
      afterOutsideRef: j,
      beforeInsideRef: Z,
      afterInsideRef: V,
      portalNode: o,
      setFocusManagerState: c
    }), [s, o]),
    children: [Y && o && /* @__PURE__ */ jsx(FocusGuard, {
      "data-type": "outside",
      ref: x,
      onFocus: (G) => {
        if (isOutsideEvent(G, o)) {
          var W;
          (W = Z.current) == null || W.focus();
        } else {
          const X = l ? l.domReference : null, K = getPreviousTabbable(X);
          K == null || K.focus();
        }
      }
    }), Y && o && /* @__PURE__ */ jsx("span", {
      "aria-owns": o.id,
      style: HIDDEN_STYLES
    }), o && /* @__PURE__ */ ReactDOM.createPortal(r, o), Y && o && /* @__PURE__ */ jsx(FocusGuard, {
      "data-type": "outside",
      ref: j,
      onFocus: (G) => {
        if (isOutsideEvent(G, o)) {
          var W;
          (W = V.current) == null || W.focus();
        } else {
          const X = l ? l.domReference : null, K = getNextTabbable(X);
          K == null || K.focus(), l != null && l.closeOnFocusOut && (l == null || l.onOpenChange(!1, G.nativeEvent, "focus-out"));
        }
      }
    })]
  });
}
const usePortalContext = () => React.useContext(PortalContext);
function useLiteMergeRefs(t) {
  return React.useMemo(() => (r) => {
    t.forEach((n) => {
      n && (n.current = r);
    });
  }, t);
}
const LIST_LIMIT = 20;
let previouslyFocusedElements = [];
function clearDisconnectedPreviouslyFocusedElements() {
  previouslyFocusedElements = previouslyFocusedElements.filter((t) => t.isConnected);
}
function addPreviouslyFocusedElement(t) {
  clearDisconnectedPreviouslyFocusedElements(), t && getNodeName(t) !== "body" && (previouslyFocusedElements.push(t), previouslyFocusedElements.length > LIST_LIMIT && (previouslyFocusedElements = previouslyFocusedElements.slice(-20)));
}
function getPreviouslyFocusedElement() {
  return clearDisconnectedPreviouslyFocusedElements(), previouslyFocusedElements[previouslyFocusedElements.length - 1];
}
function getFirstTabbableElement(t) {
  const r = getTabbableOptions();
  return isTabbable(t, r) ? t : tabbable(t, r)[0] || t;
}
function handleTabIndex(t, r) {
  var n;
  if (!r.current.includes("floating") && !((n = t.getAttribute("role")) != null && n.includes("dialog")))
    return;
  const a = getTabbableOptions(), o = focusable(t, a).filter((c) => {
    const x = c.getAttribute("data-tabindex") || "";
    return isTabbable(c, a) || c.hasAttribute("data-tabindex") && !x.startsWith("-");
  }), l = t.getAttribute("tabindex");
  r.current.includes("floating") || o.length === 0 ? l !== "0" && t.setAttribute("tabindex", "0") : (l !== "-1" || t.hasAttribute("data-tabindex") && t.getAttribute("data-tabindex") !== "-1") && (t.setAttribute("tabindex", "-1"), t.setAttribute("data-tabindex", "-1"));
}
const VisuallyHiddenDismiss = /* @__PURE__ */ React.forwardRef(function t(r, n) {
  return /* @__PURE__ */ jsx("button", {
    ...r,
    type: "button",
    ref: n,
    tabIndex: -1,
    style: HIDDEN_STYLES
  });
});
function FloatingFocusManager(t) {
  const {
    context: r,
    children: n,
    disabled: a = !1,
    order: s = ["content"],
    guards: o = !0,
    initialFocus: l = 0,
    returnFocus: c = !0,
    restoreFocus: x = !1,
    modal: j = !0,
    visuallyHiddenDismiss: Z = !1,
    closeOnFocusOut: V = !0,
    outsideElementsInert: U = !1,
    getInsideElements: $ = () => []
  } = t, {
    open: Y,
    onOpenChange: G,
    events: W,
    dataRef: X,
    elements: {
      domReference: K,
      floating: J
    }
  } = r, ee = useEffectEvent(() => {
    var be;
    return (be = X.current.floatingContext) == null ? void 0 : be.nodeId;
  }), te = useEffectEvent($), ne = typeof l == "number" && l < 0, re = isTypeableCombobox(K) && ne, ie = supportsInert(), ue = ie ? o : !0, le = !ue || ie && U, oe = useLatestRef$1(s), he = useLatestRef$1(l), fe = useLatestRef$1(c), ce = useFloatingTree(), se = usePortalContext(), pe = React.useRef(null), ve = React.useRef(null), ae = React.useRef(!1), me = React.useRef(!1), de = React.useRef(-1), ge = React.useRef(-1), Se = se != null, xe = getFloatingFocusElement(J), Ee = useEffectEvent(function(be) {
    return be === void 0 && (be = xe), be ? tabbable(be, getTabbableOptions()) : [];
  }), Ce = useEffectEvent((be) => {
    const Pe = Ee(be);
    return oe.current.map((ye) => K && ye === "reference" ? K : xe && ye === "floating" ? xe : Pe).filter(Boolean).flat();
  });
  React.useEffect(() => {
    if (a || !j) return;
    function be(ye) {
      if (ye.key === "Tab") {
        contains$1(xe, activeElement(getDocument$1(xe))) && Ee().length === 0 && !re && stopEvent(ye);
        const Ae = Ce(), Fe = getTarget$1(ye);
        oe.current[0] === "reference" && Fe === K && (stopEvent(ye), ye.shiftKey ? enqueueFocus(Ae[Ae.length - 1]) : enqueueFocus(Ae[1])), oe.current[1] === "floating" && Fe === xe && ye.shiftKey && (stopEvent(ye), enqueueFocus(Ae[0]));
      }
    }
    const Pe = getDocument$1(xe);
    return Pe.addEventListener("keydown", be), () => {
      Pe.removeEventListener("keydown", be);
    };
  }, [a, K, xe, j, oe, re, Ee, Ce]), React.useEffect(() => {
    if (a || !J) return;
    function be(Pe) {
      const ye = getTarget$1(Pe), Fe = Ee().indexOf(ye);
      Fe !== -1 && (de.current = Fe);
    }
    return J.addEventListener("focusin", be), () => {
      J.removeEventListener("focusin", be);
    };
  }, [a, J, Ee]), React.useEffect(() => {
    if (a || !V) return;
    function be() {
      me.current = !0, setTimeout(() => {
        me.current = !1;
      });
    }
    function Pe(Fe) {
      const Ie = Fe.relatedTarget, Le = Fe.currentTarget, De = getTarget$1(Fe);
      queueMicrotask(() => {
        const je = ee(), Ze = !(contains$1(K, Ie) || contains$1(J, Ie) || contains$1(Ie, J) || contains$1(se == null ? void 0 : se.portalNode, Ie) || Ie != null && Ie.hasAttribute(createAttribute("focus-guard")) || ce && (getNodeChildren$1(ce.nodesRef.current, je).find(($e) => {
          var Oe, Be;
          return contains$1((Oe = $e.context) == null ? void 0 : Oe.elements.floating, Ie) || contains$1((Be = $e.context) == null ? void 0 : Be.elements.domReference, Ie);
        }) || getNodeAncestors(ce.nodesRef.current, je).find(($e) => {
          var Oe, Be, Qe;
          return [(Oe = $e.context) == null ? void 0 : Oe.elements.floating, getFloatingFocusElement((Be = $e.context) == null ? void 0 : Be.elements.floating)].includes(Ie) || ((Qe = $e.context) == null ? void 0 : Qe.elements.domReference) === Ie;
        })));
        if (Le === K && xe && handleTabIndex(xe, oe), x && Le !== K && !(De != null && De.isConnected) && activeElement(getDocument$1(xe)) === getDocument$1(xe).body) {
          isHTMLElement(xe) && xe.focus();
          const $e = de.current, Oe = Ee(), Be = Oe[$e] || Oe[Oe.length - 1] || xe;
          isHTMLElement(Be) && Be.focus();
        }
        if (X.current.insideReactTree) {
          X.current.insideReactTree = !1;
          return;
        }
        (re || !j) && Ie && Ze && !me.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
        Ie !== getPreviouslyFocusedElement() && (ae.current = !0, G(!1, Fe, "focus-out"));
      });
    }
    const ye = !!(!ce && se);
    function Ae() {
      clearTimeoutIfSet(ge), X.current.insideReactTree = !0, ge.current = window.setTimeout(() => {
        X.current.insideReactTree = !1;
      });
    }
    if (J && isHTMLElement(K))
      return K.addEventListener("focusout", Pe), K.addEventListener("pointerdown", be), J.addEventListener("focusout", Pe), ye && J.addEventListener("focusout", Ae, !0), () => {
        K.removeEventListener("focusout", Pe), K.removeEventListener("pointerdown", be), J.removeEventListener("focusout", Pe), ye && J.removeEventListener("focusout", Ae, !0);
      };
  }, [a, K, J, xe, j, ce, se, G, V, x, Ee, re, ee, oe, X]);
  const ke = React.useRef(null), Re = React.useRef(null), _e = useLiteMergeRefs([ke, se == null ? void 0 : se.beforeInsideRef]), Me = useLiteMergeRefs([Re, se == null ? void 0 : se.afterInsideRef]);
  React.useEffect(() => {
    var be, Pe;
    if (a || !J) return;
    const ye = Array.from((se == null || (be = se.portalNode) == null ? void 0 : be.querySelectorAll("[" + createAttribute("portal") + "]")) || []), Fe = (Pe = (ce ? getNodeAncestors(ce.nodesRef.current, ee()) : []).find((De) => {
      var je;
      return isTypeableCombobox(((je = De.context) == null ? void 0 : je.elements.domReference) || null);
    })) == null || (Pe = Pe.context) == null ? void 0 : Pe.elements.domReference, Ie = [J, Fe, ...ye, ...te(), pe.current, ve.current, ke.current, Re.current, se == null ? void 0 : se.beforeOutsideRef.current, se == null ? void 0 : se.afterOutsideRef.current, oe.current.includes("reference") || re ? K : null].filter((De) => De != null), Le = j || re ? markOthers(Ie, !le, le) : markOthers(Ie);
    return () => {
      Le();
    };
  }, [a, K, J, j, oe, se, re, ue, le, ce, ee, te]), index$1(() => {
    if (a || !isHTMLElement(xe)) return;
    const be = getDocument$1(xe), Pe = activeElement(be);
    queueMicrotask(() => {
      const ye = Ce(xe), Ae = he.current, Fe = (typeof Ae == "number" ? ye[Ae] : Ae.current) || xe, Ie = contains$1(xe, Pe);
      !ne && !Ie && Y && enqueueFocus(Fe, {
        preventScroll: Fe === xe
      });
    });
  }, [a, Y, xe, ne, Ce, he]), index$1(() => {
    if (a || !xe) return;
    const be = getDocument$1(xe), Pe = activeElement(be);
    addPreviouslyFocusedElement(Pe);
    function ye(Ie) {
      let {
        reason: Le,
        event: De,
        nested: je
      } = Ie;
      if (["hover", "safe-polygon"].includes(Le) && De.type === "mouseleave" && (ae.current = !0), Le === "outside-press")
        if (je)
          ae.current = !1;
        else if (isVirtualClick(De) || isVirtualPointerEvent(De))
          ae.current = !1;
        else {
          let Ze = !1;
          document.createElement("div").focus({
            get preventScroll() {
              return Ze = !0, !1;
            }
          }), Ze ? ae.current = !1 : ae.current = !0;
        }
    }
    W.on("openchange", ye);
    const Ae = be.createElement("span");
    Ae.setAttribute("tabindex", "-1"), Ae.setAttribute("aria-hidden", "true"), Object.assign(Ae.style, HIDDEN_STYLES), Se && K && K.insertAdjacentElement("afterend", Ae);
    function Fe() {
      if (typeof fe.current == "boolean") {
        const Ie = K || getPreviouslyFocusedElement();
        return Ie && Ie.isConnected ? Ie : Ae;
      }
      return fe.current.current || Ae;
    }
    return () => {
      W.off("openchange", ye);
      const Ie = activeElement(be), Le = contains$1(J, Ie) || ce && getNodeChildren$1(ce.nodesRef.current, ee(), !1).some((je) => {
        var Ze;
        return contains$1((Ze = je.context) == null ? void 0 : Ze.elements.floating, Ie);
      }), De = Fe();
      queueMicrotask(() => {
        const je = getFirstTabbableElement(De);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        fe.current && !ae.current && isHTMLElement(je) && // If the focus moved somewhere else after mount, avoid returning focus
        // since it likely entered a different element which should be
        // respected: https://github.com/floating-ui/floating-ui/issues/2607
        (!(je !== Ie && Ie !== be.body) || Le) && je.focus({
          preventScroll: !0
        }), Ae.remove();
      });
    };
  }, [a, J, xe, fe, X, W, ce, Se, K, ee]), React.useEffect(() => (queueMicrotask(() => {
    ae.current = !1;
  }), () => {
    queueMicrotask(clearDisconnectedPreviouslyFocusedElements);
  }), [a]), index$1(() => {
    if (!a && se)
      return se.setFocusManagerState({
        modal: j,
        closeOnFocusOut: V,
        open: Y,
        onOpenChange: G,
        domReference: K
      }), () => {
        se.setFocusManagerState(null);
      };
  }, [a, se, j, Y, G, V, K]), index$1(() => {
    a || xe && handleTabIndex(xe, oe);
  }, [a, xe, oe]);
  function we(be) {
    return a || !Z || !j ? null : /* @__PURE__ */ jsx(VisuallyHiddenDismiss, {
      ref: be === "start" ? pe : ve,
      onClick: (Pe) => G(!1, Pe.nativeEvent),
      children: typeof Z == "string" ? Z : "Dismiss"
    });
  }
  const Te = !a && ue && (j ? !re : !0) && (Se || j);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [Te && /* @__PURE__ */ jsx(FocusGuard, {
      "data-type": "inside",
      ref: _e,
      onFocus: (be) => {
        if (j) {
          const ye = Ce();
          enqueueFocus(s[0] === "reference" ? ye[0] : ye[ye.length - 1]);
        } else if (se != null && se.preserveTabOrder && se.portalNode)
          if (ae.current = !1, isOutsideEvent(be, se.portalNode)) {
            const ye = getNextTabbable(K);
            ye == null || ye.focus();
          } else {
            var Pe;
            (Pe = se.beforeOutsideRef.current) == null || Pe.focus();
          }
      }
    }), !re && we("start"), n, we("end"), Te && /* @__PURE__ */ jsx(FocusGuard, {
      "data-type": "inside",
      ref: Me,
      onFocus: (be) => {
        if (j)
          enqueueFocus(Ce()[0]);
        else if (se != null && se.preserveTabOrder && se.portalNode)
          if (V && (ae.current = !0), isOutsideEvent(be, se.portalNode)) {
            const ye = getPreviousTabbable(K);
            ye == null || ye.focus();
          } else {
            var Pe;
            (Pe = se.afterOutsideRef.current) == null || Pe.focus();
          }
      }
    })]
  });
}
function isButtonTarget(t) {
  return isHTMLElement(t.target) && t.target.tagName === "BUTTON";
}
function isAnchorTarget(t) {
  return isHTMLElement(t.target) && t.target.tagName === "A";
}
function isSpaceIgnored(t) {
  return isTypeableElement(t);
}
function useClick(t, r) {
  r === void 0 && (r = {});
  const {
    open: n,
    onOpenChange: a,
    dataRef: s,
    elements: {
      domReference: o
    }
  } = t, {
    enabled: l = !0,
    event: c = "click",
    toggle: x = !0,
    ignoreMouse: j = !1,
    keyboardHandlers: Z = !0,
    stickIfOpen: V = !0
  } = r, U = React.useRef(), $ = React.useRef(!1), Y = React.useMemo(() => ({
    onPointerDown(G) {
      U.current = G.pointerType;
    },
    onMouseDown(G) {
      const W = U.current;
      G.button === 0 && c !== "click" && (isMouseLikePointerType(W, !0) && j || (n && x && (!(s.current.openEvent && V) || s.current.openEvent.type === "mousedown") ? a(!1, G.nativeEvent, "click") : (G.preventDefault(), a(!0, G.nativeEvent, "click"))));
    },
    onClick(G) {
      const W = U.current;
      if (c === "mousedown" && U.current) {
        U.current = void 0;
        return;
      }
      isMouseLikePointerType(W, !0) && j || (n && x && (!(s.current.openEvent && V) || s.current.openEvent.type === "click") ? a(!1, G.nativeEvent, "click") : a(!0, G.nativeEvent, "click"));
    },
    onKeyDown(G) {
      U.current = void 0, !(G.defaultPrevented || !Z || isButtonTarget(G)) && (G.key === " " && !isSpaceIgnored(o) && (G.preventDefault(), $.current = !0), !isAnchorTarget(G) && G.key === "Enter" && a(!(n && x), G.nativeEvent, "click"));
    },
    onKeyUp(G) {
      G.defaultPrevented || !Z || isButtonTarget(G) || isSpaceIgnored(o) || G.key === " " && $.current && ($.current = !1, a(!(n && x), G.nativeEvent, "click"));
    }
  }), [s, o, c, j, Z, a, n, V, x]);
  return React.useMemo(() => l ? {
    reference: Y
  } : {}, [l, Y]);
}
const bubbleHandlerKeys = {
  pointerdown: "onPointerDown",
  mousedown: "onMouseDown",
  click: "onClick"
}, captureHandlerKeys = {
  pointerdown: "onPointerDownCapture",
  mousedown: "onMouseDownCapture",
  click: "onClickCapture"
}, normalizeProp = (t) => {
  var r, n;
  return {
    escapeKey: typeof t == "boolean" ? t : (r = t == null ? void 0 : t.escapeKey) != null ? r : !1,
    outsidePress: typeof t == "boolean" ? t : (n = t == null ? void 0 : t.outsidePress) != null ? n : !0
  };
};
function useDismiss(t, r) {
  r === void 0 && (r = {});
  const {
    open: n,
    onOpenChange: a,
    elements: s,
    dataRef: o
  } = t, {
    enabled: l = !0,
    escapeKey: c = !0,
    outsidePress: x = !0,
    outsidePressEvent: j = "pointerdown",
    referencePress: Z = !1,
    referencePressEvent: V = "pointerdown",
    ancestorScroll: U = !1,
    bubbles: $,
    capture: Y
  } = r, G = useFloatingTree(), W = useEffectEvent(typeof x == "function" ? x : () => !1), X = typeof x == "function" ? W : x, K = React.useRef(!1), {
    escapeKey: J,
    outsidePress: ee
  } = normalizeProp($), {
    escapeKey: te,
    outsidePress: ne
  } = normalizeProp(Y), re = React.useRef(!1), ie = useEffectEvent((ce) => {
    var se;
    if (!n || !l || !c || ce.key !== "Escape" || re.current)
      return;
    const pe = (se = o.current.floatingContext) == null ? void 0 : se.nodeId, ve = G ? getNodeChildren$1(G.nodesRef.current, pe) : [];
    if (!J && (ce.stopPropagation(), ve.length > 0)) {
      let ae = !0;
      if (ve.forEach((me) => {
        var de;
        if ((de = me.context) != null && de.open && !me.context.dataRef.current.__escapeKeyBubbles) {
          ae = !1;
          return;
        }
      }), !ae)
        return;
    }
    a(!1, isReactEvent(ce) ? ce.nativeEvent : ce, "escape-key");
  }), ue = useEffectEvent((ce) => {
    var se;
    const pe = () => {
      var ve;
      ie(ce), (ve = getTarget$1(ce)) == null || ve.removeEventListener("keydown", pe);
    };
    (se = getTarget$1(ce)) == null || se.addEventListener("keydown", pe);
  }), le = useEffectEvent((ce) => {
    var se;
    const pe = o.current.insideReactTree;
    o.current.insideReactTree = !1;
    const ve = K.current;
    if (K.current = !1, j === "click" && ve || pe || typeof X == "function" && !X(ce))
      return;
    const ae = getTarget$1(ce), me = "[" + createAttribute("inert") + "]", de = getDocument$1(s.floating).querySelectorAll(me);
    let ge = isElement(ae) ? ae : null;
    for (; ge && !isLastTraversableNode(ge); ) {
      const Ce = getParentNode(ge);
      if (isLastTraversableNode(Ce) || !isElement(Ce))
        break;
      ge = Ce;
    }
    if (de.length && isElement(ae) && !isRootElement(ae) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
    !contains$1(ae, s.floating) && // If the target root element contains none of the markers, then the
    // element was injected after the floating element rendered.
    Array.from(de).every((Ce) => !contains$1(ge, Ce)))
      return;
    if (isHTMLElement(ae) && fe) {
      const Ce = isLastTraversableNode(ae), ke = getComputedStyle$1(ae), Re = /auto|scroll/, _e = Ce || Re.test(ke.overflowX), Me = Ce || Re.test(ke.overflowY), we = _e && ae.clientWidth > 0 && ae.scrollWidth > ae.clientWidth, Te = Me && ae.clientHeight > 0 && ae.scrollHeight > ae.clientHeight, be = ke.direction === "rtl", Pe = Te && (be ? ce.offsetX <= ae.offsetWidth - ae.clientWidth : ce.offsetX > ae.clientWidth), ye = we && ce.offsetY > ae.clientHeight;
      if (Pe || ye)
        return;
    }
    const Se = (se = o.current.floatingContext) == null ? void 0 : se.nodeId, xe = G && getNodeChildren$1(G.nodesRef.current, Se).some((Ce) => {
      var ke;
      return isEventTargetWithin(ce, (ke = Ce.context) == null ? void 0 : ke.elements.floating);
    });
    if (isEventTargetWithin(ce, s.floating) || isEventTargetWithin(ce, s.domReference) || xe)
      return;
    const Ee = G ? getNodeChildren$1(G.nodesRef.current, Se) : [];
    if (Ee.length > 0) {
      let Ce = !0;
      if (Ee.forEach((ke) => {
        var Re;
        if ((Re = ke.context) != null && Re.open && !ke.context.dataRef.current.__outsidePressBubbles) {
          Ce = !1;
          return;
        }
      }), !Ce)
        return;
    }
    a(!1, ce, "outside-press");
  }), oe = useEffectEvent((ce) => {
    var se;
    const pe = () => {
      var ve;
      le(ce), (ve = getTarget$1(ce)) == null || ve.removeEventListener(j, pe);
    };
    (se = getTarget$1(ce)) == null || se.addEventListener(j, pe);
  });
  React.useEffect(() => {
    if (!n || !l)
      return;
    o.current.__escapeKeyBubbles = J, o.current.__outsidePressBubbles = ee;
    let ce = -1;
    function se(de) {
      a(!1, de, "ancestor-scroll");
    }
    function pe() {
      window.clearTimeout(ce), re.current = !0;
    }
    function ve() {
      ce = window.setTimeout(
        () => {
          re.current = !1;
        },
        // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
        // Only apply to WebKit for the test to remain 0ms.
        isWebKit() ? 5 : 0
      );
    }
    const ae = getDocument$1(s.floating);
    c && (ae.addEventListener("keydown", te ? ue : ie, te), ae.addEventListener("compositionstart", pe), ae.addEventListener("compositionend", ve)), X && ae.addEventListener(j, ne ? oe : le, ne);
    let me = [];
    return U && (isElement(s.domReference) && (me = getOverflowAncestors(s.domReference)), isElement(s.floating) && (me = me.concat(getOverflowAncestors(s.floating))), !isElement(s.reference) && s.reference && s.reference.contextElement && (me = me.concat(getOverflowAncestors(s.reference.contextElement)))), me = me.filter((de) => {
      var ge;
      return de !== ((ge = ae.defaultView) == null ? void 0 : ge.visualViewport);
    }), me.forEach((de) => {
      de.addEventListener("scroll", se, {
        passive: !0
      });
    }), () => {
      c && (ae.removeEventListener("keydown", te ? ue : ie, te), ae.removeEventListener("compositionstart", pe), ae.removeEventListener("compositionend", ve)), X && ae.removeEventListener(j, ne ? oe : le, ne), me.forEach((de) => {
        de.removeEventListener("scroll", se);
      }), window.clearTimeout(ce);
    };
  }, [o, s, c, X, j, n, a, U, l, J, ee, ie, te, ue, le, ne, oe]), React.useEffect(() => {
    o.current.insideReactTree = !1;
  }, [o, X, j]);
  const he = React.useMemo(() => ({
    onKeyDown: ie,
    ...Z && {
      [bubbleHandlerKeys[V]]: (ce) => {
        a(!1, ce.nativeEvent, "reference-press");
      },
      ...V !== "click" && {
        onClick(ce) {
          a(!1, ce.nativeEvent, "reference-press");
        }
      }
    }
  }), [ie, a, Z, V]), fe = React.useMemo(() => ({
    onKeyDown: ie,
    onMouseDown() {
      K.current = !0;
    },
    onMouseUp() {
      K.current = !0;
    },
    [captureHandlerKeys[j]]: () => {
      o.current.insideReactTree = !0;
    }
  }), [ie, j, o]);
  return React.useMemo(() => l ? {
    reference: he,
    floating: fe
  } : {}, [l, he, fe]);
}
function useFloatingRootContext(t) {
  const {
    open: r = !1,
    onOpenChange: n,
    elements: a
  } = t, s = useId(), o = React.useRef({}), [l] = React.useState(() => createEventEmitter()), c = useFloatingParentNodeId() != null;
  if (process.env.NODE_ENV !== "production") {
    const $ = a.reference;
    $ && !isElement($) && error("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [x, j] = React.useState(a.reference), Z = useEffectEvent(($, Y, G) => {
    o.current.openEvent = $ ? Y : void 0, l.emit("openchange", {
      open: $,
      event: Y,
      reason: G,
      nested: c
    }), n == null || n($, Y, G);
  }), V = React.useMemo(() => ({
    setPositionReference: j
  }), []), U = React.useMemo(() => ({
    reference: x || a.reference || null,
    floating: a.floating || null,
    domReference: a.reference
  }), [x, a.reference, a.floating]);
  return React.useMemo(() => ({
    dataRef: o,
    open: r,
    onOpenChange: Z,
    elements: U,
    events: l,
    floatingId: s,
    refs: V
  }), [r, Z, U, l, s, V]);
}
function useFloating(t) {
  t === void 0 && (t = {});
  const {
    nodeId: r
  } = t, n = useFloatingRootContext({
    ...t,
    elements: {
      reference: null,
      floating: null,
      ...t.elements
    }
  }), a = t.rootContext || n, s = a.elements, [o, l] = React.useState(null), [c, x] = React.useState(null), Z = (s == null ? void 0 : s.domReference) || o, V = React.useRef(null), U = useFloatingTree();
  index$1(() => {
    Z && (V.current = Z);
  }, [Z]);
  const $ = useFloating$1({
    ...t,
    elements: {
      ...s,
      ...c && {
        reference: c
      }
    }
  }), Y = React.useCallback((J) => {
    const ee = isElement(J) ? {
      getBoundingClientRect: () => J.getBoundingClientRect(),
      getClientRects: () => J.getClientRects(),
      contextElement: J
    } : J;
    x(ee), $.refs.setReference(ee);
  }, [$.refs]), G = React.useCallback((J) => {
    (isElement(J) || J === null) && (V.current = J, l(J)), (isElement($.refs.reference.current) || $.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    J !== null && !isElement(J)) && $.refs.setReference(J);
  }, [$.refs]), W = React.useMemo(() => ({
    ...$.refs,
    setReference: G,
    setPositionReference: Y,
    domReference: V
  }), [$.refs, G, Y]), X = React.useMemo(() => ({
    ...$.elements,
    domReference: Z
  }), [$.elements, Z]), K = React.useMemo(() => ({
    ...$,
    ...a,
    refs: W,
    elements: X,
    nodeId: r
  }), [$, W, X, r, a]);
  return index$1(() => {
    a.dataRef.current.floatingContext = K;
    const J = U == null ? void 0 : U.nodesRef.current.find((ee) => ee.id === r);
    J && (J.context = K);
  }), React.useMemo(() => ({
    ...$,
    context: K,
    refs: W,
    elements: X
  }), [$, W, X, K]);
}
function isMacSafari() {
  return isMac() && isSafari();
}
function useFocus(t, r) {
  r === void 0 && (r = {});
  const {
    open: n,
    onOpenChange: a,
    events: s,
    dataRef: o,
    elements: l
  } = t, {
    enabled: c = !0,
    visibleOnly: x = !0
  } = r, j = React.useRef(!1), Z = React.useRef(-1), V = React.useRef(!0);
  React.useEffect(() => {
    if (!c) return;
    const $ = getWindow(l.domReference);
    function Y() {
      !n && isHTMLElement(l.domReference) && l.domReference === activeElement(getDocument$1(l.domReference)) && (j.current = !0);
    }
    function G() {
      V.current = !0;
    }
    function W() {
      V.current = !1;
    }
    return $.addEventListener("blur", Y), isMacSafari() && ($.addEventListener("keydown", G, !0), $.addEventListener("pointerdown", W, !0)), () => {
      $.removeEventListener("blur", Y), isMacSafari() && ($.removeEventListener("keydown", G, !0), $.removeEventListener("pointerdown", W, !0));
    };
  }, [l.domReference, n, c]), React.useEffect(() => {
    if (!c) return;
    function $(Y) {
      let {
        reason: G
      } = Y;
      (G === "reference-press" || G === "escape-key") && (j.current = !0);
    }
    return s.on("openchange", $), () => {
      s.off("openchange", $);
    };
  }, [s, c]), React.useEffect(() => () => {
    clearTimeoutIfSet(Z);
  }, []);
  const U = React.useMemo(() => ({
    onMouseLeave() {
      j.current = !1;
    },
    onFocus($) {
      if (j.current) return;
      const Y = getTarget$1($.nativeEvent);
      if (x && isElement(Y)) {
        if (isMacSafari() && !$.relatedTarget) {
          if (!V.current && !isTypeableElement(Y))
            return;
        } else if (!matchesFocusVisible(Y))
          return;
      }
      a(!0, $.nativeEvent, "focus");
    },
    onBlur($) {
      j.current = !1;
      const Y = $.relatedTarget, G = $.nativeEvent, W = isElement(Y) && Y.hasAttribute(createAttribute("focus-guard")) && Y.getAttribute("data-type") === "outside";
      Z.current = window.setTimeout(() => {
        var X;
        const K = activeElement(l.domReference ? l.domReference.ownerDocument : document);
        !Y && K === l.domReference || contains$1((X = o.current.floatingContext) == null ? void 0 : X.refs.floating.current, K) || contains$1(l.domReference, K) || W || a(!1, G, "focus");
      });
    }
  }), [o, l.domReference, a, x]);
  return React.useMemo(() => c ? {
    reference: U
  } : {}, [c, U]);
}
function mergeProps(t, r, n) {
  const a = /* @__PURE__ */ new Map(), s = n === "item";
  let o = t;
  if (s && t) {
    const {
      [ACTIVE_KEY]: l,
      [SELECTED_KEY]: c,
      ...x
    } = t;
    o = x;
  }
  return {
    ...n === "floating" && {
      tabIndex: -1,
      [FOCUSABLE_ATTRIBUTE]: ""
    },
    ...o,
    ...r.map((l) => {
      const c = l ? l[n] : null;
      return typeof c == "function" ? t ? c(t) : null : c;
    }).concat(t).reduce((l, c) => (c && Object.entries(c).forEach((x) => {
      let [j, Z] = x;
      if (!(s && [ACTIVE_KEY, SELECTED_KEY].includes(j)))
        if (j.indexOf("on") === 0) {
          if (a.has(j) || a.set(j, []), typeof Z == "function") {
            var V;
            (V = a.get(j)) == null || V.push(Z), l[j] = function() {
              for (var U, $ = arguments.length, Y = new Array($), G = 0; G < $; G++)
                Y[G] = arguments[G];
              return (U = a.get(j)) == null ? void 0 : U.map((W) => W(...Y)).find((W) => W !== void 0);
            };
          }
        } else
          l[j] = Z;
    }), l), {})
  };
}
function useInteractions(t) {
  t === void 0 && (t = []);
  const r = t.map((c) => c == null ? void 0 : c.reference), n = t.map((c) => c == null ? void 0 : c.floating), a = t.map((c) => c == null ? void 0 : c.item), s = React.useCallback(
    (c) => mergeProps(c, t, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    r
  ), o = React.useCallback(
    (c) => mergeProps(c, t, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    n
  ), l = React.useCallback(
    (c) => mergeProps(c, t, "item"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    a
  );
  return React.useMemo(() => ({
    getReferenceProps: s,
    getFloatingProps: o,
    getItemProps: l
  }), [s, o, l]);
}
const componentRoleToAriaRoleMap = /* @__PURE__ */ new Map([["select", "listbox"], ["combobox", "listbox"], ["label", !1]]);
function useRole(t, r) {
  var n, a;
  r === void 0 && (r = {});
  const {
    open: s,
    elements: o,
    floatingId: l
  } = t, {
    enabled: c = !0,
    role: x = "dialog"
  } = r, j = useId(), Z = ((n = o.domReference) == null ? void 0 : n.id) || j, V = React.useMemo(() => {
    var K;
    return ((K = getFloatingFocusElement(o.floating)) == null ? void 0 : K.id) || l;
  }, [o.floating, l]), U = (a = componentRoleToAriaRoleMap.get(x)) != null ? a : x, Y = useFloatingParentNodeId() != null, G = React.useMemo(() => U === "tooltip" || x === "label" ? {
    ["aria-" + (x === "label" ? "labelledby" : "describedby")]: s ? V : void 0
  } : {
    "aria-expanded": s ? "true" : "false",
    "aria-haspopup": U === "alertdialog" ? "dialog" : U,
    "aria-controls": s ? V : void 0,
    ...U === "listbox" && {
      role: "combobox"
    },
    ...U === "menu" && {
      id: Z
    },
    ...U === "menu" && Y && {
      role: "menuitem"
    },
    ...x === "select" && {
      "aria-autocomplete": "none"
    },
    ...x === "combobox" && {
      "aria-autocomplete": "list"
    }
  }, [U, V, Y, s, Z, x]), W = React.useMemo(() => {
    const K = {
      id: V,
      ...U && {
        role: U
      }
    };
    return U === "tooltip" || x === "label" ? K : {
      ...K,
      ...U === "menu" && {
        "aria-labelledby": Z
      }
    };
  }, [U, V, Z, x]), X = React.useCallback((K) => {
    let {
      active: J,
      selected: ee
    } = K;
    const te = {
      role: "option",
      ...J && {
        id: V + "-fui-option"
      }
    };
    switch (x) {
      case "select":
      case "combobox":
        return {
          ...te,
          "aria-selected": ee
        };
    }
    return {};
  }, [V, x]);
  return React.useMemo(() => c ? {
    reference: G,
    floating: W,
    item: X
  } : {}, [c, G, W, X]);
}
const camelCaseToKebabCase = (t) => t.replace(/[A-Z]+(?![a-z])|[A-Z]/g, (r, n) => (n ? "-" : "") + r.toLowerCase());
function execWithArgsOrReturn(t, r) {
  return typeof t == "function" ? t(r) : t;
}
function useDelayUnmount(t, r) {
  const [n, a] = React.useState(t);
  return t && !n && a(!0), React.useEffect(() => {
    if (!t && n) {
      const s = setTimeout(() => a(!1), r);
      return () => clearTimeout(s);
    }
  }, [t, n, r]), n;
}
function useTransitionStatus(t, r) {
  r === void 0 && (r = {});
  const {
    open: n,
    elements: {
      floating: a
    }
  } = t, {
    duration: s = 250
  } = r, l = (typeof s == "number" ? s : s.close) || 0, [c, x] = React.useState("unmounted"), j = useDelayUnmount(n, l);
  return !j && c === "close" && x("unmounted"), index$1(() => {
    if (a) {
      if (n) {
        x("initial");
        const Z = requestAnimationFrame(() => {
          ReactDOM.flushSync(() => {
            x("open");
          });
        });
        return () => {
          cancelAnimationFrame(Z);
        };
      }
      x("close");
    }
  }, [n, a]), {
    isMounted: j,
    status: c
  };
}
function useTransitionStyles(t, r) {
  r === void 0 && (r = {});
  const {
    initial: n = {
      opacity: 0
    },
    open: a,
    close: s,
    common: o,
    duration: l = 250
  } = r, c = t.placement, x = c.split("-")[0], j = React.useMemo(() => ({
    side: x,
    placement: c
  }), [x, c]), Z = typeof l == "number", V = (Z ? l : l.open) || 0, U = (Z ? l : l.close) || 0, [$, Y] = React.useState(() => ({
    ...execWithArgsOrReturn(o, j),
    ...execWithArgsOrReturn(n, j)
  })), {
    isMounted: G,
    status: W
  } = useTransitionStatus(t, {
    duration: l
  }), X = useLatestRef$1(n), K = useLatestRef$1(a), J = useLatestRef$1(s), ee = useLatestRef$1(o);
  return index$1(() => {
    const te = execWithArgsOrReturn(X.current, j), ne = execWithArgsOrReturn(J.current, j), re = execWithArgsOrReturn(ee.current, j), ie = execWithArgsOrReturn(K.current, j) || Object.keys(te).reduce((ue, le) => (ue[le] = "", ue), {});
    if (W === "initial" && Y((ue) => ({
      transitionProperty: ue.transitionProperty,
      ...re,
      ...te
    })), W === "open" && Y({
      transitionProperty: Object.keys(ie).map(camelCaseToKebabCase).join(","),
      transitionDuration: V + "ms",
      ...re,
      ...ie
    }), W === "close") {
      const ue = ne || te;
      Y({
        transitionProperty: Object.keys(ue).map(camelCaseToKebabCase).join(","),
        transitionDuration: U + "ms",
        ...re,
        ...ue
      });
    }
  }, [U, J, X, K, ee, V, W, j]), {
    isMounted: G,
    styles: $
  };
}
function getNodeChildren(t, r, n) {
  return n === void 0 && (n = !0), t.filter((s) => {
    var o;
    return s.parentId === r && (!n || ((o = s.context) == null ? void 0 : o.open));
  }).flatMap((s) => [s, ...getNodeChildren(t, s.id, n)]);
}
function isPointInPolygon(t, r) {
  const [n, a] = t;
  let s = !1;
  const o = r.length;
  for (let l = 0, c = o - 1; l < o; c = l++) {
    const [x, j] = r[l] || [0, 0], [Z, V] = r[c] || [0, 0];
    j >= a != V >= a && n <= (Z - x) * (a - j) / (V - j) + x && (s = !s);
  }
  return s;
}
function isInside(t, r) {
  return t[0] >= r.x && t[0] <= r.x + r.width && t[1] >= r.y && t[1] <= r.y + r.height;
}
function safePolygon(t) {
  t === void 0 && (t = {});
  const {
    buffer: r = 0.5,
    blockPointerEvents: n = !1,
    requireIntent: a = !0
  } = t, s = {
    current: -1
  };
  let o = !1, l = null, c = null, x = typeof performance != "undefined" ? performance.now() : 0;
  function j(V, U) {
    const $ = performance.now(), Y = $ - x;
    if (l === null || c === null || Y === 0)
      return l = V, c = U, x = $, null;
    const G = V - l, W = U - c, K = Math.sqrt(G * G + W * W) / Y;
    return l = V, c = U, x = $, K;
  }
  const Z = (V) => {
    let {
      x: U,
      y: $,
      placement: Y,
      elements: G,
      onClose: W,
      nodeId: X,
      tree: K
    } = V;
    return function(ee) {
      function te() {
        clearTimeoutIfSet(s), W();
      }
      if (clearTimeoutIfSet(s), !G.domReference || !G.floating || Y == null || U == null || $ == null)
        return;
      const {
        clientX: ne,
        clientY: re
      } = ee, ie = [ne, re], ue = getTarget(ee), le = ee.type === "mouseleave", oe = contains(G.floating, ue), he = contains(G.domReference, ue), fe = G.domReference.getBoundingClientRect(), ce = G.floating.getBoundingClientRect(), se = Y.split("-")[0], pe = U > ce.right - ce.width / 2, ve = $ > ce.bottom - ce.height / 2, ae = isInside(ie, fe), me = ce.width > fe.width, de = ce.height > fe.height, ge = (me ? fe : ce).left, Se = (me ? fe : ce).right, xe = (de ? fe : ce).top, Ee = (de ? fe : ce).bottom;
      if (oe && (o = !0, !le))
        return;
      if (he && (o = !1), he && !le) {
        o = !0;
        return;
      }
      if (le && isElement(ee.relatedTarget) && contains(G.floating, ee.relatedTarget) || K && getNodeChildren(K.nodesRef.current, X).length)
        return;
      if (se === "top" && $ >= fe.bottom - 1 || se === "bottom" && $ <= fe.top + 1 || se === "left" && U >= fe.right - 1 || se === "right" && U <= fe.left + 1)
        return te();
      let Ce = [];
      switch (se) {
        case "top":
          Ce = [[ge, fe.top + 1], [ge, ce.bottom - 1], [Se, ce.bottom - 1], [Se, fe.top + 1]];
          break;
        case "bottom":
          Ce = [[ge, ce.top + 1], [ge, fe.bottom - 1], [Se, fe.bottom - 1], [Se, ce.top + 1]];
          break;
        case "left":
          Ce = [[ce.right - 1, Ee], [ce.right - 1, xe], [fe.left + 1, xe], [fe.left + 1, Ee]];
          break;
        case "right":
          Ce = [[fe.right - 1, Ee], [fe.right - 1, xe], [ce.left + 1, xe], [ce.left + 1, Ee]];
          break;
      }
      function ke(Re) {
        let [_e, Me] = Re;
        switch (se) {
          case "top": {
            const we = [me ? _e + r / 2 : pe ? _e + r * 4 : _e - r * 4, Me + r + 1], Te = [me ? _e - r / 2 : pe ? _e + r * 4 : _e - r * 4, Me + r + 1], be = [[ce.left, pe || me ? ce.bottom - r : ce.top], [ce.right, pe ? me ? ce.bottom - r : ce.top : ce.bottom - r]];
            return [we, Te, ...be];
          }
          case "bottom": {
            const we = [me ? _e + r / 2 : pe ? _e + r * 4 : _e - r * 4, Me - r], Te = [me ? _e - r / 2 : pe ? _e + r * 4 : _e - r * 4, Me - r], be = [[ce.left, pe || me ? ce.top + r : ce.bottom], [ce.right, pe ? me ? ce.top + r : ce.bottom : ce.top + r]];
            return [we, Te, ...be];
          }
          case "left": {
            const we = [_e + r + 1, de ? Me + r / 2 : ve ? Me + r * 4 : Me - r * 4], Te = [_e + r + 1, de ? Me - r / 2 : ve ? Me + r * 4 : Me - r * 4];
            return [...[[ve || de ? ce.right - r : ce.left, ce.top], [ve ? de ? ce.right - r : ce.left : ce.right - r, ce.bottom]], we, Te];
          }
          case "right": {
            const we = [_e - r, de ? Me + r / 2 : ve ? Me + r * 4 : Me - r * 4], Te = [_e - r, de ? Me - r / 2 : ve ? Me + r * 4 : Me - r * 4], be = [[ve || de ? ce.left + r : ce.right, ce.top], [ve ? de ? ce.left + r : ce.right : ce.left + r, ce.bottom]];
            return [we, Te, ...be];
          }
        }
      }
      if (!isPointInPolygon([ne, re], Ce)) {
        if (o && !ae)
          return te();
        if (!le && a) {
          const Re = j(ee.clientX, ee.clientY);
          if (Re !== null && Re < 0.1)
            return te();
        }
        isPointInPolygon([ne, re], ke([U, $])) ? !o && a && (s.current = window.setTimeout(te, 40)) : te();
      }
    };
  };
  return Z.__options = {
    blockPointerEvents: n
  }, Z;
}
const TooltipContext = createContext(null), DEFAULT_ARROW_OPTIONS = {
  width: 14,
  height: 8,
  strokeWidth: 1,
  d: "m 7.5077259,7.50555 -7.49999991,7.5 H 15.007725 Z",
  padding: 8,
  tipRadius: 0,
  staticOffset: null,
  fill: "black",
  stroke: "none",
  className: null
}, DEFAULT_TOOLTIP_OPTIONS = {
  placement: "bottom",
  gap: 2,
  positioningBy: "trigger"
}, TOOLTIP_TRANSITION_DURATION = 200;
function getMiddlewares(t, r, n, a) {
  return [
    offset(t.height + r.gap),
    flip({
      crossAxis: r.placement.includes("-"),
      fallbackAxisSideDirection: "start",
      padding: 5
    }),
    shift({ padding: 5 }),
    n && arrow({
      element: a,
      padding: t == null ? void 0 : t.padding
    })
  ];
}
function useMergedTooltipOptions(t, r, n) {
  return useMemo$1(
    () => {
      var a, s, o, l, c, x;
      return {
        placement: (s = (a = t == null ? void 0 : t.placement) != null ? a : r == null ? void 0 : r.placement) != null ? s : n.placement,
        gap: (l = (o = t == null ? void 0 : t.gap) != null ? o : r == null ? void 0 : r.gap) != null ? l : n.gap,
        positioningBy: (x = (c = t == null ? void 0 : t.positioningBy) != null ? c : r == null ? void 0 : r.positioningBy) != null ? x : n.positioningBy
      };
    },
    [n, t, r]
  );
}
function useMergedArrowOptions(t, r, n, a) {
  return useMemo$1(
    () => {
      var s, o, l, c;
      return {
        ...a,
        ...n,
        ...r,
        width: t ? (o = (s = r == null ? void 0 : r.width) != null ? s : n == null ? void 0 : n.width) != null ? o : a.width : 0,
        height: t ? (c = (l = r == null ? void 0 : r.height) != null ? l : n == null ? void 0 : n.height) != null ? c : a.height : 0
      };
    },
    [a, r, n, t]
  );
}
function useTooltip({
  triggerSet: t,
  placement: r,
  withArrow: n,
  arrowOptions: a,
  gap: s,
  delay: o,
  open: l,
  triggerRef: c,
  onOpenChange: x,
  positioningBy: j,
  parentContext: Z,
  nodeId: V,
  floatingRef: U,
  useSafePolygon: $ = !0
}) {
  var he;
  const Y = Z !== null, G = useMergedTooltipOptions(
    { placement: r, gap: s, positioningBy: j },
    Z == null ? void 0 : Z.tooltipOptions,
    DEFAULT_TOOLTIP_OPTIONS
  ), W = (he = n != null ? n : Z == null ? void 0 : Z.withArrow) != null ? he : !0, X = useRef(null), K = useMergedArrowOptions(
    W,
    a,
    Z == null ? void 0 : Z.arrowOptions,
    DEFAULT_ARROW_OPTIONS
  ), { context: J, middlewareData: ee } = useFloating({
    nodeId: V,
    placement: G.placement,
    open: l,
    onOpenChange: x,
    whileElementsMounted: autoUpdate,
    // eslint-disable-next-line react-hooks/refs
    middleware: getMiddlewares(K, G, W, X)
  });
  useEffect(() => {
    var pe;
    const fe = G.positioningBy === "parent-tooltip" && (pe = Z == null ? void 0 : Z.elements.floating) != null ? pe : J.elements.reference, ce = J.elements.floating;
    if (!ce || !fe)
      return;
    const se = autoUpdate(fe, ce, () => {
      computePosition(fe, ce, {
        placement: G.placement,
        middleware: getMiddlewares(K, G, W, X)
      }).then(({ x: ve, y: ae }) => {
        ce.style.top = `${ae}px`, ce.style.left = `${ve}px`, ce.style.transform = "";
      });
    });
    return () => se();
  }, [
    K,
    J.elements.floating,
    J.elements.reference,
    Y,
    V,
    Z,
    G,
    W
  ]), useEffect(() => {
    const fe = ee.arrow, ce = X.current, se = {
      top: "bottom",
      right: "left",
      bottom: "top",
      left: "right"
    }[J.placement.split("-")[0]];
    ce && (se === "top" || se === "bottom" || se === "left" || se === "right") && (ce.style.left = fe != null && fe.x ? `${fe.x}px` : "", ce.style.top = fe != null && fe.y ? `${fe.y}px` : "", ce.style[se] = `-${K.width - 1}px`);
  }, [K.width, J.placement, ee.arrow]);
  const te = useInteractions([
    useClick(J, {
      enabled: t.has("click"),
      event: "click"
    }),
    useHover(J, {
      move: !1,
      enabled: t.has("hover"),
      delay: o,
      handleClose: $ ? safePolygon() : void 0
    }),
    useFocus(J, {
      enabled: t.has("focus")
    }),
    useDismiss(J, { bubbles: !0 }),
    useRole(J, { role: "tooltip" })
  ]), { isMounted: ne, styles: re } = useTransitionStyles(J, {
    duration: TOOLTIP_TRANSITION_DURATION
  }), ie = useMergeRefs([J.refs.setFloating, U]), ue = useMergeRefs([J.refs.setReference, c]), le = useMemo$1(
    () => (fe) => ({
      ...te.getReferenceProps(fe),
      ref: ue
    }),
    [te, ue]
  ), oe = useMemo$1(
    () => () => ({
      ...te.getFloatingProps(),
      ref: ie,
      style: { ...J.floatingStyles, ...re }
    }),
    [J.floatingStyles, ie, te, re]
  );
  return useMemo$1(
    () => ({
      getReferenceProps: le,
      getFloatingProps: oe,
      arrowOptions: W ? { ...K, ref: X } : null,
      context: { ...J, ...te, tooltipOptions: G, arrowOptions: K, withArrow: W },
      open: J.open && ne
    }),
    [K, J, oe, le, te, ne, G, W]
  );
}
const TooltipComponent = forwardRef(function t({
  trigger: r,
  title: n,
  children: a,
  initialOpen: s,
  placement: o,
  withArrow: l,
  arrowOptions: c,
  style: x,
  className: j,
  containerClassName: Z,
  gap: V,
  delay: U,
  open: $,
  triggerRef: Y,
  onOpenChange: G,
  onPointerDown: W,
  positioningBy: X,
  useSafePolygon: K,
  setReferenceProps: J,
  tooltipWrapperProps: ee,
  focusManagerProps: te,
  canTooltipBeFocused: ne = !0,
  rootContainer: re
}, ie) {
  const ue = useContext(ConfigContext), le = useContext(TooltipContext), oe = useFloatingParentNodeId(), he = useFloatingNodeId(oe != null ? oe : void 0), fe = re != null ? re : ue.rootElement, ce = useMemo$1(
    () => {
      var xe;
      return new Set((xe = r != null ? r : le == null ? void 0 : le.trigger) != null ? xe : ["hover", "focus"]);
    },
    [r, le == null ? void 0 : le.trigger]
  ), [se, pe] = useState$1(s), { getReferenceProps: ve, getFloatingProps: ae, arrowOptions: me, context: de, open: ge } = useTooltip({
    open: $ != null ? $ : se,
    onOpenChange: G != null ? G : pe,
    gap: V,
    parentContext: le,
    delay: U,
    arrowOptions: c,
    withArrow: l,
    nodeId: he,
    placement: o,
    triggerRef: Y,
    triggerSet: ce,
    positioningBy: X,
    floatingRef: ie,
    useSafePolygon: K
  });
  useEffect(() => {
    const xe = ve();
    J == null || J((Ee) => ({ ...Ee, ...xe, ref: mergeRefs(Ee == null ? void 0 : Ee.ref, xe.ref) }));
  }, [ve, J]);
  const Se = /* @__PURE__ */ jsx(
    "div",
    {
      onClick: (xe) => xe.stopPropagation(),
      onPointerDown: (xe) => xe.stopPropagation(),
      onPointerUp: (xe) => xe.stopPropagation(),
      ...ee,
      children: /* @__PURE__ */ jsxs("div", { ...ae(), className: clsx("go-tooltip__container", Z), children: [
        /* @__PURE__ */ jsx("div", { className: clsx(j, "go-tooltip"), style: x, onPointerDown: W, children: n }),
        !!me && /* @__PURE__ */ jsx(
          FloatingArrow,
          {
            ref: me.ref,
            context: de,
            className: clsx(me.className, "go-tooltip__arrow"),
            d: me.d,
            strokeWidth: me.strokeWidth,
            width: me.width,
            height: me.height,
            staticOffset: me.staticOffset,
            fill: me.fill,
            stroke: me.stroke,
            tipRadius: me.tipRadius
          }
        )
      ] })
    }
  );
  return /* @__PURE__ */ jsxs(FloatingNode, { id: he, children: [
    isValidElement(a) && cloneElement(a, ve(a.props)),
    /* @__PURE__ */ jsx(TooltipContext.Provider, { value: de, children: ge && /* @__PURE__ */ jsx(FloatingPortal, { root: fe, children: /* @__PURE__ */ jsx(ConfigProvider, { config: ue, children: ne ? /* @__PURE__ */ jsx(FloatingFocusManager, { initialFocus: -1, ...te, context: de, modal: !1, children: Se }) : Se }) }) })
  ] });
}), Tooltip = forwardRef(function t({ children: r, ...n }, a) {
  const s = r ? Children.only(r) : void 0;
  return useFloatingParentNodeId() === null ? /* @__PURE__ */ jsx(FloatingTree, { children: /* @__PURE__ */ jsx(TooltipComponent, { ...n, ref: a, children: s }) }) : /* @__PURE__ */ jsx(TooltipComponent, { ...n, ref: a, children: s });
}), MultiTooltip = ({ children: t, tooltips: r }) => {
  const n = useRef(null), [a, s] = useState$1();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    isValidElement(t) && cloneElement(t, a),
    r.map(({ key: o, ...l }) => /* @__PURE__ */ jsx(Tooltip, { ...l, triggerRef: n, setReferenceProps: s }, o))
  ] });
}, Tooltip$1 = Object.assign(Tooltip, { Multi: MultiTooltip }), inputSizeClassNames = {
  s: "go-input_size_s",
  m: "go-input_size_m"
}, statusClassNames$2 = {
  error: "go-input_status_error"
}, Input = forwardRef(function t({
  value: r,
  id: n,
  prefix: a,
  suffix: s,
  placeholder: o,
  size: l,
  status: c,
  maxLength: x,
  allowClear: j = !0,
  disabled: Z = !1,
  loading: V = !1,
  tabIndex: U = 0,
  type: $ = "text",
  autoFocus: Y,
  className: G,
  fieldClassName: W,
  inputClassName: X,
  style: K,
  onChange: J,
  onClear: ee,
  onFocus: te,
  onBlur: ne,
  onKeyDown: re,
  onKeyUp: ie,
  onClick: ue,
  onMouseEnter: le,
  onMouseLeave: oe
}, he) {
  var Pe, ye;
  const { localization: fe } = useContext(ConfigContext), { size: ce } = useGlobalComponentConfig({ size: l }), se = useRef(null), [pe, ve] = useState$1(""), ae = r != null ? r : pe, me = J != null ? J : ((Ae) => ve(Ae.currentTarget.value)), [de, ge] = useState$1(!1), [Se, xe] = useState$1(!1), Ee = j && (!!(ae != null && ae.length) && Se || de) && !Z, Ce = !(ae != null && ae.length && Se) || de || !j || Z, ke = (Ae) => {
    me == null || me(Ae);
  }, Re = (Ae) => {
    ge(!0), te == null || te(Ae), Ae.currentTarget.setSelectionRange(0, ae.length);
  }, _e = (Ae) => {
    ge(!1), ne == null || ne(Ae);
  }, Me = (Ae) => {
    if (Ae.preventDefault(), ee == null || ee(), !!me && se.current) {
      let Fe = Ae;
      const Ie = se.current.cloneNode(!0);
      Fe = Object.create(Ae, {
        target: { value: Ie },
        currentTarget: { value: Ie }
      }), Ie.value = "", me(Fe);
      return;
    }
  }, we = (Ae) => {
    xe(!0), le == null || le(Ae);
  }, Te = (Ae) => {
    xe(!1), oe == null || oe(Ae);
  }, be = (Ae) => {
    Ae.target !== se.current && Ae.preventDefault();
  };
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: clsx(
        "go-input",
        inputSizeClassNames[ce],
        c && statusClassNames$2[c],
        Z && "go-input_disabled",
        de && "go-input_focused",
        V && "go-input_loading",
        Se && "go-input_hovered",
        Ee && "go-input_has-clear-button",
        G
      ),
      style: K,
      onMouseEnter: we,
      onMouseLeave: Te,
      children: /* @__PURE__ */ jsxs("label", { className: clsx("go-input__container", W), onPointerDown: be, children: [
        !!a && /* @__PURE__ */ jsx("div", { className: "go-input__prefix", children: renderNode(a, "p") }),
        /* @__PURE__ */ jsx(
          "input",
          {
            ref: mergeRefs(se, he),
            id: n,
            value: ae != null ? ae : "",
            placeholder: o,
            className: clsx("go-input__field", X),
            disabled: Z,
            maxLength: x,
            tabIndex: U,
            type: $,
            onChange: ke,
            onFocus: Re,
            onBlur: _e,
            onKeyDown: re,
            onKeyUp: ie,
            onClick: ue,
            autoFocus: Y
          }
        ),
        !!s && Ce && /* @__PURE__ */ jsx("div", { className: "go-input__suffix", children: renderNode(s, "p") }),
        V ? /* @__PURE__ */ jsx(LoaderIcon, { className: "go-input__loader" }) : /* @__PURE__ */ jsx(Fragment, { children: Ee && /* @__PURE__ */ jsx(Tooltip$1, { title: (ye = (Pe = fe == null ? void 0 : fe.input) == null ? void 0 : Pe.values) == null ? void 0 : ye.clear, trigger: ["focus"], children: /* @__PURE__ */ jsx(
          "button",
          {
            className: "go-input__clear-button",
            disabled: de && !ae.length,
            onClick: Me,
            onPointerDown: be,
            children: typeof j == "object" && j.icon ? j.icon : /* @__PURE__ */ jsx(CloseMiniLine, {})
          }
        ) }) })
      ] })
    }
  );
}), DatePickerPopover = ({
  value: t,
  defaultValue: r,
  showTime: n,
  size: a,
  renderPopover: s,
  onCancel: o,
  onApply: l,
  onClear: c,
  isDateDisabled: x,
  isHourDisabled: j,
  isMinuteDisabled: Z
}) => {
  var W, X, K, J;
  const { localization: V } = useContext(ConfigContext), [U, $] = useState$1(t), Y = /* @__PURE__ */ jsx(
    Calendar$1,
    {
      value: U,
      onChange: $,
      defaultValue: r,
      showTime: n,
      isDateDisabled: x,
      isHourDisabled: j,
      isMinuteDisabled: Z
    }
  ), G = () => l(U);
  return s ? /* @__PURE__ */ jsx(Fragment, { children: s({ calendar: Y, currentDate: U, onCancel: o, onApply: G, onClear: c }) }) : /* @__PURE__ */ jsxs(Fragment, { children: [
    Y,
    /* @__PURE__ */ jsxs("div", { className: "go-date-picker__popover-footer", children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "danger",
          size: a,
          className: "go-date-picker__popover-footer-button",
          icon: /* @__PURE__ */ jsx(CloseRoundLight, {}),
          onClick: c,
          children: (X = (W = V == null ? void 0 : V.datePicker) == null ? void 0 : W.values) == null ? void 0 : X.cancel
        }
      ),
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "success",
          size: a,
          className: "go-date-picker__popover-footer-button",
          icon: /* @__PURE__ */ jsx(DoneLight, {}),
          onClick: G,
          children: (J = (K = V == null ? void 0 : V.datePicker) == null ? void 0 : K.values) == null ? void 0 : J.apply
        }
      )
    ] })
  ] });
};
class DateValidator {
  constructor(r) {
    Pr(this, "value");
    this.value = r;
  }
  checkFormat(r, n) {
    if (this.value) {
      const s = parse(this.value.toString(), r, /* @__PURE__ */ new Date(), { locale: n }).getTime();
      if (!isNaN(s))
        return this.value = s, this;
    }
    return this.value = null, this;
  }
  validate() {
    return this.value && new Date(this.value).getTime() || null;
  }
}
function validate(t, r, n) {
  return t == null ? null : t instanceof Date ? t.getTime() : typeof t == "number" ? t : new DateValidator(t).checkFormat(r, n).validate();
}
function validateYear(t) {
  if (t == null || t === "")
    return null;
  if (typeof t == "number")
    return t;
  const r = Number(t);
  return Number.isNaN(r) ? null : r;
}
const DEFAULT_DATE_FORMAT$1 = "dd.MM.yyyy", DEFAULT_DATE_TIME_FORMAT$1 = "dd.MM.yyyy HH:mm", DatePicker = forwardRef(function t({
  value: r = null,
  onChange: n,
  allowClear: a,
  className: s,
  disabled: o,
  autoFocus: l,
  defaultOpen: c = !1,
  open: x,
  fieldClassName: j,
  id: Z,
  inputClassName: V,
  popoverClassName: U,
  loading: $,
  onBlur: Y,
  onFocus: G,
  placeholder: W,
  size: X,
  status: K,
  style: J,
  tabIndex: ee,
  showTime: te,
  isDateDisabled: ne,
  isHourDisabled: re,
  isMinuteDisabled: ie,
  defaultValue: ue = null,
  dateFormat: le,
  renderPopover: oe,
  tooltipProps: he,
  onOpenChange: fe
}, ce) {
  var be, Pe, ye, Ae, Fe, Ie;
  const { localization: se } = useContext(ConfigContext), pe = le != null ? le : te ? DEFAULT_DATE_TIME_FORMAT$1 : DEFAULT_DATE_FORMAT$1, ve = useMemo$1(() => format(/* @__PURE__ */ new Date(), pe), [pe]), ae = useRef(null), [me, de] = useState$1((be = c || x) != null ? be : c), [ge, Se] = useState$1(!1), [xe, Ee] = useState$1(
    () => {
      var Le, De;
      return (De = validate(r, pe, (Le = se == null ? void 0 : se.calendar) == null ? void 0 : Le.locale)) != null ? De : null;
    }
  );
  useEffect(() => {
    var Le;
    x !== void 0 && (de(x), Se(!0), (Le = ae.current) == null || Le.focus());
  }, [x]), useEffect(() => {
    var De, je, Ze;
    const Le = (Ze = validate(r, pe, (De = se == null ? void 0 : se.calendar) == null ? void 0 : De.locale)) != null ? Ze : validate(ue, pe, (je = se == null ? void 0 : se.calendar) == null ? void 0 : je.locale);
    Ee(Le ? format(Le, pe) : null);
  }, [pe, ue, r, (Pe = se == null ? void 0 : se.calendar) == null ? void 0 : Pe.locale]);
  const Ce = (Le) => {
    const { value: De } = Le.currentTarget;
    Ee(De);
  }, ke = useCallback(
    (Le) => {
      Se(!0), G == null || G(Le);
    },
    [G]
  ), Re = useCallback(
    (Le) => {
      var je, Ze, $e;
      const De = ($e = validate(r, pe, (je = se == null ? void 0 : se.calendar) == null ? void 0 : je.locale)) != null ? $e : validate(ue, pe, (Ze = se == null ? void 0 : se.calendar) == null ? void 0 : Ze.locale);
      Ee(De ? format(De, pe) : null), n == null || n(De ? new Date(De) : null), Se(!1), Y == null || Y(Le);
    },
    [pe, ue, (ye = se == null ? void 0 : se.calendar) == null ? void 0 : ye.locale, Y, n, r]
  ), _e = () => {
    var De, je, Ze;
    const Le = (Ze = validate(r, pe, (De = se == null ? void 0 : se.calendar) == null ? void 0 : De.locale)) != null ? Ze : validate(ue, pe, (je = se == null ? void 0 : se.calendar) == null ? void 0 : je.locale);
    Ee(Le ? format(Le, pe) : null), de(!1), fe == null || fe(!1);
  }, Me = (Le) => {
    var je, Ze, $e;
    const De = ($e = validate(Le, pe, (je = se == null ? void 0 : se.calendar) == null ? void 0 : je.locale)) != null ? $e : validate(ue, pe, (Ze = se == null ? void 0 : se.calendar) == null ? void 0 : Ze.locale);
    Ee(De ? format(De, pe) : null), n == null || n(De ? new Date(De) : null), de(!1), fe == null || fe(!1);
  }, we = useCallback(() => {
    Ee(null), n == null || n(null), de(!1), fe == null || fe(!1);
  }, [n, fe]), Te = useCallback(() => {
    var Le;
    de(!0), fe == null || fe(!0), (Le = ae.current) == null || Le.focus();
  }, [fe]);
  return /* @__PURE__ */ jsx("div", { className: clsx("go-date-picker", s), style: J, children: /* @__PURE__ */ jsx(
    Tooltip$1,
    {
      title: /* @__PURE__ */ jsx(
        DatePickerPopover,
        {
          value: validate(xe, pe, (Ae = se == null ? void 0 : se.calendar) == null ? void 0 : Ae.locale),
          defaultValue: validate(ue, pe, (Fe = se == null ? void 0 : se.calendar) == null ? void 0 : Fe.locale),
          showTime: te,
          size: X,
          isDateDisabled: ne,
          isHourDisabled: re,
          isMinuteDisabled: ie,
          renderPopover: oe,
          onApply: Me,
          onCancel: _e,
          onClear: we
        }
      ),
      placement: "bottom-start",
      open: me,
      trigger: ["click", "focus"],
      onOpenChange: de,
      withArrow: !1,
      gap: 8,
      className: clsx("go-date-picker__popover", U),
      onPointerDown: (Le) => Le.preventDefault(),
      triggerRef: mergeRefs(ce, ae),
      ...he,
      children: /* @__PURE__ */ jsx(
        Input,
        {
          id: Z,
          value: (Ie = xe == null ? void 0 : xe.toString()) != null ? Ie : null,
          onChange: Ce,
          suffix: !ge && /* @__PURE__ */ jsx(CalendarDuotoneLine, { className: "go-date-picker__suffix-icon" }),
          allowClear: a,
          loading: $,
          placeholder: W != null ? W : ve,
          size: X,
          status: K,
          tabIndex: ee,
          autoFocus: l,
          disabled: o,
          inputClassName: V,
          fieldClassName: j,
          onClear: we,
          onBlur: Re,
          onFocus: ke,
          onClick: Te,
          onKeyUp: (Le) => {
            Le.code === "Enter" && Te();
          }
        }
      )
    }
  ) });
}), WeekV2 = forwardRef(function t({ weekStart: r, month: n, selectedDate: a, isDateDisabled: s, onDateChange: o, config: l, onUnmount: c }, x) {
  var V;
  const { localization: j } = useContext(ConfigContext), Z = useMemo$1(() => {
    var Y, G;
    const U = startOfWeek(toDate(r), { locale: (Y = j == null ? void 0 : j.calendar) == null ? void 0 : Y.locale }), $ = endOfWeek(U, { locale: (G = j == null ? void 0 : j.calendar) == null ? void 0 : G.locale });
    return eachDayOfInterval({ start: U, end: $ });
  }, [(V = j == null ? void 0 : j.calendar) == null ? void 0 : V.locale, r]);
  return useEffect(() => () => c(r), [c, r]), /* @__PURE__ */ jsx(
    "div",
    {
      ref: x,
      id: `${format(r, "dd.MM.yyyy")}`,
      className: "go-calendar__week-row",
      style: { height: `${l.weekRowHeight}px` },
      children: Z.map((U) => {
        var $;
        return /* @__PURE__ */ jsx(
          CalendarDate,
          {
            value: U,
            onClick: () => o(U.getTime()),
            isSelected: isSelectedDate(U, a),
            isActive: isActiveMonth(n, U),
            disabled: ($ = s == null ? void 0 : s(millisecondsToSeconds(U.getTime()))) != null ? $ : !1
          },
          U.getTime().toString()
        );
      })
    }
  );
});
function moveWeekRows(t, r, n, a) {
  for (const [s, o] of t) {
    const l = getViewportPoint(s, r, a);
    o.style.transform = `translateY(${l - n}px)`;
  }
}
const CalendarDatesV2 = ({
  month: t,
  year: r,
  selectedDate: n,
  config: a,
  onDateChange: s,
  onMonthChange: o,
  isDateDisabled: l
}) => {
  var le, oe;
  const { localization: c } = useContext(ConfigContext), x = (le = c == null ? void 0 : c.calendar) == null ? void 0 : le.locale, j = useRef(startOfWeek(startOfMonth(/* @__PURE__ */ new Date()), { locale: x })), [Z, V] = useState$1(() => getStartOfMonth(t, r));
  useEffect(() => V(getStartOfMonth(t, r)), [t, r]);
  const [U, $] = useState$1(() => getWeeks(Z, x));
  useEffect(() => $(getWeeks(Z, x)), [x, Z]);
  const Y = useRef(/* @__PURE__ */ new Map()), G = useRef(null), W = useRef(
    // eslint-disable-next-line react-hooks/refs
    getViewportByDate(Z, j.current, a.weekRowHeight, x)
  ), X = useRef(null), [K, J] = useState$1(!1);
  useEffect(() => {
    var ce;
    if (K)
      return;
    const he = W.current, fe = getViewportByDate(Z, j.current, a.weekRowHeight, x);
    (ce = X.current) == null || ce.call(X), X.current = animate(
      he,
      fe,
      (se) => {
        W.current = se, moveWeekRows(Y.current, j.current, se, a.weekRowHeight);
      },
      (se) => W.current = se
    );
  }, [a.weekRowHeight, Z, K, x]);
  const ee = useCallback(
    ({ y: he }) => {
      J(!0), W.current += he;
      const fe = Math.ceil(W.current / a.weekRowHeight), ce = startOfWeek(
        // Add (NUMBER_OF_WEEKS_ON_PAGE / 2) weeks to switch months in header when month is half displayed.
        startOfMonth(add$1(j.current, { weeks: fe + NUMBER_OF_WEEKS_ON_PAGE / 2 })),
        {
          locale: x
        }
      );
      moveWeekRows(Y.current, j.current, W.current, a.weekRowHeight);
      const se = endOfWeek(ce, { locale: x }), pe = getMonth(se), ve = getYear(se);
      V(getStartOfMonth(getMonth(se), getYear(se))), o(pe, ve);
    },
    [a.weekRowHeight, x, o]
  ), te = useCallback(() => {
    J(!1);
  }, []), ne = useThrottledFn((he) => {
    const fe = he > 0 ? 1 : -1, ce = startOfWeek(startOfMonth(add$1(Z, { months: 1 * fe })), {
      locale: x
    }).getTime();
    if (Y.current.get(ce)) {
      const pe = endOfWeek(ce, { locale: x });
      o(getMonth(pe), getYear(pe));
    }
  }, 300);
  useScroll({
    // eslint-disable-next-line react-hooks/refs
    element: (oe = G.current) != null ? oe : null,
    onMove: ee,
    onMoveEnd: te,
    onScroll: ne
  });
  const re = (he, fe) => {
    if (he !== null) {
      Y.current.set(fe, he);
      const ce = W.current, se = getViewportPoint(fe, j.current, a.weekRowHeight);
      he.style.transform = `translateY(${se - ce}px)`;
    }
  }, ie = useCallback((he) => {
    Y.current.delete(he);
  }, []), ue = useMemo$1(() => eachDayOfInterval({
    start: startOfWeek(Z, { locale: x }),
    end: endOfWeek(Z, { locale: x })
  }), [Z, x]);
  return /* @__PURE__ */ jsxs("div", { className: "go-calendar__dates-container", children: [
    /* @__PURE__ */ jsx("div", { className: "go-calendar__week-days-row", children: ue.map((he) => /* @__PURE__ */ jsx(
      "div",
      {
        className: clsx("go-calendar__week-day", isWeekend(he) && "go-calendar__date_weekend"),
        children: /* @__PURE__ */ jsx("span", { className: "go-calendar__week-day-inner", children: format(he, "cccccc", { locale: x }) })
      },
      he.getTime().toString()
    )) }),
    /* @__PURE__ */ jsx("div", { ref: G, className: "go-calendar__dates", children: U.map((he) => /* @__PURE__ */ jsx(
      WeekV2,
      {
        ref: (fe) => re(fe, he),
        onUnmount: ie,
        selectedDate: n,
        month: t,
        weekStart: he,
        config: a,
        onDateChange: s,
        isDateDisabled: l
      },
      he.toString()
    )) })
  ] });
}, CalendarMonthPageV2 = ({
  month: t,
  year: r,
  selectedDate: n,
  config: a,
  onDateChange: s,
  onMonthChange: o,
  isDateDisabled: l
}) => /* @__PURE__ */ jsx("div", { className: "go-calendar__month-page", children: /* @__PURE__ */ jsx(
  CalendarDatesV2,
  {
    month: t,
    year: r,
    selectedDate: n,
    config: a,
    onDateChange: s,
    onMonthChange: o,
    isDateDisabled: l
  }
) });
function shouldShowTime(t) {
  return typeof t == "boolean" ? t : typeof t == "object" ? !!t.hours || !!t.minutes : !1;
}
const CalendarV2 = ({
  value: t = null,
  defaultValue: r = null,
  defaultOpenDate: n = null,
  showTime: a = !1,
  mode: s = "month",
  config: o,
  className: l,
  style: c,
  onChange: x,
  isDateDisabled: j,
  isHourDisabled: Z,
  isMinuteDisabled: V
}) => {
  var ue, le;
  const U = t ? secondsToMilliseconds(t) : null, $ = r ? secondsToMilliseconds(r) : null, Y = n ? secondsToMilliseconds(n) : null, [G, W] = useReducer(
    reducer,
    initialState,
    (oe) => initStore(oe, U, $, Y, s)
  );
  useEffect(() => {
    U !== null && W({ type: "SET_DATE", payload: U });
  }, [U]);
  const X = useMemo$1(
    () => ({ ...DEFAULT_CALENDAR_CONFIG, ...o }),
    [o]
  ), K = useCallback(
    (oe) => {
      var ce, se;
      const he = (/* @__PURE__ */ new Date()).getTime(), fe = applyTimeV2(oe, (ce = G.hours) != null ? ce : getHours(he), (se = G.minutes) != null ? se : getMinutes(he));
      x == null || x(fe ? millisecondsToSeconds(fe) : null);
    },
    [x, G.hours, G.minutes]
  ), J = useCallback(
    (oe) => {
      if (W({ type: "SET_HOURS", payload: oe.value }), G.mode !== "month" || G.minutes === null || U === null)
        return;
      const he = applyTimeV2(U, oe.value, G.minutes);
      x == null || x(he ? millisecondsToSeconds(he) : null);
    },
    [x, U, G.minutes, G.mode]
  ), ee = useCallback(
    (oe) => {
      if (W({ type: "SET_MINUTES", payload: oe.value }), G.mode !== "month" || G.hours === null || U === null)
        return;
      const he = applyTimeV2(U, G.hours, oe.value);
      x == null || x(he ? millisecondsToSeconds(he) : null);
    },
    [x, G.hours, G.mode, U]
  ), te = useCallback(
    (oe) => Z ? G.mode === "year" ? !0 : Z(
      oe,
      U !== null ? millisecondsToSeconds(applyTimeV2(U, oe, G.minutes)) : null
    ) : !1,
    [Z, G.minutes, G.mode, U]
  ), ne = useCallback(
    (oe) => V ? G.mode === "year" ? !0 : V(
      oe,
      G.hours,
      U !== null ? millisecondsToSeconds(applyTimeV2(U, G.hours, oe)) : null
    ) : !1,
    [V, G.hours, G.mode, U]
  ), re = useCallback((oe, he) => {
    W({ type: "SET_MONTH", payload: { month: oe, year: he } });
  }, []), ie = shouldShowTime(a);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: clsx("go-calendar", ie && "go-calendar_with-time", l),
      style: {
        ...c,
        "--dates-container-height": `${X.weekRowHeight * NUMBER_OF_WEEKS_ON_PAGE}px`
      },
      children: [
        /* @__PURE__ */ jsx(
          CalendarHeader,
          {
            month: (ue = G.month) != null ? ue : getMonth(/* @__PURE__ */ new Date()),
            year: (le = G.year) != null ? le : getYear(/* @__PURE__ */ new Date()),
            mode: G.mode,
            onChange: (oe, he) => {
              W({ type: "SET_MONTH", payload: { month: oe, year: he } });
            },
            onTitleClick: () => {
              W({ type: "TOGGLE_MODE" });
            }
          }
        ),
        G.mode === "month" && /* @__PURE__ */ jsx(
          CalendarMonthPageV2,
          {
            month: G.month,
            year: G.year,
            selectedDate: U,
            config: X,
            onDateChange: K,
            onMonthChange: re,
            isDateDisabled: j
          }
        ),
        G.mode === "year" && /* @__PURE__ */ jsx(
          CalendarYearPage,
          {
            month: G.month,
            year: G.year,
            onYearChange: (oe) => {
              W({ type: "SET_YEAR", payload: oe });
            },
            onMonthChange: (oe) => {
              W({ type: "SET_MONTH", payload: { month: oe } }), W({ type: "TOGGLE_MODE", payload: "month" });
            }
          }
        ),
        ie && /* @__PURE__ */ jsx(
          CalendarTime,
          {
            hours: G.hours,
            minutes: G.minutes,
            onHourChange: J,
            onMinuteChange: ee,
            viewSettings: typeof a == "object" ? a : void 0,
            isHourDisabled: te,
            isMinuteDisabled: ne,
            disabled: G.mode === "year"
          }
        )
      ]
    }
  );
}, DatePickerPopoverV2 = ({
  value: t,
  defaultValue: r,
  defaultOpenDate: n,
  showTime: a,
  size: s,
  renderPopover: o,
  onCancel: l,
  onApply: c,
  onClear: x,
  isDateDisabled: j,
  isHourDisabled: Z,
  isMinuteDisabled: V
}) => {
  var X, K, J, ee;
  const { localization: U } = useContext(ConfigContext), [$, Y] = useState$1(t), G = /* @__PURE__ */ jsx(
    CalendarV2,
    {
      value: $ && millisecondsToSeconds($),
      onChange: (te) => Y(te && secondsToMilliseconds(te)),
      defaultValue: r,
      defaultOpenDate: n,
      showTime: a,
      isDateDisabled: j,
      isHourDisabled: Z,
      isMinuteDisabled: V
    }
  ), W = () => c($);
  return o ? /* @__PURE__ */ jsx(Fragment, { children: o({
    calendar: G,
    currentDate: $ && millisecondsToSeconds($),
    onCancel: l,
    onApply: W,
    onClear: x
  }) }) : /* @__PURE__ */ jsxs(Fragment, { children: [
    G,
    /* @__PURE__ */ jsxs("div", { className: "go-date-picker__popover-footer", children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "danger",
          size: s,
          className: "go-date-picker__popover-footer-button",
          icon: /* @__PURE__ */ jsx(CloseRoundLight, {}),
          onClick: x,
          children: (K = (X = U == null ? void 0 : U.datePicker) == null ? void 0 : X.values) == null ? void 0 : K.cancel
        }
      ),
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "success",
          size: s,
          className: "go-date-picker__popover-footer-button",
          icon: /* @__PURE__ */ jsx(DoneLight, {}),
          onClick: W,
          children: (ee = (J = U == null ? void 0 : U.datePicker) == null ? void 0 : J.values) == null ? void 0 : ee.apply
        }
      )
    ] })
  ] });
}, DEFAULT_DATE_FORMAT = "dd.MM.yyyy", DEFAULT_DATE_TIME_FORMAT = "dd.MM.yyyy HH:mm", DatePickerV2 = forwardRef(function t({
  value: r = null,
  onChange: n,
  allowClear: a,
  className: s,
  disabled: o,
  autoFocus: l,
  defaultOpen: c = !1,
  fieldClassName: x,
  id: j,
  inputClassName: Z,
  popoverClassName: V,
  loading: U,
  onBlur: $,
  onFocus: Y,
  onKeyDown: G,
  placeholder: W,
  size: X,
  status: K,
  style: J,
  tabIndex: ee,
  showTime: te,
  isDateDisabled: ne,
  isHourDisabled: re,
  isMinuteDisabled: ie,
  defaultValue: ue = null,
  defaultOpenDate: le,
  dateFormat: oe,
  renderPopover: he,
  tooltipProps: fe
}, ce) {
  var Ae, Fe, Ie, Le, De, je, Ze, $e;
  const { localization: se } = useContext(ConfigContext), pe = r && secondsToMilliseconds(r), ve = oe != null ? oe : te ? DEFAULT_DATE_TIME_FORMAT : DEFAULT_DATE_FORMAT, ae = useMemo$1(() => format(/* @__PURE__ */ new Date(), ve), [ve]), me = useRef(null), [de, ge] = useState$1(c), [Se, xe] = useState$1(!1), [Ee, Ce] = useState$1(
    () => {
      var Oe, Be;
      return (Be = validate(pe, ve, (Oe = se == null ? void 0 : se.calendar) == null ? void 0 : Oe.locale)) != null ? Be : null;
    }
  );
  useEffect(() => {
    var Be, Qe, Xe;
    const Oe = (Xe = validate(pe, ve, (Be = se == null ? void 0 : se.calendar) == null ? void 0 : Be.locale)) != null ? Xe : validate(ue, ve, (Qe = se == null ? void 0 : se.calendar) == null ? void 0 : Qe.locale);
    Ce(Oe ? format(Oe, ve) : null);
  }, [ve, ue, pe, (Ae = se == null ? void 0 : se.calendar) == null ? void 0 : Ae.locale]);
  const ke = (Oe) => {
    const { value: Be } = Oe.currentTarget;
    Ce(Be);
  }, Re = useCallback(
    (Oe) => {
      xe(!0), Y == null || Y(Oe);
    },
    [Y]
  ), _e = useCallback(
    (Oe) => {
      var Qe, Xe, rt;
      const Be = (rt = validate(pe, ve, (Qe = se == null ? void 0 : se.calendar) == null ? void 0 : Qe.locale)) != null ? rt : validate(ue, ve, (Xe = se == null ? void 0 : se.calendar) == null ? void 0 : Xe.locale);
      Ce(Be ? format(Be, ve) : null), n == null || n(Be ? getUnixTime(Be) : null), xe(!1), $ == null || $(Oe);
    },
    [ve, ue, (Fe = se == null ? void 0 : se.calendar) == null ? void 0 : Fe.locale, $, n, pe]
  ), Me = () => {
    var Be, Qe, Xe;
    const Oe = (Xe = validate(pe, ve, (Be = se == null ? void 0 : se.calendar) == null ? void 0 : Be.locale)) != null ? Xe : validate(ue, ve, (Qe = se == null ? void 0 : se.calendar) == null ? void 0 : Qe.locale);
    Ce(Oe ? format(Oe, ve) : null), ge(!1);
  }, we = useCallback(
    (Oe) => {
      var Qe, Xe, rt;
      const Be = (rt = validate(Oe, ve, (Qe = se == null ? void 0 : se.calendar) == null ? void 0 : Qe.locale)) != null ? rt : validate(ue, ve, (Xe = se == null ? void 0 : se.calendar) == null ? void 0 : Xe.locale);
      Oe !== pe && (Ce(Be ? format(Be, ve) : null), n == null || n(Be ? getUnixTime(Be) : null)), ge(!1);
    },
    [ve, ue, (Ie = se == null ? void 0 : se.calendar) == null ? void 0 : Ie.locale, n, pe]
  ), Te = useCallback(() => {
    Ce(null), n == null || n(null), ge(!1);
  }, [n]), be = useCallback(() => {
    var Oe;
    ge(!0), (Oe = me.current) == null || Oe.focus();
  }, []), Pe = useCallback(
    (Oe) => {
      var Be, Qe, Xe, rt, lt;
      if (Oe.key === "Enter") {
        if (!de) {
          ge(!0);
          return;
        }
        const ct = Ee === null ? null : (Qe = parse(Ee.toString(), ve, /* @__PURE__ */ new Date(), {
          locale: (Be = se == null ? void 0 : se.calendar) == null ? void 0 : Be.locale
        })) == null ? void 0 : Qe.getTime(), Je = (lt = validate(ct, ve, (Xe = se == null ? void 0 : se.calendar) == null ? void 0 : Xe.locale)) != null ? lt : validate(ue, ve, (rt = se == null ? void 0 : se.calendar) == null ? void 0 : rt.locale);
        ct !== pe && (Ce(Je ? format(Je, ve) : null), n == null || n(Je ? getUnixTime(Je) : null)), ge(!1);
      }
      G == null || G(Oe);
    },
    [ve, ue, (Le = se == null ? void 0 : se.calendar) == null ? void 0 : Le.locale, n, G, de, Ee, pe]
  ), ye = useMemo$1(() => mergeRefs(ce, me), [ce]);
  return /* @__PURE__ */ jsx("div", { className: clsx("go-date-picker", s), style: J, children: /* @__PURE__ */ jsx(
    Tooltip$1,
    {
      title: /* @__PURE__ */ jsx(
        DatePickerPopoverV2,
        {
          value: validate(Ee, ve, (De = se == null ? void 0 : se.calendar) == null ? void 0 : De.locale),
          defaultValue: validate(ue, ve, (je = se == null ? void 0 : se.calendar) == null ? void 0 : je.locale),
          defaultOpenDate: validate(le, ve, (Ze = se == null ? void 0 : se.calendar) == null ? void 0 : Ze.locale),
          showTime: te,
          size: X,
          isDateDisabled: ne,
          isHourDisabled: re,
          isMinuteDisabled: ie,
          renderPopover: he,
          onApply: we,
          onCancel: Me,
          onClear: Te
        }
      ),
      placement: "bottom-start",
      open: de,
      trigger: ["click", "focus"],
      onOpenChange: ge,
      withArrow: !1,
      gap: 8,
      className: clsx("go-date-picker__popover", V),
      onPointerDown: (Oe) => Oe.preventDefault(),
      triggerRef: ye,
      focusManagerProps: { returnFocus: !1 },
      ...fe,
      children: /* @__PURE__ */ jsx(
        Input,
        {
          id: j,
          value: ($e = Ee == null ? void 0 : Ee.toString()) != null ? $e : null,
          onChange: ke,
          suffix: !Se && /* @__PURE__ */ jsx(CalendarDuotoneLine, { className: "go-date-picker__suffix-icon" }),
          allowClear: a,
          loading: U,
          placeholder: Se ? W != null ? W : ae : W != null ? W : "",
          size: X,
          status: K,
          tabIndex: ee,
          autoFocus: l,
          disabled: o,
          inputClassName: Z,
          fieldClassName: x,
          onClear: Te,
          onBlur: _e,
          onFocus: Re,
          onClick: be,
          onKeyDown: Pe
        }
      )
    }
  ) });
}), CalendarYearsRow = forwardRef(function t({ startYear: r, selectedYear: n, config: a, min: s, max: o, isYearDisabled: l, onChange: c }, x) {
  const j = numberRange(Math.max(r, s), Math.min(r + a.numberOfYearsInRow - 1, o));
  return /* @__PURE__ */ jsx("div", { ref: x, className: "go-calendar_years__row", style: { height: `${a.rowHeight}px` }, children: j.map((Z) => /* @__PURE__ */ jsx(
    "button",
    {
      disabled: l == null ? void 0 : l(Z),
      onClick: c && (() => c(Z)),
      className: clsx("go-calendar_years__year", Z === n && "go-calendar_years__year_selected"),
      style: { width: `calc(100% / ${a.numberOfYearsInRow})` },
      children: /* @__PURE__ */ jsx("span", { className: "go-calendar_years__year-inner", children: Z })
    },
    Z
  )) });
});
function getScrolledDistance(t, r, n) {
  return ((t - r) / n.numberOfYearsInRow - 1) * n.rowHeight - Math.floor(n.numberOfYearsInRow / 2) * n.rowHeight;
}
const CalendarYearsPage = ({ year: t, config: r, min: n = 1900, max: a = 2099, onChange: s, isYearDisabled: o }) => {
  const [l, c] = n <= a ? [Math.trunc(n), Math.trunc(a)] : [Math.trunc(a), Math.trunc(n)];
  useEffect(() => {
    n > a && console.warn(`Invalid minimum and maximum years: ${n} > ${a}`);
  }, [a, n]);
  const [x, j] = useState$1(null), Z = ((getStartOfYearRow(l, c, r.numberOfYearsInRow) - l) / r.numberOfYearsInRow + 1) * r.rowHeight, V = useRef(t != null ? t : (/* @__PURE__ */ new Date()).getFullYear());
  useEffect(() => {
    if (!x)
      return;
    const $ = getStartOfYearRow(l, V.current, r.numberOfYearsInRow), Y = getScrolledDistance($, l, r);
    x.scroll({ top: Y });
  }, [r, x, l]), useEffect(() => {
    if (!x || t === null || t < l || t > c)
      return;
    const $ = getStartOfYearRow(l, t, r.numberOfYearsInRow), Y = getScrolledDistance($, l, r);
    x.scroll({ top: Y, behavior: "smooth" });
  }, [r, x, c, l, t]);
  const U = useMemo$1(
    () => getYearRowStartPoints(l, c, r.numberOfYearsInRow),
    [r.numberOfYearsInRow, c, l]
  );
  return /* @__PURE__ */ jsx(
    "div",
    {
      ref: ($) => j($),
      className: "go-calendar_years__inner",
      style: { height: `${r.numberOfRows * r.rowHeight}px` },
      children: /* @__PURE__ */ jsx("div", { style: { height: `${Z}px` }, children: U.map(($) => /* @__PURE__ */ jsx(
        CalendarYearsRow,
        {
          startYear: $,
          selectedYear: t,
          config: r,
          min: l,
          max: c,
          isYearDisabled: o,
          onChange: s
        },
        $
      )) })
    }
  );
}, YearsCalendar = ({
  value: t,
  defaultValue: r,
  minYear: n,
  maxYear: a,
  config: s,
  style: o,
  className: l,
  onChange: c,
  isYearDisabled: x
}) => {
  var Z;
  const j = useMemo$1(
    () => ({ ...DEFAULT_YEARS_CALENDAR_CONFIG, ...s }),
    [s]
  );
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: clsx("go-calendar_years", l),
      style: {
        ...o,
        "--dates-container-height": `${j.rowHeight * j.numberOfRows}px`
      },
      children: /* @__PURE__ */ jsx(
        CalendarYearsPage,
        {
          year: (Z = t != null ? t : r) != null ? Z : null,
          config: j,
          onChange: c,
          isYearDisabled: x,
          min: n,
          max: a
        }
      )
    }
  );
}, YearPickerPopover = ({
  value: t,
  defaultValue: r,
  minYear: n,
  maxYear: a,
  size: s,
  renderPopover: o,
  onCancel: l,
  onApply: c,
  onClear: x,
  isYearDisabled: j,
  calendarConfig: Z
}) => {
  var W, X, K, J;
  const { localization: V } = useContext(ConfigContext), [U, $] = useState$1(t);
  useEffect(() => {
    $(t);
  }, [t]);
  const Y = /* @__PURE__ */ jsx(
    YearsCalendar,
    {
      value: U,
      onChange: $,
      defaultValue: r,
      isYearDisabled: j,
      minYear: n,
      maxYear: a,
      config: Z
    }
  ), G = () => c(U);
  return o ? /* @__PURE__ */ jsx(Fragment, { children: o({
    calendar: Y,
    currentYear: U,
    onCancel: l,
    onApply: G,
    onClear: x
  }) }) : /* @__PURE__ */ jsxs(Fragment, { children: [
    Y,
    /* @__PURE__ */ jsxs("div", { className: "go-date-picker__popover-footer", children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "danger",
          size: s,
          className: "go-date-picker__popover-footer-button",
          icon: /* @__PURE__ */ jsx(CloseRoundLight, {}),
          onClick: x,
          children: (X = (W = V == null ? void 0 : V.datePicker) == null ? void 0 : W.values) == null ? void 0 : X.cancel
        }
      ),
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "success",
          size: s,
          className: "go-date-picker__popover-footer-button",
          icon: /* @__PURE__ */ jsx(DoneLight, {}),
          onClick: G,
          children: (J = (K = V == null ? void 0 : V.datePicker) == null ? void 0 : K.values) == null ? void 0 : J.apply
        }
      )
    ] })
  ] });
}, YearPicker = forwardRef(function t({
  value: r = null,
  onChange: n,
  allowClear: a,
  className: s,
  disabled: o,
  autoFocus: l,
  defaultOpen: c = !1,
  fieldClassName: x,
  id: j,
  inputClassName: Z,
  popoverClassName: V,
  loading: U,
  onBlur: $,
  onFocus: Y,
  onKeyDown: G,
  placeholder: W,
  size: X,
  status: K,
  style: J,
  calendarConfig: ee,
  tabIndex: te,
  defaultValue: ne = null,
  renderPopover: re,
  tooltipProps: ie,
  isYearDisabled: ue,
  onApplyInPopover: le
}, oe) {
  var Re;
  const he = useRef(null), [fe, ce] = useState$1(c), [se, pe] = useState$1(!1), [ve, ae] = useState$1(() => r != null ? r : null);
  useEffect(() => {
    var Me;
    const _e = (Me = validateYear(r)) != null ? Me : validateYear(ne);
    ae(_e);
  }, [ne, r]);
  const me = (_e) => {
    var Te;
    const { value: Me } = _e.currentTarget, we = (Te = validateYear(Me)) != null ? Te : validateYear(ne);
    ae(we);
  }, de = useCallback(
    (_e) => {
      pe(!0), Y == null || Y(_e);
    },
    [Y]
  ), ge = useCallback(
    (_e) => {
      var we;
      const Me = (we = validateYear(r)) != null ? we : validateYear(ne);
      ae(Me), n == null || n(Me), pe(!1), $ == null || $(_e);
    },
    [ne, $, n, r]
  ), Se = () => {
    var Me;
    const _e = (Me = validateYear(r)) != null ? Me : validateYear(ne);
    ae(_e), ce(!1);
  }, xe = (_e) => {
    var we;
    const Me = (we = validateYear(_e)) != null ? we : validateYear(ne);
    _e !== r && (ae(Me), n == null || n(Me)), ce(!1), le == null || le(Me);
  }, Ee = useCallback(() => {
    ae(null), n == null || n(null);
  }, [n]), Ce = useCallback(() => {
    var _e;
    ce(!0), (_e = he.current) == null || _e.focus();
  }, []), ke = useCallback(
    (_e) => {
      var Me;
      if (_e.key === "Enter") {
        const we = (Me = validateYear(ve)) != null ? Me : validateYear(ne);
        we !== r && (ae(we), n == null || n(we)), ce(!fe);
      }
      G == null || G(_e);
    },
    [ne, n, G, fe, ve, r]
  );
  return /* @__PURE__ */ jsx("div", { className: clsx("go-date-picker", s), style: J, children: /* @__PURE__ */ jsx(
    Tooltip$1,
    {
      title: /* @__PURE__ */ jsx(
        YearPickerPopover,
        {
          value: ve,
          defaultValue: ne,
          size: X,
          isYearDisabled: ue,
          renderPopover: re,
          onApply: xe,
          onCancel: Se,
          onClear: Ee,
          calendarConfig: ee
        }
      ),
      placement: "bottom-start",
      open: fe,
      trigger: ["click", "focus"],
      onOpenChange: ce,
      withArrow: !1,
      gap: 8,
      className: clsx("go-date-picker__popover", V),
      onPointerDown: (_e) => _e.preventDefault(),
      triggerRef: mergeRefs(oe, he),
      focusManagerProps: { returnFocus: !1 },
      ...ie,
      children: /* @__PURE__ */ jsx(
        Input,
        {
          id: j,
          value: (Re = ve == null ? void 0 : ve.toString()) != null ? Re : null,
          onChange: me,
          suffix: !se && /* @__PURE__ */ jsx(CalendarDuotoneLine, { className: "go-date-picker__suffix-icon" }),
          allowClear: a,
          loading: U,
          placeholder: W,
          size: X,
          status: K,
          tabIndex: te,
          autoFocus: l,
          disabled: o,
          inputClassName: Z,
          fieldClassName: x,
          onClear: Ee,
          onBlur: ge,
          onFocus: de,
          onClick: Ce,
          onKeyDown: ke
        }
      )
    }
  ) });
}), DeleteButton = forwardRef(
  ({ className: t, style: r, onClick: n, loading: a, onPointerUp: s, onPointerDown: o, disabled: l }, c) => /* @__PURE__ */ jsx(
    "button",
    {
      ref: c,
      className: clsx("go-delete-button", a && "go-delete-button_loading", t),
      style: r,
      disabled: l,
      onClick: n,
      onPointerDown: o,
      onPointerUp: s,
      children: a ? /* @__PURE__ */ jsx(LoaderIcon, { size: "s", className: "go-delete-button__loader" }) : /* @__PURE__ */ jsx(CloseRoundDuotone, { className: "go-delete-button__icon" })
    }
  )
);
DeleteButton.displayName = "DeleteButton";
function Item({ titleClassName: t, valueClassName: r, label: n, children: a, titleStyle: s, valueStyle: o }) {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("div", { className: clsx("go-descriptions__item-title", t), style: s, children: n }),
    /* @__PURE__ */ jsx("div", { className: clsx("go-descriptions__item-value", r), style: o, children: a })
  ] });
}
function Descriptions({ className: t, children: r, layout: n = "horizontal" }) {
  return /* @__PURE__ */ jsx("div", { className: clsx("go-descriptions", n === "vertical" && "go-descriptions_vertical", t), children: r });
}
const descriptions = Object.assign(Descriptions, { Item });
function getOrCreatePortalElement(t) {
  const r = document.getElementById(t);
  if (r)
    return r;
  const n = document.createElement("div");
  return n.id = t, n.classList.add("go-portal"), n;
}
function useMountTransition(t, r) {
  const [n, a] = useState$1(!1);
  return useEffect(() => {
    let s;
    return t && !n ? a(!0) : !t && n && (s = window.setTimeout(() => a(!1), r)), () => {
      clearTimeout(s);
    };
  }, [r, t, n]), n;
}
const Portal = ({
  transitionDuration: t = 300,
  open: r,
  children: n,
  rootElement: a,
  className: s,
  contentClassName: o,
  contentOpenClassName: l,
  portalClassName: c,
  destroyOnClose: x = !0,
  mask: j = !0,
  onClickOutside: Z
}) => {
  var J;
  const V = useContext(ConfigContext), $ = `go-portal-${useId$3()}`, Y = useRef(getOrCreatePortalElement($)), G = useRef(null), W = (J = a != null ? a : V.rootElement) != null ? J : document.body, X = useMountTransition(r, t);
  useEffect(() => {
    const ee = Y.current;
    return W.appendChild(ee), () => {
      ee.remove();
    };
  }, [W]), useEffect(() => {
    if (s) {
      const ee = Y.current;
      return ee.classList.add(s), () => ee.classList.remove(s);
    }
  }, [s]), useEffect(() => {
    const ee = Y.current;
    return r && window.requestAnimationFrame(() => {
      ee.classList.add("go-portal_open");
    }), !r && X && window.requestAnimationFrame(() => {
      ee.classList.add("go-portal_closing");
    }), () => {
      window.requestAnimationFrame(() => {
        ee.classList.remove("go-portal_open"), ee.classList.remove("go-portal_closing");
      });
    };
  }, [X, r]);
  const K = useCallback(
    (ee) => {
      !Z || !r || ee.target === G.current && Z(ee);
    },
    [Z, r]
  );
  return !X && x && !r ? null : createPortal(
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: clsx(
          "go-portal__container",
          V.theme === "dark" && "go-theme_dark",
          V.theme === "light" && "go-theme_light",
          V.style === "bordered" && "go-style_bordered",
          c
        ),
        style: { "--go-transition": `${t}ms` },
        "aria-hidden": r,
        children: [
          j && /* @__PURE__ */ jsx("div", { ref: G, className: "go-portal__overlay", onClick: K }),
          /* @__PURE__ */ jsx("div", { className: clsx(o, "go-portal__content", r && l), children: n })
        ]
      }
    ),
    // eslint-disable-next-line react-hooks/refs
    Y.current
  );
}, Drawer = ({
  open: t,
  title: r,
  closeIcon: n = !0,
  loading: a,
  className: s,
  portalClassName: o,
  style: l,
  onClose: c,
  onClickOutside: x = c,
  children: j,
  transitionDuration: Z,
  destroyOnClose: V,
  container: U,
  mask: $
}) => {
  const Y = useCallback(() => typeof r == "string" || typeof r == "number" ? /* @__PURE__ */ jsx("h2", { className: "go-drawer__title", children: r }) : r, [r]);
  return /* @__PURE__ */ jsx(
    Portal,
    {
      open: t,
      onClickOutside: x != null ? x : null,
      className: "go-drawer__portal",
      contentClassName: "go-drawer__wrapper",
      contentOpenClassName: "go-drawer__wrapper_open",
      portalClassName: o,
      transitionDuration: Z,
      destroyOnClose: V,
      rootElement: U,
      mask: $,
      children: /* @__PURE__ */ jsxs("div", { className: clsx(s, "go-drawer"), style: l, children: [
        /* @__PURE__ */ jsx("div", { className: "go-drawer__header", children: Y() }),
        n && /* @__PURE__ */ jsx("button", { className: "go-drawer__close-button", onClick: c, children: /* @__PURE__ */ jsx(CloseRoundLight, {}) }),
        j,
        a && /* @__PURE__ */ jsx(Loader, { className: "go-drawer__loader" })
      ] })
    }
  );
}, orientationClassNames$1 = {
  horizontal: "go-field_orientation_horizontal",
  vertical: "go-field_orientation_vertical"
}, sizeClassNames$3 = {
  s: "go-field_size_s",
  m: "go-field_size_m"
}, statusClassNames$1 = {
  error: "go-field_status_error"
}, Field = ({
  children: t,
  label: r,
  id: n,
  orientation: a = "vertical",
  hint: s,
  info: o,
  size: l,
  status: c,
  className: x,
  style: j
}) => {
  const { size: Z } = useGlobalComponentConfig({ size: l }), V = useId$3(), U = n != null ? n : `go-field-${V}`, $ = () => isValidElement(t) ? cloneElement(t, {
    id: U,
    size: Z,
    status: c
  }) : null;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: clsx(
        "go-field",
        orientationClassNames$1[a],
        sizeClassNames$3[Z],
        !!c && statusClassNames$1[c],
        x
      ),
      style: j,
      children: [
        (!!r || !!o) && /* @__PURE__ */ jsxs("div", { className: "go-field__label-container", children: [
          !!r && /* @__PURE__ */ jsx("label", { htmlFor: U, className: "go-field__label", title: r.toString(), children: r }),
          !!o && /* @__PURE__ */ jsx(Tooltip$1, { title: renderNode(o, "p"), placement: "top", useSafePolygon: !1, withArrow: !0, children: /* @__PURE__ */ jsx("span", { className: "go-field__info-icon", tabIndex: 0, children: /* @__PURE__ */ jsx(InfoLight, {}) }) })
        ] }),
        $(),
        !!s && renderNode(s, "p", "go-field__hint")
      ]
    }
  );
}, Upload = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { width: 328, height: 412, fill: "none", viewBox: "0 0 328 412", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#D2DFFA",
        d: "M285.972 127.126h-8.876a21.347 21.347 0 0 1-15.102-6.261 21.381 21.381 0 0 1-.285-29.93 21.35 21.35 0 0 1 14.566-6.535h6.708a22.966 22.966 0 0 0 15.777-6.982 23.002 23.002 0 0 0 6.476-16.002 23.003 23.003 0 0 0-6.476-16.002 22.966 22.966 0 0 0-15.777-6.982H47.689a22.969 22.969 0 0 0-15.778 6.982 23.005 23.005 0 0 0 0 32.004A22.969 22.969 0 0 0 47.69 84.4h2.281a21.35 21.35 0 0 1 14.566 6.536 21.382 21.382 0 0 1 5.97 14.815c0 5.669-2.25 11.106-6.255 15.114a21.347 21.347 0 0 1-15.102 6.261h-7.895a18.246 18.246 0 0 0-12.907 5.35 18.277 18.277 0 0 0 0 25.836 18.247 18.247 0 0 0 12.907 5.351h244.718a18.25 18.25 0 0 0 12.908-5.351 18.277 18.277 0 0 0 0-25.836 18.249 18.249 0 0 0-12.908-5.35Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#BECDFA",
        d: "m222.634 281.299-58.265-33.718c-5.651-3.27-12.881-1.336-16.15 4.32L94.333 345.13c-3.27 5.656-1.339 12.891 4.312 16.161l58.265 33.718c5.651 3.27 12.881 1.336 16.15-4.32l53.886-93.229c3.269-5.655 1.339-12.891-4.312-16.161Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#F1F4FA",
        stroke: "#3A36DB",
        strokeMiterlimit: "10",
        strokeWidth: "2",
        d: "M122.142 257.357h74.157l20.901 22.082v100.934a8.323 8.323 0 0 1-5.143 7.686 8.306 8.306 0 0 1-3.185.626h-86.707a8.312 8.312 0 0 1-8.306-8.312V265.67c0-2.201.872-4.312 2.425-5.87a8.303 8.303 0 0 1 5.858-2.443Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#BECDFA",
        stroke: "#3A36DB",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M196.3 257.357v14.387c0 2.204.875 4.319 2.432 5.877a8.304 8.304 0 0 0 5.873 2.435h12.596L196.3 257.357Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#F1F4FA",
        d: "M184.982 409.671a261.313 261.313 0 0 0 3.833-36.103c0-6.668-3.217-10.505-6.046-10.505h-2.647a1.94 1.94 0 0 0-1.94 1.941v-.753a3.364 3.364 0 0 0-.949-2.433 3.36 3.36 0 0 0-2.405-1.015h-2.282a3.424 3.424 0 0 0-3.422 3.425v1.462a3.58 3.58 0 0 0-3.583-3.586h-2.281a3.769 3.769 0 0 0-3.765 3.768v.914a2.538 2.538 0 0 0-2.442-2.444h-3.149a3.354 3.354 0 0 0-3.354 3.311v3.7h-3.126a5.391 5.391 0 0 0-3.824 1.594 5.41 5.41 0 0 0-1.561 3.841v10.184a19.05 19.05 0 0 0 4.701 11.418 15.519 15.519 0 0 1 2.145 2.763 26.298 26.298 0 0 1 2.897 9.774h32.949l.251-1.256Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#3A36DB",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M178.182 365.004a1.945 1.945 0 0 1 1.94-1.941h2.647c2.829 0 6.046 3.837 6.046 10.505a261.313 261.313 0 0 1-3.833 36.103l-.251 1.256h-32.949a26.298 26.298 0 0 0-2.897-9.774 15.519 15.519 0 0 0-2.145-2.763 19.05 19.05 0 0 1-4.701-11.418v-10.184a5.393 5.393 0 0 1 3.314-5.021 5.391 5.391 0 0 1 2.071-.414h3.126m27.632-6.349v-.753a3.364 3.364 0 0 0-.949-2.433 3.36 3.36 0 0 0-2.405-1.015h-2.282a3.424 3.424 0 0 0-3.422 3.425v1.462m9.058-.686v9.707m-9.058-9.021a3.58 3.58 0 0 0-3.583-3.586h-2.281a3.769 3.769 0 0 0-3.765 3.768v.914m9.629-1.096v8.814m-9.629-7.718a2.538 2.538 0 0 0-2.442-2.444h-3.149a3.354 3.354 0 0 0-3.354 3.311v3.7m8.945-4.567v8.86m-8.945-4.293v12.285"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#D2DFFA",
        d: "M236.481.57H75.298c-5.419 0-9.812 4.392-9.812 9.809 0 5.416 4.393 9.808 9.812 9.808H236.48c5.419 0 9.811-4.392 9.811-9.808 0-5.417-4.392-9.808-9.811-9.808Zm20.194 175.058H92.594c-8.935 0-16.178 7.244-16.178 16.179 0 8.936 7.243 16.179 16.178 16.179h164.081c8.934 0 16.177-7.243 16.177-16.179 0-8.935-7.243-16.179-16.177-16.179Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#F1F4FA",
        d: "M236.663 66.223v116.211c0 3.028-1.202 5.932-3.341 8.073a11.403 11.403 0 0 1-8.067 3.345H105.828a11.402 11.402 0 0 1-8.068-3.345 11.42 11.42 0 0 1-3.341-8.073V23.384a10.33 10.33 0 0 1 3.029-7.307 10.313 10.313 0 0 1 7.307-3.015h80.82"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#3A36DB",
        strokeDasharray: "5 5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M236.663 66.223v116.211c0 3.028-1.202 5.932-3.341 8.073a11.403 11.403 0 0 1-8.067 3.345H105.828a11.402 11.402 0 0 1-8.068-3.345 11.42 11.42 0 0 1-3.341-8.073V23.384a10.33 10.33 0 0 1 3.029-7.307 10.313 10.313 0 0 1 7.307-3.015h80.82"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#BECDFA",
        stroke: "#3A36DB",
        strokeDasharray: "5 5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M186.719 13.701v37.533c0 4.332-.215 7.97 2.841 11.034 3.057 3.063 7.516 3.955 11.839 3.955h35.515l-50.195-52.522Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#3A36DB",
        strokeLinecap: "round",
        strokeMiterlimit: "10",
        strokeWidth: "3",
        d: "M165.336 86.775v50.855m-25.783-25.416h51.157"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#3A36DB",
        strokeMiterlimit: "10",
        strokeWidth: "2",
        d: "M203.441 344.201h-74.225v-58.002h74.225v58.002Zm-49.788 0v-58.002m25.442 58.002v-58.002m-49.879 20.953h74.225m-74.225 18.712h74.225"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#3A36DB",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "m153.653 236.386 11.865-12.537 12.185 12.537"
      }
    )
  ] }) : /* @__PURE__ */ jsxs("svg", { width: 328, height: 412, fill: "none", viewBox: "0 0 328 412", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#28313F",
        d: "M284.487 127.126h-8.876a21.346 21.346 0 0 1-15.102-6.261 21.384 21.384 0 0 1-6.256-15.114 21.382 21.382 0 0 1 5.971-14.815 21.346 21.346 0 0 1 14.565-6.536h6.709a22.968 22.968 0 0 0 15.777-6.982 23.007 23.007 0 0 0 0-32.004 22.968 22.968 0 0 0-15.777-6.982H46.203a22.97 22.97 0 0 0-15.777 6.982 23.005 23.005 0 0 0 0 32.004A22.97 22.97 0 0 0 46.203 84.4h2.282a21.35 21.35 0 0 1 14.566 6.536 21.382 21.382 0 0 1 5.97 14.815 21.38 21.38 0 0 1-6.256 15.114 21.347 21.347 0 0 1-15.102 6.261H39.77a18.246 18.246 0 0 0-12.908 5.35 18.277 18.277 0 0 0 0 25.836 18.247 18.247 0 0 0 12.908 5.351h244.718c4.841 0 9.484-1.925 12.907-5.351a18.274 18.274 0 0 0 0-25.836 18.245 18.245 0 0 0-12.907-5.35Zm-63.338 154.173-58.266-33.718c-5.65-3.27-12.881-1.336-16.149 4.32L92.847 345.13c-3.269 5.656-1.338 12.891 4.313 16.161l58.265 33.718c5.65 3.27 12.881 1.336 16.15-4.32l53.886-93.229c3.269-5.655 1.338-12.891-4.312-16.161Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#605CFF",
        stroke: "#605CFF",
        strokeMiterlimit: "10",
        strokeWidth: "2",
        d: "M120.657 257.357h74.157l20.901 22.082v100.934a8.316 8.316 0 0 1-5.143 7.686 8.31 8.31 0 0 1-3.186.626H120.68a8.312 8.312 0 0 1-8.306-8.312V265.67c0-2.201.872-4.312 2.425-5.87a8.301 8.301 0 0 1 5.858-2.443Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#4541C9",
        stroke: "#4541C9",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M194.814 257.357v14.387c0 2.204.876 4.319 2.433 5.877a8.302 8.302 0 0 0 5.873 2.435h12.595l-20.901-22.699Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#1A202C",
        d: "M183.496 409.671a261.315 261.315 0 0 0 3.834-36.103c0-6.668-3.217-10.505-6.047-10.505h-2.647a1.94 1.94 0 0 0-1.939 1.941v-.753a3.365 3.365 0 0 0-.95-2.433 3.345 3.345 0 0 0-2.404-1.015h-2.282a3.422 3.422 0 0 0-3.423 3.425v1.462a3.583 3.583 0 0 0-3.582-3.586h-2.282a3.773 3.773 0 0 0-2.662 1.104 3.76 3.76 0 0 0-1.103 2.664v.914a2.532 2.532 0 0 0-2.441-2.444h-3.149a3.357 3.357 0 0 0-3.354 3.311v3.7h-3.126a5.391 5.391 0 0 0-3.824 1.594 5.394 5.394 0 0 0-1.561 3.841v10.184a19.055 19.055 0 0 0 4.7 11.418 15.473 15.473 0 0 1 2.145 2.763 26.3 26.3 0 0 1 2.898 9.774h32.948l.251-1.256Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#605CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M176.697 365.004a1.94 1.94 0 0 1 1.939-1.941h2.647c2.83 0 6.047 3.837 6.047 10.505a261.315 261.315 0 0 1-3.834 36.103l-.25 1.256h-32.949a26.3 26.3 0 0 0-2.898-9.774 15.473 15.473 0 0 0-2.145-2.763 19.055 19.055 0 0 1-4.7-11.418v-10.184a5.393 5.393 0 0 1 3.314-5.021 5.391 5.391 0 0 1 2.071-.414h3.126m27.632-6.349v-.753a3.365 3.365 0 0 0-.95-2.433 3.345 3.345 0 0 0-2.404-1.015h-2.282a3.422 3.422 0 0 0-3.423 3.425v1.462m9.059-.686v9.707m-9.059-9.021a3.583 3.583 0 0 0-3.582-3.586h-2.282a3.773 3.773 0 0 0-2.662 1.104 3.76 3.76 0 0 0-1.103 2.664v.914m9.629-1.096v8.814m-9.629-7.718a2.532 2.532 0 0 0-2.441-2.444h-3.149a3.357 3.357 0 0 0-3.354 3.311v3.7m8.944-4.567v8.86m-8.944-4.293v12.285"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#28313F",
        d: "M234.996.57H73.812c-5.418 0-9.811 4.392-9.811 9.809 0 5.416 4.393 9.808 9.811 9.808h161.184c5.418 0 9.811-4.392 9.811-9.808 0-5.417-4.393-9.808-9.811-9.808Zm20.193 175.058H91.109c-8.935 0-16.178 7.244-16.178 16.179 0 8.936 7.243 16.179 16.177 16.179H255.19c8.935 0 16.178-7.243 16.178-16.179 0-8.935-7.243-16.179-16.178-16.179Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#364153",
        d: "M235.178 66.223v116.211c0 3.028-1.202 5.932-3.341 8.073a11.404 11.404 0 0 1-8.068 3.345H104.342a11.403 11.403 0 0 1-8.067-3.345 11.421 11.421 0 0 1-3.341-8.073V23.384a10.33 10.33 0 0 1 3.028-7.307 10.311 10.311 0 0 1 7.308-3.015h80.82"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#605CFF",
        strokeDasharray: "5 5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M235.178 66.223v116.211c0 3.028-1.202 5.932-3.341 8.073a11.404 11.404 0 0 1-8.068 3.345H104.342a11.403 11.403 0 0 1-8.067-3.345 11.421 11.421 0 0 1-3.341-8.073V23.384a10.33 10.33 0 0 1 3.028-7.307 10.311 10.311 0 0 1 7.308-3.015h80.82"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#1A202C",
        stroke: "#605CFF",
        strokeDasharray: "5 5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M185.234 13.701v37.533c0 4.332-.215 7.97 2.841 11.034 3.056 3.063 7.516 3.955 11.838 3.955h35.516l-50.195-52.522Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#605CFF",
        strokeLinecap: "round",
        strokeMiterlimit: "10",
        strokeWidth: "3",
        d: "M163.851 86.775v50.855m-25.784-25.416h51.157"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#364153",
        strokeMiterlimit: "10",
        strokeWidth: "2",
        d: "M201.956 344.201H127.73v-58.002h74.226v58.002Zm-49.788 0v-58.002m25.441 58.002v-58.002m-49.879 20.953h74.226m-74.226 18.712h74.226"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#605CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "m152.168 236.386 11.865-12.537 12.185 12.537"
      }
    )
  ] });
}, Upload2 = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { width: 467, height: 263, fill: "none", viewBox: "0 0 384 221", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#D2DFFA",
        d: "m240.009 29.375-50.47-27.54c-4.894-2.67-11.026-.864-13.696 4.035l-44.009 80.755c-2.67 4.899-.867 11.035 4.028 13.706l50.47 27.539c4.895 2.671 11.027.864 13.696-4.034l44.01-80.755c2.669-4.9.866-11.035-4.029-13.706Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#3A36DB",
        d: "m160.411 17.293-53.94 19.905c-5.231 1.93-7.903 7.738-5.969 12.97l31.886 86.265c1.934 5.233 7.743 7.91 12.973 5.98l53.94-19.906c5.23-1.93 7.903-7.737 5.969-12.97l-31.886-86.264c-1.934-5.233-7.743-7.91-12.973-5.98Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#D2DFFA",
        d: "M74.132 43.098 33.767 55.044a7.39 7.39 0 0 0-4.985 9.188l19.143 64.557a7.398 7.398 0 0 0 9.19 4.993l40.364-11.946a7.389 7.389 0 0 0 4.986-9.188L83.322 48.091a7.398 7.398 0 0 0-9.19-4.993Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#F1F4FA",
        stroke: "#3A36DB",
        strokeMiterlimit: "10",
        strokeWidth: "2",
        d: "m5.626 73.844 41.416-19.381 17.444 6.87 26.379 56.37a5.13 5.13 0 0 1-.864 5.637 5.114 5.114 0 0 1-1.615 1.182l-48.425 22.661a5.124 5.124 0 0 1-6.811-2.472L3.172 80.651a5.128 5.128 0 0 1 2.454-6.807Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#F1F4FA",
        stroke: "#3A36DB",
        strokeMiterlimit: "10",
        strokeWidth: "2",
        d: "m73.728 101.098-41.455 19.398-15.159-32.393 11.98-5.606 29.475-13.793 15.159 32.394Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#3A36DB",
        strokeMiterlimit: "10",
        strokeWidth: "2",
        d: "m45.922 114.11-15.16-32.394m29.368 25.745L44.97 75.067M22.59 99.805l41.455-19.399M27.48 110.255l41.455-19.398"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#D2DFFA",
        stroke: "#3A36DB",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "m47.042 54.462 3.76 8.035a5.127 5.127 0 0 0 6.81 2.472l7.035-3.292-17.605-7.215Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#F1F4FA",
        d: "m382.459 79.96-22.933 56.596a5.992 5.992 0 0 1-7.809 3.309l-58.162-23.567a6.001 6.001 0 0 1-3.303-7.812l31.387-77.46a5.422 5.422 0 0 1 7.071-2.986l39.36 15.949"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#3A36DB",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "m382.459 79.96-22.933 56.596a5.992 5.992 0 0 1-7.809 3.309l-58.162-23.567a6.001 6.001 0 0 1-3.303-7.812l31.387-77.46a5.422 5.422 0 0 1 7.071-2.986l39.36 15.949"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#D2DFFA",
        stroke: "#3A36DB",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "m368.502 44.526-7.407 18.279c-.855 2.11-1.678 3.839-.794 5.934.884 2.095 2.88 3.41 4.985 4.262l17.297 7.009-14.081-35.484Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#3A36DB",
        strokeLinecap: "round",
        strokeMiterlimit: "10",
        strokeWidth: "3",
        d: "M343.666 75.894 333.63 100.66m-7.54-17.465 24.914 10.095"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#BECDFA",
        d: "M1 172.523c0 24.503 18.96 44.536 43.042 46.33v.118h263.316c30.177 0 54.642-24.445 54.642-54.597 0-28.445-21.756-51.831-49.548-54.361C310.891 60.594 270.293 21 220.45 21c-39.686 0-73.513 25.092-86.437 60.244-7.361-3.706-15.633-5.765-24.436-5.765-29.058 0-52.816 22.62-54.553 51.213a45.53 45.53 0 0 0-7.567-.618c-25.672 0-46.486 20.798-46.486 46.449H1Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#F1F4FA", d: "M227.913 165.715H136l45.956 53.919 45.957-53.919Z" }),
    /* @__PURE__ */ jsx("path", { fill: "#F1F4FA", d: "M201.913 168h-38v-57h38z" })
  ] }) : /* @__PURE__ */ jsxs("svg", { width: 467, height: 263, viewBox: "0 0 467 263", fill: "none", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M287.009 44.3749L236.539 16.8357C231.645 14.165 225.513 15.9713 222.843 20.87L178.834 101.625C176.164 106.524 177.967 112.66 182.862 115.331L233.332 142.87C238.227 145.541 244.359 143.734 247.028 138.836L291.038 58.0806C293.707 53.1819 291.904 47.0456 287.009 44.3749Z",
        fill: "#605CFF",
        fillOpacity: "0.4"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M207.411 32.293L153.471 52.1983C148.24 54.1286 145.568 59.9357 147.502 65.1686L179.388 151.433C181.322 156.666 187.131 159.343 192.361 157.413L246.301 137.507C251.531 135.577 254.204 129.77 252.27 124.537L220.384 38.2729C218.45 33.0399 212.641 30.3626 207.411 32.293Z",
        fill: "#28313F"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M121.132 58.0976L80.7674 70.0434C76.853 71.2019 74.621 75.3157 75.7823 79.2319L94.9245 143.789C96.0858 147.705 100.2 149.941 104.115 148.782L144.479 136.836C148.394 135.678 150.626 131.564 149.465 127.648L130.322 63.0909C129.161 59.1747 125.046 56.9391 121.132 58.0976Z",
        fill: "#28313F"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M52.6259 88.8436L94.042 69.4626L111.486 76.3328L137.865 132.703C138.151 133.314 138.313 133.975 138.343 134.649C138.373 135.322 138.27 135.995 138.04 136.628C137.81 137.262 137.457 137.843 137.001 138.34C136.546 138.837 135.997 139.238 135.386 139.522L86.9611 162.183C85.7309 162.759 84.3221 162.822 83.0448 162.358C81.7675 161.895 80.7263 160.943 80.1501 159.711L50.1724 95.6505C49.5973 94.4215 49.5326 93.0148 49.9925 91.7388C50.4524 90.4628 51.3994 89.4216 52.6259 88.8436Z",
        fill: "#28313F",
        stroke: "#605CFF",
        strokeWidth: "2",
        strokeMiterlimit: "10"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M120.728 116.098L79.2732 135.496L64.1143 103.103L76.0931 97.4969L105.569 83.7037L120.728 116.098Z",
        fill: "#28313F",
        stroke: "#605CFF",
        strokeWidth: "2",
        strokeMiterlimit: "10"
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M92.9216 129.11L77.7627 96.7158", stroke: "#605CFF", strokeWidth: "2", strokeMiterlimit: "10" }),
    /* @__PURE__ */ jsx("path", { d: "M107.13 122.461L91.9707 90.0667", stroke: "#605CFF", strokeWidth: "2", strokeMiterlimit: "10" }),
    /* @__PURE__ */ jsx("path", { d: "M69.5908 114.805L111.045 95.4061", stroke: "#605CFF", strokeWidth: "2", strokeMiterlimit: "10" }),
    /* @__PURE__ */ jsx("path", { d: "M74.4805 125.255L115.935 105.857", stroke: "#605CFF", strokeWidth: "2", strokeMiterlimit: "10" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M94.042 69.4624L97.8019 77.4971C98.378 78.7284 99.4193 79.6804 100.697 80.144C101.974 80.6075 103.383 80.5445 104.613 79.9688L111.647 76.677L94.042 69.4624Z",
        fill: "#605CFF",
        fillOpacity: "0.4",
        stroke: "#605CFF",
        strokeWidth: "2",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M429.459 94.9604L406.526 151.556C405.929 153.031 404.77 154.208 403.306 154.829C401.841 155.449 400.191 155.463 398.717 154.865L340.555 131.298C339.081 130.701 337.905 129.542 337.286 128.077C336.667 126.612 336.654 124.96 337.252 123.486L368.639 46.0268C368.907 45.3657 369.302 44.7639 369.803 44.2559C370.303 43.7479 370.899 43.3435 371.556 43.0661C372.213 42.7886 372.918 42.6435 373.63 42.639C374.343 42.6345 375.05 42.7707 375.71 43.0398L415.07 58.9888",
        fill: "#28313F"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M429.459 94.9604L406.526 151.556C405.929 153.031 404.77 154.208 403.306 154.829C401.841 155.449 400.191 155.463 398.717 154.865L340.555 131.298C339.081 130.701 337.905 129.542 337.286 128.077C336.667 126.612 336.654 124.96 337.252 123.486L368.639 46.0268C368.907 45.3657 369.302 44.7639 369.803 44.2559C370.303 43.7479 370.899 43.3435 371.556 43.0661C372.213 42.7886 372.918 42.6435 373.63 42.639C374.343 42.6345 375.05 42.7707 375.71 43.0398L415.07 58.9888",
        stroke: "#605CFF",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M415.502 59.5258L408.095 77.8049C407.24 79.9146 406.417 81.6441 407.301 83.7391C408.185 85.8341 410.181 87.1484 412.286 88.0014L429.583 95.0101L415.502 59.5258Z",
        fill: "#605CFF",
        fillOpacity: "0.4",
        stroke: "#605CFF",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M390.666 90.8939L380.63 115.661",
        stroke: "#605CFF",
        strokeWidth: "3",
        strokeMiterlimit: "10",
        strokeLinecap: "round"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M373.09 98.1949L398.004 108.29",
        stroke: "#605CFF",
        strokeWidth: "3",
        strokeMiterlimit: "10",
        strokeLinecap: "round"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M48.0001 189.523C48.0001 214.026 66.9599 234.059 91.0422 235.853V235.971H354.358C384.535 235.971 409 211.526 409 181.374C409 152.929 387.244 129.543 359.452 127.013C357.891 77.5941 317.293 38 267.45 38C227.764 38 193.937 63.092 181.013 98.2442C173.652 94.5378 165.38 92.4787 156.577 92.4787C127.519 92.4787 103.761 115.1 102.024 143.692C99.58 143.28 97.0481 143.074 94.4573 143.074C68.7852 143.074 47.9707 163.872 47.9707 189.523H48.0001Z",
        fill: "#4541C9"
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M274.914 182.714L183.001 182.714L228.957 236.634L274.914 182.714Z", fill: "#364153" }),
    /* @__PURE__ */ jsx("rect", { x: "248.914", y: "185", width: "38", height: "57", transform: "rotate(-180 248.914 185)", fill: "#364153" })
  ] });
}, Import = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { width: 467, height: 263, fill: "none", viewBox: "0 0 361 220", children: [
    /* @__PURE__ */ jsx("path", { fill: "#BECDFA", d: "M171.39 189.939h37.22v15.27h-37.22z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#BECDFA",
        d: "M75 58.664a8 8 0 0 1 8-8h214a8 8 0 0 1 8 8V182.41a8 8 0 0 1-8 8H83a8 8 0 0 1-8-8V58.664Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "rect",
      {
        width: "210.821",
        height: "120.157",
        x: "84.804",
        y: "60.192",
        fill: "#BECDFA",
        stroke: "#fff",
        strokeWidth: "2",
        rx: "4"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#BECDFA", d: "M138.941 205.209h102.116v14.315H138.941z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#F1F4FA",
        d: "m276.474 53.866-25.196 51.493a5.63 5.63 0 0 1-7.531 2.586l-52.918-25.893a5.636 5.636 0 0 1-2.58-7.533l34.484-70.475a5.092 5.092 0 0 1 6.818-2.332l35.811 17.522"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#3A36DB",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "m276.474 53.866-25.196 51.493a5.63 5.63 0 0 1-7.531 2.586l-52.918-25.893a5.621 5.621 0 0 1-2.849-3.23 5.636 5.636 0 0 1 .269-4.303l34.484-70.475a5.092 5.092 0 0 1 6.818-2.332l35.811 17.522"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#605CFF",
        fillOpacity: ".4",
        stroke: "#3A36DB",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "m265.732 19.766-8.138 16.63c-.939 1.92-1.823 3.486-1.133 5.506s2.473 3.382 4.388 4.319l15.737 7.7-10.854-34.155Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#D2DFFA",
        d: "m136.626 25.308-29.263 26.557a6.937 6.937 0 0 0-.47 9.803l42.507 46.787a6.946 6.946 0 0 0 9.807.476l29.263-26.558a6.937 6.937 0 0 0 .47-9.802l-42.506-46.788a6.946 6.946 0 0 0-9.808-.475Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#D2DFFA",
        stroke: "#3A36DB",
        strokeMiterlimit: "10",
        strokeWidth: "2",
        d: "m129.973 36.319 37.612-20.69 16.762 5.368 28.16 51.193a4.818 4.818 0 0 1-.464 5.333 4.801 4.801 0 0 1-1.441 1.206l-43.976 24.192a4.809 4.809 0 0 1-6.532-1.899l-32.002-58.177a4.812 4.812 0 0 1 1.881-6.526Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#D2DFFA",
        stroke: "#3A36DB",
        strokeMiterlimit: "10",
        strokeWidth: "2",
        d: "m195.436 57.682-37.647 20.71-16.183-29.42 10.879-5.983 26.768-14.725 16.183 29.418Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#3A36DB",
        strokeMiterlimit: "10",
        strokeWidth: "2",
        d: "m170.185 71.573-16.183-29.418m29.085 22.32-16.183-29.418M147.454 59.6l37.647-20.709m-32.426 30.2 37.646-20.709"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#605CFF",
        fillOpacity: ".4",
        stroke: "#3A36DB",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "m167.586 15.628 4.014 7.297a4.806 4.806 0 0 0 6.531 1.899l6.389-3.514-16.934-5.682Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M213 133h-47l23.5 27 23.5-27Z" }),
    /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M199 134h-18v-23h18zm14 34h-46v-3h46z" })
  ] }) : /* @__PURE__ */ jsxs("svg", { width: 467, height: 263, fill: "none", viewBox: "0 0 467 263", children: [
    /* @__PURE__ */ jsx("path", { fill: "#364153", d: "M183 185.92h91.913L228.957 132 183 185.92Z" }),
    /* @__PURE__ */ jsx("path", { fill: "#364153", d: "M209 183.634h38v57h-38z" }),
    /* @__PURE__ */ jsx("path", { fill: "#28313F", d: "M221.676 209.891h39.647v16.266h-39.647z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#4541C9",
        d: "M119 69.532a8 8 0 0 1 8-8h229a8 8 0 0 1 8 8v132.86a8 8 0 0 1-8 8H127a8 8 0 0 1-8-8V69.532Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "rect",
      {
        width: "224.701",
        height: "128.124",
        x: "129.378",
        y: "71.617",
        fill: "#4541C9",
        stroke: "#364153",
        strokeWidth: "2",
        rx: "4"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#4541C9", d: "M187.111 226.156h108.776v15.249H187.111z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#28313F",
        d: "m333.616 64.943-26.839 54.852a5.994 5.994 0 0 1-8.022 2.754l-56.369-27.582a5.993 5.993 0 0 1-2.748-8.023l36.732-75.072a5.434 5.434 0 0 1 3.117-2.75 5.422 5.422 0 0 1 4.146.265l38.147 18.665"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#605CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "m333.616 64.943-26.839 54.852a5.994 5.994 0 0 1-8.022 2.754l-56.369-27.582a5.993 5.993 0 0 1-2.748-8.023l36.732-75.072a5.434 5.434 0 0 1 3.117-2.75 5.422 5.422 0 0 1 4.146.265l38.147 18.665"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#605CFF",
        fillOpacity: ".4",
        stroke: "#605CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "m322.171 28.618-8.668 17.716c-1 2.045-1.942 3.712-1.207 5.864.735 2.152 2.634 3.603 4.674 4.601l16.764 8.202-11.563-36.383Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#28313F",
        d: "m184.645 34.522-31.171 28.29a7.39 7.39 0 0 0-.501 10.442l45.279 49.839a7.398 7.398 0 0 0 10.447.506l31.171-28.29a7.39 7.39 0 0 0 .501-10.441l-45.279-49.839a7.399 7.399 0 0 0-10.447-.507Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#28313F",
        stroke: "#605CFF",
        strokeMiterlimit: "10",
        strokeWidth: "2",
        d: "m177.558 46.251 40.065-22.04 17.855 5.72 29.997 54.53a5.13 5.13 0 0 1-.495 5.681 5.108 5.108 0 0 1-1.535 1.285l-46.844 25.77a5.125 5.125 0 0 1-6.958-2.023l-34.09-61.97a5.126 5.126 0 0 1 2.005-6.953Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#28313F",
        stroke: "#605CFF",
        strokeMiterlimit: "10",
        strokeWidth: "2",
        d: "m247.291 69.008-40.102 22.06-17.238-31.337 11.588-6.375 28.514-15.685 17.238 31.337Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#605CFF",
        strokeMiterlimit: "10",
        strokeWidth: "2",
        d: "m220.392 83.805-17.238-31.337m30.983 23.776-17.239-31.337m-20.719 26.144 40.101-22.06M201.739 81.16l40.102-22.059"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#605CFF",
        fillOpacity: ".4",
        stroke: "#605CFF",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "m217.623 24.212 4.276 7.772a5.126 5.126 0 0 0 6.957 2.023l6.805-3.744-18.038-6.051Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#28313F", d: "M266 149h-49l24.5 29 24.5-29Z" }),
    /* @__PURE__ */ jsx("path", { fill: "#28313F", d: "M251 150h-19v-24h19zm15 37h-48v-4h48z" })
  ] });
}, AddPhoto = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { height: 263, width: 467, fill: "none", viewBox: "0 0 467 263", children: [
    /* @__PURE__ */ jsx("rect", { width: "157.591", height: "157.591", x: "95", y: "59", fill: "#6562F5", rx: "16", transform: "rotate(-15.21 95 59)" }),
    /* @__PURE__ */ jsx(
      "rect",
      {
        width: "135.201",
        height: "135.201",
        x: "108.739",
        y: "66.866",
        fill: "#D2DFFA",
        rx: "8",
        transform: "rotate(-15.21 108.739 66.866)"
      }
    ),
    /* @__PURE__ */ jsx(
      "rect",
      {
        width: "157.591",
        height: "157.591",
        x: "226.215",
        y: "8",
        fill: "#6562F5",
        rx: "16",
        transform: "rotate(22.07 226.215 8)"
      }
    ),
    /* @__PURE__ */ jsx(
      "rect",
      {
        width: "135.201",
        height: "135.201",
        x: "232.383",
        y: "22.581",
        fill: "#D2DFFA",
        rx: "8",
        transform: "rotate(22.07 232.383 22.581)"
      }
    ),
    /* @__PURE__ */ jsx("rect", { width: "157.591", height: "157.591", x: "150.696", y: "57.871", fill: "#6562F5", rx: "16" }),
    /* @__PURE__ */ jsx("rect", { width: "135.201", height: "135.201", x: "161.892", y: "69.066", fill: "#D2DFFA", rx: "8" }),
    /* @__PURE__ */ jsx("mask", { id: "a", width: "137", height: "136", x: "161", y: "69", maskUnits: "userSpaceOnUse", children: /* @__PURE__ */ jsx("rect", { width: "135.201", height: "135.201", x: "161.892", y: "69.066", fill: "#28313F", rx: "8" }) }),
    /* @__PURE__ */ jsxs("g", { mask: "url(#a)", children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#3A36DB",
          fillOpacity: ".2",
          d: "m266.868 142.696-23.167 33.192v29.671l71.906 5.597 13.348-25.834-29.203-42.505c-7.911-11.514-24.889-11.576-32.884-.121Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#6562F5",
          d: "m206.566 124.247-47.689 67.533v15.071h137.784l-57.335-82.483c-7.921-11.394-24.755-11.457-32.76-.121Z"
        }
      ),
      /* @__PURE__ */ jsx("circle", { cx: "260.924", cy: "96.623", r: "18.084", fill: "#6562F5" })
    ] }),
    /* @__PURE__ */ jsx("circle", { cx: "229.921", cy: "201.684", r: "37.891", fill: "#BECDFA" }),
    /* @__PURE__ */ jsx("rect", { width: "6.889", height: "43.057", x: "226.476", y: "180.155", fill: "#6562F5", rx: "3.445" }),
    /* @__PURE__ */ jsx(
      "rect",
      {
        width: "6.889",
        height: "43.057",
        x: "208.392",
        y: "205.128",
        fill: "#6562F5",
        rx: "3.445",
        transform: "rotate(-90 208.392 205.128)"
      }
    )
  ] }) : /* @__PURE__ */ jsxs("svg", { height: 263, width: 467, fill: "none", viewBox: "0 0 278 232", children: [
    /* @__PURE__ */ jsx("rect", { width: "157.591", height: "157.591", y: "51", fill: "#605CFF", rx: "16", transform: "rotate(-15.21 0 51)" }),
    /* @__PURE__ */ jsx(
      "rect",
      {
        width: "135.201",
        height: "135.201",
        x: "13.739",
        y: "58.866",
        fill: "#28313F",
        rx: "8",
        transform: "rotate(-15.21 13.74 58.866)"
      }
    ),
    /* @__PURE__ */ jsx("rect", { width: "157.591", height: "157.591", x: "131.215", fill: "#605CFF", rx: "16", transform: "rotate(22.07 131.215 0)" }),
    /* @__PURE__ */ jsx(
      "rect",
      {
        width: "135.201",
        height: "135.201",
        x: "137.383",
        y: "14.581",
        fill: "#28313F",
        rx: "8",
        transform: "rotate(22.07 137.383 14.581)"
      }
    ),
    /* @__PURE__ */ jsx("rect", { width: "157.591", height: "157.591", x: "55.696", y: "49.871", fill: "#605CFF", rx: "16" }),
    /* @__PURE__ */ jsx("rect", { width: "135.201", height: "135.201", x: "66.892", y: "61.066", fill: "#28313F", rx: "8" }),
    /* @__PURE__ */ jsx("mask", { id: "a", width: "137", height: "136", x: "66", y: "61", maskUnits: "userSpaceOnUse", children: /* @__PURE__ */ jsx("rect", { width: "135.201", height: "135.201", x: "66.892", y: "61.066", fill: "#28313F", rx: "8" }) }),
    /* @__PURE__ */ jsxs("g", { fill: "#605CFF", mask: "url(#a)", children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillOpacity: ".4",
          d: "m171.868 134.696-23.167 33.192v29.671l71.906 5.597 13.348-25.834-29.203-42.505c-7.911-11.514-24.889-11.576-32.884-.121Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M111.566 116.247 63.877 183.78v15.071h137.784l-57.335-82.483c-7.921-11.394-24.755-11.457-32.76-.121Z" }),
      /* @__PURE__ */ jsx("circle", { cx: "165.924", cy: "88.623", r: "18.084" })
    ] }),
    /* @__PURE__ */ jsx("circle", { cx: "134.921", cy: "193.684", r: "37.891", fill: "#1A202C" }),
    /* @__PURE__ */ jsx("rect", { width: "6.889", height: "43.057", x: "131.476", y: "172.155", fill: "#605CFF", rx: "3.445" }),
    /* @__PURE__ */ jsx(
      "rect",
      {
        width: "6.889",
        height: "43.057",
        x: "113.392",
        y: "197.128",
        fill: "#605CFF",
        rx: "3.445",
        transform: "rotate(-90 113.392 197.128)"
      }
    )
  ] });
}, NoResult = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { height: 263, width: 467, fill: "none", viewBox: "0 0 262 252", children: [
    /* @__PURE__ */ jsx("circle", { cx: "126", cy: "126", r: "126", fill: "#D2DFFA" }),
    /* @__PURE__ */ jsx("path", { fill: "#3A36DB", d: "M129.5 72H227v119c0 11.046-8.954 20-20 20H80.5c-11.046 0-20-8.954-20-20V61h61l8 11Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#7471FF",
        d: "M111 95c0 23.372-17.43 42.672-40 45.612.5 4.388 1 6.888 6 10.888-27.5 0-58-22-58-56.5 0-25.405 20.595-46 46-46s46 20.595 46 46Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#6562F5", d: "M95 93.5h167V191c0 11.046-8.954 20-20 20H78c9.389 0 17-7.611 17-17V93.5Z" }),
    /* @__PURE__ */ jsx("circle", { cx: "206", cy: "154", r: "8", fill: "#28313F" }),
    /* @__PURE__ */ jsx("circle", { cx: "151", cy: "154", r: "8", fill: "#28313F" }),
    /* @__PURE__ */ jsx("path", { fill: "#28313F", d: "M171 187a4 4 0 0 1 4-4h7a4 4 0 0 1 4 4h-15Z" })
  ] }) : /* @__PURE__ */ jsxs("svg", { height: 263, width: 467, fill: "none", viewBox: "0 0 262 252", children: [
    /* @__PURE__ */ jsx("circle", { cx: "126", cy: "126", r: "126", fill: "#28313F" }),
    /* @__PURE__ */ jsx("path", { fill: "#4541C9", d: "M129.5 72H227v119c0 11.046-8.954 20-20 20H80.5c-11.046 0-20-8.954-20-20V61h61l8 11Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#7471FF",
        d: "M111 95c0 23.372-17.43 42.672-40 45.612.5 4.388 1 6.888 6 10.888-27.5 0-58-22-58-56.5 0-25.405 20.595-46 46-46s46 20.595 46 46Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#605CFF", d: "M95 93.5h167V191c0 11.046-8.954 20-20 20H78c9.389 0 17-7.611 17-17V93.5Z" }),
    /* @__PURE__ */ jsx("circle", { cx: "206", cy: "154", r: "8", fill: "#28313F" }),
    /* @__PURE__ */ jsx("circle", { cx: "151", cy: "154", r: "8", fill: "#28313F" }),
    /* @__PURE__ */ jsx("path", { fill: "#28313F", d: "M171 187a4 4 0 0 1 4-4h7a4 4 0 0 1 4 4h-15Z" })
  ] });
}, Delete = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#D2DFFA",
        d: "M57.81 43.462h-1.95a4.71 4.71 0 0 1-3.32-1.364 4.641 4.641 0 0 1-1.376-3.295 4.64 4.64 0 0 1 1.313-3.23 4.712 4.712 0 0 1 3.202-1.425h1.474a5.069 5.069 0 0 0 3.469-1.522 4.993 4.993 0 0 0 1.423-3.488c0-1.302-.51-2.553-1.423-3.489a5.069 5.069 0 0 0-3.469-1.521H5.427a5.07 5.07 0 0 0-3.468 1.521 4.993 4.993 0 0 0-1.424 3.489c0 1.302.51 2.553 1.424 3.488a5.07 5.07 0 0 0 3.468 1.522h.502a4.712 4.712 0 0 1 3.202 1.425 4.64 4.64 0 0 1 1.313 3.23c0 1.236-.495 2.42-1.376 3.295a4.713 4.713 0 0 1-3.32 1.364H4.013a4.03 4.03 0 0 0-2.838 1.167A3.968 3.968 0 0 0 0 47.445c0 1.056.423 2.07 1.175 2.816a4.028 4.028 0 0 0 2.838 1.166H57.81c1.065 0 2.085-.42 2.838-1.166a3.967 3.967 0 0 0 1.175-2.816c0-1.056-.422-2.07-1.175-2.816a4.029 4.029 0 0 0-2.838-1.166ZM19.027 58.873a4.964 4.964 0 0 1 4.964-4.964h27.3a4.964 4.964 0 0 1 0 9.928h-27.3a4.964 4.964 0 0 1-4.964-4.964ZM5.79 15.855a4.964 4.964 0 0 1 4.965-4.964h19.027a4.964 4.964 0 1 1 0 9.927H10.755a4.964 4.964 0 0 1-4.964-4.963Zm41.364 0a4.964 4.964 0 1 1 9.928 0 4.964 4.964 0 0 1-9.928 0ZM6.62 58.873a4.964 4.964 0 1 1 9.926 0 4.964 4.964 0 0 1-9.927 0Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#6562F5",
        d: "M42.522 62.09c0 1.422-5.418 2.574-12.101 2.574-6.684 0-12.102-1.152-12.102-2.574 0-.644-2.887-22.038-3.756-30.384h31.715s-3.756 28.963-3.756 30.384Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#3A36DB",
        d: "M46.278 31.706c0 1.421-7.1 2.573-15.858 2.573-8.758 0-15.858-1.152-15.858-2.573s7.1-2.573 15.858-2.573c8.758 0 15.858 1.152 15.858 2.573Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#3A36DB",
        fillRule: "evenodd",
        d: "M22.183 40.152a.948.948 0 0 1 1.043.844l2.017 19.092a.948.948 0 0 1-1.887.199L21.34 41.195a.948.948 0 0 1 .844-1.043Zm16.892 0a.948.948 0 0 0-1.043.844l-2.017 19.092a.948.948 0 0 0 1.886.199l2.017-19.092a.948.948 0 0 0-.843-1.043Zm-8.655-.388c.523 0 .947.425.947.949v19.996a.948.948 0 0 1-1.896 0V40.713c0-.524.424-.949.948-.949Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#EB5757",
        d: "M30.464 13.702a2 2 0 0 1 2.566-1.19l10.874 3.98a2 2 0 0 1 1.19 2.566L40.038 32.87a2 2 0 0 1-2.566 1.19l-10.874-3.98a2 2 0 0 1-1.19-2.566l5.056-13.813Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#974146",
        d: "m31.993 16.205 10.385 3.802-1.052 2.873-10.385-3.801 1.052-2.874Zm-1.435 3.919 4.963 1.817-.745 2.036-4.964-1.818.745-2.035Zm-1.144 2.909 4.964 1.817-.745 2.035-4.964-1.817.745-2.035Zm6.696-.877 4.833 1.77-.745 2.035-4.833-1.77.745-2.035Zm-1.145 2.909 4.833 1.77-.745 2.035-4.833-1.77.745-2.035Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#3A36DB",
        d: "M34.06 2.504c1.171.807-1.91 7.306-6.882 14.516-4.97 7.21-9.95 12.402-11.12 11.595-1.17-.807-1.492-1.038-1.492-1.038S30.964 3.293 32.51 1.461c.487.313.78.511 1.55 1.043Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#7471FF",
        d: "M32.53 1.46c1.17.807-1.912 7.307-6.883 14.517-4.971 7.21-9.95 12.401-11.12 11.595-1.17-.807 1.912-7.306 6.883-14.516S31.36.654 32.53 1.46Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#3A36DB",
        d: "M23.676 14.328c-1.078 1.495-2.126 2.743-3.621 1.665a3.338 3.338 0 1 1 3.904-5.417c1.496 1.078.795 2.256-.283 3.752Z"
      }
    )
  ] }) : /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 63 65", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#28313F",
        d: "M57.81 43.462h-1.95a4.71 4.71 0 0 1-3.32-1.364 4.642 4.642 0 0 1-1.376-3.295 4.64 4.64 0 0 1 1.313-3.23 4.711 4.711 0 0 1 3.202-1.425h1.474a5.069 5.069 0 0 0 3.469-1.522 4.993 4.993 0 0 0 1.423-3.488c0-1.302-.51-2.553-1.423-3.488a5.069 5.069 0 0 0-3.469-1.522H5.427A5.069 5.069 0 0 0 1.96 25.65a4.993 4.993 0 0 0-1.424 3.488c0 1.302.51 2.553 1.424 3.488a5.07 5.07 0 0 0 3.468 1.523h.502a4.711 4.711 0 0 1 3.202 1.424 4.64 4.64 0 0 1 1.313 3.23c0 1.236-.495 2.42-1.376 3.295a4.713 4.713 0 0 1-3.32 1.364H4.013a4.03 4.03 0 0 0-2.838 1.167A3.967 3.967 0 0 0 0 47.445c0 1.056.423 2.07 1.175 2.816a4.029 4.029 0 0 0 2.838 1.166H57.81c1.065 0 2.085-.42 2.838-1.166a3.968 3.968 0 0 0 1.175-2.816c0-1.056-.422-2.07-1.175-2.816a4.029 4.029 0 0 0-2.838-1.166Z"
      }
    ),
    /* @__PURE__ */ jsx("rect", { width: "37.227", height: "9.927", x: "19.027", y: "53.909", fill: "#28313F", rx: "4.964" }),
    /* @__PURE__ */ jsx("rect", { width: "28.954", height: "9.927", x: "5.791", y: "10.891", fill: "#28313F", rx: "4.964" }),
    /* @__PURE__ */ jsx("rect", { width: "9.927", height: "9.927", x: "47.154", y: "10.891", fill: "#28313F", rx: "4.964" }),
    /* @__PURE__ */ jsx("rect", { width: "9.927", height: "9.927", x: "6.619", y: "53.909", fill: "#28313F", rx: "4.964" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#605CFF",
        d: "M42.522 62.09c0 1.422-5.418 2.574-12.101 2.574-6.684 0-12.102-1.152-12.102-2.574 0-.644-2.887-22.038-3.756-30.384h31.715s-3.756 28.963-3.756 30.384Z"
      }
    ),
    /* @__PURE__ */ jsx("ellipse", { cx: "30.42", cy: "31.706", fill: "#4541C9", rx: "15.858", ry: "2.573" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#4541C9",
        fillRule: "evenodd",
        d: "M22.183 40.152a.948.948 0 0 1 1.043.844l2.017 19.092a.948.948 0 1 1-1.887.199L21.34 41.195a.948.948 0 0 1 .844-1.043Zm16.892 0a.948.948 0 0 0-1.043.844l-2.017 19.092a.948.948 0 1 0 1.886.199l2.017-19.092a.948.948 0 0 0-.843-1.043Zm-8.655-.388c.523 0 .947.425.947.949v19.996a.948.948 0 1 1-1.896 0V40.713c0-.524.424-.949.948-.949Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ jsx(
      "rect",
      {
        width: "15.579",
        height: "18.709",
        x: "31.15",
        y: "11.824",
        fill: "#EB5757",
        rx: "2",
        transform: "rotate(20.107 31.15 11.824)"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#1A202C",
        d: "m31.992 16.205 10.385 3.802-1.052 2.873-10.385-3.802zm-1.435 3.919 4.964 1.817-.746 2.036-4.963-1.817zm-1.145 2.909 4.964 1.817-.746 2.036-4.963-1.817zm6.695-.877 4.833 1.77-.745 2.035-4.833-1.77zm-1.144 2.909 4.833 1.77-.745 2.035-4.833-1.77z",
        opacity: ".4"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#4541C9",
        d: "M34.06 2.504c1.17.807-1.911 7.306-6.882 14.516-4.972 7.21-9.95 12.402-11.12 11.595-1.17-.807-1.493-1.038-1.493-1.038S30.963 3.293 32.509 1.461c.487.313.78.512 1.551 1.043Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "ellipse",
      {
        cx: "23.528",
        cy: "14.516",
        fill: "#605CFF",
        rx: "15.858",
        ry: "2.573",
        transform: "rotate(-55.416 23.528 14.516)"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#4541C9",
        d: "M23.675 14.328c-1.078 1.495-2.125 2.743-3.621 1.665a3.338 3.338 0 1 1 3.904-5.417c1.496 1.078.796 2.256-.283 3.752Z"
      }
    )
  ] });
}, Archive = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#D2DFFA",
        d: "M64.748 42.635h-2.186c-1.394 0-2.732-.49-3.718-1.365-.986-.874-1.54-2.059-1.54-3.295 0-1.204.527-2.362 1.47-3.23.943-.867 2.228-1.378 3.586-1.424h1.652c1.469-.041 2.862-.587 3.884-1.522 1.023-.935 1.595-2.186 1.595-3.489 0-1.302-.572-2.553-1.595-3.488-1.022-.935-2.415-1.481-3.884-1.522H6.079c-1.47.041-2.862.587-3.885 1.522C1.171 25.757.6 27.008.6 28.31c0 1.303.571 2.554 1.594 3.489 1.023.935 2.416 1.48 3.885 1.522h.562c1.358.046 2.643.557 3.586 1.425.942.867 1.47 2.025 1.47 3.23 0 1.235-.554 2.42-1.54 3.294-.987.874-2.324 1.365-3.719 1.365H4.494c-1.192 0-2.335.42-3.178 1.166C.474 44.548 0 45.561 0 46.617c0 1.057.474 2.07 1.316 2.817.843.746 1.986 1.166 3.178 1.166h60.254c1.192 0 2.335-.42 3.178-1.166.843-.747 1.316-1.76 1.316-2.816 0-1.057-.473-2.07-1.316-2.817-.843-.746-1.986-1.166-3.178-1.166Zm-45.721 15.41a4.964 4.964 0 0 1 4.964-4.963H63.7a4.964 4.964 0 0 1 0 9.927H23.99a4.964 4.964 0 0 1-4.963-4.964ZM5.79 15.027a4.964 4.964 0 0 1 4.965-4.963h39.709a4.964 4.964 0 1 1 0 9.927h-39.71a4.964 4.964 0 0 1-4.963-4.964Zm52.946 0a4.964 4.964 0 1 1 9.928 0 4.964 4.964 0 0 1-9.928 0ZM3.309 58.046a4.964 4.964 0 1 1 9.927 0 4.964 4.964 0 0 1-9.927 0Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#EB5757",
        d: "M37.498 17.605a2 2 0 0 1 2.566-1.19l15.214 5.57a2 2 0 0 1 1.191 2.565l-6.965 19.026a2 2 0 0 1-2.566 1.19l-15.215-5.57a2 2 0 0 1-1.19-2.565l6.965-19.026Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#974146",
        d: "m39.275 21.408 13.466 4.93-1.364 3.726-13.466-4.93 1.364-3.726Zm-1.861 5.082 6.436 2.356-.966 2.64-6.437-2.356.967-2.64Zm-1.483 3.772 6.437 2.356-.966 2.64-6.437-2.356.966-2.64Zm8.684-1.137 6.267 2.295-.966 2.64-6.267-2.295.966-2.64Zm-1.485 3.773 6.268 2.294-.966 2.64-6.268-2.295.967-2.64Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#6562F5", d: "M10.8 57.49V37.87H53v19.62a8 8 0 0 1-8 8H18.8a8 8 0 0 1-8-8Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#3A36DB",
        d: "M24.61 43.24a2.302 2.302 0 0 1 2.303-2.3h10.741a2.302 2.302 0 1 1 0 4.602H26.913a2.302 2.302 0 0 1-2.302-2.301Zm-3.068 11.208a2 2 0 0 1 2-2h16.716a2 2 0 0 1 2 2v5.207a2 2 0 0 1-2 2H23.542a2 2 0 0 1-2-2v-5.207Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#6562F5",
        d: "M27.681 57.051c0-.847.687-1.534 1.535-1.534h5.37a1.535 1.535 0 0 1 0 3.069h-5.37a1.534 1.534 0 0 1-1.535-1.535ZM3.603 37.984a4 4 0 0 1 .106-5.656l29.608-28.51a4 4 0 0 1 5.656.106L43.65 8.78 8.28 42.84l-4.676-4.856Z"
      }
    )
  ] }) : /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#28313F",
        d: "M64.748 42.635h-2.186c-1.394 0-2.732-.49-3.718-1.365-.986-.874-1.54-2.059-1.54-3.295 0-1.204.527-2.361 1.47-3.23.943-.867 2.228-1.378 3.586-1.424h1.652c1.469-.041 2.862-.587 3.884-1.522 1.023-.935 1.595-2.186 1.595-3.488 0-1.303-.572-2.554-1.595-3.489-1.022-.935-2.415-1.481-3.884-1.522H6.079c-1.47.041-2.862.587-3.885 1.522C1.171 25.757.6 27.008.6 28.311c0 1.302.571 2.553 1.594 3.488 1.023.935 2.416 1.48 3.885 1.522h.562c1.358.046 2.643.557 3.586 1.425.942.867 1.47 2.025 1.47 3.23 0 1.235-.554 2.42-1.54 3.294-.987.874-2.324 1.365-3.719 1.365H4.494c-1.192 0-2.335.42-3.178 1.166C.474 44.548 0 45.561 0 46.617c0 1.057.474 2.07 1.316 2.817.843.746 1.986 1.166 3.178 1.166h60.254c1.192 0 2.335-.42 3.178-1.166.843-.747 1.316-1.76 1.316-2.816 0-1.057-.473-2.07-1.316-2.817-.843-.746-1.986-1.166-3.178-1.166Z"
      }
    ),
    /* @__PURE__ */ jsx("rect", { width: "49.636", height: "9.927", x: "19.027", y: "53.082", fill: "#28313F", rx: "4.964" }),
    /* @__PURE__ */ jsx("rect", { width: "49.636", height: "9.927", x: "5.791", y: "10.064", fill: "#28313F", rx: "4.964" }),
    /* @__PURE__ */ jsx("rect", { width: "9.927", height: "9.927", x: "58.736", y: "10.064", fill: "#28313F", rx: "4.964" }),
    /* @__PURE__ */ jsx("rect", { width: "9.927", height: "9.927", x: "3.309", y: "53.082", fill: "#28313F", rx: "4.964" }),
    /* @__PURE__ */ jsx(
      "rect",
      {
        width: "20.202",
        height: "24.261",
        x: "38.185",
        y: "15.727",
        fill: "#EB5757",
        rx: "2",
        transform: "rotate(20.107 38.185 15.727)"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#1A202C",
        d: "m39.275 21.408 13.466 4.93-1.364 3.726-13.466-4.93zm-1.861 5.082 6.436 2.356-.966 2.64-6.436-2.356zm-1.482 3.772 6.436 2.356-.966 2.64-6.436-2.356zm8.683-1.137 6.267 2.294-.966 2.64-6.267-2.294zm-1.485 3.773 6.268 2.294-.966 2.64-6.268-2.294z",
        opacity: ".4"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#605CFF", d: "M10.8 57.49V37.87H53v19.62a8 8 0 0 1-8 8H18.8a8 8 0 0 1-8-8Z" }),
    /* @__PURE__ */ jsx("rect", { width: "15.345", height: "4.603", x: "24.611", y: "40.939", fill: "#4541C9", rx: "2.302" }),
    /* @__PURE__ */ jsx("rect", { width: "20.715", height: "9.207", x: "21.543", y: "52.448", fill: "#4541C9", rx: "2" }),
    /* @__PURE__ */ jsx("rect", { width: "8.44", height: "3.069", x: "27.682", y: "55.517", fill: "#605CFF", rx: "1.534" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#4541C9",
        d: "M3.603 37.984a4 4 0 0 1 .106-5.656l29.608-28.51a4 4 0 0 1 5.656.106L43.65 8.78 8.28 42.84l-4.676-4.856Z"
      }
    )
  ] });
}, Exclude = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { width: 92, height: 66, fill: "none", viewBox: "0 0 92 66", children: [
    /* @__PURE__ */ jsxs("g", { clipPath: "url(#a)", children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#D2DFFA",
          d: "M88.913 51.968C82.954 72.292 39.88 65.925 26.07 62.318 16.759 65.612 0 59.025 0 38.325c0-8.939 13.5-7.527 22.81-19.76C32.12 6.336 42.827-2.604 55.862.69c13.034 3.293 40.5 25.875 33.051 51.28Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#6562F5", d: "M12.408 55.5v-8.893h5.377v-8.893h-5.377V19.927h70.318V55.5H12.408Z" }),
      /* @__PURE__ */ jsx("path", { fill: "#6562F5", d: "M12.408 56.328V46.4h.827v9.927z" }),
      /* @__PURE__ */ jsx("path", { fill: "#3A36DB", d: "M28.127 38.127v-18.2h.827v18.2zm0 18.2V46.4h.827v9.927z" }),
      /* @__PURE__ */ jsx("path", { fill: "#6562F5", d: "M17.37 47.227V37.3h.828v9.927z" }),
      /* @__PURE__ */ jsx("path", { fill: "#3A36DB", d: "M82.726 56.327v-36.4h.827v36.4zM12.408 10h71.145v9.927H12.408z" }),
      /* @__PURE__ */ jsx("path", { fill: "#F1F4FA", stroke: "#3A36DB", d: "M16.871 37.627h70.491V46.9H16.871z" }),
      /* @__PURE__ */ jsx("path", { fill: "#3A36DB", d: "M33.918 47.227V37.3h.827v9.927z" }),
      /* @__PURE__ */ jsx("path", { fill: "#3A36DB", d: "M12.408 37.3h71.145v.827H12.408zm0 9.1h71.145v.827H12.408z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          stroke: "#EB5757",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".5",
          d: "M27.05 40.905s-6.722 2.682-5.36 3.025c1.362.343 8.2-2.908 10.283-2.993 2.092-.085-7.283 4.47-6.339 4.632.935.161 12.696-4.819 15.5-4.81 2.805.01-6.205 4.333-4.416 4.313 1.799-.021 10.078-4.236 13.096-4.312 3.028-.079-7.015 4.247-4.691 4.229 2.323-.019 11.645-4.623 13.568-4.37 1.923.253-9.57 4.008-6.526 4.317 3.045.308 10.826-4.027 14.556-4.245 3.73-.22-8.627 3.948-5.012 4.058 3.606.11 9.01-4.344 11.823-3.99 2.813.355-5.164 2.828-3.989 2.989 1.176.161 4.933-2.98 8.69-2.988 3.757-.01-4.46 2.827-3.526 3.17.935.343 4.71-.838 4.71-.838"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#3A36DB", d: "M12.408 55.5h71.145v.827H12.408zm0-27.3h71.145v.827H12.408z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#EB5757",
          fillRule: "evenodd",
          d: "M14.272 42.264a1.861 1.861 0 1 1-3.723 0 1.861 1.861 0 0 1 3.723 0Zm-3.043 1.18a.5.5 0 0 1 0-.707l.474-.473-.474-.474a.5.5 0 1 1 .708-.707l.473.474.474-.474a.5.5 0 1 1 .707.707l-.474.474.474.473a.5.5 0 1 1-.707.707l-.474-.473-.473.474a.5.5 0 0 1-.708 0Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#06152B",
          d: "m4.826 42.264.354-.354.353.354-.353.353-.354-.353Zm-3.447.5a.5.5 0 1 1 0-1v1Zm1.733-2.922L5.18 41.91l-.707.707-2.069-2.068.708-.707Zm2.068 2.775-2.068 2.069-.708-.708 2.069-2.068.707.707Zm-.354.147H1.38v-1h3.447v1Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { stroke: "#06152B", d: "M6.895 39.85v4.827" })
    ] }),
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h92v66H0z" }) }) })
  ] }) : /* @__PURE__ */ jsxs("svg", { width: 92, height: 66, fill: "none", viewBox: "0 0 92 66", children: [
    /* @__PURE__ */ jsxs("g", { clipPath: "url(#a)", children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#28313F",
          d: "M88.913 51.968C82.954 72.292 39.88 65.925 26.07 62.318 16.759 65.612 0 59.025 0 38.325c0-8.939 13.5-7.527 22.81-19.76C32.12 6.336 42.827-2.604 55.862.69c13.034 3.293 40.5 25.875 33.051 51.28Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#605CFF", d: "M12.408 55.5v-8.893h5.377v-8.893h-5.377V19.927h70.318V55.5H12.408Z" }),
      /* @__PURE__ */ jsx("path", { fill: "#605CFF", d: "M12.408 56.328V46.4h.827v9.927z" }),
      /* @__PURE__ */ jsx("path", { fill: "#4541C9", d: "M28.127 38.127v-18.2h.827v18.2zm0 18.2V46.4h.827v9.927z" }),
      /* @__PURE__ */ jsx("path", { fill: "#605CFF", d: "M17.37 47.227V37.3h.828v9.927z" }),
      /* @__PURE__ */ jsx("path", { fill: "#4541C9", d: "M82.726 56.327v-36.4h.827v36.4zM12.408 10h71.145v9.927H12.408z" }),
      /* @__PURE__ */ jsx("path", { fill: "#1A202C", stroke: "#4541C9", d: "M16.871 37.627h70.491V46.9H16.871z" }),
      /* @__PURE__ */ jsx("path", { fill: "#4541C9", d: "M33.918 47.227V37.3h.827v9.927z" }),
      /* @__PURE__ */ jsx("path", { fill: "#4541C9", d: "M12.408 37.3h71.145v.827H12.408zm0 9.1h71.145v.827H12.408z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          stroke: "#EB5757",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".5",
          d: "M27.05 40.905s-6.722 2.682-5.36 3.025c1.362.343 8.2-2.908 10.283-2.993 2.092-.085-7.283 4.47-6.339 4.632.935.161 12.696-4.819 15.5-4.81 2.805.01-6.205 4.333-4.416 4.313 1.799-.021 10.078-4.236 13.096-4.312 3.028-.079-7.015 4.247-4.691 4.229 2.323-.019 11.645-4.623 13.568-4.37 1.923.253-9.57 4.008-6.526 4.317 3.045.308 10.826-4.027 14.556-4.245 3.73-.22-8.627 3.948-5.012 4.058 3.606.11 9.01-4.344 11.823-3.99 2.813.355-5.164 2.828-3.989 2.989 1.176.161 4.933-2.98 8.69-2.988 3.757-.01-4.46 2.827-3.526 3.17.935.343 4.71-.838 4.71-.838"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#4541C9", d: "M12.408 55.5h71.145v.827H12.408zm0-27.3h71.145v.827H12.408z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#EB5757",
          fillRule: "evenodd",
          d: "M14.272 42.264a1.861 1.861 0 1 1-3.723 0 1.861 1.861 0 0 1 3.723 0Zm-3.043 1.18a.5.5 0 0 1 0-.707l.474-.473-.474-.474a.5.5 0 1 1 .708-.707l.473.474.474-.474a.5.5 0 0 1 .707.707l-.474.474.474.473a.5.5 0 1 1-.707.707l-.474-.473-.473.474a.5.5 0 0 1-.708 0Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#CCD2E3",
          d: "m4.826 42.264.354-.354.353.354-.353.353-.354-.353Zm-3.447.5a.5.5 0 1 1 0-1v1Zm1.733-2.922L5.18 41.91l-.707.707-2.069-2.068.708-.707Zm2.068 2.775-2.068 2.068-.708-.707 2.069-2.068.707.707Zm-.354.147H1.38v-1h3.447v1Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { stroke: "#CCD2E3", d: "M6.895 39.85v4.826" })
    ] }),
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h92v66H0z" }) }) })
  ] });
}, Attention = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsxs("g", { clipPath: "url(#a)", children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#D2DFFA",
          d: "M89.482 51.826c-5.996 20.268-49.348 13.918-63.246 10.321C16.866 65.431 0 58.863 0 38.22c0-8.914 13.586-7.507 22.956-19.705C32.326 6.317 43.101-2.597 56.22.687 69.337 3.97 96.98 26.49 89.482 51.826Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#6562F5",
          d: "M11.56 7.124a8 8 0 0 0-8 8v30.444c0 .088.002.175.005.262l-.004-.003V62.76l9.192-9.192H72a8 8 0 0 0 8-8V15.124a8 8 0 0 0-8-8H11.56Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#3A36DB",
          fillRule: "evenodd",
          d: "M72.259 23.09a2.419 2.419 0 0 1-2.42 2.418H45.65a2.419 2.419 0 0 1 0-4.838h24.19a2.419 2.419 0 0 1 2.419 2.42Zm0 7.74a2.419 2.419 0 0 1-2.42 2.419H45.65a2.419 2.419 0 0 1 0-4.838h24.19a2.419 2.419 0 0 1 2.419 2.419Zm0 7.74a2.419 2.419 0 0 1-2.42 2.42H45.65a2.419 2.419 0 0 1 0-4.838h24.19a2.419 2.419 0 0 1 2.419 2.419Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#EB5757",
          d: "M20.837 19.053 10.22 36.425c-1.221 2 .218 4.565 2.56 4.565h21.232c2.343 0 3.782-2.566 2.56-4.565L25.956 19.054c-1.17-1.915-3.95-1.915-5.12 0Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "m24.737 25.508-.236 8.028h-2.213l-.242-8.028h2.691ZM23.395 37.12c-.4 0-.742-.13-1.029-.392a1.233 1.233 0 0 1-.423-.951 1.21 1.21 0 0 1 .423-.941 1.473 1.473 0 0 1 1.029-.392c.383 0 .72.13 1.01.392.29.261.437.575.44.94a1.232 1.232 0 0 1-.21.678 1.459 1.459 0 0 1-1.24.666Z"
        }
      )
    ] }),
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h99v66H0z" }) }) })
  ] }) : /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsxs("g", { clipPath: "url(#a)", children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#28313F",
          d: "M89.482 51.826c-5.996 20.268-49.348 13.918-63.246 10.321C16.866 65.431 0 58.863 0 38.22c0-8.914 13.586-7.507 22.956-19.705C32.326 6.317 43.101-2.597 56.22.687 69.337 3.97 96.98 26.49 89.482 51.826Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#605CFF",
          fillRule: "evenodd",
          d: "M11.56 7.124a8 8 0 0 0-8 8v30.444c0 .088.002.175.005.262l-.004-.002V62.76l9.192-9.192H72a8 8 0 0 0 8-8V15.124a8 8 0 0 0-8-8H11.56Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#4541C9",
          fillRule: "evenodd",
          d: "M72.26 23.09a2.419 2.419 0 0 1-2.42 2.418H45.652a2.419 2.419 0 1 1 0-4.838h24.19a2.419 2.419 0 0 1 2.419 2.42Zm0 7.74a2.419 2.419 0 0 1-2.42 2.419H45.652a2.419 2.419 0 0 1 0-4.838h24.19a2.419 2.419 0 0 1 2.419 2.419Zm0 7.74a2.419 2.419 0 0 1-2.42 2.42H45.652a2.419 2.419 0 1 1 0-4.838h24.19a2.419 2.419 0 0 1 2.419 2.419Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#EB5757",
          d: "M20.837 19.054 10.221 36.425c-1.222 2 .217 4.565 2.56 4.565h21.232c2.343 0 3.781-2.566 2.56-4.565L25.957 19.054c-1.17-1.915-3.95-1.915-5.12 0Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "m24.737 25.508-.236 8.028h-2.213l-.242-8.028h2.691ZM23.395 37.12c-.4 0-.742-.13-1.028-.392a1.233 1.233 0 0 1-.424-.951 1.21 1.21 0 0 1 .424-.94 1.472 1.472 0 0 1 1.028-.393c.383 0 .72.13 1.01.392.29.261.437.575.441.94a1.232 1.232 0 0 1-.212.678 1.46 1.46 0 0 1-1.24.666Z"
        }
      )
    ] }),
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h99v66H0z" }) }) })
  ] });
}, Edit = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsxs("g", { clipPath: "url(#a)", children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#D2DFFA",
          d: "M88.913 51.968C82.954 72.292 39.88 65.925 26.07 62.318 16.759 65.612 0 59.025 0 38.325c0-8.939 13.5-7.527 22.81-19.76C32.12 6.336 42.827-2.604 55.862.69c13.034 3.293 40.5 25.875 33.051 51.28Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#3A36DB", d: "M35.844 47.967h13.85v5.327h-13.85z" }),
      /* @__PURE__ */ jsx("path", { fill: "#6562F5", d: "M24.123 53.294h37.289v5.327H24.123z" }),
      /* @__PURE__ */ jsx("rect", { width: "69.63", height: "42.307", x: "7", y: "6.154", fill: "#605CFF", rx: "8" }),
      /* @__PURE__ */ jsx("rect", { width: "63.341", height: "36.018", x: "10.145", y: "9.298", fill: "#6562F5", stroke: "#F1F4FA", rx: "4.5" }),
      /* @__PURE__ */ jsx("path", { fill: "#3A36DB", d: "M45.342 20.58a1 1 0 0 0-.99 1.145 1 1 0 1 0 .99-1.146Z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#3A36DB",
          fillRule: "evenodd",
          d: "M41.44 25.707a.089.089 0 0 1-.1-.027l-.82-1.005a.09.09 0 0 1-.007-.103l.57-.919a4.717 4.717 0 0 1-.44-1.46l-.98-.454a.089.089 0 0 1-.051-.09l.13-1.29a.088.088 0 0 1 .068-.077l1.052-.247c.169-.491.415-.943.723-1.343l-.373-1.015a.09.09 0 0 1 .027-.1l1.005-.819a.089.089 0 0 1 .102-.006l.92.569a4.702 4.702 0 0 1 1.46-.44l.453-.98a.089.089 0 0 1 .09-.051l1.29.13a.089.089 0 0 1 .077.068l.248 1.052c.49.169.943.415 1.343.723l1.014-.373a.089.089 0 0 1 .1.027l.82 1.005c.023.029.026.07.006.102l-.569.92c.222.453.372.945.44 1.46l.98.454a.088.088 0 0 1 .05.09l-.13 1.289a.089.089 0 0 1-.068.077l-1.051.248a4.715 4.715 0 0 1-.723 1.343l.373 1.014a.09.09 0 0 1-.027.1l-1.005.82a.09.09 0 0 1-.103.006l-.919-.569a4.707 4.707 0 0 1-1.46.44l-.454.98a.089.089 0 0 1-.09.051l-1.289-.13a.088.088 0 0 1-.078-.069l-.247-1.051a4.711 4.711 0 0 1-1.343-.723l-1.014.373Zm3.926-.943a3.27 3.27 0 0 1-.937-.138h-.002l-.002-.001-.02-.006-.035-.011a.076.076 0 1 1 .046-.145 3.052 3.052 0 0 0 3.996-2.91c0-.7-.239-1.373-.687-1.923a3.032 3.032 0 0 0-2.058-1.107 3.055 3.055 0 0 0-3.071 4.332.076.076 0 0 1-.037.1.076.076 0 0 1-.101-.036 3.198 3.198 0 0 1-.286-1.683 3.208 3.208 0 0 1 3.51-2.865 3.182 3.182 0 0 1 2.16 1.163 3.18 3.18 0 0 1 .706 2.348 3.183 3.183 0 0 1-1.163 2.16 3.18 3.18 0 0 1-2.02.722Zm-.027-1.882a1.305 1.305 0 0 1-1.288-1.114 1.305 1.305 0 0 1 2.066-1.236 1.305 1.305 0 0 1-.778 2.35Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#3A36DB",
          d: "M28.154 29.182a1.653 1.653 0 0 0-.986 2.977c.355.263.79.372 1.227.308a1.64 1.64 0 0 0 1.085-.649c.263-.354.372-.789.308-1.226a1.654 1.654 0 0 0-1.634-1.41Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#3A36DB",
          fillRule: "evenodd",
          d: "M21.553 37.82a.15.15 0 0 1-.169-.047l-1.387-1.7a.15.15 0 0 1-.011-.174l.962-1.555a7.97 7.97 0 0 1-.743-2.472l-1.659-.767a.15.15 0 0 1-.086-.152l.221-2.183a.15.15 0 0 1 .115-.13l1.78-.42a7.96 7.96 0 0 1 1.223-2.272l-.631-1.717a.15.15 0 0 1 .046-.168l1.7-1.387a.15.15 0 0 1 .174-.012l1.555.963a7.96 7.96 0 0 1 2.472-.743l.767-1.66a.15.15 0 0 1 .152-.086l2.183.222a.15.15 0 0 1 .13.115l.42 1.779a7.956 7.956 0 0 1 2.272 1.224l1.717-.632a.15.15 0 0 1 .168.047l1.387 1.7c.04.05.045.12.012.174l-.963 1.555c.375.768.63 1.6.743 2.472l1.66.767a.15.15 0 0 1 .086.152l-.221 2.182a.15.15 0 0 1-.115.132l-1.78.418a7.956 7.956 0 0 1-1.224 2.273l.632 1.717a.15.15 0 0 1-.047.168l-1.7 1.387a.151.151 0 0 1-.174.011l-1.555-.962a7.97 7.97 0 0 1-2.472.743l-.767 1.659a.15.15 0 0 1-.151.086l-2.183-.22a.15.15 0 0 1-.131-.116l-.419-1.779a7.959 7.959 0 0 1-2.273-1.224l-1.716.632Zm6.64-1.428a5.636 5.636 0 0 1-1.684-.257l-.05-.016a.297.297 0 1 1 .183-.564 5.07 5.07 0 0 0 1.042.218l.058.005a4.949 4.949 0 0 0 3.57-1.077l.009-.007.004-.003.022-.018a4.964 4.964 0 0 0 1.838-3.882 4.96 4.96 0 0 0-1.126-3.149 4.965 4.965 0 0 0-3.368-1.812 4.97 4.97 0 0 0-3.663 1.1 4.965 4.965 0 0 0-1.838 3.875c0 .73.16 1.454.472 2.117a.299.299 0 0 1-.143.395.297.297 0 0 1-.395-.143 5.58 5.58 0 0 1-.5-2.936 5.554 5.554 0 0 1 2.029-3.768 5.548 5.548 0 0 1 4.098-1.23 5.55 5.55 0 0 1 3.768 2.027 5.55 5.55 0 0 1 1.231 4.098 5.598 5.598 0 0 1-5.558 5.027Zm-.044-3.313c-.48 0-.944-.153-1.335-.444a2.231 2.231 0 0 1-.881-1.474 2.247 2.247 0 0 1 1.893-2.548 2.248 2.248 0 0 1 2.549 1.893 2.228 2.228 0 0 1-.42 1.667 2.228 2.228 0 0 1-1.806.906Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#EB5757",
          d: "M80.768 13.075a2.663 2.663 0 0 0-3.638.974l-1.332 2.307 4.613 2.664 1.332-2.307a2.664 2.664 0 0 0-.975-3.639Zm-1.422 7.79-4.614-2.663-12.898 22.341-1.309 7.593 5.922-4.93 12.899-22.34Z"
        }
      )
    ] }),
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h99v66H0z" }) }) })
  ] }) : /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsxs("g", { clipPath: "url(#a)", children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#28313F",
          d: "M88.913 51.968C82.954 72.292 39.88 65.925 26.07 62.318 16.759 65.612 0 59.025 0 38.325c0-8.939 13.5-7.527 22.81-19.76C32.12 6.336 42.827-2.604 55.862.69c13.034 3.293 40.5 25.875 33.051 51.28Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#3A36DB", d: "M35.844 47.967h13.85v5.327h-13.85z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#605CFF",
          d: "M24.123 53.294h37.289v5.327H24.123zM7 14.154a8 8 0 0 1 8-8h53.63a8 8 0 0 1 8 8v26.307a8 8 0 0 1-8 8H15a8 8 0 0 1-8-8V14.154Z"
        }
      ),
      /* @__PURE__ */ jsx("rect", { width: "63.341", height: "36.018", x: "10.145", y: "9.298", fill: "#605CFF", stroke: "#364153", rx: "4.5" }),
      /* @__PURE__ */ jsx("path", { fill: "#4541C9", d: "M45.342 20.58a1 1 0 0 0-.99 1.145 1 1 0 1 0 .99-1.146Z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#4541C9",
          fillRule: "evenodd",
          d: "M41.44 25.707a.089.089 0 0 1-.1-.027l-.82-1.005a.09.09 0 0 1-.007-.103l.57-.919a4.717 4.717 0 0 1-.44-1.46l-.98-.454a.089.089 0 0 1-.051-.09l.13-1.29a.088.088 0 0 1 .068-.077l1.052-.247c.169-.491.415-.943.723-1.343l-.373-1.015a.09.09 0 0 1 .027-.1l1.005-.819a.089.089 0 0 1 .102-.006l.92.569a4.702 4.702 0 0 1 1.46-.44l.453-.98a.089.089 0 0 1 .09-.051l1.29.13a.089.089 0 0 1 .077.068l.248 1.052c.49.169.943.415 1.343.723l1.014-.373a.089.089 0 0 1 .1.027l.82 1.005c.023.029.026.07.006.102l-.569.92c.222.453.372.945.44 1.46l.98.454a.088.088 0 0 1 .05.09l-.13 1.289a.089.089 0 0 1-.068.077l-1.051.248a4.715 4.715 0 0 1-.723 1.343l.373 1.014a.09.09 0 0 1-.027.1l-1.005.82a.09.09 0 0 1-.103.006l-.919-.569a4.707 4.707 0 0 1-1.46.44l-.454.98a.089.089 0 0 1-.09.051l-1.289-.13a.088.088 0 0 1-.078-.069l-.247-1.051a4.711 4.711 0 0 1-1.343-.723l-1.014.373Zm3.926-.943a3.27 3.27 0 0 1-.937-.138h-.002l-.002-.001-.02-.006-.035-.011a.076.076 0 1 1 .046-.145 3.052 3.052 0 0 0 3.996-2.91c0-.7-.239-1.373-.687-1.923a3.032 3.032 0 0 0-2.058-1.107 3.055 3.055 0 0 0-3.071 4.332.076.076 0 0 1-.037.1.076.076 0 0 1-.101-.036 3.198 3.198 0 0 1-.286-1.683 3.208 3.208 0 0 1 3.51-2.865 3.182 3.182 0 0 1 2.16 1.163 3.18 3.18 0 0 1 .706 2.348 3.183 3.183 0 0 1-1.163 2.16 3.18 3.18 0 0 1-2.02.722Zm-.027-1.882a1.305 1.305 0 0 1-1.288-1.114 1.305 1.305 0 0 1 2.066-1.236 1.305 1.305 0 0 1-.778 2.35Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#4541C9",
          d: "M28.154 29.182a1.653 1.653 0 0 0-.986 2.977c.355.263.79.372 1.227.308a1.64 1.64 0 0 0 1.085-.649c.263-.354.372-.789.308-1.226a1.654 1.654 0 0 0-1.634-1.41Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#4541C9",
          fillRule: "evenodd",
          d: "M21.553 37.82a.15.15 0 0 1-.169-.046v-.001l-1.387-1.7a.15.15 0 0 1-.011-.174l.962-1.555a7.97 7.97 0 0 1-.743-2.472l-1.659-.767a.15.15 0 0 1-.086-.152l.221-2.183a.15.15 0 0 1 .115-.13l1.78-.42a7.959 7.959 0 0 1 1.223-2.272l-.631-1.717a.15.15 0 0 1 .046-.168l1.7-1.387a.15.15 0 0 1 .174-.011l1.555.962a7.96 7.96 0 0 1 2.472-.743l.767-1.66a.15.15 0 0 1 .152-.086l2.183.222a.15.15 0 0 1 .13.115l.42 1.78a7.954 7.954 0 0 1 2.272 1.223l1.717-.631a.15.15 0 0 1 .168.046l1.387 1.7c.04.05.045.12.012.174l-.963 1.555c.375.768.63 1.6.743 2.472l1.66.767a.15.15 0 0 1 .086.152l-.221 2.182a.15.15 0 0 1-.115.132l-1.78.418a7.957 7.957 0 0 1-1.224 2.273l.632 1.717a.15.15 0 0 1-.047.168l-1.7 1.387a.151.151 0 0 1-.174.011l-1.555-.962a7.97 7.97 0 0 1-2.472.743l-.767 1.659a.15.15 0 0 1-.151.087l-2.183-.222a.15.15 0 0 1-.131-.115l-.419-1.779a7.959 7.959 0 0 1-2.273-1.224l-1.716.632Zm6.64-1.428a5.636 5.636 0 0 1-1.684-.257l-.05-.016a.297.297 0 1 1 .183-.564 5.07 5.07 0 0 0 1.042.218l.058.005a4.949 4.949 0 0 0 3.57-1.077l.009-.007.004-.003.022-.018a4.965 4.965 0 0 0 1.838-3.882 4.96 4.96 0 0 0-1.126-3.149 4.965 4.965 0 0 0-3.368-1.812 4.97 4.97 0 0 0-3.663 1.1 4.964 4.964 0 0 0-1.838 3.875c0 .731.16 1.454.472 2.117a.298.298 0 0 1-.143.395.297.297 0 0 1-.395-.143 5.58 5.58 0 0 1-.5-2.936 5.554 5.554 0 0 1 2.029-3.767 5.549 5.549 0 0 1 4.098-1.231 5.55 5.55 0 0 1 3.768 2.027 5.55 5.55 0 0 1 1.231 4.098 5.598 5.598 0 0 1-5.558 5.027Zm-.044-3.313c-.48 0-.944-.153-1.335-.444a2.23 2.23 0 0 1-.881-1.474 2.247 2.247 0 0 1 1.893-2.548 2.248 2.248 0 0 1 2.549 1.893 2.229 2.229 0 0 1-.42 1.667 2.228 2.228 0 0 1-1.806.906Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#EB5757",
          fillRule: "evenodd",
          d: "M80.768 13.074a2.663 2.663 0 0 0-3.639.975l-1.332 2.307 4.614 2.664 1.332-2.307a2.663 2.663 0 0 0-.975-3.639Zm-1.423 7.791-4.613-2.663-12.9 22.341-1.307 7.593 5.921-4.93 12.9-22.34Z",
          clipRule: "evenodd"
        }
      )
    ] }),
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h99v66H0z" }) }) })
  ] });
}, SaveTable = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#D2DFFA",
        d: "M88.097 50.956C82.194 70.884 39.513 64.641 25.83 61.105 16.605 64.334 0 57.875 0 37.579c0-8.765 13.376-7.381 22.6-19.375C31.827 6.211 42.435-2.554 55.35.675c12.914 3.23 40.127 25.371 32.747 50.281Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#6562F5", d: "M4.137 54.214V18.893h69.49v35.321H4.138Z" }),
    /* @__PURE__ */ jsx("path", { fill: "#D2DFFA", d: "M4.137 54.214V18.893h13.236v35.321H4.137Z" }),
    /* @__PURE__ */ jsx("path", { fill: "#BECDFA", d: "M18.2 54.214V18.893h13.236v35.321H18.199Zm14.064 0V18.893H45.5v35.321H32.264Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#EB5757",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: ".5",
        d: "M11.153 18.893 6.603 21.1l4.501 2.208-6.967 2.208 7.234 2.207-6.486 2.208 6.486 2.207-6.362 2.208 6.573 2.208-6.493 2.207 6.386 2.208-6.106 2.207 6.002 2.208-4.495 2.208 4.599 2.207-4.873 2.208 1.26 2.207"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#3A36DB",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: ".5",
        d: "M42.589 18.893 32.677 21.1l9.863 2.208-9.863 2.156 10.13 2.26-10.13 2.207 8.475 2.207-8.475 2.208 7.86 2.208-7.86 2.207 6.924 2.208-6.924 2.207 4.339 2.208-2.84 2.208 1.29 2.207-2.789 2.208s1.993 1.345 2.485 2.207"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#fff",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: ".5",
        d: "m28.11 54.214-9.911-2.207 9.862-2.208-9.862-2.156 10.13-2.26-10.13-2.207 8.475-2.207-8.475-2.208 7.858-2.208-7.858-2.207 6.924-2.208-6.924-2.207 4.338-2.208-2.84-2.207 1.29-2.208-2.788-2.208s1.992-1.345 2.485-2.207"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#6562F5", d: "M3.309 55.035v-9.857h.827v9.857z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#3A36DB",
        d: "M17.373 55.036V18.893h.827v36.143zm14.063-.001V18.892h.827v36.143zm14.064.001V18.893h.827v36.143zm14.063-.001V18.892h.827v36.143zm14.064.001V18.893h.827v36.143zm-70.318-.001V18.892h.827v36.143z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#3A36DB", d: "M3.309 54.214h71.145v.821H3.309zm0-45.178h71.145v9.857H3.309z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#BECDFA",
        d: "M80.555 50.518c0 6.294-5.14 11.397-11.479 11.397-6.34 0-11.478-5.103-11.478-11.397 0-6.295 5.139-11.398 11.478-11.398 6.34 0 11.479 5.103 11.479 11.398Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#3A36DB",
        d: "M68.514 54.27v-.078c.009-.828.096-1.487.26-1.977.165-.49.4-.886.703-1.19a5.671 5.671 0 0 1 1.092-.838c.255-.156.485-.34.689-.552a2.458 2.458 0 0 0 .663-1.684c0-.425-.1-.793-.3-1.105a2.009 2.009 0 0 0-.799-.722 2.425 2.425 0 0 0-1.112-.253 2.49 2.49 0 0 0-1.027.22 1.99 1.99 0 0 0-.825.696c-.221.317-.35.73-.384 1.242h-1.638c.035-.737.225-1.367.572-1.892a3.445 3.445 0 0 1 1.385-1.203 4.365 4.365 0 0 1 1.917-.416c.763 0 1.426.152 1.99.456a3.26 3.26 0 0 1 1.313 1.248c.312.528.468 1.13.468 1.807a3.6 3.6 0 0 1-.221 1.294c-.143.385-.351.73-.624 1.033a4.282 4.282 0 0 1-.975.806c-.382.239-.687.49-.917.755-.23.26-.396.57-.5.93-.104.359-.16.807-.17 1.345v.078h-1.56Zm.833 3.848c-.321 0-.596-.114-.826-.344a1.126 1.126 0 0 1-.345-.826c0-.32.115-.596.345-.825.23-.23.505-.345.826-.345.32 0 .595.115.825.345.23.23.345.505.345.825 0 .213-.054.408-.163.585a1.224 1.224 0 0 1-.422.43 1.115 1.115 0 0 1-.585.155Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#fff",
        strokeOpacity: ".4",
        d: "M49.72 35.321c0-1.76 1.453-3.196 3.223-3.196 1.77 0 3.223 1.436 3.223 3.196 0 1.761-1.453 3.197-3.223 3.197-1.77 0-3.222-1.436-3.222-3.197Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { stroke: "#fff", strokeLinejoin: "round", d: "M52.943 33.679v3.285m1.657-1.643h-3.31" })
  ] }) : /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#28313F",
        d: "M88.097 50.956C82.194 70.884 39.513 64.641 25.83 61.105 16.605 64.334 0 57.875 0 37.579c0-8.765 13.376-7.381 22.6-19.375C31.827 6.211 42.435-2.554 55.35.675c12.914 3.23 40.127 25.371 32.747 50.281Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#605CFF", d: "M4.137 54.214V18.893h69.49v35.321H4.138Z" }),
    /* @__PURE__ */ jsx("path", { fill: "#1A202C", d: "M4.137 54.214V18.893h13.236v35.321H4.137Z" }),
    /* @__PURE__ */ jsx("path", { fill: "#7471FF", d: "M18.2 54.214V18.893h13.236v35.321H18.199Zm14.064 0V18.893H45.5v35.321H32.264Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#EB5757",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: ".5",
        d: "M11.153 18.893 6.603 21.1l4.501 2.208-6.967 2.208 7.234 2.207-6.486 2.208 6.486 2.207-6.362 2.208 6.573 2.208-6.493 2.207 6.386 2.208-6.106 2.207 6.002 2.208-4.495 2.208 4.599 2.207-4.873 2.208 1.26 2.207"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#4541C9",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: ".5",
        d: "M42.589 18.893 32.677 21.1l9.863 2.208-9.863 2.156 10.13 2.26-10.13 2.207 8.475 2.207-8.475 2.208 7.86 2.208-7.86 2.207 6.924 2.208-6.924 2.207 4.339 2.208-2.84 2.208 1.29 2.207-2.789 2.208s1.993 1.345 2.485 2.207"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#fff",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: ".5",
        d: "m28.11 54.214-9.911-2.207 9.862-2.208-9.862-2.156 10.13-2.26-10.13-2.207 8.475-2.207-8.475-2.208 7.858-2.207-7.858-2.208 6.924-2.208-6.924-2.207 4.338-2.208-2.84-2.207 1.29-2.208-2.788-2.208s1.992-1.345 2.485-2.207"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#605CFF", d: "M3.309 55.035v-9.857h.827v9.857z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#4541C9",
        d: "M17.373 55.036V18.893h.827v36.143zm14.063-.001V18.892h.827v36.143zm14.064.001V18.893h.827v36.143zm14.063-.001V18.892h.827v36.143zm14.064.001V18.893h.827v36.143zm-70.318-.001V18.892h.827v36.143z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#4541C9", d: "M3.309 54.214h71.145v.821H3.309zm0-45.178h71.145v9.857H3.309z" }),
    /* @__PURE__ */ jsx("ellipse", { cx: "69.491", cy: "50.929", fill: "#28313F", rx: "9.1", ry: "9.036" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#BECDFA",
        fillRule: "evenodd",
        d: "M69.076 61.915c6.34 0 11.479-5.103 11.479-11.397 0-6.295-5.14-11.398-11.479-11.398-6.34 0-11.478 5.103-11.478 11.398 0 6.294 5.139 11.397 11.478 11.397Zm-.562-7.723v.078h1.56v-.078c.01-.538.066-.986.17-1.346.104-.36.27-.67.5-.93a4.04 4.04 0 0 1 .917-.754c.381-.234.706-.502.975-.806.273-.303.481-.648.624-1.033a3.6 3.6 0 0 0 .221-1.294c0-.676-.156-1.279-.468-1.807a3.259 3.259 0 0 0-1.313-1.248c-.564-.304-1.227-.455-1.99-.455-.702 0-1.34.138-1.917.416a3.446 3.446 0 0 0-1.385 1.202c-.347.525-.537 1.155-.572 1.892h1.638c.035-.511.163-.925.384-1.242.22-.316.496-.548.825-.695.33-.148.672-.221 1.027-.221.408 0 .779.084 1.112.253.334.17.6.41.8.722.2.312.299.68.299 1.105a2.458 2.458 0 0 1-.663 1.684 3.413 3.413 0 0 1-.69.552 5.67 5.67 0 0 0-1.091.839c-.304.303-.538.7-.703 1.19-.164.49-.251 1.148-.26 1.976Zm.007 3.582c.23.23.505.344.826.344.216 0 .411-.052.585-.156.177-.108.318-.25.422-.429.109-.177.163-.372.163-.585 0-.32-.115-.596-.345-.825a1.126 1.126 0 0 0-.825-.345c-.321 0-.596.115-.826.345-.23.23-.345.505-.345.825 0 .321.115.596.345.826Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#fff",
        strokeOpacity: ".4",
        d: "M49.72 35.321c0-1.76 1.453-3.196 3.223-3.196 1.77 0 3.223 1.436 3.223 3.196 0 1.761-1.453 3.197-3.223 3.197-1.77 0-3.222-1.436-3.222-3.197Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { stroke: "#fff", strokeLinejoin: "round", d: "M52.943 33.679v3.285m1.657-1.643h-3.31" })
  ] });
}, Work = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#D2DFFA",
        d: "M80.245 47.483c-5.295 17.869-43.57 12.27-55.841 9.1C16.13 59.478 1.24 53.687 1.24 35.487c0-7.859 11.996-6.618 20.268-17.373C29.781 7.36 39.295-.498 50.877 2.396c11.581 2.896 35.986 22.75 29.368 45.087Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#FEBBBA",
        d: "M23.935 47.602c2.083-1.45 4.443 0 4.443 0 2.785 1.824 4.846 2.6 6.366 2.692a7.744 7.744 0 0 1-.129 4.684c-3.12-.672-5.353-2.933-6.323-4.093a1.006 1.006 0 0 0-1.395-.153c-.434.343-.855.813-.778 1.307.15.975-.98 1.285-1.064.931-.085-.353.386-2.449.386-2.449s-2.26 2.275-3.141 3.15c-.882.874-1.991 0-1.991 0s1.543-4.617 3.626-6.067v-.002Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#6562F5",
        d: "M60.812 27.522s-8.133-3.26-23.27 9.252c0 0-1.264 2.62.116 4.952.18.305.56.764 1.09 1.345.254 2.68.116 7.472-4.003 7.223a7.734 7.734 0 0 1-.13 4.683c1.442.31 3.073.283 4.858-.352 3.34-1.187 5.199-2.884 6.23-4.342 3.67 3.909 7.006 6.267 7.905 9.406 0 0 8.343.962 16.303-1.457 0 0-.148-3.632-1.1-8.83 1.56 1.194 3.272 3.164 4.472 6.396 1.161-.743 2.163-1.855 2.918-3.442 5.262-11.07-15.389-24.834-15.389-24.834Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#3A36DB",
        d: "M67.115 47.776a.226.226 0 0 0 .22-.172c.965-3.937-8.294-12.303-8.689-12.657a.226.226 0 1 0-.301.338c.094.085 9.452 8.536 8.55 12.21a.226.226 0 0 0 .22.28Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#FEBBBA",
        d: "M52.623 48.005s11.339 4.408 14.106 1.092c.188-.224.31-.48.379-.76 1.86.925 4.51 2.98 6.173 7.462-5.964 3.815-16.157-2.123-18.913-3.873a2.056 2.056 0 0 0-1.523-.28c-1.063.22-2.9.545-3.89.392-1.45-.224-3.53 4.894-5.879 3.316 0 0 2.011-8.896 9.547-7.349ZM36.02 17.474c-.04.156.94 10.78.94 10.78l3.013-.343 2.153 4.456a2.458 2.458 0 0 0 2.02 1.38c2.925.228 4.243-1.424 4.8-2.559a1.597 1.597 0 0 0-.21-1.716l-3.492-4.238c.614.02 1.449-.284 1.891-1.866.607-2.167-1.005-2.736-2.203-2.113-.964.502-.666 2.65-.512 3.47l-1.283.465.435-7.832s-6.877-2.5-7.551.116Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#6562F5",
        d: "m41.998 19.473.123 5.397a.728.728 0 0 1-.024.204c-.105.41-.57 1.796-1.957 1.232-1.258-.511-2.414-.959-3.264-.797a.754.754 0 0 0-.61.81c.09.965.33 3.137.828 4.99.1.377.475.61.858.542 1.155-.204 3.578-.701 5.434-1.559a.754.754 0 0 0 .44-.635c.09-1.348.38-5.448.638-6.577.242-1.06 1.628-1.56 2.225-1.727a.742.742 0 0 0 .455-.367c.338-.635.871-2.133-.995-2.976a.755.755 0 0 1-.368-1.023c.375-.767.629-1.973-.795-2.81-1.447-.85-2.672-.163-3.358.43a.753.753 0 0 1-.967.009c-.163-.13-.385-.192-.676-.051-.393.189-.862-.021-1.01-.432-.282-.789-.936-1.673-2.454-1.581-2.694.163-3.315 3.063-2.806 4.86.51 1.795 3.42 1.452 4.938.742 1.155-.54 2.484.305 3.054.741a.75.75 0 0 1 .293.579h-.002Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#EB5757",
        d: "m46.815 56.698-.055.001-23.79-.026a1.065 1.065 0 0 1-1.064-1.067c0-.59.48-1.076 1.067-1.065l23.79.026a1.065 1.065 0 0 1 .052 2.131Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#EB5757",
        d: "M1.584 35.07h19.813c1.461 0 2.792.844 3.415 2.168l9.159 19.447H9.35a2.295 2.295 0 0 1-2.135-1.453L.112 37.236a1.584 1.584 0 0 1 1.472-2.167Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#1A202C",
        d: "M15.542 45.041c.429 1.335.112 2.633-.708 2.897-.82.265-1.834-.603-2.264-1.94-.429-1.335-.112-2.633.708-2.897.82-.264 1.834.604 2.264 1.94Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#BECDFA",
        d: "M86.646 57.727a1.346 1.346 0 0 0-.161-.866c-.145-.242-.362-.381-.59-.381H8.602c-.3 0-.58.21-.74.556a1.603 1.603 0 0 0-.058 1.157l.837 2.487c.192.57.608.934 1.065.934h75.66c.425 0 .79-.414.87-.987l.41-2.9Z"
      }
    )
  ] }) : /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#28313F",
        d: "M80.245 47.483c-5.295 17.869-43.57 12.27-55.841 9.1C16.13 59.478 1.24 53.687 1.24 35.487c0-7.859 11.996-6.618 20.268-17.373C29.781 7.36 39.295-.498 50.877 2.396c11.581 2.896 35.986 22.75 29.368 45.087Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#FEBBBA",
        d: "M23.935 47.602c2.083-1.45 4.443 0 4.443 0 2.785 1.824 4.846 2.6 6.366 2.692a7.744 7.744 0 0 1-.129 4.684c-3.12-.672-5.353-2.933-6.323-4.093a1.006 1.006 0 0 0-1.395-.153c-.434.343-.855.813-.778 1.307.15.975-.98 1.285-1.064.932-.085-.354.386-2.45.386-2.45s-2.26 2.276-3.141 3.15c-.882.874-1.991 0-1.991 0s1.543-4.617 3.626-6.067v-.002Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#605CFF",
        d: "M60.812 27.522s-8.133-3.26-23.27 9.252c0 0-1.264 2.62.116 4.952.18.305.56.764 1.09 1.345.254 2.68.116 7.472-4.003 7.223a7.735 7.735 0 0 1-.13 4.683c1.442.31 3.073.283 4.858-.352 3.34-1.187 5.199-2.884 6.23-4.342 3.67 3.909 7.006 6.267 7.905 9.406 0 0 8.343.962 16.303-1.457 0 0-.148-3.632-1.1-8.83 1.56 1.194 3.272 3.164 4.472 6.396 1.161-.743 2.163-1.855 2.918-3.442 5.262-11.07-15.389-24.834-15.389-24.834Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#1A202C",
        d: "M67.115 47.776a.226.226 0 0 0 .22-.172c.965-3.937-8.294-12.302-8.689-12.656a.226.226 0 1 0-.301.337c.094.085 9.452 8.536 8.55 12.211a.226.226 0 0 0 .22.28Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#FEBBBA",
        d: "M52.623 48.005s11.339 4.408 14.106 1.092c.188-.224.31-.48.379-.76 1.86.925 4.51 2.98 6.173 7.462-5.964 3.815-16.157-2.123-18.913-3.873a2.056 2.056 0 0 0-1.523-.28c-1.063.22-2.9.545-3.89.392-1.45-.224-3.53 4.894-5.879 3.316 0 0 2.011-8.896 9.547-7.349ZM36.02 17.474c-.04.156.94 10.78.94 10.78l3.013-.343 2.153 4.456a2.458 2.458 0 0 0 2.02 1.38c2.925.228 4.243-1.424 4.8-2.559a1.597 1.597 0 0 0-.21-1.716l-3.492-4.238c.614.02 1.449-.284 1.891-1.866.607-2.167-1.005-2.736-2.203-2.113-.964.502-.666 2.65-.512 3.47l-1.283.465.435-7.832s-6.877-2.5-7.551.116Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#605CFF",
        d: "m41.998 19.473.123 5.397a.729.729 0 0 1-.024.204c-.105.41-.57 1.796-1.957 1.232-1.258-.511-2.414-.959-3.264-.797a.754.754 0 0 0-.61.81c.09.965.33 3.137.828 4.99.1.377.475.61.858.542 1.155-.204 3.578-.701 5.434-1.559a.754.754 0 0 0 .44-.635c.09-1.348.38-5.448.638-6.577.242-1.06 1.628-1.56 2.225-1.727a.742.742 0 0 0 .455-.367c.338-.635.871-2.133-.995-2.976a.755.755 0 0 1-.368-1.023c.375-.767.629-1.973-.795-2.81-1.447-.85-2.672-.162-3.358.43a.753.753 0 0 1-.967.009c-.163-.13-.385-.192-.676-.051-.393.189-.862-.021-1.01-.432-.282-.789-.936-1.673-2.454-1.58-2.694.162-3.315 3.062-2.806 4.858.51 1.796 3.42 1.453 4.938.743 1.155-.54 2.484.305 3.054.741a.75.75 0 0 1 .293.579h-.002Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#EB5757",
        d: "m46.815 56.698-.055.001-23.79-.026a1.065 1.065 0 0 1-1.064-1.067c0-.59.48-1.076 1.067-1.065l23.79.026a1.065 1.065 0 0 1 .052 2.131Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#EB5757",
        d: "M1.584 35.07h19.813c1.461 0 2.792.845 3.415 2.168l9.159 19.447H9.35a2.295 2.295 0 0 1-2.135-1.453L.112 37.236a1.584 1.584 0 0 1 1.472-2.167Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#1A202C",
        d: "M15.542 45.041c.429 1.336.112 2.633-.708 2.897-.82.265-1.834-.603-2.264-1.94-.429-1.335-.112-2.632.708-2.897.82-.264 1.834.604 2.264 1.94Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#28313F",
        d: "M86.646 57.727a1.346 1.346 0 0 0-.161-.866c-.145-.241-.362-.381-.59-.381H8.602c-.3 0-.58.21-.74.556a1.603 1.603 0 0 0-.058 1.157l.837 2.487c.192.57.608.934 1.065.934h75.66c.425 0 .79-.414.87-.987l.41-2.899Z"
      }
    )
  ] });
}, Support = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsxs("g", { clipPath: "url(#a)", children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#D2DFFA",
          d: "M64.437 57.258c-1.334 1.415-2.598 2.328-3.596 3.05-11.73 8.476-25.61 6.006-28.56 5.402-4.356-.891-12.776-2.614-18.863-9.824-9.21-10.909-7.777-28.096-.633-39.44 1.307-2.076 8.21-13.594 22.24-15.44 8.49-1.118 18.387 1.136 25.554 7.184 15.045 12.695 13.974 38.342 3.858 49.068Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#6562F5",
          d: "m5.87 51.567 1.769 2.947a2.688 2.688 0 0 0 2.867 1.25l2.662-.57a2.246 2.246 0 0 1 2.004.567 24.039 24.039 0 0 0 4.41 3.267 2.261 2.261 0 0 1 1.13 1.757l.241 2.723a2.698 2.698 0 0 0 2.032 2.383l3.328.83a2.687 2.687 0 0 0 2.907-1.152l1.484-2.293a2.251 2.251 0 0 1 1.819-1.021 23.97 23.97 0 0 0 5.421-.815 2.245 2.245 0 0 1 2.035.44l2.087 1.753c.88.74 2.132.838 3.116.243l2.938-1.774a2.705 2.705 0 0 0 1.245-2.876l-.567-2.672a2.264 2.264 0 0 1 .564-2.01 24.112 24.112 0 0 0 3.256-4.425 2.252 2.252 0 0 1 1.751-1.135l2.715-.24a2.694 2.694 0 0 0 2.374-2.04l.827-3.339a2.705 2.705 0 0 0-1.147-2.917l-2.285-1.488a2.262 2.262 0 0 1-1.018-1.825 24.196 24.196 0 0 0-.812-5.44 2.263 2.263 0 0 1 .439-2.041l1.747-2.095a2.706 2.706 0 0 0 .242-3.126l-1.768-2.948a2.688 2.688 0 0 0-2.867-1.249l-2.662.569a2.246 2.246 0 0 1-2.003-.566 24.035 24.035 0 0 0-4.411-3.268 2.26 2.26 0 0 1-1.13-1.756l-.241-2.723a2.698 2.698 0 0 0-2.032-2.383l-3.328-.83a2.688 2.688 0 0 0-2.907 1.151l-1.484 2.293a2.25 2.25 0 0 1-1.818 1.022 23.965 23.965 0 0 0-5.422.815 2.248 2.248 0 0 1-2.035-.441l-2.087-1.753a2.685 2.685 0 0 0-3.116-.243l-2.938 1.774a2.704 2.704 0 0 0-1.245 2.876l.567 2.672a2.264 2.264 0 0 1-.564 2.01 24.108 24.108 0 0 0-3.257 4.425 2.252 2.252 0 0 1-1.75 1.135l-2.714.241a2.695 2.695 0 0 0-2.375 2.04l-.827 3.338a2.705 2.705 0 0 0 1.147 2.917l2.286 1.488a2.262 2.262 0 0 1 1.017 1.825 24.19 24.19 0 0 0 .813 5.44 2.264 2.264 0 0 1-.44 2.041L6.114 48.44a2.708 2.708 0 0 0-.242 3.127Zm7.746-5.025c-4.702-10-.435-21.93 9.531-26.648 9.966-4.718 21.857-.437 26.56 9.563 4.701 10 .434 21.93-9.532 26.649-9.966 4.718-21.857.436-26.56-9.564Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#EB5757",
          d: "M42.929 32.753c-2.128-.459-9.384-1.805-16.981-.713a8.786 8.786 0 0 0-6.171 4.03c-2.475 3.927-5.975 10.93-5.235 18.234l3.884.964s2.684-8.666 5.705-12.193c0 0 3.578 8.183 3.397 12.676a7.116 7.116 0 0 1-.024.372c-.41 4.396 17.174.82 17.174.82l-1.095-23.416a.83.83 0 0 0-.654-.775Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FEBBBA",
          d: "m36.88 24.53.51 6.083c.048.566-.242 1.095-.727 1.322-1.116.522-3.259 1.27-5.55.721-.42-.1-.693-.54-.624-.989l1.486-9.643 4.904 2.505Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FEBBBA",
          d: "M30.055 17.156s-1.154 4.495-.925 6.72c.229 2.226-.017 3.734 2.596 3.77 2.612.037 4.552-1.577 5.362-3.96 0 0 1.279-3.678.65-4.999-.629-1.321-7.683-1.531-7.683-1.531Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#3A36DB",
          d: "m35.967 22.245-.322.052s.89-2.938-.349-3.23c-1.24-.292-5.998-.496-7.254-1.978-1.21-1.428-.68-3.608.507-4.385a.173.173 0 0 1 .23.045l.139.185a.175.175 0 0 0 .313-.084c.018-.149.204-.21.302-.097.383.441 1.334 1.107 3.61 1.162 3.228.078 5.505 1.02 5.902 3.187.026.137.184.19.29.099.21-.179.57-.305 1.13.034.978.588.925 2.53-.716 4.383-.078.088-.055.229.053.276.378.169.972.62-.237 1.54-1.237.942-2.05.991-2.364.962a.175.175 0 0 1-.16-.158l-.188-1.946a.175.175 0 0 0-.201-.157l-.685.11Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "url(#b)", d: "M35.953 22.661s.268-2.796 1.588-2.236c1.32.56-.144 3.108-1.092 3.363l-.496-1.127Z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#EB5757",
          d: "M43.5 49.957c.379-2.687-2.395-6.636-3.542-8.135a2.495 2.495 0 0 1-.516-1.493c-.033-3.805 1.25-5.793 3.802-7.434 0 0 9.568 10.368 7.21 18.694a7.013 7.013 0 0 1-1.148 2.334c-.372-3.137-3.986-3.821-5.807-3.966Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "url(#c)",
          d: "m43.325 48.918.353-.04c-.299-2.635-2.603-5.888-3.58-7.164l-.282.217c.96 1.253 3.22 4.44 3.51 6.987Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "url(#d)",
          d: "M43.426 50.33c.033-.121.055-.246.073-.373 1.821.145 5.435.83 5.807 3.966-4.132 5.484-15.523 3.506-15.523 3.506v-2.134s8.748-1.63 9.643-4.966Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "url(#e)", d: "M34.88 56.84s-1.682-3.982-4.645-2.57c-2.964 1.412-2.73 2.337-2.73 2.337l7.375.232Z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#3A36DB",
          d: "M35.257 57.666a.563.563 0 0 1-.58.52l-15.356-.537a.563.563 0 0 1-.517-.396l-.446-1.431a.564.564 0 0 1 .507-.732l5.6-.299a.558.558 0 0 1 .151.013l10.202 2.267c.274.06.461.315.44.595Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#6562F5", d: "m24.964 57.104-.423-1.976-5.752.275.379 1.64 5.796.06Z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#3A36DB",
          d: "M27.913 35.792c.325 2.669 1.79 13.513 2.209 16.611a.71.71 0 0 1-.724.807l-24.843-.714a.71.71 0 0 1-.673-.557L.017 34.476a.712.712 0 0 1 .735-.866l26.497 1.557a.71.71 0 0 1 .664.624Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#3A36DB",
          d: "m17.926 46.79 3.672 10.457-8.538.182-.71-10.576a.82.82 0 0 1 .871-.875l3.987.266a.82.82 0 0 1 .719.547Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#3A36DB",
          d: "M25.06 57.396a.445.445 0 0 1-.422.584h-13.37a.444.444 0 0 1-.444-.445v-.576c0-.253.21-.455.463-.444l13.37.575c.184.008.345.13.402.306Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#364153",
          d: "M31.73 25.442c2.994.787 5.333-2.038 5.356-2.067l-.183-.15c-.022.028-2.267 2.736-5.113 1.988l-.06.229Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "url(#f)",
          d: "m30.973 25.037.035-.096a.33.33 0 0 1 .424-.198l.573.211c.171.063.26.253.197.425l-.035.096a.33.33 0 0 1-.424.198l-.573-.21a.332.332 0 0 1-.197-.426Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#364153",
          d: "m32.464 24.94-1.495-.427-.213 1.068 1.281.428.427-1.068Zm5.089-5.06s-.21-5.067-3.14-6.121c0 0 .917-.23 1.733.378.816.608 2.666 3.42 2.139 6.011-.645.084-.732-.268-.732-.268Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#364153",
          d: "M38.12 19.68c1.607.646 1.016 2.726 1.016 2.726-.16 1.559-.746 2.238-1.385 2.496a1.336 1.336 0 0 1-1.308-.176 1.347 1.347 0 0 1-.523-1.216c.045-.424.083-.828.077-.975-.012-.355.517-3.501 2.123-2.855Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#28313F",
          d: "M37.87 20.187a.77.77 0 0 1 .745.6c.574 2.502-.925 3.785-1.532 3.706-.64-.083-.07-3.14.208-3.899.117-.318.348-.409.578-.407Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#91B3FA",
          d: "m28.276 46.873.198-.025-1.22-9.659a1.266 1.266 0 0 0-1.178-1.106L3.178 34.695l-.012.2 22.898 1.388c.51.03.927.422.992.931l1.22 9.659Zm.547 2.727-.198.024.262 2.091.198-.025-.262-2.09Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#BECDFA",
          d: "M20.388 24.626S-1.925 13.565 5.372 5.42C12.67-2.724 26.274.531 26.962 9.103c.69 8.572-15.868 6.561-6.574 15.523Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#6562F5",
          d: "M7.035 7.524c0 .125.1.226.225.226h9.848a.225.225 0 0 0 0-.452H7.26a.225.225 0 0 0-.225.226Zm12.995.226h2.922a.225.225 0 0 0 0-.452H20.03a.225.225 0 0 0 0 .451ZM6.703 9.524c0 .125.1.226.225.226h3.698a.225.225 0 0 0 0-.452H6.928a.225.225 0 0 0-.225.226Zm9.123 0c0 .125.1.226.225.226h6.57a.225.225 0 0 0 0-.452h-6.57a.225.225 0 0 0-.225.226Zm-9.23 2.226h9.83a.225.225 0 0 0 0-.451h-9.83a.225.225 0 0 0 0 .451Zm12.291 0h3.403a.225.225 0 0 0 0-.451h-3.403a.225.225 0 0 0 0 .451Z"
        }
      )
    ] }),
    /* @__PURE__ */ jsxs("defs", { children: [
      /* @__PURE__ */ jsxs("linearGradient", { id: "b", x1: "36.412", x2: "29.89", y1: "21.947", y2: "20.245", gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#FEBBBA" }),
        /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#FF928E" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: "c", x1: "73.798", x2: "11.65", y1: "12.078", y2: "76.265", gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#E1473D" }),
        /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#E9605A" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: "d", x1: "44.473", x2: "37.683", y1: "46.877", y2: "64.684", gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#FEBBBA" }),
        /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#FF928E" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: "e", x1: "36.1", x2: "29.31", y1: "43.684", y2: "61.491", gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#FEBBBA" }),
        /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#FF928E" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: "f", x1: "30.95", x2: "32.22", y1: "25.211", y2: "25.211", gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#4F52FF" }),
        /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#4042E2" })
      ] }),
      /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h99v66H0z" }) })
    ] })
  ] }) : /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsxs("g", { clipPath: "url(#a)", children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#28313F",
          d: "M64.437 57.258c-1.334 1.415-2.598 2.328-3.596 3.05-11.73 8.476-25.61 6.006-28.56 5.402-4.356-.891-12.776-2.614-18.863-9.824-9.21-10.909-7.777-28.096-.633-39.44 1.307-2.076 8.21-13.594 22.24-15.44 8.49-1.118 18.387 1.136 25.554 7.184 15.045 12.695 13.974 38.342 3.858 49.068Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1A202C",
          d: "m5.87 51.567 1.769 2.947a2.689 2.689 0 0 0 2.867 1.25l2.662-.57a2.246 2.246 0 0 1 2.004.567 24.039 24.039 0 0 0 4.41 3.267 2.261 2.261 0 0 1 1.13 1.757l.241 2.723a2.698 2.698 0 0 0 2.032 2.383l3.328.83a2.688 2.688 0 0 0 2.907-1.152l1.484-2.293a2.252 2.252 0 0 1 1.819-1.021 23.958 23.958 0 0 0 5.421-.815 2.245 2.245 0 0 1 2.035.44l2.087 1.753c.88.74 2.132.838 3.116.243l2.938-1.774a2.705 2.705 0 0 0 1.245-2.876l-.567-2.672a2.264 2.264 0 0 1 .564-2.01 24.112 24.112 0 0 0 3.256-4.425 2.252 2.252 0 0 1 1.751-1.135l2.715-.241a2.694 2.694 0 0 0 2.374-2.039l.827-3.339a2.705 2.705 0 0 0-1.147-2.917l-2.285-1.488a2.261 2.261 0 0 1-1.018-1.825 24.195 24.195 0 0 0-.812-5.44 2.263 2.263 0 0 1 .439-2.041l1.747-2.095a2.706 2.706 0 0 0 .242-3.126l-1.768-2.948a2.689 2.689 0 0 0-2.867-1.249l-2.662.569a2.246 2.246 0 0 1-2.003-.567 24.035 24.035 0 0 0-4.411-3.267 2.261 2.261 0 0 1-1.13-1.756l-.241-2.723a2.698 2.698 0 0 0-2.032-2.383l-3.328-.83a2.688 2.688 0 0 0-2.907 1.151l-1.484 2.293a2.25 2.25 0 0 1-1.818 1.021 23.97 23.97 0 0 0-5.422.816 2.248 2.248 0 0 1-2.035-.441l-2.087-1.753a2.685 2.685 0 0 0-3.116-.243l-2.938 1.774a2.704 2.704 0 0 0-1.245 2.876l.567 2.672a2.264 2.264 0 0 1-.564 2.01 24.108 24.108 0 0 0-3.257 4.425 2.252 2.252 0 0 1-1.75 1.135l-2.714.241a2.695 2.695 0 0 0-2.375 2.04l-.827 3.338a2.705 2.705 0 0 0 1.147 2.917l2.286 1.488a2.262 2.262 0 0 1 1.017 1.825 24.19 24.19 0 0 0 .813 5.44 2.264 2.264 0 0 1-.44 2.041L6.114 48.44a2.708 2.708 0 0 0-.242 3.127Zm7.746-5.025c-4.702-10-.435-21.93 9.531-26.648 9.966-4.718 21.857-.437 26.56 9.563 4.701 10 .434 21.93-9.532 26.649-9.966 4.718-21.857.436-26.56-9.564Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#EB5757",
          d: "M42.929 32.753c-2.128-.459-9.384-1.805-16.981-.713a8.787 8.787 0 0 0-6.171 4.03c-2.475 3.927-5.975 10.93-5.235 18.234l3.884.964s2.684-8.666 5.705-12.193c0 0 3.578 8.183 3.397 12.676a7.112 7.112 0 0 1-.024.372c-.41 4.396 17.174.82 17.174.82l-1.095-23.416a.83.83 0 0 0-.654-.775Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FEBBBA",
          d: "m36.88 24.53.51 6.083c.048.566-.242 1.095-.727 1.322-1.116.522-3.259 1.27-5.55.721-.42-.1-.693-.54-.624-.989l1.486-9.643 4.904 2.505Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FEBBBA",
          d: "M30.055 17.156s-1.154 4.495-.925 6.72c.229 2.226-.017 3.734 2.596 3.77 2.612.037 4.552-1.577 5.362-3.96 0 0 1.279-3.678.65-4.999-.629-1.321-7.683-1.531-7.683-1.531Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#605CFF",
          d: "m35.967 22.245-.322.052s.89-2.938-.349-3.23c-1.24-.292-5.998-.496-7.254-1.978-1.21-1.428-.68-3.608.507-4.385a.173.173 0 0 1 .23.045l.139.185a.175.175 0 0 0 .313-.084c.018-.149.204-.21.302-.097.383.442 1.334 1.107 3.61 1.162 3.228.078 5.505 1.02 5.902 3.187.026.137.184.19.29.099.21-.179.57-.305 1.13.034.978.588.925 2.53-.716 4.383-.078.088-.055.229.053.276.378.169.972.62-.237 1.54-1.237.942-2.05.991-2.364.962a.175.175 0 0 1-.16-.158l-.188-1.946a.175.175 0 0 0-.201-.156l-.685.11Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "url(#b)", d: "M35.953 22.661s.268-2.796 1.588-2.236c1.32.56-.144 3.108-1.092 3.363l-.496-1.127Z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#EB5757",
          d: "M43.5 49.957c.379-2.687-2.395-6.636-3.542-8.135a2.495 2.495 0 0 1-.516-1.493c-.033-3.805 1.25-5.793 3.802-7.434 0 0 9.568 10.368 7.21 18.694a7.012 7.012 0 0 1-1.148 2.334c-.372-3.137-3.986-3.821-5.807-3.966Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "url(#c)",
          d: "m43.325 48.918.353-.04c-.299-2.635-2.603-5.888-3.58-7.164l-.282.217c.96 1.253 3.22 4.44 3.51 6.987Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "url(#d)",
          d: "M43.426 50.33c.033-.121.055-.246.073-.373 1.821.145 5.435.83 5.807 3.966-4.132 5.484-15.523 3.506-15.523 3.506v-2.134s8.748-1.63 9.643-4.966Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "url(#e)", d: "M34.88 56.84s-1.682-3.982-4.645-2.57c-2.964 1.413-2.73 2.337-2.73 2.337l7.375.233Z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#605CFF",
          d: "M35.257 57.666a.563.563 0 0 1-.58.52l-15.356-.537a.563.563 0 0 1-.517-.396l-.446-1.431a.564.564 0 0 1 .507-.732l5.6-.299a.554.554 0 0 1 .151.013l10.202 2.267c.274.06.461.315.44.595Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "url(#f)", d: "m24.964 57.104-.423-1.976-5.752.276.379 1.639 5.796.06Z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#605CFF",
          d: "M27.913 35.792c.325 2.669 1.79 13.513 2.209 16.611a.71.71 0 0 1-.724.807l-24.843-.714a.71.71 0 0 1-.673-.557L.017 34.476a.712.712 0 0 1 .735-.866l26.497 1.557a.71.71 0 0 1 .664.624Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#605CFF",
          d: "m17.926 46.79 3.672 10.457-8.538.182-.71-10.576a.82.82 0 0 1 .871-.875l3.987.266a.82.82 0 0 1 .719.547Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#605CFF",
          d: "M25.06 57.396a.445.445 0 0 1-.422.584h-13.37a.444.444 0 0 1-.444-.445v-.576c0-.253.21-.455.463-.444l13.37.575c.184.008.345.13.402.306Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#364153",
          d: "M31.73 25.442c2.994.787 5.333-2.038 5.356-2.067l-.183-.15c-.022.028-2.267 2.736-5.113 1.988l-.06.229Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "url(#g)",
          d: "m30.973 25.037.035-.096a.33.33 0 0 1 .424-.198l.573.211c.171.063.26.253.197.425l-.035.097a.33.33 0 0 1-.424.197l-.573-.21a.332.332 0 0 1-.197-.426Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#364153",
          d: "m32.464 24.94-1.495-.426-.213 1.067 1.281.428.427-1.068Zm5.089-5.06s-.21-5.067-3.14-6.121c0 0 .917-.23 1.733.378.816.608 2.666 3.42 2.139 6.012-.645.083-.732-.27-.732-.27Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#364153",
          d: "M38.12 19.68c1.607.646 1.016 2.726 1.016 2.726-.16 1.559-.746 2.238-1.385 2.496a1.336 1.336 0 0 1-1.308-.176 1.347 1.347 0 0 1-.523-1.216c.045-.424.083-.828.077-.975-.012-.355.517-3.501 2.123-2.855Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#28313F",
          d: "M37.87 20.187a.771.771 0 0 1 .745.6c.574 2.502-.925 3.785-1.532 3.706-.64-.083-.07-3.14.208-3.899.117-.318.348-.409.578-.407Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#91B3FA",
          d: "m28.276 46.873.198-.025-1.22-9.659a1.266 1.266 0 0 0-1.178-1.106L3.178 34.695l-.012.2 22.898 1.388c.51.03.927.422.992.931l1.22 9.659Zm.547 2.727-.198.024.262 2.091.198-.025-.262-2.09Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#BECDFA",
          d: "M20.388 24.626S-1.925 13.565 5.372 5.42C12.67-2.724 26.274.531 26.962 9.103c.69 8.572-15.868 6.561-6.574 15.523Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M7.035 7.524c0 .124.1.225.225.225h9.848a.225.225 0 0 0 0-.451H7.26a.225.225 0 0 0-.225.226Zm12.995.226h2.922a.225.225 0 0 0 0-.452H20.03a.225.225 0 0 0 0 .451ZM6.703 9.524c0 .125.1.226.225.226h3.698a.225.225 0 0 0 0-.452H6.928a.225.225 0 0 0-.225.226Zm9.123 0c0 .125.1.226.225.226h6.57a.225.225 0 0 0 0-.452h-6.57a.225.225 0 0 0-.225.226Zm-9.23 2.226h9.83a.225.225 0 0 0 0-.451h-9.83a.225.225 0 0 0 0 .451Zm12.291 0h3.403a.225.225 0 0 0 0-.451h-3.403a.225.225 0 0 0 0 .451Z"
        }
      )
    ] }),
    /* @__PURE__ */ jsxs("defs", { children: [
      /* @__PURE__ */ jsxs("linearGradient", { id: "b", x1: "36.412", x2: "29.89", y1: "21.947", y2: "20.245", gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#FEBBBA" }),
        /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#FF928E" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: "c", x1: "73.798", x2: "11.65", y1: "12.078", y2: "76.265", gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#E1473D" }),
        /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#E9605A" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: "d", x1: "44.473", x2: "37.683", y1: "46.877", y2: "64.684", gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#FEBBBA" }),
        /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#FF928E" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: "e", x1: "36.1", x2: "29.31", y1: "43.684", y2: "61.492", gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#FEBBBA" }),
        /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#FF928E" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: "f", x1: "18.839", x2: "22.348", y1: "52.189", y2: "56.693", gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#4F52FF" }),
        /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#4042E2" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: "g", x1: "30.95", x2: "32.22", y1: "25.211", y2: "25.211", gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsx("stop", { stopColor: "#4F52FF" }),
        /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#4042E2" })
      ] }),
      /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h99v66H0z" }) })
    ] })
  ] });
}, TableCross = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#D2DFFA",
        d: "M86.77 51.826c-5.814 20.268-47.852 13.918-61.33 10.321C16.356 65.431 0 58.863 0 38.22c0-8.914 13.175-7.507 22.26-19.705C31.347 6.317 41.796-2.597 54.517.687 67.236 3.97 94.04 26.49 86.77 51.826Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#605CFF", d: "M9.42 52.759V19.01h66.712v33.75H9.42Z" }),
    /* @__PURE__ */ jsx("path", { fill: "#605CFF", d: "M9.42 53.544v-9.418h.785v9.418z" }),
    /* @__PURE__ */ jsx("path", { fill: "#4541C9", d: "M24.332 36.277V19.01h.785v17.267zm0 17.267v-9.418h.785v9.418z" }),
    /* @__PURE__ */ jsx("path", { fill: "#605CFF", d: "M14.129 44.91v-9.418h.785v9.418z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#4541C9",
        d: "M76.133 53.543V19.01h.785v34.533zM9.42 9.592h67.497v9.418H9.42zM24.332 44.91v-9.418h.785v9.418z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#4541C9",
        d: "M9.42 35.492h67.497v.785H9.42zm0 8.633h67.497v.785H9.42zm0 8.634h67.497v.785H9.42zm0-25.9h67.497v.785H9.42z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#06152B",
        d: "m4.578 40.201.354-.353.353.353-.353.354-.354-.354Zm-3.27.5a.5.5 0 1 1 0-1v1Zm1.662-2.816 1.962 1.963-.707.707-1.963-1.962.708-.708Zm1.962 2.67L2.97 42.517l-.708-.707 1.963-1.962.707.707Zm-.354.146h-3.27v-1h3.27v1Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { stroke: "#06152B", d: "M6.541 37.912v4.578" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#BECDFA",
        d: "M14.12 26.335v-.445h.69m4.139.445v-.445h-.575m0 0-.581-1.892m.581 1.892-1.782-1.13m1.782 1.13h-1.782m-1.783 0 .581-1.892m-.58 1.892 1.782-1.13m-1.783 1.13h1.783m-1.093-4.119h2.07m.224 2.227-1.201.762m1.2-.762h-1.2m1.2 0-.453-1.478m-1.949 1.478 1.202.762m-1.202-.762h1.202m-1.202 0 .454-1.478m.748 2.24v1.13m0-1.892.747-1.478m-.747 1.478-.748-1.478m1.495 0-.23-.749v-.668h-1.035v.668l-.23.749m1.495 0h-1.495M14.12 34.184v-.445h.69m4.139.445v-.445h-.575m0 0-.581-1.893m.581 1.893-1.782-1.13m1.782 1.13h-1.782m-1.783 0 .581-1.893m-.58 1.893 1.782-1.13m-1.783 1.13h1.783m-1.093-4.12h2.07m.224 2.227-1.201.762m1.2-.762h-1.2m1.2 0-.453-1.477m-1.949 1.477 1.202.762m-1.202-.762h1.202m-1.202 0 .454-1.477m.748 2.24v1.13m0-1.893.747-1.477m-.747 1.477-.748-1.477m1.495 0-.23-.75v-.667h-1.035v.668l-.23.748m1.495 0h-1.495M14.12 42.817v-.445h.69m4.139.445v-.445h-.575m0 0-.581-1.893m.581 1.893-1.782-1.13m1.782 1.13h-1.782m-1.783 0 .581-1.893m-.58 1.893 1.782-1.13m-1.783 1.13h1.783m-1.093-4.12h2.07m.224 2.227-1.201.762m1.2-.762h-1.2m1.2 0-.453-1.477m-1.949 1.477 1.202.762m-1.202-.762h1.202m-1.202 0 .454-1.477m.748 2.24v1.13m0-1.893.747-1.477m-.747 1.477-.748-1.477m1.495 0-.23-.75v-.667h-1.035v.668l-.23.749m1.495 0h-1.495M14.12 51.45v-.445h.69m4.139.446v-.446h-.575m0 0-.581-1.892m.581 1.892-1.782-1.13m1.782 1.13h-1.782m-1.783 0 .581-1.892m-.58 1.892 1.782-1.13m-1.783 1.13h1.783m-1.093-4.119h2.07m.224 2.227-1.201.762m1.2-.762h-1.2m1.2 0-.453-1.478m-1.949 1.478 1.202.762m-1.202-.762h1.202m-1.202 0 .454-1.478m.748 2.24v1.13m0-1.892.747-1.478m-.747 1.478-.748-1.478m1.495 0-.23-.749v-.668h-1.035v.668l-.23.75m1.495 0h-1.495"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#fff",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M27.47 22.934h18.837M30.61 31.568h18.836m-21.192 8.633H47.09m-18.836 8.633h14.912M54.94 31.568h18.836m-21.19 8.633h18.836m-24.33 8.633h14.912m-8.634-25.9h18.836"
      }
    ),
    /* @__PURE__ */ jsx("circle", { cx: "70.635", cy: "52.759", r: "8.241", fill: "#EB5757" }),
    /* @__PURE__ */ jsx("path", { stroke: "#fff", strokeLinecap: "round", d: "m66.975 56.421 7.325-7.325m0 7.325-7.325-7.325" })
  ] }) : /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#28313F",
        d: "M86.77 51.826c-5.814 20.268-47.852 13.918-61.33 10.321C16.356 65.431 0 58.863 0 38.22c0-8.914 13.175-7.507 22.26-19.705C31.347 6.317 41.796-2.597 54.517.687 67.236 3.97 94.04 26.49 86.77 51.826Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#605CFF", d: "M9.42 52.759V19.01h66.712v33.75H9.42Z" }),
    /* @__PURE__ */ jsx("path", { fill: "#605CFF", d: "M9.42 53.544v-9.418h.785v9.418z" }),
    /* @__PURE__ */ jsx("path", { fill: "#4541C9", d: "M24.332 36.277V19.01h.785v17.267zm0 17.267v-9.418h.785v9.418z" }),
    /* @__PURE__ */ jsx("path", { fill: "#605CFF", d: "M14.129 44.91v-9.418h.785v9.418z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#4541C9",
        d: "M76.133 53.543V19.01h.785v34.533zM9.42 9.592h67.497v9.418H9.42zM24.332 44.91v-9.418h.785v9.418z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#4541C9",
        d: "M9.42 35.492h67.497v.785H9.42zm0 8.633h67.497v.785H9.42zm0 8.634h67.497v.785H9.42zm0-25.9h67.497v.785H9.42z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#CCD2E3",
        d: "m4.578 40.201.354-.353.353.353-.353.354-.354-.354Zm-3.27.5a.5.5 0 0 1 0-1v1Zm1.662-2.816 1.962 1.963-.707.707-1.963-1.962.708-.708Zm1.962 2.67L2.97 42.517l-.708-.707 1.963-1.962.707.707Zm-.354.146h-3.27v-1h3.27v1Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { stroke: "#CCD2E3", d: "M6.541 37.912v4.578" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#BECDFA",
        d: "M14.12 26.335v-.445h.69m4.139.445v-.445h-.575m0 0-.581-1.892m.581 1.892-1.782-1.13m1.782 1.13h-1.782m-1.783 0 .581-1.892m-.58 1.892 1.782-1.13m-1.783 1.13h1.783m-1.093-4.119h2.07m.224 2.227-1.201.762m1.2-.762h-1.2m1.2 0-.453-1.478m-1.949 1.478 1.202.762m-1.202-.762h1.202m-1.202 0 .454-1.478m.748 2.24v1.13m0-1.892.747-1.478m-.747 1.478-.748-1.478m1.495 0-.23-.749v-.668h-1.035v.668l-.23.75m1.495 0h-1.495M14.12 34.184v-.445h.69m4.139.445v-.445h-.575m0 0-.581-1.893m.581 1.893-1.782-1.13m1.782 1.13h-1.782m-1.783 0 .581-1.893m-.58 1.893 1.782-1.13m-1.783 1.13h1.783m-1.093-4.12h2.07m.224 2.227-1.201.762m1.2-.762h-1.2m1.2 0-.453-1.477m-1.949 1.477 1.202.762m-1.202-.762h1.202m-1.202 0 .454-1.477m.748 2.24v1.13m0-1.893.747-1.477m-.747 1.477-.748-1.477m1.495 0-.23-.75v-.667h-1.035v.668l-.23.748m1.495 0h-1.495M14.12 42.817v-.445h.69m4.139.445v-.445h-.575m0 0-.581-1.892m.581 1.892-1.782-1.13m1.782 1.13h-1.782m-1.783 0 .581-1.892m-.58 1.892 1.782-1.13m-1.783 1.13h1.783m-1.093-4.12h2.07m.224 2.227-1.201.762m1.2-.761h-1.2m1.2 0-.453-1.478m-1.949 1.477 1.202.762m-1.202-.761h1.202m-1.202 0 .454-1.478m.748 2.24v1.13m0-1.892.747-1.478m-.747 1.477-.748-1.477m1.495 0-.23-.75v-.667h-1.035v.668l-.23.749m1.495 0h-1.495M14.12 51.45v-.445h.69m4.139.446v-.446h-.575m0 0-.581-1.892m.581 1.892-1.782-1.13m1.782 1.13h-1.782m-1.783 0 .581-1.892m-.58 1.892 1.782-1.13m-1.783 1.13h1.783m-1.093-4.119h2.07m.224 2.227-1.201.762m1.2-.762h-1.2m1.2 0-.453-1.478m-1.949 1.478 1.202.762m-1.202-.762h1.202m-1.202 0 .454-1.478m.748 2.24v1.13m0-1.892.747-1.478m-.747 1.478-.748-1.478m1.495 0-.23-.749v-.668h-1.035v.668l-.23.75m1.495 0h-1.495"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M27.47 22.934h18.837M30.61 31.568h18.836m-21.192 8.633H47.09m-18.836 8.633h14.912M54.94 31.568h18.836m-21.19 8.633h18.836m-24.33 8.633h14.912m-8.634-25.9h18.836"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#EB5757",
        fillRule: "evenodd",
        d: "M78.876 52.759a8.24 8.24 0 1 1-16.481 0 8.24 8.24 0 0 1 16.481 0ZM66.62 56.775a.5.5 0 0 1 0-.707l3.31-3.31-3.31-3.308a.5.5 0 1 1 .707-.707l3.31 3.309 3.309-3.31a.5.5 0 1 1 .707.708l-3.31 3.309 3.31 3.309a.5.5 0 1 1-.707.707l-3.31-3.31-3.309 3.31a.5.5 0 0 1-.707 0Z",
        clipRule: "evenodd"
      }
    )
  ] });
}, Mail = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#D2DFFA",
        d: "M88.097 51.319C82.194 71.389 39.513 65.1 25.83 61.539 16.605 64.791 0 58.287 0 37.846c0-8.827 13.376-7.433 22.6-19.512C31.827 6.254 42.435-2.572 55.35.68c12.914 3.252 40.127 25.552 32.747 50.639Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#4541C9",
        d: "M5.791 30.544a8 8 0 0 1 2.918-6.178l24.328-20.01a8 8 0 0 1 10.087-.062l25.026 20.07a8 8 0 0 1 2.996 6.241v25.406a8 8 0 0 1-8 8H13.79a8 8 0 0 1-8-8V30.544Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#EB5757",
        d: "M19.855 13.72a1 1 0 0 1 1-1h35.228a1 1 0 0 1 1 1v29.717l-18.614 8.165-18.614-8.165V13.72Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#974146",
        fillRule: "evenodd",
        d: "M50.463 22.647c0 .914-.74 1.655-1.655 1.655H27.3a1.655 1.655 0 0 1 0-3.31h21.51c.913 0 1.654.741 1.654 1.655Zm0 6.618c0 .914-.74 1.655-1.655 1.655H27.3a1.655 1.655 0 0 1 0-3.31h21.51c.913 0 1.654.742 1.654 1.655Zm0 6.619c0 .913-.74 1.654-1.655 1.654H27.3a1.655 1.655 0 0 1 0-3.309h21.51c.913 0 1.654.74 1.654 1.655Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#6562F5",
        d: "m5.791 29.265 28.166 17.09a8 8 0 0 0 8.223.045l28.966-17.135v26.746a8 8 0 0 1-8 8H13.79a8 8 0 0 1-8-8V29.265Z"
      }
    )
  ] }) : /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#28313F",
        d: "M88.097 51.319C82.194 71.389 39.513 65.1 25.83 61.539 16.605 64.791 0 58.287 0 37.846c0-8.827 13.376-7.433 22.6-19.512C31.827 6.254 42.435-2.572 55.35.68c12.914 3.252 40.127 25.552 32.747 50.639Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#4541C9",
        d: "M5.791 30.544a8 8 0 0 1 2.918-6.178l24.328-20.01a8 8 0 0 1 10.087-.062l25.026 20.07a8 8 0 0 1 2.996 6.241v25.406a8 8 0 0 1-8 8H13.79a8 8 0 0 1-8-8V30.544Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#EB5757",
        d: "M19.855 13.72a1 1 0 0 1 1-1h35.228a1 1 0 0 1 1 1v29.717l-18.614 8.165-18.614-8.165V13.72Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#605CFF",
        d: "m5.791 29.265 28.166 17.09a8 8 0 0 0 8.223.045l28.966-17.135v26.746a8 8 0 0 1-8 8H13.79a8 8 0 0 1-8-8V29.265Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#1A202C",
        fillRule: "evenodd",
        d: "M50.463 22.647c0 .914-.74 1.655-1.655 1.655H27.3a1.655 1.655 0 1 1 0-3.31h21.51c.913 0 1.654.741 1.654 1.655Zm0 6.618c0 .914-.74 1.655-1.655 1.655H27.3a1.655 1.655 0 0 1 0-3.31h21.51c.913 0 1.654.742 1.654 1.655Zm0 6.619c0 .913-.74 1.654-1.655 1.654H27.3a1.655 1.655 0 0 1 0-3.309h21.51c.913 0 1.654.74 1.654 1.655Z",
        clipRule: "evenodd"
      }
    )
  ] });
}, CreateLink = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsxs("g", { clipPath: "url(#a)", children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#D2DFFA",
          d: "M1.259 51.319c5.958 20.07 49.034 13.782 62.844 10.22 9.31 3.252 26.069-3.252 26.069-23.693 0-8.827-13.5-7.433-22.81-19.512C58.052 6.254 47.345-2.572 34.31.68 21.276 3.932-6.19 26.232 1.26 51.319Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#6562F5",
          fillRule: "evenodd",
          d: "M7.445 27.818v10.755H29.78V27.818H7.445Zm-.828-2.482c-.913 0-1.654.741-1.654 1.655v12.41c0 .913.74 1.654 1.654 1.654h23.991c.914 0 1.655-.741 1.655-1.655V26.991c0-.914-.74-1.655-1.655-1.655H6.618Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          stroke: "#6562F5",
          strokeLinecap: "round",
          strokeWidth: "5",
          d: "M38.88 13.755V3m0 49.148v10.754m-12.7-46.327L18.76 8.79m7.42 40.536-7.42 7.784m32.555-40.536 7.421-7.784m-7.42 40.536 7.42 7.784"
        }
      ),
      /* @__PURE__ */ jsx("path", { stroke: "#EB5757", strokeLinecap: "round", strokeWidth: "2", d: "M39.709 28.232v5.79m-2.895-2.895h5.791" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#3A36DB",
          fillRule: "evenodd",
          d: "M52.03 24.277 49.864 35.54l22.02 4.238 2.167-11.262-22.02-4.238Zm-.343-2.593a1.655 1.655 0 0 0-1.937 1.312l-2.48 12.887a1.655 1.655 0 0 0 1.312 1.937l23.644 4.55a1.655 1.655 0 0 0 1.937-1.312l2.48-12.887a1.655 1.655 0 0 0-1.312-1.937l-23.644-4.55Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("mask", { id: "b", width: "39", height: "32", x: "18", y: "18", maskUnits: "userSpaceOnUse", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#4541C9",
          d: "M30.609 41.055c.913 0 1.654-.741 1.654-1.655v-6.204l18.2-.828 1.655-8.686 4.136 10.754-9.1 6.205-15.304 9.1-10.755-3.723-2.482-4.963 4.964-17.373 26.886-5.377-.413 4.136-1.655 7.445-19.027 2.069.414 6.618h-4.964l-.207 2.482h5.998Z"
        }
      ) }),
      /* @__PURE__ */ jsx("g", { mask: "url(#b)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#EB5757",
          fillRule: "evenodd",
          d: "m26.358 29.724 3.603 10.888 21.288-7.043-3.602-10.888-21.289 7.043Zm-1.564-2.096a1.655 1.655 0 0 0-1.052 2.09l4.122 12.46a1.655 1.655 0 0 0 2.09 1.05l22.86-7.562a1.655 1.655 0 0 0 1.051-2.09l-4.122-12.46a1.654 1.654 0 0 0-2.09-1.05l-22.86 7.562Z",
          clipRule: "evenodd"
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h99v66H0z" }) }) })
  ] }) : /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsxs("g", { clipPath: "url(#a)", children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#28313F",
          d: "M1.259 51.319c5.958 20.07 49.034 13.782 62.844 10.22 9.31 3.252 26.069-3.252 26.069-23.693 0-8.827-13.5-7.433-22.81-19.512C58.052 6.254 47.345-2.572 34.31.68 21.276 3.932-6.19 26.232 1.26 51.319Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#605CFF",
          fillRule: "evenodd",
          d: "M7.445 27.818v10.755H29.78V27.818H7.445Zm-.828-2.482c-.913 0-1.654.741-1.654 1.655V39.4c0 .914.74 1.654 1.654 1.654h23.991c.914 0 1.655-.74 1.655-1.654V26.99c0-.913-.74-1.654-1.655-1.654H6.618Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          stroke: "#1A202C",
          strokeLinecap: "round",
          strokeWidth: "5",
          d: "M38.88 13.755V3m0 49.148v10.754m-12.7-46.327L18.76 8.79m7.42 40.537-7.42 7.784m32.555-40.536 7.421-7.784m-7.421 40.536 7.421 7.784"
        }
      ),
      /* @__PURE__ */ jsx("path", { stroke: "#EB5757", strokeLinecap: "round", strokeWidth: "2", d: "M39.709 28.232v5.79m-2.894-2.895h5.79" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#4541C9",
          fillRule: "evenodd",
          d: "M52.03 24.277 49.864 35.54l22.02 4.238 2.167-11.262-22.02-4.238Zm-.343-2.593a1.655 1.655 0 0 0-1.937 1.312l-2.48 12.887a1.655 1.655 0 0 0 1.312 1.937l23.644 4.55a1.655 1.655 0 0 0 1.937-1.312l2.48-12.887a1.655 1.655 0 0 0-1.312-1.937l-23.644-4.55Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("mask", { id: "b", width: "39", height: "32", x: "18", y: "18", maskUnits: "userSpaceOnUse", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#4541C9",
          d: "M30.609 41.054c.913 0 1.654-.74 1.654-1.654v-6.204l18.2-.828 1.655-8.686 4.136 10.754-9.1 6.205-15.304 9.1-10.755-3.723-2.482-4.964 4.964-17.372 26.886-5.377-.413 4.136-1.655 7.445-19.027 2.069.414 6.618h-4.964l-.207 2.481h5.998Z"
        }
      ) }),
      /* @__PURE__ */ jsx("g", { mask: "url(#b)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#EB5757",
          fillRule: "evenodd",
          d: "m26.358 29.724 3.603 10.888 21.288-7.043-3.602-10.888-21.289 7.043Zm-1.564-2.096a1.655 1.655 0 0 0-1.052 2.09l4.122 12.46a1.655 1.655 0 0 0 2.09 1.05l22.86-7.562a1.655 1.655 0 0 0 1.051-2.09l-4.122-12.46a1.655 1.655 0 0 0-2.09-1.05l-22.86 7.562Z",
          clipRule: "evenodd"
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h99v66H0z" }) }) })
  ] });
}, CloseNotSave = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#D2DFFA",
        d: "M90.707 51.38C84.63 71.36 40.684 65.1 26.595 61.556 17.097 64.792 0 58.318 0 37.969c0-8.787 13.772-7.4 23.27-19.424C32.77 6.521 43.691-2.266 56.99.971c13.297 3.237 41.317 25.436 33.718 50.41Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#3A36DB", d: "M7.596 41.47V21.707h74.269l-.001 19.765H7.596Z" }),
    /* @__PURE__ */ jsx("ellipse", { cx: "76.801", cy: "25", fill: "#F1F4FA", rx: ".844", ry: ".824" }),
    /* @__PURE__ */ jsx("ellipse", { cx: "73.424", cy: "25", fill: "#BECDFA", rx: ".844", ry: ".824" }),
    /* @__PURE__ */ jsx("ellipse", { cx: "70.049", cy: "25", fill: "#6562F5", rx: ".844", ry: ".824" }),
    /* @__PURE__ */ jsx("path", { fill: "#EB5757", d: "M13.504 29.118h59.922v4.94H13.504v-4.94Z" }),
    /* @__PURE__ */ jsx("path", { fill: "#F1F4FA", d: "M52.084 47.484c0-.636.515-1.15 1.15-1.15h2.12c.636 0 1.15.514 1.15 1.15h-4.42Z" }),
    /* @__PURE__ */ jsx("path", { fill: "#6562F5", d: "M24.475 6.235a1 1 0 0 1 1-1h35.978a1 1 0 0 1 1 1v27.93H24.475V6.236Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#F1F4FA",
        strokeLinecap: "round",
        strokeWidth: "2",
        d: "M37.133 26.647a8.55 8.55 0 0 1 6.752-3.294 8.55 8.55 0 0 1 6.751 3.294m-15.191-9.025L39.7 13.47m0 4.152-4.255-4.151m12.625 4.151 4.255-4.151m-.001 4.151L48.07 13.47"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#6562F5",
        d: "M24.475 41.47h1.997v23h-1.998v-23Zm3.998 0h1.998v13h-1.998v-13Zm0 15h1.998v4h-1.998v-4Zm3.997-15h1.999v20H32.47v-20Zm3.999 0h1.998v7h-1.998v-7Zm0 9h1.998v10h-1.998v-10Zm3.998-9h1.998v23h-1.998v-23Zm3.998 0h1.998v20h-1.998v-20Zm3.995 0h1.999v12H48.46v-12Zm0 14h1.999v5H48.46v-5Zm3.999-14h1.998v23h-1.998v-23Zm3.998 0h1.998v15h-1.998v-15Zm0 17h1.998v2h-1.998v-2Zm3.998-17h1.998v20h-1.998v-20Z"
      }
    )
  ] }) : /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#28313F",
        d: "M90.707 51.38C84.63 71.36 40.684 65.1 26.595 61.556 17.097 64.792 0 58.318 0 37.97c0-8.787 13.772-7.4 23.27-19.424C32.77 6.521 43.691-2.266 56.99.971c13.297 3.237 41.317 25.436 33.718 50.41Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#4541C9", d: "M7.596 41.47V21.707h74.269l-.001 19.765H7.596Z" }),
    /* @__PURE__ */ jsx("ellipse", { cx: "76.801", cy: "25", fill: "#28313F", rx: ".844", ry: ".824" }),
    /* @__PURE__ */ jsx("ellipse", { cx: "73.424", cy: "25", fill: "#1A202C", rx: ".844", ry: ".824" }),
    /* @__PURE__ */ jsx("ellipse", { cx: "70.049", cy: "25", fill: "#605CFF", rx: ".844", ry: ".824" }),
    /* @__PURE__ */ jsx("path", { fill: "#EB5757", d: "M13.504 29.118h59.922v4.94H13.504v-4.94Z" }),
    /* @__PURE__ */ jsx("path", { fill: "#28313F", d: "M52.084 47.484c0-.636.515-1.15 1.15-1.15h2.12c.636 0 1.15.514 1.15 1.15h-4.42Z" }),
    /* @__PURE__ */ jsx("path", { fill: "#7471FF", d: "M24.475 6.235a1 1 0 0 1 1-1h35.978a1 1 0 0 1 1 1v27.93H24.475V6.236Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#28313F",
        strokeLinecap: "round",
        strokeWidth: "2",
        d: "M37.133 26.647a8.55 8.55 0 0 1 6.752-3.294 8.55 8.55 0 0 1 6.751 3.294m-15.191-9.025 4.255-4.151m0 4.151-4.255-4.151m12.625 4.151 4.255-4.151m-.001 4.151-4.254-4.151"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#7471FF",
        d: "M24.475 41.47h1.997v23h-1.998v-23Zm3.998 0h1.998v13h-1.998v-13Zm0 15h1.998v4h-1.998v-4Zm3.997-15h1.999v20H32.47v-20Zm3.999 0h1.998v7h-1.998v-7Zm0 9h1.998v10h-1.998v-10Zm3.998-9h1.998v23h-1.998v-23Zm3.998 0h1.998v20h-1.998v-20Zm3.995 0h1.999v12H48.46v-12Zm0 14h1.999v5H48.46v-5Zm3.999-14h1.998v23h-1.998v-23Zm3.998 0h1.998v15h-1.998v-15Zm0 17h1.998v2h-1.998v-2Zm3.998-17h1.998v20h-1.998v-20Z"
      }
    )
  ] });
}, NoPage = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#D2DFFA",
        d: "M37 58.5a5.5 5.5 0 0 1 5.5-5.5h31a5.5 5.5 0 1 1 0 11h-31a5.5 5.5 0 0 1-5.5-5.5Zm-13 0a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Zm0-51A5.5 5.5 0 0 1 29.5 2h21a5.5 5.5 0 1 1 0 11h-21A5.5 5.5 0 0 1 24 7.5Zm55.359 31.747H77.22a5.159 5.159 0 0 1-3.638-1.5 5.108 5.108 0 0 1-1.508-3.62c0-1.324.516-2.596 1.439-3.55a5.157 5.157 0 0 1 3.51-1.565h1.615a5.548 5.548 0 0 0 3.802-1.673A5.494 5.494 0 0 0 84 23.506c0-1.43-.56-2.806-1.56-3.833A5.548 5.548 0 0 0 78.638 18h-56.69a5.549 5.549 0 0 0-3.801 1.673 5.495 5.495 0 0 0-1.56 3.833c0 1.431.56 2.806 1.56 3.833a5.549 5.549 0 0 0 3.801 1.673h.55c1.33.05 2.587.612 3.51 1.566a5.107 5.107 0 0 1 1.438 3.549c0 1.358-.542 2.66-1.507 3.62a5.159 5.159 0 0 1-3.639 1.5h-1.902a4.409 4.409 0 0 0-3.11 1.282A4.366 4.366 0 0 0 16 43.624c0 1.16.463 2.273 1.288 3.094A4.41 4.41 0 0 0 20.398 48h58.96a4.41 4.41 0 0 0 3.11-1.282 4.365 4.365 0 0 0 0-6.189 4.409 4.409 0 0 0-3.11-1.282Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#3A36DB",
        d: "M73.705 16.796a2.89 2.89 0 0 0-2.861 3.307 2.888 2.888 0 0 0 3.276 2.434 2.89 2.89 0 0 0 2.434-3.275 2.866 2.866 0 0 0-1.134-1.896 2.864 2.864 0 0 0-1.715-.57Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#3A36DB",
        fillRule: "evenodd",
        d: "M62.434 31.605a.257.257 0 0 1-.287-.079h-.001l-2.367-2.9a.257.257 0 0 1-.02-.298l1.644-2.654a13.617 13.617 0 0 1-1.269-4.218l-2.831-1.31a.257.257 0 0 1-.147-.258l.377-3.725a.256.256 0 0 1 .196-.224l3.036-.715a13.61 13.61 0 0 1 2.09-3.879l-1.078-2.93a.257.257 0 0 1 .078-.287l2.901-2.367a.257.257 0 0 1 .297-.019l2.654 1.643a13.58 13.58 0 0 1 4.219-1.269l1.309-2.831c.045-.1.15-.158.258-.147l3.725.377c.11.01.199.09.224.196l.715 3.037a13.591 13.591 0 0 1 3.879 2.088l2.93-1.077a.257.257 0 0 1 .287.078l2.367 2.901a.258.258 0 0 1 .02.297l-1.644 2.655c.64 1.31 1.075 2.73 1.269 4.218l2.831 1.31c.1.045.159.149.148.258l-.377 3.725a.256.256 0 0 1-.197.224l-3.036.715a13.606 13.606 0 0 1-2.089 3.878l1.078 2.93a.257.257 0 0 1-.079.287l-2.9 2.367a.258.258 0 0 1-.298.02l-2.654-1.644a13.61 13.61 0 0 1-4.218 1.27l-1.31 2.83a.256.256 0 0 1-.258.148l-3.725-.377a.256.256 0 0 1-.224-.197l-.714-3.036a13.609 13.609 0 0 1-3.879-2.089l-2.93 1.078Zm11.339-2.723a9.467 9.467 0 0 1-2.705-.398l-.005-.002-.007-.002-.055-.017a6.769 6.769 0 0 1-.105-.033.219.219 0 0 1-.142-.277.22.22 0 0 1 .276-.141 8.814 8.814 0 0 0 9.65-2.934 8.762 8.762 0 0 0 1.846-4.562 8.748 8.748 0 0 0-1.94-6.461 8.757 8.757 0 0 0-5.942-3.197c-4.837-.49-9.168 3.046-9.657 7.88a8.786 8.786 0 0 0 .786 4.629.22.22 0 0 1-.105.292.22.22 0 0 1-.292-.105 9.233 9.233 0 0 1-.827-4.86c.514-5.077 5.064-8.788 10.14-8.274a9.192 9.192 0 0 1 6.236 3.356 9.184 9.184 0 0 1 2.037 6.783 9.193 9.193 0 0 1-3.356 6.237 9.185 9.185 0 0 1-5.833 2.086Zm-.076-5.436a3.769 3.769 0 0 1-3.72-3.215 3.767 3.767 0 0 1 3.174-4.272 3.737 3.737 0 0 1 2.793.702 3.74 3.74 0 0 1 1.479 2.472 3.768 3.768 0 0 1-3.727 4.313Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#6562F5",
        d: "M34.405 34.968a4.161 4.161 0 0 0-4.114 4.763 4.125 4.125 0 0 0 1.633 2.729 4.138 4.138 0 0 0 3.086.776 4.13 4.13 0 0 0 2.73-1.633 4.134 4.134 0 0 0 .777-3.086 4.165 4.165 0 0 0-4.112-3.55Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#6562F5",
        fillRule: "evenodd",
        d: "M17.787 56.71a.378.378 0 0 1-.424-.117v-.002l-3.491-4.279a.379.379 0 0 1-.029-.438l2.423-3.914a20.064 20.064 0 0 1-1.87-6.222l-4.177-1.931a.379.379 0 0 1-.217-.382l.557-5.494a.377.377 0 0 1 .29-.33l4.479-1.054a20.027 20.027 0 0 1 3.08-5.721l-1.59-4.32a.378.378 0 0 1 .117-.425l4.279-3.491a.377.377 0 0 1 .438-.029l3.915 2.423a20.064 20.064 0 0 1 6.222-1.87l1.93-4.176a.379.379 0 0 1 .383-.218l5.494.557c.16.016.294.132.33.29l1.054 4.479a20.029 20.029 0 0 1 5.721 3.08l4.321-1.59a.378.378 0 0 1 .424.117l3.491 4.279a.38.38 0 0 1 .029.438l-2.423 3.916a20.063 20.063 0 0 1 1.87 6.222l4.177 1.93a.379.379 0 0 1 .217.382l-.557 5.494a.377.377 0 0 1-.29.33L53.482 45.7a20.03 20.03 0 0 1-3.08 5.72l1.59 4.321a.378.378 0 0 1-.117.424l-4.279 3.492a.381.381 0 0 1-.438.028l-3.915-2.423a20.065 20.065 0 0 1-6.222 1.87l-1.93 4.177a.379.379 0 0 1-.382.217l-5.495-.557a.377.377 0 0 1-.33-.29l-1.054-4.477a20.029 20.029 0 0 1-5.72-3.08l-4.322 1.589Zm16.714-3.594a14.194 14.194 0 0 1-4.239-.647l-.123-.04a.747.747 0 1 1 .46-1.42 12.7 12.7 0 0 0 2.621.548l.147.014c2.11.194 4.189-.147 6.085-.964a12.62 12.62 0 0 0 2.901-1.747l.022-.017.011-.01.055-.044a12.496 12.496 0 0 0 4.561-8.478 12.486 12.486 0 0 0-2.768-9.22 12.496 12.496 0 0 0-8.478-4.561 12.51 12.51 0 0 0-9.22 2.768 12.496 12.496 0 0 0-4.562 8.478 12.528 12.528 0 0 0 1.122 6.605.75.75 0 0 1-.359.994.75.75 0 0 1-.994-.359 14.05 14.05 0 0 1-1.257-7.39 13.98 13.98 0 0 1 5.105-9.484 13.967 13.967 0 0 1 10.315-3.098 13.97 13.97 0 0 1 9.485 5.104 13.97 13.97 0 0 1 3.172 8.868c0 .48-.024.963-.073 1.446-.734 7.24-6.863 12.654-13.99 12.654Zm-.11-8.34a5.602 5.602 0 0 1-3.359-1.117 5.62 5.62 0 0 1-2.22-3.711 5.657 5.657 0 0 1 4.767-6.413 5.66 5.66 0 0 1 6.415 4.766 5.61 5.61 0 0 1-1.055 4.194 5.61 5.61 0 0 1-3.712 2.22c-.28.041-.56.06-.837.06Z",
        clipRule: "evenodd"
      }
    )
  ] }) : /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsx("rect", { width: "42", height: "11", x: "27", y: "54", fill: "#28313F", rx: "5.5" }),
    /* @__PURE__ */ jsx("rect", { width: "11", height: "11", x: "14", y: "54", fill: "#28313F", rx: "5.5" }),
    /* @__PURE__ */ jsx("rect", { width: "32", height: "11", x: "14", y: "3", fill: "#28313F", rx: "5.5" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#28313F",
        d: "M69.359 40.247H67.22a5.159 5.159 0 0 1-3.638-1.5 5.108 5.108 0 0 1-1.508-3.62c0-1.324.516-2.596 1.439-3.55a5.157 5.157 0 0 1 3.51-1.565h1.615a5.548 5.548 0 0 0 3.802-1.673A5.494 5.494 0 0 0 74 24.506c0-1.43-.56-2.806-1.56-3.833A5.548 5.548 0 0 0 68.638 19h-56.69a5.549 5.549 0 0 0-3.801 1.673 5.495 5.495 0 0 0-1.56 3.833c0 1.431.56 2.806 1.56 3.833a5.549 5.549 0 0 0 3.801 1.673h.55c1.33.05 2.587.612 3.51 1.566a5.107 5.107 0 0 1 1.438 3.549c0 1.358-.542 2.66-1.507 3.62a5.159 5.159 0 0 1-3.639 1.5h-1.902a4.409 4.409 0 0 0-3.11 1.282 4.365 4.365 0 0 0 0 6.19A4.41 4.41 0 0 0 10.398 49h58.96a4.41 4.41 0 0 0 3.11-1.282 4.365 4.365 0 0 0 0-6.189 4.409 4.409 0 0 0-3.11-1.282Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#4541C9",
        d: "M63.705 17.796a2.89 2.89 0 0 0-2.861 3.307 2.888 2.888 0 0 0 3.276 2.434 2.89 2.89 0 0 0 2.434-3.275 2.866 2.866 0 0 0-1.134-1.896 2.864 2.864 0 0 0-1.715-.57Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#4541C9",
        fillRule: "evenodd",
        d: "M52.434 32.605a.257.257 0 0 1-.287-.079h-.001l-2.367-2.9a.257.257 0 0 1-.02-.298l1.644-2.654a13.617 13.617 0 0 1-1.269-4.218l-2.831-1.31a.257.257 0 0 1-.147-.258l.377-3.725a.256.256 0 0 1 .196-.224l3.036-.715a13.61 13.61 0 0 1 2.09-3.879l-1.078-2.93a.257.257 0 0 1 .078-.287l2.901-2.367a.257.257 0 0 1 .297-.019l2.654 1.643a13.58 13.58 0 0 1 4.219-1.268l1.309-2.832c.045-.1.15-.158.258-.147l3.725.377c.11.01.199.09.224.196l.715 3.037a13.591 13.591 0 0 1 3.879 2.088l2.93-1.077a.257.257 0 0 1 .287.078l2.367 2.901a.258.258 0 0 1 .02.297l-1.644 2.655c.64 1.31 1.075 2.73 1.269 4.218l2.831 1.31c.1.045.159.149.148.258l-.377 3.725a.256.256 0 0 1-.197.224l-3.036.715a13.606 13.606 0 0 1-2.089 3.878l1.078 2.93a.257.257 0 0 1-.079.287l-2.9 2.367a.258.258 0 0 1-.298.02l-2.654-1.644a13.61 13.61 0 0 1-4.218 1.27l-1.31 2.83a.256.256 0 0 1-.258.148l-3.725-.377a.256.256 0 0 1-.224-.197l-.714-3.036a13.606 13.606 0 0 1-3.879-2.089l-2.93 1.078Zm11.339-2.723a9.437 9.437 0 0 1-2.705-.398l-.005-.002-.007-.002-.055-.017a6.769 6.769 0 0 1-.105-.033.219.219 0 0 1-.142-.277.22.22 0 0 1 .277-.141 8.813 8.813 0 0 0 9.65-2.934 8.762 8.762 0 0 0 1.845-4.562 8.748 8.748 0 0 0-1.94-6.461 8.757 8.757 0 0 0-5.942-3.197c-4.837-.49-9.168 3.046-9.658 7.88a8.786 8.786 0 0 0 .787 4.629.22.22 0 0 1-.105.292.22.22 0 0 1-.292-.105 9.233 9.233 0 0 1-.827-4.86c.514-5.077 5.064-8.788 10.14-8.274a9.192 9.192 0 0 1 6.236 3.356 9.184 9.184 0 0 1 2.037 6.783 9.193 9.193 0 0 1-3.356 6.237 9.185 9.185 0 0 1-5.833 2.086Zm-.077-5.436a3.769 3.769 0 0 1-3.72-3.215 3.767 3.767 0 0 1 3.175-4.272 3.738 3.738 0 0 1 2.793.702 3.74 3.74 0 0 1 1.479 2.472 3.768 3.768 0 0 1-3.727 4.313Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#7471FF",
        d: "M24.405 35.968a4.161 4.161 0 0 0-4.114 4.763 4.125 4.125 0 0 0 1.633 2.729 4.138 4.138 0 0 0 3.086.776 4.13 4.13 0 0 0 2.73-1.633 4.134 4.134 0 0 0 .777-3.086 4.165 4.165 0 0 0-4.112-3.55Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#7471FF",
        fillRule: "evenodd",
        d: "M7.787 57.71a.378.378 0 0 1-.424-.116v-.003l-3.491-4.278a.38.38 0 0 1-.029-.439l2.423-3.914a20.062 20.062 0 0 1-1.87-6.222L.219 40.807a.379.379 0 0 1-.217-.382l.557-5.494a.377.377 0 0 1 .29-.33l4.479-1.054a20.027 20.027 0 0 1 3.08-5.721l-1.59-4.32a.378.378 0 0 1 .117-.425l4.279-3.491a.377.377 0 0 1 .438-.029l3.915 2.423a20.064 20.064 0 0 1 6.222-1.87l1.93-4.176a.379.379 0 0 1 .383-.218l5.494.557c.16.016.294.132.33.29l1.054 4.479a20.029 20.029 0 0 1 5.721 3.08l4.321-1.59a.378.378 0 0 1 .424.117l3.491 4.279a.38.38 0 0 1 .029.438l-2.423 3.916a20.064 20.064 0 0 1 1.87 6.222l4.177 1.93a.38.38 0 0 1 .217.382l-.557 5.495a.377.377 0 0 1-.29.33l-4.479 1.054a20.032 20.032 0 0 1-3.08 5.72l1.59 4.321a.378.378 0 0 1-.117.424l-4.279 3.492a.381.381 0 0 1-.438.028l-3.915-2.423a20.065 20.065 0 0 1-6.222 1.87l-1.93 4.177a.379.379 0 0 1-.382.217l-5.495-.557a.377.377 0 0 1-.33-.289l-1.054-4.478a20.029 20.029 0 0 1-5.72-3.08L7.786 57.71Zm16.714-3.594a14.18 14.18 0 0 1-4.239-.647l-.123-.04a.747.747 0 1 1 .46-1.42 12.7 12.7 0 0 0 2.621.548l.147.014c2.11.194 4.189-.147 6.084-.964a12.617 12.617 0 0 0 2.902-1.747l.022-.017.011-.01.055-.044a12.496 12.496 0 0 0 4.561-8.478 12.486 12.486 0 0 0-2.768-9.22 12.496 12.496 0 0 0-8.478-4.561 12.51 12.51 0 0 0-9.22 2.768 12.496 12.496 0 0 0-4.562 8.478 12.528 12.528 0 0 0 1.122 6.605.75.75 0 0 1-.359.994.749.749 0 0 1-.994-.359 14.05 14.05 0 0 1-1.257-7.39 13.98 13.98 0 0 1 5.105-9.484 13.967 13.967 0 0 1 10.315-3.098 13.97 13.97 0 0 1 9.485 5.104 13.97 13.97 0 0 1 3.172 8.868c0 .48-.024.963-.073 1.446-.734 7.24-6.863 12.654-13.99 12.654Zm-.11-8.34a5.602 5.602 0 0 1-3.359-1.117 5.62 5.62 0 0 1-2.22-3.711 5.657 5.657 0 0 1 4.767-6.413 5.66 5.66 0 0 1 6.415 4.766 5.61 5.61 0 0 1-1.055 4.194 5.61 5.61 0 0 1-3.712 2.22c-.28.041-.56.06-.837.06Z",
        clipRule: "evenodd"
      }
    )
  ] });
}, Calendar = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#D2DFFA",
        d: "M88.743 52.04c-5.947 19.961-48.94 13.708-62.724 10.166C16.726 65.44 0 58.97 0 38.64c0-8.78 13.474-7.393 22.767-19.407C32.059 7.221 42.745-1.558 55.755 1.676 68.765 4.911 96.177 27.09 88.743 52.04Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#3A36DB",
        d: "M14.735 10.82a8.003 8.003 0 0 0-5.217 7.503v5.566h50.61v-5.566a8.003 8.003 0 0 0-5.216-7.502v1.198a2.478 2.478 0 1 1-4.957 0v-1.696h-3.653v1.696a2.478 2.478 0 1 1-4.957 0v-1.696H37.17v1.696a2.478 2.478 0 1 1-4.957 0v-1.696h-3.651v1.696a2.478 2.478 0 1 1-4.957 0v-1.696h-3.914v1.696a2.478 2.478 0 1 1-4.956 0V10.82Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#6562F5", d: "M9.52 23.889h50.61v28a8 8 0 0 1-8 8H17.52a8 8 0 0 1-8-8v-28Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#BECDFA",
        d: "M23.87 31.367a2 2 0 0 1 2-2h.696a2 2 0 0 1 2 2v.696a2 2 0 0 1-2 2h-.696a2 2 0 0 1-2-2v-.696Zm0 8.609a2 2 0 0 1 2-2h.696a2 2 0 0 1 2 2v.696a2 2 0 0 1-2 2h-.696a2 2 0 0 1-2-2v-.696Zm0 8.609a2 2 0 0 1 2-2h.696a2 2 0 0 1 2 2v.696a2 2 0 0 1-2 2h-.696a2 2 0 0 1-2-2v-.696Zm-8.87 0a2 2 0 0 1 2-2h.696a2 2 0 0 1 2 2v.696a2 2 0 0 1-2 2H17a2 2 0 0 1-2-2v-.696Zm17.74-17.218a2 2 0 0 1 2-2h.696a2 2 0 0 1 2 2v.696a2 2 0 0 1-2 2h-.696a2 2 0 0 1-2-2v-.696Zm0 8.609a2 2 0 0 1 2-2h.696a2 2 0 0 1 2 2v.696a2 2 0 0 1-2 2h-.696a2 2 0 0 1-2-2v-.696Zm0 8.609a2 2 0 0 1 2-2h.696a2 2 0 0 1 2 2v.696a2 2 0 0 1-2 2h-.696a2 2 0 0 1-2-2v-.696Zm8.867-17.218a2 2 0 0 1 2-2h.696a2 2 0 0 1 2 2v.696a2 2 0 0 1-2 2h-.696a2 2 0 0 1-2-2v-.696Zm0 8.609a2 2 0 0 1 2-2h.696a2 2 0 0 1 2 2v.696a2 2 0 0 1-2 2h-.696a2 2 0 0 1-2-2v-.696Zm0 8.609a2 2 0 0 1 2-2h.696a2 2 0 0 1 2 2v.696a2 2 0 0 1-2 2h-.696a2 2 0 0 1-2-2v-.696Zm8.872-17.218a2 2 0 0 1 2-2h.696a2 2 0 0 1 2 2v.696a2 2 0 0 1-2 2h-.696a2 2 0 0 1-2-2v-.696Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#3A36DB",
        d: "M16.04 7.323a1.174 1.174 0 1 1 2.348 0v4.696a1.174 1.174 0 1 1-2.348 0V7.323Zm8.87 0a1.174 1.174 0 1 1 2.349 0v4.696a1.174 1.174 0 0 1-2.348 0V7.323Zm8.609 0a1.174 1.174 0 1 1 2.347 0v4.696a1.174 1.174 0 0 1-2.347 0V7.323Zm9.131 0a1.174 1.174 0 1 1 2.349 0v4.696a1.174 1.174 0 0 1-2.348 0V7.323Zm8.61 0a1.174 1.174 0 1 1 2.349 0v4.696a1.174 1.174 0 0 1-2.348 0V7.323Zm23.742 41.871c0 8.212-6.658 14.87-14.87 14.87-8.213 0-14.87-6.658-14.87-14.87 0-8.213 6.657-14.87 14.87-14.87 8.212 0 14.87 6.657 14.87 14.87Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#6562F5",
        d: "M72.132 49.194c0 6.627-5.373 12-12 12-6.628 0-12-5.373-12-12 0-6.628 5.372-12 12-12s12 5.372 12 12Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M59.35 41.629a.783.783 0 1 1 1.565 0v8.608a.783.783 0 0 1-1.565 0V41.63Z" }),
    /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M58.306 49.977a.783.783 0 1 1 0-1.566h8.609a.783.783 0 0 1 0 1.566h-8.609Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#EB5757",
        d: "M22.827 36.15c0 1.594-.377 3.1-1.045 4.435l.5 2.442c.304 1.487-1.093 2.757-2.544 2.314l-1.906-.582a9.867 9.867 0 0 1-4.919 1.304C7.438 46.063 3 41.625 3 36.15c0-5.475 4.438-9.913 9.913-9.913 5.475 0 9.914 4.438 9.914 9.913Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#fff",
        d: "M14.48 40.976a1.435 1.435 0 1 1-2.87 0 1.435 1.435 0 0 1 2.87 0Zm-3.229-9.659a1.8 1.8 0 1 1 3.589 0l-.523 6.272a1.276 1.276 0 0 1-2.543 0l-.523-6.272Z"
      }
    )
  ] }) : /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#28313F",
        d: "M88.743 52.04c-5.947 19.961-48.94 13.708-62.724 10.166C16.726 65.44 0 58.97 0 38.64c0-8.78 13.474-7.393 22.767-19.407C32.059 7.221 42.745-1.558 55.755 1.676 68.765 4.911 96.177 27.09 88.743 52.04Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#4541C9",
        fillRule: "evenodd",
        d: "M14.737 10.82a8.003 8.003 0 0 0-5.217 7.503v5.566h50.61v-5.566a8.003 8.003 0 0 0-5.216-7.502v1.198a2.478 2.478 0 0 1-4.957 0v-1.696h-3.653v1.696a2.478 2.478 0 0 1-4.957 0v-1.696h-4.175v1.696a2.478 2.478 0 0 1-4.957 0v-1.696h-3.651v1.696a2.478 2.478 0 0 1-4.957 0v-1.696h-3.914v1.696a2.478 2.478 0 0 1-4.956 0v-1.198Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#7471FF", d: "M9.52 23.889h50.61v28a8 8 0 0 1-8 8H17.52a8 8 0 0 1-8-8v-28Z" }),
    /* @__PURE__ */ jsx("rect", { width: "4.696", height: "4.696", x: "23.869", y: "29.367", fill: "#1A202C", rx: "2" }),
    /* @__PURE__ */ jsx("rect", { width: "4.696", height: "4.696", x: "23.869", y: "37.976", fill: "#1A202C", rx: "2" }),
    /* @__PURE__ */ jsx("rect", { width: "4.696", height: "4.696", x: "23.869", y: "46.585", fill: "#1A202C", rx: "2" }),
    /* @__PURE__ */ jsx("rect", { width: "4.696", height: "4.696", x: "14.998", y: "46.585", fill: "#1A202C", rx: "2" }),
    /* @__PURE__ */ jsx("rect", { width: "4.696", height: "4.696", x: "32.738", y: "29.367", fill: "#1A202C", rx: "2" }),
    /* @__PURE__ */ jsx("rect", { width: "4.696", height: "4.696", x: "32.738", y: "37.976", fill: "#1A202C", rx: "2" }),
    /* @__PURE__ */ jsx("rect", { width: "4.696", height: "4.696", x: "32.738", y: "46.585", fill: "#1A202C", rx: "2" }),
    /* @__PURE__ */ jsx("rect", { width: "4.696", height: "4.696", x: "41.605", y: "29.367", fill: "#1A202C", rx: "2" }),
    /* @__PURE__ */ jsx("rect", { width: "4.696", height: "4.696", x: "41.605", y: "37.976", fill: "#1A202C", rx: "2" }),
    /* @__PURE__ */ jsx("rect", { width: "4.696", height: "4.696", x: "41.605", y: "46.585", fill: "#1A202C", rx: "2" }),
    /* @__PURE__ */ jsx("rect", { width: "4.696", height: "4.696", x: "50.478", y: "29.367", fill: "#1A202C", rx: "2" }),
    /* @__PURE__ */ jsx("rect", { width: "2.348", height: "7.044", x: "16.041", y: "6.149", fill: "#605CFF", rx: "1.174" }),
    /* @__PURE__ */ jsx("rect", { width: "2.348", height: "7.044", x: "24.912", y: "6.149", fill: "#605CFF", rx: "1.174" }),
    /* @__PURE__ */ jsx("rect", { width: "2.348", height: "7.044", x: "33.52", y: "6.149", fill: "#605CFF", rx: "1.174" }),
    /* @__PURE__ */ jsx("rect", { width: "2.348", height: "7.044", x: "42.652", y: "6.149", fill: "#605CFF", rx: "1.174" }),
    /* @__PURE__ */ jsx("rect", { width: "2.348", height: "7.044", x: "51.262", y: "6.149", fill: "#605CFF", rx: "1.174" }),
    /* @__PURE__ */ jsx("circle", { cx: "60.13", cy: "49.194", r: "14.87", fill: "#4541C9" }),
    /* @__PURE__ */ jsx("circle", { cx: "60.129", cy: "49.194", r: "12", fill: "#7471FF" }),
    /* @__PURE__ */ jsx("rect", { width: "1.565", height: "10.174", x: "59.348", y: "40.846", fill: "#fff", rx: ".783" }),
    /* @__PURE__ */ jsx(
      "rect",
      {
        width: "1.565",
        height: "10.174",
        x: "57.522",
        y: "49.977",
        fill: "#fff",
        rx: ".783",
        transform: "rotate(-90 57.522 49.977)"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#EB5757",
        d: "M22.827 36.15c0 1.594-.377 3.1-1.045 4.435l.5 2.442c.304 1.487-1.093 2.757-2.544 2.314l-1.906-.582a9.867 9.867 0 0 1-4.919 1.304C7.438 46.063 3 41.625 3 36.15c0-5.475 4.438-9.913 9.913-9.913 5.475 0 9.914 4.438 9.914 9.913Z"
      }
    ),
    /* @__PURE__ */ jsx("circle", { cx: "13.044", cy: "40.976", r: "1.435", fill: "#fff" }),
    /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M11.252 31.317a1.8 1.8 0 1 1 3.588 0l-.522 6.272a1.276 1.276 0 0 1-2.543 0l-.523-6.272Z" })
  ] });
}, AllowPopup = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsxs("g", { clipPath: "url(#a)", children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#D2DBEC",
          d: "M88.913 51.968C82.954 72.292 39.88 65.925 26.07 62.318 16.759 65.612 0 59.025 0 38.325c0-8.939 13.5-7.527 22.81-19.76C32.12 6.336 42.827-2.604 55.862.69c13.034 3.293 40.5 25.875 33.051 51.28Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#3A36DB", d: "M33.219 46.342H46.77v5.14H33.219z" }),
      /* @__PURE__ */ jsx("path", { fill: "#605CFF", d: "M21.75 51.481h36.484v5.14H21.75z" }),
      /* @__PURE__ */ jsx("path", { fill: "#698AFF", d: "M5 9a3 3 0 0 1 3-3h62.126a3 3 0 0 1 3 3v34.818a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3V9Z" }),
      /* @__PURE__ */ jsx("rect", { width: "61.952", height: "34.716", x: "8.086", y: "9.051", fill: "#698AFF", stroke: "#C5D0E5", rx: "1.5" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#3954D0",
          d: "M10 30V16h16v14zm17.152-.237V15.895h15.431v13.868zM43.494 42V15.895h24.508V42zM10 42V31h33v11z"
        }
      ),
      /* @__PURE__ */ jsx("circle", { cx: "11.815", cy: "12", r: "1", fill: "#EB5757" }),
      /* @__PURE__ */ jsx("circle", { cx: "14.539", cy: "12", r: "1", fill: "#BECDFA" }),
      /* @__PURE__ */ jsx("circle", { cx: "17.262", cy: "12", r: "1", fill: "#fff" }),
      /* @__PURE__ */ jsx("rect", { width: "46", height: "2", x: "22", y: "11", fill: "#BECDFA", rx: "1" }),
      /* @__PURE__ */ jsx("path", { fill: "#DFE6F2", d: "M35 54a1 1 0 0 1-1-1V26h56v27a1 1 0 0 1-1 1H35Z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#B7C4DE",
          d: "M35.806 39.925V26.224H51.12v13.701zm16.117 0v-13.7h13.701v13.7zm14.511 12.09V26.224h21.76v24.79a1 1 0 0 1-1 1h-20.76Zm-30.627 0V40.73h29.82v11.284h-29.82Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#DFE6F2", d: "M34 19a1 1 0 0 1 1-1h54a1 1 0 0 1 1 1v7H34v-7Z" }),
      /* @__PURE__ */ jsx("circle", { cx: "38.222", cy: "22.194", r: ".806", fill: "#EB5757" }),
      /* @__PURE__ */ jsx("circle", { cx: "40.642", cy: "22.194", r: ".806", fill: "#B7C4DE" }),
      /* @__PURE__ */ jsx("circle", { cx: "43.058", cy: "22.194", r: ".806", fill: "#fff" }),
      /* @__PURE__ */ jsx("rect", { width: "39.492", height: "1.612", x: "47.088", y: "21.388", fill: "#B7C4DE", rx: ".806" }),
      /* @__PURE__ */ jsx("circle", { cx: "86", cy: "50", r: "12", fill: "#EB5757" }),
      /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M78.615 48.154h14.769v3.692H78.615z" })
    ] }),
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h99v66H0z" }) }) })
  ] }) : /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsxs("g", { clipPath: "url(#a)", children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#28313F",
          d: "M88.913 51.968C82.954 72.292 39.88 65.925 26.07 62.318 16.759 65.612 0 59.025 0 38.325c0-8.939 13.5-7.527 22.81-19.76C32.12 6.336 42.827-2.604 55.862.69c13.034 3.293 40.5 25.875 33.051 51.28Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#3A36DB", d: "M33.219 46.342H46.77v5.14H33.219z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#605CFF",
          d: "M21.75 51.481h36.484v5.14H21.75zM5 9a3 3 0 0 1 3-3h62.126a3 3 0 0 1 3 3v34.818a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3V9Z"
        }
      ),
      /* @__PURE__ */ jsx("rect", { width: "61.952", height: "34.716", x: "8.086", y: "9.051", fill: "#605CFF", stroke: "#364153", rx: "1.5" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#4541C9",
          d: "M10 30V16h16v14zm17.152-.237V15.895h15.431v13.868zM43.494 42V15.895h24.508V42zM10 42V31h33v11z"
        }
      ),
      /* @__PURE__ */ jsx("circle", { cx: "11.815", cy: "12", r: "1", fill: "#EB5757" }),
      /* @__PURE__ */ jsx("circle", { cx: "14.539", cy: "12", r: "1", fill: "#BECDFA" }),
      /* @__PURE__ */ jsx("circle", { cx: "17.262", cy: "12", r: "1", fill: "#fff" }),
      /* @__PURE__ */ jsx("rect", { width: "46", height: "2", x: "22", y: "11", fill: "#BECDFA", rx: "1" }),
      /* @__PURE__ */ jsx("path", { fill: "#1A202C", d: "M35 54a1 1 0 0 1-1-1V26h56v27a1 1 0 0 1-1 1H35Z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#364153",
          d: "M35.806 39.925V26.224H51.12v13.701zm16.117 0v-13.7h13.701v13.7zm14.511 12.09V26.224h21.76v24.79a1 1 0 0 1-1 1h-20.76Zm-30.627 0V40.73h29.82v11.284h-29.82Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#1A202C", d: "M34 19a1 1 0 0 1 1-1h54a1 1 0 0 1 1 1v7H34v-7Z" }),
      /* @__PURE__ */ jsx("circle", { cx: "38.222", cy: "22.194", r: ".806", fill: "#EB5757" }),
      /* @__PURE__ */ jsx("circle", { cx: "40.642", cy: "22.194", r: ".806", fill: "#364153" }),
      /* @__PURE__ */ jsx("circle", { cx: "43.058", cy: "22.194", r: ".806", fill: "#fff" }),
      /* @__PURE__ */ jsx("rect", { width: "39.492", height: "1.612", x: "47.088", y: "21.388", fill: "#364153", rx: ".806" }),
      /* @__PURE__ */ jsx("circle", { cx: "86", cy: "50", r: "12", fill: "#EB5757" }),
      /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M78.615 48.154h14.769v3.692H78.615z" })
    ] }),
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h99v66H0z" }) }) })
  ] });
}, Tabs = () => {
  const { theme: t } = useContext(ConfigContext);
  return t === "light" ? /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, viewBox: "0 0 99 66", fill: "none", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M86.7707 51.8256C80.9557 72.0935 38.9181 65.7441 25.4406 62.1472C16.3547 65.4314 0 58.8631 0 38.2198C0 29.3057 13.1746 30.7132 22.2606 18.5149C31.3465 6.31665 41.7953 -2.59748 54.5156 0.686674C67.236 3.97082 94.0395 26.4907 86.7707 51.8256Z",
        fill: "#D2DBEC"
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M7 49C6.44771 49 6 48.5523 6 48L6 15L73 15L73 48C73 48.5523 72.5523 49 72 49L7 49Z", fill: "#3954D0" }),
    /* @__PURE__ */ jsx("rect", { x: "7", y: "33", width: "17", height: "19", transform: "rotate(-90 7 33)", fill: "#698AFF" }),
    /* @__PURE__ */ jsx("rect", { x: "27", y: "33", width: "17", height: "17", transform: "rotate(-90 27 33)", fill: "#698AFF" }),
    /* @__PURE__ */ jsx("path", { d: "M45 48L45 16L72 16L72 47C72 47.5523 71.5523 48 71 48L45 48Z", fill: "#698AFF" }),
    /* @__PURE__ */ jsx("path", { d: "M8 48C7.44771 48 7 47.5523 7 47L7 34L44 34L44 48L8 48Z", fill: "#698AFF" }),
    /* @__PURE__ */ jsx("path", { d: "M6 8C6 6.89543 6.89543 6 8 6H71C72.1046 6 73 6.89543 73 8V15H6V8Z", fill: "#3954D0" }),
    /* @__PURE__ */ jsx("circle", { cx: "10", cy: "11", r: "1", fill: "#EB5757" }),
    /* @__PURE__ */ jsx("circle", { cx: "13", cy: "11", r: "1", fill: "#C5D0E5" }),
    /* @__PURE__ */ jsx("circle", { cx: "16", cy: "11", r: "1", fill: "white" }),
    /* @__PURE__ */ jsx("rect", { x: "21", y: "10", width: "49", height: "2", rx: "1", fill: "#C5D0E5" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M24 61C23.4477 61 23 60.5523 23 60L23 27L90 27L90 60C90 60.5523 89.5523 61 89 61L24 61Z",
        fill: "#ABBAD8"
      }
    ),
    /* @__PURE__ */ jsx("rect", { x: "24", y: "45", width: "17", height: "19", transform: "rotate(-90 24 45)", fill: "#D2DBEC" }),
    /* @__PURE__ */ jsx("rect", { x: "44", y: "45", width: "17", height: "17", transform: "rotate(-90 44 45)", fill: "#D2DBEC" }),
    /* @__PURE__ */ jsx("path", { d: "M62 60L62 28L89 28L89 59C89 59.5523 88.5523 60 88 60L62 60Z", fill: "#D2DBEC" }),
    /* @__PURE__ */ jsx("path", { d: "M25 60C24.4477 60 24 59.5523 24 59L24 46L61 46L61 60L25 60Z", fill: "#D2DBEC" }),
    /* @__PURE__ */ jsx("path", { d: "M23 20C23 18.8954 23.8954 18 25 18H88C89.1046 18 90 18.8954 90 20V27H23V20Z", fill: "#D2DBEC" }),
    /* @__PURE__ */ jsx("circle", { cx: "27", cy: "23", r: "1", fill: "#EB5757" }),
    /* @__PURE__ */ jsx("circle", { cx: "30", cy: "23", r: "1", fill: "#ABBAD8" }),
    /* @__PURE__ */ jsx("circle", { cx: "33", cy: "23", r: "1", fill: "white" }),
    /* @__PURE__ */ jsx("rect", { x: "38", y: "22", width: "49", height: "2", rx: "1", fill: "#ABBAD8" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M82.4784 63.7946C88.8178 63.7946 93.9568 58.6919 93.9568 52.3973C93.9568 46.1028 88.8178 41 82.4784 41C76.1391 41 71 46.1028 71 52.3973C71 58.6919 76.1391 63.7946 82.4784 63.7946ZM81.9167 56.0713V56.1494H83.4769V56.0713C83.4856 55.5339 83.5419 55.0854 83.6459 54.7257C83.7499 54.3659 83.9168 54.0561 84.1465 53.796C84.3762 53.5316 84.6817 53.2803 85.0631 53.0419C85.4445 52.8079 85.7696 52.5392 86.0383 52.2358C86.3113 51.9324 86.5194 51.5879 86.6624 51.2021C86.8097 50.8164 86.8834 50.3852 86.8834 49.9084C86.8834 49.2323 86.7274 48.6299 86.4153 48.1012C86.1076 47.5724 85.6699 47.1564 85.1021 46.853C84.5387 46.5496 83.8756 46.3979 83.1129 46.3979C82.4107 46.3979 81.7715 46.5366 81.1951 46.814C80.623 47.0914 80.1614 47.4923 79.8104 48.0167C79.4636 48.5411 79.273 49.1717 79.2383 49.9084H80.8765C80.9112 49.397 81.039 48.9831 81.2601 48.6668C81.4811 48.3504 81.7563 48.1185 82.0857 47.9712C82.4151 47.8238 82.7575 47.7501 83.1129 47.7501C83.5202 47.7501 83.8908 47.8346 84.2245 48.0037C84.5582 48.1727 84.8248 48.4132 85.0241 48.7253C85.2235 49.0373 85.3232 49.4057 85.3232 49.8304C85.3232 50.1728 85.2625 50.4849 85.1411 50.7666C85.0241 51.0483 84.8638 51.2975 84.6601 51.5142C84.4564 51.7265 84.2267 51.9107 83.971 52.0668C83.5462 52.3225 83.1822 52.602 82.8788 52.9054C82.5754 53.2088 82.3414 53.6053 82.1767 54.0951C82.012 54.5848 81.9253 55.2436 81.9167 56.0713ZM81.9232 59.6534C82.1529 59.8831 82.4281 59.9979 82.7488 59.9979C82.9655 59.9979 83.1605 59.9459 83.3339 59.8419C83.5116 59.7336 83.6524 59.5905 83.7564 59.4128C83.8648 59.2351 83.919 59.0401 83.919 58.8278C83.919 58.507 83.8041 58.2318 83.5744 58.0021C83.3447 57.7724 83.0695 57.6576 82.7488 57.6576C82.4281 57.6576 82.1529 57.7724 81.9232 58.0021C81.6935 58.2318 81.5786 58.507 81.5786 58.8278C81.5786 59.1485 81.6935 59.4237 81.9232 59.6534Z",
        fill: "#3954D0"
      }
    )
  ] }) : /* @__PURE__ */ jsxs("svg", { width: 99, height: 66, fill: "none", viewBox: "0 0 99 66", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#28313F",
        d: "M86.77 51.826c-5.814 20.268-47.852 13.918-61.33 10.321C16.356 65.431 0 58.863 0 38.22c0-8.914 13.175-7.507 22.26-19.705C31.347 6.317 41.796-2.597 54.517.687 67.236 3.97 94.04 26.49 86.77 51.826Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#605CFF", d: "M7 49a1 1 0 0 1-1-1V15h67v33a1 1 0 0 1-1 1H7Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#7471FF",
        d: "M7 33V16h19v17zm20 0V16h17v17zm18 15V16h27v31a1 1 0 0 1-1 1H45ZM8 48a1 1 0 0 1-1-1V34h37v14H8Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#605CFF", d: "M6 8a2 2 0 0 1 2-2h63a2 2 0 0 1 2 2v7H6V8Z" }),
    /* @__PURE__ */ jsx("circle", { cx: "10", cy: "11", r: "1", fill: "#EB5757" }),
    /* @__PURE__ */ jsx("circle", { cx: "13", cy: "11", r: "1", fill: "#1A202C" }),
    /* @__PURE__ */ jsx("circle", { cx: "16", cy: "11", r: "1", fill: "#fff" }),
    /* @__PURE__ */ jsx("rect", { width: "49", height: "2", x: "21", y: "10", fill: "#1A202C", rx: "1" }),
    /* @__PURE__ */ jsx("path", { fill: "#605CFF", d: "M24 61a1 1 0 0 1-1-1V27h67v33a1 1 0 0 1-1 1H24Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#4541C9",
        d: "M24 45V28h19v17zm20 0V28h17v17zm18 15V28h27v31a1 1 0 0 1-1 1H62Zm-37 0a1 1 0 0 1-1-1V46h37v14H25Zm-2-40a2 2 0 0 1 2-2h63a2 2 0 0 1 2 2v7H23v-7Z"
      }
    ),
    /* @__PURE__ */ jsx("circle", { cx: "27", cy: "23", r: "1", fill: "#EB5757" }),
    /* @__PURE__ */ jsx("circle", { cx: "30", cy: "23", r: "1", fill: "#1A202C" }),
    /* @__PURE__ */ jsx("circle", { cx: "33", cy: "23", r: "1", fill: "#fff" }),
    /* @__PURE__ */ jsx("rect", { width: "49", height: "2", x: "38", y: "22", fill: "#1A202C", rx: "1" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#BECDFA",
        fillRule: "evenodd",
        d: "M82.478 63.795c6.34 0 11.479-5.103 11.479-11.398 0-6.294-5.14-11.397-11.479-11.397C76.14 41 71 46.103 71 52.397c0 6.295 5.14 11.398 11.478 11.398Zm-.561-7.724v.078h1.56v-.078c.009-.537.065-.986.169-1.345.104-.36.27-.67.5-.93.23-.264.536-.516.917-.754a4.28 4.28 0 0 0 .975-.806c.273-.304.481-.648.624-1.034.148-.386.221-.817.221-1.294 0-.676-.156-1.278-.468-1.807a3.258 3.258 0 0 0-1.313-1.248c-.563-.303-1.226-.455-1.99-.455-.701 0-1.34.139-1.917.416a3.445 3.445 0 0 0-1.385 1.203c-.346.524-.537 1.155-.572 1.891h1.638c.035-.511.163-.925.384-1.241a1.98 1.98 0 0 1 .826-.696c.33-.147.671-.22 1.027-.22.407 0 .778.084 1.112.253.333.169.6.41.8.721.198.312.298.68.298 1.105a2.457 2.457 0 0 1-.663 1.684 3.42 3.42 0 0 1-.689.553 5.669 5.669 0 0 0-1.092.838c-.304.304-.538.7-.702 1.19-.165.49-.252 1.149-.26 1.976Zm.006 3.582c.23.23.505.345.826.345.217 0 .412-.052.585-.156.178-.108.318-.252.422-.43.109-.177.163-.372.163-.584 0-.321-.115-.596-.345-.826a1.126 1.126 0 0 0-.825-.344c-.32 0-.596.114-.826.344-.23.23-.344.505-.344.826 0 .32.115.596.344.825Z",
        clipRule: "evenodd"
      }
    )
  ] });
}, EmptyWidget = ({ style: t }) => {
  const { theme: r } = useContext(ConfigContext);
  return r === "light" ? /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 550, height: 550, style: t, fill: "none", viewBox: "0 0 550 550", children: /* @__PURE__ */ jsxs("g", { opacity: ".3", children: [
    /* @__PURE__ */ jsx("path", { fill: "#ABBAD8", d: "M83.5 422.5h-6v-17h6v17Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#ABBAD8",
        d: "m80.9 410.3-3.3-5 15.4-9.7 3.2 5-15.3 9.7ZM282.1 79.7a4 4 0 0 0 4.1-4 4 4 0 0 0-4-4 4 4 0 0 0-4.1 4 4 4 0 0 0 4 4ZM375.7 247.6c0-1.7-1.4-3.2-3.2-3.2a3.2 3.2 0 0 0-3.2 3.2c0 1.8 1.4 3.2 3.2 3.2 1.8 0 3.2-1.4 3.2-3.2ZM262 110.4c3.5 0 6.4-2.8 6.4-6.3s-3-6.3-6.5-6.3a6.4 6.4 0 0 0-6.4 6.3c0 3.5 2.9 6.3 6.4 6.3ZM292.7 129.3a4 4 0 0 0-4-4 4 4 0 0 0-4 4 4 4 0 0 0 4 4 4 4 0 0 0 4-4ZM212.6 232.1ZM58.6 199.8l-.5.3.5-.2ZM364.2 139.3v-.1h-.1.1ZM362.7 138.3l-.1-.2h-.1l.2.2ZM163.3 258.9h1.6v-13.7h-1.6V259ZM214 209.3l.1-1.4-.9-.7-1 .7v1.2l.2.5 1.6-.3ZM363.5 185a3 3 0 0 0 3-3 3 3 0 0 0-3-3 3 3 0 0 0-3 3 3 3 0 0 0 3 3ZM379 204c2.7 0 4.9-2.2 4.9-4.8 0-2.7-2.2-4.9-5-4.9a4.9 4.9 0 0 0 0 9.7ZM236.8 211c2.7 0 5-2.2 5-5 0-2.6-2.3-4.7-5-4.7s-4.9 2.1-4.9 4.8c0 2.7 2.2 4.8 5 4.8ZM245.3 55.2a3 3 0 0 0 3-3 3 3 0 0 0-3-2.9 3 3 0 0 0-3 3 3 3 0 0 0 3 3ZM341.4 9.3V0S460.9 78.9 461 78.9v9.3L341.4 9.3ZM341.4 33.4V24s119.5 78.8 119.7 78.8v9.4l-119.7-79ZM537.4 209a3 3 0 0 0 3-3 3 3 0 0 0-3-2.9 3 3 0 0 0-3 3 3 3 0 0 0 3 3ZM526.2 238.3c2.8 0 5-2.1 5-4.8 0-2.7-2.2-4.8-5-4.8-2.7 0-4.9 2.1-4.9 4.8 0 2.7 2.2 4.8 5 4.8ZM509.8 121v9.4l-37.5-24.7v-9.4l37.5 24.8ZM509.8 144v9.4l-37.5-24.7v-9.4l37.5 24.8ZM509.8 167v9.4l-37.5-24.7v-9.3l37.5 24.7ZM509.8 191.8v9.3l-37.5-24.7v-9.3l37.5 24.7ZM508.7 215.4v9.3L471.2 200v-9.3l37.5 24.7ZM550 271l-106.1-70v9.4l106.1 70V271ZM550 294l-106.1-70v9.4l106.1 70V294ZM550 317l-106.1-69.9v9.3l106.1 70V317ZM463 315.7l37.5 24.7v-9.3L463 306.4v9.3ZM463 292.4l37.5 24.7v-9.3L463 283v9.4Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#ABBAD8",
        d: "m550 340.8-87-57.4v9.4l87 57.3v-9.3ZM413.3 118c3.2-3.1 6.3-6.4 8.3-8.8l1.8 1.3 19 12.6v14.2l-29.1-19.4Zm35 2.4L425.2 105l-.1.1v-.2l-123-81-.1 6.8v117.7h5.7v-30.3l66.4 44 3-4.6-24.6-16.3 11.4-2 5.4-1.2 20.1 13.4 3-4.5-15.7-10.4 1-.2 14.5-4.6 16.2 10.7 3-4.5-12.9-8.5a42.2 42.2 0 0 0 10.7-7.7l33.3 22V158l-7.5-5-3 4.5 10.5 7v19.5h5.8v-63.7ZM466.2 424.6h6v-18h-6v18Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#ABBAD8",
        d: "m468.8 411.4 3.3-5-15.4-9.7-3.2 5 15.3 9.7ZM414 478l-3.1-4.5 34.7-23.2 3.1 4.5L414 478ZM312 545.3l-3.1-4.4 50.1-33.4 3 4.5-50 33.3ZM228.5 538.3l3-4.5-50.3-33-3 4.4 50.3 33ZM245.8 550l3.1-4.5-7.1-4.7-3 4.5 7 4.7ZM155 491.4l3-4.5-44.3-29-3 4.5 44.3 29ZM80.8 442.8l3.5-4.8 13.4 9.3-3.5 4.8-13.4-9.3ZM373.5 504.4l-3-4.5 5.5-3.7 3 4.5-5.5 3.7ZM398.7 488l-3-4.4 5.5-3.7 3.1 4.4-5.6 3.7ZM459.7 447.5l-3-4.4 5.5-3.7 3 4.4-5.5 3.7ZM82 145.6l-1 .6s.2 0 .3-.2l.6-.4ZM215.4 125.5h.1-.1ZM199.7 224.1H197v-134h2.7v134ZM201 32.2v-11L142.4 60v11l58.4-38.8ZM130.9 61.6v-9.3S11.3 131.2 11 131.2v9.4l119.8-79ZM11.1 156.4v4l7.9-5.2v-4l-7.9 5.2Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#ABBAD8",
        d: "M130.9 84.5v-9.3S11.3 154 11 154v9.4l119.8-79ZM130.9 106.7v-9.3S11.3 176.3 11 176.3v9.4l119.8-79ZM.5 251v9.2L38 235.5v-9.3L.5 251ZM11.6 220.7v9.3l37.5-24.7v-9.4l-37.5 24.8ZM11.6 198.2v9.3l37.5-24.8v-9.3l-37.5 24.8ZM0 275v9.4l37.5-24.8v-9.3L0 275.1ZM200.4 157.5v-50.1l10.8-8.7v51.6l-10.8 7.2Zm-5.7 3.8L183 169v-47.5l11.7-9.4v49.2Zm-17.5 11.6-12.7 8.3V165l12.7-21.4v29.4Zm-48.8-49.7v-.3l-21 14.2-46.6 30.6v67.2l-9.3 6.4v21.8L67 252.8v-.1l20-13.2v8.1h5.7v-12l11.9-7.8V247h5.7v-21.3l12-3.1V248h5.7v-27.3l11.6-5.1V257h5.7V213L154 195l4.9-3.2v73.2h5.7v-77l12.7-8.4v37.9h5.8v-41.7l11.7-7.8v56.7h5.7v-60.5l10.8-7.1v73l-27 19.4v6.7l32.5-23.3h.3V64.8l-88.6 58.4ZM201 58V47l-58.5 38.8v11L200.8 58ZM236.7 87a3 3 0 0 0 3-3 3 3 0 0 0-3-3 3 3 0 0 0-3 3 3 3 0 0 0 3 3Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#3954D0",
        d: "m427.3 360.7-.5-.6 1.3-9 2.1-1.1 15.2-2 .5.6c-1.2 1.1-2.4 1.9-4 2.4.2.4-.2-.1 0 .2a10.5 10.5 0 0 1-6.1 2.7l.4 1c-1.5 1.5-3.6 2-5.8 2.5l.5 1-3.6 2.3Zm-4.6-10.4-.4-.8 2.8-6.9c1-2 1.8-4 2.6-6h.2v5.6l-.9 4.5-4.3 3.6Zm.6 9.4c-.2 0 0 2-.2 2l-.5 2.6-7.7 4.7c1.3 1-3.2 2.3-3.4 2.5h-.2v-.8l3.1-7.9v-.5l2.4-2.3.8-.3 2.3-1.8 3.5-3 .4.1-.5 4.7Zm-13.7-40-15.5-3.5c0-.3-3.5-10.2-3.3-10.6.2 0 3.1-2 3.3-1.7 1 1.8 3.1 4.8 5.2 6.7l3.2 1.2 8.8 1.7-.4 5.5c-.4.4-.9.2-1.3.7Zm-.3 5.2c-1.7 1.1-2.3 1.8-3.7 2.8l-24.5-3.5 10.7-4 .5-.4 17.2 4-.2 1.1Zm-2.6 47.3-.8 4a7.6 7.6 0 0 1-4.2 2.8l-.3.2-3 1.6.1.1c-.6.4-2.4 1.6-3 1.8-2.5.8-2.5 1-3 .7l.7-2.4.3-1.1 1.2-3 .7-2.2.5-.7c.3-.4 1-.6 1.6-.8 1-.3 1-.3.7-1.5 2.5-1.6 5-3.2 7.7-4.7.4-.3 1-.4 1.5-.5.4-.1-.4-.8.1-1 0-.3 1.2 0 1.2-.4v-.1l-2 7.2Zm-18.3-34.7.5.9-.3.3-3 1.9-.4-.1-5.7-11.2-.4-.7-.3-.6.6-.5 20.8 3.6c-.5.3-1.1.5-1.7.6l-1.8.4.3 1.2-4 2.6c-1.3 1-3 1-4.6 1.6Zm-7 3.8v-.1Zm5.1 44.9h-.4l-.6.4.4.8c-1.2 1.4-3 1.4-4.7 2l.1 1c-.8.7-1.8 1.3-2.9 1.5l-1 .2c-1 .3-1 .3-.8 1.5l-1.4.8-.1-6.6c.5 0 .8-.3 1-.8.2-.3.6-.1.9-.3 1-.3 1.7-1.3 2.6-1.7l9.4-5.2-2.5 6.4Zm-15-37.8.3 1.3-8.3 5.2-1.4.4-1.5.4.1 1-5 3.3-.5-1.2-.7-9 .3-1.8 2.2-.9c0-1.2 0-1.2 1.2-1.7l2-.8c.4-.1.6-.4.6-.8l19 .6-4 2.6c-1 .6-1.8 1-2.9 1.1l-1.3.3Zm-.1 47-1.4 2-7.8.8-3.2-1v-.9c.8-.3 1.7-.5 2.5-.4 1.2.1 1.8.5 2.7-.3.3-.3.6-.7.7-1.1.4-1.9.6-2.2 2.1-2.7.8-.2 0-.5.9-.7-.2-.5 2.5-.8 2.4-1.1l1.2-.8-.1 6.1Zm-13.6 8.8.4.9-.3.3c-1.5 1-2.5 2.2-4.4 2.4-.8 0-1.9 0-2.4.7l1 1.2c-1 .5-2 1.3-3 1.7-.9.4-1.5.5-2.6.8.3.7-1.5 1.7-3 2.3l-.6-.4.6-1.3 2.8-4.2.9-1.2 3.2-4.2c.6-.7 1.3-1.2 2.3-1.3.2 0 .5 0 .6-.2 1.4-1 2.8-.8 4.3-1l4 1 .2 1c-1 1.1-2.7.8-4 1.5Zm-19.8 8.6-6.4-21.4 2.9-1.7L344 400l1.5 3.3-6.3 9.1-1.3.4Zm-5.1 9c-1 .7-2.1 1.5-3.3 2-1 .6-2.3.9-3.5 1.3 0 .3 0 .6.2 1-1 .6-1.8 1.3-2.8 1.7-1 .5-2.1.7-3.3 1l.4.9c-1 .8-1.9 1.4-3 1.6l-.8.2 6.7-20.6 11.3 6.9 1.5 1.8c-1 .7-2.4.8-3.8 1.3l.4 1Zm-20.3 10-.8 2.3c-.3 1-1 1.7-2 1.8-.2 0-.4 0-.6.2v.3c-.4.5-.8 0-1.4 0l.2-2-.4-5.4v-1.3h.1v-.1l2.2-2.3 8-10.2-5.3 16.7Zm-5.1-11.8.4-6.8 1.4-10.8.2-1 6.9 5 2 1.8-10.9 13.8v-2Zm-3.3-10.2-8.7-4.5-.5-.5 2-5.1.1-.1.5-.3c.6-1 1.5-1.4 2.4-1.7h6.2l-2 12.2Zm-.6 17.6v.7c0 .5-.6.8-1 1.1l-7.6 4.9c-2 1.3-4 2.3-6.3 3-.5.2-1 .2-1.4.2h-17l-5.5-3.4-11.6-6.9.1-14.1.3-.4 11.7-7.5v16.3l1.1 1.5 1 2 1 1.1 1.6.7 1.9 1.5 2.6.7 3.7.9h3.2l2.9-.9 2-.7 3.3-4.2v-.4l.3-.7c-.4-.3.1-.5 0-.7-.3-.3 0-.3 0-.7-.2-1-.1-2.2-.1-3.3 0-.6.2-1 1-1 .6 0 1.3-.2 2-.4v-1.1l1.8-1.5c-.6-.5.4-.5 0-1-.3-.7-.3-1.2.2-1.7v-1.5l9 4.6-.2 12.9ZM290.4 531l-.2.2-.4.3-2.4.2-2.3-.3-.7-.4-1-1-1-.9v-.3l2.5-6 .3-.3.9-.8v-.1l3.1-1.6c.4.4.6.9.6 1.6l.4 5.1c.4 2 .3 2.6.2 4.3Zm-9.3-8.5-.8 1.6-.2.5-1.3 1.7c-.4.2-.9 1.3-1.6.6-.4-.3-.6-1.5-1-1.9 0 0 0-.8-.2-1v-1.6l.3-1.3.8-1.8c.3-1.1.4-1.3 1-1.9l1.2-.9 2.2 2.1.3 1.5-.7 2.4Zm-5.2-27-.9 2.1c0 .4 0 .7-.5.8-.3 0-1.5.3-1.7 0l-1.4-7.4 1.2-3.2c1 .5 3.8 1.7 4 2 .6 1.2-.3 3.8-.7 5.7Zm1.7 5.8.6-1 .2-.5c.2-1 .3-.9.4-1.3.1-1 .6-1.6.7-2.6.5.4 2 3.7 2.9 5.7l-.3.8-3 4-3.2-1.2c-.4-.3-.6-.6-.6-.7 0-.2.4-.4.7-.6l1.6-2.6Zm11.8 8.3v2.3l-.7 2.7-2.7 2.5-4.2-4.1-.4-.5V510l3-3.9 2.6-1 .9-.2 1.4.3v1.9c0 .8.5 1.6 0 2.4Zm-.3-18.2v9.4l-2.8.7h-.1l-3.5-7-1-4 .8-1 6.3-1.8c.4 1 .2 3.7.3 3.7Zm-11.6-18V472h1.8c.3 0 1.7 1 2 1 1.8.5 3 0 4.6 1 .2.1.7 1.6.9 1.8.2.2.2.7 0 1.2l-5.5-.6c-.6-.6-1.3-.8-2-1.5l-1.8-1.5Zm2.4 6.6 4.5.1c1.7.2 2.6.3 2.6 2 0 .3-.2.7-.4 1-.6.9-1.2 1.6-1.9 2.2l-2 .3-1.4-.9c-1.3-1-3.6-2.4-4-3.5-.3-1 1.5-1.3 2.6-1.2Zm-7.9 38.8c-.2 0-.5 0-.8.2l-1.2-.1-.6-8.3v-1c.2-1 .5-2 1.3-2.4.6-.3 5 2 6.4 3l.1.6-.1.2h.1l.1.8-1.3 2-4 5Zm-3.7-72-.2.7c-.2.3-1 0-1.2.2l-.7-.3-.3-.4-1.2-1.8-1-2v-.1l-1-4.8c.6-.2 1-.3 1.5-.2l1.4.8c1.1.8 2.3 2.2 2.5 3.2.5 1.8.4 2.8.2 4.7Zm-1.4 30-.7.4-.5.2-7.2 1.8-.1-.2-.5-.9c3-3.5 4.2-4.3 7.6-7.9l.9-.4.5.4v6.6Zm0 12.7-.8.4-6.2-5.2-1-.9v-1l8-1.9v8.6Zm-.3 12c-.2.6-.2.7 0 1.4l-.4.5-.4.5-.4.6-7.3-15.9.6-.3 7.4 6.3.5.8.1.3-.1 5.7Zm0 28.4-1 .6c-4-2.4-11.4-7.3-17.6-11 0 0-.2-.5-.7-.8l5.4 1.4 13.3 3.5.6.4v5.9Zm-24.1-15.4-1.6-.5c-.6-.1-1.8-.6-1.6-1.1v-.2l4.9-8.8.6-.5.7.2 14 14.3-.1.3-16.9-3.7Zm-7.5-4.8c-1.4-1.4-5.5-6.9-8.4-10.1l-.4-.7.4-.4 13.6 1.2a7 7 0 0 0 1.1.4l-.2 1.7-4.3 7.9H235Zm-9.8-5-18-11.5.5-.7 11.5 4 1 .6 5.7 6.9-.7.8Zm-27.7-19.6 14-2.1 1.7.7 1.2 6.3-.5.7-16.1-4.8-.3-.8Zm-5-3.3c-.9 0-2.7.1-4-.6l-1.5-1.3-2-4 .3-1 19 4.4.4 1c-4.4.5-4.7.9-9.2 1.3l-3 .2Zm-10-13.2-4.6-10.8 1-.6c.7.9.6.9 2.2 2l9.2 5.8.4 1-7.8 2.7-.4-.1Zm-1.8 6.5-8.3-8.5.7-.6 5 3 2.2 1.7 1 3-.6 1.4ZM170 461.6v-.5l3.4-3.5c.3.2.5 0 .8.3l1.7 5.4.5 1-.4.4-5.3-2.6-.7-.5Zm-1 7c-7.6-4.8-1.5-1.2-9.1-6l-.6-1.1 4 .5 3 1.8 2.3 3 1.2 1.2-.8.6Zm-25.2-33.1.2-.2 7.6 4.5c.6.2.6.6.6.7 0 .6.8 1.3 1.5 1.6.2 0 .3.2.5.3l7.2 12.2-.5.3-2-2.1-15-17.3Zm14.3 22.8c-2.5-.5-3-.3-5.5-.8l-2.4-1.2a8 8 0 0 1-2.4-1.7l-3.1-6.7-3.7-9.5 17 18.8.3.4c-.3.3.2.3-.2.7Zm-18.6-29.6c2 .3 4 1.3 5.5 1.5l1.9 1 2.2 3.6-1 .3-8.3-5.3-.3-1.1Zm-9.6 7.2-1.2-.7.3-1 3.7-3.1 2 1.9 1.7 3.4 3.3 9.1-9.8-9.6Zm7.6 12.4L112.3 432l-2-1-.2-.7 2.2.7 5.7 2.4.6.3.5.2h.2l2 .8c2.2.7 4.3 1.7 6.1 3.4l10.7 10.5-.6-.2Zm-30.8-21.5v-8.5l4.3 3.3-.9 3.4-3.4 1.8Zm4.1-13 1.1-.8.6.2.5.3 1.4 3v.3l.3.6.2.5-.3 1.3.2.2-5.6-4.1 1.6-1.6Zm8.2-5.2.3 1.2h-.1l.5 2.8-2.4 2-2-3.7 3.7-2.3Zm4 22.2-.4.4-8.4-3 1-.7 4.6-1.4 3.1-1.4.2 6.1Zm-.4-15.8.6 3.9-1.4 1.3-2.5 2.2-4.5 1.5.6-1.6.4-.1 3.2-3.6.9-1.3 2.7-2.3Zm.4-22.3h-.3l-2-1.4c.9-2.4 3.8-2.5 5-2.3l.4 1.7.9 5.9c-.5-.1-.8-.4-1-.9l-2.3-2-.7-1Zm-.3-11.8.1-.3.5-.7 5.3-3 1.8 1h-.3l.3.4v1.5l-3.5 2.6-1.2 1-3.3-2 .3-.5Zm0-31.6 1.2.2 9.4 4.7-3.3.7-.6.4-1.2.3-2.2.3-1.2-.1-1.4-.7c-2.6-2-2.1-5-.7-5.8Zm-2-8.8c-.2-.6.4-3.6.4-5.7s.8-3.5 1.7-7c1-3.6 1.7-2 1.7-2l.2-.2 1 .7-.3 19.7-3.7-1-.5-.6c-.2-.3-.2-3.3-.5-3.9Zm-.6-28.7c-2.3.6-3.5 1-5.6 1.4l-.7-.4 2-4.6.8-1.4 1.1-.3c.4.7.5.4.2-.2l2.3 5.3h.2l-.3.2Zm-10.7 1-1.4.6H105l-5.4-.5-.3-.4 13-5.3-3 5.6Zm-5.2 23.8v.4l-1.2.2c-.5-.5-.9-1-1.2-1.6l-.9-1-.4-.3c-.5-1.8-2.8-2.4-3.3-4.3-.1-.3-.4-.6-.7-.8-.5-.2-1-.5-1.2-.8l.5-1.3h7.7l.7.7v8.8Zm-12-40.2.6-.4 6.4 1.9-4.8 10.1-2.2-11.6Zm-.6-7 .3-2.3V286l9.3 1.9v.2l-9.1 1.7-.5-.2Zm-2.9-8.1-11.3-1.9 14.5-2.6.3.4-3.5 4Zm1.6 30.2a32.4 32.4 0 0 1-8-2.9l-.2-.7 6.1-9.2.8.3 1.9 11.9-.6.6Zm-11.7-5h-.4a32 32 0 0 1-5.4-4c-.7-.6-1-.8-1.5-1.5l.5-.8 12.3-3.7.6.4-6.1 9.6Zm2-22.8 7.6 1.5-.1 2.7-.3.5-6.8-3.9-.4-.8Zm5.5 7.9-.2.5-13.8 4.2 6-9.2 8 4.5Zm-19.4 4.2a19 19 0 0 1-1-14.3l1.8-.5 7.3 4.3h-.2L68 296l-1.3-.2Zm8.3-24c3-2.3 4-3.4 7.2-5l-2 8.6-11.3 2-.3-.4c1.6-2.2 4.2-3.6 6.4-5.2Zm11.4-6.3.1-.1 5.4 7.5-7.3 1.4 1.8-8.8Zm3.7-1.8 4.7-.7H97l3.4-.2.2.3-4.9 8.2-5.8-7.5s-.2-.2 0-.2h.1Zm14.3.8-.2 6.5-5.5 2.2h-.3l4.2-6 1.8-2.7Zm-3.7 19.6-7.8-1.5 2.5-4 .7-.6 4 5.2.6 1Zm4.5-1.1-.7.2-5.4-7 5.3-2 .2.2.6 8.6Zm-4.8 13.2-7-2.8v-.4l9-2 .3.3-2.3 4.9Zm1.8 4.2 9 3-13 5.7 4-8.7Zm6.5-7 5.5 7.5-.3.3-10.2-3.3 2-4.9 3 .4Zm-1-27.5 6.8 4.6.3.4-7-.4V266Zm9.9-2.8 3.9.8h.8c.6 0 .6.2 1 .4l-.3.6-3.5 4.3h-.5l-8.5-6h7Zm7.9 4.4h.7l.9.9c1.9 2.2 4.4 2.5 7 2.3l1.3-.2c1 0 1.2.2 1.3 1.5l.5.1c.7.6 2.2 1.6 2.3 1.9l.2.4-.2.8-17.6-3.3.2-.2 3.4-4.2Zm17.2 12.8.7.8c.3 1 .5 2.2.6 3.3.2.8 0 1.1.1 2v.2h-1l-5-.5-3-.4-.3.1-.6-.2-4-2.9 11.7-2.6.8.2Zm5.4 31.8 7.8 6-1.5.5h-.6l-1.3.5-5 .6-2 1a3 3 0 0 1-.5 0l-1-.7V313l4-1h.1Zm3.6-2 17 4 .1.4-5 3.7-9.8-6-2.3-1.8v-.2Zm2.1-3.7 23.5-6.2.2.3-5.1 10.3h-.8l-18.4-4.1.6-.3Zm19.7-16.2 2.5 5.5-.2 1-19.7 5 17.4-11.5Zm15.7-10.3-.3.8-8.3 12.9-1 .4-2.7-6 12.3-8Zm6.5-2.4 9.8 13.1-1 1.9-20.2 3.3v-.7l.4-1.4 9.7-14.7 1.3-1.5ZM206 269c.8 6.4 2.3 12.7 3 19l-.9.4-10.5-14 8.4-5.4Zm5.8 30.8 2.2.2 11.5 10.8.2 1.5-1 .6-14.9 6.8-.4.6-.1-.2 2.5-20.3Zm19.4-15.5-.3 1.4c-6.4 1.9-9.5 2.5-15.9 4.4l-2.2-1.6-3.4-19.5 21.8 15.3Zm-5.5-29.7.6.2L233 280l-.4.5-19.4-13.2-2.2-1.8 14.8-11Zm44.3 22.5v.5l-.4.1-32.1 3.9-5.1-18.8-2-8.1 39.6 22.4Zm-37.5-25.7 18.3-.7 16 9.8 5.7 12.3-.5.6-.3.1-39.3-21.8v-.3Zm16.5-13.3.2 1.5-.1 7.3-14.9 1c5.1-3.6 11.2-7.2 14.8-9.8Zm3.4 3.5 6.5 3.8.6.3h.3v.1l5 2.8.7.3 3.3 1.3.2.3c.8 1.4.6.8.6 2.5l-2.9 3.5-6.3-4-4.8-3.4c-1.5-.9-3.2-1.9-3.2-2.2v-5.3Zm.5-18.6c2.2-1.4 8.5-4.5 10.5-5.9.4 1.4.1 1.7-.7 3-.1.2 0 .7.1 1l1 3.2c1 .2 1.2.4 1.4 1.6l1.8.5c.6.1 1 .4 1 1l-.1 3.8c0 .4 0 .4-.4 1 .5.2.5.6 1 .8.7.4 1.6.7 1.9 1.8 0 .2.3.4.5.5 1.3.5 2.6 1 4 1.3 2.2.3 4.6.7 7-.1 1-.5 2.3-.6 3.6-.8.9-.1 1.7-.3 2.2-1l2.6-5 .1-13.2 12.3 7.3v12.6l-.5 1.8c-.5.4.1.2-.5.5l-2 .5-.4.2.2 1c-.5.2-1 .6-1.6.7-1.5.2-2.8.7-4 2l.2.6-2.7.8c-.2 1.3-.3 1.4-1.5 1.7-1.9.4-3.8.4-5.7.1h-1.2c-2 .3-4 .3-6.1 0h-1.3c-2.2.2-4.3.3-6.5 0l-4.5-2-.6-.5-.7-.6-6-3.4-3.8-2.6c-.3-.2-.6-.4-.7-.7l.1-13.5Zm8.5-17.5-1-3h.3l1.4-3.1.2-.1h-.2l4.3-5.4.5-.1 1.5 4.7v1l.3 2.2.2 1c0 .4.5 1 .9 1.7.2.3.7.7 1.2 1l.5.6-6.2 2.2h-.2l-3.7-2.7Zm-4.7-12.8-1-3.8 9.1 1.2-6.2 7c-.8-1-1.6-3.2-2-4.4Zm4.5-17.9.7 2.2 1.8 6.1.3 1.3h-.3l.5 1.6-9.4-1.4 6.4-9.8Zm-8.4 6 .4-.8-1.1-4.2-.2.2-1-3.6-1-3.3 8.9 2.8-6 8.8Zm2-25.6.3.8.5 1.3 2.5 8.5.7 2-9.5-2.7 5.5-9.9Zm-8.3 2.8-1.8-7.2 7.2 2-4.8 8a25 25 0 0 1-.6-2.8Zm-4.4-11.7-1.9-2.3-.2-.7-.6-2.7-.2-1 10.3.6.6 2.4 2 5.4h.1l.5 1.2-10.6-2.9Zm-4.1-13.5 7.8-4 .9.5 2.1 6.8s0-.1 0 0l-6.5-.6-3.9-.3-.4-2.4Zm-.4-7v-3c0-3.2.4-4.9 3.2-6.3 1-.4 1.7-1 2.5-1.5v4.1l.1.7-.3 3v1.8l-5.4 3.2v-2Zm34.6 72.9v-.4l.5-1.9.4-2.4v-.3l1.2-3.6 1.1-3.9 1.3-4 1-1.8 1.5-.1.8.4v.6h.1l-.1 1.1-.8 5-.2 1.9-.4 2.2-1.4 8.5v.6l-.5 2.6-.1.6-2-.4-2.5-3v-1.7Zm10.7-30.5c1.1 0 2 .6 2.3 1.5l.1.5-.1.6v.2c-.7.8-.1.5-1.1 1h-.5l-.7.2c-1 0-2-.6-2.3-1.4l-.1-.6c0-1.1 1-2 2.4-2Zm2.6 13.2v1.5l.2 2.4.3 7.7-.1 3.1V197.6l-.1 2.7-.2 2-.4.5c-.8.8-2.4 1.5-3.5 2l-.7-.6-.1-1.3 1-6.4.4-4.3.7-6.2h.2v-.8l.2-.9.1-1.7v-1l.2-.3c.1-.1.3-.4.4-.3l1 .4h.4Zm5.7 71.3.3-1 10.8-6.8 1 6.4-12.1 1.4Zm11.4 9.8-.4 1.5h-.9c-1.8-.5-1.6-.6-3.2-1.5a253 253 0 0 1-8.8-5.4l1.2-.5 12.6-1.4.6.8-1 6.5Zm4.5 17.8-.1 3.1.2.3-6-4.3h.2l-4.9-2.7-6.7-3-.8-.3 10.5-4.7c1.8.8 3.7 3.6 5.9 6.5l1.7 5Zm-.8-13.4 4.3.3 1.1 1 .2 3.3-2 .9-1.2-.9-3.2-2.3.8-2.3Zm1.6-25.6c.8-.6 1.5-.9 2.2-1.3l.2 4.5-2.8 4.2-.7-.2c0-.8-.2-1.5-.4-2.2l-.3-3.7c.3-.5.8-.7 1.8-1.3Zm3.1 9.2.6 12-5.3 1 1.2-7 .2-1.9 3.3-4Zm.8-24.6.1-5.3 1.7.6 5.6 2.6 2.2 5.3-.7 1.3-4.6-.1-4.4-3.3v-1Zm.2-9.5 5.6-2.4v.1l4-1.4.9.1 5 1.4-7.4 3.4-3 .7-1.5-.3-3.6-1.4v-.2Zm4.5-9.9 1.4-2.8 1.1-.5h.3l4.1-1 2.2-.3-4.6 5.4-.5.6-2 2-.6.3-3.8 1 2.4-4.7Zm7.9-15.4 1.8-.5 2 1v-.2l5.8 3.2-3 2.2-2.4.8-1.4.3-6.8 1 4-7.8Zm2.1-8.2v-1.5l3.5-1 .2 3 1.9 6-4.4-2.4c-.2-.1-.2-.3-.3-.4l-.9-1v-2.7Zm0-10.6v-4.4l2.2 1 .3 1.3 1.3 6.6-3.8 1.3v-5.8Zm11-13 8.4 5.2-8.2 5.7h-.4l-9.5-5.8 9.6-5.1Zm12.7 114.8 1.7-.2c2.4-2.2 3.2-3.8 4.6-3.7l-1.3 6.3-12.6 4.1-1.3.4-.9-2.8c2.3-1.4 3.8-1.8 6-3.2 1-.7 2.5-.7 3.8-1Zm11.3 8.1.3 4.3c-.2.4-.5.9-1 1.1l-1.6 1h-.2l-4.4-1.8.1-.6c1.7-1.1 2.7-1.4 4.4-2.3l2.4-1.7Zm-1.5-10.8 1-4.6.2-.2c.2-.6.4-1.2.8-1.8l2 1 2.8 1.8c.2 0 .5.5.7.6l-.2 2-.2 1-1.4 1.6-6.5 3 1-4.3h-.2Zm10.2 5.3 1.8-1 .1-.2 2.1.9 2.2 1.5-.4.3c-1.4.2-.5 1.4-1.5 1.7l-.8.9-1.5 1.3-5.8 3.8-1-.2-.3-5.8c1-.3 1.6-1 2.3-1.5l2.5-1.5.3-.2Zm-16.2 17-6.6 3.7-.7.3c-3.3-.2-4.2-3-2.3-4.8v-.3l5.2-3.9 7.6 3.2a6 6 0 0 1-.9.5l-2.3 1.4Zm-1.9 80.4c0 .2 0 .3-.2.5l-.5-.3-8.7-6 8.8-3.8c.4.2.6.5.6 1v8.6Zm-7.3 19 .6-.8 3.3-.2h1.4c1.8.9 2 1.8 2 3.8V398.2l-2.6.6-1.2-.3c-.3 0-2.4-1.5-2.4-1.5l-1-1.7v-2.2Zm4.8-11.3c.5-.6.9-1.3 1.5-1.8.2-.3.4-.6.6-.5.2 0 .4.5.4.8V388.8l-7-.3-.6-.4c1.9-2.2 3.2-4.1 5-6.3Zm-.7-4.9-7.1 8.7-1-13.7 8 5Zm-9.4-20.5 7.7 4.7.6 1.1-6 2.2-1.6.7-.3-.4-.7-8.3h.3Zm9.7-6.9 1-.4.6 1.1.8 8.6-.5.4-.8-.3-8.7-5.3h-.2l7.8-4Zm-.2-26.3-.1 1.1-.2 3.5-.4 5.6v2.8l-.2 2.7-.2 6.7h-1.7c-.2 0-1.6-.4-1.8-.6l-1.2-.6-1.5-1.3a6.7 6.7 0 0 1-1-2.2v-24.6h1.5l5.8 5 .1.3.2.2.4.6.2.7v.1Zm-8-37.8.2-.6 12.8-4.2-.2.8c-1.8 1.2-3.7 2.4-5.7 3.5l-.8 1-5.1 4-1.3-4.5Zm2.6 19.6h2.4l2.9-.4h1.2l.3-.2a834 834 0 0 1-9.5 8.2 12 12 0 0 1-1.8-1.2l-.1-.3a12 12 0 0 1 1.7-7.5l3 1.4Zm-7.2 45.2c-.7-2.5-1-4.5-1.5-7.1l-.7-5.3v-1.1l2.3-2.1v6.2l.8 2.5v.5h.2l.2.4c.3.5.7.5 1 1l.7 1.4c1.5.7 2 1.5 3.5 2.2l-4.7 2.3-.5.1c-.3-.2-1.1-.2-1.3-1Zm-5 26.5 5.2-4.2.4.2.4 9.5-6-5.5Zm-2.7 7.6c-.1-.1.3-1.1.6-1.9l.4-2 2 1.8c1.6 1.6 1.8 1.5 3.4 3l-.2 1.2-3.5-.4-2.7-1.7Zm-3.8 5.8 1.2-.3 1.4 1 7 22.8-11.2-7-11.6-8.6L325 390Zm-23.5.3.2-.3v-.2l.6-2.1H321l-9.4 5.7-1.4.6-9.8-.3 1-3.4Zm-6.1-19.6 2.6-7.8.2-.5 8.5 1.6.2.2c0 .3-.2 1.5-.7 2.5l-.7 3-2.3 4.4-1 1.4c-.4.6-1.3 1-1.6 1.7l-5.2-6.5Zm-5.6 17.4 3.9-12.4 5.2 6.1-.1 1.2-1 2.8-.2.3-1.2.4-6.6 1.6Zm-3.2 10 .4-1.4.2-.5 1.2-3.2 7-2 .1 1-3.1 8.5v.2c-.4.5-1.1 1.3-1.9 1.4-.3 0-.4.5-.6.7-.5.6-1.4.2-2-.1-.7-.3-1-.6-1.1-1.4v-.6h-.2v-2.7Zm-2.5-29.4-.8.5-.7-1.6-1.8-5.5 8.8-.2 2.4.2 1 1.1-8.9 5.5Zm-3.8 23-.9-5.9-1-9.8h-.1l-.3-2.8.3-4.4c1.1 2 2.9 6 3.5 7.4h-.1l2 4.3 1.2 2.8.6 2.1-.1.1.2.3v2l-1.9 5.9c-.7.1-1 .4-1.7.5-.4 0-.7-.1-.8-.5l-.6-.2-.3-1.7Zm-5-30h-2c-.4 0-.6-1-1-1.1l.2-1c1.5-1 2.4-1 3.8-.2l.2.7v1.2l-1.2.4Zm-4.7 19.8.6-6.5c0-1.9 1-5.2 1-6.3l1.4-.6.1 1.6h.2l.8 10h.2l1.3 14.5-.6.9a4 4 0 0 1-2.7-1.5c-.3-.4-3-.1-3.4-.5-.1 0 0-.2 0-.4h-.1l.6-4.9.4-4.7.2-1.6Zm-12.7-13.8 6.4-14.4 2-4c.3-.5.5-1.4.8-1.8l.7-.5h.7l21.4 11.6h-9.6l-.6-1.6-1.6-.8h-.1l-.6-.3h-.2l-.8-.4-1.2-.2-2 .2-1.9.6-2 1.7-.6 2.4-10.8 7.5Zm-.4 5.4.9-1.3 10-7-1.6 14.5c-.2 0-.2.5-.5.6l-8.8-6.8Zm-4.8 16.1c-1.8 1.2-3.3 2.3-5 3.3l-.2-.6 6.6-15.3.8-.7 8.4 6v.3l-1 .8-4.6 3c-1.3.9-1.2.7-3 1.7l-1.2.8c0 .4-.9.3-.8.7Zm9 74.3-13.5-2.5-.7-1.5 2.3-4.2c.2 0 .8.5 1 .8l1 1.3c1 1.9 2.7 3 5 3 1.5-.1 2.8.4 4 1.3l1.2.8-.4 1Zm-8.2 11.6-4.4-9.6.6-.7 11.6 2.2.8 1.4-7 7.2-1.6-.5Zm7 27-8-7.8-1.2-1.7-.4-1.6.2-.5 1.6-3 1.3.7 6.8 13.7-.3.3Zm-4.7 6.6 3.1 1.2 7 5 .2 2.2.3 1.6c-.4.2-.8.1-1.3.4l-.5-.5-9-9.7.2-.2Zm-8.9-10.2 1.4-2.7 1.2.4 2.8 2.6c3.3 3.7 2.4 2.4 5.7 5.8l-.5.5c-4-2-4.4-1.8-9-4.1l-1.6-2.4Zm-7.4-16.7c-.2-.1 0-.2-.2-.3l.4-.6 8.9 1.2 1.6 1.7-1.9 4.7-.7.3-.9-.5c-2.6-2.6-4.6-3.8-7.2-6.5Zm-5 10-1.3-1.2-.2-.5 11 2.8 1 1.6-.8 1.6-1.3.3-2.2-.5-6.3-4.1Zm-8-1.7h1l7.6 6.2-11.5-1-.4-1 3.2-4.2Zm-9.2-7.2 6 4.7v.6l-3 4.3-.8.1-1.3-4.2-1.3-5.2.4-.3Zm-6.5-18-.4-.4c.7-.3.4-.3 1-.4 3.6-.6 6-1.3 9.5-2 1.3-.1.5 0 1.7.3l.8 1-5.5 7-2.3-1.4-4.8-4Zm-8.2 6 .2-.9c3.8 1 9.2 3.5 12.1 4.3l.5.5-.8 3h-1c-2-1.1-5-3-8-5l-3-2Zm-6.6-1.2 8.7 5.3.1.9c-7.4-2-10.6-2.5-18-4.6l.8-.4 6.1-2 2.3.8Zm-14-15 11.6-1 1.1.6-.5 6.7-.2 1-.2.1-12-6.6.1-.7Zm.5-9.2c.6-.1 1.1-.2 1.8.2 3 1.5 4.7 1.8 7.5 3.3l.2 1.2c-4 .6-8.5.7-12.4 1.3l-.1-.3 3-5.7Zm-3.5-6.3c-3.7-2.8-7-4.7-10.8-7.5-.5-.4-.8-.9-1-1.4l10.3.2 2.1 8.7.5 1.1-1-1.1Zm-8 4.2-3-7.9 10.5 7.8c-.2.2.5.7.6.7l-3.3 6.2-1.2.4h-.2l-2-3.7a54 54 0 0 0-1.4-3.5Zm-4.4 5.8 5.3 3.9.1.3-.3.7-3 3.3-.9-.3-3.9-5.3-3.1-5.7 5.8 3.1Zm-4.2-15.9H163.3l4.2 11.5-.4.6-8.4-5-.3-.8 4-6.3Zm-5-2.8.8-.3v.2l.9 1.5-1 1.6-3.2 4-4-6.4 6.4-.6Zm-8.8-10 1.2.5c.7.2 1 .6 1.2 1.3v.2l1.1.2 1.8 1.8h1.2c.6 0 1 .2 1.2.7l.8 1.4-6 1-1.2.2-.2-.4-1.5-1.1.4-5.9Zm-.7-13.8 3.3-2.6 1-1.2 8.6 6.7.2.7c1.1 1.8 2.2 3.7 0 7l-1.5.8-1.8-1.3v-.2l-6.1-4-2.3-1.6-.2.1-3.7-2.7 2.5-1.7Zm-11.8-49.4 2.7-.8 2.5 1c.2 0 .3 0 .4.2l1.7 1.2 1.6 1.8.3.6-8.5 4-3.2-1.3-.9-.8-4-3 7.4-2.9Zm.6-12 .4.5v.2l4.7 8.2-7.5-3.9-2-1.1-.5-.7 4.9-3.3Zm-7.8-11v-.3l.1-6.2 6 13.6-.3.4c-.1 0-.3.3-.2.4v.2l-5.7 3.5.1-11.5Zm.4-7.6-.3.2v-.7l.3.5Zm-6.2-22 15.2-1.6-.6.4-4.8 3.3a4 4 0 0 1-1.3.5c-1 .3-2 .6-2.8 1.4-.8.8-1.8 1.2-2.9 1.5l-2.2-.2-2.9-4.9 2.3-.4Zm-9.8-13.1 10.3 4.2.4.1-5 4.2-.9-.2-5.8-7.6 1-.7Zm-4.6-9.5-.5-8 6.2.6-5.7 7.4Zm3.8 1.4-.2-.2 4.5-5.2.8-1.2c.2 0 .7-.5.8-.4l3.7 3.9-9.6 3.1Zm10.2-7.8 13.5 2.5-9 1-1.4.2-3.1-3.7Zm2.7 7.3 2.9 3h-10.8l-.3-.3 4.7-1.7 3.5-1Zm2 10.5-9.6-3.6-.2-.4 11.9-.2-2.1 4.2Zm9.6 5.3.4.2v.6l-12.6 1c.7-.8 2.3-2 3.5-3.4l8.7 1.6Zm6.4-2.6-2.4-.3-9.4-1.9 2-4.3 2.6-.2 7.8.7a22.3 22.3 0 0 1-.6 6Zm5.5 33.7 1.2 1.3v1.4l-13.4-8.3-.6-.6 7-.6c.1.1.3.1.3.3 2 2.2 3.6 4.3 5.5 6.5Zm26.8 6.3 2.7-4.5c.5-.6 1.7-.3 2.1 0l5.9 3.8-11.4 4.6-.9-.6 1.6-3.3Zm13.9-23.6.6.5-11 12.7h-1.3l-2.5-9.6.8-1 13.4-2.6Zm.5-5.2-.4.9-4.8 1-8.5 2 4.4-10.2.5-.2 8.8 6.5Zm5.5-1.7-1.7-.3-9.1-6 1.2-.3 18.6-3.3.3.5c-2.8 3-6.7 6.6-9.3 9.4Zm10.4 12.5-.7.4-7.7-8.7v-1.3L208 298l.2.2-2.2 20Zm13 15 3.7 2.2v.6c-3.9 2.5-11.6 6.5-14.6 7.9l-.7-.5.3-16 .4-.1 10.8 5.8Zm8.9-17.8.3-.3.2.4-.8 6-1.7 10.4-1 .7-7.3-4-7.3-4.1 2.3-1.6 13.8-7 1.5-.5Zm15-9.6.9.3.2.4-12.6 3.8a3 3 0 0 1-1.2-.6l-8-6.8-5.5-5.5 26.1 8.4Zm0-4-26-8.4 14.7-4.5 2-.6 1.7 1 2.4 3.3 5.2 9.2Zm14 24.2 11.3-13.8.1-.4.7 14.8v-.4l-12-.2Zm-1 11.4-1.4-.3-.7-6.2 1.2-1.4h2l9.2.3.2 1-10.4 6.6Zm-5.6 19.4 2-1.3c.4-.3.9-.3 1.3-.5l1.6-.4c0-.8.3-1.3 1-1.7l6-3.9-8.5 18.5-2.9-9-.5-1.7Zm-6.4 33.9-1.2.1-12.4-15 19-1 1 .2v.5l-6.4 15.2Zm.8 32-.7-.7.4-.5 4.2-3 1.2 1.6v3.8l-5-1.2Zm0 3.8 4.2 1 .9.4v3.4l-.1 1.2-.9.3-1.6-2-2.5-4.3Zm-10.4 36v-.5c2.7.3 3.6.8 6.4 1.2 1 .2 1.9.6 3 1 .7.2 1 .3 1.3 1l1.2 2.5 2.6 5.7-.4.2-14.1-11Zm2.6 14.1-1.5-1.4-3.5-9.4 1.2-.2 14.1 11.5-.4 1.1-8.5-1.1-1.4-.5Zm-3 5 1.4.3 4.8 5.7-.6.5-7.9-2-.4-1 2.7-3.5Zm-2.7-2.4v.8l-3.8 4.1-2 .6c-2-1.5-4-3.3-6.1-4.7l-1.3-1.3.8-2.4.8-.5 11.6 3.4Zm-5.3-13.5 2.4.4 3.4 9-.5.5-6.4-1.6-2.5-1-1.3-1 5-6.3Zm-14-23.1-.4-1 9.2-2.4c1.4-.3 2.3-.4 2.6 1 .3 1.6.4 4.2.7 5.8l.8 6.7.2 1.3-.4-.3-12.6-11.1Zm-8.6 6.8-.8-.4v-1.3l4.8-4c.4 0 .4.3.8.1l12.6 11-.4.4-17-5.8Zm3.8 11.7-1-.6-4-7-.5-.6 1 .1 15 4.8c1.1.4 1 .4 1 .2v1l-11 2.1h-.5Zm-6.3 5c1.4-.5 2.6-.7 4-1h.6l1.3.1 6.3 5.2-.4.5-11.3-4-.5-.5v-.3Zm-2.4-11 .7.5 3.5 5 .7 1.3-4.6 1-.8-.6.5-7.3Zm5.4-14.2.1.7c-1.4 1.2-2.1 2.2-3.8 3.6l-.9.3c-.4 0-.2-.5-.5-.8l-2.3-8 7.4 4.2Zm-9-12.5-.8-.2-1-3-2.2-8 .8.2a3 3 0 0 1 1.8.5l4 2.6c.5.3.8.8.9 1.5 0 .3 0 .7.2 1l-3.8 5.4Zm-8.4 13.8c.1-.6-.1-.4.4-.7l5.3-4.8h.6l2.3 8.6-1 .8-3.9-1.7-3.8-1.8v-.4Zm2.9-8.4-5 5-.6.3v-.3l-2.3-8.3 7.9 3.3ZM176 420a2058.9 2058.9 0 0 1 7.1-4.8l.4 1-4.3 9.9-3.5-5.3c.2-.2.3-.5.3-.8Zm-2.2-20.1-.8-1.1-.4-9.4-.2-.2h.3l.6.4h.1v.1l6.2 6.6v.2l-5.8 3.4Zm-7 25.8c.3-.3.5-.5.8-.6l3.9-2.5.7-.4 3.5 4.8H173l-6.3-.2c0-.4 0-.8.3-1.1Zm2.3-23.9c0 .8-.2 1-.4 1.7-2 1.3-2.9 2-5.2 3.2l-.3-.4-1.2-.5-.5-2.5-.6-8.4 8.2 7ZM159 385.3l.2-6 6.4 4.8.7 1-2.1 1-5 1.4-.2-2v-.1Zm-1-11.9c-.4-.1-.7-.3-.9-.6l-1.7-3-1-2.7 10.1 6-5 .3H158Zm-1.3 20.4.2.1.5 2 .7 6.5-5-3.4-.6-.8 4.2-4.4Zm-8.1-7.6 5.4 5.4-3.6 3.4-2.3-8 .5-.8Zm6.3 4.8-.1.2v-.2Zm-1.2-5-4.4-3.4.7-.9 5-3.8v.3l.3 7.8-.1.7-1.5-.7Zm-7.3-7-2.1-7.6 7.9 2 1 .4v.2l-5.1 4.8-1.2.1h-.5Zm-2.2 8.6.5.4 2 8.1-7.6-4.3 5.1-4.2ZM138 381c2 .8 2.6 1.3 4.5 2l.7 1-4.7 4.3-1-5.1-.3-1.8.8-.3Zm5.6-.5-.6.4-5-2.3-.8-1 2.5-5 .5-1 .2-.1 3.2 9Zm4.8-16.8h.9l.6 1 1.7 4.4-7.4-1.5-.8-.5c1.6-1 1.7-1.3 3.4-2.3l1.6-1.1Zm5.5-6.5v.2l-5 1.7c-.2-.1-.1-.2-.3-.4-.5-.4-.3-.6-.7-1.2l-2.6-3.8-.1-.3-2.7-4.8 11.4 8.6Zm3.5-2-14-11.2.2-.2 15 .7c.1.2.3.1.4 0l-1.6 10.6Zm4.6 9c1.7 2.2 2.3 3.3 3.4 5l-1.5-.6-11.4-6.7 1-.6 3.2-1.3h.1l2.9 1.2c.7 1 1.4 2 2.3 3Zm17 1.2-13.8-6.2-2.4-1-1.7-1.2-.1-.7 1-9 .6-.2 16.4 18.3Zm2.5-14 3.7 4.3-1 .4-15.5-9.3-3-2.8 3.8-1.3 2.2-.1 1 .6 6.6 6 2.2 2.1Zm9.1-13-4.9 8.8-6-4.6 10.6-4.5.3.3Zm19.9 13-5.8-.3-.3-.3-1.8-1.1-3.2-5.6 11 7.2ZM222 355l-.1.4-12.3-8 14.2-8 .3.2-2 15.4Zm13.7 38.6Zm7 14.3h-.7L231.4 397l.2-.5 2.5.1 5.7 1.1 2 .6c.5.8 1 1.4 1 2.2v7.3Zm2.5 26.9-11.3-7.1v-.6l4.8-1.8 1.3.6c0 .2.2.4.4.5l.2.3 4.9 7.9-.3.2Zm-11.7 10.6 1.6-.8c4.5 3 4.2 3.6 8.9 6.7l1.3 1c.7.3.9.8 1.1 1.3.2.3 0 .3 0 .6L245 457h-1.3l-10.2-11.7Zm-4.6 0c2.8 3.3 4.7 4.9 7.5 8 2 2.3 2.4 3.2 4.4 5.5l-.6.7-8.6-1.7-1.9-2-2.1-11.2 1.3.6Zm-6-27.5 2.6-.8.3-.2.5.3 3.9.3 1-.1 4.5 3.3 1 .6c.4.2-.5.2-.2.5l-3.8 1.7-6.3-1.5-1 .1-2.8-1.8-.1-.1.4-2.3Zm-6-1.2-.5-.3a18 18 0 0 1-2.2-1.6l-.3-.1-1.7-1.7-.2-.6.2-.6 2-3.7 1.6-1 2.5.5 2 1.3 1.8 1.3 2 2 .5.2.2.2-.3.3h-.3l-.3.3-7 3.5Zm-10.8 9.6c.8.4 1.4 1 1.8 1.8.6 1 1.6 1.6 2.8 1.8.7.1 1.4.3 2 .7l6.6 4.3.4.1c.6.8 0 .7 0 .8-2 .4-7 1.8-10 2.3l-1-.8-.4-1-.5-1.4-2.3-9 .6.4Zm-2.9-19-.3-.6c-.2-.2-.3-.3-.3-.5l-.2-.8.2-3.3 1 .5c1.2 0 4.5.5 4.5.5l2 1.1 1.1 1-.2 1-.1.5-2.1 4.5c-1.5-.7-1.7-.8-3.2-2l-2.4-1.8Zm-2 18.6.5.4 2.6 10.4-6.8-3.8-.6-.7.4-1 3.9-5.3ZM191 375l5.1-.8.7-.1-2.9 7.2-1.6 3.3c-.2-.6-.2.1-.3-.5l-1.2-7c-.1-1 0-1.3.2-2.1Zm6 12.2-1-1 2.6-6.5 1-1.8 2.1-4.1h.3l.1.2 4.3 16.3-9.4-3Zm1.6 4.4 9.7 3.8.5 3.2c-1.7.7-5.7-.7-9-2.4l-1.5-3.7.3-.9Zm18.7-.8-6.2 1-.8-1.5L207 377l3.4 4 7.1 10Zm.4 3.8-2.5 4.7-.8.6-1 .4h-.2c-.3-1-.4-1.8-.5-2.7l-.1-1.2v-.6c.4-.3.8-.4.7-.6l3.2-.7h1.1l.1.1Zm8 13.4-7.6-5.3V401l2.9-5 .7.3 4 11.7Zm-.6-15.6-2-1.1c-.5-.5-.5-.8-1.2-1l-3-4.2-2.9-4.4 18 11.3-9-.6Zm15.4 22.5 2 .4.2.2v2.3l-2.5 2-4.7-4 5-.9Zm-1-3.5-7.7 1-1.5-1.2-4.5-13.1 1.5.4 12.5 12.4-.2.5Zm-30-53v5l-4.9-3.3 1-4.3 4 2.6Zm5.2.6h-.2l-6-4.6h1l4.6-.7 5 3.2.4.3v.4l.2.3-5 1.1Zm8 8.6v.2l-.2 1.5-.3.6-8.7-4-.4-.2v-3.2l8.7-1.4.2.4h.8v6ZM190.1 354l4.5 3.6 13.7 9.2-1.3 1.8c-.9 0-1 0-2.8-.4-1-.2-1.4-.8-2-1l-1.4-1-8.9-8.2-3.8-4.6 2 .6Zm10.3-1.4 2.1 1.1-1 4.2-4-2.7-3-2.3 5.9-.3Zm-11.4-3-.4-.4 5.2-8.8 4.3 8.9-9 .2Zm-4.3 16.7-9-10.4 20.5 11.6.2.1c0 .3.2.7 0 1 0 .2-.5.5-1 .8L189 371l-4.4-4.6Zm6.2 63.7-.5.3-7.8-2.7 4.3-9.6 4 12ZM178.4 388l5 1 3.6 1 .6 1.4-4.3 2.7h-.3l-.3.1-6.1-6.4 1.8.2Zm-5.8-9.2 10.7 6.7h-.6l-10.6-1.6h-.2l.7-5Zm13.5-2.8h.7l1.7 8.4-10.7-7 5-.9c1.1 0 2.3-.3 3.3-.5Zm-20-12.3 7 3.3c3.2 1.7 6.2 3.6 9.5 5l.3.7-1.7.2-10.3.3c0-.2-.2-.3-.3-.4l-4.6-9.1Zm1 17.2-5-4 5.8.3 1.2 1v1.1l-.4 2.3-1.5-.7Zm1.5 7.5.3-.5.4 4.8.2 5v.4l-8.2-6.7.6-.7 6.7-2.3ZM198 404l-.1-.2v.1l-1.5-.4-1.9-1-1.5-2-.2-.4-.4-2.4.1-1.5c0-1-.2-1.8 0-3.3v-.6l1 .1c.9 1 1.6 2.4 2.3 3.8l3.1 4.3v1.5l-.6 2.4c-.5-.2-.3-.3-.3-.4Zm29.7-24.6 9.9 11.3-.1.2-15.2-10.1-11.2-7.2s-1.9-1.5-1.1-1.6l12 2.6c1.2.2 2 .8 2.8 1.6l3 3.2Zm8.7-29c-1.6 1-3.1 2.1-5.1 2.4a4.7 4.7 0 0 0-3.6 2.6c-.4.7-.8 1.2-1.6 1.7l-.7-.2 2-16.4.6-.1 8.4 10Zm11-23.2v.8l-17.4 4.1-.5-.4 2.5-15.5 1.2.3 14.3 10.7Zm.3-18 .9.7 1.3 13.6-.2.7-14-10.4-.1-1 12-3.5Zm-15.1 26.3-.7.1v-.3c6-1.8 11.3-2.5 17.6-4.3l.8.6.3 1.2.4 5.2h-.1l-18.3-2.5Zm.2 5.4c-.4-.5-.2-.7-.8-1.3l.1-.2 17.1 2v.7l-8.8 5.6c-.2.2-.6.4-1 .4l-6.6-7.2Zm1.6 26.9c1-.9 2.7-2 4.4-3.4l2.3-1.5c1.2-.7 2.3-1.5 3.8-1.7.6 0 1.2-.2 1-1 0-.3.4-.6.6-.7l.4-.3 3.3 11.3-.2.6-18.1 1.1-1.4-.2-.2-1.3 3.9-2.2.2-.1v-.6Zm31-58v.3l-11.7 14.4-1.6-13.9.3-1.3 13 .4Zm-14-4.3-3.3-2.1-7-12.6 6 3.5 10.6 7 6.9 4.6-13.3-.4ZM184.4 326l9.8-12.1 1.5-.2 7.5 8.2-.2.3-18.6 3.8Zm19.8-.3.1.2-.5 16.4-20-12.5-.6-.5 21-3.6Zm-71.5.6 23.2 14.3.4.3-17.5-1-.6-.2-.8-1-5.1-12.3.4-.1Zm-1.2-6-.8-1.2 3.4-2.2 5.8-3.7h.4v6.7h-1.2l-3.1.1c-1.4-.1-3.3.2-4.7 0l.2.4Zm135.7-17.7-5-2.7-21.7-14.4 5.7-1 26-3.3 1.7 1.5-6.7 19.9Zm16-30.6-1-.1-4-.8v.1l-2.4-.5-4.5-9.4-.5-1.4c2.7-.3 5.6-1 8.4-.8h4.2l4.4 1.6h.1l.1.1 4.5 2.2c1 .7 2.6 1.5 4 2.6l-13.2 6.4Zm27.3 28.9-13.6.4-.9-.2-10.4-14.2.8-.5 1.8.4c3.2 1 6.7 2 8.4 3.9l13.9 10.2Zm7.7-23.8 2.8 1.4-2.2 2.9-.2.2-8.7-5h-.1l2.5-1.3.2.1 5.7 1.7Zm2.2-37.5-1.7.8-2.3.9-.5.1-1.9.8-.3-1.4V237l.2-.5.5-.3 2.9-2 1.8-.3 1 1 1 1 1.3 3.4-2 .3Zm4 2.6 2.8 1.7 1 6.9-5.7-2-1.7-5.5 3.6-1.1Zm.6-18.2 2.7.6 5.7.4 3 .5.4.5v5.1c-.2-.2-.4 0-.6-.2l-2.1-.7-3.9-1.5-6.2-2.4-1.1-2.2h2Zm11.9-26.9v11.5l-.9.9-3.9 1.1v-7.8l.5-2.4.7-.7 3.6-2.6Zm-2.6-6.4ZM329.2 314l.3-.3 7.4 4-.5 3.7-.7.2-.4-.5c-2-2.5-4.1-4.6-6.1-7Zm4.2 17.5-2.6 3.5h-5.4c-.6 0 .2-.8-.2-.8l7-4.4 2.2-1.3-1 3Zm-4.5 25.3-3-3 3.3.3 4.6-.2h.8l.4.3.4.6 1 9-.4-.3-7.1-6.7Zm-6.4 9.4 9.7 2.9 1 .6-5.3 4.8-.3-.4-5.1-7.9Zm-1 12.5-4-3.1-.7-1-.1-.2-.3-.2-.9-1.4v-.2h-.1c-.9-1.7-.5-1.8-.6-3.3l.5-2.9 2.4.5 5.3 7.3 2.7 3.8.4.4v.3l-.8 2.8-2.8-1.6-1-1.2Zm-10.1-4.8c.3-.2 2.4 4.2 2.7 3.9l2.8 2.4 2.4 1.7 2 1.2.3.7c-3 0-8.6.3-13.1.3l-4.2-.1c1.5-4.6 4.2-8.2 7-10Zm-12.1-16.4.4-.7v-.3l11.4-5.6v2c.1.2-.9 4.3-.9 4.3l-.6.8-.4 1.6-1.5.6h-2L300 359c-.3-.6-.5-1-.7-1.1v-.3Zm-9.5-21.7v-.6l.6-.4 12.3-1.1.5.4-1 3.4-4.5 13.6-1.5.5-6.4-15.8Zm-13.5 4.2c1-.6 1.9-1.2 3-1.3.5 0 1-.3 1.6-.4l-.3-1c1.4-1 1.5-1.2 3-2l1.7.3 7.9 18.7-1 1.1L271 344l-.2-.4 5.5-3.5Zm-4.8-35v-.8l6.4-19.9.9.2.5.8 7.5 9.6 4.2 6.2.7.9-20.2 3Zm12.4 13.6v.9l-1.2.8-9.3 6-1-.7-.5-14.6.3-.1 11.7 7.7Zm17.6 11.3-11 1.1h-1.8l-1.7-.8v-9.1l.3-.2 13.5 8.4.7.6Zm1-5.6-1 .9-2.2-1-23.3-15.5 15.9-2.6h3.3l7.2 18.2Zm8.3-13.6-4 11.6-.4.1-.7-.3-6.4-16.2.2-.5 10.8-.5.5 5.7v.1Zm7.5-22.5-.5-.2h-.5l-4-1.3-.5-.2-.7-.3c-.6-.3-.8-.4-1.2-.8l-.5-.2.4-2c0-.6.2-1.2.4-1.7l9 5-2 1.7Zm4.2 17.4a6 6 0 0 1 1.5 1.5c.4.7.5-.3.7 2.2.3.6-.2.8-.1 1.3 0 .5-.2 1-.4 1.5-.3.3-.7.5-1.2.7h-3.1v.1h-1c-1-.4-2-.7-2.8-1.2-.6-.2-1.2-.4-1.3-1.2l-.1-.2c-.2 0-.3-.2-.4-.3l-.4-4.4 1.9-1.6c.2-.1.3-.5.8-.8.3-.1 2-.6 2.2-.4l3.7 2.8Zm3 10.4 8.1 8.6.1.2-10.3 5.7 1.6-14 .6-.5Zm-3.4 24-.1-.8.1-.4h8.5l.4.1 1 7.7-10-6.5Zm-2.4 9.7-2.4-.4c-.2-.2-.3-.6-.2-1.7v-4.2l.2-.4.5.1 3.3.8.2.2 8.8 6v.4l-10.4-.8Zm-9.6-24.7 2.5-7.7 4.6-.1.8-.3 3.7-.3v.3l-.9 5c-.2.2-.3.4-.3.2l-1.3.8-4 1-1 .2-3.1.8h-1Zm-1 8 1.2-3.8.4-.3 6.7-1.5v.4l-1.5 6.7c-.7 3-2.7 6-2.7 6l-1 .4-.9-1.7-2.3-6.2Zm1 13.2.3.9-8.8 3.8 4.5-14 3.9 9V346.2Zm8.5 15.3-1.7-1.3v-7l3 .2 7.3 7.2 4.6 4 .7.8-12.2-3.3-1.7-.6Zm6.8-72.9h.2l1.5-.7h2.4l1.3.4-.3 2.4-.2.7v3.5l-1 2-8.2-5.8 4.3-2.5Zm-9.5-19.2 1.2-.3 4.8-.6 3.5 1 1.3 2.1-.1 1.7-3.7 1.8-7.6-2.8.6-2.9Zm3-18.5-.5 2.8-1.4 3.9c-.9 1.4-.6.7-1.3 1.6l-.2-.6-.6-5.5-.4-3.1v-2.3l.9-1.7 1.6-.7.9.2.3.1.7 3.7v1.6Zm6 9-2.5 4.5-.5.7h-.3l-4.6.4 4.4-8.8h1l2.5 3.3Zm12-1.7v3.8l-1 .9-.5-.2-3.1-2.6 2.7-5.4 2-2v5.5Zm-2 25.5-3.7.5-.6-.3-8.3-.7 3.8-5 3-1.5 2.6 3.1 3 3.7.1.2Zm-4-11.8-.9-1.5-.2-.4-.2-.6.2-.4 4.5-.8h.4v.4l1.6 1.8.7.3v7.4l-.8 1.9-5.4-8.1Zm.2-26h1.1l2 1.1v.8c0 .8.2.6-.1 1.8-.3 1-1 1.7-1.4 2.6h-.5v-.2l-.4-2.2-.7-4ZM333 265l-7 1-.3-.2 1.8-2.9 2.2-.4 3.3 2.5Zm3.9-24.5v1l-1.6 2h-1.5l-1.2-1.2-.5-.2-1.2-.9-1.5-1.2 1.7-2.1 1.9-3.7v-.1h2.2c1.2.2 1.6.3 1.7.8v5.6Zm-7.9-5.5-2.4 3.1-.3-.2-.6-.6-1.4-3.8.4-2.9 4.4 2-.1 2.4Zm2 20.3-1.5 2.6-2-.6-2.8-3.2.2-1 1.3.3 4.7 1.9Zm7.4 47.3-1.9-1c-1.2-2-2.7-2.2-2.8-3.8l.4-1.6h.1l.4-4.6v-2.8h2.8l.4 4.6.8 5.3s0 .8-.2 1v2.9Zm-4.7-122.2 3.3 2v7.2l-1 .2-.4-1.3-2-6.6v-1.5Zm3.4-5.3V178.3l-3.7-2-.3-4.8 1.4 1 .1.1 2.4 1.4v1.2Zm-8.4 38.8Zm-4.6-4.4 4.3-4.8.2 6-4.5-1.2Zm5.6 8 4.1-3.4h.2v-.2l2.5-.8.5.5c.1.2 0 .5 0 .8V219.4l-.6 2-1 .4-2.1-.4-7.7-.6H323l.3-.7 5-2 1.3-.5ZM167.1 320.2l4-2.8.7.2 2 6.6-6.7-4Zm7.3 9.5-3.7 8v-.1c-2.2-4.9-2.8-7.6-5-12.4l8.7 4.5Zm-15-.1 2.6-4.4.3.2 2.7 8-5.5-3.8Zm8.3 9.8c-1.8.4-5.1 1.3-6.4 1.5l-6.5-7.7c-.1-.5-.2-1-.4-1.3.5 0 1.1 0 1.2-.3l12.1 7.8ZM150 322.6l7.9-1h1l.5.5-2.5 5.7h-3.8l-1.2-.8-4.3-3-.1-.2.5-.3 1.6-1 .4.1Zm-16 53.3-3.9-2.3a233 233 0 0 1 7-4.3l-3 6.6Zm-5 9.6 1.6-1.7 2.5-2 .7.6 1 6.6-5.8-3.5Zm.7 4.7.3.1 5.2 3.5-1.6 6c-.3.2-.5.4-.7.2-.5-.3-1.8-.9-2-1.3l-.1-.2v-.2l-1.1-8.1ZM126 415l-.6-2-.4-5v-.4c.2-.4 1.5-.4 2.5-.2l.6-1.5 3.6 2.6.3.1 3.4 2.2c.4.3.5.6.4 1-2.5.7-7.7 2.5-9.8 3.2Zm5.3 12.7v-.1l-4.4 3.5-.4-.5-.2-5.8 4.2 1.8.7.4.1.7Zm-5.2-7v-.9l.5-.3 1.3-.7 7.6-2.8-.3 2-1.5 5-.1.4h-.1l-.2-.3-1.4.2-5.8-2.6Zm14.4-15a282 282 0 0 1-4-2.7l1-3.1 1.4-4 6.2 3.8.1.2 1.7 1.7.7.3v.1l-.5 1.2-6.6 2.4Zm.6 11c.1-.4.9-.7 1-1 .8.3.4 0 1.1.3.2 0 .3.4.4.7 0 1 .6 2 1.3 2.7l-.5 6-1 .5-6.2-1.2.1-.3 1.6-6.8.2.3v-.5l2-.7Zm117.8 22.7.7 4.9-4.8-3.4c0-.5-1.7-3.4-1.7-3.8.7-.4 0-4.3.7-4.5l4 2.3c0 .4.3 2.4 1.1 4.5Zm21.2-34.3v1l-.3.1.2 2.7-1 6.3v5.7l-.6 3.7h-.2v1.3l-1.3.4-3.4-1.1v-.2l-.6-.1-2.5-2.4-.7-.9-.4-1.3-.1-3.4v-5.2l-.3-5v-2.6c.5-1.1 1.6-2 2.1-2.2l5.4.2c1.4 0 2.7.7 4 1.2l-.1 1c-.3.2.2.6-.2.8Zm73.7-89.8c0 2.2-1 3-2.2 3.3l-1-.7-3.2-2.2-.4-.5-2-1.3 7.6-6.7 1.9 5-.5 2.5-.4.4.2.2Zm24.1-22.1c.9.1 4.6 2.1 6.6 2.8l-25.8 16-1-1.9v-.3l-1-3.2.3-.2 8.8-5.8c1-.7 2.4-1.6 3.4-2l1-.8 7.3-4.7.4.1Zm8.3-6.9-1 4.7-4.4-1.3-.8-.4-.1-4.1 6.3 1.1Zm-12 42 1 .2v.7l5.8 11.3-16.6-.6 9.8-11.7Zm-1.6-16.2 5.1-3.2-3.4 12-.4.2-9-3.9 3.2-2.2c1.4-1 3-1.3 4.6-1.7l-.1-1.2ZM360 337c-.7-.2-.7-1-.7-1.7v-6.7c0-.7.3-1.3 1-1.4l.7-.3v-1c1.4-1 1.5-2.7 1.2-4.4v-.6l.1-.4 9.8 4.4-.9 1.1-11 12.5c-.3-.4 0-.3.1-.8-.2-.2 0-.6-.3-.7Zm29.5-21.2-1 1.6-10.2 3.8 3.4-13.6c.4-.4.8-.7 1.4-1 .7-.1 1.2-.5 1.6-1.2.4-.7.9-.7 1.4-.1l3.4 10.5Zm.3-26.6s-.1-.4.2-1.4l.3-3 1.7-1.6v.2l1.3 5c-.2 1.8-1 3.5-2.8 4.2l-1 .2.3-3.1v-.5Zm1.5-15V273l.3-.6 5-1-.8 3.7-.9 2.1h.2l-3.2 1.5-.6.1-.5-.3.5-4.4Zm1.5-12.3c.3 0 1.7-.7 2.7-1.1l.3.8 1.5 6.3-2 .2-3 .1h-.2l.7-6.3Zm1.8-14.4 2.9-.3-.2 7.2-.5 1.4-1.6.7-1.7.8 1.1-9.8ZM398 228l5.3 3.2 1 .6.4 1-7.9 9.3-.3-6.6 1.5-7.5Zm.8-10.5c1.7 1 9.2 6.7 10 7v3.3c-.2.1-1.6 1-2 1l-7.2-4.2-1.4-2.7.6-4.4Zm4.4-8 4.9-3.9v8.3l-.6 3.5-3.6-1.7-4.2-2.3 3.5-3.8Zm-2.7-5.8c.6-2.4 1.4-3.6 1.5-3.6l5.3-1.8-.2 3c-.7 1.4-3.2 2.6-3.4 3l-1.8 1.3-1.5 1.3.1-3.2Zm1.4-9.5.5-5c.4.2 2.5-.6 2.5-.6l2.6-.3v5.3l-4.5 2.1-1.4.3.3-1.8Zm1-10.7v-.2l.7-6v-.2l.3-.3 1.8-.8.5-.3 1.7-.8v.8l-1 8-4.1 1.6.1-1.8Zm2-17.7v-.1l.1-.7 3 2.1v3l-.7 1.3-.1.2-3.1 1.2.8-7Zm9.9-4.3c-.5 1.3-.7 2.3-1.3 3.6-.2.4-.3.6-.5.6s-.4 0-.7-.2l-4.7-3 7.2-1Zm1.4 17.3-3 1.4-1.8 1.1v-4.3l.4-6c0-.6.2-1 .6-1.3l3 .2.8 8.9Zm1 9.7c-.4.7-1 1.4-1.7 2-1 .6-1.8.6-2.8 1l-1.3.7v-6.3c.9-.3 2.7-2.7 5-2.8l.8 5.4Zm-15.7 109 2.7 1c.4-.1.6.9 1 .9.4 1 0 1.6-.5 1.9-1 .6-1.3-.4-2-.8-.7.3-1 1.5-.8 2.2.1.9 1.3 1.9 2 2 .9.2 1.8.2 2.6-.3l.3-.2.6-.7.4-.7 3.9 2 .2 4h-.3c-.1.3-7.3 1.8-10.3-1.8l-2.1-2.4c-.4-.2-.9-1.3-1-2.2l-.6-2 4-2.9Zm-5.2-5.8c.5 0 5.5-1.8 6-1.5l-.8 3.5c-1.4-.2-4.3 2.9-5.3 3l-2-.8v-1.1l2.1-3.1Zm7.3 4.7ZM402 285l1.6 1.3c-1.8 1-4.8.8-6.2 1.6l-1.2-5.1h2l3.8 2.2Zm8.8 6.4.3 3.2v3.1c-.4-.1-1.9-.4-2.7-.8l-3-1.9c-.2-.3-.4-.6-.3-.7l1-3.4 4.7.5Zm-5.9-14.3 4.6-1 1 2-.1 7-8.3-4.3-2.8-1.7 5.6-2Zm3.2-4.6-8.5 2.3.9-3.4 5.5-.2h.3l1.8 1.3Zm-4.2-7.8c1 .6 3.1 1.8 3.3 2.5l-4 .5-2.2.1-1.4-5.5 4.3 2.4Zm3-9.4 2.7-1 .5 10.5-8.8-6.2-.2-.3 5.7-3Zm-5.1-12v-.7l.6-.8 5.7-6.8.9 1.9.2 7.2-7.4-.7Zm2 3.3 5.3 1.1-.6 3-7.4 3.4.3-7.3c.3-.1 2 0 2.5-.2Zm13.6-47.7-4.4 1.4c-.7 0-1.2 0-1.5-.3v-3l.2-.6 4-2.2 1.5-.3.2 5Zm.8 4.6.8 8-1 3-.1.5-5.7-2c-.3-3.2-.2-5-.3-8.2l5.5-1.5.8.2Zm1.3 18.3.7 4.8-.2.2-2.5-1.2-1.2-.7-.5-.4-3.6-2.3-.1-4.8c0-1 3.3 1.1 5.1 1.7h.6l1.3 1 .4 1.7Zm1.7 16.7-8 3.8-.4-7.3v-6l4 .6 3.8 1.2.6 7.7Zm1.2 14.1-8.8-2a11 11 0 0 1 .2-4l7.8-3.3.8 9.3Zm.5 6c0 .6-.3 1.2-.5 1.8l-3.9 2.2h-2.7c-2.3-2.5-1.6-4.7-1.6-7.2v-.5l8.6 2.1.1 1.5Zm1.4 15.7-9.4-3.8-.2-3.4 4.9-1 4-.9c.1 2.8.6 6.4.7 9.1Zm2.1 21.3v.7l-.3 1.2-1.3 1.5-2.5 1.6 1-13.3.1-.3 2.4-1.3.6 9.9Zm1.6 14.4-6-1.5c.3-1.6.1-3.5 1.7-4l3.6-2.6.7 8Zm-13.3-30.3.3-4.9 8.7 3.6-3.4 5.8-5.6-4.5Zm3.6 39.4c-.2.3-1.7.5-2.6.7l-.1-8c2.2-5.1 5.8 2.8 2.7 7.3Zm-3.9 31c.2-.3 0-.5 0-.9v-3.3c0-.5.4-1 .5-1.6.2 0 1-2.5 1.8-4.8l1.2.1.8 10.2-.3 4.2-4 3.3c-.2-2.3-.4-6.4 0-7.2Zm4-26.9-.7 12.3-3.4-.3v-3.5c.1 2.1-.1-4.3 0-6.4 0-1.6 2.5-2.1 4.1-2Zm.7-27-.1 1.7-.8 6.4c-.2.7-.6 1.3-1 1.2l-1.8-.1-.3-7.3.6-.5 3.4-1.4Zm-2-3.7-.3.3-2 .7-.3-8 2.7 1.3c.3.4.6.9.8 1.5 0 .4.4 1 .4 1.3.3 1.7-.8 2-1.3 3Zm11.6 28.6c0 2.1-1.3 9.6-1.3 9.6l-.3.6-4.4 5.2-1.6-.4 2.1-23.3 4.1 1.1h.1c.4.2.5.5.7.7.3 1.8.6 5 .6 6.5Zm4.2 8.5.2-2.2v-1.1l1.5-.4 5.7 9.7-8.5 7.2 1-13.2Zm16.8-.4v.7l-6 3-.9.3-7.5-12.6-.5-1.2 15 9.8Zm-2.6 14.7-13 2-.5.1 8.4-7.2 5.1 5.1Zm4.6-10.3-.2 9-2-1.5-4.1-3.8-.3-1 1-.5 5.1-2.4.5.2Zm3.6 85.4c-.2-.3-.2-.7-.1-1 0-.5-.1-.8-.6-1l-.6-.1c-.7-.4-.7-.8-.1-1.2l.6-.6-1.8-.6c-.7-.3-1.6-.5-1.8-1.5 0-.2-.3-.3-.5-.4l-1.6-.6c-.6-.3-1.4-.6-1.6-1.1-.3-.7-.9-1-1.4-1-1.4-.3-2.2-1.5-3.5-2l-.2-.3c-.6-1-1.7-1.6-2.8-2-.8-.4-1.6-.9-2.5-1.2-1-.4-1.5-1.5-2.4-2.2l-.1-.3v-.3c0-.7.2-1.4.4-2.2-.9-1.1-.9-4.5.1-6-.7-.6-.7-1.4-.7-2.2 0-.8 0-1.6.8-2.1-1-1.3-1.1-4-.2-5.8-1-1.3-.8-2.7-.1-3.8l-.5-2.5v-2.2c-.1-1.3.5-2.4 1-3.5.4-.8 1-1.6 1.8-2l.4-.7.5-1.3 2.9-4.2c.4-.6.8-1.3 1.6-1.6l.4-.4c-.2-.8.3-1 .8-1.4l.2-.7.4-.8c1.1-1.7 2.2-3.5 3.5-5 .5-.6 1.1-1.1 1.5-1.8l6-6.3v-16.3l-23.3-15.9L418 160.2l-.4-2.9-15.5 2.3L398 194l-11 85.6-.4 2.8-2-.1-3.5-.6h-.1l-.3-5.5-8.5-5v-4.7l-9-5.4-.3-29.1 3.3-2.9-.2-13.8h-1l-.3-2.4-14.6-28v-21.7l-12.7-7.9-14.2 7.9-.3 23-14.2 28-.3.8v.6l.1 14 2.2 1.5v4.9l-4.2 2 .1-.5V236.2l-.1-1V222l-.4-.2-15.5-10-1.8-42.9c.4 0-.1-1.5-.2-1.8l-1.5-1.7c-.6-.5-1.1-.5-1.7-.7h-2.8l-3.5.7c-.6.3-1.4 2-1.7 2.4-.3.5-.9 3-.9 3l-.2.7-6 20.3c-4-12.3-19.3-61.3-19.6-61.9-.3-.6-2-2.7-3-4.2 0 0-.1-.2-.4-.3 0 0 .2-8.2 0-10.3-.4-2 0-2.8-.5-3.3a21 21 0 0 0-3.5-2.5c-2-1.2-1.2-.3-3.2 0-1.9.3-2.5 1.3-3.7 2-1.2.6-3.2 1.9-4.2 2.8-1 1-1.2 3.2-1.3 3.6 0 .5.5 4 .4 6.3 0 2.3.8 16.5.8 16.5l2 2.8.6 4.2 5.6 2.6 4 15.8v.1c0 .3 0 .6.3.8l.3 1.3 1.4.9 11.3 38.7 4.6 4.2.6 1-13.3 8.3-.2 12.6-26.5 18-65 41.7-6.5 4c.2-.3.2-.7 0-1.1-.2-.2-.2-.5-.2-.7V289c1.2-1 0-2.2.3-3.2l.1-.3c.6-1.7 0-3.4-.1-5-.1-.9-.4-1.7 0-2.6 0-.3 0-.5-.2-.7h.1c.3-.6-24.4-16.2-25.3-16.7-.8-.6-1.3-.7-1.9-.9H88.4l-1.4.2c-.3 0-.7.1-1 .3l-4 2.9-21.3 13.7c-.7.5-1 1-1 2v24.2c0 1.1.3 1.8 1.2 2.4l4.2 2.8c0 .6-.2 1.1 0 1.5.2.5.3.8 0 1.3-.1.5.1.8.5 1l2.3 1.6c2 1.5 3.9 3.2 5.7 4.8 1.4 1.2 3 2.2 4 3.8 0 .2.3.2.5.3l1 .6 3 3.4 2 3.2a4 4 0 0 0 4 2c.7 0 1.2.2 1.8.6 1.5 1 2.3 2.8 4 3.5l.3.4 1.3 1.2c1 .7 2 1.4 2.8 2.2.8.7 1.5 1.4 2.4 2 1.8 1.6 3.8 3 5.1 5 1.5 2.3 3.4 4.3 4.3 6.9 0 .2.3.3.4.5l1.4 1.6 3.6 5.3c.7 1 .9 2 .4 3.1a3.4 3.4 0 0 0 1 4.1c.8.6 1.6.8 2.5.7 1 0 1.8.5 2.4 1.4l1 1.7v4.3l-5.3 2.8V393h.3l-.2.7 5.9 4.6c0 1.1 0 .8-.5 1.9-.5.8-1 .8-1.1 1.6 0 .3-.4.6-.4.8l-17.8 11.2v16.8l162.1 104.5c1 .2 1.7.4 2.4.4l4.3-.2c.7 0 1.5 0 1.4-.1h6.3l8.7.2c1 0 2 .1 2.9-.4l6-4 .3-.1v-.2c.3-.5.5-1 .9-1.2 3.2-2 6-4.6 9.9-5.5-.3-.6 0-1 .5-1.3 1.3-1 2.7-1.4 4.5-1.8-.7-.9 0-1 .4-1.4 2-1.3 4-2.5 5.8-3.8 1.7-1 3.4-2.1 5.4-2.4l.6-.3-.2-1c3.7-2 6.7-5 10.8-6.3.3 0 .8-.4.8-.6 0-.7.5-.9.9-1.1l5.4-3.5c.6-.4 1.4-.7 2.1-1 .7-.3 1.6-.2 1.8-1.2l.4-.2 1.5-.6c-.1-.7.3-1 .9-1.4l2.1-1.4 5.2-3.2 1.8-.7.2-.5 8-5h.1l1-.2.1-.5 1.9-1.2.9-.3.2-.4 6.8-4.5.5-.2c.4 0 .8-.3 1.3-.5a1 1 0 0 1-.2-.4l5.7-3.7.7-.5 1.5-.4v-.5l1.3-.9h.1c.6-.3 1.6-.2 1.7-1.2l9-6c1-.4 1.8-.8 2.7-1v-.7l9.2-6.1 1-.5c.8-.2 1.6-.2 1.8-1.2v-.2l3-2a11 11 0 0 1 3.5-1.4c.2-.5.4-1 .7-1.2 1.1-.6 2.3-1 3.4-1.5.3-.5.6-1 1-1.3a671 671 0 0 1 10-6.5c.7-.4 1.5-.6 2.1-1 .4-.1 1-.3 1.2-.6l.3-.6c.4-.5 1-.7 1.4-1 2-1.4 4-2.8 6-4 2-1.3 3.7-2.7 6-3.4l.3-.2c-.2-.4-.7-.8-.7-1.2V426c0-.2.2-.6.4-.7 1.4-.3 1.6-1.3 1.4-2.5l.3-1c.3-1 .4-2-.1-3Z"
      }
    )
  ] }) }) : /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 550, height: 550, style: t, fill: "none", viewBox: "0 0 550 550", children: /* @__PURE__ */ jsxs("g", { opacity: ".2", children: [
    /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M83.5 422.5h-6v-17h6v17Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#fff",
        d: "m80.9 410.3-3.3-5 15.4-9.7 3.2 5-15.3 9.7ZM282.1 79.7a4 4 0 0 0 4.1-4 4 4 0 0 0-4-4 4 4 0 0 0-4.1 4 4 4 0 0 0 4 4ZM375.7 247.6c0-1.7-1.4-3.2-3.2-3.2a3.2 3.2 0 0 0-3.2 3.2c0 1.8 1.4 3.2 3.2 3.2 1.8 0 3.2-1.4 3.2-3.2ZM262 110.4c3.5 0 6.4-2.8 6.4-6.3s-3-6.3-6.5-6.3a6.4 6.4 0 0 0-6.4 6.3c0 3.5 2.9 6.3 6.4 6.3ZM292.7 129.3a4 4 0 0 0-4-4 4 4 0 0 0-4 4 4 4 0 0 0 4 4 4 4 0 0 0 4-4ZM212.6 232.1ZM58.6 199.8l-.5.3.5-.2ZM364.2 139.3v-.1h-.1.1ZM362.7 138.3l-.1-.2h-.1l.2.2ZM163.3 258.9h1.6v-13.7h-1.6V259ZM214 209.3l.1-1.4-.9-.7-1 .7v1.2l.2.5 1.6-.3ZM363.5 185a3 3 0 0 0 3-3 3 3 0 0 0-3-3 3 3 0 0 0-3 3 3 3 0 0 0 3 3ZM379 204c2.7 0 4.9-2.2 4.9-4.8 0-2.7-2.2-4.9-5-4.9a4.9 4.9 0 0 0 0 9.7ZM236.8 211c2.7 0 5-2.2 5-5 0-2.6-2.3-4.7-5-4.7s-4.9 2.1-4.9 4.8c0 2.7 2.2 4.8 5 4.8ZM245.3 55.2a3 3 0 0 0 3-3 3 3 0 0 0-3-2.9 3 3 0 0 0-3 3 3 3 0 0 0 3 3ZM341.4 9.3V0S460.9 78.9 461 78.9v9.3L341.4 9.3ZM341.4 33.4V24s119.5 78.8 119.7 78.8v9.4l-119.7-79ZM537.4 209a3 3 0 0 0 3-3 3 3 0 0 0-3-2.9 3 3 0 0 0-3 3 3 3 0 0 0 3 3ZM526.2 238.3c2.8 0 5-2.1 5-4.8 0-2.7-2.2-4.8-5-4.8-2.7 0-4.9 2.1-4.9 4.8 0 2.7 2.2 4.8 5 4.8ZM509.8 121v9.4l-37.5-24.7v-9.4l37.5 24.8ZM509.8 144v9.4l-37.5-24.7v-9.4l37.5 24.8ZM509.8 167v9.4l-37.5-24.7v-9.3l37.5 24.7ZM509.8 191.8v9.3l-37.5-24.7v-9.3l37.5 24.7ZM508.7 215.4v9.3L471.2 200v-9.3l37.5 24.7ZM550 271l-106.1-70v9.4l106.1 70V271ZM550 294l-106.1-70v9.4l106.1 70V294ZM550 317l-106.1-69.9v9.3l106.1 70V317ZM463 315.7l37.5 24.7v-9.3L463 306.4v9.3ZM463 292.4l37.5 24.7v-9.3L463 283v9.4Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#fff",
        d: "m550 340.8-87-57.4v9.4l87 57.3v-9.3ZM413.3 118c3.2-3.1 6.3-6.4 8.3-8.8l1.8 1.3 19 12.6v14.2l-29.1-19.4Zm35 2.4L425.2 105l-.1.1v-.2l-123-81-.1 6.8v117.7h5.7v-30.3l66.4 44 3-4.6-24.6-16.3 11.4-2 5.4-1.2 20.1 13.4 3-4.5-15.7-10.4 1-.2 14.5-4.6 16.2 10.7 3-4.5-12.9-8.5a42.2 42.2 0 0 0 10.7-7.7l33.3 22V158l-7.5-5-3 4.5 10.5 7v19.5h5.8v-63.7ZM466.2 424.6h6v-18h-6v18Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#fff",
        d: "m468.8 411.4 3.3-5-15.4-9.7-3.2 5 15.3 9.7ZM414 478l-3.1-4.5 34.7-23.2 3.1 4.5L414 478ZM312 545.3l-3.1-4.4 50.1-33.4 3 4.5-50 33.3ZM228.5 538.3l3-4.5-50.3-33-3 4.4 50.3 33ZM245.8 550l3.1-4.5-7.1-4.7-3 4.5 7 4.7ZM155 491.4l3-4.5-44.3-29-3 4.5 44.3 29ZM80.8 442.8l3.5-4.8 13.4 9.3-3.5 4.8-13.4-9.3ZM373.5 504.4l-3-4.5 5.5-3.7 3 4.5-5.5 3.7ZM398.7 488l-3-4.4 5.5-3.7 3.1 4.4-5.6 3.7ZM459.7 447.5l-3-4.4 5.5-3.7 3 4.4-5.5 3.7ZM82 145.6l-1 .6s.2 0 .3-.2l.6-.4ZM215.4 125.5h.1-.1ZM199.7 224.1H197v-134h2.7v134ZM201 32.2v-11L142.4 60v11l58.4-38.8ZM130.9 61.6v-9.3S11.3 131.2 11 131.2v9.4l119.8-79ZM11.1 156.4v4l7.9-5.2v-4l-7.9 5.2Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#fff",
        d: "M130.9 84.5v-9.3S11.3 154 11 154v9.4l119.8-79ZM130.9 106.7v-9.3S11.3 176.3 11 176.3v9.4l119.8-79ZM.5 251v9.2L38 235.5v-9.3L.5 251ZM11.6 220.7v9.3l37.5-24.7v-9.4l-37.5 24.8ZM11.6 198.2v9.3l37.5-24.8v-9.3l-37.5 24.8ZM0 275v9.4l37.5-24.8v-9.3L0 275.1ZM200.4 157.5v-50.1l10.8-8.7v51.6l-10.8 7.2Zm-5.7 3.8L183 169v-47.5l11.7-9.4v49.2Zm-17.5 11.6-12.7 8.3V165l12.7-21.4v29.4Zm-48.8-49.7v-.3l-21 14.2-46.6 30.6v67.2l-9.3 6.4v21.8L67 252.8v-.1l20-13.2v8.1h5.7v-12l11.9-7.8V247h5.7v-21.3l12-3.1V248h5.7v-27.3l11.6-5.1V257h5.7V213L154 195l4.9-3.2v73.2h5.7v-77l12.7-8.4v37.9h5.8v-41.7l11.7-7.8v56.7h5.7v-60.5l10.8-7.1v73l-27 19.4v6.7l32.5-23.3h.3V64.8l-88.6 58.4ZM201 58V47l-58.5 38.8v11L200.8 58ZM236.7 87a3 3 0 0 0 3-3 3 3 0 0 0-3-3 3 3 0 0 0-3 3 3 3 0 0 0 3 3Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#7471FF",
        d: "m427.3 360.7-.5-.6 1.3-9 2.1-1.1 15.2-2 .5.6c-1.2 1.1-2.4 1.9-4 2.4.2.4-.2-.1 0 .2a10.5 10.5 0 0 1-6.1 2.7l.4 1c-1.5 1.5-3.6 2-5.8 2.5l.5 1-3.6 2.3Zm-4.6-10.4-.4-.8 2.8-6.9c1-2 1.8-4 2.6-6h.2v5.6l-.9 4.5-4.3 3.6Zm.6 9.4c-.2 0 0 2-.2 2l-.5 2.6-7.7 4.7c1.3 1-3.2 2.3-3.4 2.5h-.2v-.8l3.1-7.9v-.5l2.4-2.3.8-.3 2.3-1.8 3.5-3 .4.1-.5 4.7Zm-13.7-40-15.5-3.5c0-.3-3.5-10.2-3.3-10.6.2 0 3.1-2 3.3-1.7 1 1.8 3.1 4.8 5.2 6.7l3.2 1.2 8.8 1.7-.4 5.5c-.4.4-.9.2-1.3.7Zm-.3 5.2c-1.7 1.1-2.3 1.8-3.7 2.8l-24.5-3.5 10.7-4 .5-.4 17.2 4-.2 1.1Zm-2.6 47.3-.8 4a7.6 7.6 0 0 1-4.2 2.8l-.3.2-3 1.6.1.1c-.6.4-2.4 1.6-3 1.8-2.5.8-2.5 1-3 .7l.7-2.4.3-1.1 1.2-3 .7-2.2.5-.7c.3-.4 1-.6 1.6-.8 1-.3 1-.3.7-1.5 2.5-1.6 5-3.2 7.7-4.7.4-.3 1-.4 1.5-.5.4-.1-.4-.8.1-1 0-.3 1.2 0 1.2-.4v-.1l-2 7.2Zm-18.3-34.7.5.9-.3.3-3 1.9-.4-.1-5.7-11.2-.4-.7-.3-.6.6-.5 20.8 3.6c-.5.3-1.1.5-1.7.6l-1.8.4.3 1.2-4 2.6c-1.3 1-3 1-4.6 1.6Zm-7 3.8v-.1Zm5.1 44.9h-.4l-.6.4.4.8c-1.2 1.4-3 1.4-4.7 2l.1 1c-.8.7-1.8 1.3-2.9 1.5l-1 .2c-1 .3-1 .3-.8 1.5l-1.4.8-.1-6.6c.5 0 .8-.3 1-.8.2-.3.6-.1.9-.3 1-.3 1.7-1.3 2.6-1.7l9.4-5.2-2.5 6.4Zm-15-37.8.3 1.3-8.3 5.2-1.4.4-1.5.4.1 1-5 3.3-.5-1.2-.7-9 .3-1.8 2.2-.9c0-1.2 0-1.2 1.2-1.7l2-.8c.4-.1.6-.4.6-.8l19 .6-4 2.6c-1 .6-1.8 1-2.9 1.1l-1.3.3Zm-.1 47-1.4 2-7.8.8-3.2-1v-.9c.8-.3 1.7-.5 2.5-.4 1.2.1 1.8.5 2.7-.3.3-.3.6-.7.7-1.1.4-1.9.6-2.2 2.1-2.7.8-.2 0-.5.9-.7-.2-.5 2.5-.8 2.4-1.1l1.2-.8-.1 6.1Zm-13.6 8.8.4.9-.3.3c-1.5 1-2.5 2.2-4.4 2.4-.8 0-1.9 0-2.4.7l1 1.2c-1 .5-2 1.3-3 1.7-.9.4-1.5.5-2.6.8.3.7-1.5 1.7-3 2.3l-.6-.4.6-1.3 2.8-4.2.9-1.2 3.2-4.2c.6-.7 1.3-1.2 2.3-1.3.2 0 .5 0 .6-.2 1.4-1 2.8-.8 4.3-1l4 1 .2 1c-1 1.1-2.7.8-4 1.5Zm-19.8 8.6-6.4-21.4 2.9-1.7L344 400l1.5 3.3-6.3 9.1-1.3.4Zm-5.1 9c-1 .7-2.1 1.5-3.3 2-1 .6-2.3.9-3.5 1.3 0 .3 0 .6.2 1-1 .6-1.8 1.3-2.8 1.7-1 .5-2.1.7-3.3 1l.4.9c-1 .8-1.9 1.4-3 1.6l-.8.2 6.7-20.6 11.3 6.9 1.5 1.8c-1 .7-2.4.8-3.8 1.3l.4 1Zm-20.3 10-.8 2.3c-.3 1-1 1.7-2 1.8-.2 0-.4 0-.6.2v.3c-.4.5-.8 0-1.4 0l.2-2-.4-5.4v-1.3h.1v-.1l2.2-2.3 8-10.2-5.3 16.7Zm-5.1-11.8.4-6.8 1.4-10.8.2-1 6.9 5 2 1.8-10.9 13.8v-2Zm-3.3-10.2-8.7-4.5-.5-.5 2-5.1.1-.1.5-.3c.6-1 1.5-1.4 2.4-1.7h6.2l-2 12.2Zm-.6 17.6v.7c0 .5-.6.8-1 1.1l-7.6 4.9c-2 1.3-4 2.3-6.3 3-.5.2-1 .2-1.4.2h-17l-5.5-3.4-11.6-6.9.1-14.1.3-.4 11.7-7.5v16.3l1.1 1.5 1 2 1 1.1 1.6.7 1.9 1.5 2.6.7 3.7.9h3.2l2.9-.9 2-.7 3.3-4.2v-.4l.3-.7c-.4-.3.1-.5 0-.7-.3-.3 0-.3 0-.7-.2-1-.1-2.2-.1-3.3 0-.6.2-1 1-1 .6 0 1.3-.2 2-.4v-1.1l1.8-1.5c-.6-.5.4-.5 0-1-.3-.7-.3-1.2.2-1.7v-1.5l9 4.6-.2 12.9ZM290.4 531l-.2.2-.4.3-2.4.2-2.3-.3-.7-.4-1-1-1-.9v-.3l2.5-6 .3-.3.9-.8v-.1l3.1-1.6c.4.4.6.9.6 1.6l.4 5.1c.4 2 .3 2.6.2 4.3Zm-9.3-8.5-.7 1.6h-.2.1l-.2.5-1.3 1.7c-.4.2-.9 1.3-1.6.6-.4-.3-.6-1.5-1-1.9 0 0 0-.8-.2-1v-1.6l.3-1.3.8-1.8c.3-1.1.4-1.3 1-1.9l1.2-.9 2.2 2.1.3 1.5-.7 2.4Zm-5.2-27-.9 2.1c0 .4 0 .7-.5.8-.3 0-1.5.3-1.7 0l-1.4-7.4 1.2-3.2c1 .5 3.8 1.7 4 2 .6 1.2-.3 3.8-.7 5.7Zm1.7 5.8.6-1 .2-.5c.2-1 .3-.9.4-1.3.1-1 .6-1.6.7-2.6.5.4 2 3.7 2.9 5.7l-.3.8-3 4-3.2-1.2c-.4-.3-.6-.6-.6-.7 0-.2.4-.4.7-.6l1.6-2.6Zm11.8 8.3v2.3l-.7 2.7-2.7 2.5-4.2-4.1-.4-.5V510l3-3.9 2.6-1 .9-.2 1.4.3v1.9c0 .8.5 1.6 0 2.4Zm-.3-18.2v9.4l-2.8.7h-.1l-3.5-7-1-4 .8-1 6.3-1.8c.4 1 .2 3.7.3 3.7Zm-11.6-18V472h1.8c.3 0 1.7 1 2 1 1.8.5 3 0 4.6 1 .2.1.7 1.6.9 1.8.2.2.2.7 0 1.2l-5.5-.6c-.6-.6-1.3-.8-2-1.5l-1.8-1.5Zm2.4 6.6 4.5.1c1.7.2 2.6.3 2.6 2 0 .3-.2.7-.4 1-.6.9-1.2 1.6-1.9 2.2l-2 .3-1.4-.9c-1.3-1-3.6-2.4-4-3.5-.3-1 1.5-1.3 2.6-1.2Zm-7.9 38.8c-.2 0-.5 0-.8.2l-1.2-.1-.6-8.3v-1c.2-1 .5-2 1.3-2.4.6-.3 5 2 6.4 3l.1.6-.1.2h.1l.1.8-1.3 2-4 5Zm-3.7-72-.2.7c-.2.3-1 0-1.2.2l-.7-.3-.3-.4-1.2-1.8-1-2v-.1l-1-4.8c.6-.2 1-.3 1.5-.2l1.4.8c1.1.8 2.3 2.2 2.5 3.2.5 1.8.4 2.8.2 4.7Zm-1.4 30-.7.4-.5.2-7.2 1.8-.1-.2-.5-.9c3-3.5 4.2-4.3 7.6-7.9l.9-.4.5.4v6.6Zm0 12.7-.8.4-6.2-5.2-1-.9v-1l8-1.9v8.6Zm-.3 12c-.2.6-.2.7 0 1.4l-.4.5-.4.5-.4.6-7.3-15.9.6-.3 7.4 6.3.5.8.1.3-.1 5.7Zm0 28.4-1 .6c-4-2.4-11.4-7.3-17.6-11 0 0-.2-.5-.7-.8l5.4 1.4 13.3 3.5.6.4v5.9Zm-24.1-15.4-1.6-.5c-.6-.1-1.8-.6-1.6-1.1v-.2l4.9-8.8.6-.5.7.2 14 14.3-.1.3-16.9-3.7Zm-7.5-4.8c-1.4-1.4-5.5-6.9-8.4-10.1l-.4-.7.4-.4 13.6 1.2a7 7 0 0 0 1.1.4l-.2 1.7-4.3 7.9H235Zm-9.8-5-18-11.5.5-.7 11.5 4 1 .6 5.7 6.9-.7.8Zm-27.7-19.6 14-2.1 1.7.7 1.2 6.3-.5.7-16.1-4.8-.3-.8Zm-5-3.3c-.9 0-2.7.1-4-.6l-1.5-1.3-2-4 .3-1 19 4.4.4 1c-4.4.5-4.7.9-9.2 1.3l-3 .2Zm-10-13.2-4.6-10.8 1-.6c.7.9.6.9 2.2 2l9.2 5.8.4 1-7.8 2.7-.4-.1Zm-1.8 6.5-8.3-8.5.7-.6 5 3 2.2 1.7 1 3-.6 1.4ZM170 461.6v-.5l3.4-3.5c.3.2.5 0 .8.3l1.7 5.4.5 1-.4.4-5.3-2.6-.7-.5Zm-1 7c-7.6-4.8-1.5-1.2-9.1-6l-.6-1.1 4 .5 3 1.8 2.3 3 1.2 1.2-.8.6Zm-25.2-33.1.2-.2 7.6 4.5c.6.2.6.6.6.7 0 .6.8 1.3 1.5 1.6.2 0 .3.2.5.3l7.2 12.2-.5.3-2-2.1-15-17.3Zm14.3 22.8c-2.5-.5-3-.3-5.5-.8l-2.4-1.2a8 8 0 0 1-2.4-1.7l-3.1-6.7-3.7-9.5 17 18.8.3.4c-.3.3.2.3-.2.7Zm-18.6-29.6c2 .3 4 1.3 5.5 1.5l1.9 1 2.2 3.6-1 .3-8.3-5.3-.3-1.1Zm-9.6 7.2-1.2-.7.3-1 3.7-3.1 2 1.9 1.7 3.4 3.3 9.1-9.8-9.6Zm7.6 12.4L112.3 432l-2-1-.2-.7 2.2.7 5.7 2.4.6.3.5.2h.2l2 .8c2.2.7 4.3 1.7 6.1 3.4l10.7 10.5-.6-.2Zm-30.8-21.5v-8.5l4.3 3.3-.9 3.4-3.4 1.8Zm4.1-13 1.1-.8.6.2.5.3 1.4 3v.3l.3.6.2.5-.3 1.3.2.2-5.6-4.1 1.6-1.6Zm8.2-5.2.3 1.2h-.1l.5 2.8-2.4 2-2-3.7 3.7-2.3Zm4 22.2-.4.4-8.4-3 1-.7 4.6-1.4 3.1-1.4.2 6.1Zm-.4-15.8.6 3.9-1.4 1.3-2.5 2.2-4.5 1.5.6-1.6.4-.1 3.2-3.6.9-1.3 2.7-2.3Zm.4-22.3h-.3l-2-1.4c.9-2.4 3.8-2.5 5-2.3l.4 1.7.9 5.9c-.5-.1-.8-.4-1-.9l-2.3-2-.7-1Zm-.3-11.8.1-.3.5-.7 5.3-3 1.8 1h-.3l.3.4v1.5l-3.5 2.6-1.2 1-3.3-2 .3-.5Zm0-31.6 1.2.2 9.4 4.7-3.3.7-.6.4-1.2.3-2.2.3-1.2-.1-1.4-.7c-2.6-2-2.1-5-.7-5.8Zm-2-8.8c-.2-.6.4-3.6.4-5.7s.8-3.5 1.7-7c1-3.6 1.7-2 1.7-2l.2-.2 1 .7-.3 19.7-3.7-1-.5-.6c-.2-.3-.2-3.3-.5-3.9Zm-.6-28.7c-2.3.6-3.5 1-5.6 1.4l-.7-.4 2-4.6.8-1.4 1.1-.3c.4.7.5.4.2-.2l2.3 5.3h.2l-.3.2Zm-10.7 1-1.4.6H105l-5.4-.5-.3-.4 13-5.3-3 5.6Zm-5.2 23.8v.4l-1.2.2c-.5-.5-.9-1-1.2-1.6l-.9-1-.4-.3c-.5-1.8-2.8-2.4-3.3-4.3-.1-.3-.4-.6-.7-.8-.5-.2-1-.5-1.2-.8l.5-1.3h7.7l.7.7v8.8Zm-12-40.2.6-.4 6.4 1.9-4.8 10.1-2.2-11.6Zm-.6-7 .3-2.3V286l9.3 1.9v.2l-9.1 1.7-.5-.2Zm-2.9-8.1-11.3-1.9 14.5-2.6.3.4-3.5 4Zm1.6 30.2a32.4 32.4 0 0 1-8-2.9l-.2-.7 6.1-9.2.8.3 1.9 11.9-.6.6Zm-11.7-5h-.4c-2.3-1.4-3.2-2-5.4-4-.7-.6-1-.8-1.5-1.5l.5-.8 12.3-3.7.6.4-6.1 9.6Zm2-22.8 7.6 1.5-.1 2.7-.3.5-6.8-3.9-.4-.8Zm5.5 7.9-.2.5-13.8 4.2 6-9.2 8 4.5Zm-19.4 4.2a19 19 0 0 1-1-14.3l1.8-.5 7.3 4.3h-.2L68 296l-1.3-.2Zm8.3-24c3-2.3 4-3.4 7.2-5l-2 8.6-11.3 2-.3-.4c1.6-2.2 4.2-3.6 6.4-5.2Zm11.4-6.3.1-.1 5.4 7.5-7.3 1.4 1.8-8.8Zm3.7-1.8 4.7-.7H97l3.4-.2.2.3-4.9 8.2-5.8-7.5s-.2-.2 0-.2h.1Zm14.3.8-.2 6.5-5.5 2.2h-.3l4.2-6 1.8-2.7Zm-3.7 19.6-7.8-1.5 2.5-4 .7-.6 4 5.2.6 1Zm4.5-1.1-.7.2-5.4-7 5.3-2 .2.2.6 8.6Zm-4.8 13.2-7-2.8v-.4l9-2 .3.3-2.3 4.9Zm1.8 4.2 9 3-13 5.7 4-8.7Zm6.5-7 5.5 7.5-.3.3-10.2-3.3 2-4.9 3 .4Zm-1-27.5 6.8 4.6.3.4-7-.4V266Zm9.9-2.8 3.9.8h.8c.6 0 .6.2 1 .4l-.3.6-3.5 4.3h-.5l-8.5-6h7Zm7.9 4.4h.7l.9.9c1.9 2.2 4.4 2.5 7 2.3l1.3-.2c1 0 1.2.2 1.3 1.5l.5.1c.7.6 2.2 1.6 2.3 1.9l.2.4-.2.8-17.6-3.3.2-.2 3.4-4.2Zm17.2 12.8.7.8c.3 1 .5 2.2.6 3.3.2.8 0 1.1.1 2v.2h-1l-5-.5-3-.4-.3.1-.6-.2-4-2.9 11.7-2.6.8.2Zm5.4 31.8 7.8 6-1.5.5h-.6l-1.3.5-5 .6-2 1a3 3 0 0 1-.5 0l-1-.7V313l4-1h.1Zm3.6-2 17 4 .1.4-5 3.7-9.8-6-2.3-1.8v-.2Zm2.1-3.7 23.5-6.2.2.3-5.1 10.3h-.8l-18.4-4.1.6-.3Zm19.7-16.2 2.5 5.5-.2 1-19.7 5 17.4-11.5Zm15.7-10.3-.3.8-8.3 12.9-1 .4-2.7-6 12.3-8Zm6.5-2.4 9.8 13.1-1 1.9-20.2 3.3v-.7l.4-1.4 9.7-14.7 1.3-1.5ZM206 269c.8 6.4 2.3 12.7 3 19l-.9.4-10.5-14 8.4-5.4Zm5.8 30.8 2.2.2 11.5 10.8.2 1.5-1 .6-14.9 6.8-.4.6-.1-.2 2.5-20.3Zm19.4-15.5-.3 1.4c-6.4 1.9-9.5 2.5-15.9 4.4l-2.2-1.6-3.4-19.5 21.8 15.3Zm-5.5-29.7.6.2L233 280l-.4.5-19.4-13.2-2.2-1.8 14.8-11Zm44.3 22.5v.5l-.4.1-32.1 3.9-5.1-18.8-2-8.1 39.6 22.4Zm-37.5-25.7 18.3-.7 16 9.8 5.7 12.3-.5.6-.3.1-39.3-21.8v-.3Zm16.5-13.3.2 1.5-.1 7.3-14.9 1c5.1-3.6 11.2-7.2 14.8-9.8Zm3.4 3.5 6.5 3.8.6.3h.3v.1l5 2.8.7.3 3.3 1.3.2.3c.8 1.4.6.8.6 2.5l-2.9 3.5-6.3-4-4.8-3.4c-1.5-.9-3.2-1.9-3.2-2.2v-5.3Zm.5-18.6c2.2-1.4 8.5-4.5 10.5-5.9.4 1.4.1 1.7-.7 3-.1.2 0 .7.1 1l1 3.2c1 .2 1.2.4 1.4 1.6l1.8.5c.6.1 1 .4 1 1l-.1 3.8c0 .4 0 .4-.4 1 .5.2.5.6 1 .8.7.4 1.6.7 1.9 1.8 0 .2.3.4.5.5 1.3.5 2.6 1 4 1.3 2.2.3 4.6.7 7-.1 1-.5 2.3-.6 3.6-.8.9-.1 1.7-.3 2.2-1l2.6-5 .1-13.2 12.3 7.3v12.6l-.5 1.8c-.5.4.1.2-.5.5l-2 .5-.4.2.2 1c-.5.2-1 .6-1.6.7-1.5.2-2.8.7-4 2l.2.6-2.7.8c-.2 1.3-.3 1.4-1.5 1.7-1.9.4-3.8.4-5.7.1h-1.2c-2 .3-4 .3-6.1 0h-1.3c-2.2.2-4.3.3-6.5 0l-4.5-2-.6-.5-.7-.6-6-3.4-3.8-2.6c-.3-.2-.6-.4-.7-.7l.1-13.5Zm8.5-17.5-1-3h.3l1.4-3.1.2-.1h-.2l4.3-5.4.5-.1 1.5 4.7v1l.3 2.2.2 1c0 .4.5 1 .9 1.7.2.3.7.7 1.2 1l.5.6-6.2 2.2h-.2l-3.7-2.7Zm-4.7-12.8-1-3.8 9.1 1.2-6.2 7c-.8-1-1.6-3.2-2-4.4Zm4.5-17.9.7 2.2a181 181 0 0 1 1.8 6.1l.3 1.3h-.3l.5 1.6-9.4-1.4 6.4-9.8Zm-8.4 6 .4-.8-1.1-4.2-.2.2-1-3.6-1-3.3 8.9 2.8-6 8.8Zm2-25.6.3.8.5 1.3 2.5 8.5.7 2-9.5-2.7 5.5-9.9Zm-8.3 2.8-1.8-7.2 7.2 2-4.8 8-.6-2.8Zm-4.4-11.7-1.9-2.3-.2-.7-.6-2.7-.2-1 10.3.6.6 2.4 2 5.4h.1l.5 1.2-10.6-2.9Zm-4.1-13.5 7.8-4 .9.5 2.1 6.8s0-.1 0 0l-6.5-.6-3.9-.3-.4-2.4Zm-.4-7v-3c0-3.2.4-4.9 3.2-6.3 1-.4 1.7-1 2.5-1.5v4.1l.1.7-.3 3v1.8l-5.4 3.2v-2Zm34.6 72.9v-.4l.5-1.9.4-2.4v-.3l1.2-3.6 1.1-3.9 1.3-4 1-1.8 1.5-.1.8.4v.6h.1l-.1 1.1-.8 5-.2 1.9-.4 2.2-1.4 8.5v.6l-.5 2.6-.1.6-2-.4-2.5-3v-1.7Zm10.7-30.5c1.1 0 2 .6 2.3 1.5l.1.5-.1.6v.2c-.7.8-.1.5-1.1 1h-.5l-.7.2c-1 0-2-.6-2.3-1.4l-.1-.6c0-1.1 1-2 2.4-2Zm2.6 13.2v1.5l.2 2.4.3 7.7-.1 3.1V197.6l-.1 2.7-.2 2-.4.5c-.8.8-2.4 1.5-3.5 2l-.7-.6-.1-1.3 1-6.4.4-4.3.7-6.2h.2v-.8l.2-.9.1-1.7v-1l.2-.3c.1-.1.3-.4.4-.3l1 .4h.4Zm5.7 71.3.3-1 10.8-6.8 1 6.4-12.1 1.4Zm11.4 9.8-.4 1.5h-.9c-1.8-.5-1.6-.6-3.2-1.5a253 253 0 0 1-8.8-5.4l1.2-.5 12.6-1.4.6.8-1 6.5Zm4.5 17.8-.1 3.1.2.3-6-4.3h.2l-4.9-2.7-6.7-3-.8-.3 10.5-4.7c1.8.8 3.7 3.6 5.9 6.5l1.7 5Zm-.8-13.4 4.3.3 1.1 1 .2 3.3-2 .9-1.2-.9-3.2-2.3.8-2.3Zm1.6-25.6c.8-.6 1.5-.9 2.2-1.3l.2 4.5-2.8 4.2-.7-.2c0-.8-.2-1.5-.4-2.2l-.3-3.7c.3-.5.8-.7 1.8-1.3Zm3.1 9.2.6 12-5.3 1 1.2-7 .2-1.9 3.3-4Zm.8-24.6.1-5.3 1.7.6 5.6 2.6 2.2 5.3-.7 1.3-4.6-.1-4.4-3.3v-1Zm.2-9.5 5.6-2.4v.1l4-1.4.9.1 5 1.4-7.4 3.4-3 .7-1.5-.3-3.6-1.4v-.2Zm4.5-9.9 1.4-2.8 1.1-.5h.3l4.1-1 2.2-.3-4.6 5.4-.5.6-2 2-.6.3-3.8 1 2.4-4.7Zm7.9-15.4 1.8-.5 2 1v-.2l5.8 3.2-3 2.2-2.4.8-1.4.3-6.8 1 4-7.8Zm2.1-8.2v-1.5l3.5-1 .2 3 1.9 6-4.4-2.4c-.2-.1-.2-.3-.3-.4l-.9-1v-2.7Zm0-10.6v-4.4l2.2 1 .3 1.3 1.3 6.6-3.8 1.3v-5.8Zm11-13 8.4 5.2-8.2 5.7h-.4l-9.5-5.8 9.6-5.1Zm12.7 114.8 1.7-.2c2.4-2.2 3.2-3.8 4.6-3.7l-1.3 6.3-12.6 4.1-1.3.4-.9-2.8c2.3-1.4 3.8-1.8 6-3.2 1-.7 2.5-.7 3.8-1Zm11.3 8.1.3 4.3c-.2.4-.5.9-1 1.1l-1.6 1h-.2l-4.4-1.8.1-.6c1.7-1.1 2.7-1.4 4.4-2.3l2.4-1.7Zm-1.5-10.8 1-4.6.2-.2c.2-.6.4-1.2.8-1.8l2 1 2.8 1.8c.2 0 .5.5.7.6l-.2 2-.2 1-1.4 1.6-6.5 3 1-4.3h-.2Zm10.2 5.3 1.8-1 .1-.2 2.1.9 2.2 1.5-.4.3c-1.4.2-.5 1.4-1.5 1.7l-.8.9-1.5 1.3-5.8 3.8-1-.2-.3-5.8c1-.3 1.6-1 2.3-1.5l2.5-1.5.3-.2Zm-16.2 17-6.6 3.7-.7.3c-3.3-.2-4.2-3-2.3-4.8v-.3l5.2-3.9 7.6 3.2a6 6 0 0 1-.9.5l-2.3 1.4Zm-1.9 80.4c0 .2 0 .3-.2.5l-.5-.3-8.7-6 8.8-3.8c.4.2.6.5.6 1v8.6Zm-7.3 19 .6-.8 3.3-.2h1.4c1.8.9 2 1.8 2 3.8V398.2l-2.6.6-1.2-.3c-.3 0-2.4-1.5-2.4-1.5l-1-1.7v-2.2Zm4.8-11.3c.5-.6.9-1.3 1.5-1.8.2-.3.4-.6.6-.5.2 0 .4.5.4.8V388.8l-7-.3-.6-.4c1.9-2.2 3.2-4.1 5-6.3Zm-.7-4.9-7.1 8.7-1-13.7 8 5Zm-9.4-20.5 7.7 4.7.6 1.1-6 2.2-1.6.7-.3-.4-.7-8.3h.3Zm9.7-6.9 1-.4.6 1.1.8 8.6-.5.4-.8-.3-8.7-5.3h-.2l7.8-4Zm-.2-26.3-.1 1.1-.2 3.5-.4 5.6v2.8l-.2 2.7-.2 6.7h-1.7c-.2 0-1.6-.4-1.8-.6l-1.2-.6-1.5-1.3a6.7 6.7 0 0 1-1-2.2v-24.6h1.5l5.8 5 .1.3.2.2.4.6.2.7v.1Zm-8-37.8.2-.6 12.8-4.2-.2.8c-1.8 1.2-3.7 2.4-5.7 3.5l-.8 1-5.1 4-1.3-4.5Zm2.6 19.6h2.4l2.9-.4h1.2l.3-.2a834 834 0 0 1-9.5 8.2 12 12 0 0 1-1.8-1.2l-.1-.3a12 12 0 0 1 1.7-7.5l3 1.4Zm-7.2 45.2c-.7-2.5-1-4.5-1.5-7.1l-.7-5.3v-1.1l2.3-2.1v6.2l.8 2.5v.5h.2l.2.4c.3.5.7.5 1 1l.7 1.4c1.5.7 2 1.5 3.5 2.2l-4.7 2.3-.5.1c-.3-.2-1.1-.2-1.3-1Zm-5 26.5 5.2-4.2.4.2.4 9.5-6-5.5Zm-2.7 7.6c-.1-.1.3-1.1.6-1.9l.4-2 2 1.8c1.6 1.6 1.8 1.5 3.4 3l-.2 1.2-3.5-.4-2.7-1.7Zm-3.8 5.8 1.2-.3 1.4 1 7 22.8-11.2-7-11.6-8.6L325 390Zm-23.5.3.2-.3v-.2l.6-2.1H321l-9.4 5.7-1.4.6-9.8-.3 1-3.4Zm-6.1-19.6 2.6-7.8.2-.5 8.5 1.6.2.2c0 .3-.2 1.5-.7 2.5l-.7 3-2.3 4.4-1 1.4c-.4.6-1.3 1-1.6 1.7l-5.2-6.5Zm-5.6 17.4 3.9-12.4 5.2 6.1-.1 1.2-1 2.8-.2.3-1.2.4-6.6 1.6Zm-3.2 10 .4-1.4.2-.5 1.2-3.2 7-2 .1 1-3.1 8.5v.2c-.4.5-1.1 1.3-1.9 1.4-.3 0-.4.5-.6.7-.5.6-1.4.2-2-.1-.7-.3-1-.6-1.1-1.4v-.6h-.2v-2.7Zm-2.5-29.4-.8.5-.7-1.6-1.8-5.5 8.8-.2 2.4.2 1 1.1-8.9 5.5Zm-3.8 23-.9-5.9-1-9.8h-.1l-.3-2.8.3-4.4c1.1 2 2.9 6 3.5 7.4h-.1l2 4.3 1.2 2.8.6 2.1-.1.1.2.3v2l-1.9 5.9c-.7.1-1 .4-1.7.5-.4 0-.7-.1-.8-.5l-.6-.2-.3-1.7Zm-5-30h-2c-.4 0-.6-1-1-1.1l.2-1c1.5-1 2.4-1 3.8-.2l.2.7v1.2l-1.2.4Zm-4.7 19.8.6-6.5c0-1.9 1-5.2 1-6.3l1.4-.6.1 1.6h.2l.8 10h.2l1.3 14.5-.6.9a4 4 0 0 1-2.7-1.5c-.3-.4-3-.1-3.4-.5-.1 0 0-.2 0-.4h-.1l.6-4.9.4-4.7.2-1.6Zm-12.7-13.8 6.4-14.4 2-4c.3-.5.5-1.4.8-1.8l.7-.5h.7l21.4 11.6h-9.6l-.6-1.6-1.6-.8h-.1l-.6-.3h-.2l-.8-.4-1.2-.2-2 .2-1.9.6-2 1.7-.6 2.4-10.8 7.5Zm-.4 5.4.9-1.3 10-7-1.6 14.5c-.2 0-.2.5-.5.6l-8.8-6.8Zm-4.8 16.1c-1.8 1.2-3.3 2.3-5 3.3l-.2-.6 6.6-15.3.8-.7 8.4 6v.3l-1 .8-4.6 3c-1.3.9-1.2.7-3 1.7l-1.2.8c0 .4-.9.3-.8.7Zm9 74.3-13.5-2.5-.7-1.5 2.3-4.2c.2 0 .8.5 1 .8l1 1.3c1 1.9 2.7 3 5 3 1.5-.1 2.8.4 4 1.3l1.2.8-.4 1Zm-8.2 11.6-4.4-9.6.6-.7 11.6 2.2.8 1.4-7 7.2-1.6-.5Zm7 27-8-7.8-1.2-1.7-.4-1.6.2-.5 1.6-3 1.3.7 6.8 13.7-.3.3Zm-4.7 6.6 3.1 1.2 7 5 .2 2.2.3 1.6c-.4.2-.8.1-1.3.4l-.5-.5-9-9.7.2-.2Zm-8.9-10.2 1.4-2.7 1.2.4 2.8 2.6c3.3 3.7 2.4 2.4 5.7 5.8l-.5.5c-4-2-4.4-1.8-9-4.1l-1.6-2.4Zm-7.4-16.7c-.2-.1 0-.2-.2-.3l.4-.6 8.9 1.2 1.6 1.7-1.9 4.7-.7.3-.9-.5c-2.6-2.6-4.6-3.8-7.2-6.5Zm-5 10-1.3-1.2-.2-.5 11 2.8 1 1.6-.8 1.6-1.3.3-2.2-.5-6.3-4.1Zm-8-1.7h1l7.6 6.2-11.5-1-.4-1 3.2-4.2Zm-9.2-7.2 6 4.7v.6l-3 4.3-.8.1-1.3-4.2-1.3-5.2.4-.3Zm-6.5-18-.4-.4c.7-.3.4-.3 1-.4 3.6-.6 6-1.3 9.5-2 1.3-.1.5 0 1.7.3l.8 1-5.5 7-2.3-1.4-4.8-4Zm-8.2 6 .2-.9c3.8 1 9.2 3.5 12.1 4.3l.5.5-.8 3h-1c-2-1.1-5-3-8-5l-3-2Zm-6.6-1.2 8.7 5.3.1.9c-7.4-2-10.6-2.5-18-4.6l.8-.4 6.1-2 2.3.8Zm-14-15 11.6-1 1.1.6-.5 6.7-.2 1-.2.1-12-6.6.1-.7Zm.5-9.2c.6-.1 1.1-.2 1.8.2 3 1.5 4.7 1.8 7.5 3.3l.2 1.2c-4 .6-8.5.7-12.4 1.3l-.1-.3 3-5.7Zm-3.5-6.3c-3.7-2.8-7-4.7-10.8-7.5-.5-.4-.8-.9-1-1.4l10.3.2 2.1 8.7.5 1.1-1-1.1Zm-8 4.2-3-7.9 10.5 7.8c-.2.2.5.7.6.7l-3.3 6.2-1.2.4h-.2l-2-3.7-1.4-3.5Zm-4.4 5.8 5.3 3.9.1.3-.3.7-3 3.3-.9-.3-3.9-5.3-3.1-5.7 5.8 3.1Zm-4.2-15.9H163.3l4.2 11.5-.4.6-8.4-5-.3-.8 4-6.3Zm-5-2.8.8-.3v.2l.9 1.5-1 1.6-3.2 4-4-6.4 6.4-.6Zm-8.8-10 1.2.5c.7.2 1 .6 1.2 1.3v.2l1.1.2 1.8 1.8h1.2c.6 0 1 .2 1.2.7l.8 1.4-6 1-1.2.2-.2-.4a28 28 0 0 1-1.5-1.1l.4-5.9Zm-.7-13.8 3.3-2.6 1-1.2 8.6 6.7.2.7c1.1 1.8 2.2 3.7 0 7l-1.5.8-1.8-1.3v-.2l-6.1-4-2.3-1.6-.2.1-3.7-2.7 2.5-1.7Zm-11.8-49.4 2.7-.8 2.5 1c.2 0 .3 0 .4.2l1.7 1.2 1.6 1.8.3.6-8.5 4-3.2-1.3-.9-.8-4-3 7.4-2.9Zm.6-12 .4.5v.2l4.7 8.2-7.5-3.9-2-1.1-.5-.7 4.9-3.3Zm-7.8-11v-.3l.1-6.2 6 13.6-.3.4c-.1 0-.3.3-.2.4v.2l-5.7 3.5.1-11.5Zm.4-7.6-.3.2v-.7l.3.5Zm-6.2-22 15.2-1.6-.6.4-4.8 3.3a4 4 0 0 1-1.3.5c-1 .3-2 .6-2.8 1.4-.8.8-1.8 1.2-2.9 1.5l-2.2-.2-2.9-4.9 2.3-.4Zm-9.8-13.1 10.3 4.2.4.1-5 4.2-.9-.2-5.8-7.6 1-.7Zm-4.6-9.5-.5-8 6.2.6-5.7 7.4Zm3.8 1.4-.2-.2 4.5-5.2.8-1.2c.2 0 .7-.5.8-.4l3.7 3.9-9.6 3.1Zm10.2-7.8 13.5 2.5-9 1-1.4.2-3.1-3.7Zm2.7 7.3 2.9 3h-10.8l-.3-.3 4.7-1.7 3.5-1Zm2 10.5-9.6-3.6-.2-.4 11.9-.2-2.1 4.2Zm9.6 5.3.4.2v.6l-12.6 1c.7-.8 2.3-2 3.5-3.4l8.7 1.6Zm6.4-2.6-2.4-.3-9.4-1.9 2-4.3 2.6-.2 7.8.7a22.3 22.3 0 0 1-.6 6Zm5.5 33.7 1.2 1.3v1.4l-13.4-8.3-.6-.6 7-.6c.1.1.3.1.3.3 2 2.2 3.6 4.3 5.5 6.5Zm26.8 6.3 2.7-4.5c.5-.6 1.7-.3 2.1 0l5.9 3.8-11.4 4.6-.9-.6 1.6-3.3Zm13.9-23.6.6.5-11 12.7h-1.3l-2.5-9.6.8-1 13.4-2.6Zm.5-5.2-.4.9-4.8 1-8.5 2 4.4-10.2.5-.2 8.8 6.5Zm5.5-1.7-1.7-.3-9.1-6 1.2-.3 18.6-3.3.3.5c-2.8 3-6.7 6.6-9.3 9.4Zm10.4 12.5-.7.4-7.7-8.7v-1.3L208 298l.2.2-2.2 20Zm13 15 3.7 2.2v.6c-3.9 2.5-11.6 6.5-14.6 7.9l-.7-.5.3-16 .4-.1 10.8 5.8Zm8.9-17.8.3-.3.2.4-.8 6-1.7 10.4-1 .7-7.3-4-7.3-4.1 2.3-1.6 13.8-7 1.5-.5Zm15-9.6.9.3.2.4-12.6 3.8a3 3 0 0 1-1.2-.6l-8-6.8-5.5-5.5 26.1 8.4Zm0-4-26-8.4 14.7-4.5 2-.6 1.7 1 2.4 3.3 5.2 9.2Zm14 24.2 11.3-13.8.1-.4.7 14.8v-.4l-12-.2Zm-1 11.4-1.4-.3-.7-6.2 1.2-1.4h2l9.2.3.2 1-10.4 6.6Zm-5.6 19.4 2-1.3c.4-.3.9-.3 1.3-.5l1.6-.4c0-.8.3-1.3 1-1.7l6-3.9-8.5 18.5-2.9-9-.5-1.7Zm-6.4 33.9-1.2.1-12.4-15 19-1 1 .2v.5l-6.4 15.2Zm.8 32-.7-.7.4-.5 4.2-3 1.2 1.6v3.8l-5-1.2Zm0 3.8 4.2 1 .9.4v3.4l-.1 1.2-.9.3-1.6-2-2.5-4.3Zm-10.4 36v-.5c2.7.3 3.6.8 6.4 1.2 1 .2 1.9.6 3 1 .7.2 1 .3 1.3 1l1.2 2.5 2.6 5.7-.4.2-14.1-11Zm2.6 14.1-1.5-1.4-3.5-9.4 1.2-.2 14.1 11.5-.4 1.1-8.5-1.1-1.4-.5Zm-3 5 1.4.3 4.8 5.7-.6.5-7.9-2-.4-1 2.7-3.5Zm-2.7-2.4v.8l-3.8 4.1-2 .6c-2-1.5-4-3.3-6.1-4.7l-1.3-1.3.8-2.4.8-.5 11.6 3.4Zm-5.3-13.5 2.4.4 3.4 9-.5.5-6.4-1.6-2.5-1-1.3-1 5-6.3Zm-14-23.1-.4-1 9.2-2.4c1.4-.3 2.3-.4 2.6 1 .3 1.6.4 4.2.7 5.8l.8 6.7.2 1.3-.4-.3-12.6-11.1Zm-8.6 6.8-.8-.4v-1.3l4.8-4c.4 0 .4.3.8.1l12.6 11-.4.4-17-5.8Zm3.8 11.7-1-.6-4-7-.5-.6 1 .1 15 4.8c1.1.4 1 .4 1 .2v1l-11 2.1h-.5Zm-6.3 5c1.4-.5 2.6-.7 4-1h.6l1.3.1 6.3 5.2-.4.5-11.3-4-.5-.5v-.3Zm-2.4-11 .7.5 3.5 5 .7 1.3-4.6 1-.8-.6.5-7.3Zm5.4-14.2.1.7c-1.4 1.2-2.1 2.2-3.8 3.6l-.9.3c-.4 0-.2-.5-.5-.8l-2.3-8 7.4 4.2Zm-9-12.5-.8-.2-1-3-2.2-8 .8.2a3 3 0 0 1 1.8.5l4 2.6c.5.3.8.8.9 1.5 0 .3 0 .7.2 1l-3.8 5.4Zm-8.4 13.8c.1-.6-.1-.4.4-.7l5.3-4.8h.6l2.3 8.6-1 .8-3.9-1.7-3.8-1.8v-.4Zm2.9-8.4-5 5-.6.3v-.3l-2.3-8.3 7.9 3.3ZM176 420a2174.4 2174.4 0 0 1 7.1-4.8l.4 1-4.3 9.9-3.5-5.3c.2-.2.3-.5.3-.8Zm-2.2-20.1-.8-1.1-.4-9.4-.2-.2h.3l.6.4h.1v.1l6.2 6.6v.2l-5.8 3.4Zm-7 25.8c.3-.3.5-.5.8-.6l3.9-2.5.7-.4 3.5 4.8H173l-6.3-.2c0-.4 0-.8.3-1.1Zm2.3-23.9c0 .8-.2 1-.4 1.7-2 1.3-2.9 2-5.2 3.2l-.3-.4-1.2-.5-.5-2.5-.6-8.4 8.2 7ZM159 385.3l.2-6 6.4 4.8.7 1-2.1 1-5 1.4-.2-2v-.1Zm-1-11.9c-.4-.1-.7-.3-.9-.6l-1.7-3-1-2.7 10.1 6-5 .3H158Zm-1.3 20.4.2.1.5 2 .7 6.5-5-3.4-.6-.8 4.2-4.4Zm-8.1-7.6 5.4 5.4-3.6 3.4-2.3-8 .5-.8Zm6.3 4.8-.1.2v-.2Zm-1.2-5-4.4-3.4.7-.9 5-3.8v.3l.3 7.8-.1.7-1.5-.7Zm-7.3-7-2.1-7.6 7.9 2 1 .4v.2l-5.1 4.8-1.2.1h-.5Zm-2.2 8.6.5.4 2 8.1-7.6-4.3 5.1-4.2ZM138 381c2 .8 2.6 1.3 4.5 2l.7 1-4.7 4.3-1-5.1-.3-1.8.8-.3Zm5.6-.5-.6.4-5-2.3-.8-1 2.5-5 .5-1 .2-.1 3.2 9Zm4.8-16.8h.9l.6 1 1.7 4.4-7.4-1.5-.8-.5c1.6-1 1.7-1.3 3.4-2.3l1.6-1.1Zm5.5-6.5v.2l-5 1.7c-.2-.1-.1-.2-.3-.4-.5-.4-.3-.6-.7-1.2l-2.6-3.8-.1-.3-2.7-4.8 11.4 8.6Zm3.5-2-14-11.2.2-.2 15 .7c.1.2.3.1.4 0l-1.6 10.6Zm4.6 9c1.7 2.2 2.3 3.3 3.4 5l-1.5-.6-11.4-6.7 1-.6 3.2-1.3h.1l2.9 1.2c.7 1 1.4 2 2.3 3Zm17 1.2-13.8-6.2-2.4-1-1.7-1.2-.1-.7 1-9 .6-.2 16.4 18.3Zm2.5-14 3.7 4.3-1 .4-15.5-9.3-3-2.8 3.8-1.3 2.2-.1 1 .6 6.6 6 2.2 2.1Zm9.1-13-4.9 8.8-6-4.6 10.6-4.5.3.3Zm19.9 13-5.8-.3-.3-.3-1.8-1.1-3.2-5.6 11 7.2ZM222 355l-.1.4-12.3-8 14.2-8 .3.2-2 15.4Zm13.7 38.6Zm7 14.3h-.7L231.4 397l.2-.5 2.5.1 5.7 1.1 2 .6c.5.8 1 1.4 1 2.2v7.3Zm2.5 26.9-11.3-7.1v-.6l4.8-1.8 1.3.6c0 .2.2.4.4.5l.2.3 4.9 7.9-.3.2Zm-11.7 10.6 1.6-.8c4.5 3 4.2 3.6 8.9 6.7l1.3 1c.7.3.9.8 1.1 1.3.2.3 0 .3 0 .6L245 457h-1.3l-10.2-11.7Zm-4.6 0c2.8 3.3 4.7 4.9 7.5 8 2 2.3 2.4 3.2 4.4 5.5l-.6.7-8.6-1.7-1.9-2-2.1-11.2 1.3.6Zm-6-27.5 2.6-.8.3-.2.5.3 3.9.3 1-.1 4.5 3.3 1 .6c.4.2-.5.2-.2.5l-3.8 1.7-6.3-1.5-1 .1-2.8-1.8-.1-.1.4-2.3Zm-6-1.2-.5-.3a18 18 0 0 1-2.2-1.6l-.3-.1-1.7-1.7-.2-.6.2-.6 2-3.7 1.6-1 2.5.5 2 1.3 1.8 1.3 2 2 .5.2.2.2-.3.3h-.3l-.3.3-7 3.5Zm-10.8 9.6c.8.4 1.4 1 1.8 1.8.6 1 1.6 1.6 2.8 1.8.7.1 1.4.3 2 .7l6.6 4.3.4.1c.6.8 0 .7 0 .8-2 .4-7 1.8-10 2.3l-1-.8-.4-1-.5-1.4-2.3-9 .6.4Zm-2.9-19-.3-.6c-.2-.2-.3-.3-.3-.5l-.2-.8.2-3.3 1 .5c1.2 0 4.5.5 4.5.5l2 1.1 1.1 1-.2 1-.1.5-2.1 4.5c-1.5-.7-1.7-.8-3.2-2l-2.4-1.8Zm-2 18.6.5.4 2.6 10.4-6.8-3.8-.6-.7.4-1 3.9-5.3ZM191 375l5.1-.8.7-.1-2.9 7.2-1.6 3.3c-.2-.6-.2.1-.3-.5l-1.2-7c-.1-1 0-1.3.2-2.1Zm6 12.2-1-1 2.6-6.5 1-1.8 2.1-4.1h.3l.1.2 4.3 16.3-9.4-3Zm1.6 4.4 9.7 3.8.5 3.2c-1.7.7-5.7-.7-9-2.4l-1.5-3.7.3-.9Zm18.7-.8-6.2 1-.8-1.5L207 377l3.4 4 7.1 10Zm.4 3.8-2.5 4.7-.8.6-1 .4h-.2c-.3-1-.4-1.8-.5-2.7l-.1-1.2v-.6c.4-.3.8-.4.7-.6l3.2-.7h1.1l.1.1Zm8 13.4-7.6-5.3V401l2.9-5 .7.3 4 11.7Zm-.6-15.6-2-1.1c-.5-.5-.5-.8-1.2-1l-3-4.2-2.9-4.4 18 11.3-9-.6Zm15.4 22.5 2 .4.2.2v2.3l-2.5 2-4.7-4 5-.9Zm-1-3.5-7.7 1-1.5-1.2-4.5-13.1 1.5.4 12.5 12.4-.2.5Zm-30-53v5l-4.9-3.3 1-4.3 4 2.6Zm5.2.6h-.2l-6-4.6h1l4.6-.7 5 3.2.4.3v.4l.2.3-5 1.1Zm8 8.6v.2l-.2 1.5-.3.6-8.7-4-.4-.2v-3.2l8.7-1.4.2.4h.8v6ZM190.1 354l4.5 3.6 13.7 9.2-1.3 1.8c-.9 0-1 0-2.8-.4-1-.2-1.4-.8-2-1l-1.4-1-8.9-8.2-3.8-4.6 2 .6Zm10.3-1.4 2.1 1.1-1 4.2-4-2.7-3-2.3 5.9-.3Zm-11.4-3-.4-.4 5.2-8.8 4.3 8.9-9 .2Zm-4.3 16.7-9-10.4 20.5 11.6.2.1c0 .3.2.7 0 1 0 .2-.5.5-1 .8L189 371l-4.4-4.6Zm6.2 63.7-.5.3-7.8-2.7 4.3-9.6 4 12ZM178.4 388l5 1 3.6 1 .6 1.4-4.3 2.7h-.3l-.3.1-6.1-6.4 1.8.2Zm-5.8-9.2 10.7 6.7h-.6l-10.6-1.6h-.2l.7-5Zm13.5-2.8h.7l1.7 8.4-10.7-7 5-.9c1.1 0 2.3-.3 3.3-.5Zm-20-12.3 7 3.3c3.2 1.7 6.2 3.6 9.5 5l.3.7-1.7.2-10.3.3c0-.2-.2-.3-.3-.4l-4.6-9.1Zm1 17.2-5-4 5.8.3 1.2 1v1.1l-.4 2.3-1.5-.7Zm1.5 7.5.3-.5.4 4.8.2 5v.4l-8.2-6.7.6-.7 6.7-2.3ZM198 404l-.1-.2v.1l-1.5-.4-1.9-1-1.5-2-.2-.4-.4-2.4.1-1.5c0-1-.2-1.8 0-3.3v-.6l1 .1c.9 1 1.6 2.4 2.3 3.8l3.1 4.3v1.5l-.6 2.4c-.5-.2-.3-.3-.3-.4Zm29.7-24.6 9.9 11.3-.1.2-15.2-10.1-11.2-7.2s-1.9-1.5-1.1-1.6l12 2.6c1.2.2 2 .8 2.8 1.6l3 3.2Zm8.7-29c-1.6 1-3.1 2.1-5.1 2.4a4.7 4.7 0 0 0-3.6 2.6c-.4.7-.8 1.2-1.6 1.7l-.7-.2 2-16.4.6-.1 8.4 10Zm11-23.2v.8l-17.4 4.1-.5-.4 2.5-15.5 1.2.3 14.3 10.7Zm.3-18 .9.7 1.3 13.6-.2.7-14-10.4-.1-1 12-3.5Zm-15.1 26.3-.7.1v-.3c6-1.8 11.3-2.5 17.6-4.3l.8.6.3 1.2.4 5.2h-.1l-18.3-2.5Zm.2 5.4c-.4-.5-.2-.7-.8-1.3l.1-.2 17.1 2v.7l-8.8 5.6c-.2.2-.6.4-1 .4l-6.6-7.2Zm1.6 26.9c1-.9 2.7-2 4.4-3.4l2.3-1.5c1.2-.7 2.3-1.5 3.8-1.7.6 0 1.2-.2 1-1 0-.3.4-.6.6-.7l.4-.3 3.3 11.3-.2.6-18.1 1.1-1.4-.2-.2-1.3 3.9-2.2.2-.1v-.6Zm31-58v.3l-11.7 14.4-1.6-13.9.3-1.3 13 .4Zm-14-4.3-3.3-2.1-7-12.6 6 3.5 10.6 7 6.9 4.6-13.3-.4ZM184.4 326l9.8-12.1 1.5-.2 7.5 8.2-.2.3-18.6 3.8Zm19.8-.3.1.2-.5 16.4-20-12.5-.6-.5 21-3.6Zm-71.5.6 23.2 14.3.4.3-17.5-1-.5-.2-1-1-5-12.3.4-.1Zm-1.2-6-.8-1.2 3.4-2.2 5.8-3.7h.4v6.7h-1.2l-3.1.1c-1.4-.1-3.3.2-4.7 0l.2.4Zm135.7-17.7-5-2.7-21.7-14.4 5.7-1 26-3.3 1.7 1.5-6.7 19.9Zm16-30.6-1-.1-4-.8v.1l-2.4-.5-4.5-9.4-.5-1.4c2.7-.3 5.6-1 8.4-.8h4.2l4.4 1.6h.1l.1.1 4.5 2.2c1 .7 2.6 1.5 4 2.6l-13.2 6.4Zm27.3 28.9-13.6.4-.9-.2-10.4-14.2.8-.5 1.8.4c3.2 1 6.7 2 8.4 3.9l13.9 10.2Zm7.7-23.8 2.8 1.4-2.2 2.9-.2.2-8.7-5h-.1l2.5-1.3.2.1 5.7 1.7Zm2.2-37.5-1.7.8-2.3.9-.5.1-1.9.8-.3-1.4V237l.2-.5.5-.3 2.9-2 1.8-.3 1 1 1 1 1.3 3.4-2 .3Zm4 2.6 2.8 1.7 1 6.9-5.7-2-1.7-5.5 3.6-1.1Zm.6-18.2 2.7.6 5.7.4 3 .5.4.5v5.1c-.2-.2-.4 0-.6-.2l-2.1-.7-3.9-1.5-6.2-2.4-1.1-2.2h2Zm11.9-26.9v11.5l-.9.9-3.9 1.1v-7.8l.5-2.4.7-.7 3.6-2.6Zm-2.6-6.4ZM329.2 314l.3-.3 7.4 4-.5 3.7-.7.2-.4-.5c-2-2.5-4.1-4.6-6.1-7Zm4.2 17.5-2.6 3.5h-5.4c-.6 0 .2-.8-.2-.8l7-4.4 2.2-1.3-1 3Zm-4.5 25.3-3-3 3.3.3 4.6-.2h.8l.4.3.4.6 1 9-.4-.3-7.1-6.7Zm-6.4 9.4 9.7 2.9 1 .6-5.3 4.8-.3-.4-5.1-7.9Zm-1 12.5-4-3.1-.7-1-.1-.2-.3-.2-.9-1.4v-.2h-.1c-.9-1.7-.5-1.8-.6-3.3l.5-2.9 2.4.5 5.3 7.3 2.7 3.8.4.4v.3l-.8 2.8-2.8-1.6-1-1.2Zm-10.1-4.8c.3-.2 2.4 4.2 2.7 3.9l2.8 2.4 2.4 1.7 2 1.2.3.7c-3 0-8.6.3-13.1.3l-4.2-.1c1.5-4.6 4.2-8.2 7-10Zm-12.1-16.4.4-.7v-.3l11.4-5.6v2c.1.2-.9 4.3-.9 4.3l-.6.8-.4 1.6-1.5.6h-2L300 359c-.3-.6-.5-1-.7-1.1v-.3Zm-9.5-21.7v-.6l.6-.4 12.3-1.1.5.4-1 3.4-4.5 13.6-1.5.5-6.4-15.8Zm-13.5 4.2c1-.6 1.9-1.2 3-1.3.5 0 1-.3 1.6-.4l-.3-1c1.4-1 1.5-1.2 3-2l1.7.3 7.9 18.7-1 1.1L271 344l-.2-.4 5.5-3.5Zm-4.8-35v-.8l6.4-19.9.9.2.5.8 7.5 9.6 4.2 6.2.7.9-20.2 3Zm12.4 13.6v.9l-1.2.8-9.3 6-1-.7-.5-14.6.3-.1 11.7 7.7Zm17.6 11.3-11 1.1h-1.8l-1.7-.8v-9.1l.3-.2 13.5 8.4.7.6Zm1-5.6-1 .9-2.2-1-23.3-15.5 15.9-2.6h3.3l7.2 18.2Zm8.3-13.6-4 11.6-.4.1-.7-.3-6.4-16.2.2-.5 10.8-.5.5 5.7v.1Zm7.5-22.5-.5-.2h-.5l-4-1.3-.5-.2-.7-.3c-.6-.3-.8-.4-1.2-.8l-.5-.2.4-2c0-.6.2-1.2.4-1.7l9 5-2 1.7Zm4.2 17.4a6 6 0 0 1 1.5 1.5c.4.7.5-.3.7 2.2.3.6-.2.8-.1 1.3 0 .5-.2 1-.4 1.5-.3.3-.7.5-1.2.7h-3.1v.1h-1c-1-.4-2-.7-2.8-1.2-.6-.2-1.2-.4-1.3-1.2l-.1-.2c-.2 0-.3-.2-.4-.3l-.4-4.4 1.9-1.6c.2-.1.3-.5.8-.8.3-.1 2-.6 2.2-.4l3.7 2.8Zm3 10.4 8.1 8.6.1.2-10.3 5.7 1.6-14 .6-.5Zm-3.4 24-.1-.8.1-.4h8.5l.4.1 1 7.7-10-6.5Zm-2.4 9.7-2.4-.4c-.2-.2-.3-.6-.2-1.7v-4.2l.2-.4.5.1 3.3.8.2.2 8.8 6v.4l-10.4-.8Zm-9.6-24.7 2.5-7.7 4.6-.1.8-.3 3.7-.3v.3l-.9 5c-.2.2-.3.4-.3.2l-1.3.8-4 1-1 .2-3.1.8h-1Zm-1 8 1.2-3.8.4-.3 6.7-1.5v.4a140 140 0 0 1-1.5 6.7c-.7 3-2.7 6-2.7 6l-1 .4-.9-1.7-2.3-6.2Zm1 13.2.3.9-8.8 3.8 4.5-14 3.9 9V346.2Zm8.5 15.3-1.7-1.3v-7l3 .2 7.3 7.2 4.6 4 .7.8-12.2-3.3-1.7-.6Zm6.8-72.9h.2l1.5-.7h2.4l1.3.4-.3 2.4-.2.7v3.5l-1 2-8.2-5.8 4.3-2.5Zm-9.5-19.2 1.2-.3 4.8-.6 3.5 1 1.3 2.1-.1 1.7-3.7 1.8-7.6-2.8.6-2.9Zm3-18.5-.5 2.8-1.4 3.9c-.9 1.4-.6.7-1.3 1.6l-.2-.6-.6-5.5-.4-3.1v-2.3l.9-1.7 1.6-.7.9.2.3.1.7 3.7v1.6Zm6 9-2.5 4.5-.5.7h-.3l-4.6.4 4.4-8.8h1l2.5 3.3Zm12-1.7v3.8l-1 .9-.5-.2-3.1-2.6 2.7-5.4 2-2v5.5Zm-2 25.5-3.7.5-.6-.3-8.3-.7 3.8-5 3-1.5 2.6 3.1 3 3.7.1.2Zm-4-11.8-.9-1.5-.2-.4-.2-.6.2-.4 4.5-.8h.4v.4l1.6 1.8.7.3v7.4l-.8 1.9-5.4-8.1Zm.2-26h1.1l2 1.1v.8c0 .8.2.6-.1 1.8-.3 1-1 1.7-1.4 2.6h-.5v-.2l-.4-2.2-.7-4ZM333 265l-7 1-.3-.2 1.8-2.9 2.2-.4 3.3 2.5Zm3.9-24.5v1l-1.6 2h-1.5l-1.2-1.2-.5-.2-1.2-.9-1.5-1.2 1.7-2.1 1.9-3.7v-.1h2.2c1.2.2 1.6.3 1.7.8v5.6Zm-7.9-5.5-2.4 3.1-.3-.2-.6-.6-1.4-3.8.4-2.9 4.4 2-.1 2.4Zm2 20.3-1.5 2.6-2-.6-2.8-3.2.2-1 1.3.3 4.7 1.9Zm7.4 47.3-1.9-1c-1.2-2-2.7-2.2-2.8-3.8l.4-1.6h.1l.4-4.6v-2.8h2.8l.4 4.6.8 5.3s0 .8-.2 1v2.9Zm-4.7-122.2 3.3 2v7.2l-1 .2-.4-1.3-2-6.6v-1.5Zm3.4-5.3V178.3l-3.7-2-.3-4.8 1.4 1 .1.1 2.4 1.4v1.2Zm-8.4 38.8Zm-4.6-4.4 4.3-4.8.2 6-4.5-1.2Zm5.6 8 4.1-3.4h.2v-.2l2.5-.8.5.5c.1.2 0 .5 0 .8V219.4l-.6 2-1 .4-2.1-.4-7.7-.6H323l.3-.7 5-2 1.3-.5ZM167.1 320.2l4-2.8.7.2 2 6.6-6.7-4Zm7.3 9.5-3.7 8v-.1c-2.2-4.9-2.8-7.6-5-12.4l8.7 4.5Zm-15-.1 2.6-4.4.3.2 2.7 8-5.5-3.8Zm8.3 9.8c-1.8.4-5.1 1.3-6.4 1.5l-6.5-7.7c-.1-.5-.2-1-.4-1.3.5 0 1.1 0 1.2-.3l12.1 7.8ZM150 322.6l7.9-1h1l.5.5-2.5 5.7h-3.8l-1.2-.8-4.3-3-.1-.2.5-.3 1.6-1 .4.1Zm-16 53.3-3.9-2.3a233 233 0 0 1 7-4.3l-3 6.6Zm-5 9.6 1.6-1.7 2.5-2 .7.6 1 6.6-5.8-3.5Zm.7 4.7.3.1 5.2 3.5-1.6 6c-.3.2-.5.4-.7.2-.5-.3-1.8-.9-2-1.3l-.1-.2v-.2l-1.1-8.1ZM126 415l-.6-2-.4-5v-.4c.2-.4 1.5-.4 2.5-.2l.6-1.5 3.6 2.6.3.1 3.4 2.2c.4.3.5.6.4 1-2.5.7-7.7 2.5-9.8 3.2Zm5.3 12.7v-.1l-4.4 3.5-.4-.5-.2-5.8 4.2 1.8.7.4.1.7Zm-5.2-7v-.9l.5-.3 1.3-.7 7.6-2.8-.3 2-1.5 5-.1.4h-.1l-.2-.3-1.4.2-5.8-2.6Zm14.4-15c-1.3-1-2.7-1.8-4-2.7l1-3.1 1.4-4 6.2 3.8.1.2 1.7 1.7.7.3v.1l-.5 1.2-6.6 2.4Zm.6 11c.1-.4.9-.7 1-1 .8.3.4 0 1.1.3.2 0 .3.4.4.7 0 1 .6 2 1.3 2.7l-.5 6-1 .5-6.2-1.2.1-.3 1.6-6.8.2.3v-.5l2-.7Zm117.8 22.7.7 4.9-4.8-3.4c0-.5-1.7-3.4-1.7-3.8.7-.4 0-4.3.7-4.5l4 2.3c0 .4.3 2.4 1.1 4.5Zm21.2-34.3v1l-.3.1.2 2.7-1 6.3v5.7l-.6 3.7h-.2v1.3l-1.3.4-3.4-1.1v-.2l-.6-.1-2.5-2.4-.7-.9-.4-1.3-.1-3.4v-5.2l-.3-5v-2.6c.5-1.1 1.6-2 2.1-2.2l5.4.2c1.4 0 2.7.7 4 1.2l-.1 1c-.3.2.2.6-.2.8Zm73.7-89.8c0 2.2-1 3-2.2 3.3l-1-.7-3.2-2.2-.4-.5-2-1.3 7.6-6.7 1.9 5-.5 2.5-.4.4.2.2Zm24.1-22.1c.9.1 4.6 2.1 6.6 2.8l-25.8 16-1-1.9v-.3l-1-3.2.3-.2 8.8-5.8c1-.7 2.4-1.6 3.4-2l1-.8 7.3-4.7.4.1Zm8.3-6.9-1 4.7-4.4-1.3-.8-.4-.1-4.1 6.3 1.1Zm-12 42 1 .2v.7l5.8 11.3-16.6-.6 9.8-11.7Zm-1.6-16.2 5.1-3.2-3.4 12-.4.2-9-3.9 3.2-2.2c1.4-1 3-1.3 4.6-1.7l-.1-1.2ZM360 337c-.7-.2-.7-1-.7-1.7v-6.7c0-.7.3-1.3 1-1.4l.7-.3v-1c1.4-1 1.5-2.7 1.2-4.4v-.6l.1-.4 9.8 4.4-.9 1.1-11 12.5c-.3-.4 0-.3.1-.8-.2-.2 0-.6-.3-.7Zm29.5-21.2-1 1.6-10.2 3.8 3.4-13.6c.4-.4.8-.7 1.4-1 .7-.1 1.2-.5 1.6-1.2.4-.7.9-.7 1.4-.1l3.4 10.5Zm.3-26.6s-.1-.4.2-1.4l.3-3 1.7-1.6v.2l1.3 5c-.2 1.8-1 3.5-2.8 4.2l-1 .2.3-3.1v-.5Zm1.5-15V273l.3-.6 5-1-.8 3.7-.9 2.1h.2l-3.2 1.5-.6.1-.5-.3.5-4.4Zm1.5-12.3c.3 0 1.7-.7 2.7-1.1l.3.8 1.5 6.3-2 .2-3 .1h-.2l.7-6.3Zm1.8-14.4 2.9-.3-.2 7.2-.5 1.4-1.6.7-1.7.8 1.1-9.8ZM398 228l5.3 3.2 1 .6.4 1-7.9 9.3-.3-6.6 1.5-7.5Zm.8-10.5c1.7 1 9.2 6.7 10 7v3.3c-.2.1-1.6 1-2 1l-7.2-4.2-1.4-2.7.6-4.4Zm4.4-8 4.9-3.9v8.3l-.6 3.5-3.6-1.7-4.2-2.3 3.5-3.8Zm-2.7-5.8c.6-2.4 1.4-3.6 1.5-3.6l5.3-1.8-.2 3c-.7 1.4-3.2 2.6-3.4 3l-1.8 1.3-1.5 1.3.1-3.2Zm1.4-9.5.5-5c.4.2 2.5-.6 2.5-.6l2.6-.3v5.3l-4.5 2.1-1.4.3.3-1.8Zm1-10.7v-.2l.7-6v-.2l.3-.3 1.8-.8.5-.3 1.7-.8v.8l-1 8-4.1 1.6.1-1.8Zm2-17.7v-.1l.1-.7 3 2.1v3l-.7 1.3-.1.2-3.1 1.2.8-7Zm9.9-4.3c-.5 1.3-.7 2.3-1.3 3.6-.2.4-.3.6-.5.6s-.4 0-.7-.2l-4.7-3 7.2-1Zm1.4 17.3-3 1.4-1.8 1.1v-4.3l.4-6c0-.6.2-1 .6-1.3l3 .2.8 8.9Zm1 9.7c-.4.7-1 1.4-1.7 2-1 .6-1.8.6-2.8 1l-1.3.7v-6.3c.9-.3 2.7-2.7 5-2.8l.8 5.4Zm-15.7 109 2.7 1c.4-.1.6.9 1 .9.4 1 0 1.6-.5 1.9-1 .6-1.3-.4-2-.8-.7.3-1 1.5-.8 2.2.1.9 1.3 1.9 2 2 .9.2 1.8.2 2.6-.3l.3-.2.6-.7.4-.7 3.9 2 .2 4h-.3c-.1.3-7.3 1.8-10.3-1.8l-2.1-2.4c-.4-.2-.9-1.3-1-2.2l-.6-2 4-2.9Zm-5.2-5.8c.5 0 5.5-1.8 6-1.5l-.8 3.5c-1.4-.2-4.3 2.9-5.3 3l-2-.8v-1.1l2.1-3.1Zm7.3 4.7ZM402 285l1.6 1.3c-1.8 1-4.8.8-6.2 1.6l-1.2-5.1h2l3.8 2.2Zm8.8 6.4.3 3.2v3.1c-.4-.1-1.9-.4-2.7-.8l-3-1.9c-.2-.3-.4-.6-.3-.7l1-3.4 4.7.5Zm-5.9-14.3 4.6-1 1 2-.1 7-8.3-4.3-2.8-1.7 5.6-2Zm3.2-4.6-8.5 2.3.9-3.4 5.5-.2h.3l1.8 1.3Zm-4.2-7.8c1 .6 3.1 1.8 3.3 2.5l-4 .5-2.2.1-1.4-5.5 4.3 2.4Zm3-9.4 2.7-1 .5 10.5-8.8-6.2-.2-.3 5.7-3Zm-5.1-12v-.7l.6-.8 5.7-6.8.9 1.9.2 7.2-7.4-.7Zm2 3.3 5.3 1.1-.6 3-7.4 3.4.3-7.3c.3-.1 2 0 2.5-.2Zm13.6-47.7-4.4 1.4c-.7 0-1.2 0-1.5-.3v-3l.2-.6 4-2.2 1.5-.3.2 5Zm.8 4.6.8 8-1 3-.1.5-5.7-2c-.3-3.2-.2-5-.3-8.2l5.5-1.5.8.2Zm1.3 18.3.7 4.8-.2.2-2.5-1.2-1.2-.7-.5-.4-3.6-2.3-.1-4.8c0-1 3.3 1.1 5.1 1.7h.6l1.3 1 .4 1.7Zm1.7 16.7-8 3.8-.4-7.3v-6l4 .6 3.8 1.2.6 7.7Zm1.2 14.1-8.8-2a11 11 0 0 1 .2-4l7.8-3.3.8 9.3Zm.5 6c0 .6-.3 1.2-.5 1.8l-3.9 2.2h-2.7c-2.3-2.5-1.6-4.7-1.6-7.2v-.5l8.6 2.1.1 1.5Zm1.4 15.7-9.4-3.8-.2-3.4 4.9-1 4-.9c.1 2.8.6 6.4.7 9.1Zm2.1 21.3v.7l-.3 1.2-1.3 1.5-2.5 1.6 1-13.3.1-.3 2.4-1.3.6 9.9Zm1.6 14.4-6-1.5c.3-1.6.1-3.5 1.7-4l3.6-2.6.7 8Zm-13.3-30.3.3-4.9 8.7 3.6-3.4 5.8-5.6-4.5Zm3.6 39.4c-.2.3-1.7.5-2.6.7l-.1-8c2.2-5.1 5.8 2.8 2.7 7.3Zm-3.9 31c.2-.3 0-.5 0-.9v-3.3c0-.5.4-1 .5-1.6.2 0 1-2.5 1.8-4.8l1.2.1.8 10.2-.3 4.2-4 3.3c-.2-2.3-.4-6.4 0-7.2Zm4-26.9-.7 12.3-3.4-.3v-3.5c.1 2.1-.1-4.3 0-6.4 0-1.6 2.5-2.1 4.1-2Zm.7-27-.1 1.7-.8 6.4c-.2.7-.6 1.3-1 1.2l-1.8-.1-.3-7.3.6-.5 3.4-1.4Zm-2-3.7-.3.3-2 .7-.3-8 2.7 1.3c.3.4.6.9.8 1.5 0 .4.4 1 .4 1.3.3 1.7-.8 2-1.3 3Zm11.6 28.6c0 2.1-1.3 9.6-1.3 9.6l-.3.6-4.4 5.2-1.6-.4 2.1-23.3 4.1 1.1h.1c.4.2.5.5.7.7.3 1.8.6 5 .6 6.5Zm4.2 8.5.2-2.2v-1.1l1.5-.4 5.7 9.7-8.5 7.2 1-13.2Zm16.8-.4v.7l-6 3-.9.3-7.5-12.6-.5-1.2 15 9.8Zm-2.6 14.7-13 2-.5.1 8.4-7.2 5.1 5.1Zm4.6-10.3-.2 9a48 48 0 0 1-2-1.5l-4.1-3.8-.3-1 1-.5 5.1-2.4.5.2Zm3.6 85.4c-.2-.3-.2-.7-.1-1 0-.5-.1-.8-.6-1l-.6-.1c-.7-.4-.7-.8-.1-1.2l.7-.6-1.9-.6c-.7-.3-1.6-.5-1.8-1.5 0-.2-.3-.3-.5-.4l-1.6-.6c-.6-.3-1.4-.6-1.6-1.1-.3-.7-.9-1-1.4-1-1.4-.3-2.2-1.5-3.5-2l-.2-.3c-.6-1-1.7-1.6-2.8-2-.8-.4-1.6-.9-2.5-1.2-1-.4-1.5-1.5-2.4-2.2l-.1-.3v-.3c0-.7.2-1.4.4-2.2-.9-1.1-.9-4.5.1-6-.7-.6-.7-1.4-.7-2.2 0-.8 0-1.6.8-2.1-1-1.3-1.1-4-.2-5.8-1-1.3-.8-2.7-.1-3.8l-.5-2.5v-2.2c-.1-1.3.5-2.4 1-3.5.4-.8 1-1.6 1.8-2l.4-.7.5-1.3 2.9-4.2c.4-.6.8-1.3 1.6-1.6l.4-.4c-.2-.8.3-1 .8-1.4l.2-.7.4-.8c1.1-1.7 2.2-3.5 3.5-5 .5-.6 1.1-1.1 1.5-1.8l6-6.3v-16.3l-23.3-15.9L418 160.2l-.4-2.9-15.5 2.3L398 194l-11 85.6-.4 2.8-2-.1-3.5-.6h-.1l-.3-5.5-8.5-5v-4.7l-9-5.4-.3-29.1 3.3-2.9-.2-13.8h-1l-.3-2.4-14.6-28v-21.7l-12.7-7.9-14.2 7.9-.3 23-14.2 28-.3.8v.6l.1 14 2.2 1.5v4.9l-4.2 2 .1-.5V236.2l-.1-1V222l-.4-.2-15.5-10-1.8-42.9c.4 0-.1-1.5-.2-1.8l-1.5-1.7c-.6-.5-1.1-.5-1.7-.7h-2.8l-3.5.7c-.6.3-1.4 2-1.7 2.4-.3.5-.9 3-.9 3l-.2.7-6 20.3c-4-12.3-19.3-61.3-19.6-61.9-.3-.6-2-2.7-3-4.2 0 0-.1-.2-.4-.3 0 0 .2-8.2 0-10.3-.4-2 0-2.8-.5-3.3a21 21 0 0 0-3.5-2.5c-2-1.2-1.2-.3-3.2 0-1.9.3-2.5 1.3-3.7 2-1.2.6-3.2 1.9-4.2 2.8-1 1-1.2 3.2-1.3 3.6 0 .5.5 4 .4 6.3 0 2.3.8 16.5.8 16.5l2 2.8.6 4.2 5.6 2.6 4 15.8v.1c0 .3 0 .6.3.8l.3 1.3 1.4.9 11.3 38.7 4.6 4.2.6 1-13.3 8.3-.2 12.6-26.5 18-65 41.7-6.5 4c.2-.3.2-.7 0-1.1-.2-.2-.2-.5-.2-.7V289c1.2-1 0-2.2.3-3.2l.1-.3c.6-1.7 0-3.4-.1-5-.1-.9-.4-1.7 0-2.6 0-.3 0-.5-.2-.7h.1c.3-.6-24.4-16.2-25.3-16.7-.8-.6-1.3-.7-1.9-.9H88.4a15.5 15.5 0 0 0-2.4.5l-4 2.9-21.3 13.7c-.7.5-1 1-1 2v24.2c0 1.1.3 1.8 1.2 2.4l4.2 2.8c0 .6-.2 1.1 0 1.5.2.5.3.8 0 1.3-.1.5.2.8.5 1l2.3 1.6c2 1.5 3.9 3.2 5.7 4.8 1.4 1.2 3 2.2 4 3.8 0 .2.3.2.5.3l1 .6 3 3.4 2 3.2a4 4 0 0 0 4 2c.7 0 1.2.2 1.8.6 1.5 1 2.3 2.8 4 3.5l.3.4 1.3 1.2c1 .7 2 1.4 2.8 2.2.8.7 1.5 1.4 2.4 2 1.8 1.6 3.8 3 5.1 5 1.5 2.3 3.4 4.3 4.3 6.9 0 .2.3.3.4.5l1.4 1.6 3.6 5.3c.7 1 .9 2 .4 3.1a3.4 3.4 0 0 0 1 4.1c.8.6 1.6.8 2.5.7 1 0 1.8.5 2.4 1.4l1 1.7v4.3l-5.3 2.8V393h.3l-.2.7 5.9 4.6c0 1.1 0 .8-.5 1.9-.5.8-1 .8-1.1 1.6 0 .3-.4.6-.4.8l-17.8 11.2v16.8l162.1 104.5c1 .2 1.7.4 2.4.4l4.3-.2c.7 0 1.5 0 1.4-.1h6.3l8.7.2c1 0 2 .1 2.9-.4l6-4 .3-.1v-.2c.3-.5.5-1 .9-1.2 3.2-2 6-4.6 9.9-5.5-.3-.6 0-1 .5-1.3 1.3-1 2.7-1.4 4.5-1.8-.7-.9 0-1 .4-1.4 2-1.3 4-2.5 5.8-3.8 1.7-1 3.4-2.1 5.4-2.4l.6-.3-.2-1c3.7-2 6.7-5 10.8-6.3.3 0 .8-.4.8-.6 0-.7.5-.9.9-1.1l5.4-3.5c.6-.4 1.4-.7 2.1-1 .7-.3 1.6-.2 1.8-1.2l.4-.2 1.5-.6c-.1-.7.3-1 .9-1.4l2.1-1.4 5.2-3.2 1.8-.7.2-.5 8-5h.1l1-.2.1-.5 1.9-1.2.9-.3.2-.4 6.8-4.5.5-.2c.4 0 .8-.3 1.3-.5a1 1 0 0 1-.2-.4l5.7-3.7.7-.5 1.5-.4v-.5l1.3-.9h.1c.6-.3 1.6-.2 1.7-1.2l9-6c1-.4 1.8-.8 2.7-1v-.7l9.2-6.1 1-.5c.8-.2 1.6-.2 1.8-1.2v-.2l3-2a11 11 0 0 1 3.5-1.4c.2-.5.4-1 .7-1.2 1.1-.6 2.3-1 3.4-1.5.3-.5.6-1 1-1.3l10-6.5c.7-.4 1.5-.6 2.1-1 .4-.1 1-.3 1.2-.6l.3-.6c.4-.5 1-.7 1.4-1 2-1.4 4-2.8 6-4 2-1.3 3.7-2.7 6-3.4l.3-.2c-.2-.4-.7-.8-.7-1.2V426c0-.2.2-.6.4-.7 1.4-.3 1.6-1.3 1.4-2.5l.3-1c.3-1 .4-2-.1-3Z"
      }
    )
  ] }) });
}, Illustration = {
  Upload,
  Upload2,
  Import,
  AddPhoto,
  NoResult,
  Delete,
  Archive,
  Exclude,
  Attention,
  Edit,
  SaveTable,
  Work,
  Support,
  TableCross,
  Mail,
  CreateLink,
  CloseNotSave,
  NoPage,
  Calendar,
  AllowPopup,
  Tabs,
  EmptyWidget
};
var EXP_LIMIT = 9e15, MAX_DIGITS = 1e9, NUMERALS = "0123456789abcdef", LN10 = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058", PI = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789", DEFAULTS = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed at run-time using the `Decimal.config` method.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used when rounding to `precision`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The modulo mode used when calculating the modulus: a mod n.
  // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
  // The remainder (r) is calculated as: r = a - n * q.
  //
  // UP         0 The remainder is positive if the dividend is negative, else is negative.
  // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
  // FLOOR      3 The remainder has the same sign as the divisor (Python %).
  // HALF_EVEN  6 The IEEE 754 remainder function.
  // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
  //
  // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
  // division (9) are commonly used for the modulus operation. The other rounding modes can also
  // be used, but they may not give useful results.
  modulo: 1,
  // 0 to 9
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -EXP_LIMIT
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to EXP_LIMIT
  // The minimum exponent value, beneath which underflow to zero occurs.
  // JavaScript numbers: -324  (5e-324)
  minE: -EXP_LIMIT,
  // -1 to -EXP_LIMIT
  // The maximum exponent value, above which overflow to Infinity occurs.
  // JavaScript numbers: 308  (1.7976931348623157e+308)
  maxE: EXP_LIMIT,
  // 1 to EXP_LIMIT
  // Whether to use cryptographically-secure random number generation, if available.
  crypto: !1
  // true/false
}, inexact, quadrant, external = !0, decimalError = "[DecimalError] ", invalidArgument = decimalError + "Invalid argument: ", precisionLimitExceeded = decimalError + "Precision limit exceeded", cryptoUnavailable = decimalError + "crypto unavailable", tag = "[object Decimal]", mathfloor = Math.floor, mathpow = Math.pow, isBinary = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, isHex = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, isOctal = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, LN10_PRECISION = LN10.length - 1, PI_PRECISION = PI.length - 1, P$1 = { toStringTag: tag };
P$1.absoluteValue = P$1.abs = function() {
  var t = new this.constructor(this);
  return t.s < 0 && (t.s = 1), finalise(t);
};
P$1.ceil = function() {
  return finalise(new this.constructor(this), this.e + 1, 2);
};
P$1.clampedTo = P$1.clamp = function(t, r) {
  var n, a = this, s = a.constructor;
  if (t = new s(t), r = new s(r), !t.s || !r.s) return new s(NaN);
  if (t.gt(r)) throw Error(invalidArgument + r);
  return n = a.cmp(t), n < 0 ? t : a.cmp(r) > 0 ? r : new s(a);
};
P$1.comparedTo = P$1.cmp = function(t) {
  var r, n, a, s, o = this, l = o.d, c = (t = new o.constructor(t)).d, x = o.s, j = t.s;
  if (!l || !c)
    return !x || !j ? NaN : x !== j ? x : l === c ? 0 : !l ^ x < 0 ? 1 : -1;
  if (!l[0] || !c[0]) return l[0] ? x : c[0] ? -j : 0;
  if (x !== j) return x;
  if (o.e !== t.e) return o.e > t.e ^ x < 0 ? 1 : -1;
  for (a = l.length, s = c.length, r = 0, n = a < s ? a : s; r < n; ++r)
    if (l[r] !== c[r]) return l[r] > c[r] ^ x < 0 ? 1 : -1;
  return a === s ? 0 : a > s ^ x < 0 ? 1 : -1;
};
P$1.cosine = P$1.cos = function() {
  var t, r, n = this, a = n.constructor;
  return n.d ? n.d[0] ? (t = a.precision, r = a.rounding, a.precision = t + Math.max(n.e, n.sd()) + LOG_BASE, a.rounding = 1, n = cosine(a, toLessThanHalfPi(a, n)), a.precision = t, a.rounding = r, finalise(quadrant == 2 || quadrant == 3 ? n.neg() : n, t, r, !0)) : new a(1) : new a(NaN);
};
P$1.cubeRoot = P$1.cbrt = function() {
  var t, r, n, a, s, o, l, c, x, j, Z = this, V = Z.constructor;
  if (!Z.isFinite() || Z.isZero()) return new V(Z);
  for (external = !1, o = Z.s * mathpow(Z.s * Z, 1 / 3), !o || Math.abs(o) == 1 / 0 ? (n = digitsToString(Z.d), t = Z.e, (o = (t - n.length + 1) % 3) && (n += o == 1 || o == -2 ? "0" : "00"), o = mathpow(n, 1 / 3), t = mathfloor((t + 1) / 3) - (t % 3 == (t < 0 ? -1 : 2)), o == 1 / 0 ? n = "5e" + t : (n = o.toExponential(), n = n.slice(0, n.indexOf("e") + 1) + t), a = new V(n), a.s = Z.s) : a = new V(o.toString()), l = (t = V.precision) + 3; ; )
    if (c = a, x = c.times(c).times(c), j = x.plus(Z), a = divide(j.plus(Z).times(c), j.plus(x), l + 2, 1), digitsToString(c.d).slice(0, l) === (n = digitsToString(a.d)).slice(0, l))
      if (n = n.slice(l - 3, l + 1), n == "9999" || !s && n == "4999") {
        if (!s && (finalise(c, t + 1, 0), c.times(c).times(c).eq(Z))) {
          a = c;
          break;
        }
        l += 4, s = 1;
      } else {
        (!+n || !+n.slice(1) && n.charAt(0) == "5") && (finalise(a, t + 1, 1), r = !a.times(a).times(a).eq(Z));
        break;
      }
  return external = !0, finalise(a, t, V.rounding, r);
};
P$1.decimalPlaces = P$1.dp = function() {
  var t, r = this.d, n = NaN;
  if (r) {
    if (t = r.length - 1, n = (t - mathfloor(this.e / LOG_BASE)) * LOG_BASE, t = r[t], t) for (; t % 10 == 0; t /= 10) n--;
    n < 0 && (n = 0);
  }
  return n;
};
P$1.dividedBy = P$1.div = function(t) {
  return divide(this, new this.constructor(t));
};
P$1.dividedToIntegerBy = P$1.divToInt = function(t) {
  var r = this, n = r.constructor;
  return finalise(divide(r, new n(t), 0, 1, 1), n.precision, n.rounding);
};
P$1.equals = P$1.eq = function(t) {
  return this.cmp(t) === 0;
};
P$1.floor = function() {
  return finalise(new this.constructor(this), this.e + 1, 3);
};
P$1.greaterThan = P$1.gt = function(t) {
  return this.cmp(t) > 0;
};
P$1.greaterThanOrEqualTo = P$1.gte = function(t) {
  var r = this.cmp(t);
  return r == 1 || r === 0;
};
P$1.hyperbolicCosine = P$1.cosh = function() {
  var t, r, n, a, s, o = this, l = o.constructor, c = new l(1);
  if (!o.isFinite()) return new l(o.s ? 1 / 0 : NaN);
  if (o.isZero()) return c;
  n = l.precision, a = l.rounding, l.precision = n + Math.max(o.e, o.sd()) + 4, l.rounding = 1, s = o.d.length, s < 32 ? (t = Math.ceil(s / 3), r = (1 / tinyPow(4, t)).toString()) : (t = 16, r = "2.3283064365386962890625e-10"), o = taylorSeries(l, 1, o.times(r), new l(1), !0);
  for (var x, j = t, Z = new l(8); j--; )
    x = o.times(o), o = c.minus(x.times(Z.minus(x.times(Z))));
  return finalise(o, l.precision = n, l.rounding = a, !0);
};
P$1.hyperbolicSine = P$1.sinh = function() {
  var t, r, n, a, s = this, o = s.constructor;
  if (!s.isFinite() || s.isZero()) return new o(s);
  if (r = o.precision, n = o.rounding, o.precision = r + Math.max(s.e, s.sd()) + 4, o.rounding = 1, a = s.d.length, a < 3)
    s = taylorSeries(o, 2, s, s, !0);
  else {
    t = 1.4 * Math.sqrt(a), t = t > 16 ? 16 : t | 0, s = s.times(1 / tinyPow(5, t)), s = taylorSeries(o, 2, s, s, !0);
    for (var l, c = new o(5), x = new o(16), j = new o(20); t--; )
      l = s.times(s), s = s.times(c.plus(l.times(x.times(l).plus(j))));
  }
  return o.precision = r, o.rounding = n, finalise(s, r, n, !0);
};
P$1.hyperbolicTangent = P$1.tanh = function() {
  var t, r, n = this, a = n.constructor;
  return n.isFinite() ? n.isZero() ? new a(n) : (t = a.precision, r = a.rounding, a.precision = t + 7, a.rounding = 1, divide(n.sinh(), n.cosh(), a.precision = t, a.rounding = r)) : new a(n.s);
};
P$1.inverseCosine = P$1.acos = function() {
  var t = this, r = t.constructor, n = t.abs().cmp(1), a = r.precision, s = r.rounding;
  return n !== -1 ? n === 0 ? t.isNeg() ? getPi(r, a, s) : new r(0) : new r(NaN) : t.isZero() ? getPi(r, a + 4, s).times(0.5) : (r.precision = a + 6, r.rounding = 1, t = new r(1).minus(t).div(t.plus(1)).sqrt().atan(), r.precision = a, r.rounding = s, t.times(2));
};
P$1.inverseHyperbolicCosine = P$1.acosh = function() {
  var t, r, n = this, a = n.constructor;
  return n.lte(1) ? new a(n.eq(1) ? 0 : NaN) : n.isFinite() ? (t = a.precision, r = a.rounding, a.precision = t + Math.max(Math.abs(n.e), n.sd()) + 4, a.rounding = 1, external = !1, n = n.times(n).minus(1).sqrt().plus(n), external = !0, a.precision = t, a.rounding = r, n.ln()) : new a(n);
};
P$1.inverseHyperbolicSine = P$1.asinh = function() {
  var t, r, n = this, a = n.constructor;
  return !n.isFinite() || n.isZero() ? new a(n) : (t = a.precision, r = a.rounding, a.precision = t + 2 * Math.max(Math.abs(n.e), n.sd()) + 6, a.rounding = 1, external = !1, n = n.times(n).plus(1).sqrt().plus(n), external = !0, a.precision = t, a.rounding = r, n.ln());
};
P$1.inverseHyperbolicTangent = P$1.atanh = function() {
  var t, r, n, a, s = this, o = s.constructor;
  return s.isFinite() ? s.e >= 0 ? new o(s.abs().eq(1) ? s.s / 0 : s.isZero() ? s : NaN) : (t = o.precision, r = o.rounding, a = s.sd(), Math.max(a, t) < 2 * -s.e - 1 ? finalise(new o(s), t, r, !0) : (o.precision = n = a - s.e, s = divide(s.plus(1), new o(1).minus(s), n + t, 1), o.precision = t + 4, o.rounding = 1, s = s.ln(), o.precision = t, o.rounding = r, s.times(0.5))) : new o(NaN);
};
P$1.inverseSine = P$1.asin = function() {
  var t, r, n, a, s = this, o = s.constructor;
  return s.isZero() ? new o(s) : (r = s.abs().cmp(1), n = o.precision, a = o.rounding, r !== -1 ? r === 0 ? (t = getPi(o, n + 4, a).times(0.5), t.s = s.s, t) : new o(NaN) : (o.precision = n + 6, o.rounding = 1, s = s.div(new o(1).minus(s.times(s)).sqrt().plus(1)).atan(), o.precision = n, o.rounding = a, s.times(2)));
};
P$1.inverseTangent = P$1.atan = function() {
  var t, r, n, a, s, o, l, c, x, j = this, Z = j.constructor, V = Z.precision, U = Z.rounding;
  if (j.isFinite()) {
    if (j.isZero())
      return new Z(j);
    if (j.abs().eq(1) && V + 4 <= PI_PRECISION)
      return l = getPi(Z, V + 4, U).times(0.25), l.s = j.s, l;
  } else {
    if (!j.s) return new Z(NaN);
    if (V + 4 <= PI_PRECISION)
      return l = getPi(Z, V + 4, U).times(0.5), l.s = j.s, l;
  }
  for (Z.precision = c = V + 10, Z.rounding = 1, n = Math.min(28, c / LOG_BASE + 2 | 0), t = n; t; --t) j = j.div(j.times(j).plus(1).sqrt().plus(1));
  for (external = !1, r = Math.ceil(c / LOG_BASE), a = 1, x = j.times(j), l = new Z(j), s = j; t !== -1; )
    if (s = s.times(x), o = l.minus(s.div(a += 2)), s = s.times(x), l = o.plus(s.div(a += 2)), l.d[r] !== void 0) for (t = r; l.d[t] === o.d[t] && t--; ) ;
  return n && (l = l.times(2 << n - 1)), external = !0, finalise(l, Z.precision = V, Z.rounding = U, !0);
};
P$1.isFinite = function() {
  return !!this.d;
};
P$1.isInteger = P$1.isInt = function() {
  return !!this.d && mathfloor(this.e / LOG_BASE) > this.d.length - 2;
};
P$1.isNaN = function() {
  return !this.s;
};
P$1.isNegative = P$1.isNeg = function() {
  return this.s < 0;
};
P$1.isPositive = P$1.isPos = function() {
  return this.s > 0;
};
P$1.isZero = function() {
  return !!this.d && this.d[0] === 0;
};
P$1.lessThan = P$1.lt = function(t) {
  return this.cmp(t) < 0;
};
P$1.lessThanOrEqualTo = P$1.lte = function(t) {
  return this.cmp(t) < 1;
};
P$1.logarithm = P$1.log = function(t) {
  var r, n, a, s, o, l, c, x, j = this, Z = j.constructor, V = Z.precision, U = Z.rounding, $ = 5;
  if (t == null)
    t = new Z(10), r = !0;
  else {
    if (t = new Z(t), n = t.d, t.s < 0 || !n || !n[0] || t.eq(1)) return new Z(NaN);
    r = t.eq(10);
  }
  if (n = j.d, j.s < 0 || !n || !n[0] || j.eq(1))
    return new Z(n && !n[0] ? -1 / 0 : j.s != 1 ? NaN : n ? 0 : 1 / 0);
  if (r)
    if (n.length > 1)
      o = !0;
    else {
      for (s = n[0]; s % 10 === 0; ) s /= 10;
      o = s !== 1;
    }
  if (external = !1, c = V + $, l = naturalLogarithm(j, c), a = r ? getLn10(Z, c + 10) : naturalLogarithm(t, c), x = divide(l, a, c, 1), checkRoundingDigits(x.d, s = V, U))
    do
      if (c += 10, l = naturalLogarithm(j, c), a = r ? getLn10(Z, c + 10) : naturalLogarithm(t, c), x = divide(l, a, c, 1), !o) {
        +digitsToString(x.d).slice(s + 1, s + 15) + 1 == 1e14 && (x = finalise(x, V + 1, 0));
        break;
      }
    while (checkRoundingDigits(x.d, s += 10, U));
  return external = !0, finalise(x, V, U);
};
P$1.minus = P$1.sub = function(t) {
  var r, n, a, s, o, l, c, x, j, Z, V, U, $ = this, Y = $.constructor;
  if (t = new Y(t), !$.d || !t.d)
    return !$.s || !t.s ? t = new Y(NaN) : $.d ? t.s = -t.s : t = new Y(t.d || $.s !== t.s ? $ : NaN), t;
  if ($.s != t.s)
    return t.s = -t.s, $.plus(t);
  if (j = $.d, U = t.d, c = Y.precision, x = Y.rounding, !j[0] || !U[0]) {
    if (U[0]) t.s = -t.s;
    else if (j[0]) t = new Y($);
    else return new Y(x === 3 ? -0 : 0);
    return external ? finalise(t, c, x) : t;
  }
  if (n = mathfloor(t.e / LOG_BASE), Z = mathfloor($.e / LOG_BASE), j = j.slice(), o = Z - n, o) {
    for (V = o < 0, V ? (r = j, o = -o, l = U.length) : (r = U, n = Z, l = j.length), a = Math.max(Math.ceil(c / LOG_BASE), l) + 2, o > a && (o = a, r.length = 1), r.reverse(), a = o; a--; ) r.push(0);
    r.reverse();
  } else {
    for (a = j.length, l = U.length, V = a < l, V && (l = a), a = 0; a < l; a++)
      if (j[a] != U[a]) {
        V = j[a] < U[a];
        break;
      }
    o = 0;
  }
  for (V && (r = j, j = U, U = r, t.s = -t.s), l = j.length, a = U.length - l; a > 0; --a) j[l++] = 0;
  for (a = U.length; a > o; ) {
    if (j[--a] < U[a]) {
      for (s = a; s && j[--s] === 0; ) j[s] = BASE - 1;
      --j[s], j[a] += BASE;
    }
    j[a] -= U[a];
  }
  for (; j[--l] === 0; ) j.pop();
  for (; j[0] === 0; j.shift()) --n;
  return j[0] ? (t.d = j, t.e = getBase10Exponent(j, n), external ? finalise(t, c, x) : t) : new Y(x === 3 ? -0 : 0);
};
P$1.modulo = P$1.mod = function(t) {
  var r, n = this, a = n.constructor;
  return t = new a(t), !n.d || !t.s || t.d && !t.d[0] ? new a(NaN) : !t.d || n.d && !n.d[0] ? finalise(new a(n), a.precision, a.rounding) : (external = !1, a.modulo == 9 ? (r = divide(n, t.abs(), 0, 3, 1), r.s *= t.s) : r = divide(n, t, 0, a.modulo, 1), r = r.times(t), external = !0, n.minus(r));
};
P$1.naturalExponential = P$1.exp = function() {
  return naturalExponential(this);
};
P$1.naturalLogarithm = P$1.ln = function() {
  return naturalLogarithm(this);
};
P$1.negated = P$1.neg = function() {
  var t = new this.constructor(this);
  return t.s = -t.s, finalise(t);
};
P$1.plus = P$1.add = function(t) {
  var r, n, a, s, o, l, c, x, j, Z, V = this, U = V.constructor;
  if (t = new U(t), !V.d || !t.d)
    return !V.s || !t.s ? t = new U(NaN) : V.d || (t = new U(t.d || V.s === t.s ? V : NaN)), t;
  if (V.s != t.s)
    return t.s = -t.s, V.minus(t);
  if (j = V.d, Z = t.d, c = U.precision, x = U.rounding, !j[0] || !Z[0])
    return Z[0] || (t = new U(V)), external ? finalise(t, c, x) : t;
  if (o = mathfloor(V.e / LOG_BASE), a = mathfloor(t.e / LOG_BASE), j = j.slice(), s = o - a, s) {
    for (s < 0 ? (n = j, s = -s, l = Z.length) : (n = Z, a = o, l = j.length), o = Math.ceil(c / LOG_BASE), l = o > l ? o + 1 : l + 1, s > l && (s = l, n.length = 1), n.reverse(); s--; ) n.push(0);
    n.reverse();
  }
  for (l = j.length, s = Z.length, l - s < 0 && (s = l, n = Z, Z = j, j = n), r = 0; s; )
    r = (j[--s] = j[s] + Z[s] + r) / BASE | 0, j[s] %= BASE;
  for (r && (j.unshift(r), ++a), l = j.length; j[--l] == 0; ) j.pop();
  return t.d = j, t.e = getBase10Exponent(j, a), external ? finalise(t, c, x) : t;
};
P$1.precision = P$1.sd = function(t) {
  var r, n = this;
  if (t !== void 0 && t !== !!t && t !== 1 && t !== 0) throw Error(invalidArgument + t);
  return n.d ? (r = getPrecision(n.d), t && n.e + 1 > r && (r = n.e + 1)) : r = NaN, r;
};
P$1.round = function() {
  var t = this, r = t.constructor;
  return finalise(new r(t), t.e + 1, r.rounding);
};
P$1.sine = P$1.sin = function() {
  var t, r, n = this, a = n.constructor;
  return n.isFinite() ? n.isZero() ? new a(n) : (t = a.precision, r = a.rounding, a.precision = t + Math.max(n.e, n.sd()) + LOG_BASE, a.rounding = 1, n = sine(a, toLessThanHalfPi(a, n)), a.precision = t, a.rounding = r, finalise(quadrant > 2 ? n.neg() : n, t, r, !0)) : new a(NaN);
};
P$1.squareRoot = P$1.sqrt = function() {
  var t, r, n, a, s, o, l = this, c = l.d, x = l.e, j = l.s, Z = l.constructor;
  if (j !== 1 || !c || !c[0])
    return new Z(!j || j < 0 && (!c || c[0]) ? NaN : c ? l : 1 / 0);
  for (external = !1, j = Math.sqrt(+l), j == 0 || j == 1 / 0 ? (r = digitsToString(c), (r.length + x) % 2 == 0 && (r += "0"), j = Math.sqrt(r), x = mathfloor((x + 1) / 2) - (x < 0 || x % 2), j == 1 / 0 ? r = "5e" + x : (r = j.toExponential(), r = r.slice(0, r.indexOf("e") + 1) + x), a = new Z(r)) : a = new Z(j.toString()), n = (x = Z.precision) + 3; ; )
    if (o = a, a = o.plus(divide(l, o, n + 2, 1)).times(0.5), digitsToString(o.d).slice(0, n) === (r = digitsToString(a.d)).slice(0, n))
      if (r = r.slice(n - 3, n + 1), r == "9999" || !s && r == "4999") {
        if (!s && (finalise(o, x + 1, 0), o.times(o).eq(l))) {
          a = o;
          break;
        }
        n += 4, s = 1;
      } else {
        (!+r || !+r.slice(1) && r.charAt(0) == "5") && (finalise(a, x + 1, 1), t = !a.times(a).eq(l));
        break;
      }
  return external = !0, finalise(a, x, Z.rounding, t);
};
P$1.tangent = P$1.tan = function() {
  var t, r, n = this, a = n.constructor;
  return n.isFinite() ? n.isZero() ? new a(n) : (t = a.precision, r = a.rounding, a.precision = t + 10, a.rounding = 1, n = n.sin(), n.s = 1, n = divide(n, new a(1).minus(n.times(n)).sqrt(), t + 10, 0), a.precision = t, a.rounding = r, finalise(quadrant == 2 || quadrant == 4 ? n.neg() : n, t, r, !0)) : new a(NaN);
};
P$1.times = P$1.mul = function(t) {
  var r, n, a, s, o, l, c, x, j, Z = this, V = Z.constructor, U = Z.d, $ = (t = new V(t)).d;
  if (t.s *= Z.s, !U || !U[0] || !$ || !$[0])
    return new V(!t.s || U && !U[0] && !$ || $ && !$[0] && !U ? NaN : !U || !$ ? t.s / 0 : t.s * 0);
  for (n = mathfloor(Z.e / LOG_BASE) + mathfloor(t.e / LOG_BASE), x = U.length, j = $.length, x < j && (o = U, U = $, $ = o, l = x, x = j, j = l), o = [], l = x + j, a = l; a--; ) o.push(0);
  for (a = j; --a >= 0; ) {
    for (r = 0, s = x + a; s > a; )
      c = o[s] + $[a] * U[s - a - 1] + r, o[s--] = c % BASE | 0, r = c / BASE | 0;
    o[s] = (o[s] + r) % BASE | 0;
  }
  for (; !o[--l]; ) o.pop();
  return r ? ++n : o.shift(), t.d = o, t.e = getBase10Exponent(o, n), external ? finalise(t, V.precision, V.rounding) : t;
};
P$1.toBinary = function(t, r) {
  return toStringBinary(this, 2, t, r);
};
P$1.toDecimalPlaces = P$1.toDP = function(t, r) {
  var n = this, a = n.constructor;
  return n = new a(n), t === void 0 ? n : (checkInt32(t, 0, MAX_DIGITS), r === void 0 ? r = a.rounding : checkInt32(r, 0, 8), finalise(n, t + n.e + 1, r));
};
P$1.toExponential = function(t, r) {
  var n, a = this, s = a.constructor;
  return t === void 0 ? n = finiteToString(a, !0) : (checkInt32(t, 0, MAX_DIGITS), r === void 0 ? r = s.rounding : checkInt32(r, 0, 8), a = finalise(new s(a), t + 1, r), n = finiteToString(a, !0, t + 1)), a.isNeg() && !a.isZero() ? "-" + n : n;
};
P$1.toFixed = function(t, r) {
  var n, a, s = this, o = s.constructor;
  return t === void 0 ? n = finiteToString(s) : (checkInt32(t, 0, MAX_DIGITS), r === void 0 ? r = o.rounding : checkInt32(r, 0, 8), a = finalise(new o(s), t + s.e + 1, r), n = finiteToString(a, !1, t + a.e + 1)), s.isNeg() && !s.isZero() ? "-" + n : n;
};
P$1.toFraction = function(t) {
  var r, n, a, s, o, l, c, x, j, Z, V, U, $ = this, Y = $.d, G = $.constructor;
  if (!Y) return new G($);
  if (j = n = new G(1), a = x = new G(0), r = new G(a), o = r.e = getPrecision(Y) - $.e - 1, l = o % LOG_BASE, r.d[0] = mathpow(10, l < 0 ? LOG_BASE + l : l), t == null)
    t = o > 0 ? r : j;
  else {
    if (c = new G(t), !c.isInt() || c.lt(j)) throw Error(invalidArgument + c);
    t = c.gt(r) ? o > 0 ? r : j : c;
  }
  for (external = !1, c = new G(digitsToString(Y)), Z = G.precision, G.precision = o = Y.length * LOG_BASE * 2; V = divide(c, r, 0, 1, 1), s = n.plus(V.times(a)), s.cmp(t) != 1; )
    n = a, a = s, s = j, j = x.plus(V.times(s)), x = s, s = r, r = c.minus(V.times(s)), c = s;
  return s = divide(t.minus(n), a, 0, 1, 1), x = x.plus(s.times(j)), n = n.plus(s.times(a)), x.s = j.s = $.s, U = divide(j, a, o, 1).minus($).abs().cmp(divide(x, n, o, 1).minus($).abs()) < 1 ? [j, a] : [x, n], G.precision = Z, external = !0, U;
};
P$1.toHexadecimal = P$1.toHex = function(t, r) {
  return toStringBinary(this, 16, t, r);
};
P$1.toNearest = function(t, r) {
  var n = this, a = n.constructor;
  if (n = new a(n), t == null) {
    if (!n.d) return n;
    t = new a(1), r = a.rounding;
  } else {
    if (t = new a(t), r === void 0 ? r = a.rounding : checkInt32(r, 0, 8), !n.d) return t.s ? n : t;
    if (!t.d)
      return t.s && (t.s = n.s), t;
  }
  return t.d[0] ? (external = !1, n = divide(n, t, 0, r, 1).times(t), external = !0, finalise(n)) : (t.s = n.s, n = t), n;
};
P$1.toNumber = function() {
  return +this;
};
P$1.toOctal = function(t, r) {
  return toStringBinary(this, 8, t, r);
};
P$1.toPower = P$1.pow = function(t) {
  var r, n, a, s, o, l, c = this, x = c.constructor, j = +(t = new x(t));
  if (!c.d || !t.d || !c.d[0] || !t.d[0]) return new x(mathpow(+c, j));
  if (c = new x(c), c.eq(1)) return c;
  if (a = x.precision, o = x.rounding, t.eq(1)) return finalise(c, a, o);
  if (r = mathfloor(t.e / LOG_BASE), r >= t.d.length - 1 && (n = j < 0 ? -j : j) <= MAX_SAFE_INTEGER)
    return s = intPow(x, c, n, a), t.s < 0 ? new x(1).div(s) : finalise(s, a, o);
  if (l = c.s, l < 0) {
    if (r < t.d.length - 1) return new x(NaN);
    if ((t.d[r] & 1) == 0 && (l = 1), c.e == 0 && c.d[0] == 1 && c.d.length == 1)
      return c.s = l, c;
  }
  return n = mathpow(+c, j), r = n == 0 || !isFinite(n) ? mathfloor(j * (Math.log("0." + digitsToString(c.d)) / Math.LN10 + c.e + 1)) : new x(n + "").e, r > x.maxE + 1 || r < x.minE - 1 ? new x(r > 0 ? l / 0 : 0) : (external = !1, x.rounding = c.s = 1, n = Math.min(12, (r + "").length), s = naturalExponential(t.times(naturalLogarithm(c, a + n)), a), s.d && (s = finalise(s, a + 5, 1), checkRoundingDigits(s.d, a, o) && (r = a + 10, s = finalise(naturalExponential(t.times(naturalLogarithm(c, r + n)), r), r + 5, 1), +digitsToString(s.d).slice(a + 1, a + 15) + 1 == 1e14 && (s = finalise(s, a + 1, 0)))), s.s = l, external = !0, x.rounding = o, finalise(s, a, o));
};
P$1.toPrecision = function(t, r) {
  var n, a = this, s = a.constructor;
  return t === void 0 ? n = finiteToString(a, a.e <= s.toExpNeg || a.e >= s.toExpPos) : (checkInt32(t, 1, MAX_DIGITS), r === void 0 ? r = s.rounding : checkInt32(r, 0, 8), a = finalise(new s(a), t, r), n = finiteToString(a, t <= a.e || a.e <= s.toExpNeg, t)), a.isNeg() && !a.isZero() ? "-" + n : n;
};
P$1.toSignificantDigits = P$1.toSD = function(t, r) {
  var n = this, a = n.constructor;
  return t === void 0 ? (t = a.precision, r = a.rounding) : (checkInt32(t, 1, MAX_DIGITS), r === void 0 ? r = a.rounding : checkInt32(r, 0, 8)), finalise(new a(n), t, r);
};
P$1.toString = function() {
  var t = this, r = t.constructor, n = finiteToString(t, t.e <= r.toExpNeg || t.e >= r.toExpPos);
  return t.isNeg() && !t.isZero() ? "-" + n : n;
};
P$1.truncated = P$1.trunc = function() {
  return finalise(new this.constructor(this), this.e + 1, 1);
};
P$1.valueOf = P$1.toJSON = function() {
  var t = this, r = t.constructor, n = finiteToString(t, t.e <= r.toExpNeg || t.e >= r.toExpPos);
  return t.isNeg() ? "-" + n : n;
};
function digitsToString(t) {
  var r, n, a, s = t.length - 1, o = "", l = t[0];
  if (s > 0) {
    for (o += l, r = 1; r < s; r++)
      a = t[r] + "", n = LOG_BASE - a.length, n && (o += getZeroString(n)), o += a;
    l = t[r], a = l + "", n = LOG_BASE - a.length, n && (o += getZeroString(n));
  } else if (l === 0)
    return "0";
  for (; l % 10 === 0; ) l /= 10;
  return o + l;
}
function checkInt32(t, r, n) {
  if (t !== ~~t || t < r || t > n)
    throw Error(invalidArgument + t);
}
function checkRoundingDigits(t, r, n, a) {
  var s, o, l, c;
  for (o = t[0]; o >= 10; o /= 10) --r;
  return --r < 0 ? (r += LOG_BASE, s = 0) : (s = Math.ceil((r + 1) / LOG_BASE), r %= LOG_BASE), o = mathpow(10, LOG_BASE - r), c = t[s] % o | 0, a == null ? r < 3 ? (r == 0 ? c = c / 100 | 0 : r == 1 && (c = c / 10 | 0), l = n < 4 && c == 99999 || n > 3 && c == 49999 || c == 5e4 || c == 0) : l = (n < 4 && c + 1 == o || n > 3 && c + 1 == o / 2) && (t[s + 1] / o / 100 | 0) == mathpow(10, r - 2) - 1 || (c == o / 2 || c == 0) && (t[s + 1] / o / 100 | 0) == 0 : r < 4 ? (r == 0 ? c = c / 1e3 | 0 : r == 1 ? c = c / 100 | 0 : r == 2 && (c = c / 10 | 0), l = (a || n < 4) && c == 9999 || !a && n > 3 && c == 4999) : l = ((a || n < 4) && c + 1 == o || !a && n > 3 && c + 1 == o / 2) && (t[s + 1] / o / 1e3 | 0) == mathpow(10, r - 3) - 1, l;
}
function convertBase(t, r, n) {
  for (var a, s = [0], o, l = 0, c = t.length; l < c; ) {
    for (o = s.length; o--; ) s[o] *= r;
    for (s[0] += NUMERALS.indexOf(t.charAt(l++)), a = 0; a < s.length; a++)
      s[a] > n - 1 && (s[a + 1] === void 0 && (s[a + 1] = 0), s[a + 1] += s[a] / n | 0, s[a] %= n);
  }
  return s.reverse();
}
function cosine(t, r) {
  var n, a, s;
  if (r.isZero()) return r;
  a = r.d.length, a < 32 ? (n = Math.ceil(a / 3), s = (1 / tinyPow(4, n)).toString()) : (n = 16, s = "2.3283064365386962890625e-10"), t.precision += n, r = taylorSeries(t, 1, r.times(s), new t(1));
  for (var o = n; o--; ) {
    var l = r.times(r);
    r = l.times(l).minus(l).times(8).plus(1);
  }
  return t.precision -= n, r;
}
var divide = /* @__PURE__ */ (function() {
  function t(a, s, o) {
    var l, c = 0, x = a.length;
    for (a = a.slice(); x--; )
      l = a[x] * s + c, a[x] = l % o | 0, c = l / o | 0;
    return c && a.unshift(c), a;
  }
  function r(a, s, o, l) {
    var c, x;
    if (o != l)
      x = o > l ? 1 : -1;
    else
      for (c = x = 0; c < o; c++)
        if (a[c] != s[c]) {
          x = a[c] > s[c] ? 1 : -1;
          break;
        }
    return x;
  }
  function n(a, s, o, l) {
    for (var c = 0; o--; )
      a[o] -= c, c = a[o] < s[o] ? 1 : 0, a[o] = c * l + a[o] - s[o];
    for (; !a[0] && a.length > 1; ) a.shift();
  }
  return function(a, s, o, l, c, x) {
    var j, Z, V, U, $, Y, G, W, X, K, J, ee, te, ne, re, ie, ue, le, oe, he, fe = a.constructor, ce = a.s == s.s ? 1 : -1, se = a.d, pe = s.d;
    if (!se || !se[0] || !pe || !pe[0])
      return new fe(
        // Return NaN if either NaN, or both Infinity or 0.
        !a.s || !s.s || (se ? pe && se[0] == pe[0] : !pe) ? NaN : (
          // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
          se && se[0] == 0 || !pe ? ce * 0 : ce / 0
        )
      );
    for (x ? ($ = 1, Z = a.e - s.e) : (x = BASE, $ = LOG_BASE, Z = mathfloor(a.e / $) - mathfloor(s.e / $)), oe = pe.length, ue = se.length, X = new fe(ce), K = X.d = [], V = 0; pe[V] == (se[V] || 0); V++) ;
    if (pe[V] > (se[V] || 0) && Z--, o == null ? (ne = o = fe.precision, l = fe.rounding) : c ? ne = o + (a.e - s.e) + 1 : ne = o, ne < 0)
      K.push(1), Y = !0;
    else {
      if (ne = ne / $ + 2 | 0, V = 0, oe == 1) {
        for (U = 0, pe = pe[0], ne++; (V < ue || U) && ne--; V++)
          re = U * x + (se[V] || 0), K[V] = re / pe | 0, U = re % pe | 0;
        Y = U || V < ue;
      } else {
        for (U = x / (pe[0] + 1) | 0, U > 1 && (pe = t(pe, U, x), se = t(se, U, x), oe = pe.length, ue = se.length), ie = oe, J = se.slice(0, oe), ee = J.length; ee < oe; ) J[ee++] = 0;
        he = pe.slice(), he.unshift(0), le = pe[0], pe[1] >= x / 2 && ++le;
        do
          U = 0, j = r(pe, J, oe, ee), j < 0 ? (te = J[0], oe != ee && (te = te * x + (J[1] || 0)), U = te / le | 0, U > 1 ? (U >= x && (U = x - 1), G = t(pe, U, x), W = G.length, ee = J.length, j = r(G, J, W, ee), j == 1 && (U--, n(G, oe < W ? he : pe, W, x))) : (U == 0 && (j = U = 1), G = pe.slice()), W = G.length, W < ee && G.unshift(0), n(J, G, ee, x), j == -1 && (ee = J.length, j = r(pe, J, oe, ee), j < 1 && (U++, n(J, oe < ee ? he : pe, ee, x))), ee = J.length) : j === 0 && (U++, J = [0]), K[V++] = U, j && J[0] ? J[ee++] = se[ie] || 0 : (J = [se[ie]], ee = 1);
        while ((ie++ < ue || J[0] !== void 0) && ne--);
        Y = J[0] !== void 0;
      }
      K[0] || K.shift();
    }
    if ($ == 1)
      X.e = Z, inexact = Y;
    else {
      for (V = 1, U = K[0]; U >= 10; U /= 10) V++;
      X.e = V + Z * $ - 1, finalise(X, c ? o + X.e + 1 : o, l, Y);
    }
    return X;
  };
})();
function finalise(t, r, n, a) {
  var s, o, l, c, x, j, Z, V, U, $ = t.constructor;
  e: if (r != null) {
    if (V = t.d, !V) return t;
    for (s = 1, c = V[0]; c >= 10; c /= 10) s++;
    if (o = r - s, o < 0)
      o += LOG_BASE, l = r, Z = V[U = 0], x = Z / mathpow(10, s - l - 1) % 10 | 0;
    else if (U = Math.ceil((o + 1) / LOG_BASE), c = V.length, U >= c)
      if (a) {
        for (; c++ <= U; ) V.push(0);
        Z = x = 0, s = 1, o %= LOG_BASE, l = o - LOG_BASE + 1;
      } else
        break e;
    else {
      for (Z = c = V[U], s = 1; c >= 10; c /= 10) s++;
      o %= LOG_BASE, l = o - LOG_BASE + s, x = l < 0 ? 0 : Z / mathpow(10, s - l - 1) % 10 | 0;
    }
    if (a = a || r < 0 || V[U + 1] !== void 0 || (l < 0 ? Z : Z % mathpow(10, s - l - 1)), j = n < 4 ? (x || a) && (n == 0 || n == (t.s < 0 ? 3 : 2)) : x > 5 || x == 5 && (n == 4 || a || n == 6 && // Check whether the digit to the left of the rounding digit is odd.
    (o > 0 ? l > 0 ? Z / mathpow(10, s - l) : 0 : V[U - 1]) % 10 & 1 || n == (t.s < 0 ? 8 : 7)), r < 1 || !V[0])
      return V.length = 0, j ? (r -= t.e + 1, V[0] = mathpow(10, (LOG_BASE - r % LOG_BASE) % LOG_BASE), t.e = -r || 0) : V[0] = t.e = 0, t;
    if (o == 0 ? (V.length = U, c = 1, U--) : (V.length = U + 1, c = mathpow(10, LOG_BASE - o), V[U] = l > 0 ? (Z / mathpow(10, s - l) % mathpow(10, l) | 0) * c : 0), j)
      for (; ; )
        if (U == 0) {
          for (o = 1, l = V[0]; l >= 10; l /= 10) o++;
          for (l = V[0] += c, c = 1; l >= 10; l /= 10) c++;
          o != c && (t.e++, V[0] == BASE && (V[0] = 1));
          break;
        } else {
          if (V[U] += c, V[U] != BASE) break;
          V[U--] = 0, c = 1;
        }
    for (o = V.length; V[--o] === 0; ) V.pop();
  }
  return external && (t.e > $.maxE ? (t.d = null, t.e = NaN) : t.e < $.minE && (t.e = 0, t.d = [0])), t;
}
function finiteToString(t, r, n) {
  if (!t.isFinite()) return nonFiniteToString(t);
  var a, s = t.e, o = digitsToString(t.d), l = o.length;
  return r ? (n && (a = n - l) > 0 ? o = o.charAt(0) + "." + o.slice(1) + getZeroString(a) : l > 1 && (o = o.charAt(0) + "." + o.slice(1)), o = o + (t.e < 0 ? "e" : "e+") + t.e) : s < 0 ? (o = "0." + getZeroString(-s - 1) + o, n && (a = n - l) > 0 && (o += getZeroString(a))) : s >= l ? (o += getZeroString(s + 1 - l), n && (a = n - s - 1) > 0 && (o = o + "." + getZeroString(a))) : ((a = s + 1) < l && (o = o.slice(0, a) + "." + o.slice(a)), n && (a = n - l) > 0 && (s + 1 === l && (o += "."), o += getZeroString(a))), o;
}
function getBase10Exponent(t, r) {
  var n = t[0];
  for (r *= LOG_BASE; n >= 10; n /= 10) r++;
  return r;
}
function getLn10(t, r, n) {
  if (r > LN10_PRECISION)
    throw external = !0, n && (t.precision = n), Error(precisionLimitExceeded);
  return finalise(new t(LN10), r, 1, !0);
}
function getPi(t, r, n) {
  if (r > PI_PRECISION) throw Error(precisionLimitExceeded);
  return finalise(new t(PI), r, n, !0);
}
function getPrecision(t) {
  var r = t.length - 1, n = r * LOG_BASE + 1;
  if (r = t[r], r) {
    for (; r % 10 == 0; r /= 10) n--;
    for (r = t[0]; r >= 10; r /= 10) n++;
  }
  return n;
}
function getZeroString(t) {
  for (var r = ""; t--; ) r += "0";
  return r;
}
function intPow(t, r, n, a) {
  var s, o = new t(1), l = Math.ceil(a / LOG_BASE + 4);
  for (external = !1; ; ) {
    if (n % 2 && (o = o.times(r), truncate(o.d, l) && (s = !0)), n = mathfloor(n / 2), n === 0) {
      n = o.d.length - 1, s && o.d[n] === 0 && ++o.d[n];
      break;
    }
    r = r.times(r), truncate(r.d, l);
  }
  return external = !0, o;
}
function isOdd(t) {
  return t.d[t.d.length - 1] & 1;
}
function maxOrMin(t, r, n) {
  for (var a, s, o = new t(r[0]), l = 0; ++l < r.length; ) {
    if (s = new t(r[l]), !s.s) {
      o = s;
      break;
    }
    a = o.cmp(s), (a === n || a === 0 && o.s === n) && (o = s);
  }
  return o;
}
function naturalExponential(t, r) {
  var n, a, s, o, l, c, x, j = 0, Z = 0, V = 0, U = t.constructor, $ = U.rounding, Y = U.precision;
  if (!t.d || !t.d[0] || t.e > 17)
    return new U(t.d ? t.d[0] ? t.s < 0 ? 0 : 1 / 0 : 1 : t.s ? t.s < 0 ? 0 : t : NaN);
  for (r == null ? (external = !1, x = Y) : x = r, c = new U(0.03125); t.e > -2; )
    t = t.times(c), V += 5;
  for (a = Math.log(mathpow(2, V)) / Math.LN10 * 2 + 5 | 0, x += a, n = o = l = new U(1), U.precision = x; ; ) {
    if (o = finalise(o.times(t), x, 1), n = n.times(++Z), c = l.plus(divide(o, n, x, 1)), digitsToString(c.d).slice(0, x) === digitsToString(l.d).slice(0, x)) {
      for (s = V; s--; ) l = finalise(l.times(l), x, 1);
      if (r == null)
        if (j < 3 && checkRoundingDigits(l.d, x - a, $, j))
          U.precision = x += 10, n = o = c = new U(1), Z = 0, j++;
        else
          return finalise(l, U.precision = Y, $, external = !0);
      else
        return U.precision = Y, l;
    }
    l = c;
  }
}
function naturalLogarithm(t, r) {
  var n, a, s, o, l, c, x, j, Z, V, U, $ = 1, Y = 10, G = t, W = G.d, X = G.constructor, K = X.rounding, J = X.precision;
  if (G.s < 0 || !W || !W[0] || !G.e && W[0] == 1 && W.length == 1)
    return new X(W && !W[0] ? -1 / 0 : G.s != 1 ? NaN : W ? 0 : G);
  if (r == null ? (external = !1, Z = J) : Z = r, X.precision = Z += Y, n = digitsToString(W), a = n.charAt(0), Math.abs(o = G.e) < 15e14) {
    for (; a < 7 && a != 1 || a == 1 && n.charAt(1) > 3; )
      G = G.times(t), n = digitsToString(G.d), a = n.charAt(0), $++;
    o = G.e, a > 1 ? (G = new X("0." + n), o++) : G = new X(a + "." + n.slice(1));
  } else
    return j = getLn10(X, Z + 2, J).times(o + ""), G = naturalLogarithm(new X(a + "." + n.slice(1)), Z - Y).plus(j), X.precision = J, r == null ? finalise(G, J, K, external = !0) : G;
  for (V = G, x = l = G = divide(G.minus(1), G.plus(1), Z, 1), U = finalise(G.times(G), Z, 1), s = 3; ; ) {
    if (l = finalise(l.times(U), Z, 1), j = x.plus(divide(l, new X(s), Z, 1)), digitsToString(j.d).slice(0, Z) === digitsToString(x.d).slice(0, Z))
      if (x = x.times(2), o !== 0 && (x = x.plus(getLn10(X, Z + 2, J).times(o + ""))), x = divide(x, new X($), Z, 1), r == null)
        if (checkRoundingDigits(x.d, Z - Y, K, c))
          X.precision = Z += Y, j = l = G = divide(V.minus(1), V.plus(1), Z, 1), U = finalise(G.times(G), Z, 1), s = c = 1;
        else
          return finalise(x, X.precision = J, K, external = !0);
      else
        return X.precision = J, x;
    x = j, s += 2;
  }
}
function nonFiniteToString(t) {
  return String(t.s * t.s / 0);
}
function parseDecimal(t, r) {
  var n, a, s;
  for ((n = r.indexOf(".")) > -1 && (r = r.replace(".", "")), (a = r.search(/e/i)) > 0 ? (n < 0 && (n = a), n += +r.slice(a + 1), r = r.substring(0, a)) : n < 0 && (n = r.length), a = 0; r.charCodeAt(a) === 48; a++) ;
  for (s = r.length; r.charCodeAt(s - 1) === 48; --s) ;
  if (r = r.slice(a, s), r) {
    if (s -= a, t.e = n = n - a - 1, t.d = [], a = (n + 1) % LOG_BASE, n < 0 && (a += LOG_BASE), a < s) {
      for (a && t.d.push(+r.slice(0, a)), s -= LOG_BASE; a < s; ) t.d.push(+r.slice(a, a += LOG_BASE));
      r = r.slice(a), a = LOG_BASE - r.length;
    } else
      a -= s;
    for (; a--; ) r += "0";
    t.d.push(+r), external && (t.e > t.constructor.maxE ? (t.d = null, t.e = NaN) : t.e < t.constructor.minE && (t.e = 0, t.d = [0]));
  } else
    t.e = 0, t.d = [0];
  return t;
}
function parseOther(t, r) {
  var n, a, s, o, l, c, x, j, Z;
  if (r.indexOf("_") > -1) {
    if (r = r.replace(/(\d)_(?=\d)/g, "$1"), isDecimal.test(r)) return parseDecimal(t, r);
  } else if (r === "Infinity" || r === "NaN")
    return +r || (t.s = NaN), t.e = NaN, t.d = null, t;
  if (isHex.test(r))
    n = 16, r = r.toLowerCase();
  else if (isBinary.test(r))
    n = 2;
  else if (isOctal.test(r))
    n = 8;
  else
    throw Error(invalidArgument + r);
  for (o = r.search(/p/i), o > 0 ? (x = +r.slice(o + 1), r = r.substring(2, o)) : r = r.slice(2), o = r.indexOf("."), l = o >= 0, a = t.constructor, l && (r = r.replace(".", ""), c = r.length, o = c - o, s = intPow(a, new a(n), o, o * 2)), j = convertBase(r, n, BASE), Z = j.length - 1, o = Z; j[o] === 0; --o) j.pop();
  return o < 0 ? new a(t.s * 0) : (t.e = getBase10Exponent(j, Z), t.d = j, external = !1, l && (t = divide(t, s, c * 4)), x && (t = t.times(Math.abs(x) < 54 ? mathpow(2, x) : Decimal.pow(2, x))), external = !0, t);
}
function sine(t, r) {
  var n, a = r.d.length;
  if (a < 3)
    return r.isZero() ? r : taylorSeries(t, 2, r, r);
  n = 1.4 * Math.sqrt(a), n = n > 16 ? 16 : n | 0, r = r.times(1 / tinyPow(5, n)), r = taylorSeries(t, 2, r, r);
  for (var s, o = new t(5), l = new t(16), c = new t(20); n--; )
    s = r.times(r), r = r.times(o.plus(s.times(l.times(s).minus(c))));
  return r;
}
function taylorSeries(t, r, n, a, s) {
  var o, l, c, x, j = t.precision, Z = Math.ceil(j / LOG_BASE);
  for (external = !1, x = n.times(n), c = new t(a); ; ) {
    if (l = divide(c.times(x), new t(r++ * r++), j, 1), c = s ? a.plus(l) : a.minus(l), a = divide(l.times(x), new t(r++ * r++), j, 1), l = c.plus(a), l.d[Z] !== void 0) {
      for (o = Z; l.d[o] === c.d[o] && o--; ) ;
      if (o == -1) break;
    }
    o = c, c = a, a = l, l = o;
  }
  return external = !0, l.d.length = Z + 1, l;
}
function tinyPow(t, r) {
  for (var n = t; --r; ) n *= t;
  return n;
}
function toLessThanHalfPi(t, r) {
  var n, a = r.s < 0, s = getPi(t, t.precision, 1), o = s.times(0.5);
  if (r = r.abs(), r.lte(o))
    return quadrant = a ? 4 : 1, r;
  if (n = r.divToInt(s), n.isZero())
    quadrant = a ? 3 : 2;
  else {
    if (r = r.minus(n.times(s)), r.lte(o))
      return quadrant = isOdd(n) ? a ? 2 : 3 : a ? 4 : 1, r;
    quadrant = isOdd(n) ? a ? 1 : 4 : a ? 3 : 2;
  }
  return r.minus(s).abs();
}
function toStringBinary(t, r, n, a) {
  var s, o, l, c, x, j, Z, V, U, $ = t.constructor, Y = n !== void 0;
  if (Y ? (checkInt32(n, 1, MAX_DIGITS), a === void 0 ? a = $.rounding : checkInt32(a, 0, 8)) : (n = $.precision, a = $.rounding), !t.isFinite())
    Z = nonFiniteToString(t);
  else {
    for (Z = finiteToString(t), l = Z.indexOf("."), Y ? (s = 2, r == 16 ? n = n * 4 - 3 : r == 8 && (n = n * 3 - 2)) : s = r, l >= 0 && (Z = Z.replace(".", ""), U = new $(1), U.e = Z.length - l, U.d = convertBase(finiteToString(U), 10, s), U.e = U.d.length), V = convertBase(Z, 10, s), o = x = V.length; V[--x] == 0; ) V.pop();
    if (!V[0])
      Z = Y ? "0p+0" : "0";
    else {
      if (l < 0 ? o-- : (t = new $(t), t.d = V, t.e = o, t = divide(t, U, n, a, 0, s), V = t.d, o = t.e, j = inexact), l = V[n], c = s / 2, j = j || V[n + 1] !== void 0, j = a < 4 ? (l !== void 0 || j) && (a === 0 || a === (t.s < 0 ? 3 : 2)) : l > c || l === c && (a === 4 || j || a === 6 && V[n - 1] & 1 || a === (t.s < 0 ? 8 : 7)), V.length = n, j)
        for (; ++V[--n] > s - 1; )
          V[n] = 0, n || (++o, V.unshift(1));
      for (x = V.length; !V[x - 1]; --x) ;
      for (l = 0, Z = ""; l < x; l++) Z += NUMERALS.charAt(V[l]);
      if (Y) {
        if (x > 1)
          if (r == 16 || r == 8) {
            for (l = r == 16 ? 4 : 3, --x; x % l; x++) Z += "0";
            for (V = convertBase(Z, s, r), x = V.length; !V[x - 1]; --x) ;
            for (l = 1, Z = "1."; l < x; l++) Z += NUMERALS.charAt(V[l]);
          } else
            Z = Z.charAt(0) + "." + Z.slice(1);
        Z = Z + (o < 0 ? "p" : "p+") + o;
      } else if (o < 0) {
        for (; ++o; ) Z = "0" + Z;
        Z = "0." + Z;
      } else if (++o > x) for (o -= x; o--; ) Z += "0";
      else o < x && (Z = Z.slice(0, o) + "." + Z.slice(o));
    }
    Z = (r == 16 ? "0x" : r == 2 ? "0b" : r == 8 ? "0o" : "") + Z;
  }
  return t.s < 0 ? "-" + Z : Z;
}
function truncate(t, r) {
  if (t.length > r)
    return t.length = r, !0;
}
function abs(t) {
  return new this(t).abs();
}
function acos(t) {
  return new this(t).acos();
}
function acosh(t) {
  return new this(t).acosh();
}
function add(t, r) {
  return new this(t).plus(r);
}
function asin(t) {
  return new this(t).asin();
}
function asinh(t) {
  return new this(t).asinh();
}
function atan(t) {
  return new this(t).atan();
}
function atanh(t) {
  return new this(t).atanh();
}
function atan2(t, r) {
  t = new this(t), r = new this(r);
  var n, a = this.precision, s = this.rounding, o = a + 4;
  return !t.s || !r.s ? n = new this(NaN) : !t.d && !r.d ? (n = getPi(this, o, 1).times(r.s > 0 ? 0.25 : 0.75), n.s = t.s) : !r.d || t.isZero() ? (n = r.s < 0 ? getPi(this, a, s) : new this(0), n.s = t.s) : !t.d || r.isZero() ? (n = getPi(this, o, 1).times(0.5), n.s = t.s) : r.s < 0 ? (this.precision = o, this.rounding = 1, n = this.atan(divide(t, r, o, 1)), r = getPi(this, o, 1), this.precision = a, this.rounding = s, n = t.s < 0 ? n.minus(r) : n.plus(r)) : n = this.atan(divide(t, r, o, 1)), n;
}
function cbrt(t) {
  return new this(t).cbrt();
}
function ceil(t) {
  return finalise(t = new this(t), t.e + 1, 2);
}
function clamp(t, r, n) {
  return new this(t).clamp(r, n);
}
function config(t) {
  if (!t || typeof t != "object") throw Error(decimalError + "Object expected");
  var r, n, a, s = t.defaults === !0, o = [
    "precision",
    1,
    MAX_DIGITS,
    "rounding",
    0,
    8,
    "toExpNeg",
    -EXP_LIMIT,
    0,
    "toExpPos",
    0,
    EXP_LIMIT,
    "maxE",
    0,
    EXP_LIMIT,
    "minE",
    -EXP_LIMIT,
    0,
    "modulo",
    0,
    9
  ];
  for (r = 0; r < o.length; r += 3)
    if (n = o[r], s && (this[n] = DEFAULTS[n]), (a = t[n]) !== void 0)
      if (mathfloor(a) === a && a >= o[r + 1] && a <= o[r + 2]) this[n] = a;
      else throw Error(invalidArgument + n + ": " + a);
  if (n = "crypto", s && (this[n] = DEFAULTS[n]), (a = t[n]) !== void 0)
    if (a === !0 || a === !1 || a === 0 || a === 1)
      if (a)
        if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes))
          this[n] = !0;
        else
          throw Error(cryptoUnavailable);
      else
        this[n] = !1;
    else
      throw Error(invalidArgument + n + ": " + a);
  return this;
}
function cos(t) {
  return new this(t).cos();
}
function cosh(t) {
  return new this(t).cosh();
}
function clone(t) {
  var r, n, a;
  function s(o) {
    var l, c, x, j = this;
    if (!(j instanceof s)) return new s(o);
    if (j.constructor = s, isDecimalInstance(o)) {
      j.s = o.s, external ? !o.d || o.e > s.maxE ? (j.e = NaN, j.d = null) : o.e < s.minE ? (j.e = 0, j.d = [0]) : (j.e = o.e, j.d = o.d.slice()) : (j.e = o.e, j.d = o.d ? o.d.slice() : o.d);
      return;
    }
    if (x = typeof o, x === "number") {
      if (o === 0) {
        j.s = 1 / o < 0 ? -1 : 1, j.e = 0, j.d = [0];
        return;
      }
      if (o < 0 ? (o = -o, j.s = -1) : j.s = 1, o === ~~o && o < 1e7) {
        for (l = 0, c = o; c >= 10; c /= 10) l++;
        external ? l > s.maxE ? (j.e = NaN, j.d = null) : l < s.minE ? (j.e = 0, j.d = [0]) : (j.e = l, j.d = [o]) : (j.e = l, j.d = [o]);
        return;
      }
      if (o * 0 !== 0) {
        o || (j.s = NaN), j.e = NaN, j.d = null;
        return;
      }
      return parseDecimal(j, o.toString());
    }
    if (x === "string")
      return (c = o.charCodeAt(0)) === 45 ? (o = o.slice(1), j.s = -1) : (c === 43 && (o = o.slice(1)), j.s = 1), isDecimal.test(o) ? parseDecimal(j, o) : parseOther(j, o);
    if (x === "bigint")
      return o < 0 ? (o = -o, j.s = -1) : j.s = 1, parseDecimal(j, o.toString());
    throw Error(invalidArgument + o);
  }
  if (s.prototype = P$1, s.ROUND_UP = 0, s.ROUND_DOWN = 1, s.ROUND_CEIL = 2, s.ROUND_FLOOR = 3, s.ROUND_HALF_UP = 4, s.ROUND_HALF_DOWN = 5, s.ROUND_HALF_EVEN = 6, s.ROUND_HALF_CEIL = 7, s.ROUND_HALF_FLOOR = 8, s.EUCLID = 9, s.config = s.set = config, s.clone = clone, s.isDecimal = isDecimalInstance, s.abs = abs, s.acos = acos, s.acosh = acosh, s.add = add, s.asin = asin, s.asinh = asinh, s.atan = atan, s.atanh = atanh, s.atan2 = atan2, s.cbrt = cbrt, s.ceil = ceil, s.clamp = clamp, s.cos = cos, s.cosh = cosh, s.div = div, s.exp = exp, s.floor = floor, s.hypot = hypot, s.ln = ln, s.log = log, s.log10 = log10, s.log2 = log2, s.max = max, s.min = min, s.mod = mod, s.mul = mul, s.pow = pow, s.random = random, s.round = round, s.sign = sign, s.sin = sin, s.sinh = sinh, s.sqrt = sqrt, s.sub = sub, s.sum = sum, s.tan = tan, s.tanh = tanh, s.trunc = trunc, t === void 0 && (t = {}), t && t.defaults !== !0)
    for (a = ["precision", "rounding", "toExpNeg", "toExpPos", "maxE", "minE", "modulo", "crypto"], r = 0; r < a.length; ) t.hasOwnProperty(n = a[r++]) || (t[n] = this[n]);
  return s.config(t), s;
}
function div(t, r) {
  return new this(t).div(r);
}
function exp(t) {
  return new this(t).exp();
}
function floor(t) {
  return finalise(t = new this(t), t.e + 1, 3);
}
function hypot() {
  var t, r, n = new this(0);
  for (external = !1, t = 0; t < arguments.length; )
    if (r = new this(arguments[t++]), r.d)
      n.d && (n = n.plus(r.times(r)));
    else {
      if (r.s)
        return external = !0, new this(1 / 0);
      n = r;
    }
  return external = !0, n.sqrt();
}
function isDecimalInstance(t) {
  return t instanceof Decimal || t && t.toStringTag === tag || !1;
}
function ln(t) {
  return new this(t).ln();
}
function log(t, r) {
  return new this(t).log(r);
}
function log2(t) {
  return new this(t).log(2);
}
function log10(t) {
  return new this(t).log(10);
}
function max() {
  return maxOrMin(this, arguments, -1);
}
function min() {
  return maxOrMin(this, arguments, 1);
}
function mod(t, r) {
  return new this(t).mod(r);
}
function mul(t, r) {
  return new this(t).mul(r);
}
function pow(t, r) {
  return new this(t).pow(r);
}
function random(t) {
  var r, n, a, s, o = 0, l = new this(1), c = [];
  if (t === void 0 ? t = this.precision : checkInt32(t, 1, MAX_DIGITS), a = Math.ceil(t / LOG_BASE), this.crypto)
    if (crypto.getRandomValues)
      for (r = crypto.getRandomValues(new Uint32Array(a)); o < a; )
        s = r[o], s >= 429e7 ? r[o] = crypto.getRandomValues(new Uint32Array(1))[0] : c[o++] = s % 1e7;
    else if (crypto.randomBytes) {
      for (r = crypto.randomBytes(a *= 4); o < a; )
        s = r[o] + (r[o + 1] << 8) + (r[o + 2] << 16) + ((r[o + 3] & 127) << 24), s >= 214e7 ? crypto.randomBytes(4).copy(r, o) : (c.push(s % 1e7), o += 4);
      o = a / 4;
    } else
      throw Error(cryptoUnavailable);
  else for (; o < a; ) c[o++] = Math.random() * 1e7 | 0;
  for (a = c[--o], t %= LOG_BASE, a && t && (s = mathpow(10, LOG_BASE - t), c[o] = (a / s | 0) * s); c[o] === 0; o--) c.pop();
  if (o < 0)
    n = 0, c = [0];
  else {
    for (n = -1; c[0] === 0; n -= LOG_BASE) c.shift();
    for (a = 1, s = c[0]; s >= 10; s /= 10) a++;
    a < LOG_BASE && (n -= LOG_BASE - a);
  }
  return l.e = n, l.d = c, l;
}
function round(t) {
  return finalise(t = new this(t), t.e + 1, this.rounding);
}
function sign(t) {
  return t = new this(t), t.d ? t.d[0] ? t.s : 0 * t.s : t.s || NaN;
}
function sin(t) {
  return new this(t).sin();
}
function sinh(t) {
  return new this(t).sinh();
}
function sqrt(t) {
  return new this(t).sqrt();
}
function sub(t, r) {
  return new this(t).sub(r);
}
function sum() {
  var t = 0, r = arguments, n = new this(r[t]);
  for (external = !1; n.s && ++t < r.length; ) n = n.plus(r[t]);
  return external = !0, finalise(n, this.precision, this.rounding);
}
function tan(t) {
  return new this(t).tan();
}
function tanh(t) {
  return new this(t).tanh();
}
function trunc(t) {
  return finalise(t = new this(t), t.e + 1, 1);
}
P$1[/* @__PURE__ */ Symbol.for("nodejs.util.inspect.custom")] = P$1.toString;
P$1[Symbol.toStringTag] = "Decimal";
var Decimal = P$1.constructor = clone(DEFAULTS);
LN10 = new Decimal(LN10);
PI = new Decimal(PI);
const DEFAULT_NUMBER_DELIMITER = ",", DEFAULT_NUMBER_PARSER = (t) => {
  var s, o, l, c;
  const r = t.toString().trim().match(/-?[0-9]*\.?[0-9]*(e[0-9]*)?/), n = r == null ? void 0 : r.at(0), a = Number.parseInt((o = (s = r == null ? void 0 : r.index) == null ? void 0 : s.toString()) != null ? o : "");
  return {
    number: n != null ? n : t,
    endPosition: a !== void 0 && !Number.isNaN(a) ? a + ((c = (l = r == null ? void 0 : r.at(0)) == null ? void 0 : l.length) != null ? c : 0) : null
  };
};
class NumberValidator {
  constructor(r) {
    Pr(this, "value");
    this.value = r;
  }
  checkMin(r) {
    return r !== void 0 && (this.value = Math.max(Number(this.value), r)), this;
  }
  checkMax(r) {
    return r !== void 0 && (this.value = Math.min(Number(this.value), r)), this;
  }
  applyPrecision(r) {
    const { value: n } = this;
    return r === void 0 ? this.value = n.toString() : this.value = Number(n).toFixed(r), this;
  }
  validate() {
    const r = Number.parseFloat(this.value.toString());
    return Number.isNaN(r) || !Number.isFinite(r) || this.value === "" || this.value === null ? null : r;
  }
}
function validateNumber(t, r, n, a) {
  if (t === null)
    return null;
  const s = t.toString().trim();
  if (s === "" || /^-*\.*$/.test(s))
    return null;
  if (/^-?\.[0-9]*(e[0-9]*)?$/.test(s)) {
    const o = Number.parseFloat(s);
    return new NumberValidator(o).checkMin(r).checkMax(n).applyPrecision(a).validate();
  }
  if (/^-?[0-9]+\.?(e[0-9]*)?/.test(s)) {
    const o = Number.parseFloat(s);
    return new NumberValidator(o).checkMin(r).checkMax(n).applyPrecision(a).validate();
  }
  return s !== "" && r !== void 0 ? new NumberValidator(r).applyPrecision(a).validate() : null;
}
function setCaretAtPosition(t, r) {
  if (t === null)
    return;
  const { selectionStart: n, selectionEnd: a } = r;
  n === a && (a !== null && a <= t || r.setSelectionRange(t, t));
}
const getDelimiterFormatter = (t) => (r) => r.toString().replace(".", t);
function combineFormatters(t, ...r) {
  let n = t.toString();
  for (const a of r)
    n = a(n);
  return n;
}
function replaceSpecialDelimiterWithDot(t, r) {
  return t.toString().replace(r, ".");
}
const InputNumber = forwardRef(function t({
  value: r,
  id: n,
  prefix: a,
  suffix: s,
  placeholder: o,
  size: l,
  status: c,
  min: x,
  max: j,
  step: Z = 1,
  precision: V,
  allowClear: U = !1,
  disabled: $ = !1,
  tabIndex: Y = 0,
  centred: G = !1,
  formatter: W,
  parser: X = DEFAULT_NUMBER_PARSER,
  autoFocus: K,
  className: J,
  fieldClassName: ee,
  style: te,
  onChange: ne,
  onFocus: re,
  onBlur: ie,
  onKeyDown: ue,
  onKeyUp: le,
  onClick: oe,
  onMouseLeave: he,
  onMouseEnter: fe,
  loading: ce,
  delimiter: se = DEFAULT_NUMBER_DELIMITER,
  allowHandleKeys: pe = !0
}, ve) {
  const { size: ae } = useGlobalComponentConfig({ size: l }), [me, de] = useState$1(r != null ? r : "");
  useEffect(() => {
    de(r != null ? r : "");
  }, [r]);
  const ge = useCallback(
    (Ee) => {
      const Ce = Ee.currentTarget.value, { number: ke } = X(replaceSpecialDelimiterWithDot(Ce, se));
      de(ke), ne == null || ne(ke === "" ? null : ke, Ee);
    },
    [se, ne, X]
  ), Se = useCallback(
    (Ee) => {
      ie == null || ie(Ee);
      const Ce = validateNumber(me, x, j, V);
      de(Ce != null ? Ce : ""), ne == null || ne(Ce, Ee);
    },
    [j, x, ie, ne, V, me]
  ), xe = useCallback(
    (Ee) => {
      if (pe) {
        if (Ee.key === "ArrowUp") {
          Ee.preventDefault();
          const ke = validateNumber(me, x, j, V), Re = new Decimal(ke != null ? ke : 0).plus(new Decimal(Z)).toNumber(), _e = validateNumber(Re, x, j, V);
          de(_e != null ? _e : ""), ne == null || ne(_e);
          return;
        }
        if (Ee.key === "ArrowDown") {
          Ee.preventDefault();
          const ke = validateNumber(me, x, j, V), Re = new Decimal(ke != null ? ke : 0).minus(new Decimal(Z)).toNumber(), _e = validateNumber(Re, x, j, V);
          de(_e != null ? _e : ""), ne == null || ne(_e);
          return;
        }
        const Ce = X(replaceSpecialDelimiterWithDot(me, se)).endPosition;
        setCaretAtPosition(Ce, Ee.currentTarget);
      }
      ue == null || ue(Ee);
    },
    [pe, se, j, x, ne, ue, X, V, Z, me]
  );
  return /* @__PURE__ */ jsx(
    Input,
    {
      ref: ve,
      value: W ? combineFormatters(me, W, getDelimiterFormatter(se)).toString() : getDelimiterFormatter(se)(me).toString(),
      allowClear: U,
      style: te,
      disabled: $,
      placeholder: o,
      className: clsx(G && "go-input-number_centred", J),
      tabIndex: Y,
      id: n,
      onClick: oe,
      prefix: a,
      suffix: s,
      status: c,
      size: ae,
      autoFocus: K,
      fieldClassName: ee,
      loading: ce,
      onChange: ge,
      onBlur: Se,
      onFocus: re,
      onKeyDown: xe,
      onKeyUp: le,
      onMouseLeave: he,
      onMouseEnter: fe
    }
  );
});
function Modal({
  open: t,
  title: r,
  closeIcon: n = !0,
  loading: a,
  className: s,
  headerClassName: o,
  wrapperClassName: l,
  portalClassName: c,
  style: x,
  onClose: j,
  onClickOutside: Z = j,
  children: V,
  transitionDuration: U,
  destroyOnClose: $
}) {
  return /* @__PURE__ */ jsx(
    Portal,
    {
      open: t,
      onClickOutside: Z != null ? Z : null,
      className: "go-modal__portal",
      contentClassName: clsx("go-modal__wrapper", l),
      contentOpenClassName: "go-modal__wrapper_open",
      portalClassName: c,
      transitionDuration: U,
      destroyOnClose: $,
      children: /* @__PURE__ */ jsxs("div", { className: clsx(s, "go-modal"), style: x, children: [
        !!r && /* @__PURE__ */ jsx("div", { className: clsx("go-modal__header", o), children: renderNode(r, "h2", "go-modal__title") }),
        !!n && /* @__PURE__ */ jsx("button", { className: "go-modal__close-button", onClick: j, children: /* @__PURE__ */ jsx(CloseRoundLight, {}) }),
        V,
        a && /* @__PURE__ */ jsx(Loader, { className: "go-modal__loader" })
      ] })
    }
  );
}
const u = (t) => typeof t == "number" && !isNaN(t), d = (t) => typeof t == "string", p = (t) => typeof t == "function", m = (t) => d(t) || p(t) ? t : null, f = (t) => isValidElement(t) || d(t) || p(t) || u(t);
function g(t, r, n) {
  n === void 0 && (n = 300);
  const { scrollHeight: a, style: s } = t;
  requestAnimationFrame(() => {
    s.minHeight = "initial", s.height = a + "px", s.transition = `all ${n}ms`, requestAnimationFrame(() => {
      s.height = "0", s.padding = "0", s.margin = "0", setTimeout(r, n);
    });
  });
}
function h(t) {
  let { enter: r, exit: n, appendPosition: a = !1, collapse: s = !0, collapseDuration: o = 300 } = t;
  return function(l) {
    let { children: c, position: x, preventExitTransition: j, done: Z, nodeRef: V, isIn: U } = l;
    const $ = a ? `${r}--${x}` : r, Y = a ? `${n}--${x}` : n, G = useRef(0);
    return useLayoutEffect$3(() => {
      const W = V.current, X = $.split(" "), K = (J) => {
        J.target === V.current && (W.dispatchEvent(new Event("d")), W.removeEventListener("animationend", K), W.removeEventListener("animationcancel", K), G.current === 0 && J.type !== "animationcancel" && W.classList.remove(...X));
      };
      W.classList.add(...X), W.addEventListener("animationend", K), W.addEventListener("animationcancel", K);
    }, []), useEffect(() => {
      const W = V.current, X = () => {
        W.removeEventListener("animationend", X), s ? g(W, Z, o) : Z();
      };
      U || (j ? X() : (G.current = 1, W.className += ` ${Y}`, W.addEventListener("animationend", X)));
    }, [U]), React__default.createElement(React__default.Fragment, null, c);
  };
}
function y(t, r) {
  return t != null ? { content: t.content, containerId: t.props.containerId, id: t.props.toastId, theme: t.props.theme, type: t.props.type, data: t.props.data || {}, isLoading: t.props.isLoading, icon: t.props.icon, status: r } : {};
}
const v = { list: /* @__PURE__ */ new Map(), emitQueue: /* @__PURE__ */ new Map(), on(t, r) {
  return this.list.has(t) || this.list.set(t, []), this.list.get(t).push(r), this;
}, off(t, r) {
  if (r) {
    const n = this.list.get(t).filter((a) => a !== r);
    return this.list.set(t, n), this;
  }
  return this.list.delete(t), this;
}, cancelEmit(t) {
  const r = this.emitQueue.get(t);
  return r && (r.forEach(clearTimeout), this.emitQueue.delete(t)), this;
}, emit(t) {
  this.list.has(t) && this.list.get(t).forEach((r) => {
    const n = setTimeout(() => {
      r(...[].slice.call(arguments, 1));
    }, 0);
    this.emitQueue.has(t) || this.emitQueue.set(t, []), this.emitQueue.get(t).push(n);
  });
} }, T = (t) => {
  let { theme: r, type: n, ...a } = t;
  return React__default.createElement("svg", { viewBox: "0 0 24 24", width: "100%", height: "100%", fill: r === "colored" ? "currentColor" : `var(--toastify-icon-color-${n})`, ...a });
}, E = { info: function(t) {
  return React__default.createElement(T, { ...t }, React__default.createElement("path", { d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z" }));
}, warning: function(t) {
  return React__default.createElement(T, { ...t }, React__default.createElement("path", { d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z" }));
}, success: function(t) {
  return React__default.createElement(T, { ...t }, React__default.createElement("path", { d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z" }));
}, error: function(t) {
  return React__default.createElement(T, { ...t }, React__default.createElement("path", { d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z" }));
}, spinner: function() {
  return React__default.createElement("div", { className: "Toastify__spinner" });
} };
function C(t) {
  const [, r] = useReducer(($) => $ + 1, 0), [n, a] = useState$1([]), s = useRef(null), o = useRef(/* @__PURE__ */ new Map()).current, l = ($) => n.indexOf($) !== -1, c = useRef({ toastKey: 1, displayedToast: 0, count: 0, queue: [], props: t, containerId: null, isToastActive: l, getToast: ($) => o.get($) }).current;
  function x($) {
    let { containerId: Y } = $;
    const { limit: G } = c.props;
    !G || Y && c.containerId !== Y || (c.count -= c.queue.length, c.queue = []);
  }
  function j($) {
    a((Y) => $ == null ? [] : Y.filter((G) => G !== $));
  }
  function Z() {
    const { toastContent: $, toastProps: Y, staleId: G } = c.queue.shift();
    U($, Y, G);
  }
  function V($, Y) {
    let { delay: G, staleId: W, ...X } = Y;
    if (!f($) || (function(he) {
      return !s.current || c.props.enableMultiContainer && he.containerId !== c.props.containerId || o.has(he.toastId) && he.updateId == null;
    })(X)) return;
    const { toastId: K, updateId: J, data: ee } = X, { props: te } = c, ne = () => j(K), re = J == null;
    re && c.count++;
    const ie = { ...te, style: te.toastStyle, key: c.toastKey++, ...Object.fromEntries(Object.entries(X).filter((he) => {
      let [fe, ce] = he;
      return ce != null;
    })), toastId: K, updateId: J, data: ee, closeToast: ne, isIn: !1, className: m(X.className || te.toastClassName), bodyClassName: m(X.bodyClassName || te.bodyClassName), progressClassName: m(X.progressClassName || te.progressClassName), autoClose: !X.isLoading && (ue = X.autoClose, le = te.autoClose, ue === !1 || u(ue) && ue > 0 ? ue : le), deleteToast() {
      const he = y(o.get(K), "removed");
      o.delete(K), v.emit(4, he);
      const fe = c.queue.length;
      if (c.count = K == null ? c.count - c.displayedToast : c.count - 1, c.count < 0 && (c.count = 0), fe > 0) {
        const ce = K == null ? c.props.limit : 1;
        if (fe === 1 || ce === 1) c.displayedToast++, Z();
        else {
          const se = ce > fe ? fe : ce;
          c.displayedToast = se;
          for (let pe = 0; pe < se; pe++) Z();
        }
      } else r();
    } };
    var ue, le;
    ie.iconOut = (function(he) {
      let { theme: fe, type: ce, isLoading: se, icon: pe } = he, ve = null;
      const ae = { theme: fe, type: ce };
      return pe === !1 || (p(pe) ? ve = pe(ae) : isValidElement(pe) ? ve = cloneElement(pe, ae) : d(pe) || u(pe) ? ve = pe : se ? ve = E.spinner() : ((me) => me in E)(ce) && (ve = E[ce](ae))), ve;
    })(ie), p(X.onOpen) && (ie.onOpen = X.onOpen), p(X.onClose) && (ie.onClose = X.onClose), ie.closeButton = te.closeButton, X.closeButton === !1 || f(X.closeButton) ? ie.closeButton = X.closeButton : X.closeButton === !0 && (ie.closeButton = !f(te.closeButton) || te.closeButton);
    let oe = $;
    isValidElement($) && !d($.type) ? oe = cloneElement($, { closeToast: ne, toastProps: ie, data: ee }) : p($) && (oe = $({ closeToast: ne, toastProps: ie, data: ee })), te.limit && te.limit > 0 && c.count > te.limit && re ? c.queue.push({ toastContent: oe, toastProps: ie, staleId: W }) : u(G) ? setTimeout(() => {
      U(oe, ie, W);
    }, G) : U(oe, ie, W);
  }
  function U($, Y, G) {
    const { toastId: W } = Y;
    G && o.delete(G);
    const X = { content: $, props: Y };
    o.set(W, X), a((K) => [...K, W].filter((J) => J !== G)), v.emit(4, y(X, X.props.updateId == null ? "added" : "updated"));
  }
  return useEffect(() => (c.containerId = t.containerId, v.cancelEmit(3).on(0, V).on(1, ($) => s.current && j($)).on(5, x).emit(2, c), () => {
    o.clear(), v.emit(3, c);
  }), []), useEffect(() => {
    c.props = t, c.isToastActive = l, c.displayedToast = n.length;
  }), { getToastToRender: function($) {
    const Y = /* @__PURE__ */ new Map(), G = Array.from(o.values());
    return t.newestOnTop && G.reverse(), G.forEach((W) => {
      const { position: X } = W.props;
      Y.has(X) || Y.set(X, []), Y.get(X).push(W);
    }), Array.from(Y, (W) => $(W[0], W[1]));
  }, containerRef: s, isToastActive: l };
}
function b(t) {
  return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientX : t.clientX;
}
function I(t) {
  return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientY : t.clientY;
}
function _(t) {
  const [r, n] = useState$1(!1), [a, s] = useState$1(!1), o = useRef(null), l = useRef({ start: 0, x: 0, y: 0, delta: 0, removalDistance: 0, canCloseOnClick: !0, canDrag: !1, boundingRect: null, didMove: !1 }).current, c = useRef(t), { autoClose: x, pauseOnHover: j, closeToast: Z, onClick: V, closeOnClick: U } = t;
  function $(ee) {
    if (t.draggable) {
      ee.nativeEvent.type === "touchstart" && ee.nativeEvent.preventDefault(), l.didMove = !1, document.addEventListener("mousemove", X), document.addEventListener("mouseup", K), document.addEventListener("touchmove", X), document.addEventListener("touchend", K);
      const te = o.current;
      l.canCloseOnClick = !0, l.canDrag = !0, l.boundingRect = te.getBoundingClientRect(), te.style.transition = "", l.x = b(ee.nativeEvent), l.y = I(ee.nativeEvent), t.draggableDirection === "x" ? (l.start = l.x, l.removalDistance = te.offsetWidth * (t.draggablePercent / 100)) : (l.start = l.y, l.removalDistance = te.offsetHeight * (t.draggablePercent === 80 ? 1.5 * t.draggablePercent : t.draggablePercent / 100));
    }
  }
  function Y(ee) {
    if (l.boundingRect) {
      const { top: te, bottom: ne, left: re, right: ie } = l.boundingRect;
      ee.nativeEvent.type !== "touchend" && t.pauseOnHover && l.x >= re && l.x <= ie && l.y >= te && l.y <= ne ? W() : G();
    }
  }
  function G() {
    n(!0);
  }
  function W() {
    n(!1);
  }
  function X(ee) {
    const te = o.current;
    l.canDrag && te && (l.didMove = !0, r && W(), l.x = b(ee), l.y = I(ee), l.delta = t.draggableDirection === "x" ? l.x - l.start : l.y - l.start, l.start !== l.x && (l.canCloseOnClick = !1), te.style.transform = `translate${t.draggableDirection}(${l.delta}px)`, te.style.opacity = "" + (1 - Math.abs(l.delta / l.removalDistance)));
  }
  function K() {
    document.removeEventListener("mousemove", X), document.removeEventListener("mouseup", K), document.removeEventListener("touchmove", X), document.removeEventListener("touchend", K);
    const ee = o.current;
    if (l.canDrag && l.didMove && ee) {
      if (l.canDrag = !1, Math.abs(l.delta) > l.removalDistance) return s(!0), void t.closeToast();
      ee.style.transition = "transform 0.2s, opacity 0.2s", ee.style.transform = `translate${t.draggableDirection}(0)`, ee.style.opacity = "1";
    }
  }
  useEffect(() => {
    c.current = t;
  }), useEffect(() => (o.current && o.current.addEventListener("d", G, { once: !0 }), p(t.onOpen) && t.onOpen(isValidElement(t.children) && t.children.props), () => {
    const ee = c.current;
    p(ee.onClose) && ee.onClose(isValidElement(ee.children) && ee.children.props);
  }), []), useEffect(() => (t.pauseOnFocusLoss && (document.hasFocus() || W(), window.addEventListener("focus", G), window.addEventListener("blur", W)), () => {
    t.pauseOnFocusLoss && (window.removeEventListener("focus", G), window.removeEventListener("blur", W));
  }), [t.pauseOnFocusLoss]);
  const J = { onMouseDown: $, onTouchStart: $, onMouseUp: Y, onTouchEnd: Y };
  return x && j && (J.onMouseEnter = W, J.onMouseLeave = G), U && (J.onClick = (ee) => {
    V && V(ee), l.canCloseOnClick && Z();
  }), { playToast: G, pauseToast: W, isRunning: r, preventExitTransition: a, toastRef: o, eventHandlers: J };
}
function L(t) {
  let { closeToast: r, theme: n, ariaLabel: a = "close" } = t;
  return React__default.createElement("button", { className: `Toastify__close-button Toastify__close-button--${n}`, type: "button", onClick: (s) => {
    s.stopPropagation(), r(s);
  }, "aria-label": a }, React__default.createElement("svg", { "aria-hidden": "true", viewBox: "0 0 14 16" }, React__default.createElement("path", { fillRule: "evenodd", d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z" })));
}
function O(t) {
  let { delay: r, isRunning: n, closeToast: a, type: s = "default", hide: o, className: l, style: c, controlledProgress: x, progress: j, rtl: Z, isIn: V, theme: U } = t;
  const $ = o || x && j === 0, Y = { ...c, animationDuration: `${r}ms`, animationPlayState: n ? "running" : "paused", opacity: $ ? 0 : 1 };
  x && (Y.transform = `scaleX(${j})`);
  const G = clsx("Toastify__progress-bar", x ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${U}`, `Toastify__progress-bar--${s}`, { "Toastify__progress-bar--rtl": Z }), W = p(l) ? l({ rtl: Z, type: s, defaultClassName: G }) : clsx(G, l);
  return React__default.createElement("div", { role: "progressbar", "aria-hidden": $ ? "true" : "false", "aria-label": "notification timer", className: W, style: Y, [x && j >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: x && j < 1 ? null : () => {
    V && a();
  } });
}
const N = (t) => {
  const { isRunning: r, preventExitTransition: n, toastRef: a, eventHandlers: s } = _(t), { closeButton: o, children: l, autoClose: c, onClick: x, type: j, hideProgressBar: Z, closeToast: V, transition: U, position: $, className: Y, style: G, bodyClassName: W, bodyStyle: X, progressClassName: K, progressStyle: J, updateId: ee, role: te, progress: ne, rtl: re, toastId: ie, deleteToast: ue, isIn: le, isLoading: oe, iconOut: he, closeOnClick: fe, theme: ce } = t, se = clsx("Toastify__toast", `Toastify__toast-theme--${ce}`, `Toastify__toast--${j}`, { "Toastify__toast--rtl": re }, { "Toastify__toast--close-on-click": fe }), pe = p(Y) ? Y({ rtl: re, position: $, type: j, defaultClassName: se }) : clsx(se, Y), ve = !!ne || !c, ae = { closeToast: V, type: j, theme: ce };
  let me = null;
  return o === !1 || (me = p(o) ? o(ae) : isValidElement(o) ? cloneElement(o, ae) : L(ae)), React__default.createElement(U, { isIn: le, done: ue, position: $, preventExitTransition: n, nodeRef: a }, React__default.createElement("div", { id: ie, onClick: x, className: pe, ...s, style: G, ref: a }, React__default.createElement("div", { ...le && { role: te }, className: p(W) ? W({ type: j }) : clsx("Toastify__toast-body", W), style: X }, he != null && React__default.createElement("div", { className: clsx("Toastify__toast-icon", { "Toastify--animate-icon Toastify__zoom-enter": !oe }) }, he), React__default.createElement("div", null, l)), me, React__default.createElement(O, { ...ee && !ve ? { key: `pb-${ee}` } : {}, rtl: re, theme: ce, delay: c, isRunning: r, isIn: le, closeToast: V, hide: Z, type: j, style: J, className: K, controlledProgress: ve, progress: ne || 0 })));
}, M = function(t, r) {
  return r === void 0 && (r = !1), { enter: `Toastify--animate Toastify__${t}-enter`, exit: `Toastify--animate Toastify__${t}-exit`, appendPosition: r };
}, R = h(M("bounce", !0)), w = h(M("slide", !0));
h(M("zoom"));
h(M("flip"));
const k = forwardRef((t, r) => {
  const { getToastToRender: n, containerRef: a, isToastActive: s } = C(t), { className: o, style: l, rtl: c, containerId: x } = t;
  function j(Z) {
    const V = clsx("Toastify__toast-container", `Toastify__toast-container--${Z}`, { "Toastify__toast-container--rtl": c });
    return p(o) ? o({ position: Z, rtl: c, defaultClassName: V }) : clsx(V, m(o));
  }
  return useEffect(() => {
    r && (r.current = a.current);
  }, []), React__default.createElement("div", { ref: a, className: "Toastify", id: x }, n((Z, V) => {
    const U = V.length ? { ...l } : { ...l, pointerEvents: "none" };
    return React__default.createElement("div", { className: j(Z), style: U, key: `container-${Z}` }, V.map(($, Y) => {
      let { content: G, props: W } = $;
      return React__default.createElement(N, { ...W, isIn: s(W.toastId), style: { ...W.style, "--nth": Y + 1, "--len": V.length }, key: `toast-${W.key}` }, G);
    }));
  }));
});
k.displayName = "ToastContainer", k.defaultProps = { position: "top-right", transition: R, autoClose: 5e3, closeButton: L, pauseOnHover: !0, pauseOnFocusLoss: !0, closeOnClick: !0, draggable: !0, draggablePercent: 80, draggableDirection: "x", role: "alert", theme: "light" };
let P, B = /* @__PURE__ */ new Map(), D = [], A = 1;
function z() {
  return "" + A++;
}
function F(t) {
  return t && (d(t.toastId) || u(t.toastId)) ? t.toastId : z();
}
function H(t, r) {
  return B.size > 0 ? v.emit(0, t, r) : D.push({ content: t, options: r }), r.toastId;
}
function S(t, r) {
  return { ...r, type: r && r.type || t, toastId: F(r) };
}
function q(t) {
  return (r, n) => H(r, S(t, n));
}
function Q(t, r) {
  return H(t, S("default", r));
}
Q.loading = (t, r) => H(t, S("default", { isLoading: !0, autoClose: !1, closeOnClick: !1, closeButton: !1, draggable: !1, ...r })), Q.promise = function(t, r, n) {
  let a, { pending: s, error: o, success: l } = r;
  s && (a = d(s) ? Q.loading(s, n) : Q.loading(s.render, { ...n, ...s }));
  const c = { isLoading: null, autoClose: null, closeOnClick: null, closeButton: null, draggable: null }, x = (Z, V, U) => {
    if (V == null) return void Q.dismiss(a);
    const $ = { type: Z, ...c, ...n, data: U }, Y = d(V) ? { render: V } : V;
    return a ? Q.update(a, { ...$, ...Y }) : Q(Y.render, { ...$, ...Y }), U;
  }, j = p(t) ? t() : t;
  return j.then((Z) => x("success", l, Z)).catch((Z) => x("error", o, Z)), j;
}, Q.success = q("success"), Q.info = q("info"), Q.error = q("error"), Q.warning = q("warning"), Q.warn = Q.warning, Q.dark = (t, r) => H(t, S("default", { theme: "dark", ...r })), Q.dismiss = (t) => {
  B.size > 0 ? v.emit(1, t) : D = D.filter((r) => t != null && r.options.toastId !== t);
}, Q.clearWaitingQueue = function(t) {
  return t === void 0 && (t = {}), v.emit(5, t);
}, Q.isActive = (t) => {
  let r = !1;
  return B.forEach((n) => {
    n.isToastActive && n.isToastActive(t) && (r = !0);
  }), r;
}, Q.update = function(t, r) {
  r === void 0 && (r = {}), setTimeout(() => {
    const n = (function(a, s) {
      let { containerId: o } = s;
      const l = B.get(o || P);
      return l && l.getToast(a);
    })(t, r);
    if (n) {
      const { props: a, content: s } = n, o = { delay: 100, ...a, ...r, toastId: r.toastId || t, updateId: z() };
      o.toastId !== t && (o.staleId = t);
      const l = o.render || s;
      delete o.render, H(l, o);
    }
  }, 0);
}, Q.done = (t) => {
  Q.update(t, { progress: 1 });
}, Q.onChange = (t) => (v.on(4, t), () => {
  v.off(4, t);
}), Q.POSITION = { TOP_LEFT: "top-left", TOP_RIGHT: "top-right", TOP_CENTER: "top-center", BOTTOM_LEFT: "bottom-left", BOTTOM_RIGHT: "bottom-right", BOTTOM_CENTER: "bottom-center" }, Q.TYPE = { INFO: "info", SUCCESS: "success", WARNING: "warning", ERROR: "error", DEFAULT: "default" }, v.on(2, (t) => {
  P = t.containerId || t, B.set(P, t), D.forEach((r) => {
    v.emit(0, r.content, r.options);
  }), D = [];
}).on(3, (t) => {
  B.delete(t.containerId || t), B.size === 0 && v.off(0).off(1).off(5);
});
function CloseButton({ closeToast: t }) {
  return /* @__PURE__ */ jsx("button", { className: "go-notification-close", type: "button", onClick: (r) => t(r), children: /* @__PURE__ */ jsx(CloseMiniLine, { style: { fontSize: 24, color: "#fff" } }) });
}
function getIcon(t) {
  switch (t) {
    case "error":
      return /* @__PURE__ */ jsx(AttantionMiniCustom, { style: { color: "#fff", fontSize: 24 } });
    case "success":
      return /* @__PURE__ */ jsx(CheckRoundFill, { style: { color: "#fff", fontSize: 24 } });
    case "warning":
      return /* @__PURE__ */ jsx(QuestionFill, { style: { color: "#fff", fontSize: 24 } });
    default:
      return /* @__PURE__ */ jsx(InfoRoundFill, { style: { color: "#fff", fontSize: 24 } });
  }
}
function NotificationContent({ title: t, text: r }) {
  return /* @__PURE__ */ jsxs("div", { className: "go-notification-content__wrapper", children: [
    t && /* @__PURE__ */ jsx("div", { className: "go-notification-content__title", children: t }),
    r && /* @__PURE__ */ jsx("div", { className: "go-notification-content__text", children: r })
  ] });
}
function createNotification({
  title: t,
  text: r,
  progressStyle: n,
  delay: a,
  isLoading: s,
  style: o,
  bodyStyle: l,
  type: c,
  draggablePercent: x,
  draggableDirection: j,
  transition: Z = w,
  position: V = "top-right",
  autoClose: U = 5e3,
  closeOnClick: $ = !1,
  closeButton: Y = !0,
  icon: G = !0,
  draggable: W = !1,
  progress: X = void 0,
  pauseOnHover: K = !0,
  theme: J = "dark",
  hideProgressBar: ee = !0,
  onClose: te,
  onOpen: ne
}) {
  const re = typeof G != "boolean";
  return Q(/* @__PURE__ */ jsx(NotificationContent, { text: r, title: t }), {
    type: c,
    position: V,
    autoClose: U,
    closeOnClick: $,
    className: clsx(`go-notification-${c}`, "go-notification"),
    bodyClassName: "go-notification-body",
    closeButton: Y && ((ie) => /* @__PURE__ */ jsx(CloseButton, { closeToast: ie.closeToast })),
    icon: G && re ? G : getIcon(c != null ? c : "default"),
    draggable: W,
    progress: X,
    hideProgressBar: ee,
    pauseOnHover: K,
    theme: J,
    delay: a,
    isLoading: s,
    style: o,
    bodyStyle: l,
    progressStyle: n,
    transition: Z,
    draggablePercent: x,
    draggableDirection: j,
    onClose: te,
    onOpen: ne
  });
}
const Radio = forwardRef(
  ({
    checked: t = !1,
    value: r,
    name: n,
    id: a,
    className: s,
    style: o,
    size: l,
    disabled: c,
    children: x,
    onChange: j
  }, Z) => {
    const { size: V } = useGlobalComponentConfig({ size: l }), U = useId$3(), $ = a || `go-radio-${U}`, [Y, G] = useState$1(t);
    useEffect(() => {
      G(t);
    }, [t]);
    const W = (X) => {
      const K = X.currentTarget.checked, J = X.currentTarget.value;
      G(K), j == null || j(J, K, X);
    };
    return /* @__PURE__ */ jsxs(
      "div",
      {
        className: clsx(s, "go-radio", c && "go-radio_disabled", V === "s" && "go-radio_size_s"),
        style: o,
        children: [
          !!x && /* @__PURE__ */ jsx("label", { htmlFor: $, className: "go-radio__label", children: x }),
          /* @__PURE__ */ jsxs("div", { className: "go-radio__button", children: [
            /* @__PURE__ */ jsx(
              "input",
              {
                ref: Z,
                id: $,
                type: "radio",
                name: n,
                value: r,
                checked: Y,
                disabled: c,
                onChange: W,
                className: "go-radio__input"
              }
            ),
            /* @__PURE__ */ jsx("label", { htmlFor: $, className: "go-radio__button-inner" })
          ] })
        ]
      }
    );
  }
);
Radio.displayName = "Radio";
const RadioGroup = ({
  value: t,
  name: r,
  items: n,
  itemClassName: a,
  onChange: s,
  style: o,
  className: l
}) => {
  const [c, x] = useState$1(t);
  useEffect(() => {
    x(t);
  }, [t]);
  const j = useCallback(
    (Z) => {
      x(Z), s == null || s(Z);
    },
    [s]
  );
  return /* @__PURE__ */ jsx("div", { style: o, className: clsx("go-radio-group", l), children: n.map((Z) => /* @__PURE__ */ jsx(
    Radio,
    {
      checked: Z.value === c,
      value: Z.value,
      onChange: j,
      className: a,
      disabled: Z.disabled,
      name: r,
      id: Z.id,
      ref: Z.ref,
      style: Z.style,
      children: Z.label
    },
    Z.value
  )) });
};
function RadioButton({
  value: t,
  name: r,
  id: n,
  checked: a,
  disabled: s,
  style: o,
  className: l,
  children: c,
  onChange: x
}) {
  return /* @__PURE__ */ jsxs("div", { className: clsx(l, "go-radio-button-group__item"), style: o, children: [
    /* @__PURE__ */ jsx(
      "input",
      {
        type: "radio",
        name: r,
        id: n,
        value: t,
        checked: a,
        disabled: s,
        onChange: x,
        className: "go-radio-button-group__item-input"
      }
    ),
    /* @__PURE__ */ jsx("label", { htmlFor: n, className: "go-radio-button-group__item-label", children: c })
  ] });
}
const sizeClassNames$2 = {
  s: "go-radio-button-group_size_s",
  m: "go-radio-button-group_size_m",
  l: "go-radio-button-group_size_l"
}, variantClassNames = {
  default: "go-radio-button-group_variant_default",
  flat: "go-radio-button-group_variant_flat"
};
function RadioButtonGroup({
  value: t,
  name: r,
  items: n,
  className: a,
  itemClassName: s,
  size: o,
  style: l,
  variant: c = "default",
  onChange: x
}) {
  const { size: j } = useGlobalComponentConfig({ size: o }), Z = useId$3(), V = r || `go-rbg-${Z}`, [U, $] = useState$1(t);
  useEffect(() => {
    $(t);
  }, [t]);
  const Y = useCallback(
    (G) => {
      $(G), x == null || x(G);
    },
    [x]
  );
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: clsx(
        a,
        "go-radio-button-group",
        sizeClassNames$2[o || j],
        variantClassNames[c]
      ),
      style: l,
      children: n.map((G) => {
        var W;
        return /* @__PURE__ */ jsx(
          RadioButton,
          {
            id: `${V}-${G.value}`,
            name: V,
            value: G.value,
            checked: G.value === U,
            disabled: G.disabled,
            onChange: () => Y(G.value),
            className: clsx(s, G.className),
            style: G.style,
            children: G.label
          },
          (W = G.value) == null ? void 0 : W.toString()
        );
      })
    }
  );
}
function isEqual(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, a = /* @__PURE__ */ new Set();
  function s(o, l) {
    var c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, x = a.has(o);
    if (warningOnce(!x, "Warning: There may be circular references"), x)
      return !1;
    if (o === l)
      return !0;
    if (n && c > 1)
      return !1;
    a.add(o);
    var j = c + 1;
    if (Array.isArray(o)) {
      if (!Array.isArray(l) || o.length !== l.length)
        return !1;
      for (var Z = 0; Z < o.length; Z++)
        if (!s(o[Z], l[Z], j))
          return !1;
      return !0;
    }
    if (o && l && _typeof$1(o) === "object" && _typeof$1(l) === "object") {
      var V = Object.keys(o);
      return V.length !== Object.keys(l).length ? !1 : V.every(function(U) {
        return s(o[U], l[U], j);
      });
    }
    return !1;
  }
  return s(t, r);
}
function getOffset(t, r, n) {
  return (t - r) / (n - r);
}
function getDirectionStyle(t, r, n, a) {
  var s = getOffset(r, n, a), o = {};
  switch (t) {
    case "rtl":
      o.right = "".concat(s * 100, "%"), o.transform = "translateX(50%)";
      break;
    case "btt":
      o.bottom = "".concat(s * 100, "%"), o.transform = "translateY(50%)";
      break;
    case "ttb":
      o.top = "".concat(s * 100, "%"), o.transform = "translateY(-50%)";
      break;
    default:
      o.left = "".concat(s * 100, "%"), o.transform = "translateX(-50%)";
      break;
  }
  return o;
}
function getIndex(t, r) {
  return Array.isArray(t) ? t[r] : t;
}
var SliderContext = /* @__PURE__ */ React.createContext({
  min: 0,
  max: 0,
  direction: "ltr",
  step: 1,
  includedStart: 0,
  includedEnd: 0,
  tabIndex: 0,
  keyboard: !0,
  styles: {},
  classNames: {}
}), _excluded$1 = ["prefixCls", "value", "valueIndex", "onStartMove", "style", "render", "dragging", "onOffsetChange", "onChangeComplete", "onFocus", "onMouseEnter"], Handle = /* @__PURE__ */ React.forwardRef(function(t, r) {
  var n = t.prefixCls, a = t.value, s = t.valueIndex, o = t.onStartMove, l = t.style, c = t.render, x = t.dragging, j = t.onOffsetChange, Z = t.onChangeComplete, V = t.onFocus, U = t.onMouseEnter, $ = _objectWithoutProperties(t, _excluded$1), Y = React.useContext(SliderContext), G = Y.min, W = Y.max, X = Y.direction, K = Y.disabled, J = Y.keyboard, ee = Y.range, te = Y.tabIndex, ne = Y.ariaLabelForHandle, re = Y.ariaLabelledByForHandle, ie = Y.ariaValueTextFormatterForHandle, ue = Y.styles, le = Y.classNames, oe = "".concat(n, "-handle"), he = function(Se) {
    K || o(Se, s);
  }, fe = function(Se) {
    V == null || V(Se, s);
  }, ce = function(Se) {
    U(Se, s);
  }, se = function(Se) {
    if (!K && J) {
      var xe = null;
      switch (Se.which || Se.keyCode) {
        case KeyCode.LEFT:
          xe = X === "ltr" || X === "btt" ? -1 : 1;
          break;
        case KeyCode.RIGHT:
          xe = X === "ltr" || X === "btt" ? 1 : -1;
          break;
        // Up is plus
        case KeyCode.UP:
          xe = X !== "ttb" ? 1 : -1;
          break;
        // Down is minus
        case KeyCode.DOWN:
          xe = X !== "ttb" ? -1 : 1;
          break;
        case KeyCode.HOME:
          xe = "min";
          break;
        case KeyCode.END:
          xe = "max";
          break;
        case KeyCode.PAGE_UP:
          xe = 2;
          break;
        case KeyCode.PAGE_DOWN:
          xe = -2;
          break;
      }
      xe !== null && (Se.preventDefault(), j(xe, s));
    }
  }, pe = function(Se) {
    switch (Se.which || Se.keyCode) {
      case KeyCode.LEFT:
      case KeyCode.RIGHT:
      case KeyCode.UP:
      case KeyCode.DOWN:
      case KeyCode.HOME:
      case KeyCode.END:
      case KeyCode.PAGE_UP:
      case KeyCode.PAGE_DOWN:
        Z == null || Z();
        break;
    }
  }, ve = getDirectionStyle(X, a, G, W), ae = {};
  if (s !== null) {
    var me;
    ae = {
      tabIndex: K ? null : getIndex(te, s),
      role: "slider",
      "aria-valuemin": G,
      "aria-valuemax": W,
      "aria-valuenow": a,
      "aria-disabled": K,
      "aria-label": getIndex(ne, s),
      "aria-labelledby": getIndex(re, s),
      "aria-valuetext": (me = getIndex(ie, s)) === null || me === void 0 ? void 0 : me(a),
      "aria-orientation": X === "ltr" || X === "rtl" ? "horizontal" : "vertical",
      onMouseDown: he,
      onTouchStart: he,
      onFocus: fe,
      onMouseEnter: ce,
      onKeyDown: se,
      onKeyUp: pe
    };
  }
  var de = /* @__PURE__ */ React.createElement("div", _extends({
    ref: r,
    className: cls(oe, _defineProperty(_defineProperty({}, "".concat(oe, "-").concat(s + 1), s !== null && ee), "".concat(oe, "-dragging"), x), le.handle),
    style: _objectSpread2(_objectSpread2(_objectSpread2({}, ve), l), ue.handle)
  }, ae, $));
  return c && (de = c(de, {
    index: s,
    prefixCls: n,
    value: a,
    dragging: x
  })), de;
});
process.env.NODE_ENV !== "production" && (Handle.displayName = "Handle");
var _excluded = ["prefixCls", "style", "onStartMove", "onOffsetChange", "values", "handleRender", "activeHandleRender", "draggingIndex", "onFocus"], Handles = /* @__PURE__ */ React.forwardRef(function(t, r) {
  var n = t.prefixCls, a = t.style, s = t.onStartMove, o = t.onOffsetChange, l = t.values, c = t.handleRender, x = t.activeHandleRender, j = t.draggingIndex, Z = t.onFocus, V = _objectWithoutProperties(t, _excluded), U = React.useRef({});
  React.useImperativeHandle(r, function() {
    return {
      focus: function(te) {
        var ne;
        (ne = U.current[te]) === null || ne === void 0 || ne.focus();
      }
    };
  });
  var $ = React.useState(-1), Y = _slicedToArray($, 2), G = Y[0], W = Y[1], X = function(te, ne) {
    W(ne), Z == null || Z(te);
  }, K = function(te, ne) {
    W(ne);
  }, J = _objectSpread2({
    prefixCls: n,
    onStartMove: s,
    onOffsetChange: o,
    render: c,
    onFocus: X,
    onMouseEnter: K
  }, V);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, l.map(function(ee, te) {
    return /* @__PURE__ */ React.createElement(Handle, _extends({
      ref: function(re) {
        re ? U.current[te] = re : delete U.current[te];
      },
      dragging: j === te,
      style: getIndex(a, te),
      key: te,
      value: ee,
      valueIndex: te
    }, J));
  }), x && /* @__PURE__ */ React.createElement(Handle, _extends({
    key: "a11y"
  }, J, {
    value: l[G],
    valueIndex: null,
    dragging: j !== -1,
    render: x,
    style: {
      pointerEvents: "none"
    },
    tabIndex: null,
    "aria-hidden": !0
  })));
});
process.env.NODE_ENV !== "production" && (Handles.displayName = "Handles");
var Mark = function t(r) {
  var n = r.prefixCls, a = r.style, s = r.children, o = r.value, l = r.onClick, c = React.useContext(SliderContext), x = c.min, j = c.max, Z = c.direction, V = c.includedStart, U = c.includedEnd, $ = c.included, Y = "".concat(n, "-text"), G = getDirectionStyle(Z, o, x, j);
  return /* @__PURE__ */ React.createElement("span", {
    className: cls(Y, _defineProperty({}, "".concat(Y, "-active"), $ && V <= o && o <= U)),
    style: _objectSpread2(_objectSpread2({}, G), a),
    onMouseDown: function(X) {
      X.stopPropagation();
    },
    onClick: function() {
      l(o);
    }
  }, s);
}, Marks = function t(r) {
  var n = r.prefixCls, a = r.marks, s = r.onClick, o = "".concat(n, "-mark");
  return a.length ? /* @__PURE__ */ React.createElement("div", {
    className: o
  }, a.map(function(l) {
    var c = l.value, x = l.style, j = l.label;
    return /* @__PURE__ */ React.createElement(Mark, {
      key: c,
      prefixCls: o,
      style: x,
      value: c,
      onClick: s
    }, j);
  })) : null;
}, Dot = function t(r) {
  var n = r.prefixCls, a = r.value, s = r.style, o = r.activeStyle, l = React.useContext(SliderContext), c = l.min, x = l.max, j = l.direction, Z = l.included, V = l.includedStart, U = l.includedEnd, $ = "".concat(n, "-dot"), Y = Z && V <= a && a <= U, G = _objectSpread2(_objectSpread2({}, getDirectionStyle(j, a, c, x)), typeof s == "function" ? s(a) : s);
  return Y && (G = _objectSpread2(_objectSpread2({}, G), typeof o == "function" ? o(a) : o)), /* @__PURE__ */ React.createElement("span", {
    className: cls($, _defineProperty({}, "".concat($, "-active"), Y)),
    style: G
  });
}, Steps = function t(r) {
  var n = r.prefixCls, a = r.marks, s = r.dots, o = r.style, l = r.activeStyle, c = React.useContext(SliderContext), x = c.min, j = c.max, Z = c.step, V = React.useMemo(function() {
    var U = /* @__PURE__ */ new Set();
    if (a.forEach(function(Y) {
      U.add(Y.value);
    }), s && Z !== null)
      for (var $ = x; $ <= j; )
        U.add($), $ += Z;
    return Array.from(U);
  }, [x, j, Z, s, a]);
  return /* @__PURE__ */ React.createElement("div", {
    className: "".concat(n, "-step")
  }, V.map(function(U) {
    return /* @__PURE__ */ React.createElement(Dot, {
      prefixCls: n,
      key: U,
      value: U,
      style: o,
      activeStyle: l
    });
  }));
}, Track = function t(r) {
  var n = r.prefixCls, a = r.style, s = r.start, o = r.end, l = r.index, c = r.onStartMove, x = r.replaceCls, j = React.useContext(SliderContext), Z = j.direction, V = j.min, U = j.max, $ = j.disabled, Y = j.range, G = j.classNames, W = "".concat(n, "-track"), X = getOffset(s, V, U), K = getOffset(o, V, U), J = function(re) {
    !$ && c && c(re, -1);
  }, ee = {};
  switch (Z) {
    case "rtl":
      ee.right = "".concat(X * 100, "%"), ee.width = "".concat(K * 100 - X * 100, "%");
      break;
    case "btt":
      ee.bottom = "".concat(X * 100, "%"), ee.height = "".concat(K * 100 - X * 100, "%");
      break;
    case "ttb":
      ee.top = "".concat(X * 100, "%"), ee.height = "".concat(K * 100 - X * 100, "%");
      break;
    default:
      ee.left = "".concat(X * 100, "%"), ee.width = "".concat(K * 100 - X * 100, "%");
  }
  var te = x || cls(W, _defineProperty(_defineProperty({}, "".concat(W, "-").concat(l + 1), l !== null && Y), "".concat(n, "-track-draggable"), c), G.track);
  return /* @__PURE__ */ React.createElement("div", {
    className: te,
    style: _objectSpread2(_objectSpread2({}, ee), a),
    onMouseDown: J,
    onTouchStart: J
  });
}, Tracks = function t(r) {
  var n = r.prefixCls, a = r.style, s = r.values, o = r.startPoint, l = r.onStartMove, c = React.useContext(SliderContext), x = c.included, j = c.range, Z = c.min, V = c.styles, U = c.classNames, $ = React.useMemo(function() {
    if (!j) {
      if (s.length === 0)
        return [];
      var G = o != null ? o : Z, W = s[0];
      return [{
        start: Math.min(G, W),
        end: Math.max(G, W)
      }];
    }
    for (var X = [], K = 0; K < s.length - 1; K += 1)
      X.push({
        start: s[K],
        end: s[K + 1]
      });
    return X;
  }, [s, j, o, Z]);
  if (!x)
    return null;
  var Y = U.tracks || V.tracks ? /* @__PURE__ */ React.createElement(Track, {
    index: null,
    prefixCls: n,
    start: $[0].start,
    end: $[$.length - 1].end,
    replaceCls: cls(U.tracks, "".concat(n, "-tracks")),
    style: V.tracks
  }) : null;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, Y, $.map(function(G, W) {
    var X = G.start, K = G.end;
    return /* @__PURE__ */ React.createElement(Track, {
      index: W,
      prefixCls: n,
      style: _objectSpread2(_objectSpread2({}, getIndex(a, W)), V.track),
      start: X,
      end: K,
      key: W,
      onStartMove: l
    });
  }));
};
function getPosition(t) {
  var r = "touches" in t ? t.touches[0] : t;
  return {
    pageX: r.pageX,
    pageY: r.pageY
  };
}
function useDrag(t, r, n, a, s, o, l, c, x) {
  var j = React.useState(null), Z = _slicedToArray(j, 2), V = Z[0], U = Z[1], $ = React.useState(-1), Y = _slicedToArray($, 2), G = Y[0], W = Y[1], X = React.useState(n), K = _slicedToArray(X, 2), J = K[0], ee = K[1], te = React.useState(n), ne = _slicedToArray(te, 2), re = ne[0], ie = ne[1], ue = React.useRef(null), le = React.useRef(null);
  React.useLayoutEffect(function() {
    G === -1 && ee(n);
  }, [n, G]), React.useEffect(function() {
    return function() {
      document.removeEventListener("mousemove", ue.current), document.removeEventListener("mouseup", le.current), document.removeEventListener("touchmove", ue.current), document.removeEventListener("touchend", le.current);
    };
  }, []);
  var oe = function(pe, ve) {
    J.some(function(ae, me) {
      return ae !== pe[me];
    }) && (ve !== void 0 && U(ve), ee(pe), l(pe));
  }, he = useEvent$1(function(se, pe) {
    if (se === -1) {
      var ve = re[0], ae = re[re.length - 1], me = a - ve, de = s - ae, ge = pe * (s - a);
      ge = Math.max(ge, me), ge = Math.min(ge, de);
      var Se = o(ve + ge);
      ge = Se - ve;
      var xe = re.map(function(Re) {
        return Re + ge;
      });
      oe(xe);
    } else {
      var Ee = (s - a) * pe, Ce = _toConsumableArray(J);
      Ce[se] = re[se];
      var ke = x(Ce, Ee, se, "dist");
      oe(ke.values, ke.value);
    }
  }), fe = function(pe, ve, ae) {
    pe.stopPropagation();
    var me = ae || n, de = me[ve];
    W(ve), U(de), ie(me);
    var ge = getPosition(pe), Se = ge.pageX, xe = ge.pageY, Ee = function(Re) {
      Re.preventDefault();
      var _e = getPosition(Re), Me = _e.pageX, we = _e.pageY, Te = Me - Se, be = we - xe, Pe = t.current.getBoundingClientRect(), ye = Pe.width, Ae = Pe.height, Fe;
      switch (r) {
        case "btt":
          Fe = -be / Ae;
          break;
        case "ttb":
          Fe = be / Ae;
          break;
        case "rtl":
          Fe = -Te / ye;
          break;
        default:
          Fe = Te / ye;
      }
      he(ve, Fe);
    }, Ce = function ke(Re) {
      Re.preventDefault(), document.removeEventListener("mouseup", ke), document.removeEventListener("mousemove", Ee), document.removeEventListener("touchend", ke), document.removeEventListener("touchmove", Ee), ue.current = null, le.current = null, W(-1), c();
    };
    document.addEventListener("mouseup", Ce), document.addEventListener("mousemove", Ee), document.addEventListener("touchend", Ce), document.addEventListener("touchmove", Ee), ue.current = Ee, le.current = Ce;
  }, ce = React.useMemo(function() {
    var se = _toConsumableArray(n).sort(function(ve, ae) {
      return ve - ae;
    }), pe = _toConsumableArray(J).sort(function(ve, ae) {
      return ve - ae;
    });
    return se.every(function(ve, ae) {
      return ve === pe[ae];
    }) ? J : n;
  }, [n, J]);
  return [G, V, ce, fe];
}
function useOffset(t, r, n, a, s, o) {
  var l = React.useCallback(function($) {
    return Math.max(t, Math.min(r, $));
  }, [t, r]), c = React.useCallback(function($) {
    if (n !== null) {
      var Y = t + Math.round((l($) - t) / n) * n, G = function(J) {
        return (String(J).split(".")[1] || "").length;
      }, W = Math.max(G(n), G(r), G(t)), X = Number(Y.toFixed(W));
      return t <= X && X <= r ? X : null;
    }
    return null;
  }, [n, t, r, l]), x = React.useCallback(function($) {
    var Y = l($), G = a.map(function(K) {
      return K.value;
    });
    n !== null && G.push(c($)), G.push(t, r);
    var W = G[0], X = r - t;
    return G.forEach(function(K) {
      var J = Math.abs(Y - K);
      J <= X && (W = K, X = J);
    }), W;
  }, [t, r, a, n, l, c]), j = function $(Y, G, W) {
    var X = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unit";
    if (typeof G == "number") {
      var K, J = Y[W], ee = J + G, te = [];
      a.forEach(function(le) {
        te.push(le.value);
      }), te.push(t, r), te.push(c(J));
      var ne = G > 0 ? 1 : -1;
      X === "unit" ? te.push(c(J + ne * n)) : te.push(c(ee)), te = te.filter(function(le) {
        return le !== null;
      }).filter(function(le) {
        return G < 0 ? le <= J : le >= J;
      }), X === "unit" && (te = te.filter(function(le) {
        return le !== J;
      }));
      var re = X === "unit" ? J : ee;
      K = te[0];
      var ie = Math.abs(K - re);
      if (te.forEach(function(le) {
        var oe = Math.abs(le - re);
        oe < ie && (K = le, ie = oe);
      }), K === void 0)
        return G < 0 ? t : r;
      if (X === "dist")
        return K;
      if (Math.abs(G) > 1) {
        var ue = _toConsumableArray(Y);
        return ue[W] = K, $(ue, G - ne, W, X);
      }
      return K;
    } else {
      if (G === "min")
        return t;
      if (G === "max")
        return r;
    }
  }, Z = function(Y, G, W) {
    var X = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unit", K = Y[W], J = j(Y, G, W, X);
    return {
      value: J,
      changed: J !== K
    };
  }, V = function(Y) {
    return o === null && Y === 0 || typeof o == "number" && Y < o;
  }, U = function(Y, G, W) {
    var X = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unit", K = Y.map(x), J = K[W], ee = j(K, G, W, X);
    if (K[W] = ee, s === !1) {
      var te = o || 0;
      W > 0 && K[W - 1] !== J && (K[W] = Math.max(K[W], K[W - 1] + te)), W < K.length - 1 && K[W + 1] !== J && (K[W] = Math.min(K[W], K[W + 1] - te));
    } else if (typeof o == "number" || o === null) {
      for (var ne = W + 1; ne < K.length; ne += 1)
        for (var re = !0; V(K[ne] - K[ne - 1]) && re; ) {
          var ie = Z(K, 1, ne);
          K[ne] = ie.value, re = ie.changed;
        }
      for (var ue = W; ue > 0; ue -= 1)
        for (var le = !0; V(K[ue] - K[ue - 1]) && le; ) {
          var oe = Z(K, -1, ue - 1);
          K[ue - 1] = oe.value, le = oe.changed;
        }
      for (var he = K.length - 1; he > 0; he -= 1)
        for (var fe = !0; V(K[he] - K[he - 1]) && fe; ) {
          var ce = Z(K, -1, he - 1);
          K[he - 1] = ce.value, fe = ce.changed;
        }
      for (var se = 0; se < K.length - 1; se += 1)
        for (var pe = !0; V(K[se + 1] - K[se]) && pe; ) {
          var ve = Z(K, 1, se + 1);
          K[se + 1] = ve.value, pe = ve.changed;
        }
    }
    return {
      value: K[W],
      values: K
    };
  };
  return [x, U];
}
var Slider$1 = /* @__PURE__ */ React.forwardRef(function(t, r) {
  var n = t.prefixCls, a = n === void 0 ? "rc-slider" : n, s = t.className, o = t.style, l = t.classNames, c = t.styles, x = t.disabled, j = x === void 0 ? !1 : x, Z = t.keyboard, V = Z === void 0 ? !0 : Z, U = t.autoFocus, $ = t.onFocus, Y = t.onBlur, G = t.min, W = G === void 0 ? 0 : G, X = t.max, K = X === void 0 ? 100 : X, J = t.step, ee = J === void 0 ? 1 : J, te = t.value, ne = t.defaultValue, re = t.range, ie = t.count, ue = t.onChange, le = t.onBeforeChange, oe = t.onAfterChange, he = t.onChangeComplete, fe = t.allowCross, ce = fe === void 0 ? !0 : fe, se = t.pushable, pe = se === void 0 ? !1 : se, ve = t.draggableTrack, ae = t.reverse, me = t.vertical, de = t.included, ge = de === void 0 ? !0 : de, Se = t.startPoint, xe = t.trackStyle, Ee = t.handleStyle, Ce = t.railStyle, ke = t.dotStyle, Re = t.activeDotStyle, _e = t.marks, Me = t.dots, we = t.handleRender, Te = t.activeHandleRender, be = t.tabIndex, Pe = be === void 0 ? 0 : be, ye = t.ariaLabelForHandle, Ae = t.ariaLabelledByForHandle, Fe = t.ariaValueTextFormatterForHandle, Ie = React.useRef(null), Le = React.useRef(null), De = React.useMemo(function() {
    return me ? ae ? "ttb" : "btt" : ae ? "rtl" : "ltr";
  }, [ae, me]), je = React.useMemo(function() {
    return isFinite(W) ? W : 0;
  }, [W]), Ze = React.useMemo(function() {
    return isFinite(K) ? K : 100;
  }, [K]), $e = React.useMemo(function() {
    return ee !== null && ee <= 0 ? 1 : ee;
  }, [ee]), Oe = React.useMemo(function() {
    return typeof pe == "boolean" ? pe ? $e : !1 : pe >= 0 ? pe : !1;
  }, [pe, $e]), Be = React.useMemo(function() {
    return Object.keys(_e || {}).map(function(Ke) {
      var Ye = _e[Ke], ot = {
        value: Number(Ke)
      };
      return Ye && _typeof$1(Ye) === "object" && !/* @__PURE__ */ React.isValidElement(Ye) && ("label" in Ye || "style" in Ye) ? (ot.style = Ye.style, ot.label = Ye.label) : ot.label = Ye, ot;
    }).filter(function(Ke) {
      var Ye = Ke.label;
      return Ye || typeof Ye == "number";
    }).sort(function(Ke, Ye) {
      return Ke.value - Ye.value;
    });
  }, [_e]), Qe = useOffset(je, Ze, $e, Be, ce, Oe), Xe = _slicedToArray(Qe, 2), rt = Xe[0], lt = Xe[1], ct = useMergedState$2(ne, {
    value: te
  }), Je = _slicedToArray(ct, 2), st = Je[0], At = Je[1], bt = React.useMemo(function() {
    var Ke = st == null ? [] : Array.isArray(st) ? st : [st], Ye = _slicedToArray(Ke, 1), ot = Ye[0], yt = ot === void 0 ? je : ot, mt = st === null ? [] : [yt];
    if (re) {
      if (mt = _toConsumableArray(Ke), ie || st === void 0) {
        var Ct = ie >= 0 ? ie + 1 : 2;
        for (mt = mt.slice(0, Ct); mt.length < Ct; ) {
          var St;
          mt.push((St = mt[mt.length - 1]) !== null && St !== void 0 ? St : je);
        }
      }
      mt.sort(function(vt, He) {
        return vt - He;
      });
    }
    return mt.forEach(function(vt, He) {
      mt[He] = rt(vt);
    }), mt;
  }, [st, re, je, ie, rt]), gt = React.useRef(bt);
  gt.current = bt;
  var xt = function(Ye) {
    return re ? Ye : Ye[0];
  }, ht = function(Ye) {
    var ot = _toConsumableArray(Ye).sort(function(yt, mt) {
      return yt - mt;
    });
    ue && !isEqual(ot, gt.current, !0) && ue(xt(ot)), At(ot);
  }, jt = function() {
    var Ye = xt(gt.current);
    oe == null || oe(Ye), warningOnce(!oe, "[rc-slider] `onAfterChange` is deprecated. Please use `onChangeComplete` instead."), he == null || he(Ye);
  }, Rt = useDrag(Le, De, bt, je, Ze, rt, ht, jt, lt), Dt = _slicedToArray(Rt, 4), wt = Dt[0], Wt = Dt[1], Bt = Dt[2], It = Dt[3], pt = function(Ye, ot) {
    if (!j) {
      var yt = 0, mt = Ze - je;
      bt.forEach(function(He, We) {
        var tt = Math.abs(Ye - He);
        tt <= mt && (mt = tt, yt = We);
      });
      var Ct = _toConsumableArray(bt);
      if (Ct[yt] = Ye, re && !bt.length && ie === void 0 && Ct.push(Ye), le == null || le(xt(Ct)), ht(Ct), ot) {
        var St, vt;
        (St = document.activeElement) === null || St === void 0 || (vt = St.blur) === null || vt === void 0 || vt.call(St), Ie.current.focus(yt), It(ot, yt, Ct);
      }
    }
  }, et = function(Ye) {
    Ye.preventDefault();
    var ot = Le.current.getBoundingClientRect(), yt = ot.width, mt = ot.height, Ct = ot.left, St = ot.top, vt = ot.bottom, He = ot.right, We = Ye.clientX, tt = Ye.clientY, ft;
    switch (De) {
      case "btt":
        ft = (vt - tt) / mt;
        break;
      case "ttb":
        ft = (tt - St) / mt;
        break;
      case "rtl":
        ft = (He - We) / yt;
        break;
      default:
        ft = (We - Ct) / yt;
    }
    var _t = je + ft * (Ze - je);
    pt(rt(_t), Ye);
  }, Tt = React.useState(null), Et = _slicedToArray(Tt, 2), dt = Et[0], zt = Et[1], Lt = function(Ye, ot) {
    if (!j) {
      var yt = lt(bt, Ye, ot);
      le == null || le(xt(bt)), ht(yt.values), zt(yt.value);
    }
  };
  React.useEffect(function() {
    if (dt !== null) {
      var Ke = bt.indexOf(dt);
      Ke >= 0 && Ie.current.focus(Ke);
    }
    zt(null);
  }, [dt]);
  var Ge = React.useMemo(function() {
    return ve && $e === null ? (process.env.NODE_ENV !== "production" && warningOnce(!1, "`draggableTrack` is not supported when `step` is `null`."), !1) : ve;
  }, [ve, $e]), ze = function(Ye, ot) {
    It(Ye, ot), le == null || le(xt(gt.current));
  }, Ne = wt !== -1;
  React.useEffect(function() {
    if (!Ne) {
      var Ke = bt.lastIndexOf(Wt);
      Ie.current.focus(Ke);
    }
  }, [Ne]);
  var Ve = React.useMemo(function() {
    return _toConsumableArray(Bt).sort(function(Ke, Ye) {
      return Ke - Ye;
    });
  }, [Bt]), qe = React.useMemo(function() {
    return re ? [Ve[0], Ve[Ve.length - 1]] : [je, Ve[0]];
  }, [Ve, re, je]), nt = _slicedToArray(qe, 2), Pt = nt[0], Mt = nt[1];
  React.useImperativeHandle(r, function() {
    return {
      focus: function() {
        Ie.current.focus(0);
      },
      blur: function() {
        var Ye, ot = document, yt = ot.activeElement;
        (Ye = Le.current) !== null && Ye !== void 0 && Ye.contains(yt) && (yt == null || yt.blur());
      }
    };
  }), React.useEffect(function() {
    U && Ie.current.focus(0);
  }, []);
  var Ft = React.useMemo(function() {
    return {
      min: je,
      max: Ze,
      direction: De,
      disabled: j,
      keyboard: V,
      step: $e,
      included: ge,
      includedStart: Pt,
      includedEnd: Mt,
      range: re,
      tabIndex: Pe,
      ariaLabelForHandle: ye,
      ariaLabelledByForHandle: Ae,
      ariaValueTextFormatterForHandle: Fe,
      styles: c || {},
      classNames: l || {}
    };
  }, [je, Ze, De, j, V, $e, ge, Pt, Mt, re, Pe, ye, Ae, Fe, c, l]);
  return /* @__PURE__ */ React.createElement(SliderContext.Provider, {
    value: Ft
  }, /* @__PURE__ */ React.createElement("div", {
    ref: Le,
    className: cls(a, s, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(a, "-disabled"), j), "".concat(a, "-vertical"), me), "".concat(a, "-horizontal"), !me), "".concat(a, "-with-marks"), Be.length)),
    style: o,
    onMouseDown: et
  }, /* @__PURE__ */ React.createElement("div", {
    className: cls("".concat(a, "-rail"), l == null ? void 0 : l.rail),
    style: _objectSpread2(_objectSpread2({}, Ce), c == null ? void 0 : c.rail)
  }), /* @__PURE__ */ React.createElement(Tracks, {
    prefixCls: a,
    style: xe,
    values: Ve,
    startPoint: Se,
    onStartMove: Ge ? ze : void 0
  }), /* @__PURE__ */ React.createElement(Steps, {
    prefixCls: a,
    marks: Be,
    dots: Me,
    style: ke,
    activeStyle: Re
  }), /* @__PURE__ */ React.createElement(Handles, {
    ref: Ie,
    prefixCls: a,
    style: Ee,
    values: Bt,
    draggingIndex: wt,
    onStartMove: ze,
    onOffsetChange: Lt,
    onFocus: $,
    onBlur: Y,
    handleRender: we,
    activeHandleRender: Te,
    onChangeComplete: jt
  }), /* @__PURE__ */ React.createElement(Marks, {
    prefixCls: a,
    marks: Be,
    onClick: pt
  })));
});
process.env.NODE_ENV !== "production" && (Slider$1.displayName = "Slider");
const defaultFormatter = (t) => typeof t == "number" ? t.toString() : "";
function Slider({
  step: t,
  min: r,
  max: n,
  style: a,
  prefixCls: s,
  onChange: o,
  included: l,
  disabled: c,
  reverse: x,
  className: j,
  vertical: Z,
  marks: V,
  dots: U,
  count: $,
  range: Y,
  value: G,
  defaultValue: W,
  tooltip: X,
  tooltipProps: K
}) {
  const [J, ee] = useState$1({}), te = (re, ie) => {
    ee((ue) => ({ ...ue, [re]: ie }));
  };
  return /* @__PURE__ */ jsx(
    Slider$1,
    {
      step: t,
      value: G,
      handleRender: X ? (re, ie) => {
        const { index: ue, dragging: le, value: oe } = ie, he = {
          ...re.props,
          onMouseEnter: () => {
            te(ue, !0);
          },
          onMouseLeave: () => {
            te(ue, !1);
          }
        };
        if (!K)
          return /* @__PURE__ */ jsx(Tooltip$1, { trigger: [], open: J[ue] || le, placement: Z ? "right" : "top", title: oe, children: cloneElement(re, he) });
        const {
          placement: fe,
          className: ce,
          containerClassName: se,
          gap: pe,
          style: ve,
          initialOpen: ae,
          withArrow: me,
          arrowOptions: de,
          alwaysOpen: ge,
          formatter: Se
        } = K;
        return /* @__PURE__ */ jsx(
          Tooltip$1,
          {
            open: ge && !Z ? ge : J[ue] || le,
            placement: fe,
            className: ce,
            style: ve,
            initialOpen: ae,
            containerClassName: se,
            arrowOptions: de,
            withArrow: me,
            gap: pe,
            trigger: [],
            title: Se ? Se(ie.value) : defaultFormatter(oe),
            children: cloneElement(re, he)
          }
        );
      } : void 0,
      defaultValue: W,
      style: a,
      className: j,
      reverse: Z ? !x : x,
      included: l,
      disabled: c,
      marks: V,
      vertical: Z,
      range: Y,
      onChange: o,
      prefixCls: clsx(s != null ? s : "go-slider"),
      min: r,
      max: n,
      count: $,
      dots: U
    }
  );
}
const sizeClassNames$1 = {
  s: "go-switch_size_s",
  m: "go-switch_size_m"
}, orientationClassNames = {
  horizontal: "go-switch_orientation_horizontal",
  vertical: "go-switch_orientation_vertical"
}, Switch = forwardRef(function t({
  checked: r,
  orientation: n = "horizontal",
  size: a,
  disabled: s,
  leftNode: o,
  rightNode: l,
  className: c,
  containerClassName: x,
  knobClassName: j,
  style: Z,
  name: V,
  tabIndex: U,
  autoFocus: $,
  onChange: Y,
  onKeyDown: G
}, W) {
  const { size: X } = useGlobalComponentConfig({ size: a }), [K, J] = useState$1(!1), ee = (te) => {
    const { checked: ne } = te.currentTarget;
    J(ne), Y == null || Y(ne, te);
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: clsx(
        c,
        "go-switch",
        sizeClassNames$1[X],
        orientationClassNames[n],
        (!!o || !!l) && "go-switch_with-content"
      ),
      style: Z,
      children: [
        /* @__PURE__ */ jsx(
          "input",
          {
            ref: W,
            type: "checkbox",
            name: V,
            checked: r != null ? r : K,
            className: "go-switch__checkbox",
            disabled: s,
            tabIndex: U,
            autoFocus: $,
            onChange: ee,
            onKeyDown: G
          }
        ),
        /* @__PURE__ */ jsxs("div", { className: "go-switch__inner", children: [
          /* @__PURE__ */ jsx("div", { className: clsx(x, "go-switch__container") }),
          /* @__PURE__ */ jsx("div", { className: clsx(j, "go-switch__knob") }),
          /* @__PURE__ */ jsxs("div", { className: "go-switch__icons-container", children: [
            /* @__PURE__ */ jsx("div", { className: "go-switch__left-node", children: o }),
            /* @__PURE__ */ jsx("div", { className: "go-switch__right-node", children: l })
          ] })
        ] })
      ]
    }
  );
}), sizeClassNames = {
  s: "go-textarea_size_s",
  m: "go-textarea_size_m"
}, statusClassNames = {
  error: "go-textarea_status_error"
}, Textarea = forwardRef(function t({
  value: r,
  id: n,
  placeholder: a,
  size: s,
  status: o,
  maxLength: l,
  rows: c,
  cols: x,
  autoHeight: j = !0,
  allowClear: Z = !1,
  disabled: V = !1,
  tabIndex: U = 0,
  suffix: $,
  className: Y,
  fieldClassName: G,
  style: W,
  onChange: X,
  onFocus: K,
  onBlur: J,
  onKeyPress: ee,
  onResize: te
}, ne) {
  var me, de;
  const { localization: re } = useContext(ConfigContext), { size: ie } = useGlobalComponentConfig({ size: s }), ue = useRef(null), [le, oe] = useState$1(r), [he, fe] = useState$1(!1), ce = Z && !!(le != null && le.length);
  useEffect(() => {
    oe(r);
  }, [r]), useEffect(() => {
    const ge = ue.current;
    ge && autoHeight(ge);
  }, [le]);
  const se = useCallback(
    (ge) => {
      const Se = ge.currentTarget.value;
      oe(Se), X == null || X(Se, ge);
    },
    [X]
  ), pe = useCallback(
    (ge) => {
      fe(!0), K == null || K(ge);
    },
    [K]
  ), ve = useCallback(
    (ge) => {
      fe(!1), J == null || J(ge);
    },
    [J]
  ), ae = useCallback(() => {
    oe(""), X == null || X("");
  }, [X]);
  return /* @__PURE__ */ jsxs(
    "label",
    {
      className: clsx(
        "go-textarea",
        sizeClassNames[ie],
        o && statusClassNames[o],
        he && "go-textarea_focused",
        V && "go-textarea_disabled",
        j && "go-textarea_not-resizable",
        ce && "go-textarea_filled",
        Y
      ),
      style: W,
      children: [
        /* @__PURE__ */ jsx(
          "textarea",
          {
            ref: mergeRefs(ue, ne),
            id: n,
            value: le,
            rows: c,
            cols: x,
            placeholder: a,
            className: clsx("go-textarea__field", G),
            disabled: V,
            maxLength: l,
            tabIndex: U,
            onChange: se,
            onFocus: pe,
            onBlur: ve,
            onKeyPress: ee,
            onResize: te
          }
        ),
        !!$ && renderNode($, "span", "go-textarea__suffix"),
        ce && /* @__PURE__ */ jsx(Tooltip$1, { title: (de = (me = re == null ? void 0 : re.input) == null ? void 0 : me.values) == null ? void 0 : de.clear, trigger: ["focus"], children: /* @__PURE__ */ jsx("button", { className: "go-textarea__clear-button", onClick: ae, children: /* @__PURE__ */ jsx(CloseRingDuotoneLine, {}) }) })
      ]
    }
  );
}), DEFAULT_MIN_CONTENT_WIDTH = 32, DEFAULT_MAX_CONTENT_WIDTH = 300, CollapseSidebar = ({
  title: t,
  icon: r,
  children: n,
  initialOpen: a = !1,
  open: s = !1,
  onToggle: o,
  width: l = { min: DEFAULT_MIN_CONTENT_WIDTH, max: DEFAULT_MAX_CONTENT_WIDTH },
  isLoading: c,
  className: x,
  style: j,
  side: Z = "left",
  onClick: V
}) => {
  const U = useRef(a != null ? a : s), [$, Y] = useState$1(
    (a != null ? a : s) ? "opening" : "closed"
  );
  useEffect(() => {
    s === U.current && !s || (U.current = s, Y(s ? "opening" : "closing"));
  }, [s]);
  const G = ["opening", "closing"].includes($), W = ["opening", "open"].includes($), X = () => {
    W ? (Y("closing"), o == null || o(!1)) : (Y("opening"), o == null || o(!0));
  }, K = () => {
    $ === "closing" ? Y("closed") : $ === "opening" && Y("open");
  }, { min: J, max: ee } = typeof l == "object" ? l : { min: DEFAULT_MIN_CONTENT_WIDTH, max: l };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: clsx(
        "go-collapse-sidebar",
        W && "go-collapse-sidebar_open",
        G && "go-collapse-sidebar_transitioning",
        `go-collapse-sidebar_side_${Z}`,
        x
      ),
      style: {
        "--go-collapse-sidebar-max-content-width": `${ee}px`,
        "--go-collapse-sidebar-min-content-width": `${J}px`,
        ...j
      },
      onTransitionEnd: K,
      onClick: V,
      children: [
        /* @__PURE__ */ jsxs("div", { className: "go-collapse-sidebar__header", children: [
          /* @__PURE__ */ jsx(
            "button",
            {
              className: clsx(
                "go-collapse-sidebar__expand-button",
                W && "go-collapse-sidebar__expand-button_expanded"
              ),
              onClick: X,
              children: /* @__PURE__ */ jsx(ExpandRightLight, {})
            }
          ),
          /* @__PURE__ */ jsx("div", { className: "go-collapse-sidebar__title-container", children: typeof t == "string" ? /* @__PURE__ */ jsx("h3", { children: t }) : t })
        ] }),
        (W || G) && /* @__PURE__ */ jsx(Scrollbar, { noScrollX: !0, children: /* @__PURE__ */ jsx("div", { className: "go-collapse-sidebar__content", children: c ? /* @__PURE__ */ jsx(Loader, { style: { "--go-loader-overlay-bg": "transparent" } }) : n }) }),
        /* @__PURE__ */ jsx("div", { className: "go-collapse-sidebar__collapsed-icon", children: r })
      ]
    }
  );
}, HINT_DEFAULT_STYLE_OPTIONS = {
  className: "go-hint__container",
  arrowOptions: {
    className: "go-hint__arrow"
  }
}, HintContent = ({ headerIcon: t, buttonOptions: r, title: n, description: a }) => /* @__PURE__ */ jsxs("div", { className: "go-hint__wrapper", children: [
  n && /* @__PURE__ */ jsxs("div", { className: "go-hint__header", children: [
    t,
    /* @__PURE__ */ jsx("h6", { className: "go-hint__title", children: n })
  ] }),
  a && /* @__PURE__ */ jsx("p", { className: clsx("go-hint__description", n && "go-hint__description_translucent"), children: a }),
  r && /* @__PURE__ */ jsx(
    Button,
    {
      className: clsx("go-hint__button", r.className),
      icon: r.icon,
      onClick: r.onClick,
      children: r.text
    }
  )
] }), HintComponent = forwardRef(function t({
  content: r,
  open: n,
  headerIcon: a,
  buttonOptions: s,
  title: o,
  description: l,
  children: c,
  arrowOptions: x,
  className: j,
  ...Z
}, V) {
  return n ? /* @__PURE__ */ jsx(
    Tooltip$1,
    {
      ref: V,
      title: r || /* @__PURE__ */ jsx(HintContent, { title: o, description: l, headerIcon: a, buttonOptions: s }),
      open: n,
      className: clsx("go-hint__container", j),
      arrowOptions: {
        className: "go-hint__arrow",
        ...x
      },
      ...Z,
      children: c
    }
  ) : c;
}), Hint = Object.assign(HintComponent, {
  HintContent
}), STYLE_VARIANTS = {
  dark: "dark",
  light: "light",
  darkBordered: "darkBordered",
  lightBordered: "lightBordered"
};
export {
  actionsBar as ActionsBar,
  AutoComplete,
  Button,
  Calendar$1 as Calendar,
  Checkbox,
  CheckboxGroup,
  collapse as Collapse,
  CollapseSidebar,
  ConfigContext,
  ConfigProvider,
  DatePicker,
  DatePickerV2,
  DeleteButton,
  descriptions as Descriptions,
  Drawer,
  Field,
  HINT_DEFAULT_STYLE_OPTIONS,
  Hint,
  Illustration,
  Input,
  InputNumber,
  Loader,
  LoaderIcon,
  Modal,
  k as NotificationContainer,
  Portal,
  Radio,
  RadioButtonGroup,
  RadioGroup,
  STYLE_VARIANTS,
  Scrollbar,
  Select,
  Slider,
  Switch,
  Textarea,
  Tooltip$1 as Tooltip,
  YearPicker,
  createNotification,
  en,
  isValidSize,
  ru,
  useDisabledRange,
  useGlobalComponentConfig,
  validateNumber
};
//# sourceMappingURL=go-ui.es.js.map
